import * as tS from "vue";
import Ci, { defineComponent as Ce, ref as Le, onMounted as Us, watch as zr, onBeforeUnmount as bl, provide as Es, inject as Bi, reactive as nS, computed as ve, watchEffect as sy, getCurrentInstance as rS, unref as iS, toRefs as Ef, nextTick as sS, toRef as oS } from "vue";
import { defineComponent as st, inject as $e, ref as ct, computed as je, watch as wl, unref as aS, isVue2 as lS, reactive as oy } from "vue-demi";
const cs = /^[a-z0-9]+(-[a-z0-9]+)*$/, vn = Object.freeze({
  left: 0,
  top: 0,
  width: 16,
  height: 16,
  rotate: 0,
  vFlip: !1,
  hFlip: !1
});
function _l(n) {
  return { ...vn, ...n };
}
const Sl = (n, e, t, r = "") => {
  const i = n.split(":");
  if (n.slice(0, 1) === "@") {
    if (i.length < 2 || i.length > 3)
      return null;
    r = i.shift().slice(1);
  }
  if (i.length > 3 || !i.length)
    return null;
  if (i.length > 1) {
    const a = i.pop(), l = i.pop(), u = {
      provider: i.length > 0 ? i[0] : r,
      prefix: l,
      name: a
    };
    return e && !ds(u) ? null : u;
  }
  const s = i[0], o = s.split("-");
  if (o.length > 1) {
    const a = {
      provider: r,
      prefix: o.shift(),
      name: o.join("-")
    };
    return e && !ds(a) ? null : a;
  }
  if (t && r === "") {
    const a = {
      provider: r,
      prefix: "",
      name: s
    };
    return e && !ds(a, t) ? null : a;
  }
  return null;
}, ds = (n, e) => n ? !!((n.provider === "" || n.provider.match(cs)) && (e && n.prefix === "" || n.prefix.match(cs)) && n.name.match(cs)) : !1;
function uS(n, e) {
  const t = { ...n };
  for (const r in vn) {
    const i = r;
    if (e[i] !== void 0) {
      const s = e[i];
      if (t[i] === void 0) {
        t[i] = s;
        continue;
      }
      switch (i) {
        case "rotate":
          t[i] = (t[i] + s) % 4;
          break;
        case "hFlip":
        case "vFlip":
          t[i] = s !== t[i];
          break;
        default:
          t[i] = s;
      }
    }
  }
  return t;
}
function ah(n, e, t = !1) {
  function r(s, o) {
    if (n.icons[s] !== void 0)
      return Object.assign({}, n.icons[s]);
    if (o > 5)
      return null;
    const a = n.aliases;
    if (a && a[s] !== void 0) {
      const u = a[s], c = r(u.parent, o + 1);
      return c && uS(c, u);
    }
    const l = n.chars;
    return !o && l && l[s] !== void 0 ? r(l[s], o + 1) : null;
  }
  const i = r(e, 0);
  if (i)
    for (const s in vn)
      i[s] === void 0 && n[s] !== void 0 && (i[s] = n[s]);
  return i && t ? _l(i) : i;
}
function cS(n) {
  for (const e in vn)
    if (n[e] !== void 0)
      return !0;
  return !1;
}
function ay(n, e, t) {
  t = t || {};
  const r = [];
  if (typeof n != "object" || typeof n.icons != "object")
    return r;
  n.not_found instanceof Array && n.not_found.forEach((o) => {
    e(o, null), r.push(o);
  });
  const i = n.icons;
  Object.keys(i).forEach((o) => {
    const a = ah(n, o, !0);
    a && (e(o, a), r.push(o));
  });
  const s = t.aliases || "all";
  if (s !== "none" && typeof n.aliases == "object") {
    const o = n.aliases;
    Object.keys(o).forEach((a) => {
      if (s === "variations" && cS(o[a]))
        return;
      const l = ah(n, a, !0);
      l && (e(a, l), r.push(a));
    });
  }
  return r;
}
const bd = {
  provider: "string",
  aliases: "object",
  not_found: "object"
};
for (const n in vn)
  bd[n] = typeof vn[n];
function ly(n) {
  if (typeof n != "object" || n === null)
    return null;
  const e = n;
  if (typeof e.prefix != "string" || !n.icons || typeof n.icons != "object")
    return null;
  for (const i in bd)
    if (n[i] !== void 0 && typeof n[i] !== bd[i])
      return null;
  const t = e.icons;
  for (const i in t) {
    const s = t[i];
    if (!i.match(cs) || typeof s.body != "string")
      return null;
    for (const o in vn)
      if (s[o] !== void 0 && typeof s[o] != typeof vn[o])
        return null;
  }
  const r = e.aliases;
  if (r)
    for (const i in r) {
      const s = r[i], o = s.parent;
      if (!i.match(cs) || typeof o != "string" || !t[o] && !r[o])
        return null;
      for (const a in vn)
        if (s[a] !== void 0 && typeof s[a] != typeof vn[a])
          return null;
    }
  return e;
}
const dS = 1;
let Go = /* @__PURE__ */ Object.create(null);
try {
  const n = window || self;
  n && n._iconifyStorage.version === dS && (Go = n._iconifyStorage.storage);
} catch {
}
function fS(n, e) {
  return {
    provider: n,
    prefix: e,
    icons: /* @__PURE__ */ Object.create(null),
    missing: /* @__PURE__ */ Object.create(null)
  };
}
function Ur(n, e) {
  Go[n] === void 0 && (Go[n] = /* @__PURE__ */ Object.create(null));
  const t = Go[n];
  return t[e] === void 0 && (t[e] = fS(n, e)), t[e];
}
function Tf(n, e) {
  if (!ly(e))
    return [];
  const t = Date.now();
  return ay(e, (r, i) => {
    i ? n.icons[r] = i : n.missing[r] = t;
  });
}
function pS(n, e, t) {
  try {
    if (typeof t.body == "string")
      return n.icons[e] = Object.freeze(_l(t)), !0;
  } catch {
  }
  return !1;
}
function hS(n, e) {
  const t = n.icons[e];
  return t === void 0 ? null : t;
}
let Ts = !1;
function uy(n) {
  return typeof n == "boolean" && (Ts = n), Ts;
}
function mS(n) {
  const e = typeof n == "string" ? Sl(n, !0, Ts) : n;
  return e ? hS(Ur(e.provider, e.prefix), e.name) : null;
}
function gS(n, e) {
  const t = Sl(n, !0, Ts);
  if (!t)
    return !1;
  const r = Ur(t.provider, t.prefix);
  return pS(r, t.name, e);
}
function vS(n, e) {
  if (typeof n != "object")
    return !1;
  if (typeof e != "string" && (e = typeof n.provider == "string" ? n.provider : ""), Ts && e === "" && (typeof n.prefix != "string" || n.prefix === "")) {
    let r = !1;
    return ly(n) && (n.prefix = "", ay(n, (i, s) => {
      s && gS(i, s) && (r = !0);
    })), r;
  }
  if (typeof n.prefix != "string" || !ds({
    provider: e,
    prefix: n.prefix,
    name: "a"
  }))
    return !1;
  const t = Ur(e, n.prefix);
  return !!Tf(t, n);
}
const lh = Object.freeze({
  inline: !1,
  width: null,
  height: null,
  hAlign: "center",
  vAlign: "middle",
  slice: !1,
  hFlip: !1,
  vFlip: !1,
  rotate: 0
});
function yS(n, e) {
  const t = {};
  for (const r in n) {
    const i = r;
    if (t[i] = n[i], e[i] === void 0)
      continue;
    const s = e[i];
    switch (i) {
      case "inline":
      case "slice":
        typeof s == "boolean" && (t[i] = s);
        break;
      case "hFlip":
      case "vFlip":
        s === !0 && (t[i] = !t[i]);
        break;
      case "hAlign":
      case "vAlign":
        typeof s == "string" && s !== "" && (t[i] = s);
        break;
      case "width":
      case "height":
        (typeof s == "string" && s !== "" || typeof s == "number" && s || s === null) && (t[i] = s);
        break;
      case "rotate":
        typeof s == "number" && (t[i] += s);
        break;
    }
  }
  return t;
}
const bS = /(-?[0-9.]*[0-9]+[0-9.]*)/g, wS = /^-?[0-9.]*[0-9]+[0-9.]*$/g;
function Fu(n, e, t) {
  if (e === 1)
    return n;
  if (t = t === void 0 ? 100 : t, typeof n == "number")
    return Math.ceil(n * e * t) / t;
  if (typeof n != "string")
    return n;
  const r = n.split(bS);
  if (r === null || !r.length)
    return n;
  const i = [];
  let s = r.shift(), o = wS.test(s);
  for (; ; ) {
    if (o) {
      const a = parseFloat(s);
      isNaN(a) ? i.push(s) : i.push(Math.ceil(a * e * t) / t);
    } else
      i.push(s);
    if (s = r.shift(), s === void 0)
      return i.join("");
    o = !o;
  }
}
function _S(n) {
  let e = "";
  switch (n.hAlign) {
    case "left":
      e += "xMin";
      break;
    case "right":
      e += "xMax";
      break;
    default:
      e += "xMid";
  }
  switch (n.vAlign) {
    case "top":
      e += "YMin";
      break;
    case "bottom":
      e += "YMax";
      break;
    default:
      e += "YMid";
  }
  return e += n.slice ? " slice" : " meet", e;
}
function SS(n, e) {
  const t = {
    left: n.left,
    top: n.top,
    width: n.width,
    height: n.height
  };
  let r = n.body;
  [n, e].forEach((a) => {
    const l = [], u = a.hFlip, c = a.vFlip;
    let f = a.rotate;
    u ? c ? f += 2 : (l.push("translate(" + (t.width + t.left).toString() + " " + (0 - t.top).toString() + ")"), l.push("scale(-1 1)"), t.top = t.left = 0) : c && (l.push("translate(" + (0 - t.left).toString() + " " + (t.height + t.top).toString() + ")"), l.push("scale(1 -1)"), t.top = t.left = 0);
    let p;
    switch (f < 0 && (f -= Math.floor(f / 4) * 4), f = f % 4, f) {
      case 1:
        p = t.height / 2 + t.top, l.unshift("rotate(90 " + p.toString() + " " + p.toString() + ")");
        break;
      case 2:
        l.unshift("rotate(180 " + (t.width / 2 + t.left).toString() + " " + (t.height / 2 + t.top).toString() + ")");
        break;
      case 3:
        p = t.width / 2 + t.left, l.unshift("rotate(-90 " + p.toString() + " " + p.toString() + ")");
        break;
    }
    f % 2 === 1 && ((t.left !== 0 || t.top !== 0) && (p = t.left, t.left = t.top, t.top = p), t.width !== t.height && (p = t.width, t.width = t.height, t.height = p)), l.length && (r = '<g transform="' + l.join(" ") + '">' + r + "</g>");
  });
  let i, s;
  e.width === null && e.height === null ? (s = "1em", i = Fu(s, t.width / t.height)) : e.width !== null && e.height !== null ? (i = e.width, s = e.height) : e.height !== null ? (s = e.height, i = Fu(s, t.width / t.height)) : (i = e.width, s = Fu(i, t.height / t.width)), i === "auto" && (i = t.width), s === "auto" && (s = t.height), i = typeof i == "string" ? i : i.toString() + "", s = typeof s == "string" ? s : s.toString() + "";
  const o = {
    attributes: {
      width: i,
      height: s,
      preserveAspectRatio: _S(e),
      viewBox: t.left.toString() + " " + t.top.toString() + " " + t.width.toString() + " " + t.height.toString()
    },
    body: r
  };
  return e.inline && (o.inline = !0), o;
}
const xS = /\sid="(\S+)"/g, CS = "IconifyId" + Date.now().toString(16) + (Math.random() * 16777216 | 0).toString(16);
let OS = 0;
function ES(n, e = CS) {
  const t = [];
  let r;
  for (; r = xS.exec(n); )
    t.push(r[1]);
  return t.length && t.forEach((i) => {
    const s = typeof e == "function" ? e(i) : e + (OS++).toString(), o = i.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    n = n.replace(new RegExp('([#;"])(' + o + ')([")]|\\.[a-z])', "g"), "$1" + s + "$3");
  }), n;
}
const wd = /* @__PURE__ */ Object.create(null);
function TS(n, e) {
  wd[n] = e;
}
function _d(n) {
  return wd[n] || wd[""];
}
function kf(n) {
  let e;
  if (typeof n.resources == "string")
    e = [n.resources];
  else if (e = n.resources, !(e instanceof Array) || !e.length)
    return null;
  return {
    resources: e,
    path: n.path === void 0 ? "/" : n.path,
    maxURL: n.maxURL ? n.maxURL : 500,
    rotate: n.rotate ? n.rotate : 750,
    timeout: n.timeout ? n.timeout : 5e3,
    random: n.random === !0,
    index: n.index ? n.index : 0,
    dataAfterTimeout: n.dataAfterTimeout !== !1
  };
}
const Mf = /* @__PURE__ */ Object.create(null), Zi = [
  "https://api.simplesvg.com",
  "https://api.unisvg.com"
], Ko = [];
for (; Zi.length > 0; )
  Zi.length === 1 || Math.random() > 0.5 ? Ko.push(Zi.shift()) : Ko.push(Zi.pop());
Mf[""] = kf({
  resources: ["https://api.iconify.design"].concat(Ko)
});
function kS(n, e) {
  const t = kf(e);
  return t === null ? !1 : (Mf[n] = t, !0);
}
function Af(n) {
  return Mf[n];
}
const cy = (n, e) => {
  let t = n, r = t.indexOf("?") !== -1;
  function i(s) {
    switch (typeof s) {
      case "boolean":
        return s ? "true" : "false";
      case "number":
        return encodeURIComponent(s);
      case "string":
        return encodeURIComponent(s);
      default:
        throw new Error("Invalid parameter");
    }
  }
  return Object.keys(e).forEach((s) => {
    let o;
    try {
      o = i(e[s]);
    } catch {
      return;
    }
    t += (r ? "&" : "?") + encodeURIComponent(s) + "=" + o, r = !0;
  }), t;
}, dy = {}, Jo = {}, MS = () => {
  let n;
  try {
    if (n = fetch, typeof n == "function")
      return n;
  } catch {
  }
  return null;
};
let uh = MS();
function AS(n, e) {
  const t = Af(n);
  if (!t)
    return 0;
  let r;
  if (!t.maxURL)
    r = 0;
  else {
    let s = 0;
    t.resources.forEach((a) => {
      s = Math.max(s, a.length);
    });
    const o = cy(e + ".json", {
      icons: ""
    });
    r = t.maxURL - s - t.path.length - o.length;
  }
  const i = n + ":" + e;
  return Jo[n] = t.path, dy[i] = r, r;
}
function PS(n) {
  return n === 404;
}
const $S = (n, e, t) => {
  const r = [];
  let i = dy[e];
  i === void 0 && (i = AS(n, e));
  const s = "icons";
  let o = {
    type: s,
    provider: n,
    prefix: e,
    icons: []
  }, a = 0;
  return t.forEach((l, u) => {
    a += l.length + 1, a >= i && u > 0 && (r.push(o), o = {
      type: s,
      provider: n,
      prefix: e,
      icons: []
    }, a = l.length), o.icons.push(l);
  }), r.push(o), r;
};
function DS(n) {
  if (typeof n == "string") {
    if (Jo[n] === void 0) {
      const e = Af(n);
      if (!e)
        return "/";
      Jo[n] = e.path;
    }
    return Jo[n];
  }
  return "/";
}
const LS = (n, e, t) => {
  if (!uh) {
    t("abort", 424);
    return;
  }
  let r = DS(e.provider);
  switch (e.type) {
    case "icons": {
      const s = e.prefix, a = e.icons.join(",");
      r += cy(s + ".json", {
        icons: a
      });
      break;
    }
    case "custom": {
      const s = e.uri;
      r += s.slice(0, 1) === "/" ? s.slice(1) : s;
      break;
    }
    default:
      t("abort", 400);
      return;
  }
  let i = 503;
  uh(n + r).then((s) => {
    const o = s.status;
    if (o !== 200) {
      setTimeout(() => {
        t(PS(o) ? "abort" : "next", o);
      });
      return;
    }
    return i = 501, s.json();
  }).then((s) => {
    if (typeof s != "object" || s === null) {
      setTimeout(() => {
        t("next", i);
      });
      return;
    }
    setTimeout(() => {
      t("success", s);
    });
  }).catch(() => {
    t("next", i);
  });
}, NS = {
  prepare: $S,
  send: LS
};
function IS(n) {
  const e = {
    loaded: [],
    missing: [],
    pending: []
  }, t = /* @__PURE__ */ Object.create(null);
  n.sort((i, s) => i.provider !== s.provider ? i.provider.localeCompare(s.provider) : i.prefix !== s.prefix ? i.prefix.localeCompare(s.prefix) : i.name.localeCompare(s.name));
  let r = {
    provider: "",
    prefix: "",
    name: ""
  };
  return n.forEach((i) => {
    if (r.name === i.name && r.prefix === i.prefix && r.provider === i.provider)
      return;
    r = i;
    const s = i.provider, o = i.prefix, a = i.name;
    t[s] === void 0 && (t[s] = /* @__PURE__ */ Object.create(null));
    const l = t[s];
    l[o] === void 0 && (l[o] = Ur(s, o));
    const u = l[o];
    let c;
    u.icons[a] !== void 0 ? c = e.loaded : o === "" || u.missing[a] !== void 0 ? c = e.missing : c = e.pending;
    const f = {
      provider: s,
      prefix: o,
      name: a
    };
    c.push(f);
  }), e;
}
const rr = /* @__PURE__ */ Object.create(null), zu = /* @__PURE__ */ Object.create(null);
function fy(n, e) {
  n.forEach((t) => {
    const r = t.provider;
    if (rr[r] === void 0)
      return;
    const i = rr[r], s = t.prefix, o = i[s];
    o && (i[s] = o.filter((a) => a.id !== e));
  });
}
function RS(n, e) {
  zu[n] === void 0 && (zu[n] = /* @__PURE__ */ Object.create(null));
  const t = zu[n];
  t[e] || (t[e] = !0, setTimeout(() => {
    if (t[e] = !1, rr[n] === void 0 || rr[n][e] === void 0)
      return;
    const r = rr[n][e].slice(0);
    if (!r.length)
      return;
    const i = Ur(n, e);
    let s = !1;
    r.forEach((o) => {
      const a = o.icons, l = a.pending.length;
      a.pending = a.pending.filter((u) => {
        if (u.prefix !== e)
          return !0;
        const c = u.name;
        if (i.icons[c] !== void 0)
          a.loaded.push({
            provider: n,
            prefix: e,
            name: c
          });
        else if (i.missing[c] !== void 0)
          a.missing.push({
            provider: n,
            prefix: e,
            name: c
          });
        else
          return s = !0, !0;
        return !1;
      }), a.pending.length !== l && (s || fy([
        {
          provider: n,
          prefix: e
        }
      ], o.id), o.callback(a.loaded.slice(0), a.missing.slice(0), a.pending.slice(0), o.abort));
    });
  }));
}
let FS = 0;
function zS(n, e, t) {
  const r = FS++, i = fy.bind(null, t, r);
  if (!e.pending.length)
    return i;
  const s = {
    id: r,
    icons: e,
    callback: n,
    abort: i
  };
  return t.forEach((o) => {
    const a = o.provider, l = o.prefix;
    rr[a] === void 0 && (rr[a] = /* @__PURE__ */ Object.create(null));
    const u = rr[a];
    u[l] === void 0 && (u[l] = []), u[l].push(s);
  }), i;
}
function BS(n, e = !0, t = !1) {
  const r = [];
  return n.forEach((i) => {
    const s = typeof i == "string" ? Sl(i, !1, t) : i;
    (!e || ds(s, t)) && r.push({
      provider: s.provider,
      prefix: s.prefix,
      name: s.name
    });
  }), r;
}
var ch = {
  resources: [],
  index: 0,
  timeout: 2e3,
  rotate: 750,
  random: !1,
  dataAfterTimeout: !1
};
function jS(n, e, t, r) {
  const i = n.resources.length, s = n.random ? Math.floor(Math.random() * i) : n.index;
  let o;
  if (n.random) {
    let C = n.resources.slice(0);
    for (o = []; C.length > 1; ) {
      const S = Math.floor(Math.random() * C.length);
      o.push(C[S]), C = C.slice(0, S).concat(C.slice(S + 1));
    }
    o = o.concat(C);
  } else
    o = n.resources.slice(s).concat(n.resources.slice(0, s));
  const a = Date.now();
  let l = "pending", u = 0, c, f = null, p = [], d = [];
  typeof r == "function" && d.push(r);
  function h() {
    f && (clearTimeout(f), f = null);
  }
  function v() {
    l === "pending" && (l = "aborted"), h(), p.forEach((C) => {
      C.status === "pending" && (C.status = "aborted");
    }), p = [];
  }
  function g(C, S) {
    S && (d = []), typeof C == "function" && d.push(C);
  }
  function m() {
    return {
      startTime: a,
      payload: e,
      status: l,
      queriesSent: u,
      queriesPending: p.length,
      subscribe: g,
      abort: v
    };
  }
  function _() {
    l = "failed", d.forEach((C) => {
      C(void 0, c);
    });
  }
  function y() {
    p.forEach((C) => {
      C.status === "pending" && (C.status = "aborted");
    }), p = [];
  }
  function w(C, S, b) {
    const x = S !== "success";
    switch (p = p.filter((E) => E !== C), l) {
      case "pending":
        break;
      case "failed":
        if (x || !n.dataAfterTimeout)
          return;
        break;
      default:
        return;
    }
    if (S === "abort") {
      c = b, _();
      return;
    }
    if (x) {
      c = b, p.length || (o.length ? O() : _());
      return;
    }
    if (h(), y(), !n.random) {
      const E = n.resources.indexOf(C.resource);
      E !== -1 && E !== n.index && (n.index = E);
    }
    l = "completed", d.forEach((E) => {
      E(b);
    });
  }
  function O() {
    if (l !== "pending")
      return;
    h();
    const C = o.shift();
    if (C === void 0) {
      if (p.length) {
        f = setTimeout(() => {
          h(), l === "pending" && (y(), _());
        }, n.timeout);
        return;
      }
      _();
      return;
    }
    const S = {
      status: "pending",
      resource: C,
      callback: (b, x) => {
        w(S, b, x);
      }
    };
    p.push(S), u++, f = setTimeout(O, n.rotate), t(C, e, S.callback);
  }
  return setTimeout(O), m;
}
function VS(n) {
  if (typeof n != "object" || typeof n.resources != "object" || !(n.resources instanceof Array) || !n.resources.length)
    throw new Error("Invalid Reduncancy configuration");
  const e = /* @__PURE__ */ Object.create(null);
  let t;
  for (t in ch)
    n[t] !== void 0 ? e[t] = n[t] : e[t] = ch[t];
  return e;
}
function py(n) {
  const e = VS(n);
  let t = [];
  function r() {
    t = t.filter((a) => a().status === "pending");
  }
  function i(a, l, u) {
    const c = jS(e, a, l, (f, p) => {
      r(), u && u(f, p);
    });
    return t.push(c), c;
  }
  function s(a) {
    const l = t.find((u) => a(u));
    return l !== void 0 ? l : null;
  }
  return {
    query: i,
    find: s,
    setIndex: (a) => {
      e.index = a;
    },
    getIndex: () => e.index,
    cleanup: r
  };
}
function dh() {
}
const Bu = /* @__PURE__ */ Object.create(null);
function HS(n) {
  if (Bu[n] === void 0) {
    const e = Af(n);
    if (!e)
      return;
    const t = py(e), r = {
      config: e,
      redundancy: t
    };
    Bu[n] = r;
  }
  return Bu[n];
}
function WS(n, e, t) {
  let r, i;
  if (typeof n == "string") {
    const s = _d(n);
    if (!s)
      return t(void 0, 424), dh;
    i = s.send;
    const o = HS(n);
    o && (r = o.redundancy);
  } else {
    const s = kf(n);
    if (s) {
      r = py(s);
      const o = n.resources ? n.resources[0] : "", a = _d(o);
      a && (i = a.send);
    }
  }
  return !r || !i ? (t(void 0, 424), dh) : r.query(e, i, t)().abort;
}
const Sd = {};
function fh() {
}
const Tr = /* @__PURE__ */ Object.create(null), ju = /* @__PURE__ */ Object.create(null), Vu = /* @__PURE__ */ Object.create(null), Hu = /* @__PURE__ */ Object.create(null);
function qS(n, e) {
  Vu[n] === void 0 && (Vu[n] = /* @__PURE__ */ Object.create(null));
  const t = Vu[n];
  t[e] || (t[e] = !0, setTimeout(() => {
    t[e] = !1, RS(n, e);
  }));
}
const ph = /* @__PURE__ */ Object.create(null);
function US(n, e, t) {
  function r() {
    const a = (n === "" ? "" : "@" + n + ":") + e, l = Math.floor(Date.now() / 6e4);
    ph[a] < l && (ph[a] = l, console.error('Unable to retrieve icons for "' + a + '" because API is not configured properly.'));
  }
  ju[n] === void 0 && (ju[n] = /* @__PURE__ */ Object.create(null));
  const i = ju[n];
  Hu[n] === void 0 && (Hu[n] = /* @__PURE__ */ Object.create(null));
  const s = Hu[n];
  Tr[n] === void 0 && (Tr[n] = /* @__PURE__ */ Object.create(null));
  const o = Tr[n];
  i[e] === void 0 ? i[e] = t : i[e] = i[e].concat(t).sort(), s[e] || (s[e] = !0, setTimeout(() => {
    s[e] = !1;
    const a = i[e];
    delete i[e];
    const l = _d(n);
    if (!l) {
      r();
      return;
    }
    l.prepare(n, e, a).forEach((c) => {
      WS(n, c, (f, p) => {
        const d = Ur(n, e);
        if (typeof f != "object") {
          if (p !== 404)
            return;
          const h = Date.now();
          c.icons.forEach((v) => {
            d.missing[v] = h;
          });
        } else
          try {
            const h = Tf(d, f);
            if (!h.length)
              return;
            const v = o[e];
            h.forEach((g) => {
              delete v[g];
            }), Sd.store && Sd.store(n, f);
          } catch (h) {
            console.error(h);
          }
        qS(n, e);
      });
    });
  }));
}
const GS = (n, e) => {
  const t = BS(n, !0, uy()), r = IS(t);
  if (!r.pending.length) {
    let u = !0;
    return e && setTimeout(() => {
      u && e(r.loaded, r.missing, r.pending, fh);
    }), () => {
      u = !1;
    };
  }
  const i = /* @__PURE__ */ Object.create(null), s = [];
  let o, a;
  r.pending.forEach((u) => {
    const c = u.provider, f = u.prefix;
    if (f === a && c === o)
      return;
    o = c, a = f, s.push({
      provider: c,
      prefix: f
    }), Tr[c] === void 0 && (Tr[c] = /* @__PURE__ */ Object.create(null));
    const p = Tr[c];
    p[f] === void 0 && (p[f] = /* @__PURE__ */ Object.create(null)), i[c] === void 0 && (i[c] = /* @__PURE__ */ Object.create(null));
    const d = i[c];
    d[f] === void 0 && (d[f] = []);
  });
  const l = Date.now();
  return r.pending.forEach((u) => {
    const c = u.provider, f = u.prefix, p = u.name, d = Tr[c][f];
    d[p] === void 0 && (d[p] = l, i[c][f].push(p));
  }), s.forEach((u) => {
    const c = u.provider, f = u.prefix;
    i[c][f].length && US(c, f, i[c][f]);
  }), e ? zS(e, r, s) : fh;
}, hy = "iconify2", Gs = "iconify", my = Gs + "-count", gy = Gs + "-version", vy = 36e5, KS = 168, Pf = {
  local: !0,
  session: !0
};
let xd = !1;
const yy = {
  local: 0,
  session: 0
}, by = {
  local: [],
  session: []
};
let po = typeof window > "u" ? {} : window;
function wy(n) {
  const e = n + "Storage";
  try {
    if (po && po[e] && typeof po[e].length == "number")
      return po[e];
  } catch {
  }
  return Pf[n] = !1, null;
}
function $f(n, e, t) {
  try {
    return n.setItem(my, t.toString()), yy[e] = t, !0;
  } catch {
    return !1;
  }
}
function _y(n) {
  const e = n.getItem(my);
  if (e) {
    const t = parseInt(e);
    return t || 0;
  }
  return 0;
}
function JS(n, e) {
  try {
    n.setItem(gy, hy);
  } catch {
  }
  $f(n, e, 0);
}
function XS(n) {
  try {
    const e = _y(n);
    for (let t = 0; t < e; t++)
      n.removeItem(Gs + t.toString());
  } catch {
  }
}
const Sy = () => {
  if (xd)
    return;
  xd = !0;
  const n = Math.floor(Date.now() / vy) - KS;
  function e(t) {
    const r = wy(t);
    if (!r)
      return;
    const i = (s) => {
      const o = Gs + s.toString(), a = r.getItem(o);
      if (typeof a != "string")
        return !1;
      let l = !0;
      try {
        const u = JSON.parse(a);
        if (typeof u != "object" || typeof u.cached != "number" || u.cached < n || typeof u.provider != "string" || typeof u.data != "object" || typeof u.data.prefix != "string")
          l = !1;
        else {
          const c = u.provider, f = u.data.prefix, p = Ur(c, f);
          l = Tf(p, u.data).length > 0;
        }
      } catch {
        l = !1;
      }
      return l || r.removeItem(o), l;
    };
    try {
      const s = r.getItem(gy);
      if (s !== hy) {
        s && XS(r), JS(r, t);
        return;
      }
      let o = _y(r);
      for (let a = o - 1; a >= 0; a--)
        i(a) || (a === o - 1 ? o-- : by[t].push(a));
      $f(r, t, o);
    } catch {
    }
  }
  for (const t in Pf)
    e(t);
}, YS = (n, e) => {
  xd || Sy();
  function t(r) {
    if (!Pf[r])
      return !1;
    const i = wy(r);
    if (!i)
      return !1;
    let s = by[r].shift();
    if (s === void 0 && (s = yy[r], !$f(i, r, s + 1)))
      return !1;
    try {
      const o = {
        cached: Math.floor(Date.now() / vy),
        provider: n,
        data: e
      };
      i.setItem(Gs + s.toString(), JSON.stringify(o));
    } catch {
      return !1;
    }
    return !0;
  }
  !Object.keys(e.icons).length || (e.not_found && (e = Object.assign({}, e), delete e.not_found), t("local") || t("session"));
}, xy = /[\s,]+/;
function QS(n, e) {
  e.split(xy).forEach((t) => {
    switch (t.trim()) {
      case "horizontal":
        n.hFlip = !0;
        break;
      case "vertical":
        n.vFlip = !0;
        break;
    }
  });
}
function ZS(n, e) {
  e.split(xy).forEach((t) => {
    const r = t.trim();
    switch (r) {
      case "left":
      case "center":
      case "right":
        n.hAlign = r;
        break;
      case "top":
      case "middle":
      case "bottom":
        n.vAlign = r;
        break;
      case "slice":
      case "crop":
        n.slice = !0;
        break;
      case "meet":
        n.slice = !1;
    }
  });
}
function ex(n, e = 0) {
  const t = n.replace(/^-?[0-9.]*/, "");
  function r(i) {
    for (; i < 0; )
      i += 4;
    return i % 4;
  }
  if (t === "") {
    const i = parseInt(n);
    return isNaN(i) ? 0 : r(i);
  } else if (t !== n) {
    let i = 0;
    switch (t) {
      case "%":
        i = 25;
        break;
      case "deg":
        i = 90;
    }
    if (i) {
      let s = parseFloat(n.slice(0, n.length - t.length));
      return isNaN(s) ? 0 : (s = s / i, s % 1 === 0 ? r(s) : 0);
    }
  }
  return e;
}
const tx = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "aria-hidden": !0,
  role: "img"
};
let Gn = {};
["horizontal", "vertical"].forEach((n) => {
  ["Align", "Flip"].forEach((e) => {
    const r = {
      attr: n.slice(0, 1) + e,
      boolean: e === "Flip"
    };
    Gn[n + "-" + e.toLowerCase()] = r, Gn[n.slice(0, 1) + "-" + e.toLowerCase()] = r, Gn[n + e] = r;
  });
});
const hh = (n, e, t, r) => {
  const i = yS(lh, e), s = { ...tx }, o = {};
  for (let f in e) {
    const p = e[f];
    if (p !== void 0)
      switch (f) {
        case "icon":
        case "style":
        case "onLoad":
          break;
        case "inline":
        case "hFlip":
        case "vFlip":
          i[f] = p === !0 || p === "true" || p === 1;
          break;
        case "flip":
          typeof p == "string" && QS(i, p);
          break;
        case "align":
          typeof p == "string" && ZS(i, p);
          break;
        case "color":
          o.color = p;
          break;
        case "rotate":
          typeof p == "string" ? i[f] = ex(p) : typeof p == "number" && (i[f] = p);
          break;
        case "ariaHidden":
        case "aria-hidden":
          p !== !0 && p !== "true" && delete s["aria-hidden"];
          break;
        default:
          Gn[f] !== void 0 ? Gn[f].boolean && (p === !0 || p === "true" || p === 1) ? i[Gn[f].attr] = !0 : !Gn[f].boolean && typeof p == "string" && p !== "" && (i[Gn[f].attr] = p) : lh[f] === void 0 && (s[f] = p);
      }
  }
  const a = SS(r, i);
  for (let f in a.attributes)
    s[f] = a.attributes[f];
  a.inline && (o.verticalAlign = "-0.125em");
  let l = 0, u = e.id;
  typeof u == "string" && (u = u.replace(/-/g, "_"));
  const c = {
    attrs: s,
    domProps: {
      innerHTML: ES(a.body, u ? () => u + "ID" + l++ : "iconifyVue")
    }
  };
  return Object.keys(o).length > 0 && (c.style = o), t && (["on", "ref"].forEach((f) => {
    t[f] !== void 0 && (c[f] = t[f]);
  }), ["staticClass", "class"].forEach((f) => {
    t[f] !== void 0 && (c.class = t[f]);
  })), n("svg", c);
};
uy(!0);
TS("", NS);
if (typeof document < "u" && typeof window < "u") {
  Sd.store = YS, Sy();
  const n = window;
  if (n.IconifyPreload !== void 0) {
    const e = n.IconifyPreload, t = "Invalid IconifyPreload syntax.";
    typeof e == "object" && e !== null && (e instanceof Array ? e : [e]).forEach((r) => {
      try {
        (typeof r != "object" || r === null || r instanceof Array || typeof r.icons != "object" || typeof r.prefix != "string" || !vS(r)) && console.error(t);
      } catch {
        console.error(t);
      }
    });
  }
  if (n.IconifyProviders !== void 0) {
    const e = n.IconifyProviders;
    if (typeof e == "object" && e !== null)
      for (let t in e) {
        const r = "IconifyProviders[" + t + "] is invalid.";
        try {
          const i = e[t];
          if (typeof i != "object" || !i || i.resources === void 0)
            continue;
          kS(t, i) || console.error(r);
        } catch {
          console.error(r);
        }
      }
  }
}
const nx = _l({
  body: ""
}), rx = Ci.extend({
  inheritAttrs: !1,
  data() {
    return {
      iconMounted: !1
    };
  },
  beforeMount() {
    this._name = "", this._loadingIcon = null, this.iconMounted = !0;
  },
  beforeDestroy() {
    this.abortLoading();
  },
  methods: {
    abortLoading() {
      this._loadingIcon && (this._loadingIcon.abort(), this._loadingIcon = null);
    },
    getIcon(n, e) {
      if (typeof n == "object" && n !== null && typeof n.body == "string")
        return this._name = "", this.abortLoading(), {
          data: _l(n)
        };
      let t;
      if (typeof n != "string" || (t = Sl(n, !1, !0)) === null)
        return this.abortLoading(), null;
      const r = mS(t);
      if (r === null)
        return (!this._loadingIcon || this._loadingIcon.name !== n) && (this.abortLoading(), this._name = "", this._loadingIcon = {
          name: n,
          abort: GS([t], () => {
            this.$forceUpdate();
          })
        }), null;
      this.abortLoading(), this._name !== n && (this._name = n, e && e(n));
      const i = ["iconify"];
      return t.prefix !== "" && i.push("iconify--" + t.prefix), t.provider !== "" && i.push("iconify--" + t.provider), { data: r, classes: i };
    }
  },
  render(n) {
    const e = this.$attrs;
    let t = this.$data;
    const r = this.iconMounted ? this.getIcon(e.icon, e.onLoad) : null;
    return r ? (r.classes && (t = {
      ...t,
      class: (typeof t.class == "string" ? t.class + " " : "") + r.classes.join(" ")
    }), hh(n, e, t, r.data)) : hh(n, e, t, nx);
  }
});
var mh = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ot(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
function Df(n) {
  var e = n.default;
  if (typeof e == "function") {
    var t = function() {
      return e.apply(this, arguments);
    };
    t.prototype = e.prototype;
  } else
    t = {};
  return Object.defineProperty(t, "__esModule", { value: !0 }), Object.keys(n).forEach(function(r) {
    var i = Object.getOwnPropertyDescriptor(n, r);
    Object.defineProperty(t, r, i.get ? i : {
      enumerable: !0,
      get: function() {
        return n[r];
      }
    });
  }), t;
}
var Lf = { exports: {} }, Wu, gh;
function Cy() {
  return gh || (gh = 1, Wu = function(n, e, t, r) {
    var i, s = 0;
    typeof e != "boolean" && (r = t, t = e, e = void 0);
    function o() {
      var a = this, l = Number(new Date()) - s, u = arguments;
      function c() {
        s = Number(new Date()), t.apply(a, u);
      }
      function f() {
        i = void 0;
      }
      r && !i && c(), i && clearTimeout(i), r === void 0 && l > n ? c() : e !== !0 && (i = setTimeout(r ? f : c, r === void 0 ? n - l : n));
    }
    return o;
  }), Wu;
}
var qu, vh;
function Nf() {
  if (vh)
    return qu;
  vh = 1;
  var n = Cy();
  return qu = function(e, t, r) {
    return r === void 0 ? n(e, t, !1) : n(e, r, t !== !1);
  }, qu;
}
var Pe = {};
const Nt = /* @__PURE__ */ Df(tS);
var yh;
function ji() {
  if (yh)
    return Pe;
  yh = 1, Pe.__esModule = !0, Pe.isInContainer = Pe.getScrollContainer = Pe.isScroll = Pe.getStyle = Pe.once = Pe.off = Pe.on = void 0;
  var n = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(_) {
    return typeof _;
  } : function(_) {
    return _ && typeof Symbol == "function" && _.constructor === Symbol && _ !== Symbol.prototype ? "symbol" : typeof _;
  };
  Pe.hasClass = p, Pe.addClass = d, Pe.removeClass = h, Pe.setStyle = g;
  var e = Nt, t = r(e);
  function r(_) {
    return _ && _.__esModule ? _ : { default: _ };
  }
  var i = t.default.prototype.$isServer, s = /([\:\-\_]+(.))/g, o = /^moz([A-Z])/, a = i ? 0 : Number(document.documentMode), l = function(y) {
    return (y || "").replace(/^[\s\uFEFF]+|[\s\uFEFF]+$/g, "");
  }, u = function(y) {
    return y.replace(s, function(w, O, C, S) {
      return S ? C.toUpperCase() : C;
    }).replace(o, "Moz$1");
  }, c = Pe.on = function() {
    return !i && document.addEventListener ? function(_, y, w) {
      _ && y && w && _.addEventListener(y, w, !1);
    } : function(_, y, w) {
      _ && y && w && _.attachEvent("on" + y, w);
    };
  }(), f = Pe.off = function() {
    return !i && document.removeEventListener ? function(_, y, w) {
      _ && y && _.removeEventListener(y, w, !1);
    } : function(_, y, w) {
      _ && y && _.detachEvent("on" + y, w);
    };
  }();
  Pe.once = function(y, w, O) {
    var C = function S() {
      O && O.apply(this, arguments), f(y, w, S);
    };
    c(y, w, C);
  };
  function p(_, y) {
    if (!_ || !y)
      return !1;
    if (y.indexOf(" ") !== -1)
      throw new Error("className should not contain space.");
    return _.classList ? _.classList.contains(y) : (" " + _.className + " ").indexOf(" " + y + " ") > -1;
  }
  function d(_, y) {
    if (!!_) {
      for (var w = _.className, O = (y || "").split(" "), C = 0, S = O.length; C < S; C++) {
        var b = O[C];
        !b || (_.classList ? _.classList.add(b) : p(_, b) || (w += " " + b));
      }
      _.classList || _.setAttribute("class", w);
    }
  }
  function h(_, y) {
    if (!(!_ || !y)) {
      for (var w = y.split(" "), O = " " + _.className + " ", C = 0, S = w.length; C < S; C++) {
        var b = w[C];
        !b || (_.classList ? _.classList.remove(b) : p(_, b) && (O = O.replace(" " + b + " ", " ")));
      }
      _.classList || _.setAttribute("class", l(O));
    }
  }
  var v = Pe.getStyle = a < 9 ? function(_, y) {
    if (!i) {
      if (!_ || !y)
        return null;
      y = u(y), y === "float" && (y = "styleFloat");
      try {
        switch (y) {
          case "opacity":
            try {
              return _.filters.item("alpha").opacity / 100;
            } catch {
              return 1;
            }
          default:
            return _.style[y] || _.currentStyle ? _.currentStyle[y] : null;
        }
      } catch {
        return _.style[y];
      }
    }
  } : function(_, y) {
    if (!i) {
      if (!_ || !y)
        return null;
      y = u(y), y === "float" && (y = "cssFloat");
      try {
        var w = document.defaultView.getComputedStyle(_, "");
        return _.style[y] || w ? w[y] : null;
      } catch {
        return _.style[y];
      }
    }
  };
  function g(_, y, w) {
    if (!(!_ || !y))
      if ((typeof y > "u" ? "undefined" : n(y)) === "object")
        for (var O in y)
          y.hasOwnProperty(O) && g(_, O, y[O]);
      else
        y = u(y), y === "opacity" && a < 9 ? _.style.filter = isNaN(w) ? "" : "alpha(opacity=" + w * 100 + ")" : _.style[y] = w;
  }
  var m = Pe.isScroll = function(y, w) {
    if (!i) {
      var O = w != null, C = O ? w ? v(y, "overflow-y") : v(y, "overflow-x") : v(y, "overflow");
      return C.match(/(scroll|auto|overlay)/);
    }
  };
  return Pe.getScrollContainer = function(y, w) {
    if (!i) {
      for (var O = y; O; ) {
        if ([window, document, document.documentElement].includes(O))
          return window;
        if (m(O, w))
          return O;
        O = O.parentNode;
      }
      return O;
    }
  }, Pe.isInContainer = function(y, w) {
    if (i || !y || !w)
      return !1;
    var O = y.getBoundingClientRect(), C = void 0;
    return [window, document, document.documentElement, null, void 0].includes(w) ? C = {
      top: 0,
      right: window.innerWidth,
      bottom: window.innerHeight,
      left: 0
    } : C = w.getBoundingClientRect(), O.top < C.bottom && O.bottom > C.top && O.right > C.left && O.left < C.right;
  }, Pe;
}
var ne = {}, Kt = {};
Kt.__esModule = !0;
Kt.isDefined = Kt.isUndefined = Kt.isFunction = void 0;
var ix = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
  return typeof n;
} : function(n) {
  return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
};
Kt.isString = lx;
Kt.isObject = ux;
Kt.isHtmlElement = cx;
var sx = Nt, ox = ax(sx);
function ax(n) {
  return n && n.__esModule ? n : { default: n };
}
function lx(n) {
  return Object.prototype.toString.call(n) === "[object String]";
}
function ux(n) {
  return Object.prototype.toString.call(n) === "[object Object]";
}
function cx(n) {
  return n && n.nodeType === Node.ELEMENT_NODE;
}
var Oy = function(e) {
  var t = {};
  return e && t.toString.call(e) === "[object Function]";
};
typeof /./ != "function" && (typeof Int8Array > "u" ? "undefined" : ix(Int8Array)) !== "object" && (ox.default.prototype.$isServer || typeof document.childNodes != "function") && (Kt.isFunction = Oy = function(e) {
  return typeof e == "function" || !1;
});
Kt.isFunction = Oy;
Kt.isUndefined = function(e) {
  return e === void 0;
};
Kt.isDefined = function(e) {
  return e != null;
};
ne.__esModule = !0;
ne.isMac = ne.isEmpty = ne.isEqual = ne.arrayEquals = ne.looseEqual = ne.capitalize = ne.kebabCase = ne.autoprefixer = ne.isFirefox = ne.isEdge = ne.isIE = ne.coerceTruthyValueToArray = ne.arrayFind = ne.arrayFindIndex = ne.escapeRegexpString = ne.valueEquals = ne.generateId = ne.getValueByPath = void 0;
var dx = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
  return typeof n;
} : function(n) {
  return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
};
ne.noop = mx;
ne.hasOwn = gx;
ne.toObject = yx;
ne.getPropByPath = bx;
ne.rafThrottle = xx;
ne.objToArray = Cx;
var fx = Nt, xl = px(fx), Cd = Kt;
function px(n) {
  return n && n.__esModule ? n : { default: n };
}
var hx = Object.prototype.hasOwnProperty;
function mx() {
}
function gx(n, e) {
  return hx.call(n, e);
}
function vx(n, e) {
  for (var t in e)
    n[t] = e[t];
  return n;
}
function yx(n) {
  for (var e = {}, t = 0; t < n.length; t++)
    n[t] && vx(e, n[t]);
  return e;
}
ne.getValueByPath = function(e, t) {
  t = t || "";
  for (var r = t.split("."), i = e, s = null, o = 0, a = r.length; o < a; o++) {
    var l = r[o];
    if (!i)
      break;
    if (o === a - 1) {
      s = i[l];
      break;
    }
    i = i[l];
  }
  return s;
};
function bx(n, e, t) {
  var r = n;
  e = e.replace(/\[(\w+)\]/g, ".$1"), e = e.replace(/^\./, "");
  for (var i = e.split("."), s = 0, o = i.length; s < o - 1 && !(!r && !t); ++s) {
    var a = i[s];
    if (a in r)
      r = r[a];
    else {
      if (t)
        throw new Error("please transfer a valid prop path to form item!");
      break;
    }
  }
  return {
    o: r,
    k: i[s],
    v: r ? r[i[s]] : null
  };
}
ne.generateId = function() {
  return Math.floor(Math.random() * 1e4);
};
ne.valueEquals = function(e, t) {
  if (e === t)
    return !0;
  if (!(e instanceof Array) || !(t instanceof Array) || e.length !== t.length)
    return !1;
  for (var r = 0; r !== e.length; ++r)
    if (e[r] !== t[r])
      return !1;
  return !0;
};
ne.escapeRegexpString = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  return String(e).replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
};
var wx = ne.arrayFindIndex = function(e, t) {
  for (var r = 0; r !== e.length; ++r)
    if (t(e[r]))
      return r;
  return -1;
};
ne.arrayFind = function(e, t) {
  var r = wx(e, t);
  return r !== -1 ? e[r] : void 0;
};
ne.coerceTruthyValueToArray = function(e) {
  return Array.isArray(e) ? e : e ? [e] : [];
};
ne.isIE = function() {
  return !xl.default.prototype.$isServer && !isNaN(Number(document.documentMode));
};
ne.isEdge = function() {
  return !xl.default.prototype.$isServer && navigator.userAgent.indexOf("Edge") > -1;
};
ne.isFirefox = function() {
  return !xl.default.prototype.$isServer && !!window.navigator.userAgent.match(/firefox/i);
};
ne.autoprefixer = function(e) {
  if ((typeof e > "u" ? "undefined" : dx(e)) !== "object")
    return e;
  var t = ["transform", "transition", "animation"], r = ["ms-", "webkit-"];
  return t.forEach(function(i) {
    var s = e[i];
    i && s && r.forEach(function(o) {
      e[o + i] = s;
    });
  }), e;
};
ne.kebabCase = function(e) {
  var t = /([^-])([A-Z])/g;
  return e.replace(t, "$1-$2").replace(t, "$1-$2").toLowerCase();
};
ne.capitalize = function(e) {
  return (0, Cd.isString)(e) ? e.charAt(0).toUpperCase() + e.slice(1) : e;
};
var Ey = ne.looseEqual = function(e, t) {
  var r = (0, Cd.isObject)(e), i = (0, Cd.isObject)(t);
  return r && i ? JSON.stringify(e) === JSON.stringify(t) : !r && !i ? String(e) === String(t) : !1;
}, _x = ne.arrayEquals = function(e, t) {
  if (e = e || [], t = t || [], e.length !== t.length)
    return !1;
  for (var r = 0; r < e.length; r++)
    if (!Ey(e[r], t[r]))
      return !1;
  return !0;
};
ne.isEqual = function(e, t) {
  return Array.isArray(e) && Array.isArray(t) ? _x(e, t) : Ey(e, t);
};
var Sx = ne.isEmpty = function(e) {
  if (e == null)
    return !0;
  if (typeof e == "boolean")
    return !1;
  if (typeof e == "number")
    return !e;
  if (e instanceof Error)
    return e.message === "";
  switch (Object.prototype.toString.call(e)) {
    case "[object String]":
    case "[object Array]":
      return !e.length;
    case "[object File]":
    case "[object Map]":
    case "[object Set]":
      return !e.size;
    case "[object Object]":
      return !Object.keys(e).length;
  }
  return !1;
};
function xx(n) {
  var e = !1;
  return function() {
    for (var t = this, r = arguments.length, i = Array(r), s = 0; s < r; s++)
      i[s] = arguments[s];
    e || (e = !0, window.requestAnimationFrame(function(o) {
      n.apply(t, i), e = !1;
    }));
  };
}
function Cx(n) {
  return Array.isArray(n) ? n : Sx(n) ? [] : [n];
}
ne.isMac = function() {
  return !xl.default.prototype.$isServer && /macintosh|mac os x/i.test(navigator.userAgent);
};
var ho = {}, ti = {}, mo = {}, bh;
function Cl() {
  return bh || (bh = 1, mo.__esModule = !0, mo.default = function(n) {
    for (var e = 1, t = arguments.length; e < t; e++) {
      var r = arguments[e] || {};
      for (var i in r)
        if (r.hasOwnProperty(i)) {
          var s = r[i];
          s !== void 0 && (n[i] = s);
        }
    }
    return n;
  }), mo;
}
var go = {}, wh;
function Ox() {
  if (wh)
    return go;
  wh = 1, go.__esModule = !0;
  var n = Nt, e = r(n), t = ji();
  function r(f) {
    return f && f.__esModule ? f : { default: f };
  }
  var i = !1, s = !1, o = void 0, a = function() {
    if (!e.default.prototype.$isServer) {
      var p = u.modalDom;
      return p ? i = !0 : (i = !1, p = document.createElement("div"), u.modalDom = p, p.addEventListener("touchmove", function(d) {
        d.preventDefault(), d.stopPropagation();
      }), p.addEventListener("click", function() {
        u.doOnModalClick && u.doOnModalClick();
      })), p;
    }
  }, l = {}, u = {
    modalFade: !0,
    getInstance: function(p) {
      return l[p];
    },
    register: function(p, d) {
      p && d && (l[p] = d);
    },
    deregister: function(p) {
      p && (l[p] = null, delete l[p]);
    },
    nextZIndex: function() {
      return u.zIndex++;
    },
    modalStack: [],
    doOnModalClick: function() {
      var p = u.modalStack[u.modalStack.length - 1];
      if (!!p) {
        var d = u.getInstance(p.id);
        d && d.closeOnClickModal && d.close();
      }
    },
    openModal: function(p, d, h, v, g) {
      if (!e.default.prototype.$isServer && !(!p || d === void 0)) {
        this.modalFade = g;
        for (var m = this.modalStack, _ = 0, y = m.length; _ < y; _++) {
          var w = m[_];
          if (w.id === p)
            return;
        }
        var O = a();
        if ((0, t.addClass)(O, "v-modal"), this.modalFade && !i && (0, t.addClass)(O, "v-modal-enter"), v) {
          var C = v.trim().split(/\s+/);
          C.forEach(function(S) {
            return (0, t.addClass)(O, S);
          });
        }
        setTimeout(function() {
          (0, t.removeClass)(O, "v-modal-enter");
        }, 200), h && h.parentNode && h.parentNode.nodeType !== 11 ? h.parentNode.appendChild(O) : document.body.appendChild(O), d && (O.style.zIndex = d), O.tabIndex = 0, O.style.display = "", this.modalStack.push({ id: p, zIndex: d, modalClass: v });
      }
    },
    closeModal: function(p) {
      var d = this.modalStack, h = a();
      if (d.length > 0) {
        var v = d[d.length - 1];
        if (v.id === p) {
          if (v.modalClass) {
            var g = v.modalClass.trim().split(/\s+/);
            g.forEach(function(_) {
              return (0, t.removeClass)(h, _);
            });
          }
          d.pop(), d.length > 0 && (h.style.zIndex = d[d.length - 1].zIndex);
        } else
          for (var m = d.length - 1; m >= 0; m--)
            if (d[m].id === p) {
              d.splice(m, 1);
              break;
            }
      }
      d.length === 0 && (this.modalFade && (0, t.addClass)(h, "v-modal-leave"), setTimeout(function() {
        d.length === 0 && (h.parentNode && h.parentNode.removeChild(h), h.style.display = "none", u.modalDom = void 0), (0, t.removeClass)(h, "v-modal-leave");
      }, 200));
    }
  };
  Object.defineProperty(u, "zIndex", {
    configurable: !0,
    get: function() {
      return s || (o = o || (e.default.prototype.$ELEMENT || {}).zIndex || 2e3, s = !0), o;
    },
    set: function(p) {
      o = p;
    }
  });
  var c = function() {
    if (!e.default.prototype.$isServer && u.modalStack.length > 0) {
      var p = u.modalStack[u.modalStack.length - 1];
      if (!p)
        return;
      var d = u.getInstance(p.id);
      return d;
    }
  };
  return e.default.prototype.$isServer || window.addEventListener("keydown", function(f) {
    if (f.keyCode === 27) {
      var p = c();
      p && p.closeOnPressEscape && (p.handleClose ? p.handleClose() : p.handleAction ? p.handleAction("cancel") : p.close());
    }
  }), go.default = u, go;
}
var vo = {}, _h;
function Ty() {
  if (_h)
    return vo;
  _h = 1, vo.__esModule = !0, vo.default = function() {
    if (e.default.prototype.$isServer)
      return 0;
    if (r !== void 0)
      return r;
    var i = document.createElement("div");
    i.className = "el-scrollbar__wrap", i.style.visibility = "hidden", i.style.width = "100px", i.style.position = "absolute", i.style.top = "-9999px", document.body.appendChild(i);
    var s = i.offsetWidth;
    i.style.overflow = "scroll";
    var o = document.createElement("div");
    o.style.width = "100%", i.appendChild(o);
    var a = o.offsetWidth;
    return i.parentNode.removeChild(i), r = s - a, r;
  };
  var n = Nt, e = t(n);
  function t(i) {
    return i && i.__esModule ? i : { default: i };
  }
  var r = void 0;
  return vo;
}
var Sh;
function ky() {
  if (Sh)
    return ti;
  Sh = 1, ti.__esModule = !0, ti.PopupManager = void 0;
  var n = Nt, e = u(n), t = Cl(), r = u(t), i = Ox(), s = u(i), o = Ty(), a = u(o), l = ji();
  function u(p) {
    return p && p.__esModule ? p : { default: p };
  }
  var c = 1, f = void 0;
  return ti.default = {
    props: {
      visible: {
        type: Boolean,
        default: !1
      },
      openDelay: {},
      closeDelay: {},
      zIndex: {},
      modal: {
        type: Boolean,
        default: !1
      },
      modalFade: {
        type: Boolean,
        default: !0
      },
      modalClass: {},
      modalAppendToBody: {
        type: Boolean,
        default: !1
      },
      lockScroll: {
        type: Boolean,
        default: !0
      },
      closeOnPressEscape: {
        type: Boolean,
        default: !1
      },
      closeOnClickModal: {
        type: Boolean,
        default: !1
      }
    },
    beforeMount: function() {
      this._popupId = "popup-" + c++, s.default.register(this._popupId, this);
    },
    beforeDestroy: function() {
      s.default.deregister(this._popupId), s.default.closeModal(this._popupId), this.restoreBodyStyle();
    },
    data: function() {
      return {
        opened: !1,
        bodyPaddingRight: null,
        computedBodyPaddingRight: 0,
        withoutHiddenClass: !0,
        rendered: !1
      };
    },
    watch: {
      visible: function(d) {
        var h = this;
        if (d) {
          if (this._opening)
            return;
          this.rendered ? this.open() : (this.rendered = !0, e.default.nextTick(function() {
            h.open();
          }));
        } else
          this.close();
      }
    },
    methods: {
      open: function(d) {
        var h = this;
        this.rendered || (this.rendered = !0);
        var v = (0, r.default)({}, this.$props || this, d);
        this._closeTimer && (clearTimeout(this._closeTimer), this._closeTimer = null), clearTimeout(this._openTimer);
        var g = Number(v.openDelay);
        g > 0 ? this._openTimer = setTimeout(function() {
          h._openTimer = null, h.doOpen(v);
        }, g) : this.doOpen(v);
      },
      doOpen: function(d) {
        if (!this.$isServer && !(this.willOpen && !this.willOpen()) && !this.opened) {
          this._opening = !0;
          var h = this.$el, v = d.modal, g = d.zIndex;
          if (g && (s.default.zIndex = g), v && (this._closing && (s.default.closeModal(this._popupId), this._closing = !1), s.default.openModal(this._popupId, s.default.nextZIndex(), this.modalAppendToBody ? void 0 : h, d.modalClass, d.modalFade), d.lockScroll)) {
            this.withoutHiddenClass = !(0, l.hasClass)(document.body, "el-popup-parent--hidden"), this.withoutHiddenClass && (this.bodyPaddingRight = document.body.style.paddingRight, this.computedBodyPaddingRight = parseInt((0, l.getStyle)(document.body, "paddingRight"), 10)), f = (0, a.default)();
            var m = document.documentElement.clientHeight < document.body.scrollHeight, _ = (0, l.getStyle)(document.body, "overflowY");
            f > 0 && (m || _ === "scroll") && this.withoutHiddenClass && (document.body.style.paddingRight = this.computedBodyPaddingRight + f + "px"), (0, l.addClass)(document.body, "el-popup-parent--hidden");
          }
          getComputedStyle(h).position === "static" && (h.style.position = "absolute"), h.style.zIndex = s.default.nextZIndex(), this.opened = !0, this.onOpen && this.onOpen(), this.doAfterOpen();
        }
      },
      doAfterOpen: function() {
        this._opening = !1;
      },
      close: function() {
        var d = this;
        if (!(this.willClose && !this.willClose())) {
          this._openTimer !== null && (clearTimeout(this._openTimer), this._openTimer = null), clearTimeout(this._closeTimer);
          var h = Number(this.closeDelay);
          h > 0 ? this._closeTimer = setTimeout(function() {
            d._closeTimer = null, d.doClose();
          }, h) : this.doClose();
        }
      },
      doClose: function() {
        this._closing = !0, this.onClose && this.onClose(), this.lockScroll && setTimeout(this.restoreBodyStyle, 200), this.opened = !1, this.doAfterClose();
      },
      doAfterClose: function() {
        s.default.closeModal(this._popupId), this._closing = !1;
      },
      restoreBodyStyle: function() {
        this.modal && this.withoutHiddenClass && (document.body.style.paddingRight = this.bodyPaddingRight, (0, l.removeClass)(document.body, "el-popup-parent--hidden")), this.withoutHiddenClass = !0;
      }
    }
  }, ti.PopupManager = s.default, ti;
}
var Uu = { exports: {} }, xh;
function Ex() {
  return xh || (xh = 1, function(n) {
    var e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    };
    (function(t, r) {
      e(n) === "object" && n.exports ? n.exports = r() : t.Popper = r();
    })(void 0, function() {
      var t = window, r = {
        placement: "bottom",
        gpuAcceleration: !0,
        offset: 0,
        boundariesElement: "viewport",
        boundariesPadding: 5,
        preventOverflowOrder: ["left", "right", "top", "bottom"],
        flipBehavior: "flip",
        arrowElement: "[x-arrow]",
        arrowOffset: 0,
        modifiers: ["shift", "offset", "preventOverflow", "keepTogether", "arrow", "flip", "applyStyle"],
        modifiersIgnored: [],
        forceAbsolute: !1
      };
      function i(y, w, O) {
        this._reference = y.jquery ? y[0] : y, this.state = {};
        var C = typeof w > "u" || w === null, S = w && Object.prototype.toString.call(w) === "[object Object]";
        return C || S ? this._popper = this.parse(S ? w : {}) : this._popper = w.jquery ? w[0] : w, this._options = Object.assign({}, r, O), this._options.modifiers = this._options.modifiers.map(function(b) {
          if (this._options.modifiersIgnored.indexOf(b) === -1)
            return b === "applyStyle" && this._popper.setAttribute("x-placement", this._options.placement), this.modifiers[b] || b;
        }.bind(this)), this.state.position = this._getPosition(this._popper, this._reference), d(this._popper, { position: this.state.position, top: 0 }), this.update(), this._setupEventListeners(), this;
      }
      i.prototype.destroy = function() {
        return this._popper.removeAttribute("x-placement"), this._popper.style.left = "", this._popper.style.position = "", this._popper.style.top = "", this._popper.style[_("transform")] = "", this._removeEventListeners(), this._options.removeOnDestroy && this._popper.remove(), this;
      }, i.prototype.update = function() {
        var y = { instance: this, styles: {} };
        y.placement = this._options.placement, y._originalPlacement = this._options.placement, y.offsets = this._getOffsets(this._popper, this._reference, y.placement), y.boundaries = this._getBoundaries(y, this._options.boundariesPadding, this._options.boundariesElement), y = this.runModifiers(y, this._options.modifiers), typeof this.state.updateCallback == "function" && this.state.updateCallback(y);
      }, i.prototype.onCreate = function(y) {
        return y(this), this;
      }, i.prototype.onUpdate = function(y) {
        return this.state.updateCallback = y, this;
      }, i.prototype.parse = function(y) {
        var w = {
          tagName: "div",
          classNames: ["popper"],
          attributes: [],
          parent: t.document.body,
          content: "",
          contentType: "text",
          arrowTagName: "div",
          arrowClassNames: ["popper__arrow"],
          arrowAttributes: ["x-arrow"]
        };
        y = Object.assign({}, w, y);
        var O = t.document, C = O.createElement(y.tagName);
        if (x(C, y.classNames), E(C, y.attributes), y.contentType === "node" ? C.appendChild(y.content.jquery ? y.content[0] : y.content) : y.contentType === "html" ? C.innerHTML = y.content : C.textContent = y.content, y.arrowTagName) {
          var S = O.createElement(y.arrowTagName);
          x(S, y.arrowClassNames), E(S, y.arrowAttributes), C.appendChild(S);
        }
        var b = y.parent.jquery ? y.parent[0] : y.parent;
        if (typeof b == "string") {
          if (b = O.querySelectorAll(y.parent), b.length > 1 && console.warn("WARNING: the given `parent` query(" + y.parent + ") matched more than one element, the first one will be used"), b.length === 0)
            throw "ERROR: the given `parent` doesn't exists!";
          b = b[0];
        }
        return b.length > 1 && !(b instanceof Element) && (console.warn("WARNING: you have passed as parent a list of elements, the first one will be used"), b = b[0]), b.appendChild(C), C;
        function x(M, $) {
          $.forEach(function(F) {
            M.classList.add(F);
          });
        }
        function E(M, $) {
          $.forEach(function(F) {
            M.setAttribute(F.split(":")[0], F.split(":")[1] || "");
          });
        }
      }, i.prototype._getPosition = function(y, w) {
        if (c(w), this._options.forceAbsolute)
          return "absolute";
        var O = p(w);
        return O ? "fixed" : "absolute";
      }, i.prototype._getOffsets = function(y, w, O) {
        O = O.split("-")[0];
        var C = {};
        C.position = this.state.position;
        var S = C.position === "fixed", b = m(w, c(y), S), x = s(y);
        return ["right", "left"].indexOf(O) !== -1 ? (C.top = b.top + b.height / 2 - x.height / 2, O === "left" ? C.left = b.left - x.width : C.left = b.right) : (C.left = b.left + b.width / 2 - x.width / 2, O === "top" ? C.top = b.top - x.height : C.top = b.bottom), C.width = x.width, C.height = x.height, {
          popper: C,
          reference: b
        };
      }, i.prototype._setupEventListeners = function() {
        if (this.state.updateBound = this.update.bind(this), t.addEventListener("resize", this.state.updateBound), this._options.boundariesElement !== "window") {
          var y = f(this._reference);
          (y === t.document.body || y === t.document.documentElement) && (y = t), y.addEventListener("scroll", this.state.updateBound), this.state.scrollTarget = y;
        }
      }, i.prototype._removeEventListeners = function() {
        t.removeEventListener("resize", this.state.updateBound), this._options.boundariesElement !== "window" && this.state.scrollTarget && (this.state.scrollTarget.removeEventListener("scroll", this.state.updateBound), this.state.scrollTarget = null), this.state.updateBound = null;
      }, i.prototype._getBoundaries = function(y, w, O) {
        var C = {}, S, b;
        if (O === "window") {
          var x = t.document.body, E = t.document.documentElement;
          b = Math.max(x.scrollHeight, x.offsetHeight, E.clientHeight, E.scrollHeight, E.offsetHeight), S = Math.max(x.scrollWidth, x.offsetWidth, E.clientWidth, E.scrollWidth, E.offsetWidth), C = {
            top: 0,
            right: S,
            bottom: b,
            left: 0
          };
        } else if (O === "viewport") {
          var M = c(this._popper), $ = f(this._popper), F = v(M), J = function(j) {
            return j == document.body ? Math.max(document.documentElement.scrollTop, document.body.scrollTop) : j.scrollTop;
          }, W = function(j) {
            return j == document.body ? Math.max(document.documentElement.scrollLeft, document.body.scrollLeft) : j.scrollLeft;
          }, H = y.offsets.popper.position === "fixed" ? 0 : J($), Y = y.offsets.popper.position === "fixed" ? 0 : W($);
          C = {
            top: 0 - (F.top - H),
            right: t.document.documentElement.clientWidth - (F.left - Y),
            bottom: t.document.documentElement.clientHeight - (F.top - H),
            left: 0 - (F.left - Y)
          };
        } else
          c(this._popper) === O ? C = {
            top: 0,
            left: 0,
            right: O.clientWidth,
            bottom: O.clientHeight
          } : C = v(O);
        return C.left += w, C.right -= w, C.top = C.top + w, C.bottom = C.bottom - w, C;
      }, i.prototype.runModifiers = function(y, w, O) {
        var C = w.slice();
        return O !== void 0 && (C = this._options.modifiers.slice(0, l(this._options.modifiers, O))), C.forEach(function(S) {
          h(S) && (y = S.call(this, y));
        }.bind(this)), y;
      }, i.prototype.isModifierRequired = function(y, w) {
        var O = l(this._options.modifiers, y);
        return !!this._options.modifiers.slice(0, O).filter(function(C) {
          return C === w;
        }).length;
      }, i.prototype.modifiers = {}, i.prototype.modifiers.applyStyle = function(y) {
        var w = {
          position: y.offsets.popper.position
        }, O = Math.round(y.offsets.popper.left), C = Math.round(y.offsets.popper.top), S;
        return this._options.gpuAcceleration && (S = _("transform")) ? (w[S] = "translate3d(" + O + "px, " + C + "px, 0)", w.top = 0, w.left = 0) : (w.left = O, w.top = C), Object.assign(w, y.styles), d(this._popper, w), this._popper.setAttribute("x-placement", y.placement), this.isModifierRequired(this.modifiers.applyStyle, this.modifiers.arrow) && y.offsets.arrow && d(y.arrowElement, y.offsets.arrow), y;
      }, i.prototype.modifiers.shift = function(y) {
        var w = y.placement, O = w.split("-")[0], C = w.split("-")[1];
        if (C) {
          var S = y.offsets.reference, b = a(y.offsets.popper), x = {
            y: {
              start: { top: S.top },
              end: { top: S.top + S.height - b.height }
            },
            x: {
              start: { left: S.left },
              end: { left: S.left + S.width - b.width }
            }
          }, E = ["bottom", "top"].indexOf(O) !== -1 ? "x" : "y";
          y.offsets.popper = Object.assign(b, x[E][C]);
        }
        return y;
      }, i.prototype.modifiers.preventOverflow = function(y) {
        var w = this._options.preventOverflowOrder, O = a(y.offsets.popper), C = {
          left: function() {
            var b = O.left;
            return O.left < y.boundaries.left && (b = Math.max(O.left, y.boundaries.left)), { left: b };
          },
          right: function() {
            var b = O.left;
            return O.right > y.boundaries.right && (b = Math.min(O.left, y.boundaries.right - O.width)), { left: b };
          },
          top: function() {
            var b = O.top;
            return O.top < y.boundaries.top && (b = Math.max(O.top, y.boundaries.top)), { top: b };
          },
          bottom: function() {
            var b = O.top;
            return O.bottom > y.boundaries.bottom && (b = Math.min(O.top, y.boundaries.bottom - O.height)), { top: b };
          }
        };
        return w.forEach(function(S) {
          y.offsets.popper = Object.assign(O, C[S]());
        }), y;
      }, i.prototype.modifiers.keepTogether = function(y) {
        var w = a(y.offsets.popper), O = y.offsets.reference, C = Math.floor;
        return w.right < C(O.left) && (y.offsets.popper.left = C(O.left) - w.width), w.left > C(O.right) && (y.offsets.popper.left = C(O.right)), w.bottom < C(O.top) && (y.offsets.popper.top = C(O.top) - w.height), w.top > C(O.bottom) && (y.offsets.popper.top = C(O.bottom)), y;
      }, i.prototype.modifiers.flip = function(y) {
        if (!this.isModifierRequired(this.modifiers.flip, this.modifiers.preventOverflow))
          return console.warn("WARNING: preventOverflow modifier is required by flip modifier in order to work, be sure to include it before flip!"), y;
        if (y.flipped && y.placement === y._originalPlacement)
          return y;
        var w = y.placement.split("-")[0], O = o(w), C = y.placement.split("-")[1] || "", S = [];
        return this._options.flipBehavior === "flip" ? S = [w, O] : S = this._options.flipBehavior, S.forEach(function(b, x) {
          if (!(w !== b || S.length === x + 1)) {
            w = y.placement.split("-")[0], O = o(w);
            var E = a(y.offsets.popper), M = ["right", "bottom"].indexOf(w) !== -1;
            (M && Math.floor(y.offsets.reference[w]) > Math.floor(E[O]) || !M && Math.floor(y.offsets.reference[w]) < Math.floor(E[O])) && (y.flipped = !0, y.placement = S[x + 1], C && (y.placement += "-" + C), y.offsets.popper = this._getOffsets(this._popper, this._reference, y.placement).popper, y = this.runModifiers(y, this._options.modifiers, this._flip));
          }
        }.bind(this)), y;
      }, i.prototype.modifiers.offset = function(y) {
        var w = this._options.offset, O = y.offsets.popper;
        return y.placement.indexOf("left") !== -1 ? O.top -= w : y.placement.indexOf("right") !== -1 ? O.top += w : y.placement.indexOf("top") !== -1 ? O.left -= w : y.placement.indexOf("bottom") !== -1 && (O.left += w), y;
      }, i.prototype.modifiers.arrow = function(y) {
        var w = this._options.arrowElement, O = this._options.arrowOffset;
        if (typeof w == "string" && (w = this._popper.querySelector(w)), !w)
          return y;
        if (!this._popper.contains(w))
          return console.warn("WARNING: `arrowElement` must be child of its popper element!"), y;
        if (!this.isModifierRequired(this.modifiers.arrow, this.modifiers.keepTogether))
          return console.warn("WARNING: keepTogether modifier is required by arrow modifier in order to work, be sure to include it before arrow!"), y;
        var C = {}, S = y.placement.split("-")[0], b = a(y.offsets.popper), x = y.offsets.reference, E = ["left", "right"].indexOf(S) !== -1, M = E ? "height" : "width", $ = E ? "top" : "left", F = E ? "left" : "top", J = E ? "bottom" : "right", W = s(w)[M];
        x[J] - W < b[$] && (y.offsets.popper[$] -= b[$] - (x[J] - W)), x[$] + W > b[J] && (y.offsets.popper[$] += x[$] + W - b[J]);
        var H = x[$] + (O || x[M] / 2 - W / 2), Y = H - b[$];
        return Y = Math.max(Math.min(b[M] - W - 8, Y), 8), C[$] = Y, C[F] = "", y.offsets.arrow = C, y.arrowElement = w, y;
      };
      function s(y) {
        var w = y.style.display, O = y.style.visibility;
        y.style.display = "block", y.style.visibility = "hidden", y.offsetWidth;
        var C = t.getComputedStyle(y), S = parseFloat(C.marginTop) + parseFloat(C.marginBottom), b = parseFloat(C.marginLeft) + parseFloat(C.marginRight), x = { width: y.offsetWidth + b, height: y.offsetHeight + S };
        return y.style.display = w, y.style.visibility = O, x;
      }
      function o(y) {
        var w = { left: "right", right: "left", bottom: "top", top: "bottom" };
        return y.replace(/left|right|bottom|top/g, function(O) {
          return w[O];
        });
      }
      function a(y) {
        var w = Object.assign({}, y);
        return w.right = w.left + w.width, w.bottom = w.top + w.height, w;
      }
      function l(y, w) {
        var O = 0, C;
        for (C in y) {
          if (y[C] === w)
            return O;
          O++;
        }
        return null;
      }
      function u(y, w) {
        var O = t.getComputedStyle(y, null);
        return O[w];
      }
      function c(y) {
        var w = y.offsetParent;
        return w === t.document.body || !w ? t.document.documentElement : w;
      }
      function f(y) {
        var w = y.parentNode;
        return w ? w === t.document ? t.document.body.scrollTop || t.document.body.scrollLeft ? t.document.body : t.document.documentElement : ["scroll", "auto"].indexOf(u(w, "overflow")) !== -1 || ["scroll", "auto"].indexOf(u(w, "overflow-x")) !== -1 || ["scroll", "auto"].indexOf(u(w, "overflow-y")) !== -1 ? w : f(y.parentNode) : y;
      }
      function p(y) {
        return y === t.document.body ? !1 : u(y, "position") === "fixed" ? !0 : y.parentNode ? p(y.parentNode) : y;
      }
      function d(y, w) {
        function O(C) {
          return C !== "" && !isNaN(parseFloat(C)) && isFinite(C);
        }
        Object.keys(w).forEach(function(C) {
          var S = "";
          ["width", "height", "top", "right", "bottom", "left"].indexOf(C) !== -1 && O(w[C]) && (S = "px"), y.style[C] = w[C] + S;
        });
      }
      function h(y) {
        var w = {};
        return y && w.toString.call(y) === "[object Function]";
      }
      function v(y) {
        var w = {
          width: y.offsetWidth,
          height: y.offsetHeight,
          left: y.offsetLeft,
          top: y.offsetTop
        };
        return w.right = w.left + w.width, w.bottom = w.top + w.height, w;
      }
      function g(y) {
        var w = y.getBoundingClientRect(), O = navigator.userAgent.indexOf("MSIE") != -1, C = O && y.tagName === "HTML" ? -y.scrollTop : w.top;
        return {
          left: w.left,
          top: C,
          right: w.right,
          bottom: w.bottom,
          width: w.right - w.left,
          height: w.bottom - C
        };
      }
      function m(y, w, O) {
        var C = g(y), S = g(w);
        if (O) {
          var b = f(w);
          S.top += b.scrollTop, S.bottom += b.scrollTop, S.left += b.scrollLeft, S.right += b.scrollLeft;
        }
        var x = {
          top: C.top - S.top,
          left: C.left - S.left,
          bottom: C.top - S.top + C.height,
          right: C.left - S.left + C.width,
          width: C.width,
          height: C.height
        };
        return x;
      }
      function _(y) {
        for (var w = ["", "ms", "webkit", "moz", "o"], O = 0; O < w.length; O++) {
          var C = w[O] ? w[O] + y.charAt(0).toUpperCase() + y.slice(1) : y;
          if (typeof t.document.body.style[C] < "u")
            return C;
        }
        return null;
      }
      return Object.assign || Object.defineProperty(Object, "assign", {
        enumerable: !1,
        configurable: !0,
        writable: !0,
        value: function(w) {
          if (w == null)
            throw new TypeError("Cannot convert first argument to object");
          for (var O = Object(w), C = 1; C < arguments.length; C++) {
            var S = arguments[C];
            if (S != null) {
              S = Object(S);
              for (var b = Object.keys(S), x = 0, E = b.length; x < E; x++) {
                var M = b[x], $ = Object.getOwnPropertyDescriptor(S, M);
                $ !== void 0 && $.enumerable && (O[M] = S[M]);
              }
            }
          }
          return O;
        }
      }), i;
    });
  }(Uu)), Uu.exports;
}
var Ch;
function Ol() {
  if (Ch)
    return ho;
  Ch = 1, ho.__esModule = !0;
  var n = Nt, e = r(n), t = ky();
  function r(o) {
    return o && o.__esModule ? o : { default: o };
  }
  var i = e.default.prototype.$isServer ? function() {
  } : Ex(), s = function(a) {
    return a.stopPropagation();
  };
  return ho.default = {
    props: {
      transformOrigin: {
        type: [Boolean, String],
        default: !0
      },
      placement: {
        type: String,
        default: "bottom"
      },
      boundariesPadding: {
        type: Number,
        default: 5
      },
      reference: {},
      popper: {},
      offset: {
        default: 0
      },
      value: Boolean,
      visibleArrow: Boolean,
      arrowOffset: {
        type: Number,
        default: 35
      },
      appendToBody: {
        type: Boolean,
        default: !0
      },
      popperOptions: {
        type: Object,
        default: function() {
          return {
            gpuAcceleration: !1
          };
        }
      }
    },
    data: function() {
      return {
        showPopper: !1,
        currentPlacement: ""
      };
    },
    watch: {
      value: {
        immediate: !0,
        handler: function(a) {
          this.showPopper = a, this.$emit("input", a);
        }
      },
      showPopper: function(a) {
        this.disabled || (a ? this.updatePopper() : this.destroyPopper(), this.$emit("input", a));
      }
    },
    methods: {
      createPopper: function() {
        var a = this;
        if (!this.$isServer && (this.currentPlacement = this.currentPlacement || this.placement, !!/^(top|bottom|left|right)(-start|-end)?$/g.test(this.currentPlacement))) {
          var l = this.popperOptions, u = this.popperElm = this.popperElm || this.popper || this.$refs.popper, c = this.referenceElm = this.referenceElm || this.reference || this.$refs.reference;
          !c && this.$slots.reference && this.$slots.reference[0] && (c = this.referenceElm = this.$slots.reference[0].elm), !(!u || !c) && (this.visibleArrow && this.appendArrow(u), this.appendToBody && document.body.appendChild(this.popperElm), this.popperJS && this.popperJS.destroy && this.popperJS.destroy(), l.placement = this.currentPlacement, l.offset = this.offset, l.arrowOffset = this.arrowOffset, this.popperJS = new i(c, u, l), this.popperJS.onCreate(function(f) {
            a.$emit("created", a), a.resetTransformOrigin(), a.$nextTick(a.updatePopper);
          }), typeof l.onUpdate == "function" && this.popperJS.onUpdate(l.onUpdate), this.popperJS._popper.style.zIndex = t.PopupManager.nextZIndex(), this.popperElm.addEventListener("click", s));
        }
      },
      updatePopper: function() {
        var a = this.popperJS;
        a ? (a.update(), a._popper && (a._popper.style.zIndex = t.PopupManager.nextZIndex())) : this.createPopper();
      },
      doDestroy: function(a) {
        !this.popperJS || this.showPopper && !a || (this.popperJS.destroy(), this.popperJS = null);
      },
      destroyPopper: function() {
        this.popperJS && this.resetTransformOrigin();
      },
      resetTransformOrigin: function() {
        if (!!this.transformOrigin) {
          var a = {
            top: "bottom",
            bottom: "top",
            left: "right",
            right: "left"
          }, l = this.popperJS._popper.getAttribute("x-placement").split("-")[0], u = a[l];
          this.popperJS._popper.style.transformOrigin = typeof this.transformOrigin == "string" ? this.transformOrigin : ["top", "bottom"].indexOf(l) > -1 ? "center " + u : u + " center";
        }
      },
      appendArrow: function(a) {
        var l = void 0;
        if (!this.appended) {
          this.appended = !0;
          for (var u in a.attributes)
            if (/^_v-/.test(a.attributes[u].name)) {
              l = a.attributes[u].name;
              break;
            }
          var c = document.createElement("div");
          l && c.setAttribute(l, ""), c.setAttribute("x-arrow", ""), c.className = "popper__arrow", a.appendChild(c);
        }
      }
    },
    beforeDestroy: function() {
      this.doDestroy(!0), this.popperElm && this.popperElm.parentNode === document.body && (this.popperElm.removeEventListener("click", s), document.body.removeChild(this.popperElm));
    },
    deactivated: function() {
      this.$options.beforeDestroy[0].call(this);
    }
  }, ho;
}
(function(n) {
  n.exports = function(e) {
    var t = {};
    function r(i) {
      if (t[i])
        return t[i].exports;
      var s = t[i] = {
        i,
        l: !1,
        exports: {}
      };
      return e[i].call(s.exports, s, s.exports, r), s.l = !0, s.exports;
    }
    return r.m = e, r.c = t, r.d = function(i, s, o) {
      r.o(i, s) || Object.defineProperty(i, s, { enumerable: !0, get: o });
    }, r.r = function(i) {
      typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(i, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(i, "__esModule", { value: !0 });
    }, r.t = function(i, s) {
      if (s & 1 && (i = r(i)), s & 8 || s & 4 && typeof i == "object" && i && i.__esModule)
        return i;
      var o = /* @__PURE__ */ Object.create(null);
      if (r.r(o), Object.defineProperty(o, "default", { enumerable: !0, value: i }), s & 2 && typeof i != "string")
        for (var a in i)
          r.d(o, a, function(l) {
            return i[l];
          }.bind(null, a));
      return o;
    }, r.n = function(i) {
      var s = i && i.__esModule ? function() {
        return i.default;
      } : function() {
        return i;
      };
      return r.d(s, "a", s), s;
    }, r.o = function(i, s) {
      return Object.prototype.hasOwnProperty.call(i, s);
    }, r.p = "/dist/", r(r.s = 138);
  }({
    138: function(e, t, r) {
      r.r(t);
      var i = r(5), s = /* @__PURE__ */ r.n(i), o = r(19), a = /* @__PURE__ */ r.n(o), l = r(2), u = r(3), c = r(7), f = /* @__PURE__ */ r.n(c), p = {
        name: "ElTooltip",
        mixins: [s.a],
        props: {
          openDelay: {
            type: Number,
            default: 0
          },
          disabled: Boolean,
          manual: Boolean,
          effect: {
            type: String,
            default: "dark"
          },
          arrowOffset: {
            type: Number,
            default: 0
          },
          popperClass: String,
          content: String,
          visibleArrow: {
            default: !0
          },
          transition: {
            type: String,
            default: "el-fade-in-linear"
          },
          popperOptions: {
            default: function() {
              return {
                boundariesPadding: 10,
                gpuAcceleration: !1
              };
            }
          },
          enterable: {
            type: Boolean,
            default: !0
          },
          hideAfter: {
            type: Number,
            default: 0
          },
          tabindex: {
            type: Number,
            default: 0
          }
        },
        data: function() {
          return {
            tooltipId: "el-tooltip-" + Object(u.generateId)(),
            timeoutPending: null,
            focusing: !1
          };
        },
        beforeCreate: function() {
          var h = this;
          this.$isServer || (this.popperVM = new f.a({
            data: { node: "" },
            render: function(g) {
              return this.node;
            }
          }).$mount(), this.debounceClose = a()(200, function() {
            return h.handleClosePopper();
          }));
        },
        render: function(h) {
          var v = this;
          this.popperVM && (this.popperVM.node = h(
            "transition",
            {
              attrs: {
                name: this.transition
              },
              on: {
                afterLeave: this.doDestroy
              }
            },
            [h(
              "div",
              {
                on: {
                  mouseleave: function() {
                    v.setExpectedState(!1), v.debounceClose();
                  },
                  mouseenter: function() {
                    v.setExpectedState(!0);
                  }
                },
                ref: "popper",
                attrs: {
                  role: "tooltip",
                  id: this.tooltipId,
                  "aria-hidden": this.disabled || !this.showPopper ? "true" : "false"
                },
                directives: [{
                  name: "show",
                  value: !this.disabled && this.showPopper
                }],
                class: ["el-tooltip__popper", "is-" + this.effect, this.popperClass]
              },
              [this.$slots.content || this.content]
            )]
          ));
          var g = this.getFirstElement();
          if (!g)
            return null;
          var m = g.data = g.data || {};
          return m.staticClass = this.addTooltipClass(m.staticClass), g;
        },
        mounted: function() {
          var h = this;
          this.referenceElm = this.$el, this.$el.nodeType === 1 && (this.$el.setAttribute("aria-describedby", this.tooltipId), this.$el.setAttribute("tabindex", this.tabindex), Object(l.on)(this.referenceElm, "mouseenter", this.show), Object(l.on)(this.referenceElm, "mouseleave", this.hide), Object(l.on)(this.referenceElm, "focus", function() {
            if (!h.$slots.default || !h.$slots.default.length) {
              h.handleFocus();
              return;
            }
            var v = h.$slots.default[0].componentInstance;
            v && v.focus ? v.focus() : h.handleFocus();
          }), Object(l.on)(this.referenceElm, "blur", this.handleBlur), Object(l.on)(this.referenceElm, "click", this.removeFocusing)), this.value && this.popperVM && this.popperVM.$nextTick(function() {
            h.value && h.updatePopper();
          });
        },
        watch: {
          focusing: function(h) {
            h ? Object(l.addClass)(this.referenceElm, "focusing") : Object(l.removeClass)(this.referenceElm, "focusing");
          }
        },
        methods: {
          show: function() {
            this.setExpectedState(!0), this.handleShowPopper();
          },
          hide: function() {
            this.setExpectedState(!1), this.debounceClose();
          },
          handleFocus: function() {
            this.focusing = !0, this.show();
          },
          handleBlur: function() {
            this.focusing = !1, this.hide();
          },
          removeFocusing: function() {
            this.focusing = !1;
          },
          addTooltipClass: function(h) {
            return h ? "el-tooltip " + h.replace("el-tooltip", "") : "el-tooltip";
          },
          handleShowPopper: function() {
            var h = this;
            !this.expectedState || this.manual || (clearTimeout(this.timeout), this.timeout = setTimeout(function() {
              h.showPopper = !0;
            }, this.openDelay), this.hideAfter > 0 && (this.timeoutPending = setTimeout(function() {
              h.showPopper = !1;
            }, this.hideAfter)));
          },
          handleClosePopper: function() {
            this.enterable && this.expectedState || this.manual || (clearTimeout(this.timeout), this.timeoutPending && clearTimeout(this.timeoutPending), this.showPopper = !1, this.disabled && this.doDestroy());
          },
          setExpectedState: function(h) {
            h === !1 && clearTimeout(this.timeoutPending), this.expectedState = h;
          },
          getFirstElement: function() {
            var h = this.$slots.default;
            if (!Array.isArray(h))
              return null;
            for (var v = null, g = 0; g < h.length; g++)
              if (h[g] && h[g].tag) {
                v = h[g];
                break;
              }
            return v;
          }
        },
        beforeDestroy: function() {
          this.popperVM && this.popperVM.$destroy();
        },
        destroyed: function() {
          var h = this.referenceElm;
          h.nodeType === 1 && (Object(l.off)(h, "mouseenter", this.show), Object(l.off)(h, "mouseleave", this.hide), Object(l.off)(h, "focus", this.handleFocus), Object(l.off)(h, "blur", this.handleBlur), Object(l.off)(h, "click", this.removeFocusing));
        }
      };
      p.install = function(d) {
        d.component(p.name, p);
      }, t.default = p;
    },
    19: function(e, t) {
      e.exports = Nf();
    },
    2: function(e, t) {
      e.exports = ji();
    },
    3: function(e, t) {
      e.exports = ne;
    },
    5: function(e, t) {
      e.exports = Ol();
    },
    7: function(e, t) {
      e.exports = Nt;
    }
  });
})(Lf);
const Tx = /* @__PURE__ */ ot(Lf.exports);
function le(n, e, t, r, i, s, o, a) {
  var l = typeof n == "function" ? n.options : n;
  e && (l.render = e, l.staticRenderFns = t, l._compiled = !0), r && (l.functional = !0), s && (l._scopeId = "data-v-" + s);
  var u;
  if (o ? (u = function(p) {
    p = p || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !p && typeof __VUE_SSR_CONTEXT__ < "u" && (p = __VUE_SSR_CONTEXT__), i && i.call(this, p), p && p._registeredComponents && p._registeredComponents.add(o);
  }, l._ssrRegister = u) : i && (u = a ? function() {
    i.call(
      this,
      (l.functional ? this.parent : this).$root.$options.shadowRoot
    );
  } : i), u)
    if (l.functional) {
      l._injectStyles = u;
      var c = l.render;
      l.render = function(d, h) {
        return u.call(h), c(d, h);
      };
    } else {
      var f = l.beforeCreate;
      l.beforeCreate = f ? [].concat(f, u) : [u];
    }
  return {
    exports: n,
    options: l
  };
}
const kx = {
  name: "ButtonCommand",
  components: { Icon: rx, ElTooltip: Tx },
  props: {
    icon: {
      type: String,
      required: !0
    },
    title: {
      type: String,
      required: !0
    },
    isActive: {
      type: Boolean,
      default: !1
    }
  }
};
var Mx = function() {
  var e = this, t = e._self._c;
  return t("el-tooltip", { attrs: { effect: "dark", content: e.title, placement: "bottom" } }, [t("button", { staticClass: "button-command", class: { "is-active": e.isActive }, attrs: { type: "button" }, on: { click: function(r) {
    return e.$emit("click");
  } } }, [t("Icon", { staticClass: "text-xl", attrs: { icon: "ri:" + e.icon } })], 1)]);
}, Ax = [], Px = /* @__PURE__ */ le(
  kx,
  Mx,
  Ax,
  !1,
  null,
  null,
  null,
  null
);
const yt = Px.exports;
var My = { exports: {} }, yo = {}, Oh;
function El() {
  if (Oh)
    return yo;
  Oh = 1, yo.__esModule = !0;
  var n = ne;
  return yo.default = {
    mounted: function() {
      if (process.env.NODE_ENV !== "production" && !!this.$vnode) {
        var t = this.getMigratingConfig(), r = t.props, i = r === void 0 ? {} : r, s = t.events, o = s === void 0 ? {} : s, a = this.$vnode, l = a.data, u = a.componentOptions, c = l.attrs || {}, f = u.listeners || {};
        for (var p in c)
          p = (0, n.kebabCase)(p), i[p] && console.warn("[Element Migrating][" + this.$options.name + "][Attribute]: " + i[p]);
        for (var d in f)
          d = (0, n.kebabCase)(d), o[d] && console.warn("[Element Migrating][" + this.$options.name + "][Event]: " + o[d]);
      }
    },
    methods: {
      getMigratingConfig: function() {
        return {
          props: {},
          events: {}
        };
      }
    }
  }, yo;
}
var bo = {}, Eh;
function If() {
  if (Eh)
    return bo;
  Eh = 1, bo.__esModule = !0;
  var n = Nt, e = r(n), t = ji();
  function r(u) {
    return u && u.__esModule ? u : { default: u };
  }
  var i = [], s = "@@clickoutsideContext", o = void 0, a = 0;
  !e.default.prototype.$isServer && (0, t.on)(document, "mousedown", function(u) {
    return o = u;
  }), !e.default.prototype.$isServer && (0, t.on)(document, "mouseup", function(u) {
    i.forEach(function(c) {
      return c[s].documentHandler(u, o);
    });
  });
  function l(u, c, f) {
    return function() {
      var p = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, d = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      !f || !f.context || !p.target || !d.target || u.contains(p.target) || u.contains(d.target) || u === p.target || f.context.popperElm && (f.context.popperElm.contains(p.target) || f.context.popperElm.contains(d.target)) || (c.expression && u[s].methodName && f.context[u[s].methodName] ? f.context[u[s].methodName]() : u[s].bindingFn && u[s].bindingFn());
    };
  }
  return bo.default = {
    bind: function(c, f, p) {
      i.push(c);
      var d = a++;
      c[s] = {
        id: d,
        documentHandler: l(c, f, p),
        methodName: f.expression,
        bindingFn: f.value
      };
    },
    update: function(c, f, p) {
      c[s].documentHandler = l(c, f, p), c[s].methodName = f.expression, c[s].bindingFn = f.value;
    },
    unbind: function(c) {
      for (var f = i.length, p = 0; p < f; p++)
        if (i[p][s].id === c[s].id) {
          i.splice(p, 1);
          break;
        }
      delete c[s];
    }
  }, bo;
}
var Tl = { exports: {} };
(function(n) {
  n.exports = function(e) {
    var t = {};
    function r(i) {
      if (t[i])
        return t[i].exports;
      var s = t[i] = {
        i,
        l: !1,
        exports: {}
      };
      return e[i].call(s.exports, s, s.exports, r), s.l = !0, s.exports;
    }
    return r.m = e, r.c = t, r.d = function(i, s, o) {
      r.o(i, s) || Object.defineProperty(i, s, { enumerable: !0, get: o });
    }, r.r = function(i) {
      typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(i, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(i, "__esModule", { value: !0 });
    }, r.t = function(i, s) {
      if (s & 1 && (i = r(i)), s & 8 || s & 4 && typeof i == "object" && i && i.__esModule)
        return i;
      var o = /* @__PURE__ */ Object.create(null);
      if (r.r(o), Object.defineProperty(o, "default", { enumerable: !0, value: i }), s & 2 && typeof i != "string")
        for (var a in i)
          r.d(o, a, function(l) {
            return i[l];
          }.bind(null, a));
      return o;
    }, r.n = function(i) {
      var s = i && i.__esModule ? function() {
        return i.default;
      } : function() {
        return i;
      };
      return r.d(s, "a", s), s;
    }, r.o = function(i, s) {
      return Object.prototype.hasOwnProperty.call(i, s);
    }, r.p = "/dist/", r(r.s = 96);
  }({
    0: function(e, t, r) {
      r.d(t, "a", function() {
        return i;
      });
      function i(s, o, a, l, u, c, f, p) {
        var d = typeof s == "function" ? s.options : s;
        o && (d.render = o, d.staticRenderFns = a, d._compiled = !0), l && (d.functional = !0), c && (d._scopeId = "data-v-" + c);
        var h;
        if (f ? (h = function(m) {
          m = m || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !m && typeof __VUE_SSR_CONTEXT__ < "u" && (m = __VUE_SSR_CONTEXT__), u && u.call(this, m), m && m._registeredComponents && m._registeredComponents.add(f);
        }, d._ssrRegister = h) : u && (h = p ? function() {
          u.call(this, this.$root.$options.shadowRoot);
        } : u), h)
          if (d.functional) {
            d._injectStyles = h;
            var v = d.render;
            d.render = function(_, y) {
              return h.call(y), v(_, y);
            };
          } else {
            var g = d.beforeCreate;
            d.beforeCreate = g ? [].concat(g, h) : [h];
          }
        return {
          exports: s,
          options: d
        };
      }
    },
    96: function(e, t, r) {
      r.r(t);
      var i = function() {
        var f = this, p = f.$createElement, d = f._self._c || p;
        return d(
          "button",
          {
            staticClass: "el-button",
            class: [
              f.type ? "el-button--" + f.type : "",
              f.buttonSize ? "el-button--" + f.buttonSize : "",
              {
                "is-disabled": f.buttonDisabled,
                "is-loading": f.loading,
                "is-plain": f.plain,
                "is-round": f.round,
                "is-circle": f.circle
              }
            ],
            attrs: {
              disabled: f.buttonDisabled || f.loading,
              autofocus: f.autofocus,
              type: f.nativeType
            },
            on: { click: f.handleClick }
          },
          [
            f.loading ? d("i", { staticClass: "el-icon-loading" }) : f._e(),
            f.icon && !f.loading ? d("i", { class: f.icon }) : f._e(),
            f.$slots.default ? d("span", [f._t("default")], 2) : f._e()
          ]
        );
      }, s = [];
      i._withStripped = !0;
      var o = {
        name: "ElButton",
        inject: {
          elForm: {
            default: ""
          },
          elFormItem: {
            default: ""
          }
        },
        props: {
          type: {
            type: String,
            default: "default"
          },
          size: String,
          icon: {
            type: String,
            default: ""
          },
          nativeType: {
            type: String,
            default: "button"
          },
          loading: Boolean,
          disabled: Boolean,
          plain: Boolean,
          autofocus: Boolean,
          round: Boolean,
          circle: Boolean
        },
        computed: {
          _elFormItemSize: function() {
            return (this.elFormItem || {}).elFormItemSize;
          },
          buttonSize: function() {
            return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
          },
          buttonDisabled: function() {
            return this.$options.propsData.hasOwnProperty("disabled") ? this.disabled : (this.elForm || {}).disabled;
          }
        },
        methods: {
          handleClick: function(p) {
            this.$emit("click", p);
          }
        }
      }, a = o, l = r(0), u = Object(l.a)(
        a,
        i,
        s,
        !1,
        null,
        null,
        null
      );
      u.options.__file = "packages/button/src/button.vue";
      var c = u.exports;
      c.install = function(f) {
        f.component(c.name, c);
      }, t.default = c;
    }
  });
})(Tl);
const Rf = /* @__PURE__ */ ot(Tl.exports);
var Gu = { exports: {} }, Th;
function $x() {
  return Th || (Th = 1, function(n) {
    n.exports = function(e) {
      var t = {};
      function r(i) {
        if (t[i])
          return t[i].exports;
        var s = t[i] = {
          i,
          l: !1,
          exports: {}
        };
        return e[i].call(s.exports, s, s.exports, r), s.l = !0, s.exports;
      }
      return r.m = e, r.c = t, r.d = function(i, s, o) {
        r.o(i, s) || Object.defineProperty(i, s, { enumerable: !0, get: o });
      }, r.r = function(i) {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(i, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(i, "__esModule", { value: !0 });
      }, r.t = function(i, s) {
        if (s & 1 && (i = r(i)), s & 8 || s & 4 && typeof i == "object" && i && i.__esModule)
          return i;
        var o = /* @__PURE__ */ Object.create(null);
        if (r.r(o), Object.defineProperty(o, "default", { enumerable: !0, value: i }), s & 2 && typeof i != "string")
          for (var a in i)
            r.d(o, a, function(l) {
              return i[l];
            }.bind(null, a));
        return o;
      }, r.n = function(i) {
        var s = i && i.__esModule ? function() {
          return i.default;
        } : function() {
          return i;
        };
        return r.d(s, "a", s), s;
      }, r.o = function(i, s) {
        return Object.prototype.hasOwnProperty.call(i, s);
      }, r.p = "/dist/", r(r.s = 97);
    }({
      0: function(e, t, r) {
        r.d(t, "a", function() {
          return i;
        });
        function i(s, o, a, l, u, c, f, p) {
          var d = typeof s == "function" ? s.options : s;
          o && (d.render = o, d.staticRenderFns = a, d._compiled = !0), l && (d.functional = !0), c && (d._scopeId = "data-v-" + c);
          var h;
          if (f ? (h = function(m) {
            m = m || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !m && typeof __VUE_SSR_CONTEXT__ < "u" && (m = __VUE_SSR_CONTEXT__), u && u.call(this, m), m && m._registeredComponents && m._registeredComponents.add(f);
          }, d._ssrRegister = h) : u && (h = p ? function() {
            u.call(this, this.$root.$options.shadowRoot);
          } : u), h)
            if (d.functional) {
              d._injectStyles = h;
              var v = d.render;
              d.render = function(_, y) {
                return h.call(y), v(_, y);
              };
            } else {
              var g = d.beforeCreate;
              d.beforeCreate = g ? [].concat(g, h) : [h];
            }
          return {
            exports: s,
            options: d
          };
        }
      },
      97: function(e, t, r) {
        r.r(t);
        var i = function() {
          var f = this, p = f.$createElement, d = f._self._c || p;
          return d("div", { staticClass: "el-button-group" }, [f._t("default")], 2);
        }, s = [];
        i._withStripped = !0;
        var o = {
          name: "ElButtonGroup"
        }, a = o, l = r(0), u = Object(l.a)(
          a,
          i,
          s,
          !1,
          null,
          null,
          null
        );
        u.options.__file = "packages/button/src/button-group.vue";
        var c = u.exports;
        c.install = function(f) {
          f.component(c.name, c);
        }, t.default = c;
      }
    });
  }(Gu)), Gu.exports;
}
var wo = {}, kh;
function an() {
  if (kh)
    return wo;
  kh = 1, wo.__esModule = !0;
  function n(e, t, r) {
    this.$children.forEach(function(i) {
      var s = i.$options.componentName;
      s === e ? i.$emit.apply(i, [t].concat(r)) : n.apply(i, [e, t].concat([r]));
    });
  }
  return wo.default = {
    methods: {
      dispatch: function(t, r, i) {
        for (var s = this.$parent || this.$root, o = s.$options.componentName; s && (!o || o !== t); )
          s = s.$parent, s && (o = s.$options.componentName);
        s && s.$emit.apply(s, [r].concat(i));
      },
      broadcast: function(t, r, i) {
        n.call(this, t, r, i);
      }
    }
  }, wo;
}
(function(n) {
  n.exports = function(e) {
    var t = {};
    function r(i) {
      if (t[i])
        return t[i].exports;
      var s = t[i] = {
        i,
        l: !1,
        exports: {}
      };
      return e[i].call(s.exports, s, s.exports, r), s.l = !0, s.exports;
    }
    return r.m = e, r.c = t, r.d = function(i, s, o) {
      r.o(i, s) || Object.defineProperty(i, s, { enumerable: !0, get: o });
    }, r.r = function(i) {
      typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(i, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(i, "__esModule", { value: !0 });
    }, r.t = function(i, s) {
      if (s & 1 && (i = r(i)), s & 8 || s & 4 && typeof i == "object" && i && i.__esModule)
        return i;
      var o = /* @__PURE__ */ Object.create(null);
      if (r.r(o), Object.defineProperty(o, "default", { enumerable: !0, value: i }), s & 2 && typeof i != "string")
        for (var a in i)
          r.d(o, a, function(l) {
            return i[l];
          }.bind(null, a));
      return o;
    }, r.n = function(i) {
      var s = i && i.__esModule ? function() {
        return i.default;
      } : function() {
        return i;
      };
      return r.d(s, "a", s), s;
    }, r.o = function(i, s) {
      return Object.prototype.hasOwnProperty.call(i, s);
    }, r.p = "/dist/", r(r.s = 130);
  }({
    0: function(e, t, r) {
      r.d(t, "a", function() {
        return i;
      });
      function i(s, o, a, l, u, c, f, p) {
        var d = typeof s == "function" ? s.options : s;
        o && (d.render = o, d.staticRenderFns = a, d._compiled = !0), l && (d.functional = !0), c && (d._scopeId = "data-v-" + c);
        var h;
        if (f ? (h = function(m) {
          m = m || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !m && typeof __VUE_SSR_CONTEXT__ < "u" && (m = __VUE_SSR_CONTEXT__), u && u.call(this, m), m && m._registeredComponents && m._registeredComponents.add(f);
        }, d._ssrRegister = h) : u && (h = p ? function() {
          u.call(this, this.$root.$options.shadowRoot);
        } : u), h)
          if (d.functional) {
            d._injectStyles = h;
            var v = d.render;
            d.render = function(_, y) {
              return h.call(y), v(_, y);
            };
          } else {
            var g = d.beforeCreate;
            d.beforeCreate = g ? [].concat(g, h) : [h];
          }
        return {
          exports: s,
          options: d
        };
      }
    },
    11: function(e, t) {
      e.exports = El();
    },
    12: function(e, t) {
      e.exports = If();
    },
    130: function(e, t, r) {
      r.r(t);
      var i = r(12), s = /* @__PURE__ */ r.n(i), o = r(4), a = /* @__PURE__ */ r.n(o), l = r(11), u = /* @__PURE__ */ r.n(l), c = r(14), f = /* @__PURE__ */ r.n(c), p = r(36), d = /* @__PURE__ */ r.n(p), h = r(3), v = {
        name: "ElDropdown",
        componentName: "ElDropdown",
        mixins: [a.a, u.a],
        directives: { Clickoutside: s.a },
        components: {
          ElButton: f.a,
          ElButtonGroup: d.a
        },
        provide: function() {
          return {
            dropdown: this
          };
        },
        props: {
          trigger: {
            type: String,
            default: "hover"
          },
          type: String,
          size: {
            type: String,
            default: ""
          },
          splitButton: Boolean,
          hideOnClick: {
            type: Boolean,
            default: !0
          },
          placement: {
            type: String,
            default: "bottom-end"
          },
          visibleArrow: {
            default: !0
          },
          showTimeout: {
            type: Number,
            default: 250
          },
          hideTimeout: {
            type: Number,
            default: 150
          },
          tabindex: {
            type: Number,
            default: 0
          },
          disabled: {
            type: Boolean,
            default: !1
          }
        },
        data: function() {
          return {
            timeout: null,
            visible: !1,
            triggerElm: null,
            menuItems: null,
            menuItemsArray: null,
            dropdownElm: null,
            focusing: !1,
            listId: "dropdown-menu-" + Object(h.generateId)()
          };
        },
        computed: {
          dropdownSize: function() {
            return this.size || (this.$ELEMENT || {}).size;
          }
        },
        mounted: function() {
          this.$on("menu-item-click", this.handleMenuItemClick);
        },
        watch: {
          visible: function(S) {
            this.broadcast("ElDropdownMenu", "visible", S), this.$emit("visible-change", S);
          },
          focusing: function(S) {
            var b = this.$el.querySelector(".el-dropdown-selfdefine");
            b && (S ? b.className += " focusing" : b.className = b.className.replace("focusing", ""));
          }
        },
        methods: {
          getMigratingConfig: function() {
            return {
              props: {
                "menu-align": "menu-align is renamed to placement."
              }
            };
          },
          show: function() {
            var S = this;
            this.disabled || (clearTimeout(this.timeout), this.timeout = setTimeout(function() {
              S.visible = !0;
            }, this.trigger === "click" ? 0 : this.showTimeout));
          },
          hide: function() {
            var S = this;
            this.disabled || (this.removeTabindex(), this.tabindex >= 0 && this.resetTabindex(this.triggerElm), clearTimeout(this.timeout), this.timeout = setTimeout(function() {
              S.visible = !1;
            }, this.trigger === "click" ? 0 : this.hideTimeout));
          },
          handleClick: function() {
            this.disabled || (this.visible ? this.hide() : this.show());
          },
          handleTriggerKeyDown: function(S) {
            var b = S.keyCode;
            [38, 40].indexOf(b) > -1 ? (this.removeTabindex(), this.resetTabindex(this.menuItems[0]), this.menuItems[0].focus(), S.preventDefault(), S.stopPropagation()) : b === 13 ? this.handleClick() : [9, 27].indexOf(b) > -1 && this.hide();
          },
          handleItemKeyDown: function(S) {
            var b = S.keyCode, x = S.target, E = this.menuItemsArray.indexOf(x), M = this.menuItemsArray.length - 1, $ = void 0;
            [38, 40].indexOf(b) > -1 ? (b === 38 ? $ = E !== 0 ? E - 1 : 0 : $ = E < M ? E + 1 : M, this.removeTabindex(), this.resetTabindex(this.menuItems[$]), this.menuItems[$].focus(), S.preventDefault(), S.stopPropagation()) : b === 13 ? (this.triggerElmFocus(), x.click(), this.hideOnClick && (this.visible = !1)) : [9, 27].indexOf(b) > -1 && (this.hide(), this.triggerElmFocus());
          },
          resetTabindex: function(S) {
            this.removeTabindex(), S.setAttribute("tabindex", "0");
          },
          removeTabindex: function() {
            this.triggerElm.setAttribute("tabindex", "-1"), this.menuItemsArray.forEach(function(S) {
              S.setAttribute("tabindex", "-1");
            });
          },
          initAria: function() {
            this.dropdownElm.setAttribute("id", this.listId), this.triggerElm.setAttribute("aria-haspopup", "list"), this.triggerElm.setAttribute("aria-controls", this.listId), this.splitButton || (this.triggerElm.setAttribute("role", "button"), this.triggerElm.setAttribute("tabindex", this.tabindex), this.triggerElm.setAttribute("class", (this.triggerElm.getAttribute("class") || "") + " el-dropdown-selfdefine"));
          },
          initEvent: function() {
            var S = this, b = this.trigger, x = this.show, E = this.hide, M = this.handleClick, $ = this.splitButton, F = this.handleTriggerKeyDown, J = this.handleItemKeyDown;
            this.triggerElm = $ ? this.$refs.trigger.$el : this.$slots.default[0].elm;
            var W = this.dropdownElm;
            this.triggerElm.addEventListener("keydown", F), W.addEventListener("keydown", J, !0), $ || (this.triggerElm.addEventListener("focus", function() {
              S.focusing = !0;
            }), this.triggerElm.addEventListener("blur", function() {
              S.focusing = !1;
            }), this.triggerElm.addEventListener("click", function() {
              S.focusing = !1;
            })), b === "hover" ? (this.triggerElm.addEventListener("mouseenter", x), this.triggerElm.addEventListener("mouseleave", E), W.addEventListener("mouseenter", x), W.addEventListener("mouseleave", E)) : b === "click" && this.triggerElm.addEventListener("click", M);
          },
          handleMenuItemClick: function(S, b) {
            this.hideOnClick && (this.visible = !1), this.$emit("command", S, b);
          },
          triggerElmFocus: function() {
            this.triggerElm.focus && this.triggerElm.focus();
          },
          initDomOperation: function() {
            this.dropdownElm = this.popperElm, this.menuItems = this.dropdownElm.querySelectorAll("[tabindex='-1']"), this.menuItemsArray = [].slice.call(this.menuItems), this.initEvent(), this.initAria();
          }
        },
        render: function(S) {
          var b = this, x = this.hide, E = this.splitButton, M = this.type, $ = this.dropdownSize, F = this.disabled, J = function(fe) {
            b.$emit("click", fe), x();
          }, W = null;
          if (E)
            W = S("el-button-group", [S(
              "el-button",
              {
                attrs: { type: M, size: $, disabled: F },
                nativeOn: {
                  click: J
                }
              },
              [this.$slots.default]
            ), S(
              "el-button",
              {
                ref: "trigger",
                attrs: { type: M, size: $, disabled: F },
                class: "el-dropdown__caret-button"
              },
              [S("i", { class: "el-dropdown__icon el-icon-arrow-down" })]
            )]);
          else {
            W = this.$slots.default;
            var H = W[0].data || {}, Y = H.attrs, z = Y === void 0 ? {} : Y;
            F && !z.disabled && (z.disabled = !0, H.attrs = z);
          }
          var j = F ? null : this.$slots.dropdown;
          return S(
            "div",
            {
              class: "el-dropdown",
              directives: [{
                name: "clickoutside",
                value: x
              }],
              attrs: { "aria-disabled": F }
            },
            [W, j]
          );
        }
      }, g = v, m = r(0), _, y, w = Object(m.a)(
        g,
        _,
        y,
        !1,
        null,
        null,
        null
      );
      w.options.__file = "packages/dropdown/src/dropdown.vue";
      var O = w.exports;
      O.install = function(C) {
        C.component(O.name, O);
      }, t.default = O;
    },
    14: function(e, t) {
      e.exports = Tl.exports;
    },
    3: function(e, t) {
      e.exports = ne;
    },
    36: function(e, t) {
      e.exports = $x();
    },
    4: function(e, t) {
      e.exports = an();
    }
  });
})(My);
const Ff = /* @__PURE__ */ ot(My.exports);
var Ay = { exports: {} };
(function(n) {
  n.exports = function(e) {
    var t = {};
    function r(i) {
      if (t[i])
        return t[i].exports;
      var s = t[i] = {
        i,
        l: !1,
        exports: {}
      };
      return e[i].call(s.exports, s, s.exports, r), s.l = !0, s.exports;
    }
    return r.m = e, r.c = t, r.d = function(i, s, o) {
      r.o(i, s) || Object.defineProperty(i, s, { enumerable: !0, get: o });
    }, r.r = function(i) {
      typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(i, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(i, "__esModule", { value: !0 });
    }, r.t = function(i, s) {
      if (s & 1 && (i = r(i)), s & 8 || s & 4 && typeof i == "object" && i && i.__esModule)
        return i;
      var o = /* @__PURE__ */ Object.create(null);
      if (r.r(o), Object.defineProperty(o, "default", { enumerable: !0, value: i }), s & 2 && typeof i != "string")
        for (var a in i)
          r.d(o, a, function(l) {
            return i[l];
          }.bind(null, a));
      return o;
    }, r.n = function(i) {
      var s = i && i.__esModule ? function() {
        return i.default;
      } : function() {
        return i;
      };
      return r.d(s, "a", s), s;
    }, r.o = function(i, s) {
      return Object.prototype.hasOwnProperty.call(i, s);
    }, r.p = "/dist/", r(r.s = 83);
  }({
    0: function(e, t, r) {
      r.d(t, "a", function() {
        return i;
      });
      function i(s, o, a, l, u, c, f, p) {
        var d = typeof s == "function" ? s.options : s;
        o && (d.render = o, d.staticRenderFns = a, d._compiled = !0), l && (d.functional = !0), c && (d._scopeId = "data-v-" + c);
        var h;
        if (f ? (h = function(m) {
          m = m || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !m && typeof __VUE_SSR_CONTEXT__ < "u" && (m = __VUE_SSR_CONTEXT__), u && u.call(this, m), m && m._registeredComponents && m._registeredComponents.add(f);
        }, d._ssrRegister = h) : u && (h = p ? function() {
          u.call(this, this.$root.$options.shadowRoot);
        } : u), h)
          if (d.functional) {
            d._injectStyles = h;
            var v = d.render;
            d.render = function(_, y) {
              return h.call(y), v(_, y);
            };
          } else {
            var g = d.beforeCreate;
            d.beforeCreate = g ? [].concat(g, h) : [h];
          }
        return {
          exports: s,
          options: d
        };
      }
    },
    5: function(e, t) {
      e.exports = Ol();
    },
    83: function(e, t, r) {
      r.r(t);
      var i = function() {
        var d = this, h = d.$createElement, v = d._self._c || h;
        return v(
          "transition",
          { attrs: { name: "el-zoom-in-top" }, on: { "after-leave": d.doDestroy } },
          [
            v(
              "ul",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: d.showPopper,
                    expression: "showPopper"
                  }
                ],
                staticClass: "el-dropdown-menu el-popper",
                class: [d.size && "el-dropdown-menu--" + d.size]
              },
              [d._t("default")],
              2
            )
          ]
        );
      }, s = [];
      i._withStripped = !0;
      var o = r(5), a = /* @__PURE__ */ r.n(o), l = {
        name: "ElDropdownMenu",
        componentName: "ElDropdownMenu",
        mixins: [a.a],
        props: {
          visibleArrow: {
            type: Boolean,
            default: !0
          },
          arrowOffset: {
            type: Number,
            default: 0
          }
        },
        data: function() {
          return {
            size: this.dropdown.dropdownSize
          };
        },
        inject: ["dropdown"],
        created: function() {
          var h = this;
          this.$on("updatePopper", function() {
            h.showPopper && h.updatePopper();
          }), this.$on("visible", function(v) {
            h.showPopper = v;
          });
        },
        mounted: function() {
          this.dropdown.popperElm = this.popperElm = this.$el, this.referenceElm = this.dropdown.$el, this.dropdown.initDomOperation();
        },
        watch: {
          "dropdown.placement": {
            immediate: !0,
            handler: function(h) {
              this.currentPlacement = h;
            }
          }
        }
      }, u = l, c = r(0), f = Object(c.a)(
        u,
        i,
        s,
        !1,
        null,
        null,
        null
      );
      f.options.__file = "packages/dropdown/src/dropdown-menu.vue";
      var p = f.exports;
      p.install = function(d) {
        d.component(p.name, p);
      }, t.default = p;
    }
  });
})(Ay);
const zf = /* @__PURE__ */ ot(Ay.exports);
var Py = { exports: {} };
(function(n) {
  n.exports = function(e) {
    var t = {};
    function r(i) {
      if (t[i])
        return t[i].exports;
      var s = t[i] = {
        i,
        l: !1,
        exports: {}
      };
      return e[i].call(s.exports, s, s.exports, r), s.l = !0, s.exports;
    }
    return r.m = e, r.c = t, r.d = function(i, s, o) {
      r.o(i, s) || Object.defineProperty(i, s, { enumerable: !0, get: o });
    }, r.r = function(i) {
      typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(i, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(i, "__esModule", { value: !0 });
    }, r.t = function(i, s) {
      if (s & 1 && (i = r(i)), s & 8 || s & 4 && typeof i == "object" && i && i.__esModule)
        return i;
      var o = /* @__PURE__ */ Object.create(null);
      if (r.r(o), Object.defineProperty(o, "default", { enumerable: !0, value: i }), s & 2 && typeof i != "string")
        for (var a in i)
          r.d(o, a, function(l) {
            return i[l];
          }.bind(null, a));
      return o;
    }, r.n = function(i) {
      var s = i && i.__esModule ? function() {
        return i.default;
      } : function() {
        return i;
      };
      return r.d(s, "a", s), s;
    }, r.o = function(i, s) {
      return Object.prototype.hasOwnProperty.call(i, s);
    }, r.p = "/dist/", r(r.s = 84);
  }({
    0: function(e, t, r) {
      r.d(t, "a", function() {
        return i;
      });
      function i(s, o, a, l, u, c, f, p) {
        var d = typeof s == "function" ? s.options : s;
        o && (d.render = o, d.staticRenderFns = a, d._compiled = !0), l && (d.functional = !0), c && (d._scopeId = "data-v-" + c);
        var h;
        if (f ? (h = function(m) {
          m = m || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !m && typeof __VUE_SSR_CONTEXT__ < "u" && (m = __VUE_SSR_CONTEXT__), u && u.call(this, m), m && m._registeredComponents && m._registeredComponents.add(f);
        }, d._ssrRegister = h) : u && (h = p ? function() {
          u.call(this, this.$root.$options.shadowRoot);
        } : u), h)
          if (d.functional) {
            d._injectStyles = h;
            var v = d.render;
            d.render = function(_, y) {
              return h.call(y), v(_, y);
            };
          } else {
            var g = d.beforeCreate;
            d.beforeCreate = g ? [].concat(g, h) : [h];
          }
        return {
          exports: s,
          options: d
        };
      }
    },
    4: function(e, t) {
      e.exports = an();
    },
    84: function(e, t, r) {
      r.r(t);
      var i = function() {
        var d = this, h = d.$createElement, v = d._self._c || h;
        return v(
          "li",
          {
            staticClass: "el-dropdown-menu__item",
            class: {
              "is-disabled": d.disabled,
              "el-dropdown-menu__item--divided": d.divided
            },
            attrs: {
              "aria-disabled": d.disabled,
              tabindex: d.disabled ? null : -1
            },
            on: { click: d.handleClick }
          },
          [d.icon ? v("i", { class: d.icon }) : d._e(), d._t("default")],
          2
        );
      }, s = [];
      i._withStripped = !0;
      var o = r(4), a = /* @__PURE__ */ r.n(o), l = {
        name: "ElDropdownItem",
        mixins: [a.a],
        props: {
          command: {},
          disabled: Boolean,
          divided: Boolean,
          icon: String
        },
        methods: {
          handleClick: function(h) {
            this.dispatch("ElDropdown", "menu-item-click", [this.command, this]);
          }
        }
      }, u = l, c = r(0), f = Object(c.a)(
        u,
        i,
        s,
        !1,
        null,
        null,
        null
      );
      f.options.__file = "packages/dropdown/src/dropdown-item.vue";
      var p = f.exports;
      p.install = function(d) {
        d.component(p.name, p);
      }, t.default = p;
    }
  });
})(Py);
const Bf = /* @__PURE__ */ ot(Py.exports), Dx = {
  menuBubble: !0,
  menuBar: !0,
  editable: !0,
  baseURL: "",
  imageBaseURL: "",
  imageUploadURL: "",
  imageUploadFolder: "",
  rootFontSize: 20,
  sites: "THINKPRO, NICESPACE, EPICZONE"
}, Lx = ["8", "10", "12", "14", "16", "18", "20", "24", "30", "36", "48", "60", "72"], Ku = "default", Nx = ["fill", "contain", "cover", "none", "scale-down"], Od = "fill", Ix = ["inline", "block", "left", "right"], Rx = {
  inline: "Inline",
  block: "Block",
  left: "Float left",
  right: "Float right"
}, kl = [
  "Bold",
  "Italic",
  "Strike",
  "Underline",
  "Color",
  "Heading 1",
  "Heading 2",
  "Heading 3",
  "Paragraph",
  "Font Size",
  "Text Left",
  "Text Center",
  "Text Right",
  "Text Justify",
  "Bullet List",
  "Ordered List",
  "Image",
  "Image Album",
  "Image Comparison",
  "Video",
  "Link",
  "Rich Link",
  "Collapse",
  "SKU",
  "Blockquote",
  "Horizontal Rule",
  "Code Block",
  "Code",
  "Hard Break",
  "Clear Format",
  "Undo",
  "Redo",
  "Highlight"
];
const Fx = st({
  name: "FontSizeCommand",
  components: { ButtonCommand: yt, ElDropdown: Ff, ElDropdownMenu: zf, ElDropdownItem: Bf },
  setup() {
    const n = $e("editor"), e = [Ku, ...Lx];
    return { editor: n, fontSizeItems: e, handleSetFontSize: (i) => i === Ku ? n == null ? void 0 : n.value.chain().focus().unsetFontSize().run() : n == null ? void 0 : n.value.chain().focus().setFontSize(i + "px").run(), getIsActive: (i) => i === Ku ? !1 : n == null ? void 0 : n.value.isActive("textStyle", { fontSize: i + "px" }) };
  }
});
var zx = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("el-dropdown", { attrs: { trigger: "click" }, on: { command: e.handleSetFontSize } }, [t("button-command", { attrs: { icon: "font-size", title: "Font Size" } }), t("el-dropdown-menu", { attrs: { slot: "dropdown" }, slot: "dropdown" }, e._l(e.fontSizeItems, function(r) {
    return t("el-dropdown-item", { key: r, class: { "is-active": e.getIsActive(r) }, attrs: { command: r } }, [e._v(" " + e._s(r) + " ")]);
  }), 1)], 1);
}, Bx = [], jx = /* @__PURE__ */ le(
  Fx,
  zx,
  Bx,
  !1,
  null,
  "4d6b194f",
  null,
  null
);
const $y = jx.exports, Vx = Ce({
  props: {
    accept: { type: String, default: void 0 },
    multiple: { type: Boolean, default: !1 }
  },
  setup(n, { emit: e }) {
    const t = Le();
    return { input: t, selectFile: (i) => {
      const s = i.target;
      !s.files || (e("input", Array.prototype.slice.call(s.files)), t.value && (t.value.value = "", t.value.files = null));
    } };
  }
});
var Hx = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("label", { staticClass: "t-upload", attrs: { for: "t-upload-input" } }, [e._t("default", null, null, { on: { click: () => e.$refs.input.click() } }), t("input", e._b({ directives: [{ name: "show", rawName: "v-show", value: !1, expression: "false" }], ref: "input", attrs: { id: "t-upload__input", accept: e.accept, multiple: e.multiple, type: "file" }, on: { input: e.selectFile } }, "input", e.$attrs, !1))], 2);
}, Wx = [], qx = /* @__PURE__ */ le(
  Vx,
  Hx,
  Wx,
  !1,
  null,
  null,
  null,
  null
);
const jf = qx.exports;
var Dy = { exports: {} }, Vf = { exports: {} }, Ly = function(e, t) {
  return function() {
    for (var i = new Array(arguments.length), s = 0; s < i.length; s++)
      i[s] = arguments[s];
    return e.apply(t, i);
  };
}, Ux = Ly, Gr = Object.prototype.toString;
function Hf(n) {
  return Gr.call(n) === "[object Array]";
}
function Ed(n) {
  return typeof n > "u";
}
function Gx(n) {
  return n !== null && !Ed(n) && n.constructor !== null && !Ed(n.constructor) && typeof n.constructor.isBuffer == "function" && n.constructor.isBuffer(n);
}
function Kx(n) {
  return Gr.call(n) === "[object ArrayBuffer]";
}
function Jx(n) {
  return typeof FormData < "u" && n instanceof FormData;
}
function Xx(n) {
  var e;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? e = ArrayBuffer.isView(n) : e = n && n.buffer && n.buffer instanceof ArrayBuffer, e;
}
function Yx(n) {
  return typeof n == "string";
}
function Qx(n) {
  return typeof n == "number";
}
function Ny(n) {
  return n !== null && typeof n == "object";
}
function Xo(n) {
  if (Gr.call(n) !== "[object Object]")
    return !1;
  var e = Object.getPrototypeOf(n);
  return e === null || e === Object.prototype;
}
function Zx(n) {
  return Gr.call(n) === "[object Date]";
}
function e1(n) {
  return Gr.call(n) === "[object File]";
}
function t1(n) {
  return Gr.call(n) === "[object Blob]";
}
function Iy(n) {
  return Gr.call(n) === "[object Function]";
}
function n1(n) {
  return Ny(n) && Iy(n.pipe);
}
function r1(n) {
  return typeof URLSearchParams < "u" && n instanceof URLSearchParams;
}
function i1(n) {
  return n.trim ? n.trim() : n.replace(/^\s+|\s+$/g, "");
}
function s1() {
  return typeof navigator < "u" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS") ? !1 : typeof window < "u" && typeof document < "u";
}
function Wf(n, e) {
  if (!(n === null || typeof n > "u"))
    if (typeof n != "object" && (n = [n]), Hf(n))
      for (var t = 0, r = n.length; t < r; t++)
        e.call(null, n[t], t, n);
    else
      for (var i in n)
        Object.prototype.hasOwnProperty.call(n, i) && e.call(null, n[i], i, n);
}
function Td() {
  var n = {};
  function e(i, s) {
    Xo(n[s]) && Xo(i) ? n[s] = Td(n[s], i) : Xo(i) ? n[s] = Td({}, i) : Hf(i) ? n[s] = i.slice() : n[s] = i;
  }
  for (var t = 0, r = arguments.length; t < r; t++)
    Wf(arguments[t], e);
  return n;
}
function o1(n, e, t) {
  return Wf(e, function(i, s) {
    t && typeof i == "function" ? n[s] = Ux(i, t) : n[s] = i;
  }), n;
}
function a1(n) {
  return n.charCodeAt(0) === 65279 && (n = n.slice(1)), n;
}
var It = {
  isArray: Hf,
  isArrayBuffer: Kx,
  isBuffer: Gx,
  isFormData: Jx,
  isArrayBufferView: Xx,
  isString: Yx,
  isNumber: Qx,
  isObject: Ny,
  isPlainObject: Xo,
  isUndefined: Ed,
  isDate: Zx,
  isFile: e1,
  isBlob: t1,
  isFunction: Iy,
  isStream: n1,
  isURLSearchParams: r1,
  isStandardBrowserEnv: s1,
  forEach: Wf,
  merge: Td,
  extend: o1,
  trim: i1,
  stripBOM: a1
}, ni = It;
function Mh(n) {
  return encodeURIComponent(n).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var Ry = function(e, t, r) {
  if (!t)
    return e;
  var i;
  if (r)
    i = r(t);
  else if (ni.isURLSearchParams(t))
    i = t.toString();
  else {
    var s = [];
    ni.forEach(t, function(l, u) {
      l === null || typeof l > "u" || (ni.isArray(l) ? u = u + "[]" : l = [l], ni.forEach(l, function(f) {
        ni.isDate(f) ? f = f.toISOString() : ni.isObject(f) && (f = JSON.stringify(f)), s.push(Mh(u) + "=" + Mh(f));
      }));
    }), i = s.join("&");
  }
  if (i) {
    var o = e.indexOf("#");
    o !== -1 && (e = e.slice(0, o)), e += (e.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return e;
}, l1 = It;
function Ml() {
  this.handlers = [];
}
Ml.prototype.use = function(e, t, r) {
  return this.handlers.push({
    fulfilled: e,
    rejected: t,
    synchronous: r ? r.synchronous : !1,
    runWhen: r ? r.runWhen : null
  }), this.handlers.length - 1;
};
Ml.prototype.eject = function(e) {
  this.handlers[e] && (this.handlers[e] = null);
};
Ml.prototype.forEach = function(e) {
  l1.forEach(this.handlers, function(r) {
    r !== null && e(r);
  });
};
var u1 = Ml, c1 = It, d1 = function(e, t) {
  c1.forEach(e, function(i, s) {
    s !== t && s.toUpperCase() === t.toUpperCase() && (e[t] = i, delete e[s]);
  });
}, Fy = function(e, t, r, i, s) {
  return e.config = t, r && (e.code = r), e.request = i, e.response = s, e.isAxiosError = !0, e.toJSON = function() {
    return {
      message: this.message,
      name: this.name,
      description: this.description,
      number: this.number,
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      config: this.config,
      code: this.code
    };
  }, e;
}, Ju, Ah;
function zy() {
  if (Ah)
    return Ju;
  Ah = 1;
  var n = Fy;
  return Ju = function(t, r, i, s, o) {
    var a = new Error(t);
    return n(a, r, i, s, o);
  }, Ju;
}
var Xu, Ph;
function f1() {
  if (Ph)
    return Xu;
  Ph = 1;
  var n = zy();
  return Xu = function(t, r, i) {
    var s = i.config.validateStatus;
    !i.status || !s || s(i.status) ? t(i) : r(n(
      "Request failed with status code " + i.status,
      i.config,
      null,
      i.request,
      i
    ));
  }, Xu;
}
var Yu, $h;
function p1() {
  if ($h)
    return Yu;
  $h = 1;
  var n = It;
  return Yu = n.isStandardBrowserEnv() ? function() {
    return {
      write: function(r, i, s, o, a, l) {
        var u = [];
        u.push(r + "=" + encodeURIComponent(i)), n.isNumber(s) && u.push("expires=" + new Date(s).toGMTString()), n.isString(o) && u.push("path=" + o), n.isString(a) && u.push("domain=" + a), l === !0 && u.push("secure"), document.cookie = u.join("; ");
      },
      read: function(r) {
        var i = document.cookie.match(new RegExp("(^|;\\s*)(" + r + ")=([^;]*)"));
        return i ? decodeURIComponent(i[3]) : null;
      },
      remove: function(r) {
        this.write(r, "", Date.now() - 864e5);
      }
    };
  }() : function() {
    return {
      write: function() {
      },
      read: function() {
        return null;
      },
      remove: function() {
      }
    };
  }(), Yu;
}
var Qu, Dh;
function h1() {
  return Dh || (Dh = 1, Qu = function(e) {
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(e);
  }), Qu;
}
var Zu, Lh;
function m1() {
  return Lh || (Lh = 1, Zu = function(e, t) {
    return t ? e.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "") : e;
  }), Zu;
}
var ec, Nh;
function g1() {
  if (Nh)
    return ec;
  Nh = 1;
  var n = h1(), e = m1();
  return ec = function(r, i) {
    return r && !n(i) ? e(r, i) : i;
  }, ec;
}
var tc, Ih;
function v1() {
  if (Ih)
    return tc;
  Ih = 1;
  var n = It, e = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
  ];
  return tc = function(r) {
    var i = {}, s, o, a;
    return r && n.forEach(r.split(`
`), function(u) {
      if (a = u.indexOf(":"), s = n.trim(u.substr(0, a)).toLowerCase(), o = n.trim(u.substr(a + 1)), s) {
        if (i[s] && e.indexOf(s) >= 0)
          return;
        s === "set-cookie" ? i[s] = (i[s] ? i[s] : []).concat([o]) : i[s] = i[s] ? i[s] + ", " + o : o;
      }
    }), i;
  }, tc;
}
var nc, Rh;
function y1() {
  if (Rh)
    return nc;
  Rh = 1;
  var n = It;
  return nc = n.isStandardBrowserEnv() ? function() {
    var t = /(msie|trident)/i.test(navigator.userAgent), r = document.createElement("a"), i;
    function s(o) {
      var a = o;
      return t && (r.setAttribute("href", a), a = r.href), r.setAttribute("href", a), {
        href: r.href,
        protocol: r.protocol ? r.protocol.replace(/:$/, "") : "",
        host: r.host,
        search: r.search ? r.search.replace(/^\?/, "") : "",
        hash: r.hash ? r.hash.replace(/^#/, "") : "",
        hostname: r.hostname,
        port: r.port,
        pathname: r.pathname.charAt(0) === "/" ? r.pathname : "/" + r.pathname
      };
    }
    return i = s(window.location.href), function(a) {
      var l = n.isString(a) ? s(a) : a;
      return l.protocol === i.protocol && l.host === i.host;
    };
  }() : function() {
    return function() {
      return !0;
    };
  }(), nc;
}
var rc, Fh;
function zh() {
  if (Fh)
    return rc;
  Fh = 1;
  var n = It, e = f1(), t = p1(), r = Ry, i = g1(), s = v1(), o = y1(), a = zy();
  return rc = function(u) {
    return new Promise(function(f, p) {
      var d = u.data, h = u.headers, v = u.responseType;
      n.isFormData(d) && delete h["Content-Type"];
      var g = new XMLHttpRequest();
      if (u.auth) {
        var m = u.auth.username || "", _ = u.auth.password ? unescape(encodeURIComponent(u.auth.password)) : "";
        h.Authorization = "Basic " + btoa(m + ":" + _);
      }
      var y = i(u.baseURL, u.url);
      g.open(u.method.toUpperCase(), r(y, u.params, u.paramsSerializer), !0), g.timeout = u.timeout;
      function w() {
        if (!!g) {
          var C = "getAllResponseHeaders" in g ? s(g.getAllResponseHeaders()) : null, S = !v || v === "text" || v === "json" ? g.responseText : g.response, b = {
            data: S,
            status: g.status,
            statusText: g.statusText,
            headers: C,
            config: u,
            request: g
          };
          e(f, p, b), g = null;
        }
      }
      if ("onloadend" in g ? g.onloadend = w : g.onreadystatechange = function() {
        !g || g.readyState !== 4 || g.status === 0 && !(g.responseURL && g.responseURL.indexOf("file:") === 0) || setTimeout(w);
      }, g.onabort = function() {
        !g || (p(a("Request aborted", u, "ECONNABORTED", g)), g = null);
      }, g.onerror = function() {
        p(a("Network Error", u, null, g)), g = null;
      }, g.ontimeout = function() {
        var S = "timeout of " + u.timeout + "ms exceeded";
        u.timeoutErrorMessage && (S = u.timeoutErrorMessage), p(a(
          S,
          u,
          u.transitional && u.transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED",
          g
        )), g = null;
      }, n.isStandardBrowserEnv()) {
        var O = (u.withCredentials || o(y)) && u.xsrfCookieName ? t.read(u.xsrfCookieName) : void 0;
        O && (h[u.xsrfHeaderName] = O);
      }
      "setRequestHeader" in g && n.forEach(h, function(S, b) {
        typeof d > "u" && b.toLowerCase() === "content-type" ? delete h[b] : g.setRequestHeader(b, S);
      }), n.isUndefined(u.withCredentials) || (g.withCredentials = !!u.withCredentials), v && v !== "json" && (g.responseType = u.responseType), typeof u.onDownloadProgress == "function" && g.addEventListener("progress", u.onDownloadProgress), typeof u.onUploadProgress == "function" && g.upload && g.upload.addEventListener("progress", u.onUploadProgress), u.cancelToken && u.cancelToken.promise.then(function(S) {
        !g || (g.abort(), p(S), g = null);
      }), d || (d = null), g.send(d);
    });
  }, rc;
}
var Ye = It, Bh = d1, b1 = Fy, w1 = {
  "Content-Type": "application/x-www-form-urlencoded"
};
function jh(n, e) {
  !Ye.isUndefined(n) && Ye.isUndefined(n["Content-Type"]) && (n["Content-Type"] = e);
}
function _1() {
  var n;
  return (typeof XMLHttpRequest < "u" || typeof process < "u" && Object.prototype.toString.call(process) === "[object process]") && (n = zh()), n;
}
function S1(n, e, t) {
  if (Ye.isString(n))
    try {
      return (e || JSON.parse)(n), Ye.trim(n);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (t || JSON.stringify)(n);
}
var Al = {
  transitional: {
    silentJSONParsing: !0,
    forcedJSONParsing: !0,
    clarifyTimeoutError: !1
  },
  adapter: _1(),
  transformRequest: [function(e, t) {
    return Bh(t, "Accept"), Bh(t, "Content-Type"), Ye.isFormData(e) || Ye.isArrayBuffer(e) || Ye.isBuffer(e) || Ye.isStream(e) || Ye.isFile(e) || Ye.isBlob(e) ? e : Ye.isArrayBufferView(e) ? e.buffer : Ye.isURLSearchParams(e) ? (jh(t, "application/x-www-form-urlencoded;charset=utf-8"), e.toString()) : Ye.isObject(e) || t && t["Content-Type"] === "application/json" ? (jh(t, "application/json"), S1(e)) : e;
  }],
  transformResponse: [function(e) {
    var t = this.transitional, r = t && t.silentJSONParsing, i = t && t.forcedJSONParsing, s = !r && this.responseType === "json";
    if (s || i && Ye.isString(e) && e.length)
      try {
        return JSON.parse(e);
      } catch (o) {
        if (s)
          throw o.name === "SyntaxError" ? b1(o, this, "E_JSON_PARSE") : o;
      }
    return e;
  }],
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  }
};
Al.headers = {
  common: {
    Accept: "application/json, text/plain, */*"
  }
};
Ye.forEach(["delete", "get", "head"], function(e) {
  Al.headers[e] = {};
});
Ye.forEach(["post", "put", "patch"], function(e) {
  Al.headers[e] = Ye.merge(w1);
});
var qf = Al, x1 = It, C1 = qf, O1 = function(e, t, r) {
  var i = this || C1;
  return x1.forEach(r, function(o) {
    e = o.call(i, e, t);
  }), e;
}, ic, Vh;
function By() {
  return Vh || (Vh = 1, ic = function(e) {
    return !!(e && e.__CANCEL__);
  }), ic;
}
var Hh = It, sc = O1, E1 = By(), T1 = qf;
function oc(n) {
  n.cancelToken && n.cancelToken.throwIfRequested();
}
var k1 = function(e) {
  oc(e), e.headers = e.headers || {}, e.data = sc.call(
    e,
    e.data,
    e.headers,
    e.transformRequest
  ), e.headers = Hh.merge(
    e.headers.common || {},
    e.headers[e.method] || {},
    e.headers
  ), Hh.forEach(
    ["delete", "get", "head", "post", "put", "patch", "common"],
    function(i) {
      delete e.headers[i];
    }
  );
  var t = e.adapter || T1.adapter;
  return t(e).then(function(i) {
    return oc(e), i.data = sc.call(
      e,
      i.data,
      i.headers,
      e.transformResponse
    ), i;
  }, function(i) {
    return E1(i) || (oc(e), i && i.response && (i.response.data = sc.call(
      e,
      i.response.data,
      i.response.headers,
      e.transformResponse
    ))), Promise.reject(i);
  });
}, et = It, jy = function(e, t) {
  t = t || {};
  var r = {}, i = ["url", "method", "data"], s = ["headers", "auth", "proxy", "params"], o = [
    "baseURL",
    "transformRequest",
    "transformResponse",
    "paramsSerializer",
    "timeout",
    "timeoutMessage",
    "withCredentials",
    "adapter",
    "responseType",
    "xsrfCookieName",
    "xsrfHeaderName",
    "onUploadProgress",
    "onDownloadProgress",
    "decompress",
    "maxContentLength",
    "maxBodyLength",
    "maxRedirects",
    "transport",
    "httpAgent",
    "httpsAgent",
    "cancelToken",
    "socketPath",
    "responseEncoding"
  ], a = ["validateStatus"];
  function l(p, d) {
    return et.isPlainObject(p) && et.isPlainObject(d) ? et.merge(p, d) : et.isPlainObject(d) ? et.merge({}, d) : et.isArray(d) ? d.slice() : d;
  }
  function u(p) {
    et.isUndefined(t[p]) ? et.isUndefined(e[p]) || (r[p] = l(void 0, e[p])) : r[p] = l(e[p], t[p]);
  }
  et.forEach(i, function(d) {
    et.isUndefined(t[d]) || (r[d] = l(void 0, t[d]));
  }), et.forEach(s, u), et.forEach(o, function(d) {
    et.isUndefined(t[d]) ? et.isUndefined(e[d]) || (r[d] = l(void 0, e[d])) : r[d] = l(void 0, t[d]);
  }), et.forEach(a, function(d) {
    d in t ? r[d] = l(e[d], t[d]) : d in e && (r[d] = l(void 0, e[d]));
  });
  var c = i.concat(s).concat(o).concat(a), f = Object.keys(e).concat(Object.keys(t)).filter(function(d) {
    return c.indexOf(d) === -1;
  });
  return et.forEach(f, u), r;
};
const M1 = "axios", A1 = "0.21.4", P1 = "Promise based HTTP client for the browser and node.js", $1 = "index.js", D1 = {
  test: "grunt test",
  start: "node ./sandbox/server.js",
  build: "NODE_ENV=production grunt build",
  preversion: "npm test",
  version: "npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json",
  postversion: "git push && git push --tags",
  examples: "node ./examples/server.js",
  coveralls: "cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js",
  fix: "eslint --fix lib/**/*.js"
}, L1 = {
  type: "git",
  url: "https://github.com/axios/axios.git"
}, N1 = [
  "xhr",
  "http",
  "ajax",
  "promise",
  "node"
], I1 = "Matt Zabriskie", R1 = "MIT", F1 = {
  url: "https://github.com/axios/axios/issues"
}, z1 = "https://axios-http.com", B1 = {
  coveralls: "^3.0.0",
  "es6-promise": "^4.2.4",
  grunt: "^1.3.0",
  "grunt-banner": "^0.6.0",
  "grunt-cli": "^1.2.0",
  "grunt-contrib-clean": "^1.1.0",
  "grunt-contrib-watch": "^1.0.0",
  "grunt-eslint": "^23.0.0",
  "grunt-karma": "^4.0.0",
  "grunt-mocha-test": "^0.13.3",
  "grunt-ts": "^6.0.0-beta.19",
  "grunt-webpack": "^4.0.2",
  "istanbul-instrumenter-loader": "^1.0.0",
  "jasmine-core": "^2.4.1",
  karma: "^6.3.2",
  "karma-chrome-launcher": "^3.1.0",
  "karma-firefox-launcher": "^2.1.0",
  "karma-jasmine": "^1.1.1",
  "karma-jasmine-ajax": "^0.1.13",
  "karma-safari-launcher": "^1.0.0",
  "karma-sauce-launcher": "^4.3.6",
  "karma-sinon": "^1.0.5",
  "karma-sourcemap-loader": "^0.3.8",
  "karma-webpack": "^4.0.2",
  "load-grunt-tasks": "^3.5.2",
  minimist: "^1.2.0",
  mocha: "^8.2.1",
  sinon: "^4.5.0",
  "terser-webpack-plugin": "^4.2.3",
  typescript: "^4.0.5",
  "url-search-params": "^0.10.0",
  webpack: "^4.44.2",
  "webpack-dev-server": "^3.11.0"
}, j1 = {
  "./lib/adapters/http.js": "./lib/adapters/xhr.js"
}, V1 = "dist/axios.min.js", H1 = "dist/axios.min.js", W1 = "./index.d.ts", q1 = {
  "follow-redirects": "^1.14.0"
}, U1 = [
  {
    path: "./dist/axios.min.js",
    threshold: "5kB"
  }
], G1 = {
  name: M1,
  version: A1,
  description: P1,
  main: $1,
  scripts: D1,
  repository: L1,
  keywords: N1,
  author: I1,
  license: R1,
  bugs: F1,
  homepage: z1,
  devDependencies: B1,
  browser: j1,
  jsdelivr: V1,
  unpkg: H1,
  typings: W1,
  dependencies: q1,
  bundlesize: U1
};
var Vy = G1, Uf = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach(function(n, e) {
  Uf[n] = function(r) {
    return typeof r === n || "a" + (e < 1 ? "n " : " ") + n;
  };
});
var Wh = {}, K1 = Vy.version.split(".");
function Hy(n, e) {
  for (var t = e ? e.split(".") : K1, r = n.split("."), i = 0; i < 3; i++) {
    if (t[i] > r[i])
      return !0;
    if (t[i] < r[i])
      return !1;
  }
  return !1;
}
Uf.transitional = function(e, t, r) {
  var i = t && Hy(t);
  function s(o, a) {
    return "[Axios v" + Vy.version + "] Transitional option '" + o + "'" + a + (r ? ". " + r : "");
  }
  return function(o, a, l) {
    if (e === !1)
      throw new Error(s(a, " has been removed in " + t));
    return i && !Wh[a] && (Wh[a] = !0, console.warn(
      s(
        a,
        " has been deprecated since v" + t + " and will be removed in the near future"
      )
    )), e ? e(o, a, l) : !0;
  };
};
function J1(n, e, t) {
  if (typeof n != "object")
    throw new TypeError("options must be an object");
  for (var r = Object.keys(n), i = r.length; i-- > 0; ) {
    var s = r[i], o = e[s];
    if (o) {
      var a = n[s], l = a === void 0 || o(a, s, n);
      if (l !== !0)
        throw new TypeError("option " + s + " must be " + l);
      continue;
    }
    if (t !== !0)
      throw Error("Unknown option " + s);
  }
}
var X1 = {
  isOlderVersion: Hy,
  assertOptions: J1,
  validators: Uf
}, Wy = It, Y1 = Ry, qh = u1, Uh = k1, Pl = jy, qy = X1, ri = qy.validators;
function Ks(n) {
  this.defaults = n, this.interceptors = {
    request: new qh(),
    response: new qh()
  };
}
Ks.prototype.request = function(e) {
  typeof e == "string" ? (e = arguments[1] || {}, e.url = arguments[0]) : e = e || {}, e = Pl(this.defaults, e), e.method ? e.method = e.method.toLowerCase() : this.defaults.method ? e.method = this.defaults.method.toLowerCase() : e.method = "get";
  var t = e.transitional;
  t !== void 0 && qy.assertOptions(t, {
    silentJSONParsing: ri.transitional(ri.boolean, "1.0.0"),
    forcedJSONParsing: ri.transitional(ri.boolean, "1.0.0"),
    clarifyTimeoutError: ri.transitional(ri.boolean, "1.0.0")
  }, !1);
  var r = [], i = !0;
  this.interceptors.request.forEach(function(p) {
    typeof p.runWhen == "function" && p.runWhen(e) === !1 || (i = i && p.synchronous, r.unshift(p.fulfilled, p.rejected));
  });
  var s = [];
  this.interceptors.response.forEach(function(p) {
    s.push(p.fulfilled, p.rejected);
  });
  var o;
  if (!i) {
    var a = [Uh, void 0];
    for (Array.prototype.unshift.apply(a, r), a = a.concat(s), o = Promise.resolve(e); a.length; )
      o = o.then(a.shift(), a.shift());
    return o;
  }
  for (var l = e; r.length; ) {
    var u = r.shift(), c = r.shift();
    try {
      l = u(l);
    } catch (f) {
      c(f);
      break;
    }
  }
  try {
    o = Uh(l);
  } catch (f) {
    return Promise.reject(f);
  }
  for (; s.length; )
    o = o.then(s.shift(), s.shift());
  return o;
};
Ks.prototype.getUri = function(e) {
  return e = Pl(this.defaults, e), Y1(e.url, e.params, e.paramsSerializer).replace(/^\?/, "");
};
Wy.forEach(["delete", "get", "head", "options"], function(e) {
  Ks.prototype[e] = function(t, r) {
    return this.request(Pl(r || {}, {
      method: e,
      url: t,
      data: (r || {}).data
    }));
  };
});
Wy.forEach(["post", "put", "patch"], function(e) {
  Ks.prototype[e] = function(t, r, i) {
    return this.request(Pl(i || {}, {
      method: e,
      url: t,
      data: r
    }));
  };
});
var Q1 = Ks, ac, Gh;
function Uy() {
  if (Gh)
    return ac;
  Gh = 1;
  function n(e) {
    this.message = e;
  }
  return n.prototype.toString = function() {
    return "Cancel" + (this.message ? ": " + this.message : "");
  }, n.prototype.__CANCEL__ = !0, ac = n, ac;
}
var lc, Kh;
function Z1() {
  if (Kh)
    return lc;
  Kh = 1;
  var n = Uy();
  function e(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    var r;
    this.promise = new Promise(function(o) {
      r = o;
    });
    var i = this;
    t(function(o) {
      i.reason || (i.reason = new n(o), r(i.reason));
    });
  }
  return e.prototype.throwIfRequested = function() {
    if (this.reason)
      throw this.reason;
  }, e.source = function() {
    var r, i = new e(function(o) {
      r = o;
    });
    return {
      token: i,
      cancel: r
    };
  }, lc = e, lc;
}
var uc, Jh;
function eC() {
  return Jh || (Jh = 1, uc = function(e) {
    return function(r) {
      return e.apply(null, r);
    };
  }), uc;
}
var cc, Xh;
function tC() {
  return Xh || (Xh = 1, cc = function(e) {
    return typeof e == "object" && e.isAxiosError === !0;
  }), cc;
}
var Yh = It, nC = Ly, Yo = Q1, rC = jy, iC = qf;
function Gy(n) {
  var e = new Yo(n), t = nC(Yo.prototype.request, e);
  return Yh.extend(t, Yo.prototype, e), Yh.extend(t, e), t;
}
var sn = Gy(iC);
sn.Axios = Yo;
sn.create = function(e) {
  return Gy(rC(sn.defaults, e));
};
sn.Cancel = Uy();
sn.CancelToken = Z1();
sn.isCancel = By();
sn.all = function(e) {
  return Promise.all(e);
};
sn.spread = eC();
sn.isAxiosError = tC();
Vf.exports = sn;
Vf.exports.default = sn;
(function(n) {
  n.exports = Vf.exports;
})(Dy);
const da = /* @__PURE__ */ ot(Dy.exports), Gf = (n) => ({ uploadMedia: async (i) => {
  const { data: s } = await da.post(n.value.imageUploadURL, i);
  return s;
}, getFormData: (i) => {
  if (!n.value.imageUploadFolder)
    throw new Error("config.imageUploadFolder require");
  const s = new FormData();
  return s.append("file", i), s.append("folder", n.value.imageUploadFolder), s;
}, getFullPathMedia: (i) => n.value.imageBaseURL + "/" + i }), sC = st({
  name: "ImageCommand",
  components: { TUpload: jf, ButtonCommand: yt },
  setup() {
    const n = $e("config"), e = $e("editor"), { getFullPathMedia: t, uploadMedia: r, getFormData: i } = Gf(n), s = (l) => {
      !l.length || o(l[0]);
    }, o = async (l) => {
      try {
        const u = await r(i(l));
        a(u);
      } catch (u) {
        console.log("uploadImage", u);
      }
    }, a = (l) => {
      var u;
      !l || (u = e == null ? void 0 : e.value) == null || u.chain().focus().setImageView({ src: t(l) }).run();
    };
    return { editor: e, selectImage: s };
  }
});
var oC = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("t-upload", { attrs: { multiple: !1, accept: "image/*" }, on: { input: e.selectImage }, scopedSlots: e._u([{ key: "default", fn: function({ on: r }) {
    return [t("button-command", e._g({ attrs: { icon: "image-line", title: "Image" } }, r))];
  } }]) });
}, aC = [], lC = /* @__PURE__ */ le(
  sC,
  oC,
  aC,
  !1,
  null,
  null,
  null,
  null
);
const uC = lC.exports;
var cC = {
  inject: ["manager"],
  props: {
    index: {
      type: Number,
      required: !0
    },
    collection: {
      type: [String, Number],
      default: "default"
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  mounted: function() {
    var e = this.$props, t = e.collection, r = e.disabled, i = e.index;
    r || this.setDraggable(t, i);
  },
  watch: {
    index: function(e) {
      this.$el && this.$el.sortableInfo && (this.$el.sortableInfo.index = e);
    },
    disabled: function(e) {
      e ? this.removeDraggable(this.collection) : this.setDraggable(this.collection, this.index);
    },
    collection: function(e, t) {
      this.removeDraggable(t), this.setDraggable(e, this.index);
    }
  },
  beforeDestroy: function() {
    var e = this.collection, t = this.disabled;
    t || this.removeDraggable(e);
  },
  methods: {
    setDraggable: function(e, t) {
      var r = this.$el;
      r.sortableInfo = {
        index: t,
        collection: e,
        manager: this.manager
      }, this.ref = { node: r }, this.manager.add(e, this.ref);
    },
    removeDraggable: function(e) {
      this.manager.remove(e, this.ref);
    }
  }
}, dC = function(n, e) {
  if (!(n instanceof e))
    throw new TypeError("Cannot call a class as a function");
}, fC = function() {
  function n(e, t) {
    for (var r = 0; r < t.length; r++) {
      var i = t[r];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
    }
  }
  return function(e, t, r) {
    return t && n(e.prototype, t), r && n(e, r), e;
  };
}(), Qh = function() {
  function n(e, t) {
    var r = [], i = !0, s = !1, o = void 0;
    try {
      for (var a = e[Symbol.iterator](), l; !(i = (l = a.next()).done) && (r.push(l.value), !(t && r.length === t)); i = !0)
        ;
    } catch (u) {
      s = !0, o = u;
    } finally {
      try {
        !i && a.return && a.return();
      } finally {
        if (s)
          throw o;
      }
    }
    return r;
  }
  return function(e, t) {
    if (Array.isArray(e))
      return e;
    if (Symbol.iterator in Object(e))
      return n(e, t);
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  };
}(), Zh = function(n) {
  if (Array.isArray(n)) {
    for (var e = 0, t = Array(n.length); e < n.length; e++)
      t[e] = n[e];
    return t;
  } else
    return Array.from(n);
}, pC = function() {
  function n() {
    dC(this, n), this.refs = {};
  }
  return fC(n, [{
    key: "add",
    value: function(t, r) {
      this.refs[t] || (this.refs[t] = []), this.refs[t].push(r);
    }
  }, {
    key: "remove",
    value: function(t, r) {
      var i = this.getIndex(t, r);
      i !== -1 && this.refs[t].splice(i, 1);
    }
  }, {
    key: "isActive",
    value: function() {
      return this.active;
    }
  }, {
    key: "getActive",
    value: function() {
      var t = this;
      return this.refs[this.active.collection].find(function(r) {
        var i = r.node;
        return i.sortableInfo.index == t.active.index;
      });
    }
  }, {
    key: "getIndex",
    value: function(t, r) {
      return this.refs[t].indexOf(r);
    }
  }, {
    key: "getOrderedRefs",
    value: function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.active.collection;
      return this.refs[t].sort(function(r, i) {
        return r.node.sortableInfo.index - i.node.sortableInfo.index;
      });
    }
  }]), n;
}();
function hC(n, e, t) {
  var r = n.slice(0);
  if (t >= r.length)
    for (var i = t - r.length; i-- + 1; )
      r.push(void 0);
  return r.splice(t, 0, r.splice(e, 1)[0]), r;
}
var ii = {
  start: ["touchstart", "mousedown"],
  move: ["touchmove", "mousemove"],
  end: ["touchend", "touchcancel", "mouseup"]
}, Tn = function() {
  if (typeof window > "u" || typeof document > "u")
    return "";
  var n = window.getComputedStyle(document.documentElement, "") || ["-moz-hidden-iframe"], e = (Array.prototype.slice.call(n).join("").match(/-(moz|webkit|ms)-/) || n.OLink === "" && ["", "o"])[1];
  switch (e) {
    case "ms":
      return "ms";
    default:
      return e && e.length ? e[0].toUpperCase() + e.substr(1) : "";
  }
}();
function em(n, e) {
  for (; n; ) {
    if (e(n))
      return n;
    n = n.parentNode;
  }
}
function tm(n, e, t) {
  return t < n ? n : t > e ? e : t;
}
function _o(n) {
  return n.substr(-2) === "px" ? parseFloat(n) : 0;
}
function mC(n) {
  var e = window.getComputedStyle(n);
  return {
    top: _o(e.marginTop),
    right: _o(e.marginRight),
    bottom: _o(e.marginBottom),
    left: _o(e.marginLeft)
  };
}
var gC = {
  data: function() {
    return {
      sorting: !1,
      sortingIndex: null,
      manager: new pC(),
      events: {
        start: this.handleStart,
        move: this.handleMove,
        end: this.handleEnd
      }
    };
  },
  props: {
    value: { type: Array, required: !0 },
    axis: { type: String, default: "y" },
    distance: { type: Number, default: 0 },
    pressDelay: { type: Number, default: 0 },
    pressThreshold: { type: Number, default: 5 },
    useDragHandle: { type: Boolean, default: !1 },
    useWindowAsScrollContainer: { type: Boolean, default: !1 },
    hideSortableGhost: { type: Boolean, default: !0 },
    lockToContainerEdges: { type: Boolean, default: !1 },
    lockOffset: { type: [String, Number, Array], default: "50%" },
    transitionDuration: { type: Number, default: 300 },
    appendTo: { type: String, default: "body" },
    draggedSettlingDuration: { type: Number, default: null },
    lockAxis: String,
    helperClass: String,
    contentWindow: Object,
    shouldCancelStart: {
      type: Function,
      default: function(e) {
        var t = ["input", "textarea", "select", "option", "button"];
        return t.indexOf(e.target.tagName.toLowerCase()) !== -1;
      }
    },
    getHelperDimensions: {
      type: Function,
      default: function(e) {
        var t = e.node;
        return {
          width: t.offsetWidth,
          height: t.offsetHeight
        };
      }
    }
  },
  provide: function() {
    return {
      manager: this.manager
    };
  },
  mounted: function() {
    var e = this;
    this.container = this.$el, this.document = this.container.ownerDocument || document, this._window = this.contentWindow || window, this.scrollContainer = this.useWindowAsScrollContainer ? this.document.body : this.container;
    var t = function(s) {
      e.events.hasOwnProperty(s) && ii[s].forEach(function(o) {
        return e.container.addEventListener(o, e.events[s], { passive: !0 });
      });
    };
    for (var r in this.events)
      t(r);
  },
  beforeDestroy: function() {
    var e = this, t = function(s) {
      e.events.hasOwnProperty(s) && ii[s].forEach(function(o) {
        return e.container.removeEventListener(o, e.events[s]);
      });
    };
    for (var r in this.events)
      t(r);
  },
  methods: {
    handleStart: function(e) {
      var t = this, r = this.$props, i = r.distance, s = r.shouldCancelStart;
      if (e.button === 2 || s(e))
        return !1;
      this._touched = !0, this._pos = this.getOffset(e);
      var o = em(e.target, function(f) {
        return f.sortableInfo != null;
      });
      if (o && o.sortableInfo && this.nodeIsChild(o) && !this.sorting) {
        var a = this.$props.useDragHandle, l = o.sortableInfo, u = l.index, c = l.collection;
        if (a && !em(e.target, function(f) {
          return f.sortableHandle != null;
        }))
          return;
        this.manager.active = { index: u, collection: c }, e.target.tagName.toLowerCase() === "a" && e.preventDefault(), i || (this.$props.pressDelay === 0 ? this.handlePress(e) : this.pressTimer = setTimeout(function() {
          return t.handlePress(e);
        }, this.$props.pressDelay));
      }
    },
    nodeIsChild: function(e) {
      return e.sortableInfo.manager === this.manager;
    },
    handleMove: function(e) {
      var t = this.$props, r = t.distance, i = t.pressThreshold;
      if (!this.sorting && this._touched) {
        var s = this.getOffset(e);
        this._delta = {
          x: this._pos.x - s.x,
          y: this._pos.y - s.y
        };
        var o = Math.abs(this._delta.x) + Math.abs(this._delta.y);
        !r && (!i || i && o >= i) ? (clearTimeout(this.cancelTimer), this.cancelTimer = setTimeout(this.cancel, 0)) : r && o >= r && this.manager.isActive() && this.handlePress(e);
      }
    },
    handleEnd: function() {
      var e = this.$props.distance;
      this._touched = !1, e || this.cancel();
    },
    cancel: function() {
      this.sorting || (clearTimeout(this.pressTimer), this.manager.active = null);
    },
    handlePress: function(e) {
      var t = this;
      e.stopPropagation();
      var r = this.manager.getActive();
      if (r) {
        var i = this.$props, s = i.axis, o = i.getHelperDimensions, a = i.helperClass, l = i.hideSortableGhost, u = i.useWindowAsScrollContainer, c = i.appendTo, f = r.node, p = r.collection, d = f.sortableInfo.index, h = mC(f), v = this.container.getBoundingClientRect(), g = o({ index: d, node: f, collection: p });
        this.node = f, this.margin = h, this.width = g.width, this.height = g.height, this.marginOffset = {
          x: this.margin.left + this.margin.right,
          y: Math.max(this.margin.top, this.margin.bottom)
        }, this.boundingClientRect = f.getBoundingClientRect(), this.containerBoundingRect = v, this.index = d, this.newIndex = d, this._axis = {
          x: s.indexOf("x") >= 0,
          y: s.indexOf("y") >= 0
        }, this.offsetEdge = this.getEdgeOffset(f), this.initialOffset = this.getOffset(e), this.initialScroll = {
          top: this.scrollContainer.scrollTop,
          left: this.scrollContainer.scrollLeft
        }, this.initialWindowScroll = {
          top: window.pageYOffset,
          left: window.pageXOffset
        };
        var m = f.querySelectorAll("input, textarea, select"), _ = f.cloneNode(!0), y = [].concat(Zh(_.querySelectorAll("input, textarea, select")));
        if (y.forEach(function(O, C) {
          O.type !== "file" && m[C] && (O.value = m[C].value);
        }), this.helper = this.document.querySelector(c).appendChild(_), this.helper.style.position = "fixed", this.helper.style.top = this.boundingClientRect.top - h.top + "px", this.helper.style.left = this.boundingClientRect.left - h.left + "px", this.helper.style.width = this.width + "px", this.helper.style.height = this.height + "px", this.helper.style.boxSizing = "border-box", this.helper.style.pointerEvents = "none", l && (this.sortableGhost = f, f.style.visibility = "hidden", f.style.opacity = 0), this.translate = {}, this.minTranslate = {}, this.maxTranslate = {}, this._axis.x && (this.minTranslate.x = (u ? 0 : v.left) - this.boundingClientRect.left - this.width / 2, this.maxTranslate.x = (u ? this._window.innerWidth : v.left + v.width) - this.boundingClientRect.left - this.width / 2), this._axis.y && (this.minTranslate.y = (u ? 0 : v.top) - this.boundingClientRect.top - this.height / 2, this.maxTranslate.y = (u ? this._window.innerHeight : v.top + v.height) - this.boundingClientRect.top - this.height / 2), a) {
          var w;
          (w = this.helper.classList).add.apply(w, Zh(a.split(" ")));
        }
        this.listenerNode = e.touches ? f : this._window, ii.move.forEach(function(O) {
          return t.listenerNode.addEventListener(O, t.handleSortMove, !1);
        }), ii.end.forEach(function(O) {
          return t.listenerNode.addEventListener(O, t.handleSortEnd, !1);
        }), this.sorting = !0, this.sortingIndex = d, this.$emit("sort-start", { event: e, node: f, index: d, collection: p });
      }
    },
    handleSortMove: function(e) {
      e.preventDefault(), this.updatePosition(e), this.animateNodes(), this.autoscroll(), this.$emit("sort-move", { event: e });
    },
    handleSortEnd: function(e) {
      var t = this, r = this.manager.active.collection;
      this.listenerNode && (ii.move.forEach(function(o) {
        return t.listenerNode.removeEventListener(o, t.handleSortMove);
      }), ii.end.forEach(function(o) {
        return t.listenerNode.removeEventListener(o, t.handleSortEnd);
      }));
      var i = this.manager.refs[r], s = function() {
        t.helper.parentNode.removeChild(t.helper), t.hideSortableGhost && t.sortableGhost && (t.sortableGhost.style.visibility = "", t.sortableGhost.style.opacity = "");
        for (var a = 0, l = i.length; a < l; a++) {
          var u = i[a], c = u.node;
          u.edgeOffset = null, c.style[Tn + "Transform"] = "", c.style[Tn + "TransitionDuration"] = "";
        }
        clearInterval(t.autoscrollInterval), t.autoscrollInterval = null, t.manager.active = null, t.sorting = !1, t.sortingIndex = null, t.$emit("sort-end", {
          event: e,
          oldIndex: t.index,
          newIndex: t.newIndex,
          collection: r
        }), t.$emit("input", hC(t.value, t.index, t.newIndex)), t._touched = !1;
      };
      this.$props.transitionDuration || this.$props.draggedSettlingDuration ? this.transitionHelperIntoPlace(i).then(function() {
        return s();
      }) : s();
    },
    transitionHelperIntoPlace: function(e) {
      var t = this;
      if (this.$props.draggedSettlingDuration === 0 || e.length === 0)
        return Promise.resolve();
      var r = {
        left: this.scrollContainer.scrollLeft - this.initialScroll.left,
        top: this.scrollContainer.scrollTop - this.initialScroll.top
      }, i = e[this.index].node, s = e[this.newIndex].node, o = -r.left;
      this.translate && this.translate.x > 0 ? o += s.offsetLeft + s.offsetWidth - (i.offsetLeft + i.offsetWidth) : o += s.offsetLeft - i.offsetLeft;
      var a = -r.top;
      this.translate && this.translate.y > 0 ? a += s.offsetTop + s.offsetHeight - (i.offsetTop + i.offsetHeight) : a += s.offsetTop - i.offsetTop;
      var l = this.$props.draggedSettlingDuration !== null ? this.$props.draggedSettlingDuration : this.$props.transitionDuration;
      return this.helper.style[Tn + "Transform"] = "translate3d(" + o + "px," + a + "px, 0)", this.helper.style[Tn + "TransitionDuration"] = l + "ms", new Promise(function(u) {
        var c = function(d) {
          (!d || d.propertyName === "transform") && (clearTimeout(f), t.helper.style[Tn + "Transform"] = "", t.helper.style[Tn + "TransitionDuration"] = "", u());
        }, f = setTimeout(c, l + 10);
        t.helper.addEventListener("transitionend", c, !1);
      });
    },
    getEdgeOffset: function(e) {
      var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : { top: 0, left: 0 };
      if (e) {
        var r = {
          top: t.top + e.offsetTop,
          left: t.left + e.offsetLeft
        };
        return e.parentNode !== this.container ? this.getEdgeOffset(e.parentNode, r) : r;
      }
    },
    getOffset: function(e) {
      var t = e.touches ? e.touches[0] : e, r = t.pageX, i = t.pageY;
      return {
        x: r,
        y: i
      };
    },
    getLockPixelOffsets: function() {
      var e = this.$props.lockOffset;
      if (Array.isArray(this.lockOffset) || (e = [e, e]), e.length !== 2)
        throw new Error("lockOffset prop of SortableContainer should be a single value or an array of exactly two values. Given " + e);
      var t = e, r = Qh(t, 2), i = r[0], s = r[1];
      return [this.getLockPixelOffset(i), this.getLockPixelOffset(s)];
    },
    getLockPixelOffset: function(e) {
      var t = e, r = e, i = "px";
      if (typeof e == "string") {
        var s = /^[+-]?\d*(?:\.\d*)?(px|%)$/.exec(e);
        if (s === null)
          throw new Error('lockOffset value should be a number or a string of a number followed by "px" or "%". Given ' + e);
        t = r = parseFloat(e), i = s[1];
      }
      if (!isFinite(t) || !isFinite(r))
        throw new Error("lockOffset value should be a finite. Given " + e);
      return i === "%" && (t = t * this.width / 100, r = r * this.height / 100), {
        x: t,
        y: r
      };
    },
    updatePosition: function(e) {
      var t = this.$props, r = t.lockAxis, i = t.lockToContainerEdges, s = this.getOffset(e), o = {
        x: s.x - this.initialOffset.x,
        y: s.y - this.initialOffset.y
      };
      if (o.y -= window.pageYOffset - this.initialWindowScroll.top, o.x -= window.pageXOffset - this.initialWindowScroll.left, this.translate = o, i) {
        var a = this.getLockPixelOffsets(), l = Qh(a, 2), u = l[0], c = l[1], f = {
          x: this.width / 2 - u.x,
          y: this.height / 2 - u.y
        }, p = {
          x: this.width / 2 - c.x,
          y: this.height / 2 - c.y
        };
        o.x = tm(this.minTranslate.x + f.x, this.maxTranslate.x - p.x, o.x), o.y = tm(this.minTranslate.y + f.y, this.maxTranslate.y - p.y, o.y);
      }
      r === "x" ? o.y = 0 : r === "y" && (o.x = 0), this.helper.style[Tn + "Transform"] = "translate3d(" + o.x + "px," + o.y + "px, 0)";
    },
    animateNodes: function() {
      var e = this.$props, t = e.transitionDuration, r = e.hideSortableGhost, i = this.manager.getOrderedRefs(), s = {
        left: this.scrollContainer.scrollLeft - this.initialScroll.left,
        top: this.scrollContainer.scrollTop - this.initialScroll.top
      }, o = {
        left: this.offsetEdge.left + this.translate.x + s.left,
        top: this.offsetEdge.top + this.translate.y + s.top
      }, a = {
        top: window.pageYOffset - this.initialWindowScroll.top,
        left: window.pageXOffset - this.initialWindowScroll.left
      };
      this.newIndex = null;
      for (var l = 0, u = i.length; l < u; l++) {
        var c = i[l].node, f = c.sortableInfo.index, p = c.offsetWidth, d = c.offsetHeight, h = {
          width: this.width > p ? p / 2 : this.width / 2,
          height: this.height > d ? d / 2 : this.height / 2
        }, v = {
          x: 0,
          y: 0
        }, g = i[l].edgeOffset;
        g || (i[l].edgeOffset = g = this.getEdgeOffset(c));
        var m = l < i.length - 1 && i[l + 1], _ = l > 0 && i[l - 1];
        if (m && !m.edgeOffset && (m.edgeOffset = this.getEdgeOffset(m.node)), f === this.index) {
          r && (this.sortableGhost = c, c.style.visibility = "hidden", c.style.opacity = 0);
          continue;
        }
        t && (c.style[Tn + "TransitionDuration"] = t + "ms"), this._axis.x ? this._axis.y ? f < this.index && (o.left + a.left - h.width <= g.left && o.top + a.top <= g.top + h.height || o.top + a.top + h.height <= g.top) ? (v.x = this.width + this.marginOffset.x, g.left + v.x > this.containerBoundingRect.width - h.width && (v.x = m.edgeOffset.left - g.left, v.y = m.edgeOffset.top - g.top), this.newIndex === null && (this.newIndex = f)) : f > this.index && (o.left + a.left + h.width >= g.left && o.top + a.top + h.height >= g.top || o.top + a.top + h.height >= g.top + d) && (v.x = -(this.width + this.marginOffset.x), g.left + v.x < this.containerBoundingRect.left + h.width && (v.x = _.edgeOffset.left - g.left, v.y = _.edgeOffset.top - g.top), this.newIndex = f) : f > this.index && o.left + a.left + h.width >= g.left ? (v.x = -(this.width + this.marginOffset.x), this.newIndex = f) : f < this.index && o.left + a.left <= g.left + h.width && (v.x = this.width + this.marginOffset.x, this.newIndex == null && (this.newIndex = f)) : this._axis.y && (f > this.index && o.top + a.top + h.height >= g.top ? (v.y = -(this.height + this.marginOffset.y), this.newIndex = f) : f < this.index && o.top + a.top <= g.top + h.height && (v.y = this.height + this.marginOffset.y, this.newIndex == null && (this.newIndex = f))), c.style[Tn + "Transform"] = "translate3d(" + v.x + "px," + v.y + "px,0)";
      }
      this.newIndex == null && (this.newIndex = this.index);
    },
    autoscroll: function() {
      var e = this, t = this.translate, r = {
        x: 0,
        y: 0
      }, i = {
        x: 1,
        y: 1
      }, s = {
        x: 10,
        y: 10
      };
      t.y >= this.maxTranslate.y - this.height / 2 ? (r.y = 1, i.y = s.y * Math.abs((this.maxTranslate.y - this.height / 2 - t.y) / this.height)) : t.x >= this.maxTranslate.x - this.width / 2 ? (r.x = 1, i.x = s.x * Math.abs((this.maxTranslate.x - this.width / 2 - t.x) / this.width)) : t.y <= this.minTranslate.y + this.height / 2 ? (r.y = -1, i.y = s.y * Math.abs((t.y - this.height / 2 - this.minTranslate.y) / this.height)) : t.x <= this.minTranslate.x + this.width / 2 && (r.x = -1, i.x = s.x * Math.abs((t.x - this.width / 2 - this.minTranslate.x) / this.width)), this.autoscrollInterval && (clearInterval(this.autoscrollInterval), this.autoscrollInterval = null, this.isAutoScrolling = !1), (r.x !== 0 || r.y !== 0) && (this.autoscrollInterval = setInterval(function() {
        e.isAutoScrolling = !0;
        var o = {
          left: 1 * i.x * r.x,
          top: 1 * i.y * r.y
        };
        e.scrollContainer.scrollTop += o.top, e.scrollContainer.scrollLeft += o.left, e.translate.x += o.left, e.translate.y += o.top, e.animateNodes();
      }, 5));
    }
  }
};
function Ky(n, e) {
  return {
    name: n,
    mixins: [e],
    props: {
      tag: {
        type: String,
        default: "div"
      }
    },
    render: function(r) {
      return r(this.tag, this.$slots.default);
    }
  };
}
var Jy = Ky("slick-list", gC), Xy = Ky("slick-item", cC), Yy = { exports: {} };
(function(n) {
  n.exports = function(e) {
    var t = {};
    function r(i) {
      if (t[i])
        return t[i].exports;
      var s = t[i] = {
        i,
        l: !1,
        exports: {}
      };
      return e[i].call(s.exports, s, s.exports, r), s.l = !0, s.exports;
    }
    return r.m = e, r.c = t, r.d = function(i, s, o) {
      r.o(i, s) || Object.defineProperty(i, s, { enumerable: !0, get: o });
    }, r.r = function(i) {
      typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(i, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(i, "__esModule", { value: !0 });
    }, r.t = function(i, s) {
      if (s & 1 && (i = r(i)), s & 8 || s & 4 && typeof i == "object" && i && i.__esModule)
        return i;
      var o = /* @__PURE__ */ Object.create(null);
      if (r.r(o), Object.defineProperty(o, "default", { enumerable: !0, value: i }), s & 2 && typeof i != "string")
        for (var a in i)
          r.d(o, a, function(l) {
            return i[l];
          }.bind(null, a));
      return o;
    }, r.n = function(i) {
      var s = i && i.__esModule ? function() {
        return i.default;
      } : function() {
        return i;
      };
      return r.d(s, "a", s), s;
    }, r.o = function(i, s) {
      return Object.prototype.hasOwnProperty.call(i, s);
    }, r.p = "/dist/", r(r.s = 82);
  }({
    0: function(e, t, r) {
      r.d(t, "a", function() {
        return i;
      });
      function i(s, o, a, l, u, c, f, p) {
        var d = typeof s == "function" ? s.options : s;
        o && (d.render = o, d.staticRenderFns = a, d._compiled = !0), l && (d.functional = !0), c && (d._scopeId = "data-v-" + c);
        var h;
        if (f ? (h = function(m) {
          m = m || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !m && typeof __VUE_SSR_CONTEXT__ < "u" && (m = __VUE_SSR_CONTEXT__), u && u.call(this, m), m && m._registeredComponents && m._registeredComponents.add(f);
        }, d._ssrRegister = h) : u && (h = p ? function() {
          u.call(this, this.$root.$options.shadowRoot);
        } : u), h)
          if (d.functional) {
            d._injectStyles = h;
            var v = d.render;
            d.render = function(_, y) {
              return h.call(y), v(_, y);
            };
          } else {
            var g = d.beforeCreate;
            d.beforeCreate = g ? [].concat(g, h) : [h];
          }
        return {
          exports: s,
          options: d
        };
      }
    },
    11: function(e, t) {
      e.exports = El();
    },
    13: function(e, t) {
      e.exports = ky();
    },
    4: function(e, t) {
      e.exports = an();
    },
    82: function(e, t, r) {
      r.r(t);
      var i = function() {
        var m = this, _ = m.$createElement, y = m._self._c || _;
        return y(
          "transition",
          {
            attrs: { name: "dialog-fade" },
            on: { "after-enter": m.afterEnter, "after-leave": m.afterLeave }
          },
          [
            y(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: m.visible,
                    expression: "visible"
                  }
                ],
                staticClass: "el-dialog__wrapper",
                on: {
                  click: function(w) {
                    return w.target !== w.currentTarget ? null : m.handleWrapperClick(w);
                  }
                }
              },
              [
                y(
                  "div",
                  {
                    key: m.key,
                    ref: "dialog",
                    class: [
                      "el-dialog",
                      {
                        "is-fullscreen": m.fullscreen,
                        "el-dialog--center": m.center
                      },
                      m.customClass
                    ],
                    style: m.style,
                    attrs: {
                      role: "dialog",
                      "aria-modal": "true",
                      "aria-label": m.title || "dialog"
                    }
                  },
                  [
                    y(
                      "div",
                      { staticClass: "el-dialog__header" },
                      [
                        m._t("title", [
                          y("span", { staticClass: "el-dialog__title" }, [
                            m._v(m._s(m.title))
                          ])
                        ]),
                        m.showClose ? y(
                          "button",
                          {
                            staticClass: "el-dialog__headerbtn",
                            attrs: { type: "button", "aria-label": "Close" },
                            on: { click: m.handleClose }
                          },
                          [
                            y("i", {
                              staticClass: "el-dialog__close el-icon el-icon-close"
                            })
                          ]
                        ) : m._e()
                      ],
                      2
                    ),
                    m.rendered ? y(
                      "div",
                      { staticClass: "el-dialog__body" },
                      [m._t("default")],
                      2
                    ) : m._e(),
                    m.$slots.footer ? y(
                      "div",
                      { staticClass: "el-dialog__footer" },
                      [m._t("footer")],
                      2
                    ) : m._e()
                  ]
                )
              ]
            )
          ]
        );
      }, s = [];
      i._withStripped = !0;
      var o = r(13), a = /* @__PURE__ */ r.n(o), l = r(11), u = /* @__PURE__ */ r.n(l), c = r(4), f = /* @__PURE__ */ r.n(c), p = {
        name: "ElDialog",
        mixins: [a.a, f.a, u.a],
        props: {
          title: {
            type: String,
            default: ""
          },
          modal: {
            type: Boolean,
            default: !0
          },
          modalAppendToBody: {
            type: Boolean,
            default: !0
          },
          appendToBody: {
            type: Boolean,
            default: !1
          },
          lockScroll: {
            type: Boolean,
            default: !0
          },
          closeOnClickModal: {
            type: Boolean,
            default: !0
          },
          closeOnPressEscape: {
            type: Boolean,
            default: !0
          },
          showClose: {
            type: Boolean,
            default: !0
          },
          width: String,
          fullscreen: Boolean,
          customClass: {
            type: String,
            default: ""
          },
          top: {
            type: String,
            default: "15vh"
          },
          beforeClose: Function,
          center: {
            type: Boolean,
            default: !1
          },
          destroyOnClose: Boolean
        },
        data: function() {
          return {
            closed: !1,
            key: 0
          };
        },
        watch: {
          visible: function(_) {
            var y = this;
            _ ? (this.closed = !1, this.$emit("open"), this.$el.addEventListener("scroll", this.updatePopper), this.$nextTick(function() {
              y.$refs.dialog.scrollTop = 0;
            }), this.appendToBody && document.body.appendChild(this.$el)) : (this.$el.removeEventListener("scroll", this.updatePopper), this.closed || this.$emit("close"), this.destroyOnClose && this.$nextTick(function() {
              y.key++;
            }));
          }
        },
        computed: {
          style: function() {
            var _ = {};
            return this.fullscreen || (_.marginTop = this.top, this.width && (_.width = this.width)), _;
          }
        },
        methods: {
          getMigratingConfig: function() {
            return {
              props: {
                size: "size is removed."
              }
            };
          },
          handleWrapperClick: function() {
            !this.closeOnClickModal || this.handleClose();
          },
          handleClose: function() {
            typeof this.beforeClose == "function" ? this.beforeClose(this.hide) : this.hide();
          },
          hide: function(_) {
            _ !== !1 && (this.$emit("update:visible", !1), this.$emit("close"), this.closed = !0);
          },
          updatePopper: function() {
            this.broadcast("ElSelectDropdown", "updatePopper"), this.broadcast("ElDropdownMenu", "updatePopper");
          },
          afterEnter: function() {
            this.$emit("opened");
          },
          afterLeave: function() {
            this.$emit("closed");
          }
        },
        mounted: function() {
          this.visible && (this.rendered = !0, this.open(), this.appendToBody && document.body.appendChild(this.$el));
        },
        destroyed: function() {
          this.appendToBody && this.$el && this.$el.parentNode && this.$el.parentNode.removeChild(this.$el);
        }
      }, d = p, h = r(0), v = Object(h.a)(
        d,
        i,
        s,
        !1,
        null,
        null,
        null
      );
      v.options.__file = "packages/dialog/src/component.vue";
      var g = v.exports;
      g.install = function(m) {
        m.component(g.name, g);
      }, t.default = g;
    }
  });
})(Yy);
const Kr = /* @__PURE__ */ ot(Yy.exports);
const vC = Ce({
  name: "TSpin",
  props: {
    size: { type: String, default: "md" }
  }
});
var yC = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("i", { staticClass: "t-spin", class: {
    "t-spin--sm": e.size === "sm",
    "t-spin--md": e.size === "md",
    "t-spin--lg": e.size === "lg"
  } });
}, bC = [], wC = /* @__PURE__ */ le(
  vC,
  yC,
  bC,
  !1,
  null,
  null,
  null,
  null
);
const _C = wC.exports;
const SC = Ce({
  components: { TSpin: _C },
  props: {
    tag: { type: String, default: "button" },
    size: { type: String, default: "md" },
    theme: { type: String, default: "solid" },
    color: { type: String, default: "" },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    block: { type: Boolean, default: !1 },
    icon: { type: Boolean, default: !1 }
  }
});
var xC = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t(e.tag, e._g(e._b({ tag: "component", staticClass: "t-button", class: {
    "t-button--icon": e.icon,
    "t-button--block": e.block,
    "t-button--loading": e.loading,
    "t-button--disabled": e.disabled,
    "t-button--sm": e.size === "sm",
    "t-button--md": e.size === "md",
    "t-button--lg": e.size === "lg",
    "t-button--light": e.theme === "light",
    "t-button--solid": e.theme === "solid",
    "t-button--ghost": e.theme === "ghost",
    "t-button--primary": e.color === "primary",
    "t-button--secondary": e.color === "secondary",
    "t-button--info": e.color === "info",
    "t-button--success": e.color === "success",
    "t-button--warning": e.color === "warning",
    "t-button--danger": e.color === "danger"
  }, attrs: { disabled: e.disabled, readonly: e.readonly } }, "component", e.$attrs, !1), e.$listeners), [e.icon ? [e.loading ? t("t-spin", { attrs: { size: "sm" } }) : e._t("default")] : [e.$scopedSlots.prefix ? t("span", { staticClass: "t-button__prefix" }, [e.loading ? t("t-spin", { attrs: { size: "sm" } }) : e._t("prefix")], 2) : e._e(), e._t("default"), e.$scopedSlots.suffix ? t("span", { staticClass: "t-button__suffix" }, [e.loading ? t("t-spin", { attrs: { size: "sm" } }) : e._t("suffix")], 2) : e._e(), !e.$scopedSlots.prefix && !e.$scopedSlots.suffix && e.loading ? t("span", { staticClass: "t-button__suffix" }, [t("t-spin", { attrs: { size: "sm" } })], 1) : e._e()]], 2);
}, CC = [], OC = /* @__PURE__ */ le(
  SC,
  xC,
  CC,
  !1,
  null,
  null,
  null,
  null
);
const $l = OC.exports;
function nm(n) {
  return n !== null && typeof n == "object" && "constructor" in n && n.constructor === Object;
}
function Kf(n = {}, e = {}) {
  Object.keys(e).forEach((t) => {
    typeof n[t] > "u" ? n[t] = e[t] : nm(e[t]) && nm(n[t]) && Object.keys(e[t]).length > 0 && Kf(n[t], e[t]);
  });
}
const Qy = {
  body: {},
  addEventListener() {
  },
  removeEventListener() {
  },
  activeElement: {
    blur() {
    },
    nodeName: ""
  },
  querySelector() {
    return null;
  },
  querySelectorAll() {
    return [];
  },
  getElementById() {
    return null;
  },
  createEvent() {
    return {
      initEvent() {
      }
    };
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {
      },
      getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS() {
    return {};
  },
  importNode() {
    return null;
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  }
};
function Rt() {
  const n = typeof document < "u" ? document : {};
  return Kf(n, Qy), n;
}
const EC = {
  document: Qy,
  navigator: {
    userAgent: ""
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  },
  history: {
    replaceState() {
    },
    pushState() {
    },
    go() {
    },
    back() {
    }
  },
  CustomEvent: function() {
    return this;
  },
  addEventListener() {
  },
  removeEventListener() {
  },
  getComputedStyle() {
    return {
      getPropertyValue() {
        return "";
      }
    };
  },
  Image() {
  },
  Date() {
  },
  screen: {},
  setTimeout() {
  },
  clearTimeout() {
  },
  matchMedia() {
    return {};
  },
  requestAnimationFrame(n) {
    return typeof setTimeout > "u" ? (n(), null) : setTimeout(n, 0);
  },
  cancelAnimationFrame(n) {
    typeof setTimeout > "u" || clearTimeout(n);
  }
};
function Ke() {
  const n = typeof window < "u" ? window : {};
  return Kf(n, EC), n;
}
function TC(n) {
  const e = n.__proto__;
  Object.defineProperty(n, "__proto__", {
    get() {
      return e;
    },
    set(t) {
      e.__proto__ = t;
    }
  });
}
class Xn extends Array {
  constructor(e) {
    typeof e == "number" ? super(e) : (super(...e || []), TC(this));
  }
}
function Js(n = []) {
  const e = [];
  return n.forEach((t) => {
    Array.isArray(t) ? e.push(...Js(t)) : e.push(t);
  }), e;
}
function Zy(n, e) {
  return Array.prototype.filter.call(n, e);
}
function kC(n) {
  const e = [];
  for (let t = 0; t < n.length; t += 1)
    e.indexOf(n[t]) === -1 && e.push(n[t]);
  return e;
}
function MC(n, e) {
  if (typeof n != "string")
    return [n];
  const t = [], r = e.querySelectorAll(n);
  for (let i = 0; i < r.length; i += 1)
    t.push(r[i]);
  return t;
}
function ee(n, e) {
  const t = Ke(), r = Rt();
  let i = [];
  if (!e && n instanceof Xn)
    return n;
  if (!n)
    return new Xn(i);
  if (typeof n == "string") {
    const s = n.trim();
    if (s.indexOf("<") >= 0 && s.indexOf(">") >= 0) {
      let o = "div";
      s.indexOf("<li") === 0 && (o = "ul"), s.indexOf("<tr") === 0 && (o = "tbody"), (s.indexOf("<td") === 0 || s.indexOf("<th") === 0) && (o = "tr"), s.indexOf("<tbody") === 0 && (o = "table"), s.indexOf("<option") === 0 && (o = "select");
      const a = r.createElement(o);
      a.innerHTML = s;
      for (let l = 0; l < a.childNodes.length; l += 1)
        i.push(a.childNodes[l]);
    } else
      i = MC(n.trim(), e || r);
  } else if (n.nodeType || n === t || n === r)
    i.push(n);
  else if (Array.isArray(n)) {
    if (n instanceof Xn)
      return n;
    i = n;
  }
  return new Xn(kC(i));
}
ee.fn = Xn.prototype;
function AC(...n) {
  const e = Js(n.map((t) => t.split(" ")));
  return this.forEach((t) => {
    t.classList.add(...e);
  }), this;
}
function PC(...n) {
  const e = Js(n.map((t) => t.split(" ")));
  return this.forEach((t) => {
    t.classList.remove(...e);
  }), this;
}
function $C(...n) {
  const e = Js(n.map((t) => t.split(" ")));
  this.forEach((t) => {
    e.forEach((r) => {
      t.classList.toggle(r);
    });
  });
}
function DC(...n) {
  const e = Js(n.map((t) => t.split(" ")));
  return Zy(this, (t) => e.filter((r) => t.classList.contains(r)).length > 0).length > 0;
}
function LC(n, e) {
  if (arguments.length === 1 && typeof n == "string")
    return this[0] ? this[0].getAttribute(n) : void 0;
  for (let t = 0; t < this.length; t += 1)
    if (arguments.length === 2)
      this[t].setAttribute(n, e);
    else
      for (const r in n)
        this[t][r] = n[r], this[t].setAttribute(r, n[r]);
  return this;
}
function NC(n) {
  for (let e = 0; e < this.length; e += 1)
    this[e].removeAttribute(n);
  return this;
}
function IC(n) {
  for (let e = 0; e < this.length; e += 1)
    this[e].style.transform = n;
  return this;
}
function RC(n) {
  for (let e = 0; e < this.length; e += 1)
    this[e].style.transitionDuration = typeof n != "string" ? `${n}ms` : n;
  return this;
}
function FC(...n) {
  let [e, t, r, i] = n;
  typeof n[1] == "function" && ([e, r, i] = n, t = void 0), i || (i = !1);
  function s(u) {
    const c = u.target;
    if (!c)
      return;
    const f = u.target.dom7EventData || [];
    if (f.indexOf(u) < 0 && f.unshift(u), ee(c).is(t))
      r.apply(c, f);
    else {
      const p = ee(c).parents();
      for (let d = 0; d < p.length; d += 1)
        ee(p[d]).is(t) && r.apply(p[d], f);
    }
  }
  function o(u) {
    const c = u && u.target ? u.target.dom7EventData || [] : [];
    c.indexOf(u) < 0 && c.unshift(u), r.apply(this, c);
  }
  const a = e.split(" ");
  let l;
  for (let u = 0; u < this.length; u += 1) {
    const c = this[u];
    if (t)
      for (l = 0; l < a.length; l += 1) {
        const f = a[l];
        c.dom7LiveListeners || (c.dom7LiveListeners = {}), c.dom7LiveListeners[f] || (c.dom7LiveListeners[f] = []), c.dom7LiveListeners[f].push({
          listener: r,
          proxyListener: s
        }), c.addEventListener(f, s, i);
      }
    else
      for (l = 0; l < a.length; l += 1) {
        const f = a[l];
        c.dom7Listeners || (c.dom7Listeners = {}), c.dom7Listeners[f] || (c.dom7Listeners[f] = []), c.dom7Listeners[f].push({
          listener: r,
          proxyListener: o
        }), c.addEventListener(f, o, i);
      }
  }
  return this;
}
function zC(...n) {
  let [e, t, r, i] = n;
  typeof n[1] == "function" && ([e, r, i] = n, t = void 0), i || (i = !1);
  const s = e.split(" ");
  for (let o = 0; o < s.length; o += 1) {
    const a = s[o];
    for (let l = 0; l < this.length; l += 1) {
      const u = this[l];
      let c;
      if (!t && u.dom7Listeners ? c = u.dom7Listeners[a] : t && u.dom7LiveListeners && (c = u.dom7LiveListeners[a]), c && c.length)
        for (let f = c.length - 1; f >= 0; f -= 1) {
          const p = c[f];
          r && p.listener === r || r && p.listener && p.listener.dom7proxy && p.listener.dom7proxy === r ? (u.removeEventListener(a, p.proxyListener, i), c.splice(f, 1)) : r || (u.removeEventListener(a, p.proxyListener, i), c.splice(f, 1));
        }
    }
  }
  return this;
}
function BC(...n) {
  const e = Ke(), t = n[0].split(" "), r = n[1];
  for (let i = 0; i < t.length; i += 1) {
    const s = t[i];
    for (let o = 0; o < this.length; o += 1) {
      const a = this[o];
      if (e.CustomEvent) {
        const l = new e.CustomEvent(s, {
          detail: r,
          bubbles: !0,
          cancelable: !0
        });
        a.dom7EventData = n.filter((u, c) => c > 0), a.dispatchEvent(l), a.dom7EventData = [], delete a.dom7EventData;
      }
    }
  }
  return this;
}
function jC(n) {
  const e = this;
  function t(r) {
    r.target === this && (n.call(this, r), e.off("transitionend", t));
  }
  return n && e.on("transitionend", t), this;
}
function VC(n) {
  if (this.length > 0) {
    if (n) {
      const e = this.styles();
      return this[0].offsetWidth + parseFloat(e.getPropertyValue("margin-right")) + parseFloat(e.getPropertyValue("margin-left"));
    }
    return this[0].offsetWidth;
  }
  return null;
}
function HC(n) {
  if (this.length > 0) {
    if (n) {
      const e = this.styles();
      return this[0].offsetHeight + parseFloat(e.getPropertyValue("margin-top")) + parseFloat(e.getPropertyValue("margin-bottom"));
    }
    return this[0].offsetHeight;
  }
  return null;
}
function WC() {
  if (this.length > 0) {
    const n = Ke(), e = Rt(), t = this[0], r = t.getBoundingClientRect(), i = e.body, s = t.clientTop || i.clientTop || 0, o = t.clientLeft || i.clientLeft || 0, a = t === n ? n.scrollY : t.scrollTop, l = t === n ? n.scrollX : t.scrollLeft;
    return {
      top: r.top + a - s,
      left: r.left + l - o
    };
  }
  return null;
}
function qC() {
  const n = Ke();
  return this[0] ? n.getComputedStyle(this[0], null) : {};
}
function UC(n, e) {
  const t = Ke();
  let r;
  if (arguments.length === 1)
    if (typeof n == "string") {
      if (this[0])
        return t.getComputedStyle(this[0], null).getPropertyValue(n);
    } else {
      for (r = 0; r < this.length; r += 1)
        for (const i in n)
          this[r].style[i] = n[i];
      return this;
    }
  if (arguments.length === 2 && typeof n == "string") {
    for (r = 0; r < this.length; r += 1)
      this[r].style[n] = e;
    return this;
  }
  return this;
}
function GC(n) {
  return n ? (this.forEach((e, t) => {
    n.apply(e, [e, t]);
  }), this) : this;
}
function KC(n) {
  const e = Zy(this, n);
  return ee(e);
}
function JC(n) {
  if (typeof n > "u")
    return this[0] ? this[0].innerHTML : null;
  for (let e = 0; e < this.length; e += 1)
    this[e].innerHTML = n;
  return this;
}
function XC(n) {
  if (typeof n > "u")
    return this[0] ? this[0].textContent.trim() : null;
  for (let e = 0; e < this.length; e += 1)
    this[e].textContent = n;
  return this;
}
function YC(n) {
  const e = Ke(), t = Rt(), r = this[0];
  let i, s;
  if (!r || typeof n > "u")
    return !1;
  if (typeof n == "string") {
    if (r.matches)
      return r.matches(n);
    if (r.webkitMatchesSelector)
      return r.webkitMatchesSelector(n);
    if (r.msMatchesSelector)
      return r.msMatchesSelector(n);
    for (i = ee(n), s = 0; s < i.length; s += 1)
      if (i[s] === r)
        return !0;
    return !1;
  }
  if (n === t)
    return r === t;
  if (n === e)
    return r === e;
  if (n.nodeType || n instanceof Xn) {
    for (i = n.nodeType ? [n] : n, s = 0; s < i.length; s += 1)
      if (i[s] === r)
        return !0;
    return !1;
  }
  return !1;
}
function QC() {
  let n = this[0], e;
  if (n) {
    for (e = 0; (n = n.previousSibling) !== null; )
      n.nodeType === 1 && (e += 1);
    return e;
  }
}
function ZC(n) {
  if (typeof n > "u")
    return this;
  const e = this.length;
  if (n > e - 1)
    return ee([]);
  if (n < 0) {
    const t = e + n;
    return t < 0 ? ee([]) : ee([this[t]]);
  }
  return ee([this[n]]);
}
function eO(...n) {
  let e;
  const t = Rt();
  for (let r = 0; r < n.length; r += 1) {
    e = n[r];
    for (let i = 0; i < this.length; i += 1)
      if (typeof e == "string") {
        const s = t.createElement("div");
        for (s.innerHTML = e; s.firstChild; )
          this[i].appendChild(s.firstChild);
      } else if (e instanceof Xn)
        for (let s = 0; s < e.length; s += 1)
          this[i].appendChild(e[s]);
      else
        this[i].appendChild(e);
  }
  return this;
}
function tO(n) {
  const e = Rt();
  let t, r;
  for (t = 0; t < this.length; t += 1)
    if (typeof n == "string") {
      const i = e.createElement("div");
      for (i.innerHTML = n, r = i.childNodes.length - 1; r >= 0; r -= 1)
        this[t].insertBefore(i.childNodes[r], this[t].childNodes[0]);
    } else if (n instanceof Xn)
      for (r = 0; r < n.length; r += 1)
        this[t].insertBefore(n[r], this[t].childNodes[0]);
    else
      this[t].insertBefore(n, this[t].childNodes[0]);
  return this;
}
function nO(n) {
  return this.length > 0 ? n ? this[0].nextElementSibling && ee(this[0].nextElementSibling).is(n) ? ee([this[0].nextElementSibling]) : ee([]) : this[0].nextElementSibling ? ee([this[0].nextElementSibling]) : ee([]) : ee([]);
}
function rO(n) {
  const e = [];
  let t = this[0];
  if (!t)
    return ee([]);
  for (; t.nextElementSibling; ) {
    const r = t.nextElementSibling;
    n ? ee(r).is(n) && e.push(r) : e.push(r), t = r;
  }
  return ee(e);
}
function iO(n) {
  if (this.length > 0) {
    const e = this[0];
    return n ? e.previousElementSibling && ee(e.previousElementSibling).is(n) ? ee([e.previousElementSibling]) : ee([]) : e.previousElementSibling ? ee([e.previousElementSibling]) : ee([]);
  }
  return ee([]);
}
function sO(n) {
  const e = [];
  let t = this[0];
  if (!t)
    return ee([]);
  for (; t.previousElementSibling; ) {
    const r = t.previousElementSibling;
    n ? ee(r).is(n) && e.push(r) : e.push(r), t = r;
  }
  return ee(e);
}
function oO(n) {
  const e = [];
  for (let t = 0; t < this.length; t += 1)
    this[t].parentNode !== null && (n ? ee(this[t].parentNode).is(n) && e.push(this[t].parentNode) : e.push(this[t].parentNode));
  return ee(e);
}
function aO(n) {
  const e = [];
  for (let t = 0; t < this.length; t += 1) {
    let r = this[t].parentNode;
    for (; r; )
      n ? ee(r).is(n) && e.push(r) : e.push(r), r = r.parentNode;
  }
  return ee(e);
}
function lO(n) {
  let e = this;
  return typeof n > "u" ? ee([]) : (e.is(n) || (e = e.parents(n).eq(0)), e);
}
function uO(n) {
  const e = [];
  for (let t = 0; t < this.length; t += 1) {
    const r = this[t].querySelectorAll(n);
    for (let i = 0; i < r.length; i += 1)
      e.push(r[i]);
  }
  return ee(e);
}
function cO(n) {
  const e = [];
  for (let t = 0; t < this.length; t += 1) {
    const r = this[t].children;
    for (let i = 0; i < r.length; i += 1)
      (!n || ee(r[i]).is(n)) && e.push(r[i]);
  }
  return ee(e);
}
function dO() {
  for (let n = 0; n < this.length; n += 1)
    this[n].parentNode && this[n].parentNode.removeChild(this[n]);
  return this;
}
const rm = {
  addClass: AC,
  removeClass: PC,
  hasClass: DC,
  toggleClass: $C,
  attr: LC,
  removeAttr: NC,
  transform: IC,
  transition: RC,
  on: FC,
  off: zC,
  trigger: BC,
  transitionEnd: jC,
  outerWidth: VC,
  outerHeight: HC,
  styles: qC,
  offset: WC,
  css: UC,
  each: GC,
  html: JC,
  text: XC,
  is: YC,
  index: QC,
  eq: ZC,
  append: eO,
  prepend: tO,
  next: nO,
  nextAll: rO,
  prev: iO,
  prevAll: sO,
  parent: oO,
  parents: aO,
  closest: lO,
  find: uO,
  children: cO,
  filter: KC,
  remove: dO
};
Object.keys(rm).forEach((n) => {
  Object.defineProperty(ee.fn, n, {
    value: rm[n],
    writable: !0
  });
});
function fO(n) {
  const e = n;
  Object.keys(e).forEach((t) => {
    try {
      e[t] = null;
    } catch {
    }
    try {
      delete e[t];
    } catch {
    }
  });
}
function kd(n, e = 0) {
  return setTimeout(n, e);
}
function ks() {
  return Date.now();
}
function pO(n) {
  const e = Ke();
  let t;
  return e.getComputedStyle && (t = e.getComputedStyle(n, null)), !t && n.currentStyle && (t = n.currentStyle), t || (t = n.style), t;
}
function hO(n, e = "x") {
  const t = Ke();
  let r, i, s;
  const o = pO(n);
  return t.WebKitCSSMatrix ? (i = o.transform || o.webkitTransform, i.split(",").length > 6 && (i = i.split(", ").map((a) => a.replace(",", ".")).join(", ")), s = new t.WebKitCSSMatrix(i === "none" ? "" : i)) : (s = o.MozTransform || o.OTransform || o.MsTransform || o.msTransform || o.transform || o.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), r = s.toString().split(",")), e === "x" && (t.WebKitCSSMatrix ? i = s.m41 : r.length === 16 ? i = parseFloat(r[12]) : i = parseFloat(r[4])), e === "y" && (t.WebKitCSSMatrix ? i = s.m42 : r.length === 16 ? i = parseFloat(r[13]) : i = parseFloat(r[5])), i || 0;
}
function So(n) {
  return typeof n == "object" && n !== null && n.constructor && Object.prototype.toString.call(n).slice(8, -1) === "Object";
}
function mO(n) {
  return typeof window < "u" && typeof window.HTMLElement < "u" ? n instanceof HTMLElement : n && (n.nodeType === 1 || n.nodeType === 11);
}
function kt(...n) {
  const e = Object(n[0]), t = ["__proto__", "constructor", "prototype"];
  for (let r = 1; r < n.length; r += 1) {
    const i = n[r];
    if (i != null && !mO(i)) {
      const s = Object.keys(Object(i)).filter((o) => t.indexOf(o) < 0);
      for (let o = 0, a = s.length; o < a; o += 1) {
        const l = s[o], u = Object.getOwnPropertyDescriptor(i, l);
        u !== void 0 && u.enumerable && (So(e[l]) && So(i[l]) ? i[l].__swiper__ ? e[l] = i[l] : kt(e[l], i[l]) : !So(e[l]) && So(i[l]) ? (e[l] = {}, i[l].__swiper__ ? e[l] = i[l] : kt(e[l], i[l])) : e[l] = i[l]);
      }
    }
  }
  return e;
}
function xo(n, e, t) {
  n.style.setProperty(e, t);
}
function eb({
  swiper: n,
  targetPosition: e,
  side: t
}) {
  const r = Ke(), i = -n.translate;
  let s = null, o;
  const a = n.params.speed;
  n.wrapperEl.style.scrollSnapType = "none", r.cancelAnimationFrame(n.cssModeFrameID);
  const l = e > i ? "next" : "prev", u = (f, p) => l === "next" && f >= p || l === "prev" && f <= p, c = () => {
    o = new Date().getTime(), s === null && (s = o);
    const f = Math.max(Math.min((o - s) / a, 1), 0), p = 0.5 - Math.cos(f * Math.PI) / 2;
    let d = i + p * (e - i);
    if (u(d, e) && (d = e), n.wrapperEl.scrollTo({
      [t]: d
    }), u(d, e)) {
      n.wrapperEl.style.overflow = "hidden", n.wrapperEl.style.scrollSnapType = "", setTimeout(() => {
        n.wrapperEl.style.overflow = "", n.wrapperEl.scrollTo({
          [t]: d
        });
      }), r.cancelAnimationFrame(n.cssModeFrameID);
      return;
    }
    n.cssModeFrameID = r.requestAnimationFrame(c);
  };
  c();
}
let dc;
function gO() {
  const n = Ke(), e = Rt();
  return {
    smoothScroll: e.documentElement && "scrollBehavior" in e.documentElement.style,
    touch: !!("ontouchstart" in n || n.DocumentTouch && e instanceof n.DocumentTouch),
    passiveListener: function() {
      let r = !1;
      try {
        const i = Object.defineProperty({}, "passive", {
          get() {
            r = !0;
          }
        });
        n.addEventListener("testPassiveListener", null, i);
      } catch {
      }
      return r;
    }(),
    gestures: function() {
      return "ongesturestart" in n;
    }()
  };
}
function tb() {
  return dc || (dc = gO()), dc;
}
let fc;
function vO({
  userAgent: n
} = {}) {
  const e = tb(), t = Ke(), r = t.navigator.platform, i = n || t.navigator.userAgent, s = {
    ios: !1,
    android: !1
  }, o = t.screen.width, a = t.screen.height, l = i.match(/(Android);?[\s\/]+([\d.]+)?/);
  let u = i.match(/(iPad).*OS\s([\d_]+)/);
  const c = i.match(/(iPod)(.*OS\s([\d_]+))?/), f = !u && i.match(/(iPhone\sOS|iOS)\s([\d_]+)/), p = r === "Win32";
  let d = r === "MacIntel";
  const h = ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"];
  return !u && d && e.touch && h.indexOf(`${o}x${a}`) >= 0 && (u = i.match(/(Version)\/([\d.]+)/), u || (u = [0, 1, "13_0_0"]), d = !1), l && !p && (s.os = "android", s.android = !0), (u || f || c) && (s.os = "ios", s.ios = !0), s;
}
function yO(n = {}) {
  return fc || (fc = vO(n)), fc;
}
let pc;
function bO() {
  const n = Ke();
  function e() {
    const t = n.navigator.userAgent.toLowerCase();
    return t.indexOf("safari") >= 0 && t.indexOf("chrome") < 0 && t.indexOf("android") < 0;
  }
  return {
    isSafari: e(),
    isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(n.navigator.userAgent)
  };
}
function wO() {
  return pc || (pc = bO()), pc;
}
function _O({
  swiper: n,
  on: e,
  emit: t
}) {
  const r = Ke();
  let i = null, s = null;
  const o = () => {
    !n || n.destroyed || !n.initialized || (t("beforeResize"), t("resize"));
  }, a = () => {
    !n || n.destroyed || !n.initialized || (i = new ResizeObserver((c) => {
      s = r.requestAnimationFrame(() => {
        const {
          width: f,
          height: p
        } = n;
        let d = f, h = p;
        c.forEach(({
          contentBoxSize: v,
          contentRect: g,
          target: m
        }) => {
          m && m !== n.el || (d = g ? g.width : (v[0] || v).inlineSize, h = g ? g.height : (v[0] || v).blockSize);
        }), (d !== f || h !== p) && o();
      });
    }), i.observe(n.el));
  }, l = () => {
    s && r.cancelAnimationFrame(s), i && i.unobserve && n.el && (i.unobserve(n.el), i = null);
  }, u = () => {
    !n || n.destroyed || !n.initialized || t("orientationchange");
  };
  e("init", () => {
    if (n.params.resizeObserver && typeof r.ResizeObserver < "u") {
      a();
      return;
    }
    r.addEventListener("resize", o), r.addEventListener("orientationchange", u);
  }), e("destroy", () => {
    l(), r.removeEventListener("resize", o), r.removeEventListener("orientationchange", u);
  });
}
function SO({
  swiper: n,
  extendParams: e,
  on: t,
  emit: r
}) {
  const i = [], s = Ke(), o = (u, c = {}) => {
    const f = s.MutationObserver || s.WebkitMutationObserver, p = new f((d) => {
      if (d.length === 1) {
        r("observerUpdate", d[0]);
        return;
      }
      const h = function() {
        r("observerUpdate", d[0]);
      };
      s.requestAnimationFrame ? s.requestAnimationFrame(h) : s.setTimeout(h, 0);
    });
    p.observe(u, {
      attributes: typeof c.attributes > "u" ? !0 : c.attributes,
      childList: typeof c.childList > "u" ? !0 : c.childList,
      characterData: typeof c.characterData > "u" ? !0 : c.characterData
    }), i.push(p);
  }, a = () => {
    if (!!n.params.observer) {
      if (n.params.observeParents) {
        const u = n.$el.parents();
        for (let c = 0; c < u.length; c += 1)
          o(u[c]);
      }
      o(n.$el[0], {
        childList: n.params.observeSlideChildren
      }), o(n.$wrapperEl[0], {
        attributes: !1
      });
    }
  }, l = () => {
    i.forEach((u) => {
      u.disconnect();
    }), i.splice(0, i.length);
  };
  e({
    observer: !1,
    observeParents: !1,
    observeSlideChildren: !1
  }), t("init", a), t("destroy", l);
}
const xO = {
  on(n, e, t) {
    const r = this;
    if (!r.eventsListeners || r.destroyed || typeof e != "function")
      return r;
    const i = t ? "unshift" : "push";
    return n.split(" ").forEach((s) => {
      r.eventsListeners[s] || (r.eventsListeners[s] = []), r.eventsListeners[s][i](e);
    }), r;
  },
  once(n, e, t) {
    const r = this;
    if (!r.eventsListeners || r.destroyed || typeof e != "function")
      return r;
    function i(...s) {
      r.off(n, i), i.__emitterProxy && delete i.__emitterProxy, e.apply(r, s);
    }
    return i.__emitterProxy = e, r.on(n, i, t);
  },
  onAny(n, e) {
    const t = this;
    if (!t.eventsListeners || t.destroyed || typeof n != "function")
      return t;
    const r = e ? "unshift" : "push";
    return t.eventsAnyListeners.indexOf(n) < 0 && t.eventsAnyListeners[r](n), t;
  },
  offAny(n) {
    const e = this;
    if (!e.eventsListeners || e.destroyed || !e.eventsAnyListeners)
      return e;
    const t = e.eventsAnyListeners.indexOf(n);
    return t >= 0 && e.eventsAnyListeners.splice(t, 1), e;
  },
  off(n, e) {
    const t = this;
    return !t.eventsListeners || t.destroyed || !t.eventsListeners || n.split(" ").forEach((r) => {
      typeof e > "u" ? t.eventsListeners[r] = [] : t.eventsListeners[r] && t.eventsListeners[r].forEach((i, s) => {
        (i === e || i.__emitterProxy && i.__emitterProxy === e) && t.eventsListeners[r].splice(s, 1);
      });
    }), t;
  },
  emit(...n) {
    const e = this;
    if (!e.eventsListeners || e.destroyed || !e.eventsListeners)
      return e;
    let t, r, i;
    return typeof n[0] == "string" || Array.isArray(n[0]) ? (t = n[0], r = n.slice(1, n.length), i = e) : (t = n[0].events, r = n[0].data, i = n[0].context || e), r.unshift(i), (Array.isArray(t) ? t : t.split(" ")).forEach((o) => {
      e.eventsAnyListeners && e.eventsAnyListeners.length && e.eventsAnyListeners.forEach((a) => {
        a.apply(i, [o, ...r]);
      }), e.eventsListeners && e.eventsListeners[o] && e.eventsListeners[o].forEach((a) => {
        a.apply(i, r);
      });
    }), e;
  }
};
function CO() {
  const n = this;
  let e, t;
  const r = n.$el;
  typeof n.params.width < "u" && n.params.width !== null ? e = n.params.width : e = r[0].clientWidth, typeof n.params.height < "u" && n.params.height !== null ? t = n.params.height : t = r[0].clientHeight, !(e === 0 && n.isHorizontal() || t === 0 && n.isVertical()) && (e = e - parseInt(r.css("padding-left") || 0, 10) - parseInt(r.css("padding-right") || 0, 10), t = t - parseInt(r.css("padding-top") || 0, 10) - parseInt(r.css("padding-bottom") || 0, 10), Number.isNaN(e) && (e = 0), Number.isNaN(t) && (t = 0), Object.assign(n, {
    width: e,
    height: t,
    size: n.isHorizontal() ? e : t
  }));
}
function OO() {
  const n = this;
  function e(E) {
    return n.isHorizontal() ? E : {
      width: "height",
      "margin-top": "margin-left",
      "margin-bottom ": "margin-right",
      "margin-left": "margin-top",
      "margin-right": "margin-bottom",
      "padding-left": "padding-top",
      "padding-right": "padding-bottom",
      marginRight: "marginBottom"
    }[E];
  }
  function t(E, M) {
    return parseFloat(E.getPropertyValue(e(M)) || 0);
  }
  const r = n.params, {
    $wrapperEl: i,
    size: s,
    rtlTranslate: o,
    wrongRTL: a
  } = n, l = n.virtual && r.virtual.enabled, u = l ? n.virtual.slides.length : n.slides.length, c = i.children(`.${n.params.slideClass}`), f = l ? n.virtual.slides.length : c.length;
  let p = [];
  const d = [], h = [];
  let v = r.slidesOffsetBefore;
  typeof v == "function" && (v = r.slidesOffsetBefore.call(n));
  let g = r.slidesOffsetAfter;
  typeof g == "function" && (g = r.slidesOffsetAfter.call(n));
  const m = n.snapGrid.length, _ = n.slidesGrid.length;
  let y = r.spaceBetween, w = -v, O = 0, C = 0;
  if (typeof s > "u")
    return;
  typeof y == "string" && y.indexOf("%") >= 0 && (y = parseFloat(y.replace("%", "")) / 100 * s), n.virtualSize = -y, o ? c.css({
    marginLeft: "",
    marginBottom: "",
    marginTop: ""
  }) : c.css({
    marginRight: "",
    marginBottom: "",
    marginTop: ""
  }), r.centeredSlides && r.cssMode && (xo(n.wrapperEl, "--swiper-centered-offset-before", ""), xo(n.wrapperEl, "--swiper-centered-offset-after", ""));
  const S = r.grid && r.grid.rows > 1 && n.grid;
  S && n.grid.initSlides(f);
  let b;
  const x = r.slidesPerView === "auto" && r.breakpoints && Object.keys(r.breakpoints).filter((E) => typeof r.breakpoints[E].slidesPerView < "u").length > 0;
  for (let E = 0; E < f; E += 1) {
    b = 0;
    const M = c.eq(E);
    if (S && n.grid.updateSlide(E, M, f, e), M.css("display") !== "none") {
      if (r.slidesPerView === "auto") {
        x && (c[E].style[e("width")] = "");
        const $ = getComputedStyle(M[0]), F = M[0].style.transform, J = M[0].style.webkitTransform;
        if (F && (M[0].style.transform = "none"), J && (M[0].style.webkitTransform = "none"), r.roundLengths)
          b = n.isHorizontal() ? M.outerWidth(!0) : M.outerHeight(!0);
        else {
          const W = t($, "width"), H = t($, "padding-left"), Y = t($, "padding-right"), z = t($, "margin-left"), j = t($, "margin-right"), Q = $.getPropertyValue("box-sizing");
          if (Q && Q === "border-box")
            b = W + z + j;
          else {
            const {
              clientWidth: fe,
              offsetWidth: ue
            } = M[0];
            b = W + H + Y + z + j + (ue - fe);
          }
        }
        F && (M[0].style.transform = F), J && (M[0].style.webkitTransform = J), r.roundLengths && (b = Math.floor(b));
      } else
        b = (s - (r.slidesPerView - 1) * y) / r.slidesPerView, r.roundLengths && (b = Math.floor(b)), c[E] && (c[E].style[e("width")] = `${b}px`);
      c[E] && (c[E].swiperSlideSize = b), h.push(b), r.centeredSlides ? (w = w + b / 2 + O / 2 + y, O === 0 && E !== 0 && (w = w - s / 2 - y), E === 0 && (w = w - s / 2 - y), Math.abs(w) < 1 / 1e3 && (w = 0), r.roundLengths && (w = Math.floor(w)), C % r.slidesPerGroup === 0 && p.push(w), d.push(w)) : (r.roundLengths && (w = Math.floor(w)), (C - Math.min(n.params.slidesPerGroupSkip, C)) % n.params.slidesPerGroup === 0 && p.push(w), d.push(w), w = w + b + y), n.virtualSize += b + y, O = b, C += 1;
    }
  }
  if (n.virtualSize = Math.max(n.virtualSize, s) + g, o && a && (r.effect === "slide" || r.effect === "coverflow") && i.css({
    width: `${n.virtualSize + r.spaceBetween}px`
  }), r.setWrapperSize && i.css({
    [e("width")]: `${n.virtualSize + r.spaceBetween}px`
  }), S && n.grid.updateWrapperSize(b, p, e), !r.centeredSlides) {
    const E = [];
    for (let M = 0; M < p.length; M += 1) {
      let $ = p[M];
      r.roundLengths && ($ = Math.floor($)), p[M] <= n.virtualSize - s && E.push($);
    }
    p = E, Math.floor(n.virtualSize - s) - Math.floor(p[p.length - 1]) > 1 && p.push(n.virtualSize - s);
  }
  if (p.length === 0 && (p = [0]), r.spaceBetween !== 0) {
    const E = n.isHorizontal() && o ? "marginLeft" : e("marginRight");
    c.filter((M, $) => r.cssMode ? $ !== c.length - 1 : !0).css({
      [E]: `${y}px`
    });
  }
  if (r.centeredSlides && r.centeredSlidesBounds) {
    let E = 0;
    h.forEach(($) => {
      E += $ + (r.spaceBetween ? r.spaceBetween : 0);
    }), E -= r.spaceBetween;
    const M = E - s;
    p = p.map(($) => $ < 0 ? -v : $ > M ? M + g : $);
  }
  if (r.centerInsufficientSlides) {
    let E = 0;
    if (h.forEach((M) => {
      E += M + (r.spaceBetween ? r.spaceBetween : 0);
    }), E -= r.spaceBetween, E < s) {
      const M = (s - E) / 2;
      p.forEach(($, F) => {
        p[F] = $ - M;
      }), d.forEach(($, F) => {
        d[F] = $ + M;
      });
    }
  }
  if (Object.assign(n, {
    slides: c,
    snapGrid: p,
    slidesGrid: d,
    slidesSizesGrid: h
  }), r.centeredSlides && r.cssMode && !r.centeredSlidesBounds) {
    xo(n.wrapperEl, "--swiper-centered-offset-before", `${-p[0]}px`), xo(n.wrapperEl, "--swiper-centered-offset-after", `${n.size / 2 - h[h.length - 1] / 2}px`);
    const E = -n.snapGrid[0], M = -n.slidesGrid[0];
    n.snapGrid = n.snapGrid.map(($) => $ + E), n.slidesGrid = n.slidesGrid.map(($) => $ + M);
  }
  if (f !== u && n.emit("slidesLengthChange"), p.length !== m && (n.params.watchOverflow && n.checkOverflow(), n.emit("snapGridLengthChange")), d.length !== _ && n.emit("slidesGridLengthChange"), r.watchSlidesProgress && n.updateSlidesOffset(), !l && !r.cssMode && (r.effect === "slide" || r.effect === "fade")) {
    const E = `${r.containerModifierClass}backface-hidden`, M = n.$el.hasClass(E);
    f <= r.maxBackfaceHiddenSlides ? M || n.$el.addClass(E) : M && n.$el.removeClass(E);
  }
}
function EO(n) {
  const e = this, t = [], r = e.virtual && e.params.virtual.enabled;
  let i = 0, s;
  typeof n == "number" ? e.setTransition(n) : n === !0 && e.setTransition(e.params.speed);
  const o = (a) => r ? e.slides.filter((l) => parseInt(l.getAttribute("data-swiper-slide-index"), 10) === a)[0] : e.slides.eq(a)[0];
  if (e.params.slidesPerView !== "auto" && e.params.slidesPerView > 1)
    if (e.params.centeredSlides)
      (e.visibleSlides || ee([])).each((a) => {
        t.push(a);
      });
    else
      for (s = 0; s < Math.ceil(e.params.slidesPerView); s += 1) {
        const a = e.activeIndex + s;
        if (a > e.slides.length && !r)
          break;
        t.push(o(a));
      }
  else
    t.push(o(e.activeIndex));
  for (s = 0; s < t.length; s += 1)
    if (typeof t[s] < "u") {
      const a = t[s].offsetHeight;
      i = a > i ? a : i;
    }
  (i || i === 0) && e.$wrapperEl.css("height", `${i}px`);
}
function TO() {
  const n = this, e = n.slides;
  for (let t = 0; t < e.length; t += 1)
    e[t].swiperSlideOffset = n.isHorizontal() ? e[t].offsetLeft : e[t].offsetTop;
}
function kO(n = this && this.translate || 0) {
  const e = this, t = e.params, {
    slides: r,
    rtlTranslate: i,
    snapGrid: s
  } = e;
  if (r.length === 0)
    return;
  typeof r[0].swiperSlideOffset > "u" && e.updateSlidesOffset();
  let o = -n;
  i && (o = n), r.removeClass(t.slideVisibleClass), e.visibleSlidesIndexes = [], e.visibleSlides = [];
  for (let a = 0; a < r.length; a += 1) {
    const l = r[a];
    let u = l.swiperSlideOffset;
    t.cssMode && t.centeredSlides && (u -= r[0].swiperSlideOffset);
    const c = (o + (t.centeredSlides ? e.minTranslate() : 0) - u) / (l.swiperSlideSize + t.spaceBetween), f = (o - s[0] + (t.centeredSlides ? e.minTranslate() : 0) - u) / (l.swiperSlideSize + t.spaceBetween), p = -(o - u), d = p + e.slidesSizesGrid[a];
    (p >= 0 && p < e.size - 1 || d > 1 && d <= e.size || p <= 0 && d >= e.size) && (e.visibleSlides.push(l), e.visibleSlidesIndexes.push(a), r.eq(a).addClass(t.slideVisibleClass)), l.progress = i ? -c : c, l.originalProgress = i ? -f : f;
  }
  e.visibleSlides = ee(e.visibleSlides);
}
function MO(n) {
  const e = this;
  if (typeof n > "u") {
    const u = e.rtlTranslate ? -1 : 1;
    n = e && e.translate && e.translate * u || 0;
  }
  const t = e.params, r = e.maxTranslate() - e.minTranslate();
  let {
    progress: i,
    isBeginning: s,
    isEnd: o
  } = e;
  const a = s, l = o;
  r === 0 ? (i = 0, s = !0, o = !0) : (i = (n - e.minTranslate()) / r, s = i <= 0, o = i >= 1), Object.assign(e, {
    progress: i,
    isBeginning: s,
    isEnd: o
  }), (t.watchSlidesProgress || t.centeredSlides && t.autoHeight) && e.updateSlidesProgress(n), s && !a && e.emit("reachBeginning toEdge"), o && !l && e.emit("reachEnd toEdge"), (a && !s || l && !o) && e.emit("fromEdge"), e.emit("progress", i);
}
function AO() {
  const n = this, {
    slides: e,
    params: t,
    $wrapperEl: r,
    activeIndex: i,
    realIndex: s
  } = n, o = n.virtual && t.virtual.enabled;
  e.removeClass(`${t.slideActiveClass} ${t.slideNextClass} ${t.slidePrevClass} ${t.slideDuplicateActiveClass} ${t.slideDuplicateNextClass} ${t.slideDuplicatePrevClass}`);
  let a;
  o ? a = n.$wrapperEl.find(`.${t.slideClass}[data-swiper-slide-index="${i}"]`) : a = e.eq(i), a.addClass(t.slideActiveClass), t.loop && (a.hasClass(t.slideDuplicateClass) ? r.children(`.${t.slideClass}:not(.${t.slideDuplicateClass})[data-swiper-slide-index="${s}"]`).addClass(t.slideDuplicateActiveClass) : r.children(`.${t.slideClass}.${t.slideDuplicateClass}[data-swiper-slide-index="${s}"]`).addClass(t.slideDuplicateActiveClass));
  let l = a.nextAll(`.${t.slideClass}`).eq(0).addClass(t.slideNextClass);
  t.loop && l.length === 0 && (l = e.eq(0), l.addClass(t.slideNextClass));
  let u = a.prevAll(`.${t.slideClass}`).eq(0).addClass(t.slidePrevClass);
  t.loop && u.length === 0 && (u = e.eq(-1), u.addClass(t.slidePrevClass)), t.loop && (l.hasClass(t.slideDuplicateClass) ? r.children(`.${t.slideClass}:not(.${t.slideDuplicateClass})[data-swiper-slide-index="${l.attr("data-swiper-slide-index")}"]`).addClass(t.slideDuplicateNextClass) : r.children(`.${t.slideClass}.${t.slideDuplicateClass}[data-swiper-slide-index="${l.attr("data-swiper-slide-index")}"]`).addClass(t.slideDuplicateNextClass), u.hasClass(t.slideDuplicateClass) ? r.children(`.${t.slideClass}:not(.${t.slideDuplicateClass})[data-swiper-slide-index="${u.attr("data-swiper-slide-index")}"]`).addClass(t.slideDuplicatePrevClass) : r.children(`.${t.slideClass}.${t.slideDuplicateClass}[data-swiper-slide-index="${u.attr("data-swiper-slide-index")}"]`).addClass(t.slideDuplicatePrevClass)), n.emitSlidesClasses();
}
function PO(n) {
  const e = this, t = e.rtlTranslate ? e.translate : -e.translate, {
    slidesGrid: r,
    snapGrid: i,
    params: s,
    activeIndex: o,
    realIndex: a,
    snapIndex: l
  } = e;
  let u = n, c;
  if (typeof u > "u") {
    for (let p = 0; p < r.length; p += 1)
      typeof r[p + 1] < "u" ? t >= r[p] && t < r[p + 1] - (r[p + 1] - r[p]) / 2 ? u = p : t >= r[p] && t < r[p + 1] && (u = p + 1) : t >= r[p] && (u = p);
    s.normalizeSlideIndex && (u < 0 || typeof u > "u") && (u = 0);
  }
  if (i.indexOf(t) >= 0)
    c = i.indexOf(t);
  else {
    const p = Math.min(s.slidesPerGroupSkip, u);
    c = p + Math.floor((u - p) / s.slidesPerGroup);
  }
  if (c >= i.length && (c = i.length - 1), u === o) {
    c !== l && (e.snapIndex = c, e.emit("snapIndexChange"));
    return;
  }
  const f = parseInt(e.slides.eq(u).attr("data-swiper-slide-index") || u, 10);
  Object.assign(e, {
    snapIndex: c,
    realIndex: f,
    previousIndex: o,
    activeIndex: u
  }), e.emit("activeIndexChange"), e.emit("snapIndexChange"), a !== f && e.emit("realIndexChange"), (e.initialized || e.params.runCallbacksOnInit) && e.emit("slideChange");
}
function $O(n) {
  const e = this, t = e.params, r = ee(n).closest(`.${t.slideClass}`)[0];
  let i = !1, s;
  if (r) {
    for (let o = 0; o < e.slides.length; o += 1)
      if (e.slides[o] === r) {
        i = !0, s = o;
        break;
      }
  }
  if (r && i)
    e.clickedSlide = r, e.virtual && e.params.virtual.enabled ? e.clickedIndex = parseInt(ee(r).attr("data-swiper-slide-index"), 10) : e.clickedIndex = s;
  else {
    e.clickedSlide = void 0, e.clickedIndex = void 0;
    return;
  }
  t.slideToClickedSlide && e.clickedIndex !== void 0 && e.clickedIndex !== e.activeIndex && e.slideToClickedSlide();
}
const DO = {
  updateSize: CO,
  updateSlides: OO,
  updateAutoHeight: EO,
  updateSlidesOffset: TO,
  updateSlidesProgress: kO,
  updateProgress: MO,
  updateSlidesClasses: AO,
  updateActiveIndex: PO,
  updateClickedSlide: $O
};
function LO(n = this.isHorizontal() ? "x" : "y") {
  const e = this, {
    params: t,
    rtlTranslate: r,
    translate: i,
    $wrapperEl: s
  } = e;
  if (t.virtualTranslate)
    return r ? -i : i;
  if (t.cssMode)
    return i;
  let o = hO(s[0], n);
  return r && (o = -o), o || 0;
}
function NO(n, e) {
  const t = this, {
    rtlTranslate: r,
    params: i,
    $wrapperEl: s,
    wrapperEl: o,
    progress: a
  } = t;
  let l = 0, u = 0;
  const c = 0;
  t.isHorizontal() ? l = r ? -n : n : u = n, i.roundLengths && (l = Math.floor(l), u = Math.floor(u)), i.cssMode ? o[t.isHorizontal() ? "scrollLeft" : "scrollTop"] = t.isHorizontal() ? -l : -u : i.virtualTranslate || s.transform(`translate3d(${l}px, ${u}px, ${c}px)`), t.previousTranslate = t.translate, t.translate = t.isHorizontal() ? l : u;
  let f;
  const p = t.maxTranslate() - t.minTranslate();
  p === 0 ? f = 0 : f = (n - t.minTranslate()) / p, f !== a && t.updateProgress(n), t.emit("setTranslate", t.translate, e);
}
function IO() {
  return -this.snapGrid[0];
}
function RO() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
function FO(n = 0, e = this.params.speed, t = !0, r = !0, i) {
  const s = this, {
    params: o,
    wrapperEl: a
  } = s;
  if (s.animating && o.preventInteractionOnTransition)
    return !1;
  const l = s.minTranslate(), u = s.maxTranslate();
  let c;
  if (r && n > l ? c = l : r && n < u ? c = u : c = n, s.updateProgress(c), o.cssMode) {
    const f = s.isHorizontal();
    if (e === 0)
      a[f ? "scrollLeft" : "scrollTop"] = -c;
    else {
      if (!s.support.smoothScroll)
        return eb({
          swiper: s,
          targetPosition: -c,
          side: f ? "left" : "top"
        }), !0;
      a.scrollTo({
        [f ? "left" : "top"]: -c,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return e === 0 ? (s.setTransition(0), s.setTranslate(c), t && (s.emit("beforeTransitionStart", e, i), s.emit("transitionEnd"))) : (s.setTransition(e), s.setTranslate(c), t && (s.emit("beforeTransitionStart", e, i), s.emit("transitionStart")), s.animating || (s.animating = !0, s.onTranslateToWrapperTransitionEnd || (s.onTranslateToWrapperTransitionEnd = function(p) {
    !s || s.destroyed || p.target === this && (s.$wrapperEl[0].removeEventListener("transitionend", s.onTranslateToWrapperTransitionEnd), s.$wrapperEl[0].removeEventListener("webkitTransitionEnd", s.onTranslateToWrapperTransitionEnd), s.onTranslateToWrapperTransitionEnd = null, delete s.onTranslateToWrapperTransitionEnd, t && s.emit("transitionEnd"));
  }), s.$wrapperEl[0].addEventListener("transitionend", s.onTranslateToWrapperTransitionEnd), s.$wrapperEl[0].addEventListener("webkitTransitionEnd", s.onTranslateToWrapperTransitionEnd))), !0;
}
const zO = {
  getTranslate: LO,
  setTranslate: NO,
  minTranslate: IO,
  maxTranslate: RO,
  translateTo: FO
};
function BO(n, e) {
  const t = this;
  t.params.cssMode || t.$wrapperEl.transition(n), t.emit("setTransition", n, e);
}
function nb({
  swiper: n,
  runCallbacks: e,
  direction: t,
  step: r
}) {
  const {
    activeIndex: i,
    previousIndex: s
  } = n;
  let o = t;
  if (o || (i > s ? o = "next" : i < s ? o = "prev" : o = "reset"), n.emit(`transition${r}`), e && i !== s) {
    if (o === "reset") {
      n.emit(`slideResetTransition${r}`);
      return;
    }
    n.emit(`slideChangeTransition${r}`), o === "next" ? n.emit(`slideNextTransition${r}`) : n.emit(`slidePrevTransition${r}`);
  }
}
function jO(n = !0, e) {
  const t = this, {
    params: r
  } = t;
  r.cssMode || (r.autoHeight && t.updateAutoHeight(), nb({
    swiper: t,
    runCallbacks: n,
    direction: e,
    step: "Start"
  }));
}
function VO(n = !0, e) {
  const t = this, {
    params: r
  } = t;
  t.animating = !1, !r.cssMode && (t.setTransition(0), nb({
    swiper: t,
    runCallbacks: n,
    direction: e,
    step: "End"
  }));
}
const HO = {
  setTransition: BO,
  transitionStart: jO,
  transitionEnd: VO
};
function WO(n = 0, e = this.params.speed, t = !0, r, i) {
  if (typeof n != "number" && typeof n != "string")
    throw new Error(`The 'index' argument cannot have type other than 'number' or 'string'. [${typeof n}] given.`);
  if (typeof n == "string") {
    const y = parseInt(n, 10);
    if (!isFinite(y))
      throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${n}] given.`);
    n = y;
  }
  const s = this;
  let o = n;
  o < 0 && (o = 0);
  const {
    params: a,
    snapGrid: l,
    slidesGrid: u,
    previousIndex: c,
    activeIndex: f,
    rtlTranslate: p,
    wrapperEl: d,
    enabled: h
  } = s;
  if (s.animating && a.preventInteractionOnTransition || !h && !r && !i)
    return !1;
  const v = Math.min(s.params.slidesPerGroupSkip, o);
  let g = v + Math.floor((o - v) / s.params.slidesPerGroup);
  g >= l.length && (g = l.length - 1);
  const m = -l[g];
  if (a.normalizeSlideIndex)
    for (let y = 0; y < u.length; y += 1) {
      const w = -Math.floor(m * 100), O = Math.floor(u[y] * 100), C = Math.floor(u[y + 1] * 100);
      typeof u[y + 1] < "u" ? w >= O && w < C - (C - O) / 2 ? o = y : w >= O && w < C && (o = y + 1) : w >= O && (o = y);
    }
  if (s.initialized && o !== f && (!s.allowSlideNext && m < s.translate && m < s.minTranslate() || !s.allowSlidePrev && m > s.translate && m > s.maxTranslate() && (f || 0) !== o))
    return !1;
  o !== (c || 0) && t && s.emit("beforeSlideChangeStart"), s.updateProgress(m);
  let _;
  if (o > f ? _ = "next" : o < f ? _ = "prev" : _ = "reset", p && -m === s.translate || !p && m === s.translate)
    return s.updateActiveIndex(o), a.autoHeight && s.updateAutoHeight(), s.updateSlidesClasses(), a.effect !== "slide" && s.setTranslate(m), _ !== "reset" && (s.transitionStart(t, _), s.transitionEnd(t, _)), !1;
  if (a.cssMode) {
    const y = s.isHorizontal(), w = p ? m : -m;
    if (e === 0) {
      const O = s.virtual && s.params.virtual.enabled;
      O && (s.wrapperEl.style.scrollSnapType = "none", s._immediateVirtual = !0), d[y ? "scrollLeft" : "scrollTop"] = w, O && requestAnimationFrame(() => {
        s.wrapperEl.style.scrollSnapType = "", s._swiperImmediateVirtual = !1;
      });
    } else {
      if (!s.support.smoothScroll)
        return eb({
          swiper: s,
          targetPosition: w,
          side: y ? "left" : "top"
        }), !0;
      d.scrollTo({
        [y ? "left" : "top"]: w,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return s.setTransition(e), s.setTranslate(m), s.updateActiveIndex(o), s.updateSlidesClasses(), s.emit("beforeTransitionStart", e, r), s.transitionStart(t, _), e === 0 ? s.transitionEnd(t, _) : s.animating || (s.animating = !0, s.onSlideToWrapperTransitionEnd || (s.onSlideToWrapperTransitionEnd = function(w) {
    !s || s.destroyed || w.target === this && (s.$wrapperEl[0].removeEventListener("transitionend", s.onSlideToWrapperTransitionEnd), s.$wrapperEl[0].removeEventListener("webkitTransitionEnd", s.onSlideToWrapperTransitionEnd), s.onSlideToWrapperTransitionEnd = null, delete s.onSlideToWrapperTransitionEnd, s.transitionEnd(t, _));
  }), s.$wrapperEl[0].addEventListener("transitionend", s.onSlideToWrapperTransitionEnd), s.$wrapperEl[0].addEventListener("webkitTransitionEnd", s.onSlideToWrapperTransitionEnd)), !0;
}
function qO(n = 0, e = this.params.speed, t = !0, r) {
  if (typeof n == "string") {
    const o = parseInt(n, 10);
    if (!isFinite(o))
      throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${n}] given.`);
    n = o;
  }
  const i = this;
  let s = n;
  return i.params.loop && (s += i.loopedSlides), i.slideTo(s, e, t, r);
}
function UO(n = this.params.speed, e = !0, t) {
  const r = this, {
    animating: i,
    enabled: s,
    params: o
  } = r;
  if (!s)
    return r;
  let a = o.slidesPerGroup;
  o.slidesPerView === "auto" && o.slidesPerGroup === 1 && o.slidesPerGroupAuto && (a = Math.max(r.slidesPerViewDynamic("current", !0), 1));
  const l = r.activeIndex < o.slidesPerGroupSkip ? 1 : a;
  if (o.loop) {
    if (i && o.loopPreventsSlide)
      return !1;
    r.loopFix(), r._clientLeft = r.$wrapperEl[0].clientLeft;
  }
  return o.rewind && r.isEnd ? r.slideTo(0, n, e, t) : r.slideTo(r.activeIndex + l, n, e, t);
}
function GO(n = this.params.speed, e = !0, t) {
  const r = this, {
    params: i,
    animating: s,
    snapGrid: o,
    slidesGrid: a,
    rtlTranslate: l,
    enabled: u
  } = r;
  if (!u)
    return r;
  if (i.loop) {
    if (s && i.loopPreventsSlide)
      return !1;
    r.loopFix(), r._clientLeft = r.$wrapperEl[0].clientLeft;
  }
  const c = l ? r.translate : -r.translate;
  function f(g) {
    return g < 0 ? -Math.floor(Math.abs(g)) : Math.floor(g);
  }
  const p = f(c), d = o.map((g) => f(g));
  let h = o[d.indexOf(p) - 1];
  if (typeof h > "u" && i.cssMode) {
    let g;
    o.forEach((m, _) => {
      p >= m && (g = _);
    }), typeof g < "u" && (h = o[g > 0 ? g - 1 : g]);
  }
  let v = 0;
  if (typeof h < "u" && (v = a.indexOf(h), v < 0 && (v = r.activeIndex - 1), i.slidesPerView === "auto" && i.slidesPerGroup === 1 && i.slidesPerGroupAuto && (v = v - r.slidesPerViewDynamic("previous", !0) + 1, v = Math.max(v, 0))), i.rewind && r.isBeginning) {
    const g = r.params.virtual && r.params.virtual.enabled && r.virtual ? r.virtual.slides.length - 1 : r.slides.length - 1;
    return r.slideTo(g, n, e, t);
  }
  return r.slideTo(v, n, e, t);
}
function KO(n = this.params.speed, e = !0, t) {
  const r = this;
  return r.slideTo(r.activeIndex, n, e, t);
}
function JO(n = this.params.speed, e = !0, t, r = 0.5) {
  const i = this;
  let s = i.activeIndex;
  const o = Math.min(i.params.slidesPerGroupSkip, s), a = o + Math.floor((s - o) / i.params.slidesPerGroup), l = i.rtlTranslate ? i.translate : -i.translate;
  if (l >= i.snapGrid[a]) {
    const u = i.snapGrid[a], c = i.snapGrid[a + 1];
    l - u > (c - u) * r && (s += i.params.slidesPerGroup);
  } else {
    const u = i.snapGrid[a - 1], c = i.snapGrid[a];
    l - u <= (c - u) * r && (s -= i.params.slidesPerGroup);
  }
  return s = Math.max(s, 0), s = Math.min(s, i.slidesGrid.length - 1), i.slideTo(s, n, e, t);
}
function XO() {
  const n = this, {
    params: e,
    $wrapperEl: t
  } = n, r = e.slidesPerView === "auto" ? n.slidesPerViewDynamic() : e.slidesPerView;
  let i = n.clickedIndex, s;
  if (e.loop) {
    if (n.animating)
      return;
    s = parseInt(ee(n.clickedSlide).attr("data-swiper-slide-index"), 10), e.centeredSlides ? i < n.loopedSlides - r / 2 || i > n.slides.length - n.loopedSlides + r / 2 ? (n.loopFix(), i = t.children(`.${e.slideClass}[data-swiper-slide-index="${s}"]:not(.${e.slideDuplicateClass})`).eq(0).index(), kd(() => {
      n.slideTo(i);
    })) : n.slideTo(i) : i > n.slides.length - r ? (n.loopFix(), i = t.children(`.${e.slideClass}[data-swiper-slide-index="${s}"]:not(.${e.slideDuplicateClass})`).eq(0).index(), kd(() => {
      n.slideTo(i);
    })) : n.slideTo(i);
  } else
    n.slideTo(i);
}
const YO = {
  slideTo: WO,
  slideToLoop: qO,
  slideNext: UO,
  slidePrev: GO,
  slideReset: KO,
  slideToClosest: JO,
  slideToClickedSlide: XO
};
function QO() {
  const n = this, e = Rt(), {
    params: t,
    $wrapperEl: r
  } = n, i = r.children().length > 0 ? ee(r.children()[0].parentNode) : r;
  i.children(`.${t.slideClass}.${t.slideDuplicateClass}`).remove();
  let s = i.children(`.${t.slideClass}`);
  if (t.loopFillGroupWithBlank) {
    const l = t.slidesPerGroup - s.length % t.slidesPerGroup;
    if (l !== t.slidesPerGroup) {
      for (let u = 0; u < l; u += 1) {
        const c = ee(e.createElement("div")).addClass(`${t.slideClass} ${t.slideBlankClass}`);
        i.append(c);
      }
      s = i.children(`.${t.slideClass}`);
    }
  }
  t.slidesPerView === "auto" && !t.loopedSlides && (t.loopedSlides = s.length), n.loopedSlides = Math.ceil(parseFloat(t.loopedSlides || t.slidesPerView, 10)), n.loopedSlides += t.loopAdditionalSlides, n.loopedSlides > s.length && n.params.loopedSlidesLimit && (n.loopedSlides = s.length);
  const o = [], a = [];
  s.each((l, u) => {
    ee(l).attr("data-swiper-slide-index", u);
  });
  for (let l = 0; l < n.loopedSlides; l += 1) {
    const u = l - Math.floor(l / s.length) * s.length;
    a.push(s.eq(u)[0]), o.unshift(s.eq(s.length - u - 1)[0]);
  }
  for (let l = 0; l < a.length; l += 1)
    i.append(ee(a[l].cloneNode(!0)).addClass(t.slideDuplicateClass));
  for (let l = o.length - 1; l >= 0; l -= 1)
    i.prepend(ee(o[l].cloneNode(!0)).addClass(t.slideDuplicateClass));
}
function ZO() {
  const n = this;
  n.emit("beforeLoopFix");
  const {
    activeIndex: e,
    slides: t,
    loopedSlides: r,
    allowSlidePrev: i,
    allowSlideNext: s,
    snapGrid: o,
    rtlTranslate: a
  } = n;
  let l;
  n.allowSlidePrev = !0, n.allowSlideNext = !0;
  const c = -o[e] - n.getTranslate();
  e < r ? (l = t.length - r * 3 + e, l += r, n.slideTo(l, 0, !1, !0) && c !== 0 && n.setTranslate((a ? -n.translate : n.translate) - c)) : e >= t.length - r && (l = -t.length + e + r, l += r, n.slideTo(l, 0, !1, !0) && c !== 0 && n.setTranslate((a ? -n.translate : n.translate) - c)), n.allowSlidePrev = i, n.allowSlideNext = s, n.emit("loopFix");
}
function eE() {
  const n = this, {
    $wrapperEl: e,
    params: t,
    slides: r
  } = n;
  e.children(`.${t.slideClass}.${t.slideDuplicateClass},.${t.slideClass}.${t.slideBlankClass}`).remove(), r.removeAttr("data-swiper-slide-index");
}
const tE = {
  loopCreate: QO,
  loopFix: ZO,
  loopDestroy: eE
};
function nE(n) {
  const e = this;
  if (e.support.touch || !e.params.simulateTouch || e.params.watchOverflow && e.isLocked || e.params.cssMode)
    return;
  const t = e.params.touchEventsTarget === "container" ? e.el : e.wrapperEl;
  t.style.cursor = "move", t.style.cursor = n ? "grabbing" : "grab";
}
function rE() {
  const n = this;
  n.support.touch || n.params.watchOverflow && n.isLocked || n.params.cssMode || (n[n.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "");
}
const iE = {
  setGrabCursor: nE,
  unsetGrabCursor: rE
};
function sE(n, e = this) {
  function t(r) {
    if (!r || r === Rt() || r === Ke())
      return null;
    r.assignedSlot && (r = r.assignedSlot);
    const i = r.closest(n);
    return !i && !r.getRootNode ? null : i || t(r.getRootNode().host);
  }
  return t(e);
}
function oE(n) {
  const e = this, t = Rt(), r = Ke(), i = e.touchEventsData, {
    params: s,
    touches: o,
    enabled: a
  } = e;
  if (!a || e.animating && s.preventInteractionOnTransition)
    return;
  !e.animating && s.cssMode && s.loop && e.loopFix();
  let l = n;
  l.originalEvent && (l = l.originalEvent);
  let u = ee(l.target);
  if (s.touchEventsTarget === "wrapper" && !u.closest(e.wrapperEl).length || (i.isTouchEvent = l.type === "touchstart", !i.isTouchEvent && "which" in l && l.which === 3) || !i.isTouchEvent && "button" in l && l.button > 0 || i.isTouched && i.isMoved)
    return;
  const c = !!s.noSwipingClass && s.noSwipingClass !== "", f = n.composedPath ? n.composedPath() : n.path;
  c && l.target && l.target.shadowRoot && f && (u = ee(f[0]));
  const p = s.noSwipingSelector ? s.noSwipingSelector : `.${s.noSwipingClass}`, d = !!(l.target && l.target.shadowRoot);
  if (s.noSwiping && (d ? sE(p, u[0]) : u.closest(p)[0])) {
    e.allowClick = !0;
    return;
  }
  if (s.swipeHandler && !u.closest(s.swipeHandler)[0])
    return;
  o.currentX = l.type === "touchstart" ? l.targetTouches[0].pageX : l.pageX, o.currentY = l.type === "touchstart" ? l.targetTouches[0].pageY : l.pageY;
  const h = o.currentX, v = o.currentY, g = s.edgeSwipeDetection || s.iOSEdgeSwipeDetection, m = s.edgeSwipeThreshold || s.iOSEdgeSwipeThreshold;
  if (g && (h <= m || h >= r.innerWidth - m))
    if (g === "prevent")
      n.preventDefault();
    else
      return;
  if (Object.assign(i, {
    isTouched: !0,
    isMoved: !1,
    allowTouchCallbacks: !0,
    isScrolling: void 0,
    startMoving: void 0
  }), o.startX = h, o.startY = v, i.touchStartTime = ks(), e.allowClick = !0, e.updateSize(), e.swipeDirection = void 0, s.threshold > 0 && (i.allowThresholdMove = !1), l.type !== "touchstart") {
    let _ = !0;
    u.is(i.focusableElements) && (_ = !1, u[0].nodeName === "SELECT" && (i.isTouched = !1)), t.activeElement && ee(t.activeElement).is(i.focusableElements) && t.activeElement !== u[0] && t.activeElement.blur();
    const y = _ && e.allowTouchMove && s.touchStartPreventDefault;
    (s.touchStartForcePreventDefault || y) && !u[0].isContentEditable && l.preventDefault();
  }
  e.params.freeMode && e.params.freeMode.enabled && e.freeMode && e.animating && !s.cssMode && e.freeMode.onTouchStart(), e.emit("touchStart", l);
}
function aE(n) {
  const e = Rt(), t = this, r = t.touchEventsData, {
    params: i,
    touches: s,
    rtlTranslate: o,
    enabled: a
  } = t;
  if (!a)
    return;
  let l = n;
  if (l.originalEvent && (l = l.originalEvent), !r.isTouched) {
    r.startMoving && r.isScrolling && t.emit("touchMoveOpposite", l);
    return;
  }
  if (r.isTouchEvent && l.type !== "touchmove")
    return;
  const u = l.type === "touchmove" && l.targetTouches && (l.targetTouches[0] || l.changedTouches[0]), c = l.type === "touchmove" ? u.pageX : l.pageX, f = l.type === "touchmove" ? u.pageY : l.pageY;
  if (l.preventedByNestedSwiper) {
    s.startX = c, s.startY = f;
    return;
  }
  if (!t.allowTouchMove) {
    ee(l.target).is(r.focusableElements) || (t.allowClick = !1), r.isTouched && (Object.assign(s, {
      startX: c,
      startY: f,
      currentX: c,
      currentY: f
    }), r.touchStartTime = ks());
    return;
  }
  if (r.isTouchEvent && i.touchReleaseOnEdges && !i.loop) {
    if (t.isVertical()) {
      if (f < s.startY && t.translate <= t.maxTranslate() || f > s.startY && t.translate >= t.minTranslate()) {
        r.isTouched = !1, r.isMoved = !1;
        return;
      }
    } else if (c < s.startX && t.translate <= t.maxTranslate() || c > s.startX && t.translate >= t.minTranslate())
      return;
  }
  if (r.isTouchEvent && e.activeElement && l.target === e.activeElement && ee(l.target).is(r.focusableElements)) {
    r.isMoved = !0, t.allowClick = !1;
    return;
  }
  if (r.allowTouchCallbacks && t.emit("touchMove", l), l.targetTouches && l.targetTouches.length > 1)
    return;
  s.currentX = c, s.currentY = f;
  const p = s.currentX - s.startX, d = s.currentY - s.startY;
  if (t.params.threshold && Math.sqrt(p ** 2 + d ** 2) < t.params.threshold)
    return;
  if (typeof r.isScrolling > "u") {
    let m;
    t.isHorizontal() && s.currentY === s.startY || t.isVertical() && s.currentX === s.startX ? r.isScrolling = !1 : p * p + d * d >= 25 && (m = Math.atan2(Math.abs(d), Math.abs(p)) * 180 / Math.PI, r.isScrolling = t.isHorizontal() ? m > i.touchAngle : 90 - m > i.touchAngle);
  }
  if (r.isScrolling && t.emit("touchMoveOpposite", l), typeof r.startMoving > "u" && (s.currentX !== s.startX || s.currentY !== s.startY) && (r.startMoving = !0), r.isScrolling) {
    r.isTouched = !1;
    return;
  }
  if (!r.startMoving)
    return;
  t.allowClick = !1, !i.cssMode && l.cancelable && l.preventDefault(), i.touchMoveStopPropagation && !i.nested && l.stopPropagation(), r.isMoved || (i.loop && !i.cssMode && t.loopFix(), r.startTranslate = t.getTranslate(), t.setTransition(0), t.animating && t.$wrapperEl.trigger("webkitTransitionEnd transitionend"), r.allowMomentumBounce = !1, i.grabCursor && (t.allowSlideNext === !0 || t.allowSlidePrev === !0) && t.setGrabCursor(!0), t.emit("sliderFirstMove", l)), t.emit("sliderMove", l), r.isMoved = !0;
  let h = t.isHorizontal() ? p : d;
  s.diff = h, h *= i.touchRatio, o && (h = -h), t.swipeDirection = h > 0 ? "prev" : "next", r.currentTranslate = h + r.startTranslate;
  let v = !0, g = i.resistanceRatio;
  if (i.touchReleaseOnEdges && (g = 0), h > 0 && r.currentTranslate > t.minTranslate() ? (v = !1, i.resistance && (r.currentTranslate = t.minTranslate() - 1 + (-t.minTranslate() + r.startTranslate + h) ** g)) : h < 0 && r.currentTranslate < t.maxTranslate() && (v = !1, i.resistance && (r.currentTranslate = t.maxTranslate() + 1 - (t.maxTranslate() - r.startTranslate - h) ** g)), v && (l.preventedByNestedSwiper = !0), !t.allowSlideNext && t.swipeDirection === "next" && r.currentTranslate < r.startTranslate && (r.currentTranslate = r.startTranslate), !t.allowSlidePrev && t.swipeDirection === "prev" && r.currentTranslate > r.startTranslate && (r.currentTranslate = r.startTranslate), !t.allowSlidePrev && !t.allowSlideNext && (r.currentTranslate = r.startTranslate), i.threshold > 0)
    if (Math.abs(h) > i.threshold || r.allowThresholdMove) {
      if (!r.allowThresholdMove) {
        r.allowThresholdMove = !0, s.startX = s.currentX, s.startY = s.currentY, r.currentTranslate = r.startTranslate, s.diff = t.isHorizontal() ? s.currentX - s.startX : s.currentY - s.startY;
        return;
      }
    } else {
      r.currentTranslate = r.startTranslate;
      return;
    }
  !i.followFinger || i.cssMode || ((i.freeMode && i.freeMode.enabled && t.freeMode || i.watchSlidesProgress) && (t.updateActiveIndex(), t.updateSlidesClasses()), t.params.freeMode && i.freeMode.enabled && t.freeMode && t.freeMode.onTouchMove(), t.updateProgress(r.currentTranslate), t.setTranslate(r.currentTranslate));
}
function lE(n) {
  const e = this, t = e.touchEventsData, {
    params: r,
    touches: i,
    rtlTranslate: s,
    slidesGrid: o,
    enabled: a
  } = e;
  if (!a)
    return;
  let l = n;
  if (l.originalEvent && (l = l.originalEvent), t.allowTouchCallbacks && e.emit("touchEnd", l), t.allowTouchCallbacks = !1, !t.isTouched) {
    t.isMoved && r.grabCursor && e.setGrabCursor(!1), t.isMoved = !1, t.startMoving = !1;
    return;
  }
  r.grabCursor && t.isMoved && t.isTouched && (e.allowSlideNext === !0 || e.allowSlidePrev === !0) && e.setGrabCursor(!1);
  const u = ks(), c = u - t.touchStartTime;
  if (e.allowClick) {
    const _ = l.path || l.composedPath && l.composedPath();
    e.updateClickedSlide(_ && _[0] || l.target), e.emit("tap click", l), c < 300 && u - t.lastClickTime < 300 && e.emit("doubleTap doubleClick", l);
  }
  if (t.lastClickTime = ks(), kd(() => {
    e.destroyed || (e.allowClick = !0);
  }), !t.isTouched || !t.isMoved || !e.swipeDirection || i.diff === 0 || t.currentTranslate === t.startTranslate) {
    t.isTouched = !1, t.isMoved = !1, t.startMoving = !1;
    return;
  }
  t.isTouched = !1, t.isMoved = !1, t.startMoving = !1;
  let f;
  if (r.followFinger ? f = s ? e.translate : -e.translate : f = -t.currentTranslate, r.cssMode)
    return;
  if (e.params.freeMode && r.freeMode.enabled) {
    e.freeMode.onTouchEnd({
      currentPos: f
    });
    return;
  }
  let p = 0, d = e.slidesSizesGrid[0];
  for (let _ = 0; _ < o.length; _ += _ < r.slidesPerGroupSkip ? 1 : r.slidesPerGroup) {
    const y = _ < r.slidesPerGroupSkip - 1 ? 1 : r.slidesPerGroup;
    typeof o[_ + y] < "u" ? f >= o[_] && f < o[_ + y] && (p = _, d = o[_ + y] - o[_]) : f >= o[_] && (p = _, d = o[o.length - 1] - o[o.length - 2]);
  }
  let h = null, v = null;
  r.rewind && (e.isBeginning ? v = e.params.virtual && e.params.virtual.enabled && e.virtual ? e.virtual.slides.length - 1 : e.slides.length - 1 : e.isEnd && (h = 0));
  const g = (f - o[p]) / d, m = p < r.slidesPerGroupSkip - 1 ? 1 : r.slidesPerGroup;
  if (c > r.longSwipesMs) {
    if (!r.longSwipes) {
      e.slideTo(e.activeIndex);
      return;
    }
    e.swipeDirection === "next" && (g >= r.longSwipesRatio ? e.slideTo(r.rewind && e.isEnd ? h : p + m) : e.slideTo(p)), e.swipeDirection === "prev" && (g > 1 - r.longSwipesRatio ? e.slideTo(p + m) : v !== null && g < 0 && Math.abs(g) > r.longSwipesRatio ? e.slideTo(v) : e.slideTo(p));
  } else {
    if (!r.shortSwipes) {
      e.slideTo(e.activeIndex);
      return;
    }
    e.navigation && (l.target === e.navigation.nextEl || l.target === e.navigation.prevEl) ? l.target === e.navigation.nextEl ? e.slideTo(p + m) : e.slideTo(p) : (e.swipeDirection === "next" && e.slideTo(h !== null ? h : p + m), e.swipeDirection === "prev" && e.slideTo(v !== null ? v : p));
  }
}
function im() {
  const n = this, {
    params: e,
    el: t
  } = n;
  if (t && t.offsetWidth === 0)
    return;
  e.breakpoints && n.setBreakpoint();
  const {
    allowSlideNext: r,
    allowSlidePrev: i,
    snapGrid: s
  } = n;
  n.allowSlideNext = !0, n.allowSlidePrev = !0, n.updateSize(), n.updateSlides(), n.updateSlidesClasses(), (e.slidesPerView === "auto" || e.slidesPerView > 1) && n.isEnd && !n.isBeginning && !n.params.centeredSlides ? n.slideTo(n.slides.length - 1, 0, !1, !0) : n.slideTo(n.activeIndex, 0, !1, !0), n.autoplay && n.autoplay.running && n.autoplay.paused && n.autoplay.run(), n.allowSlidePrev = i, n.allowSlideNext = r, n.params.watchOverflow && s !== n.snapGrid && n.checkOverflow();
}
function uE(n) {
  const e = this;
  !e.enabled || e.allowClick || (e.params.preventClicks && n.preventDefault(), e.params.preventClicksPropagation && e.animating && (n.stopPropagation(), n.stopImmediatePropagation()));
}
function cE() {
  const n = this, {
    wrapperEl: e,
    rtlTranslate: t,
    enabled: r
  } = n;
  if (!r)
    return;
  n.previousTranslate = n.translate, n.isHorizontal() ? n.translate = -e.scrollLeft : n.translate = -e.scrollTop, n.translate === 0 && (n.translate = 0), n.updateActiveIndex(), n.updateSlidesClasses();
  let i;
  const s = n.maxTranslate() - n.minTranslate();
  s === 0 ? i = 0 : i = (n.translate - n.minTranslate()) / s, i !== n.progress && n.updateProgress(t ? -n.translate : n.translate), n.emit("setTranslate", n.translate, !1);
}
let sm = !1;
function dE() {
}
const rb = (n, e) => {
  const t = Rt(), {
    params: r,
    touchEvents: i,
    el: s,
    wrapperEl: o,
    device: a,
    support: l
  } = n, u = !!r.nested, c = e === "on" ? "addEventListener" : "removeEventListener", f = e;
  if (!l.touch)
    s[c](i.start, n.onTouchStart, !1), t[c](i.move, n.onTouchMove, u), t[c](i.end, n.onTouchEnd, !1);
  else {
    const p = i.start === "touchstart" && l.passiveListener && r.passiveListeners ? {
      passive: !0,
      capture: !1
    } : !1;
    s[c](i.start, n.onTouchStart, p), s[c](i.move, n.onTouchMove, l.passiveListener ? {
      passive: !1,
      capture: u
    } : u), s[c](i.end, n.onTouchEnd, p), i.cancel && s[c](i.cancel, n.onTouchEnd, p);
  }
  (r.preventClicks || r.preventClicksPropagation) && s[c]("click", n.onClick, !0), r.cssMode && o[c]("scroll", n.onScroll), r.updateOnWindowResize ? n[f](a.ios || a.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", im, !0) : n[f]("observerUpdate", im, !0);
};
function fE() {
  const n = this, e = Rt(), {
    params: t,
    support: r
  } = n;
  n.onTouchStart = oE.bind(n), n.onTouchMove = aE.bind(n), n.onTouchEnd = lE.bind(n), t.cssMode && (n.onScroll = cE.bind(n)), n.onClick = uE.bind(n), r.touch && !sm && (e.addEventListener("touchstart", dE), sm = !0), rb(n, "on");
}
function pE() {
  rb(this, "off");
}
const hE = {
  attachEvents: fE,
  detachEvents: pE
}, om = (n, e) => n.grid && e.grid && e.grid.rows > 1;
function mE() {
  const n = this, {
    activeIndex: e,
    initialized: t,
    loopedSlides: r = 0,
    params: i,
    $el: s
  } = n, o = i.breakpoints;
  if (!o || o && Object.keys(o).length === 0)
    return;
  const a = n.getBreakpoint(o, n.params.breakpointsBase, n.el);
  if (!a || n.currentBreakpoint === a)
    return;
  const u = (a in o ? o[a] : void 0) || n.originalParams, c = om(n, i), f = om(n, u), p = i.enabled;
  c && !f ? (s.removeClass(`${i.containerModifierClass}grid ${i.containerModifierClass}grid-column`), n.emitContainerClasses()) : !c && f && (s.addClass(`${i.containerModifierClass}grid`), (u.grid.fill && u.grid.fill === "column" || !u.grid.fill && i.grid.fill === "column") && s.addClass(`${i.containerModifierClass}grid-column`), n.emitContainerClasses()), ["navigation", "pagination", "scrollbar"].forEach((g) => {
    const m = i[g] && i[g].enabled, _ = u[g] && u[g].enabled;
    m && !_ && n[g].disable(), !m && _ && n[g].enable();
  });
  const d = u.direction && u.direction !== i.direction, h = i.loop && (u.slidesPerView !== i.slidesPerView || d);
  d && t && n.changeDirection(), kt(n.params, u);
  const v = n.params.enabled;
  Object.assign(n, {
    allowTouchMove: n.params.allowTouchMove,
    allowSlideNext: n.params.allowSlideNext,
    allowSlidePrev: n.params.allowSlidePrev
  }), p && !v ? n.disable() : !p && v && n.enable(), n.currentBreakpoint = a, n.emit("_beforeBreakpoint", u), h && t && (n.loopDestroy(), n.loopCreate(), n.updateSlides(), n.slideTo(e - r + n.loopedSlides, 0, !1)), n.emit("breakpoint", u);
}
function gE(n, e = "window", t) {
  if (!n || e === "container" && !t)
    return;
  let r = !1;
  const i = Ke(), s = e === "window" ? i.innerHeight : t.clientHeight, o = Object.keys(n).map((a) => {
    if (typeof a == "string" && a.indexOf("@") === 0) {
      const l = parseFloat(a.substr(1));
      return {
        value: s * l,
        point: a
      };
    }
    return {
      value: a,
      point: a
    };
  });
  o.sort((a, l) => parseInt(a.value, 10) - parseInt(l.value, 10));
  for (let a = 0; a < o.length; a += 1) {
    const {
      point: l,
      value: u
    } = o[a];
    e === "window" ? i.matchMedia(`(min-width: ${u}px)`).matches && (r = l) : u <= t.clientWidth && (r = l);
  }
  return r || "max";
}
const vE = {
  setBreakpoint: mE,
  getBreakpoint: gE
};
function yE(n, e) {
  const t = [];
  return n.forEach((r) => {
    typeof r == "object" ? Object.keys(r).forEach((i) => {
      r[i] && t.push(e + i);
    }) : typeof r == "string" && t.push(e + r);
  }), t;
}
function bE() {
  const n = this, {
    classNames: e,
    params: t,
    rtl: r,
    $el: i,
    device: s,
    support: o
  } = n, a = yE(["initialized", t.direction, {
    "pointer-events": !o.touch
  }, {
    "free-mode": n.params.freeMode && t.freeMode.enabled
  }, {
    autoheight: t.autoHeight
  }, {
    rtl: r
  }, {
    grid: t.grid && t.grid.rows > 1
  }, {
    "grid-column": t.grid && t.grid.rows > 1 && t.grid.fill === "column"
  }, {
    android: s.android
  }, {
    ios: s.ios
  }, {
    "css-mode": t.cssMode
  }, {
    centered: t.cssMode && t.centeredSlides
  }, {
    "watch-progress": t.watchSlidesProgress
  }], t.containerModifierClass);
  e.push(...a), i.addClass([...e].join(" ")), n.emitContainerClasses();
}
function wE() {
  const n = this, {
    $el: e,
    classNames: t
  } = n;
  e.removeClass(t.join(" ")), n.emitContainerClasses();
}
const _E = {
  addClasses: bE,
  removeClasses: wE
};
function SE(n, e, t, r, i, s) {
  const o = Ke();
  let a;
  function l() {
    s && s();
  }
  !ee(n).parent("picture")[0] && (!n.complete || !i) && e ? (a = new o.Image(), a.onload = l, a.onerror = l, r && (a.sizes = r), t && (a.srcset = t), e && (a.src = e)) : l();
}
function xE() {
  const n = this;
  n.imagesToLoad = n.$el.find("img");
  function e() {
    typeof n > "u" || n === null || !n || n.destroyed || (n.imagesLoaded !== void 0 && (n.imagesLoaded += 1), n.imagesLoaded === n.imagesToLoad.length && (n.params.updateOnImagesReady && n.update(), n.emit("imagesReady")));
  }
  for (let t = 0; t < n.imagesToLoad.length; t += 1) {
    const r = n.imagesToLoad[t];
    n.loadImage(r, r.currentSrc || r.getAttribute("src"), r.srcset || r.getAttribute("srcset"), r.sizes || r.getAttribute("sizes"), !0, e);
  }
}
const CE = {
  loadImage: SE,
  preloadImages: xE
};
function OE() {
  const n = this, {
    isLocked: e,
    params: t
  } = n, {
    slidesOffsetBefore: r
  } = t;
  if (r) {
    const i = n.slides.length - 1, s = n.slidesGrid[i] + n.slidesSizesGrid[i] + r * 2;
    n.isLocked = n.size > s;
  } else
    n.isLocked = n.snapGrid.length === 1;
  t.allowSlideNext === !0 && (n.allowSlideNext = !n.isLocked), t.allowSlidePrev === !0 && (n.allowSlidePrev = !n.isLocked), e && e !== n.isLocked && (n.isEnd = !1), e !== n.isLocked && n.emit(n.isLocked ? "lock" : "unlock");
}
const EE = {
  checkOverflow: OE
}, am = {
  init: !0,
  direction: "horizontal",
  touchEventsTarget: "wrapper",
  initialSlide: 0,
  speed: 300,
  cssMode: !1,
  updateOnWindowResize: !0,
  resizeObserver: !0,
  nested: !1,
  createElements: !1,
  enabled: !0,
  focusableElements: "input, select, option, textarea, button, video, label",
  width: null,
  height: null,
  preventInteractionOnTransition: !1,
  userAgent: null,
  url: null,
  edgeSwipeDetection: !1,
  edgeSwipeThreshold: 20,
  autoHeight: !1,
  setWrapperSize: !1,
  virtualTranslate: !1,
  effect: "slide",
  breakpoints: void 0,
  breakpointsBase: "window",
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: !1,
  centeredSlides: !1,
  centeredSlidesBounds: !1,
  slidesOffsetBefore: 0,
  slidesOffsetAfter: 0,
  normalizeSlideIndex: !0,
  centerInsufficientSlides: !1,
  watchOverflow: !0,
  roundLengths: !1,
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: !0,
  shortSwipes: !0,
  longSwipes: !0,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: !0,
  allowTouchMove: !0,
  threshold: 0,
  touchMoveStopPropagation: !1,
  touchStartPreventDefault: !0,
  touchStartForcePreventDefault: !1,
  touchReleaseOnEdges: !1,
  uniqueNavElements: !0,
  resistance: !0,
  resistanceRatio: 0.85,
  watchSlidesProgress: !1,
  grabCursor: !1,
  preventClicks: !0,
  preventClicksPropagation: !0,
  slideToClickedSlide: !1,
  preloadImages: !0,
  updateOnImagesReady: !0,
  loop: !1,
  loopAdditionalSlides: 0,
  loopedSlides: null,
  loopedSlidesLimit: !0,
  loopFillGroupWithBlank: !1,
  loopPreventsSlide: !0,
  rewind: !1,
  allowSlidePrev: !0,
  allowSlideNext: !0,
  swipeHandler: null,
  noSwiping: !0,
  noSwipingClass: "swiper-no-swiping",
  noSwipingSelector: null,
  passiveListeners: !0,
  maxBackfaceHiddenSlides: 10,
  containerModifierClass: "swiper-",
  slideClass: "swiper-slide",
  slideBlankClass: "swiper-slide-invisible-blank",
  slideActiveClass: "swiper-slide-active",
  slideDuplicateActiveClass: "swiper-slide-duplicate-active",
  slideVisibleClass: "swiper-slide-visible",
  slideDuplicateClass: "swiper-slide-duplicate",
  slideNextClass: "swiper-slide-next",
  slideDuplicateNextClass: "swiper-slide-duplicate-next",
  slidePrevClass: "swiper-slide-prev",
  slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
  wrapperClass: "swiper-wrapper",
  runCallbacksOnInit: !0,
  _emitClasses: !1
};
function TE(n, e) {
  return function(r = {}) {
    const i = Object.keys(r)[0], s = r[i];
    if (typeof s != "object" || s === null) {
      kt(e, r);
      return;
    }
    if (["navigation", "pagination", "scrollbar"].indexOf(i) >= 0 && n[i] === !0 && (n[i] = {
      auto: !0
    }), !(i in n && "enabled" in s)) {
      kt(e, r);
      return;
    }
    n[i] === !0 && (n[i] = {
      enabled: !0
    }), typeof n[i] == "object" && !("enabled" in n[i]) && (n[i].enabled = !0), n[i] || (n[i] = {
      enabled: !1
    }), kt(e, r);
  };
}
const hc = {
  eventsEmitter: xO,
  update: DO,
  translate: zO,
  transition: HO,
  slide: YO,
  loop: tE,
  grabCursor: iE,
  events: hE,
  breakpoints: vE,
  checkOverflow: EE,
  classes: _E,
  images: CE
}, mc = {};
class Wt {
  constructor(...e) {
    let t, r;
    if (e.length === 1 && e[0].constructor && Object.prototype.toString.call(e[0]).slice(8, -1) === "Object" ? r = e[0] : [t, r] = e, r || (r = {}), r = kt({}, r), t && !r.el && (r.el = t), r.el && ee(r.el).length > 1) {
      const a = [];
      return ee(r.el).each((l) => {
        const u = kt({}, r, {
          el: l
        });
        a.push(new Wt(u));
      }), a;
    }
    const i = this;
    i.__swiper__ = !0, i.support = tb(), i.device = yO({
      userAgent: r.userAgent
    }), i.browser = wO(), i.eventsListeners = {}, i.eventsAnyListeners = [], i.modules = [...i.__modules__], r.modules && Array.isArray(r.modules) && i.modules.push(...r.modules);
    const s = {};
    i.modules.forEach((a) => {
      a({
        swiper: i,
        extendParams: TE(r, s),
        on: i.on.bind(i),
        once: i.once.bind(i),
        off: i.off.bind(i),
        emit: i.emit.bind(i)
      });
    });
    const o = kt({}, am, s);
    return i.params = kt({}, o, mc, r), i.originalParams = kt({}, i.params), i.passedParams = kt({}, r), i.params && i.params.on && Object.keys(i.params.on).forEach((a) => {
      i.on(a, i.params.on[a]);
    }), i.params && i.params.onAny && i.onAny(i.params.onAny), i.$ = ee, Object.assign(i, {
      enabled: i.params.enabled,
      el: t,
      classNames: [],
      slides: ee(),
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      isHorizontal() {
        return i.params.direction === "horizontal";
      },
      isVertical() {
        return i.params.direction === "vertical";
      },
      activeIndex: 0,
      realIndex: 0,
      isBeginning: !0,
      isEnd: !1,
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: !1,
      allowSlideNext: i.params.allowSlideNext,
      allowSlidePrev: i.params.allowSlidePrev,
      touchEvents: function() {
        const l = ["touchstart", "touchmove", "touchend", "touchcancel"], u = ["pointerdown", "pointermove", "pointerup"];
        return i.touchEventsTouch = {
          start: l[0],
          move: l[1],
          end: l[2],
          cancel: l[3]
        }, i.touchEventsDesktop = {
          start: u[0],
          move: u[1],
          end: u[2]
        }, i.support.touch || !i.params.simulateTouch ? i.touchEventsTouch : i.touchEventsDesktop;
      }(),
      touchEventsData: {
        isTouched: void 0,
        isMoved: void 0,
        allowTouchCallbacks: void 0,
        touchStartTime: void 0,
        isScrolling: void 0,
        currentTranslate: void 0,
        startTranslate: void 0,
        allowThresholdMove: void 0,
        focusableElements: i.params.focusableElements,
        lastClickTime: ks(),
        clickTimeout: void 0,
        velocities: [],
        allowMomentumBounce: void 0,
        isTouchEvent: void 0,
        startMoving: void 0
      },
      allowClick: !0,
      allowTouchMove: i.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      imagesToLoad: [],
      imagesLoaded: 0
    }), i.emit("_swiper"), i.params.init && i.init(), i;
  }
  enable() {
    const e = this;
    e.enabled || (e.enabled = !0, e.params.grabCursor && e.setGrabCursor(), e.emit("enable"));
  }
  disable() {
    const e = this;
    !e.enabled || (e.enabled = !1, e.params.grabCursor && e.unsetGrabCursor(), e.emit("disable"));
  }
  setProgress(e, t) {
    const r = this;
    e = Math.min(Math.max(e, 0), 1);
    const i = r.minTranslate(), o = (r.maxTranslate() - i) * e + i;
    r.translateTo(o, typeof t > "u" ? 0 : t), r.updateActiveIndex(), r.updateSlidesClasses();
  }
  emitContainerClasses() {
    const e = this;
    if (!e.params._emitClasses || !e.el)
      return;
    const t = e.el.className.split(" ").filter((r) => r.indexOf("swiper") === 0 || r.indexOf(e.params.containerModifierClass) === 0);
    e.emit("_containerClasses", t.join(" "));
  }
  getSlideClasses(e) {
    const t = this;
    return t.destroyed ? "" : e.className.split(" ").filter((r) => r.indexOf("swiper-slide") === 0 || r.indexOf(t.params.slideClass) === 0).join(" ");
  }
  emitSlidesClasses() {
    const e = this;
    if (!e.params._emitClasses || !e.el)
      return;
    const t = [];
    e.slides.each((r) => {
      const i = e.getSlideClasses(r);
      t.push({
        slideEl: r,
        classNames: i
      }), e.emit("_slideClass", r, i);
    }), e.emit("_slideClasses", t);
  }
  slidesPerViewDynamic(e = "current", t = !1) {
    const r = this, {
      params: i,
      slides: s,
      slidesGrid: o,
      slidesSizesGrid: a,
      size: l,
      activeIndex: u
    } = r;
    let c = 1;
    if (i.centeredSlides) {
      let f = s[u].swiperSlideSize, p;
      for (let d = u + 1; d < s.length; d += 1)
        s[d] && !p && (f += s[d].swiperSlideSize, c += 1, f > l && (p = !0));
      for (let d = u - 1; d >= 0; d -= 1)
        s[d] && !p && (f += s[d].swiperSlideSize, c += 1, f > l && (p = !0));
    } else if (e === "current")
      for (let f = u + 1; f < s.length; f += 1)
        (t ? o[f] + a[f] - o[u] < l : o[f] - o[u] < l) && (c += 1);
    else
      for (let f = u - 1; f >= 0; f -= 1)
        o[u] - o[f] < l && (c += 1);
    return c;
  }
  update() {
    const e = this;
    if (!e || e.destroyed)
      return;
    const {
      snapGrid: t,
      params: r
    } = e;
    r.breakpoints && e.setBreakpoint(), e.updateSize(), e.updateSlides(), e.updateProgress(), e.updateSlidesClasses();
    function i() {
      const o = e.rtlTranslate ? e.translate * -1 : e.translate, a = Math.min(Math.max(o, e.maxTranslate()), e.minTranslate());
      e.setTranslate(a), e.updateActiveIndex(), e.updateSlidesClasses();
    }
    let s;
    e.params.freeMode && e.params.freeMode.enabled ? (i(), e.params.autoHeight && e.updateAutoHeight()) : ((e.params.slidesPerView === "auto" || e.params.slidesPerView > 1) && e.isEnd && !e.params.centeredSlides ? s = e.slideTo(e.slides.length - 1, 0, !1, !0) : s = e.slideTo(e.activeIndex, 0, !1, !0), s || i()), r.watchOverflow && t !== e.snapGrid && e.checkOverflow(), e.emit("update");
  }
  changeDirection(e, t = !0) {
    const r = this, i = r.params.direction;
    return e || (e = i === "horizontal" ? "vertical" : "horizontal"), e === i || e !== "horizontal" && e !== "vertical" || (r.$el.removeClass(`${r.params.containerModifierClass}${i}`).addClass(`${r.params.containerModifierClass}${e}`), r.emitContainerClasses(), r.params.direction = e, r.slides.each((s) => {
      e === "vertical" ? s.style.width = "" : s.style.height = "";
    }), r.emit("changeDirection"), t && r.update()), r;
  }
  changeLanguageDirection(e) {
    const t = this;
    t.rtl && e === "rtl" || !t.rtl && e === "ltr" || (t.rtl = e === "rtl", t.rtlTranslate = t.params.direction === "horizontal" && t.rtl, t.rtl ? (t.$el.addClass(`${t.params.containerModifierClass}rtl`), t.el.dir = "rtl") : (t.$el.removeClass(`${t.params.containerModifierClass}rtl`), t.el.dir = "ltr"), t.update());
  }
  mount(e) {
    const t = this;
    if (t.mounted)
      return !0;
    const r = ee(e || t.params.el);
    if (e = r[0], !e)
      return !1;
    e.swiper = t;
    const i = () => `.${(t.params.wrapperClass || "").trim().split(" ").join(".")}`;
    let o = (() => {
      if (e && e.shadowRoot && e.shadowRoot.querySelector) {
        const a = ee(e.shadowRoot.querySelector(i()));
        return a.children = (l) => r.children(l), a;
      }
      return r.children ? r.children(i()) : ee(r).children(i());
    })();
    if (o.length === 0 && t.params.createElements) {
      const l = Rt().createElement("div");
      o = ee(l), l.className = t.params.wrapperClass, r.append(l), r.children(`.${t.params.slideClass}`).each((u) => {
        o.append(u);
      });
    }
    return Object.assign(t, {
      $el: r,
      el: e,
      $wrapperEl: o,
      wrapperEl: o[0],
      mounted: !0,
      rtl: e.dir.toLowerCase() === "rtl" || r.css("direction") === "rtl",
      rtlTranslate: t.params.direction === "horizontal" && (e.dir.toLowerCase() === "rtl" || r.css("direction") === "rtl"),
      wrongRTL: o.css("display") === "-webkit-box"
    }), !0;
  }
  init(e) {
    const t = this;
    return t.initialized || t.mount(e) === !1 || (t.emit("beforeInit"), t.params.breakpoints && t.setBreakpoint(), t.addClasses(), t.params.loop && t.loopCreate(), t.updateSize(), t.updateSlides(), t.params.watchOverflow && t.checkOverflow(), t.params.grabCursor && t.enabled && t.setGrabCursor(), t.params.preloadImages && t.preloadImages(), t.params.loop ? t.slideTo(t.params.initialSlide + t.loopedSlides, 0, t.params.runCallbacksOnInit, !1, !0) : t.slideTo(t.params.initialSlide, 0, t.params.runCallbacksOnInit, !1, !0), t.attachEvents(), t.initialized = !0, t.emit("init"), t.emit("afterInit")), t;
  }
  destroy(e = !0, t = !0) {
    const r = this, {
      params: i,
      $el: s,
      $wrapperEl: o,
      slides: a
    } = r;
    return typeof r.params > "u" || r.destroyed || (r.emit("beforeDestroy"), r.initialized = !1, r.detachEvents(), i.loop && r.loopDestroy(), t && (r.removeClasses(), s.removeAttr("style"), o.removeAttr("style"), a && a.length && a.removeClass([i.slideVisibleClass, i.slideActiveClass, i.slideNextClass, i.slidePrevClass].join(" ")).removeAttr("style").removeAttr("data-swiper-slide-index")), r.emit("destroy"), Object.keys(r.eventsListeners).forEach((l) => {
      r.off(l);
    }), e !== !1 && (r.$el[0].swiper = null, fO(r)), r.destroyed = !0), null;
  }
  static extendDefaults(e) {
    kt(mc, e);
  }
  static get extendedDefaults() {
    return mc;
  }
  static get defaults() {
    return am;
  }
  static installModule(e) {
    Wt.prototype.__modules__ || (Wt.prototype.__modules__ = []);
    const t = Wt.prototype.__modules__;
    typeof e == "function" && t.indexOf(e) < 0 && t.push(e);
  }
  static use(e) {
    return Array.isArray(e) ? (e.forEach((t) => Wt.installModule(t)), Wt) : (Wt.installModule(e), Wt);
  }
}
Object.keys(hc).forEach((n) => {
  Object.keys(hc[n]).forEach((e) => {
    Wt.prototype[e] = hc[n][e];
  });
});
Wt.use([_O, SO]);
const Jf = (n) => n != null, kE = (n) => !Jf(n);
function Qo(n, e = (t) => t !== void 0) {
  return AE(n) ? n.map((t) => Qo(t, e)).filter(e) : Zo(n) ? Object.fromEntries(Object.entries(n).map((t) => Qo(t, e)).filter(([t, r]) => Qo(r, e))) : n;
}
const ME = (n, e) => Jf(n) ? n : e, Zo = (n) => toString.call(n) === "[object Object]", AE = (n) => Array.isArray(n), ib = (n) => typeof n == "number", PE = (n) => typeof n == "string", $E = (n) => ib(n) ? n : Number(n), DE = (n) => new Intl.NumberFormat("vi-VN").format($E(n)), lm = "\\x41-\\x5a\\xc0-\\xd6\\xd8-\\xde\\u0100\\u0102\\u0104\\u0106\\u0108\\u010a\\u010c\\u010e\\u0110\\u0112\\u0114\\u0116\\u0118\\u011a\\u011c\\u011e\\u0120\\u0122\\u0124\\u0126\\u0128\\u012a\\u012c\\u012e\\u0130\\u0132\\u0134\\u0136\\u0139\\u013b\\u013d\\u013f\\u0141\\u0143\\u0145\\u0147\\u014a\\u014c\\u014e\\u0150\\u0152\\u0154\\u0156\\u0158\\u015a\\u015c\\u015e\\u0160\\u0162\\u0164\\u0166\\u0168\\u016a\\u016c\\u016e\\u0170\\u0172\\u0174\\u0176\\u0178\\u0179\\u017b\\u017d\\u0181\\u0182\\u0184\\u0186\\u0187\\u0189-\\u018b\\u018e-\\u0191\\u0193\\u0194\\u0196-\\u0198\\u019c\\u019d\\u019f\\u01a0\\u01a2\\u01a4\\u01a6\\u01a7\\u01a9\\u01ac\\u01ae\\u01af\\u01b1-\\u01b3\\u01b5\\u01b7\\u01b8\\u01bc\\u01c4\\u01c5\\u01c7\\u01c8\\u01ca\\u01cb\\u01cd\\u01cf\\u01d1\\u01d3\\u01d5\\u01d7\\u01d9\\u01db\\u01de\\u01e0\\u01e2\\u01e4\\u01e6\\u01e8\\u01ea\\u01ec\\u01ee\\u01f1\\u01f2\\u01f4\\u01f6-\\u01f8\\u01fa\\u01fc\\u01fe\\u0200\\u0202\\u0204\\u0206\\u0208\\u020a\\u020c\\u020e\\u0210\\u0212\\u0214\\u0216\\u0218\\u021a\\u021c\\u021e\\u0220\\u0222\\u0224\\u0226\\u0228\\u022a\\u022c\\u022e\\u0230\\u0232\\u023a\\u023b\\u023d\\u023e\\u0241\\u0243-\\u0246\\u0248\\u024a\\u024c\\u024e", um = "a-z\\xB5\\xDF-\\xF6\\xF8-\\xFF\\u0101\\u0103\\u0105\\u0107\\u0109\\u010B\\u010D\\u010F\\u0111\\u0113\\u0115\\u0117\\u0119\\u011B\\u011D\\u011F\\u0121\\u0123\\u0125\\u0127\\u0129\\u012B\\u012D\\u012F\\u0131\\u0133\\u0135\\u0137\\u0138\\u013A\\u013C\\u013E\\u0140\\u0142\\u0144\\u0146\\u0148\\u0149\\u014B\\u014D\\u014F\\u0151\\u0153\\u0155\\u0157\\u0159\\u015B\\u015D\\u015F\\u0161\\u0163\\u0165\\u0167\\u0169\\u016B\\u016D\\u016F\\u0171\\u0173\\u0175\\u0177\\u017A\\u017C\\u017E-\\u0180\\u0183\\u0185\\u0188\\u018C\\u018D\\u0192\\u0195\\u0199-\\u019B\\u019E\\u01A1\\u01A3\\u01A5\\u01A8\\u01AA\\u01AB\\u01AD\\u01B0\\u01B4\\u01B6\\u01B9\\u01BA\\u01BD-\\u01BF\\u01C6\\u01C9\\u01CC\\u01CE\\u01D0\\u01D2\\u01D4\\u01D6\\u01D8\\u01DA\\u01DC\\u01DD\\u01DF\\u01E1\\u01E3\\u01E5\\u01E7\\u01E9\\u01EB\\u01ED\\u01EF\\u01F0\\u01F3\\u01F5\\u01F9\\u01FB\\u01FD\\u01FF\\u0201\\u0203\\u0205\\u0207\\u0209\\u020B\\u020D\\u020F\\u0211\\u0213\\u0215\\u0217\\u0219\\u021B\\u021D\\u021F\\u0221\\u0223\\u0225\\u0227\\u0229\\u022B\\u022D\\u022F\\u0231\\u0233-\\u0239\\u023C\\u023F\\u0240\\u0242\\u0247\\u0249\\u024B\\u024D\\u024F", gc = "\\u0300-\\u036F\\u1AB0-\\u1AFF\\u1DC0-\\u1DFF\\u20D0-\\u20FF\\uFE20-\\uFE2F", LE = "\\d", NE = "\\u2700-\\u27BF", IE = "\\s\\uFEFF\\xA0", RE = "\\x00-\\x2F\\x3A-\\x40\\x5B-\\x60\\x7b-\\xBF\\xD7\\xF7", FE = "\\u2000-\\u206F", zE = new RegExp("(?:[" + lm + "][" + gc + "]*)?(?:[" + um + "][" + gc + "]*)+|(?:[" + lm + "][" + gc + "]*)+(?![" + um + "])|[" + LE + "]+|[" + NE + "]|[^" + RE + FE + IE + "]+", "g"), BE = /^[\x01-\xFF]*$/, jE = /[A-Z\xC0-\xD6\xD8-\xDE]?[a-z\xDF-\xF6\xF8-\xFF]+|[A-Z\xC0-\xD6\xD8-\xDE]+(?![a-z\xDF-\xF6\xF8-\xFF])|\d+/g, sb = (n, e = "") => kE(n) ? e : PE(n) ? n : String(n), VE = (n, e) => {
  const t = sb(n), r = Jf(e) ? e : BE.test(t) ? jE : zE;
  return ME(t.match(r), []);
}, HE = (n) => sb(n).toLowerCase(), WE = (n) => VE(n).map(HE).join("-"), qE = (n) => {
  const e = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/, t = n.match(e);
  return t && t[2].length === 11 ? t[2] : null;
}, UE = (n) => {
  const e = "https://www.youtube.com/embed", t = qE(n);
  return t ? [e, t].join("/") : null;
}, Dl = Symbol("swiperContextKey"), GE = Symbol("slideContextKey");
const KE = Ce({
  name: "TSwiper",
  props: {
    modules: { type: Array, default: () => [] },
    updateOnWindowResize: { type: Boolean, default: void 0 },
    resizeObserver: { type: Boolean, default: void 0 },
    initialSlide: { type: Number, default: 0 },
    direction: {
      type: String,
      default: "horizontal"
    },
    speed: { type: Number, default: 300 },
    setWrapperSize: { type: Boolean, default: !1 },
    virtualTranslate: { type: Boolean, default: !1 },
    width: { type: Number, default: void 0 },
    height: { type: Number, default: void 0 },
    autoHeight: { type: Boolean, default: !1 },
    roundLengths: { type: Boolean, default: !1 },
    nested: { type: Boolean, default: !1 },
    createElements: { type: Boolean, default: !1 },
    focusableElements: { type: String, default: void 0 },
    uniqueNavElements: { type: Boolean, default: !0 },
    effect: {
      type: String,
      default: "slide"
    },
    runCallbacksOnInit: { type: Boolean, default: !0 },
    watchOverflow: { type: Boolean, default: !0 },
    userAgent: { type: String, default: void 0 },
    url: { type: String, default: void 0 },
    cssMode: { type: Boolean, default: !1 },
    spaceBetween: { type: Number, default: 0 },
    slidesPerView: {
      type: [Number, String],
      default: 1
    },
    maxBackfaceHiddenSlides: { type: Number, default: 10 },
    slidesPerGroup: { type: Number, default: 1 },
    slidesPerGroupSkip: { type: Number, default: 0 },
    slidesPerGroupAuto: { type: Boolean, default: !1 },
    centeredSlides: { type: Boolean, default: !1 },
    centeredSlidesBounds: { type: Boolean, default: !1 },
    slidesOffsetBefore: { type: Number, default: 0 },
    slidesOffsetAfter: { type: Number, default: 0 },
    normalizeSlideIndex: { type: Boolean, default: !0 },
    centerInsufficientSlides: { type: Boolean, default: !1 },
    grabCursor: { type: Boolean, default: !1 },
    touchEventsTarget: {
      type: String,
      default: "wrapper"
    },
    touchRatio: { type: Number, default: 1 },
    touchAngle: { type: Number, default: 45 },
    simulateTouch: { type: Boolean, default: !0 },
    shortSwipes: { type: Boolean, default: !0 },
    longSwipes: { type: Boolean, default: !0 },
    longSwipesRatio: { type: Number, default: 0.5 },
    longSwipesMs: { type: Number, default: 300 },
    followFinger: { type: Boolean, default: !0 },
    allowTouchMove: { type: Boolean, default: !0 },
    threshold: { type: Number, default: 0 },
    touchStartPreventDefault: { type: Boolean, default: !0 },
    touchStartForcePreventDefault: { type: Boolean, default: !1 },
    touchMoveStopPropagation: { type: Boolean, default: !1 },
    edgeSwipeDetection: { type: [Boolean, String], default: !1 },
    edgeSwipeThreshold: { type: Number, default: 20 },
    touchReleaseOnEdges: { type: Boolean, default: !1 },
    passiveListeners: { type: Boolean, default: !0 },
    resistance: { type: Boolean, default: !0 },
    resistanceRatio: { type: Number, default: 0.85 },
    preventInteractionOnTransition: { type: Boolean, default: !1 },
    allowSlidePrev: { type: Boolean, default: !0 },
    allowSlideNext: { type: Boolean, default: !0 },
    noSwiping: { type: Boolean, default: !0 },
    noSwipingClass: { type: String, default: "swiper-no-swiping" },
    noSwipingSelector: { type: String, default: void 0 },
    swipeHandler: { type: String, default: void 0 },
    preventClicks: { type: Boolean, default: !0 },
    preventClicksPropagation: { type: Boolean, default: !0 },
    slideToClickedSlide: { type: Boolean, default: !1 },
    watchSlidesProgress: { type: Boolean, default: !1 },
    preloadImages: { type: Boolean, default: !0 },
    updateOnImagesReady: { type: Boolean, default: !0 },
    loop: { type: Boolean, default: !1 },
    rewind: { type: Boolean, default: !1 },
    loopAdditionalSlides: { type: Number, default: 0 },
    loopedSlides: { type: Number, default: void 0 },
    loopFillGroupWithBlank: { type: Boolean, default: !1 },
    loopPreventsSlide: { type: Boolean, default: !0 },
    breakpoints: {
      type: Object,
      default: void 0
    },
    breakpointsBase: { type: String, default: "window" },
    observer: { type: Boolean, default: !1 },
    observeSlideChildren: { type: Boolean, default: !1 },
    observeParents: { type: Boolean, default: !1 },
    containerModifierClass: { type: String, default: "swiper-" },
    slideClass: { type: String, default: void 0 },
    slideActiveClass: { type: String, default: void 0 },
    slideDuplicateActiveClass: { type: String, default: void 0 },
    slideVisibleClass: { type: String, default: void 0 },
    slideDuplicateClass: { type: String, default: void 0 },
    slideNextClass: { type: String, default: void 0 },
    slideDuplicateNextClass: { type: String, default: void 0 },
    slidePrevClass: { type: String, default: void 0 },
    slideDuplicatePrevClass: { type: String, default: void 0 },
    slideBlankClass: { type: String, default: void 0 },
    wrapperClass: { type: String, default: void 0 },
    a11y: { type: Object, default: void 0 },
    autoplay: {
      type: [Object, Boolean],
      default: void 0
    },
    controller: {
      type: Object,
      default: void 0
    },
    coverflowEffect: {
      type: Object,
      default: void 0
    },
    cubeEffect: {
      type: Object,
      default: void 0
    },
    fadeEffect: {
      type: Object,
      default: void 0
    },
    flipEffect: {
      type: Object,
      default: void 0
    },
    creativeEffect: {
      type: Object,
      default: void 0
    },
    cardsEffect: {
      type: Object,
      default: void 0
    },
    hashNavigation: {
      type: [Object, Boolean],
      default: void 0
    },
    history: {
      type: [Object, Boolean],
      default: void 0
    },
    keyboard: {
      type: [Object, Boolean],
      default: void 0
    },
    lazy: {
      type: [Object, Boolean],
      default: void 0
    },
    mousewheel: {
      type: [Object, Boolean],
      default: void 0
    },
    navigation: {
      type: [Object, Boolean],
      default: void 0
    },
    pagination: {
      type: [Object, Boolean],
      default: void 0
    },
    parallax: {
      type: [Object, Boolean],
      default: void 0
    },
    scrollbar: {
      type: [Object, Boolean],
      default: void 0
    },
    thumbs: { type: Object, default: void 0 },
    virtual: {
      type: [Object, Boolean],
      default: void 0
    },
    zoom: {
      type: [Object, Boolean],
      default: void 0
    },
    freeMode: {
      type: [Object, Boolean],
      default: void 0
    },
    grid: { type: Object, default: void 0 }
  },
  emits: [
    "_beforeBreakpoint",
    "_containerClasses",
    "_slideClass",
    "_slideClasses",
    "_swiper",
    "_freeModeNoMomentumRelease",
    "activeIndexChange",
    "afterInit",
    "autoplay",
    "autoplayStart",
    "autoplayStop",
    "autoplayPause",
    "autoplayResume",
    "beforeDestroy",
    "beforeInit",
    "beforeLoopFix",
    "beforeResize",
    "beforeSlideChangeStart",
    "beforeTransitionStart",
    "breakpoint",
    "changeDirection",
    "click",
    "disable",
    "doubleTap",
    "doubleClick",
    "destroy",
    "enable",
    "fromEdge",
    "hashChange",
    "hashSet",
    "imagesReady",
    "init",
    "keyPress",
    "lazyImageLoad",
    "lazyImageReady",
    "lock",
    "loopFix",
    "momentumBounce",
    "navigationHide",
    "navigationShow",
    "observerUpdate",
    "orientationchange",
    "paginationHide",
    "paginationRender",
    "paginationShow",
    "paginationUpdate",
    "progress",
    "reachBeginning",
    "reachEnd",
    "realIndexChange",
    "resize",
    "scroll",
    "scrollbarDragEnd",
    "scrollbarDragMove",
    "scrollbarDragStart",
    "setTransition",
    "setTranslate",
    "slideChange",
    "slideChangeTransitionEnd",
    "slideChangeTransitionStart",
    "slideNextTransitionEnd",
    "slideNextTransitionStart",
    "slidePrevTransitionEnd",
    "slidePrevTransitionStart",
    "slideResetTransitionStart",
    "slideResetTransitionEnd",
    "sliderMove",
    "sliderFirstMove",
    "slidesLengthChange",
    "slidesGridLengthChange",
    "snapGridLengthChange",
    "snapIndexChange",
    "swiper",
    "tap",
    "toEdge",
    "touchEnd",
    "touchMove",
    "touchMoveOpposite",
    "touchStart",
    "transitionEnd",
    "transitionStart",
    "unlock",
    "update",
    "zoomChange"
  ],
  setup(n, { emit: e }) {
    const t = Le(), r = Le(), i = Le(), s = Le(), o = Le(), a = Le();
    return Us(() => {
      if (!r.value)
        return;
      const l = n.navigation ? { nextEl: i.value, prevEl: s.value, ...Zo(n.navigation) ? n.navigation : {} } : !1, u = n.pagination ? { el: o.value, ...Zo(n.pagination) ? n.pagination : {} } : !1, c = n.scrollbar ? { el: a.value, ...Zo(n.scrollbar) ? n.scrollbar : {} } : !1;
      t.value = new Wt(r.value, {
        ...Qo(n),
        navigation: l,
        pagination: u,
        scrollbar: c,
        onAny(f, ...p) {
          e(f, p);
        },
        _emitClasses: !0,
        init: !0
      }), setTimeout(() => {
        try {
          t.value && t.value.emitSlidesClasses();
        } catch {
        }
      }), e("swiper", t.value);
    }), zr(() => n.thumbs, (l, u) => {
      !t.value || (l && l.swiper && u && !u.swiper && (t.value.thumbs.swiper = l.swiper, t.value.thumbs.init(), t.value.thumbs.update(!0)), t.value.update());
    }), bl(() => {
      t.value && !t.value.destroyed && t.value.destroy(!0, !1);
    }), Es(Dl, t), {
      swiperElRef: r,
      prevElRef: s,
      nextElRef: i,
      scrollbarElRef: a,
      paginationElRef: o,
      swiperRef: t
    };
  }
});
var JE = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { ref: "swiperElRef", staticClass: "t-swiper swiper" }, [e._t("container-start"), e.navigation ? [t("div", { ref: "prevElRef", staticClass: "swiper-button-prev" }), t("div", { ref: "nextElRef", staticClass: "swiper-button-next" })] : e._e(), e.scrollbar ? [t("div", { ref: "scrollbarElRef", staticClass: "swiper-scrollbar" })] : e._e(), t("div", { staticClass: "swiper-wrapper" }, [e._t("wrapper-start"), e._t("default"), e._t("wrapper-end")], 2), e.pagination ? [t("div", { ref: "paginationElRef", staticClass: "swiper-pagination" })] : e._e(), e._t("container-end")], 2);
}, XE = [], YE = /* @__PURE__ */ le(
  KE,
  JE,
  XE,
  !1,
  null,
  null,
  null,
  null
);
const QE = YE.exports;
const ZE = Ce({
  name: "TSwiperSlide",
  props: {
    zoom: { type: Boolean, default: !1 }
  },
  setup() {
    const n = Le(), e = Bi(Dl), t = Le("swiper-slide"), r = nS({
      isActive: ve(() => t.value.includes("swiper-slide-active") || t.value.includes("swiper-slide-duplicate-active")),
      isThumbActive: ve(() => t.value.includes("swiper-slide-thumb-active") || t.value.includes("swiper-slide-thumb-duplicate-active")),
      isVisible: ve(() => t.value.includes("swiper-slide-visible")),
      isDuplicate: ve(() => t.value.includes("swiper-slide-duplicate")),
      isPrev: ve(() => t.value.includes("swiper-slide-prev") || t.value.includes("swiper-slide-duplicate-prev")),
      isNext: ve(() => t.value.includes("swiper-slide-next") || t.value.includes("swiper-slide-duplicate-next"))
    }), i = (o, a, l) => {
      a === n.value && (t.value = l);
    }, s = sy(() => {
      !(e != null && e.value) || (e.value.on("_slideClass", i), s == null || s());
    });
    return bl(() => {
      !(e != null && e.value) || e.value.off("_slideClass", i);
    }), Es(GE, r), {
      slideElRef: n,
      swiperRef: e,
      slideClasses: t,
      slideContext: r,
      isNumber: ib
    };
  }
});
var eT = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", e._g({ ref: "slideElRef", staticClass: "t-swiper-slide swiper-slide" }, e.$listeners), [e.zoom ? t("div", { staticClass: "swiper-zoom-container", attrs: { "data-swiper-zoom": e.isNumber(e.zoom) && e.zoom } }, [e._t("default", null, null, e.slideContext)], 2) : e._t("default", null, null, e.slideContext)], 2);
}, tT = [], nT = /* @__PURE__ */ le(
  ZE,
  eT,
  tT,
  !1,
  null,
  null,
  null,
  null
);
const rT = nT.exports;
Ce({
  name: "TSwiperNext",
  props: {
    swiper: {
      type: Object,
      default: null
    }
  },
  setup(n) {
    const e = Bi(Dl), t = ve(() => n.swiper || (e == null ? void 0 : e.value)), r = ve(() => t.value ? t.value.isEnd : !1);
    return { onClick: () => {
      !t.value || t.value.slideNext();
    }, isDisabled: r };
  }
});
Ce({
  name: "TSwiperPrev",
  props: {
    swiper: {
      type: Object,
      default: null
    }
  },
  setup(n) {
    const e = Bi(Dl), t = ve(() => n.swiper || (e == null ? void 0 : e.value)), r = ve(() => t.value ? t.value.isBeginning : !1);
    return { onClick: () => {
      !t.value || t.value.slidePrev();
    }, isDisabled: r };
  }
});
var Md = function(n, e) {
  return Md = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, r) {
    t.__proto__ = r;
  } || function(t, r) {
    for (var i in r)
      Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
  }, Md(n, e);
};
function iT(n, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  Md(n, e);
  function t() {
    this.constructor = n;
  }
  n.prototype = e === null ? Object.create(e) : (t.prototype = e.prototype, new t());
}
function ob(n) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && n[e], r = 0;
  if (t)
    return t.call(n);
  if (n && typeof n.length == "number")
    return {
      next: function() {
        return n && r >= n.length && (n = void 0), { value: n && n[r++], done: !n };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function sT(n) {
  var e;
  pt(n, (e = Xs()) === null || e === void 0 ? void 0 : e.proxy);
}
var fa, Co = [], ab = function() {
  function n(e) {
    this.active = !0, this.effects = [], this.cleanups = [], this.vm = e;
  }
  return n.prototype.run = function(e) {
    if (this.active)
      try {
        return this.on(), e();
      } finally {
        this.off();
      }
    else
      process.env.NODE_ENV !== "production" && sT("cannot run an inactive effect scope.");
  }, n.prototype.on = function() {
    this.active && (Co.push(this), fa = this);
  }, n.prototype.off = function() {
    this.active && (Co.pop(), fa = Co[Co.length - 1]);
  }, n.prototype.stop = function() {
    this.active && (this.vm.$destroy(), this.effects.forEach(function(e) {
      return e.stop();
    }), this.cleanups.forEach(function(e) {
      return e();
    }), this.active = !1);
  }, n;
}();
(function(n) {
  iT(e, n);
  function e(t) {
    t === void 0 && (t = !1);
    var r = this, i = void 0;
    return fT(function() {
      i = Ll(Vi());
    }), r = n.call(this, i) || this, t || oT(r), r;
  }
  return e;
})(ab);
function oT(n, e) {
  var t;
  if (e = e || fa, e && e.active) {
    e.effects.push(n);
    return;
  }
  var r = (t = Xs()) === null || t === void 0 ? void 0 : t.proxy;
  r && r.$on("hook:destroyed", function() {
    return n.stop();
  });
}
function aT() {
  return fa;
}
function lT() {
  var n, e;
  return ((n = aT()) === null || n === void 0 ? void 0 : n.vm) || ((e = Xs()) === null || e === void 0 ? void 0 : e.proxy);
}
function uT(n) {
  if (!n.scope) {
    var e = new ab(n.proxy);
    n.scope = e, n.proxy.$on("hook:destroyed", function() {
      return e.stop();
    });
  }
  return n.scope;
}
var Ad = void 0;
try {
  var br = require("vue");
  br && cm(br) ? Ad = br : br && "default" in br && cm(br.default) && (Ad = br.default);
} catch {
}
var $r = null, di = null, ea = !0, lb = "__composition_api_installed__";
function cm(n) {
  return n && Yn(n) && n.name === "Vue";
}
function cT(n) {
  return $r && Sn(n, lb);
}
function Vi() {
  return process.env.NODE_ENV !== "production" && Xf($r, "must call Vue.use(VueCompositionAPI) before using any function."), $r;
}
function ub() {
  var n = $r || Ad;
  return process.env.NODE_ENV !== "production" && Xf(n, "No vue dependency found."), n;
}
function dT(n) {
  process.env.NODE_ENV !== "production" && $r && n.__proto__ !== $r.__proto__ && pt("[vue-composition-api] another instance of Vue installed"), $r = n, Object.defineProperty(n, lb, {
    configurable: !0,
    writable: !0,
    value: !0
  });
}
function fT(n) {
  var e = ea;
  ea = !1;
  try {
    n();
  } finally {
    ea = e;
  }
}
function dm(n) {
  if (!!ea) {
    var e = di;
    e == null || e.scope.off(), di = n, di == null || di.scope.on();
  }
}
function Xs() {
  return di;
}
var vc = /* @__PURE__ */ new WeakMap();
function pa(n) {
  if (vc.has(n))
    return vc.get(n);
  var e = {
    proxy: n,
    update: n.$forceUpdate,
    type: n.$options,
    uid: n._uid,
    emit: n.$emit.bind(n),
    parent: null,
    root: null
  };
  uT(e);
  var t = [
    "data",
    "props",
    "attrs",
    "refs",
    "vnode",
    "slots"
  ];
  return t.forEach(function(r) {
    ft(e, r, {
      get: function() {
        return n["$".concat(r)];
      }
    });
  }), ft(e, "isMounted", {
    get: function() {
      return n._isMounted;
    }
  }), ft(e, "isUnmounted", {
    get: function() {
      return n._isDestroyed;
    }
  }), ft(e, "isDeactivated", {
    get: function() {
      return n._inactive;
    }
  }), ft(e, "emitted", {
    get: function() {
      return n._events;
    }
  }), vc.set(n, e), n.$parent && (e.parent = pa(n.$parent)), n.$root && (e.root = pa(n.$root)), e;
}
var pT = function(n) {
  return Object.prototype.toString.call(n);
};
function fm(n) {
  return typeof n == "function" && /native code/.test(n.toString());
}
var hT = typeof Symbol < "u" && fm(Symbol) && typeof Reflect < "u" && fm(Reflect.ownKeys), kr = function(n) {
  return n;
};
function ft(n, e, t) {
  var r = t.get, i = t.set;
  Object.defineProperty(n, e, {
    enumerable: !0,
    configurable: !0,
    get: r || kr,
    set: i || kr
  });
}
function cb(n, e, t, r) {
  Object.defineProperty(n, e, {
    value: t,
    enumerable: !!r,
    writable: !0,
    configurable: !0
  });
}
function Sn(n, e) {
  return Object.hasOwnProperty.call(n, e);
}
function Xf(n, e) {
  if (!n)
    throw new Error("[vue-composition-api] ".concat(e));
}
function mT(n) {
  return typeof n == "string" || typeof n == "number" || typeof n == "symbol" || typeof n == "boolean";
}
function Oi(n) {
  return Array.isArray(n);
}
var gT = 4294967295;
function vT(n) {
  var e = parseFloat(String(n));
  return e >= 0 && Math.floor(e) === e && isFinite(n) && e <= gT;
}
function ha(n) {
  return n !== null && typeof n == "object";
}
function dr(n) {
  return pT(n) === "[object Object]";
}
function Yn(n) {
  return typeof n == "function";
}
function yT(n) {
  return n == null;
}
function pt(n, e) {
  var t = ub();
  !t || !t.util ? console.warn("[vue-composition-api] ".concat(n)) : t.util.warn(n, e);
}
function Ll(n, e) {
  e === void 0 && (e = {});
  var t = n.config.silent;
  n.config.silent = !0;
  var r = new n(e);
  return n.config.silent = t, r;
}
function bT(n) {
  var e = Vi();
  return e && n instanceof e;
}
function wT(n, e) {
  return function() {
    for (var t = [], r = 0; r < arguments.length; r++)
      t[r] = arguments[r];
    return n.$scopedSlots[e] ? n.$scopedSlots[e].apply(n, t) : process.env.NODE_ENV !== "production" ? pt("slots.".concat(e, '() got called outside of the "render()" scope'), n) : void 0;
  };
}
function _T(n, e) {
  var t;
  if (!n)
    t = {};
  else {
    if (n._normalized)
      return n._normalized;
    t = {};
    for (var r in n)
      n[r] && r[0] !== "$" && (t[r] = !0);
  }
  for (var r in e)
    r in t || (t[r] = !0);
  return t;
}
var yc, ST = function() {
  if (!yc) {
    var n = Ll(Vi(), {
      computed: {
        value: function() {
          return 0;
        }
      }
    }), e = n._computedWatchers.value.constructor, t = n._data.__ob__.dep.constructor;
    yc = {
      Watcher: e,
      Dep: t
    }, n.$destroy();
  }
  return yc;
}, fs = "composition-api.refKey", pm = /* @__PURE__ */ new WeakMap(), xT = /* @__PURE__ */ new WeakMap();
function CT(n, e, t) {
  var r = Vi(), i = r.util, s = i.warn, o = i.defineReactive;
  process.env.NODE_ENV !== "production" && (yT(n) || mT(n)) && s("Cannot set reactive property on undefined, null, or primitive value: ".concat(n));
  var a = n.__ob__;
  function l() {
    a && ha(t) && !Sn(t, "__ob__") && Qf(t);
  }
  if (Oi(n)) {
    if (vT(e))
      return n.length = Math.max(n.length, e), n.splice(e, 1, t), l(), t;
    if (e === "length" && t !== n.length)
      return n.length = t, a == null || a.dep.notify(), t;
  }
  return e in n && !(e in Object.prototype) ? (n[e] = t, l(), t) : n._isVue || a && a.vmCount ? (process.env.NODE_ENV !== "production" && s("Avoid adding reactive properties to a Vue instance or its root $data at runtime - declare it upfront in the data option."), t) : a ? (o(a.value, e, t), pb(n, e, t), l(), a.dep.notify(), t) : (n[e] = t, t);
}
var db = function() {
  function n(e) {
    var t = e.get, r = e.set;
    ft(this, "value", {
      get: t,
      set: r
    });
  }
  return n;
}();
function Yf(n, e, t) {
  e === void 0 && (e = !1), t === void 0 && (t = !1);
  var r = new db(n);
  t && (r.effect = !0);
  var i = Object.seal(r);
  return e && xT.set(i, !0), i;
}
function hm(n) {
  var e;
  if (ht(n))
    return n;
  var t = mb((e = {}, e[fs] = n, e));
  return Yf({
    get: function() {
      return t[fs];
    },
    set: function(r) {
      return t[fs] = r;
    }
  });
}
function ht(n) {
  return n instanceof db;
}
function OT(n) {
  if (process.env.NODE_ENV !== "production" && !gi(n) && pt("toRefs() expects a reactive object but received a plain one."), !dr(n))
    return n;
  var e = {};
  for (var t in n)
    e[t] = ET(n, t);
  return e;
}
function ET(n, e) {
  e in n || CT(n, e, void 0);
  var t = n[e];
  return ht(t) ? t : Yf({
    get: function() {
      return n[e];
    },
    set: function(r) {
      return n[e] = r;
    }
  });
}
var fb = "__v_skip";
function Ei(n) {
  var e;
  return Boolean(n && Sn(n, "__ob__") && typeof n.__ob__ == "object" && ((e = n.__ob__) === null || e === void 0 ? void 0 : e[fb]));
}
function gi(n) {
  var e;
  return Boolean(n && Sn(n, "__ob__") && typeof n.__ob__ == "object" && !(!((e = n.__ob__) === null || e === void 0) && e[fb]));
}
function Pd(n) {
  if (!(!dr(n) || Ei(n) || Oi(n) || ht(n) || bT(n) || pm.has(n))) {
    pm.set(n, !0);
    for (var e = Object.keys(n), t = 0; t < e.length; t++)
      pb(n, e[t]);
  }
}
function pb(n, e, t) {
  if (e !== "__ob__" && !Ei(n[e])) {
    var r, i, s = Object.getOwnPropertyDescriptor(n, e);
    if (s) {
      if (s.configurable === !1)
        return;
      r = s.get, i = s.set, (!r || i) && arguments.length === 2 && (t = n[e]);
    }
    Pd(t), ft(n, e, {
      get: function() {
        var a = r ? r.call(n) : t;
        return e !== fs && ht(a) ? a.value : a;
      },
      set: function(a) {
        r && !i || (e !== fs && ht(t) && !ht(a) ? t.value = a : (i && i.call(n, a), t = a), Pd(a));
      }
    });
  }
}
function hb(n) {
  var e = ub(), t;
  if (e.observable)
    t = e.observable(n);
  else {
    var r = Ll(e, {
      data: {
        $$state: n
      }
    });
    t = r._data.$$state;
  }
  return Sn(t, "__ob__") || Qf(t), t;
}
function Qf(n, e) {
  var t, r;
  if (e === void 0 && (e = /* @__PURE__ */ new Set()), !(e.has(n) || Sn(n, "__ob__") || !Object.isExtensible(n))) {
    cb(n, "__ob__", TT(n)), e.add(n);
    try {
      for (var i = ob(Object.keys(n)), s = i.next(); !s.done; s = i.next()) {
        var o = s.value, a = n[o];
        !(dr(a) || Oi(a)) || Ei(a) || !Object.isExtensible(a) || Qf(a, e);
      }
    } catch (l) {
      t = { error: l };
    } finally {
      try {
        s && !s.done && (r = i.return) && r.call(i);
      } finally {
        if (t)
          throw t.error;
      }
    }
  }
}
function TT(n) {
  return n === void 0 && (n = {}), {
    value: n,
    dep: {
      notify: kr,
      depend: kr,
      addSub: kr,
      removeSub: kr
    }
  };
}
function kT() {
  return hb({}).__ob__;
}
function mb(n) {
  if (!ha(n))
    return process.env.NODE_ENV !== "production" && pt('"reactive()" must be called on an object.'), n;
  if (!(dr(n) || Oi(n)) || Ei(n) || !Object.isExtensible(n))
    return n;
  var e = hb(n);
  return Pd(e), e;
}
function Oo(n) {
  var e = lT(), t, r;
  Yn(n) ? t = n : (t = n.get, r = n.set);
  var i, s;
  if (e && !e.$isServer) {
    var o = ST(), a = o.Watcher, l = o.Dep, u;
    s = function() {
      return u || (u = new a(e, t, kr, { lazy: !0 })), u.dirty && u.evaluate(), l.target && u.depend(), u.value;
    }, i = function(f) {
      if (process.env.NODE_ENV !== "production" && !r) {
        pt("Write operation failed: computed value is readonly.", e);
        return;
      }
      r && r(f);
    };
  } else {
    var c = Ll(Vi(), {
      computed: {
        $$state: {
          get: t,
          set: r
        }
      }
    });
    e && e.$on("hook:destroyed", function() {
      return c.$destroy();
    }), s = function() {
      return c.$$state;
    }, i = function(f) {
      if (process.env.NODE_ENV !== "production" && !r) {
        pt("Write operation failed: computed value is readonly.", e);
        return;
      }
      c.$$state = f;
    };
  }
  return Yf({
    get: s,
    set: i
  }, !r, !0);
}
process.env.NODE_ENV !== "production" && Object.freeze({});
function MT(n, e, t) {
  var r = n.__composition_api_state__ = n.__composition_api_state__ || {};
  r[e] = t;
}
function AT(n, e) {
  return (n.__composition_api_state__ || {})[e];
}
var ir = {
  set: MT,
  get: AT
};
function PT(n, e, t) {
  var r = n.$options.props;
  !(e in n) && !(r && Sn(r, e)) ? (ht(t) ? ft(n, e, {
    get: function() {
      return t.value;
    },
    set: function(i) {
      t.value = i;
    }
  }) : ft(n, e, {
    get: function() {
      return gi(t) && t.__ob__.dep.depend(), t;
    },
    set: function(i) {
      t = i;
    }
  }), process.env.NODE_ENV !== "production" && n.$nextTick(function() {
    Object.keys(n._data).indexOf(e) === -1 && (ht(t) ? ft(n._data, e, {
      get: function() {
        return t.value;
      },
      set: function(i) {
        t.value = i;
      }
    }) : ft(n._data, e, {
      get: function() {
        return t;
      },
      set: function(i) {
        t = i;
      }
    }));
  })) : process.env.NODE_ENV !== "production" && (r && Sn(r, e) ? pt('The setup binding property "'.concat(e, '" is already declared as a prop.'), n) : pt('The setup binding property "'.concat(e, '" is already declared.'), n));
}
function $T(n) {
  var e = ir.get(n, "rawBindings") || {};
  if (!(!e || !Object.keys(e).length)) {
    for (var t = n.$refs, r = ir.get(n, "refs") || [], i = 0; i < r.length; i++) {
      var s = r[i], o = e[s];
      !t[s] && o && ht(o) && (o.value = null);
    }
    for (var a = Object.keys(t), l = [], i = 0; i < a.length; i++) {
      var s = a[i], o = e[s];
      t[s] && o && ht(o) && (o.value = t[s], l.push(s));
    }
    ir.set(n, "refs", l);
  }
}
function mm(n) {
  for (var e = [n._vnode]; e.length; ) {
    var t = e.pop();
    if (t && (t.context && $T(t.context), t.children))
      for (var r = 0; r < t.children.length; ++r)
        e.push(t.children[r]);
  }
}
function gm(n, e) {
  var t, r;
  if (!!n) {
    var i = ir.get(n, "attrBindings");
    if (!(!i && !e)) {
      if (!i) {
        var s = mb({});
        i = { ctx: e, data: s }, ir.set(n, "attrBindings", i), ft(e, "attrs", {
          get: function() {
            return i == null ? void 0 : i.data;
          },
          set: function() {
            process.env.NODE_ENV !== "production" && pt("Cannot assign to '$attrs' because it is a read-only property", n);
          }
        });
      }
      var o = n.$attrs, a = function(f) {
        Sn(i.data, f) || ft(i.data, f, {
          get: function() {
            return n.$attrs[f];
          }
        });
      };
      try {
        for (var l = ob(Object.keys(o)), u = l.next(); !u.done; u = l.next()) {
          var c = u.value;
          a(c);
        }
      } catch (f) {
        t = { error: f };
      } finally {
        try {
          u && !u.done && (r = l.return) && r.call(l);
        } finally {
          if (t)
            throw t.error;
        }
      }
    }
  }
}
function vm(n, e) {
  var t = n.$options._parentVnode;
  if (!!t) {
    for (var r = ir.get(n, "slots") || [], i = _T(t.data.scopedSlots, n.$slots), s = 0; s < r.length; s++) {
      var o = r[s];
      i[o] || delete e[o];
    }
    for (var a = Object.keys(i), s = 0; s < a.length; s++) {
      var o = a[s];
      e[o] || (e[o] = wT(n, o));
    }
    ir.set(n, "slots", a);
  }
}
function bc(n, e, t) {
  var r = Xs();
  dm(n);
  try {
    return e(n);
  } catch (i) {
    if (t)
      t(i);
    else
      throw i;
  } finally {
    dm(r);
  }
}
function DT(n) {
  n.mixin({
    beforeCreate: e,
    mounted: function() {
      mm(this);
    },
    beforeUpdate: function() {
      gm(this);
    },
    updated: function() {
      mm(this);
    }
  });
  function e() {
    var o = this, a = o.$options, l = a.setup, u = a.render;
    if (u && (a.render = function() {
      for (var f = this, p = [], d = 0; d < arguments.length; d++)
        p[d] = arguments[d];
      return bc(pa(o), function() {
        return u.apply(f, p);
      });
    }), !!l) {
      if (!Yn(l)) {
        process.env.NODE_ENV !== "production" && pt('The "setup" option should be a function that returns a object in component definitions.', o);
        return;
      }
      var c = a.data;
      a.data = function() {
        return t(o, o.$props), Yn(c) ? c.call(o, o) : c || {};
      };
    }
  }
  function t(o, a) {
    a === void 0 && (a = {});
    var l = o.$options.setup, u = s(o), c = pa(o);
    c.setupContext = u, cb(a, "__ob__", kT()), vm(o, u.slots);
    var f;
    if (bc(c, function() {
      f = l(a, u);
    }), !!f) {
      if (Yn(f)) {
        var p = f;
        o.$options.render = function() {
          return vm(o, u.slots), bc(c, function() {
            return p();
          });
        };
        return;
      } else if (ha(f)) {
        gi(f) && (f = OT(f)), ir.set(o, "rawBindings", f);
        var d = f;
        Object.keys(d).forEach(function(h) {
          var v = d[h];
          if (!ht(v))
            if (gi(v))
              Oi(v) && (v = hm(v));
            else if (Yn(v)) {
              var g = v;
              v = v.bind(o), Object.keys(g).forEach(function(m) {
                v[m] = g[m];
              });
            } else
              ha(v) ? i(v) && r(v) : v = hm(v);
          PT(o, h, v);
        });
        return;
      }
      process.env.NODE_ENV !== "production" && Xf(!1, '"setup" must return a "Object" or a "Function", got "'.concat(Object.prototype.toString.call(f).slice(8, -1), '"'));
    }
  }
  function r(o, a) {
    if (a === void 0 && (a = /* @__PURE__ */ new Set()), !a.has(o) && !(!dr(o) || ht(o) || gi(o) || Ei(o))) {
      var l = Vi(), u = l.util.defineReactive;
      Object.keys(o).forEach(function(c) {
        var f = o[c];
        u(o, c, f), f && (a.add(f), r(f, a));
      });
    }
  }
  function i(o, a) {
    return a === void 0 && (a = /* @__PURE__ */ new Map()), a.has(o) ? a.get(o) : (a.set(o, !1), Oi(o) && gi(o) ? (a.set(o, !0), !0) : !dr(o) || Ei(o) || ht(o) ? !1 : Object.keys(o).some(function(l) {
      return i(o[l], a);
    }));
  }
  function s(o) {
    var a = { slots: {} }, l = [
      "root",
      "parent",
      "refs",
      "listeners",
      "isServer",
      "ssrContext"
    ], u = ["emit"];
    return l.forEach(function(c) {
      var f = "$".concat(c);
      ft(a, c, {
        get: function() {
          return o[f];
        },
        set: function() {
          process.env.NODE_ENV !== "production" && pt("Cannot assign to '".concat(c, "' because it is a read-only property"), o);
        }
      });
    }), gm(o, a), u.forEach(function(c) {
      var f = "$".concat(c);
      ft(a, c, {
        get: function() {
          return function() {
            for (var p = [], d = 0; d < arguments.length; d++)
              p[d] = arguments[d];
            var h = o[f];
            h.apply(o, p);
          };
        }
      });
    }), process.env.NODE_ENV === "test" && (a._vm = o), a;
  }
}
function gb(n, e) {
  if (!n)
    return e;
  if (!e)
    return n;
  for (var t, r, i, s = hT ? Reflect.ownKeys(n) : Object.keys(n), o = 0; o < s.length; o++)
    t = s[o], t !== "__ob__" && (r = e[t], i = n[t], Sn(e, t) ? r !== i && dr(r) && !ht(r) && dr(i) && !ht(i) && gb(i, r) : e[t] = i);
  return e;
}
function LT(n) {
  if (cT(n)) {
    process.env.NODE_ENV !== "production" && pt("[vue-composition-api] already installed. Vue.use(VueCompositionAPI) should be called only once.");
    return;
  }
  process.env.NODE_ENV !== "production" && (n.version ? (n.version[0] !== "2" || n.version[1] !== ".") && pt("[vue-composition-api] only works with Vue 2, v".concat(n.version, " found.")) : pt("[vue-composition-api] no Vue version found")), n.config.optionMergeStrategies.setup = function(e, t) {
    return function(i, s) {
      return gb(Yn(e) ? e(i, s) || {} : void 0, Yn(t) ? t(i, s) || {} : void 0);
    };
  }, dT(n), DT(n);
}
var vb = {
  install: function(n) {
    return LT(n);
  }
};
typeof window < "u" && window.Vue && window.Vue.use(vb);
var Hi = {};
Object.defineProperty(Hi, "__esModule", { value: !0 });
const NT = "$nuxt", IT = "__NUXT__", RT = !1, FT = "/static-path", zT = "/_nuxt/";
var BT = Hi.globalContext = IT, ym = Hi.globalNuxt = NT;
Hi.isFullStatic = RT;
Hi.publicPath = zT;
Hi.staticPath = FT;
function wc(n) {
  return n !== null && typeof n == "object";
}
function $d(n, e, t = ".", r) {
  if (!wc(e))
    return $d(n, {}, t, r);
  const i = Object.assign({}, e);
  for (const s in n) {
    if (s === "__proto__" || s === "constructor")
      continue;
    const o = n[s];
    o != null && (r && r(i, s, o, t) || (Array.isArray(o) && Array.isArray(i[s]) ? i[s] = i[s].concat(o) : wc(o) && wc(i[s]) ? i[s] = $d(o, i[s], (t ? `${t}.` : "") + s.toString(), r) : i[s] = o));
  }
  return i;
}
function Nl(n) {
  return (...e) => e.reduce((t, r) => $d(t, r, "", n), {});
}
const Zf = Nl();
Zf.fn = Nl((n, e, t, r) => {
  if (typeof n[e] < "u" && typeof t == "function")
    return n[e] = t(n[e]), !0;
});
Zf.arrayFn = Nl((n, e, t, r) => {
  if (Array.isArray(n[e]) && typeof t == "function")
    return n[e] = t(n[e]), !0;
});
Zf.extend = Nl;
function jT() {
  const n = Xs();
  if (!!n)
    return n.proxy;
}
const yb = () => {
  const n = jT();
  if (!n)
    throw new Error("This must be called within a setup function.");
  return {
    ...(n[ym] || n.$options).context,
    route: Oo(() => n.$route),
    query: Oo(() => n.$route.query),
    from: Oo(() => (n[ym] || n.$options).context.from),
    params: Oo(() => n.$route.params)
  };
};
process.client && window[BT];
process.env.NODE_ENV === "test" && Ci.use(vb);
const VT = Ce({
  name: "TImg",
  props: {
    src: { type: String, required: !0, default: "" },
    hash: { type: String, default: "unsafe" },
    trim: { type: Boolean, default: void 0 },
    fitIn: { type: Boolean, default: void 0 },
    stretch: { type: Boolean, default: void 0 },
    smart: { type: Boolean, default: void 0 },
    width: { type: Number, default: void 0 },
    height: { type: Number, default: void 0 },
    quality: { type: Number, default: void 0 },
    backgroundColor: { type: String, default: void 0 },
    format: { type: String, default: void 0 },
    fill: { type: String, default: void 0 },
    local: { type: Boolean, default: !1 },
    alt: { type: String, default: void 0 },
    lazyload: { type: Boolean, default: !1 },
    preload: { type: Boolean, default: !1 }
  },
  setup(n) {
    const e = yb(), t = Le(!1), r = Le(!1), i = Le(!1), s = e.$img.options.providers.think.defaults.fallback, o = ve(() => ({
      format: n.format,
      quality: n.quality,
      backgroundColor: n.backgroundColor,
      fill: n.fill
    })), a = ve(() => ({
      hash: n.hash,
      trim: n.trim,
      fitIn: n.fitIn,
      stretch: n.stretch,
      smart: n.smart,
      size: n.width && n.height ? `${n.width}x${n.height}` : void 0,
      filters: o.value
    })), l = () => {
      t.value ? r.value = !0 : t.value = !0;
    }, u = ve(() => !n.src || r.value ? s : t.value ? e.$joinMediaURL(n.src) : n.local ? n.src : e.$img(e.$joinMediaURL(n.src), a.value)), c = (d) => Math.ceil(Number(d) / 10), f = ve(() => {
      if (!n.src || n.local || !i.value)
        return;
      const d = n.width && n.height ? `${c(n.width)}x${c(n.height)}` : "20x20";
      return e.$img(e.$joinMediaURL(n.src), {
        size: d
      });
    }), p = ve(() => ({
      [n.lazyload ? "data-src" : "src"]: u.value,
      "data-lowsrc": f.value
    }));
    return zr(n, () => {
      t.value = !1, r.value = !1;
    }), sy(() => {
      var _, y;
      if (process.server)
        return;
      const d = 100, h = 4, v = n.width < d && n.height < d;
      (((y = (_ = window.navigator) == null ? void 0 : _.connection) == null ? void 0 : y.downlink) || h + 1) < h && !v && (i.value = !0);
    }), {
      isBlurUp: i,
      lowerSource: f,
      source: u,
      attrs: p,
      setFallbackImage: l
    };
  },
  head() {
    return {
      link: this.preload ? [{ rel: "preload", as: "image", href: this.source }] : []
    };
  }
});
var HT = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("img", e._g(e._b({ key: e.src + "--" + e.source, staticClass: "t-img", class: { lazyload: e.lazyload }, attrs: { alt: e.alt } }, "img", { ...e.attrs, ...e.$attrs }, !1), {
    ...e.$listeners,
    error: e.setFallbackImage
  }));
}, WT = [], qT = /* @__PURE__ */ le(
  VT,
  HT,
  WT,
  !1,
  null,
  null,
  null,
  null
);
const ep = qT.exports, UT = Ce({
  name: "TSource",
  props: {
    srcset: { type: String, required: !0 },
    type: { type: String, required: !0 },
    lazyload: { type: Boolean, default: !1 }
  },
  setup(n) {
    return {
      attrs: ve(() => ({
        [n.lazyload ? "data-srcset" : "srcset"]: n.srcset
      }))
    };
  }
});
var GT = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("source", e._b({ attrs: { type: e.type } }, "source", e.attrs, !1));
}, KT = [], JT = /* @__PURE__ */ le(
  UT,
  GT,
  KT,
  !1,
  null,
  null,
  null,
  null
);
const XT = JT.exports;
Ce({
  name: "TPicture",
  components: { TImg: ep, TSource: XT },
  props: {
    src: { type: String, required: !0, default: "" },
    hash: { type: String, default: "unsafe" },
    trim: { type: Boolean, default: void 0 },
    fitIn: { type: Boolean, default: void 0 },
    stretch: { type: Boolean, default: void 0 },
    smart: { type: Boolean, default: void 0 },
    width: { type: Number, default: void 0 },
    height: { type: Number, default: void 0 },
    quality: { type: Number, default: void 0 },
    backgroundColor: { type: String, default: void 0 },
    fill: { type: String, default: void 0 },
    local: { type: Boolean, default: !1 },
    alt: { type: String, default: void 0 },
    lazyload: { type: Boolean, default: !1 },
    preload: { type: Boolean, default: !1 },
    format: { type: String, default: "jpeg" }
  },
  setup(n) {
    const e = yb(), t = Le([]);
    return zr(n, () => {
      t.value = ["webp", n.format].map((s) => {
        if (n.local)
          return {
            src: n.src,
            format: `image/${s}`
          };
        const o = {
          hash: n.hash,
          trim: n.trim,
          fitIn: n.fitIn,
          stretch: n.stretch,
          smart: n.smart,
          size: n.width && n.height ? `${n.width}x${n.height}` : void 0,
          filters: {
            format: s,
            quality: n.quality,
            backgroundColor: n.backgroundColor,
            fill: n.fill
          }
        };
        return {
          src: e.$img(e.$joinMediaURL(n.src), o),
          format: `image/${s}`
        };
      });
    }, { immediate: !0, deep: !0 }), {
      sources: t,
      onError: (s) => {
        t.value = t.value.map((o) => ({
          ...o,
          src: s
        }));
      }
    };
  },
  head() {
    const n = this.sources;
    return {
      link: this.preload ? [{ rel: "preload", as: "image", href: n[0].src, type: n[0].format }] : []
    };
  }
});
function bm(n) {
  return n !== null && typeof n == "object" && "constructor" in n && n.constructor === Object;
}
function tp(n, e) {
  n === void 0 && (n = {}), e === void 0 && (e = {}), Object.keys(e).forEach(function(t) {
    typeof n[t] > "u" ? n[t] = e[t] : bm(e[t]) && bm(n[t]) && Object.keys(e[t]).length > 0 && tp(n[t], e[t]);
  });
}
var bb = {
  body: {},
  addEventListener: function() {
  },
  removeEventListener: function() {
  },
  activeElement: {
    blur: function() {
    },
    nodeName: ""
  },
  querySelector: function() {
    return null;
  },
  querySelectorAll: function() {
    return [];
  },
  getElementById: function() {
    return null;
  },
  createEvent: function() {
    return {
      initEvent: function() {
      }
    };
  },
  createElement: function() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute: function() {
      },
      getElementsByTagName: function() {
        return [];
      }
    };
  },
  createElementNS: function() {
    return {};
  },
  importNode: function() {
    return null;
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  }
};
function Ys() {
  var n = typeof document < "u" ? document : {};
  return tp(n, bb), n;
}
var YT = {
  document: bb,
  navigator: {
    userAgent: ""
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  },
  history: {
    replaceState: function() {
    },
    pushState: function() {
    },
    go: function() {
    },
    back: function() {
    }
  },
  CustomEvent: function() {
    return this;
  },
  addEventListener: function() {
  },
  removeEventListener: function() {
  },
  getComputedStyle: function() {
    return {
      getPropertyValue: function() {
        return "";
      }
    };
  },
  Image: function() {
  },
  Date: function() {
  },
  screen: {},
  setTimeout: function() {
  },
  clearTimeout: function() {
  },
  matchMedia: function() {
    return {};
  },
  requestAnimationFrame: function(n) {
    return typeof setTimeout > "u" ? (n(), null) : setTimeout(n, 0);
  },
  cancelAnimationFrame: function(n) {
    typeof setTimeout > "u" || clearTimeout(n);
  }
};
function Wi() {
  var n = typeof window < "u" ? window : {};
  return tp(n, YT), n;
}
function QT(n, e) {
  n.prototype = Object.create(e.prototype), n.prototype.constructor = n, n.__proto__ = e;
}
function Dd(n) {
  return Dd = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, Dd(n);
}
function ma(n, e) {
  return ma = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, ma(n, e);
}
function ZT() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function ta(n, e, t) {
  return ZT() ? ta = Reflect.construct : ta = function(i, s, o) {
    var a = [null];
    a.push.apply(a, s);
    var l = Function.bind.apply(i, a), u = new l();
    return o && ma(u, o.prototype), u;
  }, ta.apply(null, arguments);
}
function ek(n) {
  return Function.toString.call(n).indexOf("[native code]") !== -1;
}
function Ld(n) {
  var e = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return Ld = function(r) {
    if (r === null || !ek(r))
      return r;
    if (typeof r != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof e < "u") {
      if (e.has(r))
        return e.get(r);
      e.set(r, i);
    }
    function i() {
      return ta(r, arguments, Dd(this).constructor);
    }
    return i.prototype = Object.create(r.prototype, {
      constructor: {
        value: i,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), ma(i, r);
  }, Ld(n);
}
function tk(n) {
  if (n === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
function nk(n) {
  var e = n.__proto__;
  Object.defineProperty(n, "__proto__", {
    get: function() {
      return e;
    },
    set: function(r) {
      e.__proto__ = r;
    }
  });
}
var Qn = /* @__PURE__ */ function(n) {
  QT(e, n);
  function e(t) {
    var r;
    return r = n.call.apply(n, [this].concat(t)) || this, nk(tk(r)), r;
  }
  return e;
}(/* @__PURE__ */ Ld(Array));
function Qs(n) {
  n === void 0 && (n = []);
  var e = [];
  return n.forEach(function(t) {
    Array.isArray(t) ? e.push.apply(e, Qs(t)) : e.push(t);
  }), e;
}
function wb(n, e) {
  return Array.prototype.filter.call(n, e);
}
function rk(n) {
  for (var e = [], t = 0; t < n.length; t += 1)
    e.indexOf(n[t]) === -1 && e.push(n[t]);
  return e;
}
function ik(n, e) {
  if (typeof n != "string")
    return [n];
  for (var t = [], r = e.querySelectorAll(n), i = 0; i < r.length; i += 1)
    t.push(r[i]);
  return t;
}
function ge(n, e) {
  var t = Wi(), r = Ys(), i = [];
  if (!e && n instanceof Qn)
    return n;
  if (!n)
    return new Qn(i);
  if (typeof n == "string") {
    var s = n.trim();
    if (s.indexOf("<") >= 0 && s.indexOf(">") >= 0) {
      var o = "div";
      s.indexOf("<li") === 0 && (o = "ul"), s.indexOf("<tr") === 0 && (o = "tbody"), (s.indexOf("<td") === 0 || s.indexOf("<th") === 0) && (o = "tr"), s.indexOf("<tbody") === 0 && (o = "table"), s.indexOf("<option") === 0 && (o = "select");
      var a = r.createElement(o);
      a.innerHTML = s;
      for (var l = 0; l < a.childNodes.length; l += 1)
        i.push(a.childNodes[l]);
    } else
      i = ik(n.trim(), e || r);
  } else if (n.nodeType || n === t || n === r)
    i.push(n);
  else if (Array.isArray(n)) {
    if (n instanceof Qn)
      return n;
    i = n;
  }
  return new Qn(rk(i));
}
ge.fn = Qn.prototype;
function sk() {
  for (var n = arguments.length, e = new Array(n), t = 0; t < n; t++)
    e[t] = arguments[t];
  var r = Qs(e.map(function(i) {
    return i.split(" ");
  }));
  return this.forEach(function(i) {
    var s;
    (s = i.classList).add.apply(s, r);
  }), this;
}
function ok() {
  for (var n = arguments.length, e = new Array(n), t = 0; t < n; t++)
    e[t] = arguments[t];
  var r = Qs(e.map(function(i) {
    return i.split(" ");
  }));
  return this.forEach(function(i) {
    var s;
    (s = i.classList).remove.apply(s, r);
  }), this;
}
function ak() {
  for (var n = arguments.length, e = new Array(n), t = 0; t < n; t++)
    e[t] = arguments[t];
  var r = Qs(e.map(function(i) {
    return i.split(" ");
  }));
  this.forEach(function(i) {
    r.forEach(function(s) {
      i.classList.toggle(s);
    });
  });
}
function lk() {
  for (var n = arguments.length, e = new Array(n), t = 0; t < n; t++)
    e[t] = arguments[t];
  var r = Qs(e.map(function(i) {
    return i.split(" ");
  }));
  return wb(this, function(i) {
    return r.filter(function(s) {
      return i.classList.contains(s);
    }).length > 0;
  }).length > 0;
}
function uk(n, e) {
  if (arguments.length === 1 && typeof n == "string")
    return this[0] ? this[0].getAttribute(n) : void 0;
  for (var t = 0; t < this.length; t += 1)
    if (arguments.length === 2)
      this[t].setAttribute(n, e);
    else
      for (var r in n)
        this[t][r] = n[r], this[t].setAttribute(r, n[r]);
  return this;
}
function ck(n) {
  for (var e = 0; e < this.length; e += 1)
    this[e].removeAttribute(n);
  return this;
}
function dk(n) {
  for (var e = 0; e < this.length; e += 1)
    this[e].style.transform = n;
  return this;
}
function fk(n) {
  for (var e = 0; e < this.length; e += 1)
    this[e].style.transitionDuration = typeof n != "string" ? n + "ms" : n;
  return this;
}
function pk() {
  for (var n = arguments.length, e = new Array(n), t = 0; t < n; t++)
    e[t] = arguments[t];
  var r = e[0], i = e[1], s = e[2], o = e[3];
  typeof e[1] == "function" && (r = e[0], s = e[1], o = e[2], i = void 0), o || (o = !1);
  function a(v) {
    var g = v.target;
    if (!!g) {
      var m = v.target.dom7EventData || [];
      if (m.indexOf(v) < 0 && m.unshift(v), ge(g).is(i))
        s.apply(g, m);
      else
        for (var _ = ge(g).parents(), y = 0; y < _.length; y += 1)
          ge(_[y]).is(i) && s.apply(_[y], m);
    }
  }
  function l(v) {
    var g = v && v.target ? v.target.dom7EventData || [] : [];
    g.indexOf(v) < 0 && g.unshift(v), s.apply(this, g);
  }
  for (var u = r.split(" "), c, f = 0; f < this.length; f += 1) {
    var p = this[f];
    if (i)
      for (c = 0; c < u.length; c += 1) {
        var h = u[c];
        p.dom7LiveListeners || (p.dom7LiveListeners = {}), p.dom7LiveListeners[h] || (p.dom7LiveListeners[h] = []), p.dom7LiveListeners[h].push({
          listener: s,
          proxyListener: a
        }), p.addEventListener(h, a, o);
      }
    else
      for (c = 0; c < u.length; c += 1) {
        var d = u[c];
        p.dom7Listeners || (p.dom7Listeners = {}), p.dom7Listeners[d] || (p.dom7Listeners[d] = []), p.dom7Listeners[d].push({
          listener: s,
          proxyListener: l
        }), p.addEventListener(d, l, o);
      }
  }
  return this;
}
function hk() {
  for (var n = arguments.length, e = new Array(n), t = 0; t < n; t++)
    e[t] = arguments[t];
  var r = e[0], i = e[1], s = e[2], o = e[3];
  typeof e[1] == "function" && (r = e[0], s = e[1], o = e[2], i = void 0), o || (o = !1);
  for (var a = r.split(" "), l = 0; l < a.length; l += 1)
    for (var u = a[l], c = 0; c < this.length; c += 1) {
      var f = this[c], p = void 0;
      if (!i && f.dom7Listeners ? p = f.dom7Listeners[u] : i && f.dom7LiveListeners && (p = f.dom7LiveListeners[u]), p && p.length)
        for (var d = p.length - 1; d >= 0; d -= 1) {
          var h = p[d];
          s && h.listener === s || s && h.listener && h.listener.dom7proxy && h.listener.dom7proxy === s ? (f.removeEventListener(u, h.proxyListener, o), p.splice(d, 1)) : s || (f.removeEventListener(u, h.proxyListener, o), p.splice(d, 1));
        }
    }
  return this;
}
function mk() {
  for (var n = Wi(), e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  for (var i = t[0].split(" "), s = t[1], o = 0; o < i.length; o += 1)
    for (var a = i[o], l = 0; l < this.length; l += 1) {
      var u = this[l];
      if (n.CustomEvent) {
        var c = new n.CustomEvent(a, {
          detail: s,
          bubbles: !0,
          cancelable: !0
        });
        u.dom7EventData = t.filter(function(f, p) {
          return p > 0;
        }), u.dispatchEvent(c), u.dom7EventData = [], delete u.dom7EventData;
      }
    }
  return this;
}
function gk(n) {
  var e = this;
  function t(r) {
    r.target === this && (n.call(this, r), e.off("transitionend", t));
  }
  return n && e.on("transitionend", t), this;
}
function vk(n) {
  if (this.length > 0) {
    if (n) {
      var e = this.styles();
      return this[0].offsetWidth + parseFloat(e.getPropertyValue("margin-right")) + parseFloat(e.getPropertyValue("margin-left"));
    }
    return this[0].offsetWidth;
  }
  return null;
}
function yk(n) {
  if (this.length > 0) {
    if (n) {
      var e = this.styles();
      return this[0].offsetHeight + parseFloat(e.getPropertyValue("margin-top")) + parseFloat(e.getPropertyValue("margin-bottom"));
    }
    return this[0].offsetHeight;
  }
  return null;
}
function bk() {
  if (this.length > 0) {
    var n = Wi(), e = Ys(), t = this[0], r = t.getBoundingClientRect(), i = e.body, s = t.clientTop || i.clientTop || 0, o = t.clientLeft || i.clientLeft || 0, a = t === n ? n.scrollY : t.scrollTop, l = t === n ? n.scrollX : t.scrollLeft;
    return {
      top: r.top + a - s,
      left: r.left + l - o
    };
  }
  return null;
}
function wk() {
  var n = Wi();
  return this[0] ? n.getComputedStyle(this[0], null) : {};
}
function _k(n, e) {
  var t = Wi(), r;
  if (arguments.length === 1)
    if (typeof n == "string") {
      if (this[0])
        return t.getComputedStyle(this[0], null).getPropertyValue(n);
    } else {
      for (r = 0; r < this.length; r += 1)
        for (var i in n)
          this[r].style[i] = n[i];
      return this;
    }
  if (arguments.length === 2 && typeof n == "string") {
    for (r = 0; r < this.length; r += 1)
      this[r].style[n] = e;
    return this;
  }
  return this;
}
function Sk(n) {
  return n ? (this.forEach(function(e, t) {
    n.apply(e, [e, t]);
  }), this) : this;
}
function xk(n) {
  var e = wb(this, n);
  return ge(e);
}
function Ck(n) {
  if (typeof n > "u")
    return this[0] ? this[0].innerHTML : null;
  for (var e = 0; e < this.length; e += 1)
    this[e].innerHTML = n;
  return this;
}
function Ok(n) {
  if (typeof n > "u")
    return this[0] ? this[0].textContent.trim() : null;
  for (var e = 0; e < this.length; e += 1)
    this[e].textContent = n;
  return this;
}
function Ek(n) {
  var e = Wi(), t = Ys(), r = this[0], i, s;
  if (!r || typeof n > "u")
    return !1;
  if (typeof n == "string") {
    if (r.matches)
      return r.matches(n);
    if (r.webkitMatchesSelector)
      return r.webkitMatchesSelector(n);
    if (r.msMatchesSelector)
      return r.msMatchesSelector(n);
    for (i = ge(n), s = 0; s < i.length; s += 1)
      if (i[s] === r)
        return !0;
    return !1;
  }
  if (n === t)
    return r === t;
  if (n === e)
    return r === e;
  if (n.nodeType || n instanceof Qn) {
    for (i = n.nodeType ? [n] : n, s = 0; s < i.length; s += 1)
      if (i[s] === r)
        return !0;
    return !1;
  }
  return !1;
}
function Tk() {
  var n = this[0], e;
  if (n) {
    for (e = 0; (n = n.previousSibling) !== null; )
      n.nodeType === 1 && (e += 1);
    return e;
  }
}
function kk(n) {
  if (typeof n > "u")
    return this;
  var e = this.length;
  if (n > e - 1)
    return ge([]);
  if (n < 0) {
    var t = e + n;
    return t < 0 ? ge([]) : ge([this[t]]);
  }
  return ge([this[n]]);
}
function Mk() {
  for (var n, e = Ys(), t = 0; t < arguments.length; t += 1) {
    n = t < 0 || arguments.length <= t ? void 0 : arguments[t];
    for (var r = 0; r < this.length; r += 1)
      if (typeof n == "string") {
        var i = e.createElement("div");
        for (i.innerHTML = n; i.firstChild; )
          this[r].appendChild(i.firstChild);
      } else if (n instanceof Qn)
        for (var s = 0; s < n.length; s += 1)
          this[r].appendChild(n[s]);
      else
        this[r].appendChild(n);
  }
  return this;
}
function Ak(n) {
  var e = Ys(), t, r;
  for (t = 0; t < this.length; t += 1)
    if (typeof n == "string") {
      var i = e.createElement("div");
      for (i.innerHTML = n, r = i.childNodes.length - 1; r >= 0; r -= 1)
        this[t].insertBefore(i.childNodes[r], this[t].childNodes[0]);
    } else if (n instanceof Qn)
      for (r = 0; r < n.length; r += 1)
        this[t].insertBefore(n[r], this[t].childNodes[0]);
    else
      this[t].insertBefore(n, this[t].childNodes[0]);
  return this;
}
function Pk(n) {
  return this.length > 0 ? n ? this[0].nextElementSibling && ge(this[0].nextElementSibling).is(n) ? ge([this[0].nextElementSibling]) : ge([]) : this[0].nextElementSibling ? ge([this[0].nextElementSibling]) : ge([]) : ge([]);
}
function $k(n) {
  var e = [], t = this[0];
  if (!t)
    return ge([]);
  for (; t.nextElementSibling; ) {
    var r = t.nextElementSibling;
    n ? ge(r).is(n) && e.push(r) : e.push(r), t = r;
  }
  return ge(e);
}
function Dk(n) {
  if (this.length > 0) {
    var e = this[0];
    return n ? e.previousElementSibling && ge(e.previousElementSibling).is(n) ? ge([e.previousElementSibling]) : ge([]) : e.previousElementSibling ? ge([e.previousElementSibling]) : ge([]);
  }
  return ge([]);
}
function Lk(n) {
  var e = [], t = this[0];
  if (!t)
    return ge([]);
  for (; t.previousElementSibling; ) {
    var r = t.previousElementSibling;
    n ? ge(r).is(n) && e.push(r) : e.push(r), t = r;
  }
  return ge(e);
}
function Nk(n) {
  for (var e = [], t = 0; t < this.length; t += 1)
    this[t].parentNode !== null && (n ? ge(this[t].parentNode).is(n) && e.push(this[t].parentNode) : e.push(this[t].parentNode));
  return ge(e);
}
function Ik(n) {
  for (var e = [], t = 0; t < this.length; t += 1)
    for (var r = this[t].parentNode; r; )
      n ? ge(r).is(n) && e.push(r) : e.push(r), r = r.parentNode;
  return ge(e);
}
function Rk(n) {
  var e = this;
  return typeof n > "u" ? ge([]) : (e.is(n) || (e = e.parents(n).eq(0)), e);
}
function Fk(n) {
  for (var e = [], t = 0; t < this.length; t += 1)
    for (var r = this[t].querySelectorAll(n), i = 0; i < r.length; i += 1)
      e.push(r[i]);
  return ge(e);
}
function zk(n) {
  for (var e = [], t = 0; t < this.length; t += 1)
    for (var r = this[t].children, i = 0; i < r.length; i += 1)
      (!n || ge(r[i]).is(n)) && e.push(r[i]);
  return ge(e);
}
function Bk() {
  for (var n = 0; n < this.length; n += 1)
    this[n].parentNode && this[n].parentNode.removeChild(this[n]);
  return this;
}
var wm = {
  addClass: sk,
  removeClass: ok,
  hasClass: lk,
  toggleClass: ak,
  attr: uk,
  removeAttr: ck,
  transform: dk,
  transition: fk,
  on: pk,
  off: hk,
  trigger: mk,
  transitionEnd: gk,
  outerWidth: vk,
  outerHeight: yk,
  styles: wk,
  offset: bk,
  css: _k,
  each: Sk,
  html: Ck,
  text: Ok,
  is: Ek,
  index: Tk,
  eq: kk,
  append: Mk,
  prepend: Ak,
  next: Pk,
  nextAll: $k,
  prev: Dk,
  prevAll: Lk,
  parent: Nk,
  parents: Ik,
  closest: Rk,
  find: Fk,
  children: zk,
  filter: xk,
  remove: Bk
};
Object.keys(wm).forEach(function(n) {
  Object.defineProperty(ge.fn, n, {
    value: wm[n],
    writable: !0
  });
});
function vi(n) {
  return typeof n == "object" && n !== null && n.constructor && Object.prototype.toString.call(n).slice(8, -1) === "Object";
}
function jk(n) {
  return typeof window < "u" && typeof window.HTMLElement < "u" ? n instanceof HTMLElement : n && (n.nodeType === 1 || n.nodeType === 11);
}
function ps() {
  for (var n = Object(arguments.length <= 0 ? void 0 : arguments[0]), e = ["__proto__", "constructor", "prototype"], t = 1; t < arguments.length; t += 1) {
    var r = t < 0 || arguments.length <= t ? void 0 : arguments[t];
    if (r != null && !jk(r))
      for (var i = Object.keys(Object(r)).filter(function(u) {
        return e.indexOf(u) < 0;
      }), s = 0, o = i.length; s < o; s += 1) {
        var a = i[s], l = Object.getOwnPropertyDescriptor(r, a);
        l !== void 0 && l.enumerable && (vi(n[a]) && vi(r[a]) ? r[a].__swiper__ ? n[a] = r[a] : ps(n[a], r[a]) : !vi(n[a]) && vi(r[a]) ? (n[a] = {}, r[a].__swiper__ ? n[a] = r[a] : ps(n[a], r[a])) : n[a] = r[a]);
      }
  }
  return n;
}
function Vk(n, e) {
  Object.keys(e).forEach(function(t) {
    vi(e[t]) && Object.keys(e[t]).forEach(function(r) {
      typeof e[t][r] == "function" && (e[t][r] = e[t][r].bind(n));
    }), n[t] = e[t];
  });
}
function Nd() {
  return Nd = Object.assign || function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, Nd.apply(this, arguments);
}
var Hk = {
  init: function() {
    var e = this, t = e.params.thumbs;
    if (e.thumbs.initialized)
      return !1;
    e.thumbs.initialized = !0;
    var r = e.constructor;
    return t.swiper instanceof r ? (e.thumbs.swiper = t.swiper, ps(e.thumbs.swiper.originalParams, {
      watchSlidesProgress: !0,
      slideToClickedSlide: !1
    }), ps(e.thumbs.swiper.params, {
      watchSlidesProgress: !0,
      slideToClickedSlide: !1
    })) : vi(t.swiper) && (e.thumbs.swiper = new r(ps({}, t.swiper, {
      watchSlidesVisibility: !0,
      watchSlidesProgress: !0,
      slideToClickedSlide: !1
    })), e.thumbs.swiperCreated = !0), e.thumbs.swiper.$el.addClass(e.params.thumbs.thumbsContainerClass), e.thumbs.swiper.on("tap", e.thumbs.onThumbClick), !0;
  },
  onThumbClick: function() {
    var e = this, t = e.thumbs.swiper;
    if (!!t) {
      var r = t.clickedIndex, i = t.clickedSlide;
      if (!(i && ge(i).hasClass(e.params.thumbs.slideThumbActiveClass)) && !(typeof r > "u" || r === null)) {
        var s;
        if (t.params.loop ? s = parseInt(ge(t.clickedSlide).attr("data-swiper-slide-index"), 10) : s = r, e.params.loop) {
          var o = e.activeIndex;
          e.slides.eq(o).hasClass(e.params.slideDuplicateClass) && (e.loopFix(), e._clientLeft = e.$wrapperEl[0].clientLeft, o = e.activeIndex);
          var a = e.slides.eq(o).prevAll('[data-swiper-slide-index="' + s + '"]').eq(0).index(), l = e.slides.eq(o).nextAll('[data-swiper-slide-index="' + s + '"]').eq(0).index();
          typeof a > "u" ? s = l : typeof l > "u" ? s = a : l - o < o - a ? s = l : s = a;
        }
        e.slideTo(s);
      }
    }
  },
  update: function(e) {
    var t = this, r = t.thumbs.swiper;
    if (!!r) {
      var i = r.params.slidesPerView === "auto" ? r.slidesPerViewDynamic() : r.params.slidesPerView, s = t.params.thumbs.autoScrollOffset, o = s && !r.params.loop;
      if (t.realIndex !== r.realIndex || o) {
        var a = r.activeIndex, l, u;
        if (r.params.loop) {
          r.slides.eq(a).hasClass(r.params.slideDuplicateClass) && (r.loopFix(), r._clientLeft = r.$wrapperEl[0].clientLeft, a = r.activeIndex);
          var c = r.slides.eq(a).prevAll('[data-swiper-slide-index="' + t.realIndex + '"]').eq(0).index(), f = r.slides.eq(a).nextAll('[data-swiper-slide-index="' + t.realIndex + '"]').eq(0).index();
          typeof c > "u" ? l = f : typeof f > "u" ? l = c : f - a === a - c ? l = r.params.slidesPerGroup > 1 ? f : a : f - a < a - c ? l = f : l = c, u = t.activeIndex > t.previousIndex ? "next" : "prev";
        } else
          l = t.realIndex, u = l > t.previousIndex ? "next" : "prev";
        o && (l += u === "next" ? s : -1 * s), r.visibleSlidesIndexes && r.visibleSlidesIndexes.indexOf(l) < 0 && (r.params.centeredSlides ? l > a ? l = l - Math.floor(i / 2) + 1 : l = l + Math.floor(i / 2) - 1 : l > a && r.params.slidesPerGroup, r.slideTo(l, e ? 0 : void 0));
      }
      var p = 1, d = t.params.thumbs.slideThumbActiveClass;
      if (t.params.slidesPerView > 1 && !t.params.centeredSlides && (p = t.params.slidesPerView), t.params.thumbs.multipleActiveThumbs || (p = 1), p = Math.floor(p), r.slides.removeClass(d), r.params.loop || r.params.virtual && r.params.virtual.enabled)
        for (var h = 0; h < p; h += 1)
          r.$wrapperEl.children('[data-swiper-slide-index="' + (t.realIndex + h) + '"]').addClass(d);
      else
        for (var v = 0; v < p; v += 1)
          r.slides.eq(t.realIndex + v).addClass(d);
    }
  }
};
const Wk = {
  name: "thumbs",
  params: {
    thumbs: {
      swiper: null,
      multipleActiveThumbs: !0,
      autoScrollOffset: 0,
      slideThumbActiveClass: "swiper-slide-thumb-active",
      thumbsContainerClass: "swiper-container-thumbs"
    }
  },
  create: function() {
    var e = this;
    Vk(e, {
      thumbs: Nd({
        swiper: null,
        initialized: !1
      }, Hk)
    });
  },
  on: {
    beforeInit: function(e) {
      var t = e.params.thumbs;
      !t || !t.swiper || (e.thumbs.init(), e.thumbs.update(!0));
    },
    slideChange: function(e) {
      !e.thumbs.swiper || e.thumbs.update();
    },
    update: function(e) {
      !e.thumbs.swiper || e.thumbs.update();
    },
    resize: function(e) {
      !e.thumbs.swiper || e.thumbs.update();
    },
    observerUpdate: function(e) {
      !e.thumbs.swiper || e.thumbs.update();
    },
    setTransition: function(e, t) {
      var r = e.thumbs.swiper;
      !r || r.setTransition(t);
    },
    beforeDestroy: function(e) {
      var t = e.thumbs.swiper;
      !t || e.thumbs.swiperCreated && t && t.destroy();
    }
  }
};
const qk = Ce({
  name: "TAlbumImage",
  components: {
    TSwiper: QE,
    TSwiperSlide: rT,
    TImg: ep
  },
  props: {
    images: {
      type: Array,
      default: () => []
    }
  },
  setup() {
    const n = Le(null);
    return {
      thumbsSwiper: n,
      setThumbsSwiper: (t) => {
        n.value = t;
      },
      modules: [Wk]
    };
  }
});
var Uk = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, e.images.length ? t("div", { staticClass: "t-album-image" }, [t("t-swiper", { attrs: { modules: e.modules, "space-between": 8, thumbs: { swiper: e.thumbsSwiper }, "slides-per-view": "auto" } }, e._l(e.images, function(r, i) {
    return t("t-swiper-slide", { key: i, staticClass: "aspect-w-16 aspect-h-9" }, [e.$nuxt ? t("t-img", { attrs: { height: 900, src: r, width: 1600, alt: "", lazyload: "" } }) : t("img", { staticClass: "lazyload", attrs: { src: r, alt: "" } })], 1);
  }), 1), t("t-swiper", { attrs: { breakpoints: {
    640: {
      slidesPerView: 3
    },
    768: {
      slidesPerView: 4
    },
    1024: {
      slidesPerView: 5
    }
  }, modules: e.modules, "slides-per-view": 3, "space-between": 8, "css-mode": "", "free-mode": "", mousewheel: "", "watch-slides-progress": "" }, on: { swiper: e.setThumbsSwiper } }, e._l(e.images, function(r, i) {
    return t("t-swiper-slide", { key: i }, [e.$nuxt ? t("t-img", { attrs: { height: 380, src: r, width: 240, alt: "", lazyload: "" } }) : t("img", { staticClass: "lazyload", attrs: { src: r, alt: "" } })], 1);
  }), 1)], 1) : e._e();
}, Gk = [], Kk = /* @__PURE__ */ le(
  qk,
  Uk,
  Gk,
  !1,
  null,
  null,
  null,
  null
);
const _b = Kk.exports, Jk = st({
  name: "ImageAlbumCommand",
  components: {
    TAlbumImage: _b,
    SlickList: Jy,
    SlickItem: Xy,
    TUpload: jf,
    TBtn: $l,
    ButtonCommand: yt,
    ElDialog: Kr
  },
  setup() {
    const n = $e("editor"), e = $e("config"), { getFormData: t, getFullPathMedia: r, uploadMedia: i } = Gf(e), s = ct(!1), o = ct([]), a = je(() => n == null ? void 0 : n.value.isActive("imageAlbum")), l = (f) => {
      o.value = f;
    }, u = async (f) => {
      const p = f.map(t).map(i);
      return await Promise.all(p);
    };
    return { visible: s, isActive: a, files: o, selectImage: l, onSave: async () => {
      if (!!(n != null && n.value))
        try {
          const f = await u(o.value);
          n.value.chain().focus().setImageAlbum(f.map(r)).run(), s.value = !1;
        } catch (f) {
          console.log(f);
        }
    } };
  },
  methods: {
    getUrlFromFile(n) {
      return URL.createObjectURL(n);
    }
  }
});
var Xk = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", [t("button-command", { attrs: { "is-active": e.isActive, icon: "gallery-fill", title: "Image Album" }, on: { click: function(r) {
    e.visible = !0;
  } } }), t("el-dialog", { attrs: { visible: e.visible, "append-to-body": "", fullscreen: "", title: "Upload album image" }, on: { "update:visible": function(r) {
    e.visible = r;
  } }, scopedSlots: e._u([{ key: "title", fn: function() {
    return [t("div", { staticClass: "flex space-x-4" }, [t("t-upload", { attrs: { multiple: "" }, on: { input: e.selectImage }, scopedSlots: e._u([{ key: "default", fn: function({ on: r }) {
      return [t("t-btn", e._g({ attrs: { color: "secondary", height: "42" } }, r), [e._v("Load Image")])];
    } }]) }), t("t-btn", { attrs: { height: "42" }, on: { click: e.onSave } }, [e._v("Save")])], 1)];
  }, proxy: !0 }]) }, [t("div", { staticClass: "flex" }, [t("div", { staticClass: "w-full md:w-1/2" }, [t("div", { staticClass: "overflow-auto", staticStyle: { "max-height": "calc(100vh - 120px)" } }, [t("slick-list", { staticClass: "flex flex-col space-y-4", model: { value: e.files, callback: function(r) {
    e.files = r;
  }, expression: "files" } }, e._l(e.files, function(r, i) {
    return t("slick-item", { key: r.name, staticClass: "bg-white border rounded p-2", staticStyle: { "z-index": "9999" }, attrs: { index: i } }, [t("div", { staticClass: "flex overflow-hidden", staticStyle: { height: "120px" } }, [t("div", { staticClass: "w-1/3" }, [t("span", { staticClass: "font-bold text-ui" }, [e._v(e._s(r.name))])]), t("div", { staticClass: "flex-1 ml-2" }, [t("img", { staticClass: "h-full object-contain w-full", attrs: { alt: r.name, src: e.getUrlFromFile(r) } })])])]);
  }), 1)], 1)]), t("div", { staticClass: "flex w-full justify-center items-start md:w-1/2" }, [t("div", { staticClass: "mockup-phone" }, [t("div", { staticClass: "camera" }), t("div", { staticClass: "display" }, [t("div", { staticClass: "artboard artboard-demo phone-1" }, [t("t-album-image", { attrs: { images: e.files.map(e.getUrlFromFile) } })], 1)])])])])])], 1);
}, Yk = [], Qk = /* @__PURE__ */ le(
  Jk,
  Xk,
  Yk,
  !1,
  null,
  null,
  null,
  null
);
const Zk = Qk.exports;
function eM(n) {
  if (Array.isArray(n)) {
    for (var e = 0, t = Array(n.length); e < n.length; e++)
      t[e] = n[e];
    return t;
  } else
    return Array.from(n);
}
var np = !1;
if (typeof window < "u") {
  var _m = {
    get passive() {
      np = !0;
    }
  };
  window.addEventListener("testPassive", null, _m), window.removeEventListener("testPassive", null, _m);
}
var ga = typeof window < "u" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1), Dr = [], va = !1, Sb = -1, hs = void 0, Cr = void 0, ms = void 0, xb = function(e) {
  return Dr.some(function(t) {
    return !!(t.options.allowTouchMove && t.options.allowTouchMove(e));
  });
}, ya = function(e) {
  var t = e || window.event;
  return xb(t.target) || t.touches.length > 1 ? !0 : (t.preventDefault && t.preventDefault(), !1);
}, tM = function(e) {
  if (ms === void 0) {
    var t = !!e && e.reserveScrollBarGap === !0, r = window.innerWidth - document.documentElement.clientWidth;
    if (t && r > 0) {
      var i = parseInt(window.getComputedStyle(document.body).getPropertyValue("padding-right"), 10);
      ms = document.body.style.paddingRight, document.body.style.paddingRight = i + r + "px";
    }
  }
  hs === void 0 && (hs = document.body.style.overflow, document.body.style.overflow = "hidden");
}, nM = function() {
  ms !== void 0 && (document.body.style.paddingRight = ms, ms = void 0), hs !== void 0 && (document.body.style.overflow = hs, hs = void 0);
}, rM = function() {
  return window.requestAnimationFrame(function() {
    if (Cr === void 0) {
      Cr = {
        position: document.body.style.position,
        top: document.body.style.top,
        left: document.body.style.left
      };
      var e = window, t = e.scrollY, r = e.scrollX, i = e.innerHeight;
      document.body.style.position = "fixed", document.body.style.top = -t, document.body.style.left = -r, setTimeout(function() {
        return window.requestAnimationFrame(function() {
          var s = i - window.innerHeight;
          s && t >= i && (document.body.style.top = -(t + s));
        });
      }, 300);
    }
  });
}, iM = function() {
  if (Cr !== void 0) {
    var e = -parseInt(document.body.style.top, 10), t = -parseInt(document.body.style.left, 10);
    document.body.style.position = Cr.position, document.body.style.top = Cr.top, document.body.style.left = Cr.left, window.scrollTo(t, e), Cr = void 0;
  }
}, sM = function(e) {
  return e ? e.scrollHeight - e.scrollTop <= e.clientHeight : !1;
}, oM = function(e, t) {
  var r = e.targetTouches[0].clientY - Sb;
  return xb(e.target) ? !1 : t && t.scrollTop === 0 && r > 0 || sM(t) && r < 0 ? ya(e) : (e.stopPropagation(), !0);
}, Sm = function(e, t) {
  if (!e) {
    console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
    return;
  }
  if (!Dr.some(function(i) {
    return i.targetElement === e;
  })) {
    var r = {
      targetElement: e,
      options: t || {}
    };
    Dr = [].concat(eM(Dr), [r]), ga ? rM() : tM(t), ga && (e.ontouchstart = function(i) {
      i.targetTouches.length === 1 && (Sb = i.targetTouches[0].clientY);
    }, e.ontouchmove = function(i) {
      i.targetTouches.length === 1 && oM(i, e);
    }, va || (document.addEventListener("touchmove", ya, np ? { passive: !1 } : void 0), va = !0));
  }
}, xm = function(e) {
  if (!e) {
    console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");
    return;
  }
  Dr = Dr.filter(function(t) {
    return t.targetElement !== e;
  }), ga && (e.ontouchstart = null, e.ontouchmove = null, va && Dr.length === 0 && (document.removeEventListener("touchmove", ya, np ? { passive: !1 } : void 0), va = !1)), ga ? iM() : nM();
};
class aM {
  constructor(e, t = {}) {
    const r = {
      controlColor: "#FFFFFF",
      controlShadow: !0,
      addCircle: !1,
      addCircleBlur: !0,
      showLabels: !1,
      labelOptions: {
        before: "Before",
        after: "After",
        onHover: !1
      },
      smoothing: !0,
      smoothingAmount: 100,
      hoverStart: !1,
      verticalMode: !1,
      startingPoint: 50,
      fluidMode: !1
    };
    this.settings = Object.assign(r, t), this.animationFrameId = null, this.safariAgent = navigator.userAgent.indexOf("Safari") != -1 && navigator.userAgent.indexOf("Chrome") == -1, this.el = e, this.images = {}, this.wrapper = null, this.control = null, this.arrowContainer = null, this.arrowAnimator = [], this.active = !1, this.slideWidth = 50, this.lineWidth = 2, this.arrowCoordinates = {
      circle: [5, 3],
      standard: [8, 0]
    };
  }
  mount() {
    this.safariAgent && (this.settings.smoothing = !1), this._shapeContainer(), this._getImages(), this._buildControl(), this._events();
  }
  _events() {
    this.el.addEventListener("mousedown", (e) => {
      this._activate(!0), document.body.classList.add("icv__body"), Sm(this.el, { reserveScrollBarGap: !0 }), this._slideCompare(e);
    }), this.el.addEventListener(
      "mousemove",
      (e) => this.active && this._slideCompare(e)
    ), this.el.addEventListener("mouseup", () => this._activate(!1)), document.body.addEventListener("mouseup", () => {
      document.body.classList.remove("icv__body"), xm(this.el), this._activate(!1);
    }), this.control.addEventListener("touchstart", (e) => {
      this._activate(!0), document.body.classList.add("icv__body"), Sm(this.el, { reserveScrollBarGap: !0 });
    }), this.el.addEventListener("touchmove", (e) => {
      this.active && this._slideCompare(e);
    }), this.el.addEventListener("touchend", () => {
      this._activate(!1), document.body.classList.remove("icv__body"), xm(this.el);
    }), this.el.addEventListener("mouseenter", () => {
      this.settings.hoverStart && this._activate(!0);
      let e = this.settings.addCircle ? this.arrowCoordinates.circle : this.arrowCoordinates.standard;
      this.arrowAnimator.forEach((t, r) => {
        t.style.cssText = `
        ${this.settings.verticalMode ? `transform: translateY(${e[1] * (r === 0 ? 1 : -1)}px);` : `transform: translateX(${e[1] * (r === 0 ? 1 : -1)}px);`}
        `;
      });
    }), this.el.addEventListener("mouseleave", () => {
      let e = this.settings.addCircle ? this.arrowCoordinates.circle : this.arrowCoordinates.standard;
      this.arrowAnimator.forEach((t, r) => {
        t.style.cssText = `
        ${this.settings.verticalMode ? `transform: translateY(${r === 0 ? `${e[0]}px` : `-${e[0]}px`});` : `transform: translateX(${r === 0 ? `${e[0]}px` : `-${e[0]}px`});`}
        `;
      });
    });
  }
  _slideCompare(e) {
    this.animationFrameId === null && (this.animationFrameId = requestAnimationFrame(() => {
      const t = this.el.getBoundingClientRect(), r = e.touches !== void 0 ? e.touches[0].clientX - t.left : e.clientX - t.left, i = e.touches !== void 0 ? e.touches[0].clientY - t.top : e.clientY - t.top, s = this.settings.verticalMode ? i / t.height * 100 : r / t.width * 100;
      s >= 0 && s <= 100 && (this.settings.verticalMode ? this.control.style.top = `calc(${s}% - ${this.slideWidth / 2}px)` : this.control.style.left = `calc(${s}% - ${this.slideWidth / 2}px)`, this.settings.fluidMode ? this.settings.verticalMode ? this.wrapper.style.clipPath = `inset(0 0 ${100 - s}% 0)` : this.wrapper.style.clipPath = `inset(0 0 0 ${s}%)` : this.settings.verticalMode ? this.wrapper.style.height = `calc(${s}%)` : this.wrapper.style.width = `calc(${100 - s}%)`), this.animationFrameId = null;
    }));
  }
  _activate(e) {
    this.active = e;
  }
  _shapeContainer() {
    let e = document.createElement("div"), t = document.createElement("span"), r = document.createElement("span");
    t.classList.add("icv__label", "icv__label-before", "keep"), r.classList.add("icv__label", "icv__label-after", "keep"), this.settings.labelOptions.onHover && (t.classList.add("on-hover"), r.classList.add("on-hover")), this.settings.verticalMode && (t.classList.add("vertical"), r.classList.add("vertical")), t.innerHTML = this.settings.labelOptions.before || "Before", r.innerHTML = this.settings.labelOptions.after || "After", this.settings.showLabels && (this.el.appendChild(t), this.el.appendChild(r)), this.el.classList.add(
      "icv",
      this.settings.verticalMode ? "icv__icv--vertical" : "icv__icv--horizontal",
      this.settings.fluidMode ? "icv__is--fluid" : "standard"
    ), e.classList.add("icv__imposter"), this.el.appendChild(e);
  }
  _buildControl() {
    let e = document.createElement("div"), t = document.createElement("div"), r = document.createElement("div"), i = document.createElement("div");
    const s = "20";
    r.classList.add("icv__theme-wrapper");
    for (var o = 0; o <= 1; o++) {
      let u = document.createElement("div"), c = `<svg
      height="15"
      width="15"
       style="
       transform: 
       scale(${this.settings.addCircle ? 0.7 : 1.5})  
       rotateZ(${o === 0 ? this.settings.verticalMode ? "-90deg" : "180deg" : this.settings.verticalMode ? "90deg" : "0deg"}); height: ${s}px; width: ${s}px;
       
       ${this.settings.controlShadow ? `
       -webkit-filter: drop-shadow( 0px 3px 5px rgba(0, 0, 0, .33));
       filter: drop-shadow( 0px ${o === 0 ? "-3px" : "3px"} 5px rgba(0, 0, 0, .33));
       ` : ""}
       "
       xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 15 15">
       <path ${this.settings.addCircle ? 'fill="transparent"' : `fill="${this.settings.controlColor}"`}
       stroke="${this.settings.controlColor}"
       stroke-linecap="round"
       stroke-width="${this.settings.addCircle ? 3 : 0}"
       d="M4.5 1.9L10 7.65l-5.5 5.4"
       />
     </svg>`;
      u.innerHTML += c, this.arrowAnimator.push(u), r.appendChild(u);
    }
    let a = this.settings.addCircle ? this.arrowCoordinates.circle : this.arrowCoordinates.standard;
    this.arrowAnimator.forEach((u, c) => {
      u.classList.add("icv__arrow-wrapper"), u.style.cssText = `
      ${this.settings.verticalMode ? `transform: translateY(${c === 0 ? `${a[0]}px` : `-${a[0]}px`});` : `transform: translateX(${c === 0 ? `${a[0]}px` : `-${a[0]}px`});`}
      `;
    }), e.classList.add("icv__control"), e.style.cssText = `
    ${this.settings.verticalMode ? "height" : "width "}: ${this.slideWidth}px;
    ${this.settings.verticalMode ? "top" : "left "}: calc(${this.settings.startingPoint}% - ${this.slideWidth / 2}px);
    ${"ontouchstart" in document.documentElement ? "" : this.settings.smoothing ? `transition: ${this.settings.smoothingAmount}ms ease-out;` : ""}
    `, t.classList.add("icv__control-line"), t.style.cssText = `
      ${this.settings.verticalMode ? "height" : "width "}: ${this.lineWidth}px;
      background: ${this.settings.controlColor};
        ${this.settings.controlShadow ? "box-shadow: 0px 0px 15px rgba(0,0,0,0.33);" : ""}
    `;
    let l = t.cloneNode(!0);
    i.classList.add("icv__circle"), i.style.cssText = `

      ${this.settings.addCircleBlur && "-webkit-backdrop-filter: blur(5px); backdrop-filter: blur(5px)"};
      
      border: ${this.lineWidth}px solid ${this.settings.controlColor};
      ${this.settings.controlShadow && "box-shadow: 0px 0px 15px rgba(0,0,0,0.33)"};
    `, e.appendChild(t), this.settings.addCircle && e.appendChild(i), e.appendChild(r), e.appendChild(l), this.arrowContainer = r, this.control = e, this.el.appendChild(e);
  }
  _getImages() {
    let e = this.el.querySelectorAll("img, video, .keep");
    this.el.innerHTML = "", e.forEach((r) => {
      this.el.appendChild(r);
    });
    let t = [...e].filter(
      (r) => ["img", "video"].includes(r.nodeName.toLowerCase())
    );
    this.settings.verticalMode && t.reverse();
    for (let r = 0; r <= 1; r++) {
      let i = t[r];
      if (i.classList.add("icv__img"), i.classList.add(r === 0 ? "icv__img-a" : "icv__img-b"), r === 1) {
        let s = document.createElement("div"), o = t[1].src;
        s.classList.add("icv__wrapper"), s.style.cssText = `
            width: ${100 - this.settings.startingPoint}%; 
            height: ${this.settings.startingPoint}%;

            ${"ontouchstart" in document.documentElement ? "" : this.settings.smoothing ? `transition: ${this.settings.smoothingAmount}ms ease-out;` : ""}
            ${this.settings.fluidMode && `background-image: url(${o}); clip-path: inset(${this.settings.verticalMode ? ` 0 0 ${100 - this.settings.startingPoint}% 0` : `0 0 0 ${this.settings.startingPoint}%`})`}
        `, s.appendChild(i), this.wrapper = s, this.el.appendChild(this.wrapper);
      }
    }
    if (this.settings.fluidMode) {
      let r = t[0].src, i = document.createElement("div");
      i.classList.add("icv__fluidwrapper"), i.style.cssText = `
 
        background-image: url(${r});
        
      `, this.el.appendChild(i);
    }
  }
}
const lM = Ce({
  name: "TComparisonImage",
  props: {
    leftImage: {
      type: String,
      default: ""
    },
    leftImageAlt: {
      type: String,
      default: null
    },
    rightImage: {
      type: String,
      default: ""
    },
    rightImageAlt: {
      type: String,
      default: null
    }
  },
  setup() {
    const n = Le(), e = Le();
    return Us(() => {
      !n.value || (e.value = new aM(n.value, uM).mount());
    }), {
      imageCompareRef: n,
      viewer: e
    };
  }
}), uM = {
  controlColor: "#FFFFFF",
  controlShadow: !0,
  addCircle: !0,
  addCircleBlur: !0,
  showLabels: !1,
  labelOptions: {
    before: "Before",
    after: "After",
    onHover: !1
  },
  smoothing: !0,
  smoothingAmount: 200,
  hoverStart: !0,
  verticalMode: !1,
  startingPoint: 50,
  fluidMode: !1
};
var cM = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { ref: "imageCompareRef", staticClass: "t-comparison-image" }, [t("img", { attrs: { alt: e.leftImageAlt, src: e.leftImage } }), t("img", { attrs: { alt: e.rightImageAlt, src: e.rightImage } })]);
}, dM = [], fM = /* @__PURE__ */ le(
  lM,
  cM,
  dM,
  !1,
  null,
  null,
  null,
  null
);
const Cb = fM.exports, pM = st({
  name: "ImageComparisonCommand",
  components: {
    TComparisonImage: Cb,
    SlickList: Jy,
    SlickItem: Xy,
    TUpload: jf,
    TBtn: $l,
    ButtonCommand: yt,
    ElDialog: Kr
  },
  setup() {
    const n = $e("editor"), e = $e("config"), { getFormData: t, getFullPathMedia: r, uploadMedia: i } = Gf(e), s = ct(!1), o = ct([]), a = je(() => n == null ? void 0 : n.value.isActive("imageAlbum")), l = (f) => {
      o.value = f.splice(0, 2);
    }, u = async (f) => {
      const p = f.map(t).map(i);
      return await Promise.all(p);
    };
    return { visible: s, isActive: a, files: o, selectImage: l, onSave: async () => {
      if (!!(n != null && n.value))
        try {
          const f = await u(o.value);
          n.value.chain().focus().setImageComparison(f.map(r)).run(), s.value = !1;
        } catch (f) {
          console.log(f);
        }
    } };
  },
  methods: {
    getUrlFromFile(n) {
      return URL.createObjectURL(n);
    }
  }
});
var hM = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", [t("button-command", { attrs: { "is-active": e.isActive, icon: "qr-scan-line", title: "Image Comparison" }, on: { click: function(r) {
    e.visible = !0;
  } } }), t("el-dialog", { attrs: { visible: e.visible, "append-to-body": "", fullscreen: "", title: "Upload album image" }, on: { "update:visible": function(r) {
    e.visible = r;
  } }, scopedSlots: e._u([{ key: "title", fn: function() {
    return [t("div", { staticClass: "flex space-x-4" }, [t("t-upload", { attrs: { multiple: "" }, on: { input: e.selectImage }, scopedSlots: e._u([{ key: "default", fn: function({ on: r }) {
      return [t("t-btn", e._g({ attrs: { color: "secondary", height: "42" } }, r), [e._v("Load Image")])];
    } }]) }), t("t-btn", { attrs: { height: "42" }, on: { click: e.onSave } }, [e._v("Save")])], 1)];
  }, proxy: !0 }]) }, [t("div", { staticClass: "flex" }, [t("div", { staticClass: "w-full md:w-1/2" }, [t("div", { staticClass: "overflow-auto", staticStyle: { "max-height": "calc(100vh - 120px)" } }, [t("slick-list", { staticClass: "flex flex-col space-y-4", model: { value: e.files, callback: function(r) {
    e.files = r;
  }, expression: "files" } }, e._l(e.files, function(r, i) {
    return t("slick-item", { key: r.name, staticClass: "bg-white border rounded p-2", staticStyle: { "z-index": "9999" }, attrs: { index: i } }, [t("div", { staticClass: "flex overflow-hidden", staticStyle: { height: "120px" } }, [t("div", { staticClass: "w-1/3" }, [t("span", { staticClass: "font-bold text-ui" }, [e._v(e._s(r.name))])]), t("div", { staticClass: "flex-1 ml-2" }, [t("img", { staticClass: "h-full object-contain w-full", attrs: { alt: r.name, src: e.getUrlFromFile(r) } })])])]);
  }), 1)], 1)]), t("div", { staticClass: "flex w-full justify-center items-start md:w-1/2" }, [t("div", { staticClass: "mockup-phone" }, [t("div", { staticClass: "camera" }), t("div", { staticClass: "display" }, [t("div", { staticClass: "artboard artboard-demo phone-1", staticStyle: { padding: "16px", width: "375px", height: "667px" } }, [e.files.length === 2 ? t("t-comparison-image", { attrs: { "left-image": e.getUrlFromFile(e.files[0]), "right-image": e.getUrlFromFile(e.files[1]) } }) : e._e()], 1)])])])])])], 1);
}, mM = [], gM = /* @__PURE__ */ le(
  pM,
  hM,
  mM,
  !1,
  null,
  null,
  null,
  null
);
const vM = gM.exports, yM = {
  name: "VideoCommand",
  components: { ButtonCommand: yt },
  setup() {
    const n = $e("editor");
    return { isActive: je(() => n == null ? void 0 : n.value.isActive("iframe")), setVideo: () => {
      const r = window.prompt("URL");
      !(n != null && n.value) || !r || n.value.chain().focus().setIframe({ src: UE(r || "") }).run();
    } };
  }
};
var bM = function() {
  var e = this, t = e._self._c;
  return t("button-command", { attrs: { "is-active": e.isActive, icon: "youtube-line", title: "Video" }, on: { click: e.setVideo } });
}, wM = [], _M = /* @__PURE__ */ le(
  yM,
  bM,
  wM,
  !1,
  null,
  null,
  null,
  null
);
const SM = _M.exports, xM = {
  name: "LinkCommand",
  components: { ButtonCommand: yt },
  setup() {
    const n = $e("editor"), e = je(() => n == null ? void 0 : n.value.isActive("link"));
    return { isActive: e, toggleLink: () => {
      if (!!(n != null && n.value))
        if (e.value)
          n.value.commands.unsetLink();
        else {
          const r = window.prompt("URL");
          n.value.chain().focus().setLink({ href: r || "" }).run();
        }
    } };
  }
};
var CM = function() {
  var e = this, t = e._self._c;
  return t("button-command", { attrs: { "is-active": e.isActive, icon: "link", title: "Link" }, on: { click: e.toggleLink } });
}, OM = [], EM = /* @__PURE__ */ le(
  xM,
  CM,
  OM,
  !1,
  null,
  null,
  null,
  null
);
const TM = EM.exports;
var Zs = { exports: {} }, es = {}, Cm;
function Ob() {
  if (Cm)
    return es;
  Cm = 1, es.__esModule = !0, es.isDef = n, es.isKorean = e;
  function n(t) {
    return t != null;
  }
  function e(t) {
    var r = /([(\uAC00-\uD7AF)|(\u3130-\u318F)])+/gi;
    return r.test(t);
  }
  return es;
}
(function(n) {
  n.exports = function(e) {
    var t = {};
    function r(i) {
      if (t[i])
        return t[i].exports;
      var s = t[i] = {
        i,
        l: !1,
        exports: {}
      };
      return e[i].call(s.exports, s, s.exports, r), s.l = !0, s.exports;
    }
    return r.m = e, r.c = t, r.d = function(i, s, o) {
      r.o(i, s) || Object.defineProperty(i, s, { enumerable: !0, get: o });
    }, r.r = function(i) {
      typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(i, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(i, "__esModule", { value: !0 });
    }, r.t = function(i, s) {
      if (s & 1 && (i = r(i)), s & 8 || s & 4 && typeof i == "object" && i && i.__esModule)
        return i;
      var o = /* @__PURE__ */ Object.create(null);
      if (r.r(o), Object.defineProperty(o, "default", { enumerable: !0, value: i }), s & 2 && typeof i != "string")
        for (var a in i)
          r.d(o, a, function(l) {
            return i[l];
          }.bind(null, a));
      return o;
    }, r.n = function(i) {
      var s = i && i.__esModule ? function() {
        return i.default;
      } : function() {
        return i;
      };
      return r.d(s, "a", s), s;
    }, r.o = function(i, s) {
      return Object.prototype.hasOwnProperty.call(i, s);
    }, r.p = "/dist/", r(r.s = 75);
  }({
    0: function(e, t, r) {
      r.d(t, "a", function() {
        return i;
      });
      function i(s, o, a, l, u, c, f, p) {
        var d = typeof s == "function" ? s.options : s;
        o && (d.render = o, d.staticRenderFns = a, d._compiled = !0), l && (d.functional = !0), c && (d._scopeId = "data-v-" + c);
        var h;
        if (f ? (h = function(m) {
          m = m || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !m && typeof __VUE_SSR_CONTEXT__ < "u" && (m = __VUE_SSR_CONTEXT__), u && u.call(this, m), m && m._registeredComponents && m._registeredComponents.add(f);
        }, d._ssrRegister = h) : u && (h = p ? function() {
          u.call(this, this.$root.$options.shadowRoot);
        } : u), h)
          if (d.functional) {
            d._injectStyles = h;
            var v = d.render;
            d.render = function(_, y) {
              return h.call(y), v(_, y);
            };
          } else {
            var g = d.beforeCreate;
            d.beforeCreate = g ? [].concat(g, h) : [h];
          }
        return {
          exports: s,
          options: d
        };
      }
    },
    11: function(e, t) {
      e.exports = El();
    },
    21: function(e, t) {
      e.exports = Ob();
    },
    4: function(e, t) {
      e.exports = an();
    },
    75: function(e, t, r) {
      r.r(t);
      var i = function() {
        var S = this, b = S.$createElement, x = S._self._c || b;
        return x(
          "div",
          {
            class: [
              S.type === "textarea" ? "el-textarea" : "el-input",
              S.inputSize ? "el-input--" + S.inputSize : "",
              {
                "is-disabled": S.inputDisabled,
                "is-exceed": S.inputExceed,
                "el-input-group": S.$slots.prepend || S.$slots.append,
                "el-input-group--append": S.$slots.append,
                "el-input-group--prepend": S.$slots.prepend,
                "el-input--prefix": S.$slots.prefix || S.prefixIcon,
                "el-input--suffix": S.$slots.suffix || S.suffixIcon || S.clearable || S.showPassword
              }
            ],
            on: {
              mouseenter: function(E) {
                S.hovering = !0;
              },
              mouseleave: function(E) {
                S.hovering = !1;
              }
            }
          },
          [
            S.type !== "textarea" ? [
              S.$slots.prepend ? x(
                "div",
                { staticClass: "el-input-group__prepend" },
                [S._t("prepend")],
                2
              ) : S._e(),
              S.type !== "textarea" ? x(
                "input",
                S._b(
                  {
                    ref: "input",
                    staticClass: "el-input__inner",
                    attrs: {
                      tabindex: S.tabindex,
                      type: S.showPassword ? S.passwordVisible ? "text" : "password" : S.type,
                      disabled: S.inputDisabled,
                      readonly: S.readonly,
                      autocomplete: S.autoComplete || S.autocomplete,
                      "aria-label": S.label
                    },
                    on: {
                      compositionstart: S.handleCompositionStart,
                      compositionupdate: S.handleCompositionUpdate,
                      compositionend: S.handleCompositionEnd,
                      input: S.handleInput,
                      focus: S.handleFocus,
                      blur: S.handleBlur,
                      change: S.handleChange
                    }
                  },
                  "input",
                  S.$attrs,
                  !1
                )
              ) : S._e(),
              S.$slots.prefix || S.prefixIcon ? x(
                "span",
                { staticClass: "el-input__prefix" },
                [
                  S._t("prefix"),
                  S.prefixIcon ? x("i", {
                    staticClass: "el-input__icon",
                    class: S.prefixIcon
                  }) : S._e()
                ],
                2
              ) : S._e(),
              S.getSuffixVisible() ? x("span", { staticClass: "el-input__suffix" }, [
                x(
                  "span",
                  { staticClass: "el-input__suffix-inner" },
                  [
                    !S.showClear || !S.showPwdVisible || !S.isWordLimitVisible ? [
                      S._t("suffix"),
                      S.suffixIcon ? x("i", {
                        staticClass: "el-input__icon",
                        class: S.suffixIcon
                      }) : S._e()
                    ] : S._e(),
                    S.showClear ? x("i", {
                      staticClass: "el-input__icon el-icon-circle-close el-input__clear",
                      on: {
                        mousedown: function(E) {
                          E.preventDefault();
                        },
                        click: S.clear
                      }
                    }) : S._e(),
                    S.showPwdVisible ? x("i", {
                      staticClass: "el-input__icon el-icon-view el-input__clear",
                      on: { click: S.handlePasswordVisible }
                    }) : S._e(),
                    S.isWordLimitVisible ? x("span", { staticClass: "el-input__count" }, [
                      x(
                        "span",
                        { staticClass: "el-input__count-inner" },
                        [
                          S._v(
                            `
            ` + S._s(S.textLength) + "/" + S._s(S.upperLimit) + `
          `
                          )
                        ]
                      )
                    ]) : S._e()
                  ],
                  2
                ),
                S.validateState ? x("i", {
                  staticClass: "el-input__icon",
                  class: ["el-input__validateIcon", S.validateIcon]
                }) : S._e()
              ]) : S._e(),
              S.$slots.append ? x(
                "div",
                { staticClass: "el-input-group__append" },
                [S._t("append")],
                2
              ) : S._e()
            ] : x(
              "textarea",
              S._b(
                {
                  ref: "textarea",
                  staticClass: "el-textarea__inner",
                  style: S.textareaStyle,
                  attrs: {
                    tabindex: S.tabindex,
                    disabled: S.inputDisabled,
                    readonly: S.readonly,
                    autocomplete: S.autoComplete || S.autocomplete,
                    "aria-label": S.label
                  },
                  on: {
                    compositionstart: S.handleCompositionStart,
                    compositionupdate: S.handleCompositionUpdate,
                    compositionend: S.handleCompositionEnd,
                    input: S.handleInput,
                    focus: S.handleFocus,
                    blur: S.handleBlur,
                    change: S.handleChange
                  }
                },
                "textarea",
                S.$attrs,
                !1
              )
            ),
            S.isWordLimitVisible && S.type === "textarea" ? x("span", { staticClass: "el-input__count" }, [
              S._v(S._s(S.textLength) + "/" + S._s(S.upperLimit))
            ]) : S._e()
          ],
          2
        );
      }, s = [];
      i._withStripped = !0;
      var o = r(4), a = /* @__PURE__ */ r.n(o), l = r(11), u = /* @__PURE__ */ r.n(l), c = void 0, f = `
  height:0 !important;
  visibility:hidden !important;
  overflow:hidden !important;
  position:absolute !important;
  z-index:-1000 !important;
  top:0 !important;
  right:0 !important
`, p = ["letter-spacing", "line-height", "padding-top", "padding-bottom", "font-family", "font-weight", "font-size", "text-rendering", "text-transform", "width", "text-indent", "padding-left", "padding-right", "border-width", "box-sizing"];
      function d(S) {
        var b = window.getComputedStyle(S), x = b.getPropertyValue("box-sizing"), E = parseFloat(b.getPropertyValue("padding-bottom")) + parseFloat(b.getPropertyValue("padding-top")), M = parseFloat(b.getPropertyValue("border-bottom-width")) + parseFloat(b.getPropertyValue("border-top-width")), $ = p.map(function(F) {
          return F + ":" + b.getPropertyValue(F);
        }).join(";");
        return { contextStyle: $, paddingSize: E, borderSize: M, boxSizing: x };
      }
      function h(S) {
        var b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, x = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
        c || (c = document.createElement("textarea"), document.body.appendChild(c));
        var E = d(S), M = E.paddingSize, $ = E.borderSize, F = E.boxSizing, J = E.contextStyle;
        c.setAttribute("style", J + ";" + f), c.value = S.value || S.placeholder || "";
        var W = c.scrollHeight, H = {};
        F === "border-box" ? W = W + $ : F === "content-box" && (W = W - M), c.value = "";
        var Y = c.scrollHeight - M;
        if (b !== null) {
          var z = Y * b;
          F === "border-box" && (z = z + M + $), W = Math.max(z, W), H.minHeight = z + "px";
        }
        if (x !== null) {
          var j = Y * x;
          F === "border-box" && (j = j + M + $), W = Math.min(j, W);
        }
        return H.height = W + "px", c.parentNode && c.parentNode.removeChild(c), c = null, H;
      }
      var v = r(9), g = /* @__PURE__ */ r.n(v), m = r(21), _ = {
        name: "ElInput",
        componentName: "ElInput",
        mixins: [a.a, u.a],
        inheritAttrs: !1,
        inject: {
          elForm: {
            default: ""
          },
          elFormItem: {
            default: ""
          }
        },
        data: function() {
          return {
            textareaCalcStyle: {},
            hovering: !1,
            focused: !1,
            isComposing: !1,
            passwordVisible: !1
          };
        },
        props: {
          value: [String, Number],
          size: String,
          resize: String,
          form: String,
          disabled: Boolean,
          readonly: Boolean,
          type: {
            type: String,
            default: "text"
          },
          autosize: {
            type: [Boolean, Object],
            default: !1
          },
          autocomplete: {
            type: String,
            default: "off"
          },
          autoComplete: {
            type: String,
            validator: function(b) {
              return !0;
            }
          },
          validateEvent: {
            type: Boolean,
            default: !0
          },
          suffixIcon: String,
          prefixIcon: String,
          label: String,
          clearable: {
            type: Boolean,
            default: !1
          },
          showPassword: {
            type: Boolean,
            default: !1
          },
          showWordLimit: {
            type: Boolean,
            default: !1
          },
          tabindex: String
        },
        computed: {
          _elFormItemSize: function() {
            return (this.elFormItem || {}).elFormItemSize;
          },
          validateState: function() {
            return this.elFormItem ? this.elFormItem.validateState : "";
          },
          needStatusIcon: function() {
            return this.elForm ? this.elForm.statusIcon : !1;
          },
          validateIcon: function() {
            return {
              validating: "el-icon-loading",
              success: "el-icon-circle-check",
              error: "el-icon-circle-close"
            }[this.validateState];
          },
          textareaStyle: function() {
            return g()({}, this.textareaCalcStyle, { resize: this.resize });
          },
          inputSize: function() {
            return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
          },
          inputDisabled: function() {
            return this.disabled || (this.elForm || {}).disabled;
          },
          nativeInputValue: function() {
            return this.value === null || this.value === void 0 ? "" : String(this.value);
          },
          showClear: function() {
            return this.clearable && !this.inputDisabled && !this.readonly && this.nativeInputValue && (this.focused || this.hovering);
          },
          showPwdVisible: function() {
            return this.showPassword && !this.inputDisabled && !this.readonly && (!!this.nativeInputValue || this.focused);
          },
          isWordLimitVisible: function() {
            return this.showWordLimit && this.$attrs.maxlength && (this.type === "text" || this.type === "textarea") && !this.inputDisabled && !this.readonly && !this.showPassword;
          },
          upperLimit: function() {
            return this.$attrs.maxlength;
          },
          textLength: function() {
            return typeof this.value == "number" ? String(this.value).length : (this.value || "").length;
          },
          inputExceed: function() {
            return this.isWordLimitVisible && this.textLength > this.upperLimit;
          }
        },
        watch: {
          value: function(b) {
            this.$nextTick(this.resizeTextarea), this.validateEvent && this.dispatch("ElFormItem", "el.form.change", [b]);
          },
          nativeInputValue: function() {
            this.setNativeInputValue();
          },
          type: function() {
            var b = this;
            this.$nextTick(function() {
              b.setNativeInputValue(), b.resizeTextarea(), b.updateIconOffset();
            });
          }
        },
        methods: {
          focus: function() {
            this.getInput().focus();
          },
          blur: function() {
            this.getInput().blur();
          },
          getMigratingConfig: function() {
            return {
              props: {
                icon: "icon is removed, use suffix-icon / prefix-icon instead.",
                "on-icon-click": "on-icon-click is removed."
              },
              events: {
                click: "click is removed."
              }
            };
          },
          handleBlur: function(b) {
            this.focused = !1, this.$emit("blur", b), this.validateEvent && this.dispatch("ElFormItem", "el.form.blur", [this.value]);
          },
          select: function() {
            this.getInput().select();
          },
          resizeTextarea: function() {
            if (!this.$isServer) {
              var b = this.autosize, x = this.type;
              if (x === "textarea") {
                if (!b) {
                  this.textareaCalcStyle = {
                    minHeight: h(this.$refs.textarea).minHeight
                  };
                  return;
                }
                var E = b.minRows, M = b.maxRows;
                this.textareaCalcStyle = h(this.$refs.textarea, E, M);
              }
            }
          },
          setNativeInputValue: function() {
            var b = this.getInput();
            !b || b.value !== this.nativeInputValue && (b.value = this.nativeInputValue);
          },
          handleFocus: function(b) {
            this.focused = !0, this.$emit("focus", b);
          },
          handleCompositionStart: function(b) {
            this.$emit("compositionstart", b), this.isComposing = !0;
          },
          handleCompositionUpdate: function(b) {
            this.$emit("compositionupdate", b);
            var x = b.target.value, E = x[x.length - 1] || "";
            this.isComposing = !Object(m.isKorean)(E);
          },
          handleCompositionEnd: function(b) {
            this.$emit("compositionend", b), this.isComposing && (this.isComposing = !1, this.handleInput(b));
          },
          handleInput: function(b) {
            this.isComposing || b.target.value !== this.nativeInputValue && (this.$emit("input", b.target.value), this.$nextTick(this.setNativeInputValue));
          },
          handleChange: function(b) {
            this.$emit("change", b.target.value);
          },
          calcIconOffset: function(b) {
            var x = [].slice.call(this.$el.querySelectorAll(".el-input__" + b) || []);
            if (!!x.length) {
              for (var E = null, M = 0; M < x.length; M++)
                if (x[M].parentNode === this.$el) {
                  E = x[M];
                  break;
                }
              if (!!E) {
                var $ = {
                  suffix: "append",
                  prefix: "prepend"
                }, F = $[b];
                this.$slots[F] ? E.style.transform = "translateX(" + (b === "suffix" ? "-" : "") + this.$el.querySelector(".el-input-group__" + F).offsetWidth + "px)" : E.removeAttribute("style");
              }
            }
          },
          updateIconOffset: function() {
            this.calcIconOffset("prefix"), this.calcIconOffset("suffix");
          },
          clear: function() {
            this.$emit("input", ""), this.$emit("change", ""), this.$emit("clear");
          },
          handlePasswordVisible: function() {
            var b = this;
            this.passwordVisible = !this.passwordVisible, this.$nextTick(function() {
              b.focus();
            });
          },
          getInput: function() {
            return this.$refs.input || this.$refs.textarea;
          },
          getSuffixVisible: function() {
            return this.$slots.suffix || this.suffixIcon || this.showClear || this.showPassword || this.isWordLimitVisible || this.validateState && this.needStatusIcon;
          }
        },
        created: function() {
          this.$on("inputSelect", this.select);
        },
        mounted: function() {
          this.setNativeInputValue(), this.resizeTextarea(), this.updateIconOffset();
        },
        updated: function() {
          this.$nextTick(this.updateIconOffset);
        }
      }, y = _, w = r(0), O = Object(w.a)(
        y,
        i,
        s,
        !1,
        null,
        null,
        null
      );
      O.options.__file = "packages/input/src/input.vue";
      var C = O.exports;
      C.install = function(S) {
        S.component(C.name, C);
      }, t.default = C;
    },
    9: function(e, t) {
      e.exports = Cl();
    }
  });
})(Zs);
const Eb = /* @__PURE__ */ ot(Zs.exports);
const kM = Ce({
  props: {
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    url: {
      type: String,
      required: !0
    },
    image: {
      type: String,
      default: ""
    }
  },
  setup(n) {
    const e = ve(() => new URL(n.url)), t = ve(() => e.value.hostname);
    return {
      domain: e,
      hostname: t
    };
  }
});
var MM = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("a", { staticClass: "t-rich-link", attrs: { href: e.url, target: "_blank" } }, [t("div", { staticClass: "t-rich-link__image-container" }, [t("div", { staticClass: "t-rich-link__image-wrapper" }, [t("img", { staticClass: "t-rich-link__image lazyload", attrs: { alt: e.title, "data-src": e.image } })])]), t("div", { staticClass: "t-rich-link__content" }, [t("span", { staticClass: "t-rich-link__domain" }, [e._v(e._s(e.hostname))]), t("div", { staticClass: "t-rich-link__title" }, [e._v(e._s(e.title))]), t("p", { staticClass: "t-rich-link__description" }, [e._v(e._s(e.description))])])]);
}, AM = [], PM = /* @__PURE__ */ le(
  kM,
  MM,
  AM,
  !1,
  null,
  null,
  null,
  null
);
const Tb = PM.exports, $M = st({
  name: "RichLinkCommand",
  components: {
    TRichLink: Tb,
    ButtonCommand: yt,
    ElDialog: Kr,
    ElInput: Eb,
    ElButton: Rf
  },
  setup() {
    const n = $e("editor"), e = ct(""), t = ct({
      title: "",
      description: "",
      image: "",
      url: ""
    }), r = je(() => n == null ? void 0 : n.value.isActive("richLink")), i = async () => {
      try {
        const a = await (await fetch("https://api.linkpreview.net", {
          method: "POST",
          mode: "cors",
          body: JSON.stringify({
            key: "0cebd234eeee9094ebca6737846cb40f",
            q: e.value
          })
        })).json();
        a && a.title && (t.value = a);
      } catch (o) {
        console.log({ e: o });
      }
    }, s = () => {
      !n.value || n.value.chain().focus().setRichLink(t.value).run();
    };
    return wl(e, i), {
      editor: n,
      isActive: r,
      link: e,
      state: t,
      setRichLink: s
    };
  },
  data() {
    return {
      visible: !1
    };
  },
  methods: {
    close() {
      this.visible = !1;
    },
    onSave() {
      this.link && (this.setRichLink(), this.close());
    }
  }
});
var DM = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", [t("button-command", { attrs: { "is-active": e.isActive, icon: "external-link-line", title: "Rich link" }, on: { click: function(r) {
    e.visible = !0;
  } } }), t("el-dialog", { attrs: { visible: e.visible, "append-to-body": "", title: "Rich Link", top: "20px", width: "800px" }, on: { "update:visible": function(r) {
    e.visible = r;
  } }, scopedSlots: e._u([{ key: "title", fn: function() {
    return [t("div", { staticClass: "flex space-x-4" }, [t("el-button", { on: { click: e.onSave } }, [e._v("Save")]), t("div", { staticClass: "w-2/3" }, [t("el-input", { staticClass: "w-full", attrs: { placeholder: "Nh\u1EADp rich link" }, model: { value: e.link, callback: function(r) {
      e.link = r;
    }, expression: "link" } })], 1)], 1)];
  }, proxy: !0 }]) }, [t("div", { staticClass: "flex justify-center" }, [e.state.url ? t("t-rich-link", e._b({}, "t-rich-link", e.state, !1)) : e._e()], 1)])], 1);
}, LM = [], NM = /* @__PURE__ */ le(
  $M,
  DM,
  LM,
  !1,
  null,
  null,
  null,
  null
);
const IM = NM.exports;
var Om;
const RM = typeof window < "u", Em = () => {
};
RM && ((Om = window == null ? void 0 : window.navigator) == null ? void 0 : Om.userAgent) && /iP(ad|hone|od)/.test(window.navigator.userAgent);
function Tm(n) {
  return typeof n == "function" ? n() : aS(n);
}
function FM(n, e) {
  function t(...r) {
    return new Promise((i, s) => {
      Promise.resolve(n(() => e.apply(this, r), { fn: e, thisArg: this, args: r })).then(i).catch(s);
    });
  }
  return t;
}
const zM = (n) => n();
function BM(n, e = {}) {
  let t, r, i = Em;
  const s = (a) => {
    clearTimeout(a), i(), i = Em;
  };
  return (a) => {
    const l = Tm(n), u = Tm(e.maxWait);
    return t && s(t), l <= 0 || u !== void 0 && u <= 0 ? (r && (s(r), r = null), Promise.resolve(a())) : new Promise((c, f) => {
      i = e.rejectOnCancel ? f : c, u && !r && (r = setTimeout(() => {
        t && s(t), r = null, c(a());
      }, u)), t = setTimeout(() => {
        r && s(r), r = null, c(a());
      }, l);
    });
  };
}
var km = Object.getOwnPropertySymbols, jM = Object.prototype.hasOwnProperty, VM = Object.prototype.propertyIsEnumerable, HM = (n, e) => {
  var t = {};
  for (var r in n)
    jM.call(n, r) && e.indexOf(r) < 0 && (t[r] = n[r]);
  if (n != null && km)
    for (var r of km(n))
      e.indexOf(r) < 0 && VM.call(n, r) && (t[r] = n[r]);
  return t;
};
function WM(n, e, t = {}) {
  const r = t, {
    eventFilter: i = zM
  } = r, s = HM(r, [
    "eventFilter"
  ]);
  return wl(n, FM(i, e), s);
}
var qM = Object.defineProperty, UM = Object.defineProperties, GM = Object.getOwnPropertyDescriptors, ba = Object.getOwnPropertySymbols, kb = Object.prototype.hasOwnProperty, Mb = Object.prototype.propertyIsEnumerable, Mm = (n, e, t) => e in n ? qM(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, KM = (n, e) => {
  for (var t in e || (e = {}))
    kb.call(e, t) && Mm(n, t, e[t]);
  if (ba)
    for (var t of ba(e))
      Mb.call(e, t) && Mm(n, t, e[t]);
  return n;
}, JM = (n, e) => UM(n, GM(e)), XM = (n, e) => {
  var t = {};
  for (var r in n)
    kb.call(n, r) && e.indexOf(r) < 0 && (t[r] = n[r]);
  if (n != null && ba)
    for (var r of ba(n))
      e.indexOf(r) < 0 && Mb.call(n, r) && (t[r] = n[r]);
  return t;
};
function YM(n, e, t = {}) {
  const r = t, {
    debounce: i = 0,
    maxWait: s = void 0
  } = r, o = XM(r, [
    "debounce",
    "maxWait"
  ]);
  return WM(n, e, JM(KM({}, o), {
    eventFilter: BM(i, { maxWait: s })
  }));
}
const Ab = (n = !1) => {
  const e = ct(n);
  return {
    visible: e,
    open: () => e.value = !0,
    close: () => e.value = !1,
    toggle: () => e.value = !e.value
  };
};
var QM = (n) => n != null, ZM = (n) => toString.call(n) === "[object Object]", eA = (n) => Array.isArray(n), Id = (n) => {
  if (!QM(n))
    return n;
  if (eA(n))
    return n.map(Id);
  if (ZM(n)) {
    const e = {};
    return Object.keys(n).forEach((t) => {
      e[t] = Id(n[t]);
    }), e;
  }
  return n;
};
const tA = lS ? "input" : "update:modelValue", nA = (n, e = 0, t = tA) => {
  var o, a;
  const r = rS();
  if (!r)
    throw new Error("useLazyValue must be called within a component.");
  const i = (a = (o = r.proxy) == null ? void 0 : o.$emit) == null ? void 0 : a.bind(r.proxy), s = Le(n.value);
  return YM(s, (l) => {
    i(t, l), i("change", l);
  }, { debounce: iS(e) }), zr(n, (l) => {
    s.value = l;
  }), { internalValue: s };
}, Pb = Symbol("collapseContextKey");
const rA = Ce({
  model: {
    prop: "modelValue",
    event: "input"
  },
  props: {
    modelValue: { type: [Array, String, Number], default: () => [] },
    accordion: { type: Boolean, default: !1 }
  },
  setup(n) {
    const { modelValue: e, accordion: t } = Ef(n), { internalValue: r } = nA(e);
    Es(Pb, {
      internalValue: r,
      accordion: t
    });
  }
});
var iA = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "t-collapse" }, [e._t("default")], 2);
}, sA = [], oA = /* @__PURE__ */ le(
  rA,
  iA,
  sA,
  !1,
  null,
  null,
  null,
  null
);
const $b = oA.exports;
const aA = Ce({
  setup() {
    return { enter: async (t) => {
      await sS(), t.style.maxHeight = t.scrollHeight + "px";
    }, beforeLeave: (t) => {
      t.style.maxHeight = "0px";
    } };
  }
});
var lA = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("transition", e._g({ staticClass: "t-collapse-transition", attrs: { appear: "" } }, { enter: e.enter, beforeLeave: e.beforeLeave }), [e._t("default")], 2);
}, uA = [], cA = /* @__PURE__ */ le(
  aA,
  lA,
  uA,
  !1,
  null,
  null,
  null,
  null
);
const dA = cA.exports;
const fA = Ce({
  components: { TCollapseTransition: dA },
  props: {
    title: { type: String, required: !0 },
    name: { type: [String, Number], required: !0 },
    showExpandIcon: { type: Boolean, default: !0 }
  },
  setup(n) {
    const { internalValue: e, accordion: t } = Bi(Pb), { name: r } = Ef(n), i = ve(() => Array.isArray(e.value) ? e.value.includes(r.value) : e.value === r.value), s = ve(() => WE(String(r.value)));
    return {
      internalValue: e,
      accordion: t,
      isExpanded: i,
      uidContent: ve(() => "collapse-content-" + s.value),
      uidHeader: ve(() => "collapse-header-" + s.value),
      uidInput: ve(() => "collapse-input-" + s.value)
    };
  }
});
var pA = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "t-collapse-item", class: {
    "t-collapse-item--expanded": e.isExpanded
  } }, [t("h3", { attrs: { "aria-controls": e.uidContent, "aria-describedby": e.uidContent, "aria-expanded": e.isExpanded } }, [t("label", { staticClass: "t-collapse-item__header", attrs: { id: e.uidHeader, for: e.uidInput } }, [e._t("title", function() {
    return [t("div", { staticClass: "t-collapse-item__title" }, [e._v(e._s(e.title))])];
  }, null, { isExpanded: e.isExpanded }), e.showExpandIcon ? t("i", { staticClass: "t-collapse--item__expand-icon", class: e.isExpanded ? "i-ui-minus" : "i-ui-plus", attrs: { "aria-hidden": "true" } }) : e._e(), (e.accordion ? "radio" : "checkbox") == "checkbox" ? t("input", { directives: [{ name: "model", rawName: "v-model", value: e.internalValue, expression: "internalValue" }], attrs: { id: e.uidInput, "aria-hidden": "true", type: "checkbox" }, domProps: { value: e.name, checked: Array.isArray(e.internalValue) ? e._i(e.internalValue, e.name) > -1 : e.internalValue }, on: { change: function(r) {
    var i = e.internalValue, s = r.target, o = !!s.checked;
    if (Array.isArray(i)) {
      var a = e.name, l = e._i(i, a);
      s.checked ? l < 0 && (e.internalValue = i.concat([a])) : l > -1 && (e.internalValue = i.slice(0, l).concat(i.slice(l + 1)));
    } else
      e.internalValue = o;
  } } }) : (e.accordion ? "radio" : "checkbox") == "radio" ? t("input", { directives: [{ name: "model", rawName: "v-model", value: e.internalValue, expression: "internalValue" }], attrs: { id: e.uidInput, "aria-hidden": "true", type: "radio" }, domProps: { value: e.name, checked: e._q(e.internalValue, e.name) }, on: { change: function(r) {
    e.internalValue = e.name;
  } } }) : t("input", { directives: [{ name: "model", rawName: "v-model", value: e.internalValue, expression: "internalValue" }], attrs: { id: e.uidInput, "aria-hidden": "true", type: e.accordion ? "radio" : "checkbox" }, domProps: { value: e.name, value: e.internalValue }, on: { input: function(r) {
    r.target.composing || (e.internalValue = r.target.value);
  } } })], 2)]), t("t-collapse-transition", [t("div", { directives: [{ name: "show", rawName: "v-show", value: e.isExpanded, expression: "isExpanded" }], staticClass: "t-collapse-item__content", attrs: { id: e.uidContent, "aria-hidden": !e.isExpanded, "aria-labelledby": e.uidHeader } }, [e._t("default")], 2)])], 1);
}, hA = [], mA = /* @__PURE__ */ le(
  fA,
  pA,
  hA,
  !1,
  null,
  null,
  null,
  null
);
const Db = mA.exports;
const gA = st({
  name: "CollapseCommand",
  components: {
    TCollapse: $b,
    TCollapseItem: Db,
    TBtn: $l,
    ButtonCommand: yt,
    ElDialog: Kr
  },
  setup() {
    const { visible: n, close: e } = Ab(), { collapseList: t, addCollapseItem: r, removeCollapse: i } = vA(n), s = $e("editor"), o = je(() => s == null ? void 0 : s.value.isActive("collapse")), a = () => {
      !t.value.length || s.value.chain().focus().setCollapse(t.value).run();
    };
    return {
      visible: n,
      close: e,
      editor: s,
      isActive: o,
      onSave: () => {
        a(), e(), t.value = [];
      },
      addSku: a,
      collapseList: t,
      addCollapseItem: r,
      removeCollapse: i
    };
  }
}), vA = (n) => {
  const e = {
    title: "What is Lorem Ipsum?",
    content: `<p><strong>Lorem Ipsum</strong><span style="font-size: 14px"> is simply dummy text of the printing and typesetting industry. </span></p><p><span style="font-size: 14px">Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</span></p>`
  }, t = ct([]), r = () => {
    t.value.push(Id(e));
  }, i = (s) => {
    t.value.splice(s, 1);
  };
  return wl(n, () => {
    t.value = [], r();
  }), { collapseList: t, addCollapseItem: r, removeCollapse: i };
};
var yA = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", [t("button-command", { attrs: { "is-active": e.isActive, icon: "menu-fold-line", title: "Collapse" }, on: { click: function(r) {
    e.visible = !0;
  } } }), t("el-dialog", { attrs: { visible: e.visible, "append-to-body": "", "custom-class": "dialog-collapse", fullscreen: "", title: "Ch\u1ECDn collapse" }, on: { "update:visible": function(r) {
    e.visible = r;
  } }, scopedSlots: e._u([{ key: "title", fn: function() {
    return [t("div", { staticClass: "flex space-x-4" }, [t("t-btn", { attrs: { height: "40" }, on: { click: e.onSave } }, [e._v("Save")]), t("div", { staticClass: "w-1/2" })], 1)];
  }, proxy: !0 }]) }, [t("div", { staticClass: "flex bg-gray-50 justify-center" }, [t("div", { staticClass: "flex flex-col flex-1" }, [t("div", { staticClass: "flex-1", staticStyle: { overflow: "hidden", "max-height": "calc(100vh - 200px)" } }, [t("div", { staticClass: "flex flex-col space-y-4", staticStyle: { overflow: "auto", height: "100%" } }, e._l(e.collapseList, function(r, i) {
    return t("div", { key: i, staticClass: "collapse-item" }, [t("button", { staticClass: "btn-close", on: { click: function(s) {
      return e.removeCollapse(i);
    } } }, [t("svg", { attrs: { fill: "none", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" } }, [t("path", { attrs: { d: "M6 18L18 6M6 6l12 12", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "2" } })])]), t("div", { staticClass: "form-control" }, [t("label", { staticClass: "label" }, [t("span", { staticClass: "label-text" }, [e._v("Collapse " + e._s(i + 1))])]), t("input", { directives: [{ name: "model", rawName: "v-model", value: r.title, expression: "collapse.title" }], staticClass: "w-full input input-bordered", attrs: { placeholder: "Nh\u1EADp title", type: "text" }, domProps: { value: r.title }, on: { input: function(s) {
      s.target.composing || e.$set(r, "title", s.target.value);
    } } }), t("textarea", { directives: [{ name: "model", rawName: "v-model", value: r.content, expression: "collapse.content" }], attrs: { name: "", id: "", cols: "30", rows: "10" }, domProps: { value: r.content }, on: { input: function(s) {
      s.target.composing || e.$set(r, "content", s.target.value);
    } } })])]);
  }), 0)]), t("t-btn", { attrs: { color: "secondary", height: "40" }, on: { click: e.addCollapseItem } }, [e._v("Th\xEAm collapse")])], 1), t("div", { staticStyle: { width: "500px" } }, [t("t-collapse", e._l(e.collapseList, function(r, i) {
    return t("t-collapse-item", { key: i, attrs: { name: `${i}`, title: r.title } }, [t("span", { domProps: { innerHTML: e._s(r.content) } })]);
  }), 1)], 1)])])], 1);
}, bA = [], wA = /* @__PURE__ */ le(
  gA,
  yA,
  bA,
  !1,
  null,
  null,
  null,
  null
);
const _A = wA.exports;
var Lb = { exports: {} }, _c = { exports: {} }, wr = {}, Nb = function() {
  if (typeof Map < "u")
    return Map;
  function n(e, t) {
    var r = -1;
    return e.some(function(i, s) {
      return i[0] === t ? (r = s, !0) : !1;
    }), r;
  }
  return function() {
    function e() {
      this.__entries__ = [];
    }
    return Object.defineProperty(e.prototype, "size", {
      get: function() {
        return this.__entries__.length;
      },
      enumerable: !0,
      configurable: !0
    }), e.prototype.get = function(t) {
      var r = n(this.__entries__, t), i = this.__entries__[r];
      return i && i[1];
    }, e.prototype.set = function(t, r) {
      var i = n(this.__entries__, t);
      ~i ? this.__entries__[i][1] = r : this.__entries__.push([t, r]);
    }, e.prototype.delete = function(t) {
      var r = this.__entries__, i = n(r, t);
      ~i && r.splice(i, 1);
    }, e.prototype.has = function(t) {
      return !!~n(this.__entries__, t);
    }, e.prototype.clear = function() {
      this.__entries__.splice(0);
    }, e.prototype.forEach = function(t, r) {
      r === void 0 && (r = null);
      for (var i = 0, s = this.__entries__; i < s.length; i++) {
        var o = s[i];
        t.call(r, o[1], o[0]);
      }
    }, e;
  }();
}(), Rd = typeof window < "u" && typeof document < "u" && window.document === document, wa = function() {
  return typeof global < "u" && global.Math === Math ? global : typeof self < "u" && self.Math === Math ? self : typeof window < "u" && window.Math === Math ? window : Function("return this")();
}(), SA = function() {
  return typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind(wa) : function(n) {
    return setTimeout(function() {
      return n(Date.now());
    }, 1e3 / 60);
  };
}(), xA = 2;
function CA(n, e) {
  var t = !1, r = !1, i = 0;
  function s() {
    t && (t = !1, n()), r && a();
  }
  function o() {
    SA(s);
  }
  function a() {
    var l = Date.now();
    if (t) {
      if (l - i < xA)
        return;
      r = !0;
    } else
      t = !0, r = !1, setTimeout(o, e);
    i = l;
  }
  return a;
}
var OA = 20, EA = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], TA = typeof MutationObserver < "u", kA = function() {
  function n() {
    this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = CA(this.refresh.bind(this), OA);
  }
  return n.prototype.addObserver = function(e) {
    ~this.observers_.indexOf(e) || this.observers_.push(e), this.connected_ || this.connect_();
  }, n.prototype.removeObserver = function(e) {
    var t = this.observers_, r = t.indexOf(e);
    ~r && t.splice(r, 1), !t.length && this.connected_ && this.disconnect_();
  }, n.prototype.refresh = function() {
    var e = this.updateObservers_();
    e && this.refresh();
  }, n.prototype.updateObservers_ = function() {
    var e = this.observers_.filter(function(t) {
      return t.gatherActive(), t.hasActive();
    });
    return e.forEach(function(t) {
      return t.broadcastActive();
    }), e.length > 0;
  }, n.prototype.connect_ = function() {
    !Rd || this.connected_ || (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), TA ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
      attributes: !0,
      childList: !0,
      characterData: !0,
      subtree: !0
    })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
  }, n.prototype.disconnect_ = function() {
    !Rd || !this.connected_ || (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
  }, n.prototype.onTransitionEnd_ = function(e) {
    var t = e.propertyName, r = t === void 0 ? "" : t, i = EA.some(function(s) {
      return !!~r.indexOf(s);
    });
    i && this.refresh();
  }, n.getInstance = function() {
    return this.instance_ || (this.instance_ = new n()), this.instance_;
  }, n.instance_ = null, n;
}(), Ib = function(n, e) {
  for (var t = 0, r = Object.keys(e); t < r.length; t++) {
    var i = r[t];
    Object.defineProperty(n, i, {
      value: e[i],
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  }
  return n;
}, Ti = function(n) {
  var e = n && n.ownerDocument && n.ownerDocument.defaultView;
  return e || wa;
}, Rb = Il(0, 0, 0, 0);
function _a(n) {
  return parseFloat(n) || 0;
}
function Am(n) {
  for (var e = [], t = 1; t < arguments.length; t++)
    e[t - 1] = arguments[t];
  return e.reduce(function(r, i) {
    var s = n["border-" + i + "-width"];
    return r + _a(s);
  }, 0);
}
function MA(n) {
  for (var e = ["top", "right", "bottom", "left"], t = {}, r = 0, i = e; r < i.length; r++) {
    var s = i[r], o = n["padding-" + s];
    t[s] = _a(o);
  }
  return t;
}
function AA(n) {
  var e = n.getBBox();
  return Il(0, 0, e.width, e.height);
}
function PA(n) {
  var e = n.clientWidth, t = n.clientHeight;
  if (!e && !t)
    return Rb;
  var r = Ti(n).getComputedStyle(n), i = MA(r), s = i.left + i.right, o = i.top + i.bottom, a = _a(r.width), l = _a(r.height);
  if (r.boxSizing === "border-box" && (Math.round(a + s) !== e && (a -= Am(r, "left", "right") + s), Math.round(l + o) !== t && (l -= Am(r, "top", "bottom") + o)), !DA(n)) {
    var u = Math.round(a + s) - e, c = Math.round(l + o) - t;
    Math.abs(u) !== 1 && (a -= u), Math.abs(c) !== 1 && (l -= c);
  }
  return Il(i.left, i.top, a, l);
}
var $A = function() {
  return typeof SVGGraphicsElement < "u" ? function(n) {
    return n instanceof Ti(n).SVGGraphicsElement;
  } : function(n) {
    return n instanceof Ti(n).SVGElement && typeof n.getBBox == "function";
  };
}();
function DA(n) {
  return n === Ti(n).document.documentElement;
}
function LA(n) {
  return Rd ? $A(n) ? AA(n) : PA(n) : Rb;
}
function NA(n) {
  var e = n.x, t = n.y, r = n.width, i = n.height, s = typeof DOMRectReadOnly < "u" ? DOMRectReadOnly : Object, o = Object.create(s.prototype);
  return Ib(o, {
    x: e,
    y: t,
    width: r,
    height: i,
    top: t,
    right: e + r,
    bottom: i + t,
    left: e
  }), o;
}
function Il(n, e, t, r) {
  return { x: n, y: e, width: t, height: r };
}
var IA = function() {
  function n(e) {
    this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = Il(0, 0, 0, 0), this.target = e;
  }
  return n.prototype.isActive = function() {
    var e = LA(this.target);
    return this.contentRect_ = e, e.width !== this.broadcastWidth || e.height !== this.broadcastHeight;
  }, n.prototype.broadcastRect = function() {
    var e = this.contentRect_;
    return this.broadcastWidth = e.width, this.broadcastHeight = e.height, e;
  }, n;
}(), RA = function() {
  function n(e, t) {
    var r = NA(t);
    Ib(this, { target: e, contentRect: r });
  }
  return n;
}(), FA = function() {
  function n(e, t, r) {
    if (this.activeObservations_ = [], this.observations_ = new Nb(), typeof e != "function")
      throw new TypeError("The callback provided as parameter 1 is not a function.");
    this.callback_ = e, this.controller_ = t, this.callbackCtx_ = r;
  }
  return n.prototype.observe = function(e) {
    if (!arguments.length)
      throw new TypeError("1 argument required, but only 0 present.");
    if (!(typeof Element > "u" || !(Element instanceof Object))) {
      if (!(e instanceof Ti(e).Element))
        throw new TypeError('parameter 1 is not of type "Element".');
      var t = this.observations_;
      t.has(e) || (t.set(e, new IA(e)), this.controller_.addObserver(this), this.controller_.refresh());
    }
  }, n.prototype.unobserve = function(e) {
    if (!arguments.length)
      throw new TypeError("1 argument required, but only 0 present.");
    if (!(typeof Element > "u" || !(Element instanceof Object))) {
      if (!(e instanceof Ti(e).Element))
        throw new TypeError('parameter 1 is not of type "Element".');
      var t = this.observations_;
      !t.has(e) || (t.delete(e), t.size || this.controller_.removeObserver(this));
    }
  }, n.prototype.disconnect = function() {
    this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
  }, n.prototype.gatherActive = function() {
    var e = this;
    this.clearActive(), this.observations_.forEach(function(t) {
      t.isActive() && e.activeObservations_.push(t);
    });
  }, n.prototype.broadcastActive = function() {
    if (!!this.hasActive()) {
      var e = this.callbackCtx_, t = this.activeObservations_.map(function(r) {
        return new RA(r.target, r.broadcastRect());
      });
      this.callback_.call(e, t, e), this.clearActive();
    }
  }, n.prototype.clearActive = function() {
    this.activeObservations_.splice(0);
  }, n.prototype.hasActive = function() {
    return this.activeObservations_.length > 0;
  }, n;
}(), Fb = typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : new Nb(), zb = function() {
  function n(e) {
    if (!(this instanceof n))
      throw new TypeError("Cannot call a class as a function.");
    if (!arguments.length)
      throw new TypeError("1 argument required, but only 0 present.");
    var t = kA.getInstance(), r = new FA(e, t, this);
    Fb.set(this, r);
  }
  return n;
}();
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(n) {
  zb.prototype[n] = function() {
    var e;
    return (e = Fb.get(this))[n].apply(e, arguments);
  };
});
var zA = function() {
  return typeof wa.ResizeObserver < "u" ? wa.ResizeObserver : zb;
}();
const BA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: zA
}, Symbol.toStringTag, { value: "Module" })), jA = /* @__PURE__ */ Df(BA);
var Sc, Pm;
function VA() {
  if (Pm)
    return Sc;
  Pm = 1;
  var n = Cy(), e = Nf();
  return Sc = {
    throttle: n,
    debounce: e
  }, Sc;
}
var $m;
function Bb() {
  if ($m)
    return wr;
  $m = 1, wr.__esModule = !0, wr.removeResizeListener = wr.addResizeListener = void 0;
  var n = jA, e = r(n), t = VA();
  function r(o) {
    return o && o.__esModule ? o : { default: o };
  }
  var i = typeof window > "u", s = function(a) {
    for (var c = a, l = Array.isArray(c), u = 0, c = l ? c : c[Symbol.iterator](); ; ) {
      var f;
      if (l) {
        if (u >= c.length)
          break;
        f = c[u++];
      } else {
        if (u = c.next(), u.done)
          break;
        f = u.value;
      }
      var p = f, d = p.target.__resizeListeners__ || [];
      d.length && d.forEach(function(h) {
        h();
      });
    }
  };
  return wr.addResizeListener = function(a, l) {
    i || (a.__resizeListeners__ || (a.__resizeListeners__ = [], a.__ro__ = new e.default((0, t.debounce)(16, s)), a.__ro__.observe(a)), a.__resizeListeners__.push(l));
  }, wr.removeResizeListener = function(a, l) {
    !a || !a.__resizeListeners__ || (a.__resizeListeners__.splice(a.__resizeListeners__.indexOf(l), 1), a.__resizeListeners__.length || a.__ro__.disconnect());
  }, wr;
}
var Dm;
function HA() {
  return Dm || (Dm = 1, function(n) {
    n.exports = function(e) {
      var t = {};
      function r(i) {
        if (t[i])
          return t[i].exports;
        var s = t[i] = {
          i,
          l: !1,
          exports: {}
        };
        return e[i].call(s.exports, s, s.exports, r), s.l = !0, s.exports;
      }
      return r.m = e, r.c = t, r.d = function(i, s, o) {
        r.o(i, s) || Object.defineProperty(i, s, { enumerable: !0, get: o });
      }, r.r = function(i) {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(i, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(i, "__esModule", { value: !0 });
      }, r.t = function(i, s) {
        if (s & 1 && (i = r(i)), s & 8 || s & 4 && typeof i == "object" && i && i.__esModule)
          return i;
        var o = /* @__PURE__ */ Object.create(null);
        if (r.r(o), Object.defineProperty(o, "default", { enumerable: !0, value: i }), s & 2 && typeof i != "string")
          for (var a in i)
            r.d(o, a, function(l) {
              return i[l];
            }.bind(null, a));
        return o;
      }, r.n = function(i) {
        var s = i && i.__esModule ? function() {
          return i.default;
        } : function() {
          return i;
        };
        return r.d(s, "a", s), s;
      }, r.o = function(i, s) {
        return Object.prototype.hasOwnProperty.call(i, s);
      }, r.p = "/dist/", r(r.s = 133);
    }({
      133: function(e, t, r) {
        r.r(t);
        var i = r(16), s = r(39), o = /* @__PURE__ */ r.n(s), a = r(3), l = r(2), u = {
          vertical: {
            offset: "offsetHeight",
            scroll: "scrollTop",
            scrollSize: "scrollHeight",
            size: "height",
            key: "vertical",
            axis: "Y",
            client: "clientY",
            direction: "top"
          },
          horizontal: {
            offset: "offsetWidth",
            scroll: "scrollLeft",
            scrollSize: "scrollWidth",
            size: "width",
            key: "horizontal",
            axis: "X",
            client: "clientX",
            direction: "left"
          }
        };
        function c(d) {
          var h = d.move, v = d.size, g = d.bar, m = {}, _ = "translate" + g.axis + "(" + h + "%)";
          return m[g.size] = v, m.transform = _, m.msTransform = _, m.webkitTransform = _, m;
        }
        var f = {
          name: "Bar",
          props: {
            vertical: Boolean,
            size: String,
            move: Number
          },
          computed: {
            bar: function() {
              return u[this.vertical ? "vertical" : "horizontal"];
            },
            wrap: function() {
              return this.$parent.wrap;
            }
          },
          render: function(h) {
            var v = this.size, g = this.move, m = this.bar;
            return h(
              "div",
              {
                class: ["el-scrollbar__bar", "is-" + m.key],
                on: {
                  mousedown: this.clickTrackHandler
                }
              },
              [h("div", {
                ref: "thumb",
                class: "el-scrollbar__thumb",
                on: {
                  mousedown: this.clickThumbHandler
                },
                style: c({ size: v, move: g, bar: m })
              })]
            );
          },
          methods: {
            clickThumbHandler: function(h) {
              h.ctrlKey || h.button === 2 || (this.startDrag(h), this[this.bar.axis] = h.currentTarget[this.bar.offset] - (h[this.bar.client] - h.currentTarget.getBoundingClientRect()[this.bar.direction]));
            },
            clickTrackHandler: function(h) {
              var v = Math.abs(h.target.getBoundingClientRect()[this.bar.direction] - h[this.bar.client]), g = this.$refs.thumb[this.bar.offset] / 2, m = (v - g) * 100 / this.$el[this.bar.offset];
              this.wrap[this.bar.scroll] = m * this.wrap[this.bar.scrollSize] / 100;
            },
            startDrag: function(h) {
              h.stopImmediatePropagation(), this.cursorDown = !0, Object(l.on)(document, "mousemove", this.mouseMoveDocumentHandler), Object(l.on)(document, "mouseup", this.mouseUpDocumentHandler), document.onselectstart = function() {
                return !1;
              };
            },
            mouseMoveDocumentHandler: function(h) {
              if (this.cursorDown !== !1) {
                var v = this[this.bar.axis];
                if (!!v) {
                  var g = (this.$el.getBoundingClientRect()[this.bar.direction] - h[this.bar.client]) * -1, m = this.$refs.thumb[this.bar.offset] - v, _ = (g - m) * 100 / this.$el[this.bar.offset];
                  this.wrap[this.bar.scroll] = _ * this.wrap[this.bar.scrollSize] / 100;
                }
              }
            },
            mouseUpDocumentHandler: function(h) {
              this.cursorDown = !1, this[this.bar.axis] = 0, Object(l.off)(document, "mousemove", this.mouseMoveDocumentHandler), document.onselectstart = null;
            }
          },
          destroyed: function() {
            Object(l.off)(document, "mouseup", this.mouseUpDocumentHandler);
          }
        }, p = {
          name: "ElScrollbar",
          components: { Bar: f },
          props: {
            native: Boolean,
            wrapStyle: {},
            wrapClass: {},
            viewClass: {},
            viewStyle: {},
            noresize: Boolean,
            tag: {
              type: String,
              default: "div"
            }
          },
          data: function() {
            return {
              sizeWidth: "0",
              sizeHeight: "0",
              moveX: 0,
              moveY: 0
            };
          },
          computed: {
            wrap: function() {
              return this.$refs.wrap;
            }
          },
          render: function(h) {
            var v = o()(), g = this.wrapStyle;
            if (v) {
              var m = "-" + v + "px", _ = "margin-bottom: " + m + "; margin-right: " + m + ";";
              Array.isArray(this.wrapStyle) ? (g = Object(a.toObject)(this.wrapStyle), g.marginRight = g.marginBottom = m) : typeof this.wrapStyle == "string" ? g += _ : g = _;
            }
            var y = h(this.tag, {
              class: ["el-scrollbar__view", this.viewClass],
              style: this.viewStyle,
              ref: "resize"
            }, this.$slots.default), w = h(
              "div",
              {
                ref: "wrap",
                style: g,
                on: {
                  scroll: this.handleScroll
                },
                class: [this.wrapClass, "el-scrollbar__wrap", v ? "" : "el-scrollbar__wrap--hidden-default"]
              },
              [[y]]
            ), O = void 0;
            return this.native ? O = [h(
              "div",
              {
                ref: "wrap",
                class: [this.wrapClass, "el-scrollbar__wrap"],
                style: g
              },
              [[y]]
            )] : O = [w, h(f, {
              attrs: {
                move: this.moveX,
                size: this.sizeWidth
              }
            }), h(f, {
              attrs: {
                vertical: !0,
                move: this.moveY,
                size: this.sizeHeight
              }
            })], h("div", { class: "el-scrollbar" }, O);
          },
          methods: {
            handleScroll: function() {
              var h = this.wrap;
              this.moveY = h.scrollTop * 100 / h.clientHeight, this.moveX = h.scrollLeft * 100 / h.clientWidth;
            },
            update: function() {
              var h = void 0, v = void 0, g = this.wrap;
              !g || (h = g.clientHeight * 100 / g.scrollHeight, v = g.clientWidth * 100 / g.scrollWidth, this.sizeHeight = h < 100 ? h + "%" : "", this.sizeWidth = v < 100 ? v + "%" : "");
            }
          },
          mounted: function() {
            this.native || (this.$nextTick(this.update), !this.noresize && Object(i.addResizeListener)(this.$refs.resize, this.update));
          },
          beforeDestroy: function() {
            this.native || !this.noresize && Object(i.removeResizeListener)(this.$refs.resize, this.update);
          }
        };
        p.install = function(d) {
          d.component(p.name, p);
        }, t.default = p;
      },
      16: function(e, t) {
        e.exports = Bb();
      },
      2: function(e, t) {
        e.exports = ji();
      },
      3: function(e, t) {
        e.exports = ne;
      },
      39: function(e, t) {
        e.exports = Ty();
      }
    });
  }(_c)), _c.exports;
}
var Eo = {}, Lm;
function rp() {
  return Lm || (Lm = 1, Eo.__esModule = !0, Eo.default = function(n) {
    return {
      methods: {
        focus: function() {
          this.$refs[n].focus();
        }
      }
    };
  }), Eo;
}
var To = {}, Nm;
function WA() {
  if (Nm)
    return To;
  Nm = 1, To.__esModule = !0, To.default = r;
  var n = Nt, e = t(n);
  function t(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function r(i, s) {
    if (!e.default.prototype.$isServer) {
      if (!s) {
        i.scrollTop = 0;
        return;
      }
      for (var o = [], a = s.offsetParent; a && i !== a && i.contains(a); )
        o.push(a), a = a.offsetParent;
      var l = s.offsetTop + o.reduce(function(p, d) {
        return p + d.offsetTop;
      }, 0), u = l + s.offsetHeight, c = i.scrollTop, f = c + i.clientHeight;
      l < c ? i.scrollTop = l : u > f && (i.scrollTop = u - i.clientHeight);
    }
  }
  return To;
}
var xc = { exports: {} }, Im;
function qA() {
  return Im || (Im = 1, function(n) {
    n.exports = function(e) {
      var t = {};
      function r(i) {
        if (t[i])
          return t[i].exports;
        var s = t[i] = {
          i,
          l: !1,
          exports: {}
        };
        return e[i].call(s.exports, s, s.exports, r), s.l = !0, s.exports;
      }
      return r.m = e, r.c = t, r.d = function(i, s, o) {
        r.o(i, s) || Object.defineProperty(i, s, { enumerable: !0, get: o });
      }, r.r = function(i) {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(i, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(i, "__esModule", { value: !0 });
      }, r.t = function(i, s) {
        if (s & 1 && (i = r(i)), s & 8 || s & 4 && typeof i == "object" && i && i.__esModule)
          return i;
        var o = /* @__PURE__ */ Object.create(null);
        if (r.r(o), Object.defineProperty(o, "default", { enumerable: !0, value: i }), s & 2 && typeof i != "string")
          for (var a in i)
            r.d(o, a, function(l) {
              return i[l];
            }.bind(null, a));
        return o;
      }, r.n = function(i) {
        var s = i && i.__esModule ? function() {
          return i.default;
        } : function() {
          return i;
        };
        return r.d(s, "a", s), s;
      }, r.o = function(i, s) {
        return Object.prototype.hasOwnProperty.call(i, s);
      }, r.p = "/dist/", r(r.s = 132);
    }({
      0: function(e, t, r) {
        r.d(t, "a", function() {
          return i;
        });
        function i(s, o, a, l, u, c, f, p) {
          var d = typeof s == "function" ? s.options : s;
          o && (d.render = o, d.staticRenderFns = a, d._compiled = !0), l && (d.functional = !0), c && (d._scopeId = "data-v-" + c);
          var h;
          if (f ? (h = function(m) {
            m = m || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !m && typeof __VUE_SSR_CONTEXT__ < "u" && (m = __VUE_SSR_CONTEXT__), u && u.call(this, m), m && m._registeredComponents && m._registeredComponents.add(f);
          }, d._ssrRegister = h) : u && (h = p ? function() {
            u.call(this, this.$root.$options.shadowRoot);
          } : u), h)
            if (d.functional) {
              d._injectStyles = h;
              var v = d.render;
              d.render = function(_, y) {
                return h.call(y), v(_, y);
              };
            } else {
              var g = d.beforeCreate;
              d.beforeCreate = g ? [].concat(g, h) : [h];
            }
          return {
            exports: s,
            options: d
          };
        }
      },
      132: function(e, t, r) {
        r.r(t);
        var i = {
          name: "ElTag",
          props: {
            text: String,
            closable: Boolean,
            type: String,
            hit: Boolean,
            disableTransitions: Boolean,
            color: String,
            size: String,
            effect: {
              type: String,
              default: "light",
              validator: function(p) {
                return ["dark", "light", "plain"].indexOf(p) !== -1;
              }
            }
          },
          methods: {
            handleClose: function(p) {
              p.stopPropagation(), this.$emit("close", p);
            },
            handleClick: function(p) {
              this.$emit("click", p);
            }
          },
          computed: {
            tagSize: function() {
              return this.size || (this.$ELEMENT || {}).size;
            }
          },
          render: function(p) {
            var d = this.type, h = this.tagSize, v = this.hit, g = this.effect, m = ["el-tag", d ? "el-tag--" + d : "", h ? "el-tag--" + h : "", g ? "el-tag--" + g : "", v && "is-hit"], _ = p(
              "span",
              {
                class: m,
                style: { backgroundColor: this.color },
                on: {
                  click: this.handleClick
                }
              },
              [this.$slots.default, this.closable && p("i", {
                class: "el-tag__close el-icon-close",
                on: {
                  click: this.handleClose
                }
              })]
            );
            return this.disableTransitions ? _ : p(
              "transition",
              {
                attrs: { name: "el-zoom-in-center" }
              },
              [_]
            );
          }
        }, s = i, o = r(0), a, l, u = Object(o.a)(
          s,
          a,
          l,
          !1,
          null,
          null,
          null
        );
        u.options.__file = "packages/tag/src/tag.vue";
        var c = u.exports;
        c.install = function(f) {
          f.component(c.name, c);
        }, t.default = c;
      }
    });
  }(xc)), xc.exports;
}
var ko = {}, Ln = {}, ip = {};
ip.__esModule = !0;
ip.default = {
  el: {
    colorpicker: {
      confirm: "\u786E\u5B9A",
      clear: "\u6E05\u7A7A"
    },
    datepicker: {
      now: "\u6B64\u523B",
      today: "\u4ECA\u5929",
      cancel: "\u53D6\u6D88",
      clear: "\u6E05\u7A7A",
      confirm: "\u786E\u5B9A",
      selectDate: "\u9009\u62E9\u65E5\u671F",
      selectTime: "\u9009\u62E9\u65F6\u95F4",
      startDate: "\u5F00\u59CB\u65E5\u671F",
      startTime: "\u5F00\u59CB\u65F6\u95F4",
      endDate: "\u7ED3\u675F\u65E5\u671F",
      endTime: "\u7ED3\u675F\u65F6\u95F4",
      prevYear: "\u524D\u4E00\u5E74",
      nextYear: "\u540E\u4E00\u5E74",
      prevMonth: "\u4E0A\u4E2A\u6708",
      nextMonth: "\u4E0B\u4E2A\u6708",
      year: "\u5E74",
      month1: "1 \u6708",
      month2: "2 \u6708",
      month3: "3 \u6708",
      month4: "4 \u6708",
      month5: "5 \u6708",
      month6: "6 \u6708",
      month7: "7 \u6708",
      month8: "8 \u6708",
      month9: "9 \u6708",
      month10: "10 \u6708",
      month11: "11 \u6708",
      month12: "12 \u6708",
      weeks: {
        sun: "\u65E5",
        mon: "\u4E00",
        tue: "\u4E8C",
        wed: "\u4E09",
        thu: "\u56DB",
        fri: "\u4E94",
        sat: "\u516D"
      },
      months: {
        jan: "\u4E00\u6708",
        feb: "\u4E8C\u6708",
        mar: "\u4E09\u6708",
        apr: "\u56DB\u6708",
        may: "\u4E94\u6708",
        jun: "\u516D\u6708",
        jul: "\u4E03\u6708",
        aug: "\u516B\u6708",
        sep: "\u4E5D\u6708",
        oct: "\u5341\u6708",
        nov: "\u5341\u4E00\u6708",
        dec: "\u5341\u4E8C\u6708"
      }
    },
    select: {
      loading: "\u52A0\u8F7D\u4E2D",
      noMatch: "\u65E0\u5339\u914D\u6570\u636E",
      noData: "\u65E0\u6570\u636E",
      placeholder: "\u8BF7\u9009\u62E9"
    },
    cascader: {
      noMatch: "\u65E0\u5339\u914D\u6570\u636E",
      loading: "\u52A0\u8F7D\u4E2D",
      placeholder: "\u8BF7\u9009\u62E9",
      noData: "\u6682\u65E0\u6570\u636E"
    },
    pagination: {
      goto: "\u524D\u5F80",
      pagesize: "\u6761/\u9875",
      total: "\u5171 {total} \u6761",
      pageClassifier: "\u9875"
    },
    messagebox: {
      title: "\u63D0\u793A",
      confirm: "\u786E\u5B9A",
      cancel: "\u53D6\u6D88",
      error: "\u8F93\u5165\u7684\u6570\u636E\u4E0D\u5408\u6CD5!"
    },
    upload: {
      deleteTip: "\u6309 delete \u952E\u53EF\u5220\u9664",
      delete: "\u5220\u9664",
      preview: "\u67E5\u770B\u56FE\u7247",
      continue: "\u7EE7\u7EED\u4E0A\u4F20"
    },
    table: {
      emptyText: "\u6682\u65E0\u6570\u636E",
      confirmFilter: "\u7B5B\u9009",
      resetFilter: "\u91CD\u7F6E",
      clearFilter: "\u5168\u90E8",
      sumText: "\u5408\u8BA1"
    },
    tree: {
      emptyText: "\u6682\u65E0\u6570\u636E"
    },
    transfer: {
      noMatch: "\u65E0\u5339\u914D\u6570\u636E",
      noData: "\u65E0\u6570\u636E",
      titles: ["\u5217\u8868 1", "\u5217\u8868 2"],
      filterPlaceholder: "\u8BF7\u8F93\u5165\u641C\u7D22\u5185\u5BB9",
      noCheckedFormat: "\u5171 {total} \u9879",
      hasCheckedFormat: "\u5DF2\u9009 {checked}/{total} \u9879"
    },
    image: {
      error: "\u52A0\u8F7D\u5931\u8D25"
    },
    pageHeader: {
      title: "\u8FD4\u56DE"
    },
    popconfirm: {
      confirmButtonText: "\u786E\u5B9A",
      cancelButtonText: "\u53D6\u6D88"
    },
    empty: {
      description: "\u6682\u65E0\u6570\u636E"
    }
  }
};
var Sa = function(e) {
  return UA(e) && !GA(e);
};
function UA(n) {
  return !!n && typeof n == "object";
}
function GA(n) {
  var e = Object.prototype.toString.call(n);
  return e === "[object RegExp]" || e === "[object Date]" || XA(n);
}
var KA = typeof Symbol == "function" && Symbol.for, JA = KA ? Symbol.for("react.element") : 60103;
function XA(n) {
  return n.$$typeof === JA;
}
function YA(n) {
  return Array.isArray(n) ? [] : {};
}
function Ms(n, e) {
  var t = e && e.clone === !0;
  return t && Sa(n) ? ki(YA(n), n, e) : n;
}
function Rm(n, e, t) {
  var r = n.slice();
  return e.forEach(function(i, s) {
    typeof r[s] > "u" ? r[s] = Ms(i, t) : Sa(i) ? r[s] = ki(n[s], i, t) : n.indexOf(i) === -1 && r.push(Ms(i, t));
  }), r;
}
function QA(n, e, t) {
  var r = {};
  return Sa(n) && Object.keys(n).forEach(function(i) {
    r[i] = Ms(n[i], t);
  }), Object.keys(e).forEach(function(i) {
    !Sa(e[i]) || !n[i] ? r[i] = Ms(e[i], t) : r[i] = ki(n[i], e[i], t);
  }), r;
}
function ki(n, e, t) {
  var r = Array.isArray(e), i = Array.isArray(n), s = t || { arrayMerge: Rm }, o = r === i;
  if (o)
    if (r) {
      var a = s.arrayMerge || Rm;
      return a(n, e, t);
    } else
      return QA(n, e, t);
  else
    return Ms(e, t);
}
ki.all = function(e, t) {
  if (!Array.isArray(e) || e.length < 2)
    throw new Error("first argument should be an array with at least two elements");
  return e.reduce(function(r, i) {
    return ki(r, i, t);
  });
};
var ZA = ki, eP = ZA, sp = {};
sp.__esModule = !0;
var tP = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
  return typeof n;
} : function(n) {
  return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
};
sp.default = function(n) {
  function e(t) {
    for (var r = arguments.length, i = Array(r > 1 ? r - 1 : 0), s = 1; s < r; s++)
      i[s - 1] = arguments[s];
    return i.length === 1 && tP(i[0]) === "object" && (i = i[0]), (!i || !i.hasOwnProperty) && (i = {}), t.replace(rP, function(o, a, l, u) {
      var c = void 0;
      return t[u - 1] === "{" && t[u + o.length] === "}" ? l : (c = (0, nP.hasOwn)(i, l) ? i[l] : null, c == null ? "" : c);
    });
  }
  return e;
};
var nP = ne, rP = /(%|)\{([0-9a-zA-Z_]+)\}/g;
Ln.__esModule = !0;
Ln.i18n = Ln.use = Ln.t = void 0;
var iP = ip, sP = Rl(iP), oP = Nt, _r = Rl(oP), aP = eP, lP = Rl(aP), uP = sp, cP = Rl(uP);
function Rl(n) {
  return n && n.__esModule ? n : { default: n };
}
var dP = (0, cP.default)(_r.default), xa = sP.default, Fm = !1, Fd = function() {
  var e = Object.getPrototypeOf(this || _r.default).$t;
  if (typeof e == "function" && !!_r.default.locale)
    return Fm || (Fm = !0, _r.default.locale(_r.default.config.lang, (0, lP.default)(xa, _r.default.locale(_r.default.config.lang) || {}, { clone: !0 }))), e.apply(this, arguments);
}, fP = Ln.t = function(e, t) {
  var r = Fd.apply(this, arguments);
  if (r != null)
    return r;
  for (var i = e.split("."), s = xa, o = 0, a = i.length; o < a; o++) {
    var l = i[o];
    if (r = s[l], o === a - 1)
      return dP(r, t);
    if (!r)
      return "";
    s = r;
  }
  return "";
}, pP = Ln.use = function(e) {
  xa = e || xa;
}, hP = Ln.i18n = function(e) {
  Fd = e || Fd;
}, mP = Ln.default = { use: pP, t: fP, i18n: hP }, zm;
function jb() {
  if (zm)
    return ko;
  zm = 1, ko.__esModule = !0;
  var n = Ln;
  return ko.default = {
    methods: {
      t: function() {
        for (var t = arguments.length, r = Array(t), i = 0; i < t; i++)
          r[i] = arguments[i];
        return n.t.apply(this, r);
      }
    }
  }, ko;
}
(function(n) {
  n.exports = function(e) {
    var t = {};
    function r(i) {
      if (t[i])
        return t[i].exports;
      var s = t[i] = {
        i,
        l: !1,
        exports: {}
      };
      return e[i].call(s.exports, s, s.exports, r), s.l = !0, s.exports;
    }
    return r.m = e, r.c = t, r.d = function(i, s, o) {
      r.o(i, s) || Object.defineProperty(i, s, { enumerable: !0, get: o });
    }, r.r = function(i) {
      typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(i, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(i, "__esModule", { value: !0 });
    }, r.t = function(i, s) {
      if (s & 1 && (i = r(i)), s & 8 || s & 4 && typeof i == "object" && i && i.__esModule)
        return i;
      var o = /* @__PURE__ */ Object.create(null);
      if (r.r(o), Object.defineProperty(o, "default", { enumerable: !0, value: i }), s & 2 && typeof i != "string")
        for (var a in i)
          r.d(o, a, function(l) {
            return i[l];
          }.bind(null, a));
      return o;
    }, r.n = function(i) {
      var s = i && i.__esModule ? function() {
        return i.default;
      } : function() {
        return i;
      };
      return r.d(s, "a", s), s;
    }, r.o = function(i, s) {
      return Object.prototype.hasOwnProperty.call(i, s);
    }, r.p = "/dist/", r(r.s = 62);
  }({
    0: function(e, t, r) {
      r.d(t, "a", function() {
        return i;
      });
      function i(s, o, a, l, u, c, f, p) {
        var d = typeof s == "function" ? s.options : s;
        o && (d.render = o, d.staticRenderFns = a, d._compiled = !0), l && (d.functional = !0), c && (d._scopeId = "data-v-" + c);
        var h;
        if (f ? (h = function(m) {
          m = m || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !m && typeof __VUE_SSR_CONTEXT__ < "u" && (m = __VUE_SSR_CONTEXT__), u && u.call(this, m), m && m._registeredComponents && m._registeredComponents.add(f);
        }, d._ssrRegister = h) : u && (h = p ? function() {
          u.call(this, this.$root.$options.shadowRoot);
        } : u), h)
          if (d.functional) {
            d._injectStyles = h;
            var v = d.render;
            d.render = function(_, y) {
              return h.call(y), v(_, y);
            };
          } else {
            var g = d.beforeCreate;
            d.beforeCreate = g ? [].concat(g, h) : [h];
          }
        return {
          exports: s,
          options: d
        };
      }
    },
    10: function(e, t) {
      e.exports = Zs.exports;
    },
    12: function(e, t) {
      e.exports = If();
    },
    15: function(e, t) {
      e.exports = HA();
    },
    16: function(e, t) {
      e.exports = Bb();
    },
    19: function(e, t) {
      e.exports = Nf();
    },
    21: function(e, t) {
      e.exports = Ob();
    },
    22: function(e, t) {
      e.exports = rp();
    },
    3: function(e, t) {
      e.exports = ne;
    },
    31: function(e, t) {
      e.exports = WA();
    },
    33: function(e, t, r) {
      var i = function() {
        var h = this, v = h.$createElement, g = h._self._c || v;
        return g(
          "li",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: h.visible,
                expression: "visible"
              }
            ],
            staticClass: "el-select-dropdown__item",
            class: {
              selected: h.itemSelected,
              "is-disabled": h.disabled || h.groupDisabled || h.limitReached,
              hover: h.hover
            },
            on: {
              mouseenter: h.hoverItem,
              click: function(m) {
                return m.stopPropagation(), h.selectOptionClick(m);
              }
            }
          },
          [h._t("default", [g("span", [h._v(h._s(h.currentLabel))])])],
          2
        );
      }, s = [];
      i._withStripped = !0;
      var o = r(4), a = /* @__PURE__ */ r.n(o), l = r(3), u = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(h) {
        return typeof h;
      } : function(h) {
        return h && typeof Symbol == "function" && h.constructor === Symbol && h !== Symbol.prototype ? "symbol" : typeof h;
      }, c = {
        mixins: [a.a],
        name: "ElOption",
        componentName: "ElOption",
        inject: ["select"],
        props: {
          value: {
            required: !0
          },
          label: [String, Number],
          created: Boolean,
          disabled: {
            type: Boolean,
            default: !1
          }
        },
        data: function() {
          return {
            index: -1,
            groupDisabled: !1,
            visible: !0,
            hitState: !1,
            hover: !1
          };
        },
        computed: {
          isObject: function() {
            return Object.prototype.toString.call(this.value).toLowerCase() === "[object object]";
          },
          currentLabel: function() {
            return this.label || (this.isObject ? "" : this.value);
          },
          currentValue: function() {
            return this.value || this.label || "";
          },
          itemSelected: function() {
            return this.select.multiple ? this.contains(this.select.value, this.value) : this.isEqual(this.value, this.select.value);
          },
          limitReached: function() {
            return this.select.multiple ? !this.itemSelected && (this.select.value || []).length >= this.select.multipleLimit && this.select.multipleLimit > 0 : !1;
          }
        },
        watch: {
          currentLabel: function() {
            !this.created && !this.select.remote && this.dispatch("ElSelect", "setSelected");
          },
          value: function(v, g) {
            var m = this.select, _ = m.remote, y = m.valueKey;
            if (!this.created && !_) {
              if (y && (typeof v > "u" ? "undefined" : u(v)) === "object" && (typeof g > "u" ? "undefined" : u(g)) === "object" && v[y] === g[y])
                return;
              this.dispatch("ElSelect", "setSelected");
            }
          }
        },
        methods: {
          isEqual: function(v, g) {
            if (this.isObject) {
              var m = this.select.valueKey;
              return Object(l.getValueByPath)(v, m) === Object(l.getValueByPath)(g, m);
            } else
              return v === g;
          },
          contains: function() {
            var v = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], g = arguments[1];
            if (this.isObject) {
              var m = this.select.valueKey;
              return v && v.some(function(_) {
                return Object(l.getValueByPath)(_, m) === Object(l.getValueByPath)(g, m);
              });
            } else
              return v && v.indexOf(g) > -1;
          },
          handleGroupDisabled: function(v) {
            this.groupDisabled = v;
          },
          hoverItem: function() {
            !this.disabled && !this.groupDisabled && (this.select.hoverIndex = this.select.options.indexOf(this));
          },
          selectOptionClick: function() {
            this.disabled !== !0 && this.groupDisabled !== !0 && this.dispatch("ElSelect", "handleOptionClick", [this, !0]);
          },
          queryChange: function(v) {
            this.visible = new RegExp(Object(l.escapeRegexpString)(v), "i").test(this.currentLabel) || this.created, this.visible || this.select.filteredOptionsCount--;
          }
        },
        created: function() {
          this.select.options.push(this), this.select.cachedOptions.push(this), this.select.optionsCount++, this.select.filteredOptionsCount++, this.$on("queryChange", this.queryChange), this.$on("handleGroupDisabled", this.handleGroupDisabled);
        },
        beforeDestroy: function() {
          var v = this.select, g = v.selected, m = v.multiple, _ = m ? g : [g], y = this.select.cachedOptions.indexOf(this), w = _.indexOf(this);
          y > -1 && w < 0 && this.select.cachedOptions.splice(y, 1), this.select.onOptionDestroy(this.select.options.indexOf(this));
        }
      }, f = c, p = r(0), d = Object(p.a)(
        f,
        i,
        s,
        !1,
        null,
        null,
        null
      );
      d.options.__file = "packages/select/src/option.vue", t.a = d.exports;
    },
    38: function(e, t) {
      e.exports = qA();
    },
    4: function(e, t) {
      e.exports = an();
    },
    5: function(e, t) {
      e.exports = Ol();
    },
    6: function(e, t) {
      e.exports = jb();
    },
    62: function(e, t, r) {
      r.r(t);
      var i = function() {
        var T = this, D = T.$createElement, R = T._self._c || D;
        return R(
          "div",
          {
            directives: [
              {
                name: "clickoutside",
                rawName: "v-clickoutside",
                value: T.handleClose,
                expression: "handleClose"
              }
            ],
            staticClass: "el-select",
            class: [T.selectSize ? "el-select--" + T.selectSize : ""],
            on: {
              click: function(I) {
                return I.stopPropagation(), T.toggleMenu(I);
              }
            }
          },
          [
            T.multiple ? R(
              "div",
              {
                ref: "tags",
                staticClass: "el-select__tags",
                style: { "max-width": T.inputWidth - 32 + "px", width: "100%" }
              },
              [
                T.collapseTags && T.selected.length ? R(
                  "span",
                  [
                    R(
                      "el-tag",
                      {
                        attrs: {
                          closable: !T.selectDisabled,
                          size: T.collapseTagSize,
                          hit: T.selected[0].hitState,
                          type: "info",
                          "disable-transitions": ""
                        },
                        on: {
                          close: function(I) {
                            T.deleteTag(I, T.selected[0]);
                          }
                        }
                      },
                      [
                        R("span", { staticClass: "el-select__tags-text" }, [
                          T._v(T._s(T.selected[0].currentLabel))
                        ])
                      ]
                    ),
                    T.selected.length > 1 ? R(
                      "el-tag",
                      {
                        attrs: {
                          closable: !1,
                          size: T.collapseTagSize,
                          type: "info",
                          "disable-transitions": ""
                        }
                      },
                      [
                        R(
                          "span",
                          { staticClass: "el-select__tags-text" },
                          [T._v("+ " + T._s(T.selected.length - 1))]
                        )
                      ]
                    ) : T._e()
                  ],
                  1
                ) : T._e(),
                T.collapseTags ? T._e() : R(
                  "transition-group",
                  { on: { "after-leave": T.resetInputHeight } },
                  T._l(T.selected, function(I) {
                    return R(
                      "el-tag",
                      {
                        key: T.getValueKey(I),
                        attrs: {
                          closable: !T.selectDisabled,
                          size: T.collapseTagSize,
                          hit: I.hitState,
                          type: "info",
                          "disable-transitions": ""
                        },
                        on: {
                          close: function(se) {
                            T.deleteTag(se, I);
                          }
                        }
                      },
                      [
                        R("span", { staticClass: "el-select__tags-text" }, [
                          T._v(T._s(I.currentLabel))
                        ])
                      ]
                    );
                  }),
                  1
                ),
                T.filterable ? R("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: T.query,
                      expression: "query"
                    }
                  ],
                  ref: "input",
                  staticClass: "el-select__input",
                  class: [T.selectSize ? "is-" + T.selectSize : ""],
                  style: {
                    "flex-grow": "1",
                    width: T.inputLength / (T.inputWidth - 32) + "%",
                    "max-width": T.inputWidth - 42 + "px"
                  },
                  attrs: {
                    type: "text",
                    disabled: T.selectDisabled,
                    autocomplete: T.autoComplete || T.autocomplete
                  },
                  domProps: { value: T.query },
                  on: {
                    focus: T.handleFocus,
                    blur: function(I) {
                      T.softFocus = !1;
                    },
                    keyup: T.managePlaceholder,
                    keydown: [
                      T.resetInputState,
                      function(I) {
                        if (!("button" in I) && T._k(I.keyCode, "down", 40, I.key, [
                          "Down",
                          "ArrowDown"
                        ]))
                          return null;
                        I.preventDefault(), T.handleNavigate("next");
                      },
                      function(I) {
                        if (!("button" in I) && T._k(I.keyCode, "up", 38, I.key, [
                          "Up",
                          "ArrowUp"
                        ]))
                          return null;
                        I.preventDefault(), T.handleNavigate("prev");
                      },
                      function(I) {
                        return !("button" in I) && T._k(
                          I.keyCode,
                          "enter",
                          13,
                          I.key,
                          "Enter"
                        ) ? null : (I.preventDefault(), T.selectOption(I));
                      },
                      function(I) {
                        if (!("button" in I) && T._k(I.keyCode, "esc", 27, I.key, [
                          "Esc",
                          "Escape"
                        ]))
                          return null;
                        I.stopPropagation(), I.preventDefault(), T.visible = !1;
                      },
                      function(I) {
                        return !("button" in I) && T._k(
                          I.keyCode,
                          "delete",
                          [8, 46],
                          I.key,
                          ["Backspace", "Delete", "Del"]
                        ) ? null : T.deletePrevTag(I);
                      },
                      function(I) {
                        if (!("button" in I) && T._k(I.keyCode, "tab", 9, I.key, "Tab"))
                          return null;
                        T.visible = !1;
                      }
                    ],
                    compositionstart: T.handleComposition,
                    compositionupdate: T.handleComposition,
                    compositionend: T.handleComposition,
                    input: [
                      function(I) {
                        I.target.composing || (T.query = I.target.value);
                      },
                      T.debouncedQueryChange
                    ]
                  }
                }) : T._e()
              ],
              1
            ) : T._e(),
            R(
              "el-input",
              {
                ref: "reference",
                class: { "is-focus": T.visible },
                attrs: {
                  type: "text",
                  placeholder: T.currentPlaceholder,
                  name: T.name,
                  id: T.id,
                  autocomplete: T.autoComplete || T.autocomplete,
                  size: T.selectSize,
                  disabled: T.selectDisabled,
                  readonly: T.readonly,
                  "validate-event": !1,
                  tabindex: T.multiple && T.filterable ? "-1" : null
                },
                on: {
                  focus: T.handleFocus,
                  blur: T.handleBlur,
                  input: T.debouncedOnInputChange,
                  compositionstart: T.handleComposition,
                  compositionupdate: T.handleComposition,
                  compositionend: T.handleComposition
                },
                nativeOn: {
                  keydown: [
                    function(I) {
                      if (!("button" in I) && T._k(I.keyCode, "down", 40, I.key, [
                        "Down",
                        "ArrowDown"
                      ]))
                        return null;
                      I.stopPropagation(), I.preventDefault(), T.handleNavigate("next");
                    },
                    function(I) {
                      if (!("button" in I) && T._k(I.keyCode, "up", 38, I.key, [
                        "Up",
                        "ArrowUp"
                      ]))
                        return null;
                      I.stopPropagation(), I.preventDefault(), T.handleNavigate("prev");
                    },
                    function(I) {
                      return !("button" in I) && T._k(I.keyCode, "enter", 13, I.key, "Enter") ? null : (I.preventDefault(), T.selectOption(I));
                    },
                    function(I) {
                      if (!("button" in I) && T._k(I.keyCode, "esc", 27, I.key, [
                        "Esc",
                        "Escape"
                      ]))
                        return null;
                      I.stopPropagation(), I.preventDefault(), T.visible = !1;
                    },
                    function(I) {
                      if (!("button" in I) && T._k(I.keyCode, "tab", 9, I.key, "Tab"))
                        return null;
                      T.visible = !1;
                    }
                  ],
                  mouseenter: function(I) {
                    T.inputHovering = !0;
                  },
                  mouseleave: function(I) {
                    T.inputHovering = !1;
                  }
                },
                model: {
                  value: T.selectedLabel,
                  callback: function(I) {
                    T.selectedLabel = I;
                  },
                  expression: "selectedLabel"
                }
              },
              [
                T.$slots.prefix ? R("template", { slot: "prefix" }, [T._t("prefix")], 2) : T._e(),
                R("template", { slot: "suffix" }, [
                  R("i", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !T.showClose,
                        expression: "!showClose"
                      }
                    ],
                    class: [
                      "el-select__caret",
                      "el-input__icon",
                      "el-icon-" + T.iconClass
                    ]
                  }),
                  T.showClose ? R("i", {
                    staticClass: "el-select__caret el-input__icon el-icon-circle-close",
                    on: { click: T.handleClearClick }
                  }) : T._e()
                ])
              ],
              2
            ),
            R(
              "transition",
              {
                attrs: { name: "el-zoom-in-top" },
                on: {
                  "before-enter": T.handleMenuEnter,
                  "after-leave": T.doDestroy
                }
              },
              [
                R(
                  "el-select-menu",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: T.visible && T.emptyText !== !1,
                        expression: "visible && emptyText !== false"
                      }
                    ],
                    ref: "popper",
                    attrs: { "append-to-body": T.popperAppendToBody }
                  },
                  [
                    R(
                      "el-scrollbar",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: T.options.length > 0 && !T.loading,
                            expression: "options.length > 0 && !loading"
                          }
                        ],
                        ref: "scrollbar",
                        class: {
                          "is-empty": !T.allowCreate && T.query && T.filteredOptionsCount === 0
                        },
                        attrs: {
                          tag: "ul",
                          "wrap-class": "el-select-dropdown__wrap",
                          "view-class": "el-select-dropdown__list"
                        }
                      },
                      [
                        T.showNewOption ? R("el-option", {
                          attrs: { value: T.query, created: "" }
                        }) : T._e(),
                        T._t("default")
                      ],
                      2
                    ),
                    T.emptyText && (!T.allowCreate || T.loading || T.allowCreate && T.options.length === 0) ? [
                      T.$slots.empty ? T._t("empty") : R("p", { staticClass: "el-select-dropdown__empty" }, [
                        T._v(
                          `
          ` + T._s(T.emptyText) + `
        `
                        )
                      ])
                    ] : T._e()
                  ],
                  2
                )
              ],
              1
            )
          ],
          1
        );
      }, s = [];
      i._withStripped = !0;
      var o = r(4), a = /* @__PURE__ */ r.n(o), l = r(22), u = /* @__PURE__ */ r.n(l), c = r(6), f = /* @__PURE__ */ r.n(c), p = r(10), d = /* @__PURE__ */ r.n(p), h = function() {
        var T = this, D = T.$createElement, R = T._self._c || D;
        return R(
          "div",
          {
            staticClass: "el-select-dropdown el-popper",
            class: [{ "is-multiple": T.$parent.multiple }, T.popperClass],
            style: { minWidth: T.minWidth }
          },
          [T._t("default")],
          2
        );
      }, v = [];
      h._withStripped = !0;
      var g = r(5), m = /* @__PURE__ */ r.n(g), _ = {
        name: "ElSelectDropdown",
        componentName: "ElSelectDropdown",
        mixins: [m.a],
        props: {
          placement: {
            default: "bottom-start"
          },
          boundariesPadding: {
            default: 0
          },
          popperOptions: {
            default: function() {
              return {
                gpuAcceleration: !1
              };
            }
          },
          visibleArrow: {
            default: !0
          },
          appendToBody: {
            type: Boolean,
            default: !0
          }
        },
        data: function() {
          return {
            minWidth: ""
          };
        },
        computed: {
          popperClass: function() {
            return this.$parent.popperClass;
          }
        },
        watch: {
          "$parent.inputWidth": function() {
            this.minWidth = this.$parent.$el.getBoundingClientRect().width + "px";
          }
        },
        mounted: function() {
          var D = this;
          this.referenceElm = this.$parent.$refs.reference.$el, this.$parent.popperElm = this.popperElm = this.$el, this.$on("updatePopper", function() {
            D.$parent.visible && D.updatePopper();
          }), this.$on("destroyPopper", this.destroyPopper);
        }
      }, y = _, w = r(0), O = Object(w.a)(
        y,
        h,
        v,
        !1,
        null,
        null,
        null
      );
      O.options.__file = "packages/select/src/select-dropdown.vue";
      var C = O.exports, S = r(33), b = r(38), x = /* @__PURE__ */ r.n(b), E = r(15), M = /* @__PURE__ */ r.n(E), $ = r(19), F = /* @__PURE__ */ r.n($), J = r(12), W = /* @__PURE__ */ r.n(J), H = r(16), Y = r(31), z = /* @__PURE__ */ r.n(Y), j = r(3), Q = {
        data: function() {
          return {
            hoverOption: -1
          };
        },
        computed: {
          optionsAllDisabled: function() {
            return this.options.filter(function(D) {
              return D.visible;
            }).every(function(D) {
              return D.disabled;
            });
          }
        },
        watch: {
          hoverIndex: function(D) {
            var R = this;
            typeof D == "number" && D > -1 && (this.hoverOption = this.options[D] || {}), this.options.forEach(function(I) {
              I.hover = R.hoverOption === I;
            });
          }
        },
        methods: {
          navigateOptions: function(D) {
            var R = this;
            if (!this.visible) {
              this.visible = !0;
              return;
            }
            if (!(this.options.length === 0 || this.filteredOptionsCount === 0) && !this.optionsAllDisabled) {
              D === "next" ? (this.hoverIndex++, this.hoverIndex === this.options.length && (this.hoverIndex = 0)) : D === "prev" && (this.hoverIndex--, this.hoverIndex < 0 && (this.hoverIndex = this.options.length - 1));
              var I = this.options[this.hoverIndex];
              (I.disabled === !0 || I.groupDisabled === !0 || !I.visible) && this.navigateOptions(D), this.$nextTick(function() {
                return R.scrollToOption(R.hoverOption);
              });
            }
          }
        }
      }, fe = r(21), ue = {
        mixins: [a.a, f.a, u()("reference"), Q],
        name: "ElSelect",
        componentName: "ElSelect",
        inject: {
          elForm: {
            default: ""
          },
          elFormItem: {
            default: ""
          }
        },
        provide: function() {
          return {
            select: this
          };
        },
        computed: {
          _elFormItemSize: function() {
            return (this.elFormItem || {}).elFormItemSize;
          },
          readonly: function() {
            return !this.filterable || this.multiple || !Object(j.isIE)() && !Object(j.isEdge)() && !this.visible;
          },
          showClose: function() {
            var D = this.multiple ? Array.isArray(this.value) && this.value.length > 0 : this.value !== void 0 && this.value !== null && this.value !== "", R = this.clearable && !this.selectDisabled && this.inputHovering && D;
            return R;
          },
          iconClass: function() {
            return this.remote && this.filterable ? "" : this.visible ? "arrow-up is-reverse" : "arrow-up";
          },
          debounce: function() {
            return this.remote ? 300 : 0;
          },
          emptyText: function() {
            return this.loading ? this.loadingText || this.t("el.select.loading") : this.remote && this.query === "" && this.options.length === 0 ? !1 : this.filterable && this.query && this.options.length > 0 && this.filteredOptionsCount === 0 ? this.noMatchText || this.t("el.select.noMatch") : this.options.length === 0 ? this.noDataText || this.t("el.select.noData") : null;
          },
          showNewOption: function() {
            var D = this, R = this.options.filter(function(I) {
              return !I.created;
            }).some(function(I) {
              return I.currentLabel === D.query;
            });
            return this.filterable && this.allowCreate && this.query !== "" && !R;
          },
          selectSize: function() {
            return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
          },
          selectDisabled: function() {
            return this.disabled || (this.elForm || {}).disabled;
          },
          collapseTagSize: function() {
            return ["small", "mini"].indexOf(this.selectSize) > -1 ? "mini" : "small";
          },
          propPlaceholder: function() {
            return typeof this.placeholder < "u" ? this.placeholder : this.t("el.select.placeholder");
          }
        },
        components: {
          ElInput: d.a,
          ElSelectMenu: C,
          ElOption: S.a,
          ElTag: x.a,
          ElScrollbar: M.a
        },
        directives: { Clickoutside: W.a },
        props: {
          name: String,
          id: String,
          value: {
            required: !0
          },
          autocomplete: {
            type: String,
            default: "off"
          },
          autoComplete: {
            type: String,
            validator: function(D) {
              return !0;
            }
          },
          automaticDropdown: Boolean,
          size: String,
          disabled: Boolean,
          clearable: Boolean,
          filterable: Boolean,
          allowCreate: Boolean,
          loading: Boolean,
          popperClass: String,
          remote: Boolean,
          loadingText: String,
          noMatchText: String,
          noDataText: String,
          remoteMethod: Function,
          filterMethod: Function,
          multiple: Boolean,
          multipleLimit: {
            type: Number,
            default: 0
          },
          placeholder: {
            type: String,
            required: !1
          },
          defaultFirstOption: Boolean,
          reserveKeyword: Boolean,
          valueKey: {
            type: String,
            default: "value"
          },
          collapseTags: Boolean,
          popperAppendToBody: {
            type: Boolean,
            default: !0
          }
        },
        data: function() {
          return {
            options: [],
            cachedOptions: [],
            createdLabel: null,
            createdSelected: !1,
            selected: this.multiple ? [] : {},
            inputLength: 20,
            inputWidth: 0,
            initialInputHeight: 0,
            cachedPlaceHolder: "",
            optionsCount: 0,
            filteredOptionsCount: 0,
            visible: !1,
            softFocus: !1,
            selectedLabel: "",
            hoverIndex: -1,
            query: "",
            previousQuery: null,
            inputHovering: !1,
            currentPlaceholder: "",
            menuVisibleOnFocus: !1,
            isOnComposition: !1,
            isSilentBlur: !1
          };
        },
        watch: {
          selectDisabled: function() {
            var D = this;
            this.$nextTick(function() {
              D.resetInputHeight();
            });
          },
          propPlaceholder: function(D) {
            this.cachedPlaceHolder = this.currentPlaceholder = D;
          },
          value: function(D, R) {
            this.multiple && (this.resetInputHeight(), D && D.length > 0 || this.$refs.input && this.query !== "" ? this.currentPlaceholder = "" : this.currentPlaceholder = this.cachedPlaceHolder, this.filterable && !this.reserveKeyword && (this.query = "", this.handleQueryChange(this.query))), this.setSelected(), this.filterable && !this.multiple && (this.inputLength = 20), Object(j.valueEquals)(D, R) || this.dispatch("ElFormItem", "el.form.change", D);
          },
          visible: function(D) {
            var R = this;
            D ? (this.broadcast("ElSelectDropdown", "updatePopper"), this.filterable && (this.query = this.remote ? "" : this.selectedLabel, this.handleQueryChange(this.query), this.multiple ? this.$refs.input.focus() : (this.remote || (this.broadcast("ElOption", "queryChange", ""), this.broadcast("ElOptionGroup", "queryChange")), this.selectedLabel && (this.currentPlaceholder = this.selectedLabel, this.selectedLabel = "")))) : (this.broadcast("ElSelectDropdown", "destroyPopper"), this.$refs.input && this.$refs.input.blur(), this.query = "", this.previousQuery = null, this.selectedLabel = "", this.inputLength = 20, this.menuVisibleOnFocus = !1, this.resetHoverIndex(), this.$nextTick(function() {
              R.$refs.input && R.$refs.input.value === "" && R.selected.length === 0 && (R.currentPlaceholder = R.cachedPlaceHolder);
            }), this.multiple || (this.selected && (this.filterable && this.allowCreate && this.createdSelected && this.createdLabel ? this.selectedLabel = this.createdLabel : this.selectedLabel = this.selected.currentLabel, this.filterable && (this.query = this.selectedLabel)), this.filterable && (this.currentPlaceholder = this.cachedPlaceHolder))), this.$emit("visible-change", D);
          },
          options: function() {
            var D = this;
            if (!this.$isServer) {
              this.$nextTick(function() {
                D.broadcast("ElSelectDropdown", "updatePopper");
              }), this.multiple && this.resetInputHeight();
              var R = this.$el.querySelectorAll("input");
              [].indexOf.call(R, document.activeElement) === -1 && this.setSelected(), this.defaultFirstOption && (this.filterable || this.remote) && this.filteredOptionsCount && this.checkDefaultFirstOption();
            }
          }
        },
        methods: {
          handleNavigate: function(D) {
            this.isOnComposition || this.navigateOptions(D);
          },
          handleComposition: function(D) {
            var R = this, I = D.target.value;
            if (D.type === "compositionend")
              this.isOnComposition = !1, this.$nextTick(function(Oe) {
                return R.handleQueryChange(I);
              });
            else {
              var se = I[I.length - 1] || "";
              this.isOnComposition = !Object(fe.isKorean)(se);
            }
          },
          handleQueryChange: function(D) {
            var R = this;
            if (!(this.previousQuery === D || this.isOnComposition)) {
              if (this.previousQuery === null && (typeof this.filterMethod == "function" || typeof this.remoteMethod == "function")) {
                this.previousQuery = D;
                return;
              }
              this.previousQuery = D, this.$nextTick(function() {
                R.visible && R.broadcast("ElSelectDropdown", "updatePopper");
              }), this.hoverIndex = -1, this.multiple && this.filterable && this.$nextTick(function() {
                var I = R.$refs.input.value.length * 15 + 20;
                R.inputLength = R.collapseTags ? Math.min(50, I) : I, R.managePlaceholder(), R.resetInputHeight();
              }), this.remote && typeof this.remoteMethod == "function" ? (this.hoverIndex = -1, this.remoteMethod(D)) : typeof this.filterMethod == "function" ? (this.filterMethod(D), this.broadcast("ElOptionGroup", "queryChange")) : (this.filteredOptionsCount = this.optionsCount, this.broadcast("ElOption", "queryChange", D), this.broadcast("ElOptionGroup", "queryChange")), this.defaultFirstOption && (this.filterable || this.remote) && this.filteredOptionsCount && this.checkDefaultFirstOption();
            }
          },
          scrollToOption: function(D) {
            var R = Array.isArray(D) && D[0] ? D[0].$el : D.$el;
            if (this.$refs.popper && R) {
              var I = this.$refs.popper.$el.querySelector(".el-select-dropdown__wrap");
              z()(I, R);
            }
            this.$refs.scrollbar && this.$refs.scrollbar.handleScroll();
          },
          handleMenuEnter: function() {
            var D = this;
            this.$nextTick(function() {
              return D.scrollToOption(D.selected);
            });
          },
          emitChange: function(D) {
            Object(j.valueEquals)(this.value, D) || this.$emit("change", D);
          },
          getOption: function(D) {
            for (var R = void 0, I = Object.prototype.toString.call(D).toLowerCase() === "[object object]", se = Object.prototype.toString.call(D).toLowerCase() === "[object null]", Oe = Object.prototype.toString.call(D).toLowerCase() === "[object undefined]", Me = this.cachedOptions.length - 1; Me >= 0; Me--) {
              var Re = this.cachedOptions[Me], Je = I ? Object(j.getValueByPath)(Re.value, this.valueKey) === Object(j.getValueByPath)(D, this.valueKey) : Re.value === D;
              if (Je) {
                R = Re;
                break;
              }
            }
            if (R)
              return R;
            var Ee = !I && !se && !Oe ? String(D) : "", Fe = {
              value: D,
              currentLabel: Ee
            };
            return this.multiple && (Fe.hitState = !1), Fe;
          },
          setSelected: function() {
            var D = this;
            if (!this.multiple) {
              var R = this.getOption(this.value);
              R.created ? (this.createdLabel = R.currentLabel, this.createdSelected = !0) : this.createdSelected = !1, this.selectedLabel = R.currentLabel, this.selected = R, this.filterable && (this.query = this.selectedLabel);
              return;
            }
            var I = [];
            Array.isArray(this.value) && this.value.forEach(function(se) {
              I.push(D.getOption(se));
            }), this.selected = I, this.$nextTick(function() {
              D.resetInputHeight();
            });
          },
          handleFocus: function(D) {
            this.softFocus ? this.softFocus = !1 : ((this.automaticDropdown || this.filterable) && (this.filterable && !this.visible && (this.menuVisibleOnFocus = !0), this.visible = !0), this.$emit("focus", D));
          },
          blur: function() {
            this.visible = !1, this.$refs.reference.blur();
          },
          handleBlur: function(D) {
            var R = this;
            setTimeout(function() {
              R.isSilentBlur ? R.isSilentBlur = !1 : R.$emit("blur", D);
            }, 50), this.softFocus = !1;
          },
          handleClearClick: function(D) {
            this.deleteSelected(D);
          },
          doDestroy: function() {
            this.$refs.popper && this.$refs.popper.doDestroy();
          },
          handleClose: function() {
            this.visible = !1;
          },
          toggleLastOptionHitState: function(D) {
            if (!!Array.isArray(this.selected)) {
              var R = this.selected[this.selected.length - 1];
              if (!!R)
                return D === !0 || D === !1 ? (R.hitState = D, D) : (R.hitState = !R.hitState, R.hitState);
            }
          },
          deletePrevTag: function(D) {
            if (D.target.value.length <= 0 && !this.toggleLastOptionHitState()) {
              var R = this.value.slice();
              R.pop(), this.$emit("input", R), this.emitChange(R);
            }
          },
          managePlaceholder: function() {
            this.currentPlaceholder !== "" && (this.currentPlaceholder = this.$refs.input.value ? "" : this.cachedPlaceHolder);
          },
          resetInputState: function(D) {
            D.keyCode !== 8 && this.toggleLastOptionHitState(!1), this.inputLength = this.$refs.input.value.length * 15 + 20, this.resetInputHeight();
          },
          resetInputHeight: function() {
            var D = this;
            this.collapseTags && !this.filterable || this.$nextTick(function() {
              if (!!D.$refs.reference) {
                var R = D.$refs.reference.$el.childNodes, I = [].filter.call(R, function(Re) {
                  return Re.tagName === "INPUT";
                })[0], se = D.$refs.tags, Oe = se ? Math.round(se.getBoundingClientRect().height) : 0, Me = D.initialInputHeight || 40;
                I.style.height = D.selected.length === 0 ? Me + "px" : Math.max(se ? Oe + (Oe > Me ? 6 : 0) : 0, Me) + "px", D.visible && D.emptyText !== !1 && D.broadcast("ElSelectDropdown", "updatePopper");
              }
            });
          },
          resetHoverIndex: function() {
            var D = this;
            setTimeout(function() {
              D.multiple ? D.selected.length > 0 ? D.hoverIndex = Math.min.apply(null, D.selected.map(function(R) {
                return D.options.indexOf(R);
              })) : D.hoverIndex = -1 : D.hoverIndex = D.options.indexOf(D.selected);
            }, 300);
          },
          handleOptionSelect: function(D, R) {
            var I = this;
            if (this.multiple) {
              var se = (this.value || []).slice(), Oe = this.getValueIndex(se, D.value);
              Oe > -1 ? se.splice(Oe, 1) : (this.multipleLimit <= 0 || se.length < this.multipleLimit) && se.push(D.value), this.$emit("input", se), this.emitChange(se), D.created && (this.query = "", this.handleQueryChange(""), this.inputLength = 20), this.filterable && this.$refs.input.focus();
            } else
              this.$emit("input", D.value), this.emitChange(D.value), this.visible = !1;
            this.isSilentBlur = R, this.setSoftFocus(), !this.visible && this.$nextTick(function() {
              I.scrollToOption(D);
            });
          },
          setSoftFocus: function() {
            this.softFocus = !0;
            var D = this.$refs.input || this.$refs.reference;
            D && D.focus();
          },
          getValueIndex: function() {
            var D = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], R = arguments[1], I = Object.prototype.toString.call(R).toLowerCase() === "[object object]";
            if (I) {
              var se = this.valueKey, Oe = -1;
              return D.some(function(Me, Re) {
                return Object(j.getValueByPath)(Me, se) === Object(j.getValueByPath)(R, se) ? (Oe = Re, !0) : !1;
              }), Oe;
            } else
              return D.indexOf(R);
          },
          toggleMenu: function() {
            this.selectDisabled || (this.menuVisibleOnFocus ? this.menuVisibleOnFocus = !1 : this.visible = !this.visible, this.visible && (this.$refs.input || this.$refs.reference).focus());
          },
          selectOption: function() {
            this.visible ? this.options[this.hoverIndex] && this.handleOptionSelect(this.options[this.hoverIndex]) : this.toggleMenu();
          },
          deleteSelected: function(D) {
            D.stopPropagation();
            var R = this.multiple ? [] : "";
            this.$emit("input", R), this.emitChange(R), this.visible = !1, this.$emit("clear");
          },
          deleteTag: function(D, R) {
            var I = this.selected.indexOf(R);
            if (I > -1 && !this.selectDisabled) {
              var se = this.value.slice();
              se.splice(I, 1), this.$emit("input", se), this.emitChange(se), this.$emit("remove-tag", R.value);
            }
            D.stopPropagation();
          },
          onInputChange: function() {
            this.filterable && this.query !== this.selectedLabel && (this.query = this.selectedLabel, this.handleQueryChange(this.query));
          },
          onOptionDestroy: function(D) {
            D > -1 && (this.optionsCount--, this.filteredOptionsCount--, this.options.splice(D, 1));
          },
          resetInputWidth: function() {
            this.inputWidth = this.$refs.reference.$el.getBoundingClientRect().width;
          },
          handleResize: function() {
            this.resetInputWidth(), this.multiple && this.resetInputHeight();
          },
          checkDefaultFirstOption: function() {
            this.hoverIndex = -1;
            for (var D = !1, R = this.options.length - 1; R >= 0; R--)
              if (this.options[R].created) {
                D = !0, this.hoverIndex = R;
                break;
              }
            if (!D)
              for (var I = 0; I !== this.options.length; ++I) {
                var se = this.options[I];
                if (this.query) {
                  if (!se.disabled && !se.groupDisabled && se.visible) {
                    this.hoverIndex = I;
                    break;
                  }
                } else if (se.itemSelected) {
                  this.hoverIndex = I;
                  break;
                }
              }
          },
          getValueKey: function(D) {
            return Object.prototype.toString.call(D.value).toLowerCase() !== "[object object]" ? D.value : Object(j.getValueByPath)(D.value, this.valueKey);
          }
        },
        created: function() {
          var D = this;
          this.cachedPlaceHolder = this.currentPlaceholder = this.propPlaceholder, this.multiple && !Array.isArray(this.value) && this.$emit("input", []), !this.multiple && Array.isArray(this.value) && this.$emit("input", ""), this.debouncedOnInputChange = F()(this.debounce, function() {
            D.onInputChange();
          }), this.debouncedQueryChange = F()(this.debounce, function(R) {
            D.handleQueryChange(R.target.value);
          }), this.$on("handleOptionClick", this.handleOptionSelect), this.$on("setSelected", this.setSelected);
        },
        mounted: function() {
          var D = this;
          this.multiple && Array.isArray(this.value) && this.value.length > 0 && (this.currentPlaceholder = ""), Object(H.addResizeListener)(this.$el, this.handleResize);
          var R = this.$refs.reference;
          if (R && R.$el) {
            var I = {
              medium: 36,
              small: 32,
              mini: 28
            }, se = R.$el.querySelector("input");
            this.initialInputHeight = se.getBoundingClientRect().height || I[this.selectSize];
          }
          this.remote && this.multiple && this.resetInputHeight(), this.$nextTick(function() {
            R && R.$el && (D.inputWidth = R.$el.getBoundingClientRect().width);
          }), this.setSelected();
        },
        beforeDestroy: function() {
          this.$el && this.handleResize && Object(H.removeResizeListener)(this.$el, this.handleResize);
        }
      }, ae = ue, ye = Object(w.a)(
        ae,
        i,
        s,
        !1,
        null,
        null,
        null
      );
      ye.options.__file = "packages/select/src/select.vue";
      var re = ye.exports;
      re.install = function(T) {
        T.component(re.name, re);
      }, t.default = re;
    }
  });
})(Lb);
const Vb = /* @__PURE__ */ ot(Lb.exports);
var Hb = { exports: {} };
(function(n) {
  n.exports = function(e) {
    var t = {};
    function r(i) {
      if (t[i])
        return t[i].exports;
      var s = t[i] = {
        i,
        l: !1,
        exports: {}
      };
      return e[i].call(s.exports, s, s.exports, r), s.l = !0, s.exports;
    }
    return r.m = e, r.c = t, r.d = function(i, s, o) {
      r.o(i, s) || Object.defineProperty(i, s, { enumerable: !0, get: o });
    }, r.r = function(i) {
      typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(i, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(i, "__esModule", { value: !0 });
    }, r.t = function(i, s) {
      if (s & 1 && (i = r(i)), s & 8 || s & 4 && typeof i == "object" && i && i.__esModule)
        return i;
      var o = /* @__PURE__ */ Object.create(null);
      if (r.r(o), Object.defineProperty(o, "default", { enumerable: !0, value: i }), s & 2 && typeof i != "string")
        for (var a in i)
          r.d(o, a, function(l) {
            return i[l];
          }.bind(null, a));
      return o;
    }, r.n = function(i) {
      var s = i && i.__esModule ? function() {
        return i.default;
      } : function() {
        return i;
      };
      return r.d(s, "a", s), s;
    }, r.o = function(i, s) {
      return Object.prototype.hasOwnProperty.call(i, s);
    }, r.p = "/dist/", r(r.s = 54);
  }({
    0: function(e, t, r) {
      r.d(t, "a", function() {
        return i;
      });
      function i(s, o, a, l, u, c, f, p) {
        var d = typeof s == "function" ? s.options : s;
        o && (d.render = o, d.staticRenderFns = a, d._compiled = !0), l && (d.functional = !0), c && (d._scopeId = "data-v-" + c);
        var h;
        if (f ? (h = function(m) {
          m = m || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !m && typeof __VUE_SSR_CONTEXT__ < "u" && (m = __VUE_SSR_CONTEXT__), u && u.call(this, m), m && m._registeredComponents && m._registeredComponents.add(f);
        }, d._ssrRegister = h) : u && (h = p ? function() {
          u.call(this, this.$root.$options.shadowRoot);
        } : u), h)
          if (d.functional) {
            d._injectStyles = h;
            var v = d.render;
            d.render = function(_, y) {
              return h.call(y), v(_, y);
            };
          } else {
            var g = d.beforeCreate;
            d.beforeCreate = g ? [].concat(g, h) : [h];
          }
        return {
          exports: s,
          options: d
        };
      }
    },
    3: function(e, t) {
      e.exports = ne;
    },
    33: function(e, t, r) {
      var i = function() {
        var h = this, v = h.$createElement, g = h._self._c || v;
        return g(
          "li",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: h.visible,
                expression: "visible"
              }
            ],
            staticClass: "el-select-dropdown__item",
            class: {
              selected: h.itemSelected,
              "is-disabled": h.disabled || h.groupDisabled || h.limitReached,
              hover: h.hover
            },
            on: {
              mouseenter: h.hoverItem,
              click: function(m) {
                return m.stopPropagation(), h.selectOptionClick(m);
              }
            }
          },
          [h._t("default", [g("span", [h._v(h._s(h.currentLabel))])])],
          2
        );
      }, s = [];
      i._withStripped = !0;
      var o = r(4), a = /* @__PURE__ */ r.n(o), l = r(3), u = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(h) {
        return typeof h;
      } : function(h) {
        return h && typeof Symbol == "function" && h.constructor === Symbol && h !== Symbol.prototype ? "symbol" : typeof h;
      }, c = {
        mixins: [a.a],
        name: "ElOption",
        componentName: "ElOption",
        inject: ["select"],
        props: {
          value: {
            required: !0
          },
          label: [String, Number],
          created: Boolean,
          disabled: {
            type: Boolean,
            default: !1
          }
        },
        data: function() {
          return {
            index: -1,
            groupDisabled: !1,
            visible: !0,
            hitState: !1,
            hover: !1
          };
        },
        computed: {
          isObject: function() {
            return Object.prototype.toString.call(this.value).toLowerCase() === "[object object]";
          },
          currentLabel: function() {
            return this.label || (this.isObject ? "" : this.value);
          },
          currentValue: function() {
            return this.value || this.label || "";
          },
          itemSelected: function() {
            return this.select.multiple ? this.contains(this.select.value, this.value) : this.isEqual(this.value, this.select.value);
          },
          limitReached: function() {
            return this.select.multiple ? !this.itemSelected && (this.select.value || []).length >= this.select.multipleLimit && this.select.multipleLimit > 0 : !1;
          }
        },
        watch: {
          currentLabel: function() {
            !this.created && !this.select.remote && this.dispatch("ElSelect", "setSelected");
          },
          value: function(v, g) {
            var m = this.select, _ = m.remote, y = m.valueKey;
            if (!this.created && !_) {
              if (y && (typeof v > "u" ? "undefined" : u(v)) === "object" && (typeof g > "u" ? "undefined" : u(g)) === "object" && v[y] === g[y])
                return;
              this.dispatch("ElSelect", "setSelected");
            }
          }
        },
        methods: {
          isEqual: function(v, g) {
            if (this.isObject) {
              var m = this.select.valueKey;
              return Object(l.getValueByPath)(v, m) === Object(l.getValueByPath)(g, m);
            } else
              return v === g;
          },
          contains: function() {
            var v = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], g = arguments[1];
            if (this.isObject) {
              var m = this.select.valueKey;
              return v && v.some(function(_) {
                return Object(l.getValueByPath)(_, m) === Object(l.getValueByPath)(g, m);
              });
            } else
              return v && v.indexOf(g) > -1;
          },
          handleGroupDisabled: function(v) {
            this.groupDisabled = v;
          },
          hoverItem: function() {
            !this.disabled && !this.groupDisabled && (this.select.hoverIndex = this.select.options.indexOf(this));
          },
          selectOptionClick: function() {
            this.disabled !== !0 && this.groupDisabled !== !0 && this.dispatch("ElSelect", "handleOptionClick", [this, !0]);
          },
          queryChange: function(v) {
            this.visible = new RegExp(Object(l.escapeRegexpString)(v), "i").test(this.currentLabel) || this.created, this.visible || this.select.filteredOptionsCount--;
          }
        },
        created: function() {
          this.select.options.push(this), this.select.cachedOptions.push(this), this.select.optionsCount++, this.select.filteredOptionsCount++, this.$on("queryChange", this.queryChange), this.$on("handleGroupDisabled", this.handleGroupDisabled);
        },
        beforeDestroy: function() {
          var v = this.select, g = v.selected, m = v.multiple, _ = m ? g : [g], y = this.select.cachedOptions.indexOf(this), w = _.indexOf(this);
          y > -1 && w < 0 && this.select.cachedOptions.splice(y, 1), this.select.onOptionDestroy(this.select.options.indexOf(this));
        }
      }, f = c, p = r(0), d = Object(p.a)(
        f,
        i,
        s,
        !1,
        null,
        null,
        null
      );
      d.options.__file = "packages/select/src/option.vue", t.a = d.exports;
    },
    4: function(e, t) {
      e.exports = an();
    },
    54: function(e, t, r) {
      r.r(t);
      var i = r(33);
      i.a.install = function(s) {
        s.component(i.a.name, i.a);
      }, t.default = i.a;
    }
  });
})(Hb);
const Wb = /* @__PURE__ */ ot(Hb.exports);
const gP = Ce({
  props: {
    color: { type: String, default: "" },
    theme: { type: String, default: "solid" },
    size: { type: String, default: "md" },
    closeable: { type: Boolean, default: !1 },
    rounded: { type: Boolean, default: !1 }
  },
  emits: ["close"]
});
var vP = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", e._g({ staticClass: "t-tag", class: {
    "t-tag--closable": e.closeable,
    "t-tag--rounded": e.rounded,
    "t-tag--light": e.theme === "light",
    "t-tag--solid": e.theme === "solid",
    "t-tag--ghost": e.theme === "ghost",
    "t-tag--sm": e.size === "sm",
    "t-tag--md": e.size === "md",
    "t-tag--lg": e.size === "lg",
    "t-tag--xl": e.size === "xl",
    "t-tag--2xl": e.size === "2xl",
    "t-tag--primary": e.color === "primary",
    "t-tag--secondary": e.color === "secondary",
    "t-tag--info": e.color === "info",
    "t-tag--danger": e.color === "danger",
    "t-tag--success": e.color === "success",
    "t-tag--warning": e.color === "warning"
  } }, e.$listeners), [e._t("default"), e.closeable ? t("button", { staticClass: "t-tag__btn-close", on: { click: function(r) {
    return e.$emit("close");
  } } }, [t("i", { staticClass: "i-ui-close" })]) : e._e()], 2);
}, yP = [], bP = /* @__PURE__ */ le(
  gP,
  vP,
  yP,
  !1,
  null,
  null,
  null,
  null
);
const wP = bP.exports;
const _P = Ce({
  props: {
    code: { type: String, default: "" },
    name: { type: String, default: "" },
    size: { type: String, default: "sm" }
  },
  setup(n) {
    const { code: e } = Ef(n), t = ve(() => {
      const i = `${e.value}`.toLowerCase().replace(/ /g, "").replace(/\r/g, "");
      return ["#fff", "#ffffff", "white", "rgb(255,255,255)", "rgba(255,255,255,1)", "hsl(0,0%,100%)"].includes(i);
    }), r = ve(() => ({
      border: `1px solid ${t.value ? "#DADDE0" : e.value}`,
      background: e.value
    }));
    return { isWhite: t, styles: r };
  }
});
var SP = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "t-color", class: {
    "t-color--sm": e.size === "sm"
  }, style: e.styles });
}, xP = [], CP = /* @__PURE__ */ le(
  _P,
  SP,
  xP,
  !1,
  null,
  null,
  null,
  null
);
const OP = CP.exports;
const EP = Ce({
  name: "TProductItem",
  components: { TTag: wP, TColor: OP },
  props: {
    image: { type: String, required: !0 },
    name: { type: String, required: !0 },
    price: { type: Number, required: !0 },
    priceBeforeDiscount: { type: Number, default: void 0 },
    priceDiscountPercent: { type: Number, default: void 0 },
    colors: { type: Array, default: () => [] },
    hasGift: { type: Boolean, default: void 0 },
    specs: { type: String, default: "" },
    status: { type: Number, default: void 0 },
    sharedUrl: { type: String, required: !0 },
    lazyload: { type: Boolean, default: !1 }
  },
  setup(n) {
    const e = Bi("config");
    return {
      config: e,
      formatCurrency: DE,
      imageUrl: ve(() => e.value.imageBaseURL + "/" + n.image)
    };
  }
});
var TP = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("a", { staticClass: "t-product-item", attrs: { href: `/${e.sharedUrl}` } }, [t("div", { staticClass: "t-product-item__image" }, [t("img", { attrs: { alt: e.name, src: e.imageUrl } })]), t("div", { staticClass: "t-product-item__info" }, [t("div", { staticClass: "t-product-item__title" }, [e._v(e._s(e.name))]), t("div", { staticClass: "t-product-item__price-wrapper" }, [t("span", { staticClass: "t-product-item__secondary-text" }, [e._v("T\u1EEB")]), t("span", { staticClass: "t-product-item__price" }, [e._v(e._s(e.formatCurrency(e.price)))]), e.priceDiscountPercent ? t("t-tag", { attrs: { color: "secondary", size: "sm", theme: "light" } }, [e._v(" -" + e._s(e.priceDiscountPercent) + "% ")]) : e._e()], 1), e.colors && e.colors.length ? t("div", { staticClass: "t-product-item__color-wrapper" }, [t("span", { staticClass: "t-product-item__secondary-text" }, [e._v("M\xE0u")]), e._l(e.colors, function(r, i) {
    return t("t-color", e._b({ key: "color-" + r.code + i }, "t-color", r, !1));
  })], 2) : e._e(), e.specs ? t("div", { staticClass: "t-product-item__specs", domProps: { innerHTML: e._s(e.specs) } }) : e._e(), e.hasGift ? t("div", { staticClass: "t-product-item__gift-wrapper" }, [e._m(0)]) : e._e()])]);
}, kP = [function() {
  var n = this, e = n._self._c;
  return n._self._setupProxy, e("div", { staticClass: "t-product-item__gift" }, [e("div", { staticClass: "t-product-item__gift-icon-wrapper" }, [e("i", { staticClass: "t-product-item__gift-icon" })]), e("span", { staticClass: "t-product-item__gift-text" }, [n._v("Qu\xE0 t\u1EB7ng")])]);
}], MP = /* @__PURE__ */ le(
  EP,
  TP,
  kP,
  !1,
  null,
  null,
  null,
  null
);
const qb = MP.exports, AP = st({
  name: "SkuCommand",
  components: {
    TProductItem: qb,
    TBtn: $l,
    ButtonCommand: yt,
    ElDialog: Kr,
    ElSelect: Vb,
    ElOption: Wb
  },
  setup() {
    const { visible: n, close: e } = Ab(), t = $e("editor"), r = je(() => t == null ? void 0 : t.value.isActive("skuCard"));
    return {
      visible: n,
      close: e,
      editor: t,
      isActive: r,
      ...PP()
    };
  },
  methods: {
    addSku() {
      !this.selectedSku || (this.editor.chain().focus().deleteSelection().run(), this.editor.chain().focus().setSkuCard(this.selectedSku.sku_id).run());
    },
    onSave() {
      this.addSku(), this.close();
    }
  }
}), PP = (n) => {
  const e = $e("config", ct(Dx)), t = ct(), r = ct(), i = ct(""), s = ct(!1), o = ct([]), a = async (c) => {
    const { data: f } = await da.get(e.value.baseURL + "/front-store/v2/suggestion", {
      params: { q: c },
      headers: { sites: e.value.sites }
    });
    return f;
  }, l = async (c) => {
    if (!c) {
      o.value = [];
      return;
    }
    try {
      const { data: f } = await a(c);
      o.value = f.product_items;
    } catch (f) {
      console.log({ e: f });
    }
  };
  return wl(t, async () => {
    if (!!t.value)
      try {
        const { data: c } = await da.get(e.value.baseURL + "/front-store/v2/sku/detail/" + t.value, {
          headers: { sites: e.value.sites }
        });
        r.value = c.data;
      } catch (c) {
        console.log({ e: c });
      }
  }, { immediate: !0 }), { selectedId: t, selectedSku: r, query: i, loading: s, options: o, remoteMethod: l };
};
var $P = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", [t("button-command", { attrs: { "is-active": e.isActive, icon: "shopping-cart-line", title: "Sku Card" }, on: { click: function(r) {
    e.visible = !0;
  } } }), t("el-dialog", { attrs: { visible: e.visible, "append-to-body": "", title: "Ch\u1ECDn Sku card", top: "20px", width: "500px" }, on: { "update:visible": function(r) {
    e.visible = r;
  } }, scopedSlots: e._u([{ key: "title", fn: function() {
    return [t("div", { staticClass: "flex space-x-4" }, [t("t-btn", { attrs: { height: "40" }, on: { click: e.onSave } }, [e._v("Save")]), t("div", { staticClass: "w-2/3" }, [t("el-select", { staticStyle: { width: "100%" }, attrs: { loading: e.loading, "remote-method": e.remoteMethod, filterable: "", placeholder: "T\xECm ki\u1EBFm Sku", remote: "", "reserve-keyword": "" }, model: { value: e.selectedId, callback: function(r) {
      e.selectedId = r;
    }, expression: "selectedId" } }, e._l(e.options, function(r) {
      return t("el-option", { key: r.value, attrs: { label: r.name, value: r.sku_id } });
    }), 1)], 1)], 1)];
  }, proxy: !0 }]) }, [e.selectedSku ? t("div", { staticClass: "flex justify-center" }, [t("t-product-item", { attrs: { colors: e.selectedSku.colors, "has-gift": e.selectedSku.has_gift, image: e.selectedSku.image, name: e.selectedSku.name, price: e.selectedSku.price, "price-before-discount": e.selectedSku.price_before_discount, "price-discount-percent": e.selectedSku.price_discount_percent, "shared-url": e.selectedSku.shared_url, specs: e.selectedSku.specs, status: e.selectedSku.status } })], 1) : e._e()])], 1);
}, DP = [], LP = /* @__PURE__ */ le(
  AP,
  $P,
  DP,
  !1,
  null,
  null,
  null,
  null
);
const NP = LP.exports;
var Ub = { exports: {} };
(function(n) {
  n.exports = function(e) {
    var t = {};
    function r(i) {
      if (t[i])
        return t[i].exports;
      var s = t[i] = {
        i,
        l: !1,
        exports: {}
      };
      return e[i].call(s.exports, s, s.exports, r), s.l = !0, s.exports;
    }
    return r.m = e, r.c = t, r.d = function(i, s, o) {
      r.o(i, s) || Object.defineProperty(i, s, { enumerable: !0, get: o });
    }, r.r = function(i) {
      typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(i, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(i, "__esModule", { value: !0 });
    }, r.t = function(i, s) {
      if (s & 1 && (i = r(i)), s & 8 || s & 4 && typeof i == "object" && i && i.__esModule)
        return i;
      var o = /* @__PURE__ */ Object.create(null);
      if (r.r(o), Object.defineProperty(o, "default", { enumerable: !0, value: i }), s & 2 && typeof i != "string")
        for (var a in i)
          r.d(o, a, function(l) {
            return i[l];
          }.bind(null, a));
      return o;
    }, r.n = function(i) {
      var s = i && i.__esModule ? function() {
        return i.default;
      } : function() {
        return i;
      };
      return r.d(s, "a", s), s;
    }, r.o = function(i, s) {
      return Object.prototype.hasOwnProperty.call(i, s);
    }, r.p = "/dist/", r(r.s = 91);
  }({
    0: function(e, t, r) {
      r.d(t, "a", function() {
        return i;
      });
      function i(s, o, a, l, u, c, f, p) {
        var d = typeof s == "function" ? s.options : s;
        o && (d.render = o, d.staticRenderFns = a, d._compiled = !0), l && (d.functional = !0), c && (d._scopeId = "data-v-" + c);
        var h;
        if (f ? (h = function(m) {
          m = m || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !m && typeof __VUE_SSR_CONTEXT__ < "u" && (m = __VUE_SSR_CONTEXT__), u && u.call(this, m), m && m._registeredComponents && m._registeredComponents.add(f);
        }, d._ssrRegister = h) : u && (h = p ? function() {
          u.call(this, this.$root.$options.shadowRoot);
        } : u), h)
          if (d.functional) {
            d._injectStyles = h;
            var v = d.render;
            d.render = function(_, y) {
              return h.call(y), v(_, y);
            };
          } else {
            var g = d.beforeCreate;
            d.beforeCreate = g ? [].concat(g, h) : [h];
          }
        return {
          exports: s,
          options: d
        };
      }
    },
    4: function(e, t) {
      e.exports = an();
    },
    91: function(e, t, r) {
      r.r(t);
      var i = function() {
        var d = this, h = d.$createElement, v = d._self._c || h;
        return v(
          "label",
          {
            staticClass: "el-checkbox",
            class: [
              d.border && d.checkboxSize ? "el-checkbox--" + d.checkboxSize : "",
              { "is-disabled": d.isDisabled },
              { "is-bordered": d.border },
              { "is-checked": d.isChecked }
            ],
            attrs: { id: d.id }
          },
          [
            v(
              "span",
              {
                staticClass: "el-checkbox__input",
                class: {
                  "is-disabled": d.isDisabled,
                  "is-checked": d.isChecked,
                  "is-indeterminate": d.indeterminate,
                  "is-focus": d.focus
                },
                attrs: {
                  tabindex: d.indeterminate ? 0 : !1,
                  role: d.indeterminate ? "checkbox" : !1,
                  "aria-checked": d.indeterminate ? "mixed" : !1
                }
              },
              [
                v("span", { staticClass: "el-checkbox__inner" }),
                d.trueLabel || d.falseLabel ? v("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: d.model,
                      expression: "model"
                    }
                  ],
                  staticClass: "el-checkbox__original",
                  attrs: {
                    type: "checkbox",
                    "aria-hidden": d.indeterminate ? "true" : "false",
                    name: d.name,
                    disabled: d.isDisabled,
                    "true-value": d.trueLabel,
                    "false-value": d.falseLabel
                  },
                  domProps: {
                    checked: Array.isArray(d.model) ? d._i(d.model, null) > -1 : d._q(d.model, d.trueLabel)
                  },
                  on: {
                    change: [
                      function(g) {
                        var m = d.model, _ = g.target, y = _.checked ? d.trueLabel : d.falseLabel;
                        if (Array.isArray(m)) {
                          var w = null, O = d._i(m, w);
                          _.checked ? O < 0 && (d.model = m.concat([w])) : O > -1 && (d.model = m.slice(0, O).concat(m.slice(O + 1)));
                        } else
                          d.model = y;
                      },
                      d.handleChange
                    ],
                    focus: function(g) {
                      d.focus = !0;
                    },
                    blur: function(g) {
                      d.focus = !1;
                    }
                  }
                }) : v("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: d.model,
                      expression: "model"
                    }
                  ],
                  staticClass: "el-checkbox__original",
                  attrs: {
                    type: "checkbox",
                    "aria-hidden": d.indeterminate ? "true" : "false",
                    disabled: d.isDisabled,
                    name: d.name
                  },
                  domProps: {
                    value: d.label,
                    checked: Array.isArray(d.model) ? d._i(d.model, d.label) > -1 : d.model
                  },
                  on: {
                    change: [
                      function(g) {
                        var m = d.model, _ = g.target, y = !!_.checked;
                        if (Array.isArray(m)) {
                          var w = d.label, O = d._i(m, w);
                          _.checked ? O < 0 && (d.model = m.concat([w])) : O > -1 && (d.model = m.slice(0, O).concat(m.slice(O + 1)));
                        } else
                          d.model = y;
                      },
                      d.handleChange
                    ],
                    focus: function(g) {
                      d.focus = !0;
                    },
                    blur: function(g) {
                      d.focus = !1;
                    }
                  }
                })
              ]
            ),
            d.$slots.default || d.label ? v(
              "span",
              { staticClass: "el-checkbox__label" },
              [
                d._t("default"),
                d.$slots.default ? d._e() : [d._v(d._s(d.label))]
              ],
              2
            ) : d._e()
          ]
        );
      }, s = [];
      i._withStripped = !0;
      var o = r(4), a = /* @__PURE__ */ r.n(o), l = {
        name: "ElCheckbox",
        mixins: [a.a],
        inject: {
          elForm: {
            default: ""
          },
          elFormItem: {
            default: ""
          }
        },
        componentName: "ElCheckbox",
        data: function() {
          return {
            selfModel: !1,
            focus: !1,
            isLimitExceeded: !1
          };
        },
        computed: {
          model: {
            get: function() {
              return this.isGroup ? this.store : this.value !== void 0 ? this.value : this.selfModel;
            },
            set: function(h) {
              this.isGroup ? (this.isLimitExceeded = !1, this._checkboxGroup.min !== void 0 && h.length < this._checkboxGroup.min && (this.isLimitExceeded = !0), this._checkboxGroup.max !== void 0 && h.length > this._checkboxGroup.max && (this.isLimitExceeded = !0), this.isLimitExceeded === !1 && this.dispatch("ElCheckboxGroup", "input", [h])) : (this.$emit("input", h), this.selfModel = h);
            }
          },
          isChecked: function() {
            if ({}.toString.call(this.model) === "[object Boolean]")
              return this.model;
            if (Array.isArray(this.model))
              return this.model.indexOf(this.label) > -1;
            if (this.model !== null && this.model !== void 0)
              return this.model === this.trueLabel;
          },
          isGroup: function() {
            for (var h = this.$parent; h; )
              if (h.$options.componentName !== "ElCheckboxGroup")
                h = h.$parent;
              else
                return this._checkboxGroup = h, !0;
            return !1;
          },
          store: function() {
            return this._checkboxGroup ? this._checkboxGroup.value : this.value;
          },
          isLimitDisabled: function() {
            var h = this._checkboxGroup, v = h.max, g = h.min;
            return !!(v || g) && this.model.length >= v && !this.isChecked || this.model.length <= g && this.isChecked;
          },
          isDisabled: function() {
            return this.isGroup ? this._checkboxGroup.disabled || this.disabled || (this.elForm || {}).disabled || this.isLimitDisabled : this.disabled || (this.elForm || {}).disabled;
          },
          _elFormItemSize: function() {
            return (this.elFormItem || {}).elFormItemSize;
          },
          checkboxSize: function() {
            var h = this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
            return this.isGroup && this._checkboxGroup.checkboxGroupSize || h;
          }
        },
        props: {
          value: {},
          label: {},
          indeterminate: Boolean,
          disabled: Boolean,
          checked: Boolean,
          name: String,
          trueLabel: [String, Number],
          falseLabel: [String, Number],
          id: String,
          controls: String,
          border: Boolean,
          size: String
        },
        methods: {
          addToStore: function() {
            Array.isArray(this.model) && this.model.indexOf(this.label) === -1 ? this.model.push(this.label) : this.model = this.trueLabel || !0;
          },
          handleChange: function(h) {
            var v = this;
            if (!this.isLimitExceeded) {
              var g = void 0;
              h.target.checked ? g = this.trueLabel === void 0 ? !0 : this.trueLabel : g = this.falseLabel === void 0 ? !1 : this.falseLabel, this.$emit("change", g, h), this.$nextTick(function() {
                v.isGroup && v.dispatch("ElCheckboxGroup", "change", [v._checkboxGroup.value]);
              });
            }
          }
        },
        created: function() {
          this.checked && this.addToStore();
        },
        mounted: function() {
          this.indeterminate && this.$el.setAttribute("aria-controls", this.controls);
        },
        watch: {
          value: function(h) {
            this.dispatch("ElFormItem", "el.form.change", h);
          }
        }
      }, u = l, c = r(0), f = Object(c.a)(
        u,
        i,
        s,
        !1,
        null,
        null,
        null
      );
      f.options.__file = "packages/checkbox/src/checkbox.vue";
      var p = f.exports;
      p.install = function(d) {
        d.component(p.name, p);
      }, t.default = p;
    }
  });
})(Ub);
const IP = /* @__PURE__ */ ot(Ub.exports);
var Gb = { exports: {} };
(function(n) {
  n.exports = function(e) {
    var t = {};
    function r(i) {
      if (t[i])
        return t[i].exports;
      var s = t[i] = {
        i,
        l: !1,
        exports: {}
      };
      return e[i].call(s.exports, s, s.exports, r), s.l = !0, s.exports;
    }
    return r.m = e, r.c = t, r.d = function(i, s, o) {
      r.o(i, s) || Object.defineProperty(i, s, { enumerable: !0, get: o });
    }, r.r = function(i) {
      typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(i, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(i, "__esModule", { value: !0 });
    }, r.t = function(i, s) {
      if (s & 1 && (i = r(i)), s & 8 || s & 4 && typeof i == "object" && i && i.__esModule)
        return i;
      var o = /* @__PURE__ */ Object.create(null);
      if (r.r(o), Object.defineProperty(o, "default", { enumerable: !0, value: i }), s & 2 && typeof i != "string")
        for (var a in i)
          r.d(o, a, function(l) {
            return i[l];
          }.bind(null, a));
      return o;
    }, r.n = function(i) {
      var s = i && i.__esModule ? function() {
        return i.default;
      } : function() {
        return i;
      };
      return r.d(s, "a", s), s;
    }, r.o = function(i, s) {
      return Object.prototype.hasOwnProperty.call(i, s);
    }, r.p = "/dist/", r(r.s = 55);
  }({
    0: function(e, t, r) {
      r.d(t, "a", function() {
        return i;
      });
      function i(s, o, a, l, u, c, f, p) {
        var d = typeof s == "function" ? s.options : s;
        o && (d.render = o, d.staticRenderFns = a, d._compiled = !0), l && (d.functional = !0), c && (d._scopeId = "data-v-" + c);
        var h;
        if (f ? (h = function(m) {
          m = m || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !m && typeof __VUE_SSR_CONTEXT__ < "u" && (m = __VUE_SSR_CONTEXT__), u && u.call(this, m), m && m._registeredComponents && m._registeredComponents.add(f);
        }, d._ssrRegister = h) : u && (h = p ? function() {
          u.call(this, this.$root.$options.shadowRoot);
        } : u), h)
          if (d.functional) {
            d._injectStyles = h;
            var v = d.render;
            d.render = function(_, y) {
              return h.call(y), v(_, y);
            };
          } else {
            var g = d.beforeCreate;
            d.beforeCreate = g ? [].concat(g, h) : [h];
          }
        return {
          exports: s,
          options: d
        };
      }
    },
    10: function(e, t) {
      e.exports = Zs.exports;
    },
    12: function(e, t) {
      e.exports = If();
    },
    14: function(e, t) {
      e.exports = Tl.exports;
    },
    4: function(e, t) {
      e.exports = an();
    },
    5: function(e, t) {
      e.exports = Ol();
    },
    55: function(e, t, r) {
      r.r(t);
      var i = function() {
        var k = this, A = k.$createElement, P = k._self._c || A;
        return P(
          "div",
          {
            directives: [
              {
                name: "clickoutside",
                rawName: "v-clickoutside",
                value: k.hide,
                expression: "hide"
              }
            ],
            class: [
              "el-color-picker",
              k.colorDisabled ? "is-disabled" : "",
              k.colorSize ? "el-color-picker--" + k.colorSize : ""
            ]
          },
          [
            k.colorDisabled ? P("div", { staticClass: "el-color-picker__mask" }) : k._e(),
            P(
              "div",
              {
                staticClass: "el-color-picker__trigger",
                on: { click: k.handleTrigger }
              },
              [
                P(
                  "span",
                  {
                    staticClass: "el-color-picker__color",
                    class: { "is-alpha": k.showAlpha }
                  },
                  [
                    P("span", {
                      staticClass: "el-color-picker__color-inner",
                      style: {
                        backgroundColor: k.displayedColor
                      }
                    }),
                    !k.value && !k.showPanelColor ? P("span", {
                      staticClass: "el-color-picker__empty el-icon-close"
                    }) : k._e()
                  ]
                ),
                P("span", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: k.value || k.showPanelColor,
                      expression: "value || showPanelColor"
                    }
                  ],
                  staticClass: "el-color-picker__icon el-icon-arrow-down"
                })
              ]
            ),
            P("picker-dropdown", {
              ref: "dropdown",
              class: ["el-color-picker__panel", k.popperClass || ""],
              attrs: {
                color: k.color,
                "show-alpha": k.showAlpha,
                predefine: k.predefine
              },
              on: { pick: k.confirmValue, clear: k.clearValue },
              model: {
                value: k.showPicker,
                callback: function(L) {
                  k.showPicker = L;
                },
                expression: "showPicker"
              }
            })
          ],
          1
        );
      }, s = [];
      i._withStripped = !0;
      var o = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(k) {
        return typeof k;
      } : function(k) {
        return k && typeof Symbol == "function" && k.constructor === Symbol && k !== Symbol.prototype ? "symbol" : typeof k;
      };
      function a(k, A) {
        if (!(k instanceof A))
          throw new TypeError("Cannot call a class as a function");
      }
      var l = function(A, P, L) {
        return [A, P * L / ((A = (2 - P) * L) < 1 ? A : 2 - A) || 0, A / 2];
      }, u = function(A) {
        return typeof A == "string" && A.indexOf(".") !== -1 && parseFloat(A) === 1;
      }, c = function(A) {
        return typeof A == "string" && A.indexOf("%") !== -1;
      }, f = function(A, P) {
        u(A) && (A = "100%");
        var L = c(A);
        return A = Math.min(P, Math.max(0, parseFloat(A))), L && (A = parseInt(A * P, 10) / 100), Math.abs(A - P) < 1e-6 ? 1 : A % P / parseFloat(P);
      }, p = { 10: "A", 11: "B", 12: "C", 13: "D", 14: "E", 15: "F" }, d = function(A) {
        var P = A.r, L = A.g, B = A.b, U = function(ce) {
          ce = Math.min(Math.round(ce), 255);
          var _e = Math.floor(ce / 16), De = ce % 16;
          return "" + (p[_e] || _e) + (p[De] || De);
        };
        return isNaN(P) || isNaN(L) || isNaN(B) ? "" : "#" + U(P) + U(L) + U(B);
      }, h = { A: 10, B: 11, C: 12, D: 13, E: 14, F: 15 }, v = function(A) {
        return A.length === 2 ? (h[A[0].toUpperCase()] || +A[0]) * 16 + (h[A[1].toUpperCase()] || +A[1]) : h[A[1].toUpperCase()] || +A[1];
      }, g = function(A, P, L) {
        P = P / 100, L = L / 100;
        var B = P, U = Math.max(L, 0.01), ie = void 0, ce = void 0;
        return L *= 2, P *= L <= 1 ? L : 2 - L, B *= U <= 1 ? U : 2 - U, ce = (L + P) / 2, ie = L === 0 ? 2 * B / (U + B) : 2 * P / (L + P), {
          h: A,
          s: ie * 100,
          v: ce * 100
        };
      }, m = function(A, P, L) {
        A = f(A, 255), P = f(P, 255), L = f(L, 255);
        var B = Math.max(A, P, L), U = Math.min(A, P, L), ie = void 0, ce = void 0, _e = B, De = B - U;
        if (ce = B === 0 ? 0 : De / B, B === U)
          ie = 0;
        else {
          switch (B) {
            case A:
              ie = (P - L) / De + (P < L ? 6 : 0);
              break;
            case P:
              ie = (L - A) / De + 2;
              break;
            case L:
              ie = (A - P) / De + 4;
              break;
          }
          ie /= 6;
        }
        return { h: ie * 360, s: ce * 100, v: _e * 100 };
      }, _ = function(A, P, L) {
        A = f(A, 360) * 6, P = f(P, 100), L = f(L, 100);
        var B = Math.floor(A), U = A - B, ie = L * (1 - P), ce = L * (1 - U * P), _e = L * (1 - (1 - U) * P), De = B % 6, He = [L, ce, ie, ie, _e, L][De], Tt = [_e, L, L, ce, ie, ie][De], jt = [ie, ie, _e, L, L, ce][De];
        return {
          r: Math.round(He * 255),
          g: Math.round(Tt * 255),
          b: Math.round(jt * 255)
        };
      }, y = function() {
        function k(A) {
          a(this, k), this._hue = 0, this._saturation = 100, this._value = 100, this._alpha = 100, this.enableAlpha = !1, this.format = "hex", this.value = "", A = A || {};
          for (var P in A)
            A.hasOwnProperty(P) && (this[P] = A[P]);
          this.doOnChange();
        }
        return k.prototype.set = function(P, L) {
          if (arguments.length === 1 && (typeof P > "u" ? "undefined" : o(P)) === "object") {
            for (var B in P)
              P.hasOwnProperty(B) && this.set(B, P[B]);
            return;
          }
          this["_" + P] = L, this.doOnChange();
        }, k.prototype.get = function(P) {
          return this["_" + P];
        }, k.prototype.toRgb = function() {
          return _(this._hue, this._saturation, this._value);
        }, k.prototype.fromString = function(P) {
          var L = this;
          if (!P) {
            this._hue = 0, this._saturation = 100, this._value = 100, this.doOnChange();
            return;
          }
          var B = function(yr, Z_, eS) {
            L._hue = Math.max(0, Math.min(360, yr)), L._saturation = Math.max(0, Math.min(100, Z_)), L._value = Math.max(0, Math.min(100, eS)), L.doOnChange();
          };
          if (P.indexOf("hsl") !== -1) {
            var U = P.replace(/hsla|hsl|\(|\)/gm, "").split(/\s|,/g).filter(function(ut) {
              return ut !== "";
            }).map(function(ut, yr) {
              return yr > 2 ? parseFloat(ut) : parseInt(ut, 10);
            });
            if (U.length === 4 ? this._alpha = Math.floor(parseFloat(U[3]) * 100) : U.length === 3 && (this._alpha = 100), U.length >= 3) {
              var ie = g(U[0], U[1], U[2]), ce = ie.h, _e = ie.s, De = ie.v;
              B(ce, _e, De);
            }
          } else if (P.indexOf("hsv") !== -1) {
            var He = P.replace(/hsva|hsv|\(|\)/gm, "").split(/\s|,/g).filter(function(ut) {
              return ut !== "";
            }).map(function(ut, yr) {
              return yr > 2 ? parseFloat(ut) : parseInt(ut, 10);
            });
            He.length === 4 ? this._alpha = Math.floor(parseFloat(He[3]) * 100) : He.length === 3 && (this._alpha = 100), He.length >= 3 && B(He[0], He[1], He[2]);
          } else if (P.indexOf("rgb") !== -1) {
            var Tt = P.replace(/rgba|rgb|\(|\)/gm, "").split(/\s|,/g).filter(function(ut) {
              return ut !== "";
            }).map(function(ut, yr) {
              return yr > 2 ? parseFloat(ut) : parseInt(ut, 10);
            });
            if (Tt.length === 4 ? this._alpha = Math.floor(parseFloat(Tt[3]) * 100) : Tt.length === 3 && (this._alpha = 100), Tt.length >= 3) {
              var jt = m(Tt[0], Tt[1], Tt[2]), cn = jt.h, $u = jt.s, Du = jt.v;
              B(cn, $u, Du);
            }
          } else if (P.indexOf("#") !== -1) {
            var ze = P.replace("#", "").trim();
            if (!/^(?:[0-9a-fA-F]{3}){1,2}|[0-9a-fA-F]{8}$/.test(ze))
              return;
            var Lu = void 0, Nu = void 0, Iu = void 0;
            ze.length === 3 ? (Lu = v(ze[0] + ze[0]), Nu = v(ze[1] + ze[1]), Iu = v(ze[2] + ze[2])) : (ze.length === 6 || ze.length === 8) && (Lu = v(ze.substring(0, 2)), Nu = v(ze.substring(2, 4)), Iu = v(ze.substring(4, 6))), ze.length === 8 ? this._alpha = Math.floor(v(ze.substring(6)) / 255 * 100) : (ze.length === 3 || ze.length === 6) && (this._alpha = 100);
            var Ru = m(Lu, Nu, Iu), X_ = Ru.h, Y_ = Ru.s, Q_ = Ru.v;
            B(X_, Y_, Q_);
          }
        }, k.prototype.compare = function(P) {
          return Math.abs(P._hue - this._hue) < 2 && Math.abs(P._saturation - this._saturation) < 1 && Math.abs(P._value - this._value) < 1 && Math.abs(P._alpha - this._alpha) < 1;
        }, k.prototype.doOnChange = function() {
          var P = this._hue, L = this._saturation, B = this._value, U = this._alpha, ie = this.format;
          if (this.enableAlpha)
            switch (ie) {
              case "hsl":
                var ce = l(P, L / 100, B / 100);
                this.value = "hsla(" + P + ", " + Math.round(ce[1] * 100) + "%, " + Math.round(ce[2] * 100) + "%, " + U / 100 + ")";
                break;
              case "hsv":
                this.value = "hsva(" + P + ", " + Math.round(L) + "%, " + Math.round(B) + "%, " + U / 100 + ")";
                break;
              default:
                var _e = _(P, L, B), De = _e.r, He = _e.g, Tt = _e.b;
                this.value = "rgba(" + De + ", " + He + ", " + Tt + ", " + U / 100 + ")";
            }
          else
            switch (ie) {
              case "hsl":
                var jt = l(P, L / 100, B / 100);
                this.value = "hsl(" + P + ", " + Math.round(jt[1] * 100) + "%, " + Math.round(jt[2] * 100) + "%)";
                break;
              case "hsv":
                this.value = "hsv(" + P + ", " + Math.round(L) + "%, " + Math.round(B) + "%)";
                break;
              case "rgb":
                var cn = _(P, L, B), $u = cn.r, Du = cn.g, ze = cn.b;
                this.value = "rgb(" + $u + ", " + Du + ", " + ze + ")";
                break;
              default:
                this.value = d(_(P, L, B));
            }
        }, k;
      }(), w = y, O = function() {
        var k = this, A = k.$createElement, P = k._self._c || A;
        return P(
          "transition",
          { attrs: { name: "el-zoom-in-top" }, on: { "after-leave": k.doDestroy } },
          [
            P(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: k.showPopper,
                    expression: "showPopper"
                  }
                ],
                staticClass: "el-color-dropdown"
              },
              [
                P(
                  "div",
                  { staticClass: "el-color-dropdown__main-wrapper" },
                  [
                    P("hue-slider", {
                      ref: "hue",
                      staticStyle: { float: "right" },
                      attrs: { color: k.color, vertical: "" }
                    }),
                    P("sv-panel", { ref: "sl", attrs: { color: k.color } })
                  ],
                  1
                ),
                k.showAlpha ? P("alpha-slider", { ref: "alpha", attrs: { color: k.color } }) : k._e(),
                k.predefine ? P("predefine", {
                  attrs: { color: k.color, colors: k.predefine }
                }) : k._e(),
                P(
                  "div",
                  { staticClass: "el-color-dropdown__btns" },
                  [
                    P(
                      "span",
                      { staticClass: "el-color-dropdown__value" },
                      [
                        P("el-input", {
                          attrs: { "validate-event": !1, size: "mini" },
                          on: { blur: k.handleConfirm },
                          nativeOn: {
                            keyup: function(L) {
                              return !("button" in L) && k._k(
                                L.keyCode,
                                "enter",
                                13,
                                L.key,
                                "Enter"
                              ) ? null : k.handleConfirm(L);
                            }
                          },
                          model: {
                            value: k.customInput,
                            callback: function(L) {
                              k.customInput = L;
                            },
                            expression: "customInput"
                          }
                        })
                      ],
                      1
                    ),
                    P(
                      "el-button",
                      {
                        staticClass: "el-color-dropdown__link-btn",
                        attrs: { size: "mini", type: "text" },
                        on: {
                          click: function(L) {
                            k.$emit("clear");
                          }
                        }
                      },
                      [
                        k._v(
                          `
        ` + k._s(k.t("el.colorpicker.clear")) + `
      `
                        )
                      ]
                    ),
                    P(
                      "el-button",
                      {
                        staticClass: "el-color-dropdown__btn",
                        attrs: { plain: "", size: "mini" },
                        on: { click: k.confirmValue }
                      },
                      [
                        k._v(
                          `
        ` + k._s(k.t("el.colorpicker.confirm")) + `
      `
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        );
      }, C = [];
      O._withStripped = !0;
      var S = function() {
        var k = this, A = k.$createElement, P = k._self._c || A;
        return P(
          "div",
          {
            staticClass: "el-color-svpanel",
            style: {
              backgroundColor: k.background
            }
          },
          [
            P("div", { staticClass: "el-color-svpanel__white" }),
            P("div", { staticClass: "el-color-svpanel__black" }),
            P(
              "div",
              {
                staticClass: "el-color-svpanel__cursor",
                style: {
                  top: k.cursorTop + "px",
                  left: k.cursorLeft + "px"
                }
              },
              [P("div")]
            )
          ]
        );
      }, b = [];
      S._withStripped = !0;
      var x = r(7), E = /* @__PURE__ */ r.n(x), M = !1, $ = function(k, A) {
        if (!E.a.prototype.$isServer) {
          var P = function(U) {
            A.drag && A.drag(U);
          }, L = function B(U) {
            document.removeEventListener("mousemove", P), document.removeEventListener("mouseup", B), document.onselectstart = null, document.ondragstart = null, M = !1, A.end && A.end(U);
          };
          k.addEventListener("mousedown", function(B) {
            M || (document.onselectstart = function() {
              return !1;
            }, document.ondragstart = function() {
              return !1;
            }, document.addEventListener("mousemove", P), document.addEventListener("mouseup", L), M = !0, A.start && A.start(B));
          });
        }
      }, F = {
        name: "el-sl-panel",
        props: {
          color: {
            required: !0
          }
        },
        computed: {
          colorValue: function() {
            var A = this.color.get("hue"), P = this.color.get("value");
            return { hue: A, value: P };
          }
        },
        watch: {
          colorValue: function() {
            this.update();
          }
        },
        methods: {
          update: function() {
            var A = this.color.get("saturation"), P = this.color.get("value"), L = this.$el, B = L.clientWidth, U = L.clientHeight;
            this.cursorLeft = A * B / 100, this.cursorTop = (100 - P) * U / 100, this.background = "hsl(" + this.color.get("hue") + ", 100%, 50%)";
          },
          handleDrag: function(A) {
            var P = this.$el, L = P.getBoundingClientRect(), B = A.clientX - L.left, U = A.clientY - L.top;
            B = Math.max(0, B), B = Math.min(B, L.width), U = Math.max(0, U), U = Math.min(U, L.height), this.cursorLeft = B, this.cursorTop = U, this.color.set({
              saturation: B / L.width * 100,
              value: 100 - U / L.height * 100
            });
          }
        },
        mounted: function() {
          var A = this;
          $(this.$el, {
            drag: function(L) {
              A.handleDrag(L);
            },
            end: function(L) {
              A.handleDrag(L);
            }
          }), this.update();
        },
        data: function() {
          return {
            cursorTop: 0,
            cursorLeft: 0,
            background: "hsl(0, 100%, 50%)"
          };
        }
      }, J = F, W = r(0), H = Object(W.a)(
        J,
        S,
        b,
        !1,
        null,
        null,
        null
      );
      H.options.__file = "packages/color-picker/src/components/sv-panel.vue";
      var Y = H.exports, z = function() {
        var k = this, A = k.$createElement, P = k._self._c || A;
        return P(
          "div",
          {
            staticClass: "el-color-hue-slider",
            class: { "is-vertical": k.vertical }
          },
          [
            P("div", {
              ref: "bar",
              staticClass: "el-color-hue-slider__bar",
              on: { click: k.handleClick }
            }),
            P("div", {
              ref: "thumb",
              staticClass: "el-color-hue-slider__thumb",
              style: {
                left: k.thumbLeft + "px",
                top: k.thumbTop + "px"
              }
            })
          ]
        );
      }, j = [];
      z._withStripped = !0;
      var Q = {
        name: "el-color-hue-slider",
        props: {
          color: {
            required: !0
          },
          vertical: Boolean
        },
        data: function() {
          return {
            thumbLeft: 0,
            thumbTop: 0
          };
        },
        computed: {
          hueValue: function() {
            var A = this.color.get("hue");
            return A;
          }
        },
        watch: {
          hueValue: function() {
            this.update();
          }
        },
        methods: {
          handleClick: function(A) {
            var P = this.$refs.thumb, L = A.target;
            L !== P && this.handleDrag(A);
          },
          handleDrag: function(A) {
            var P = this.$el.getBoundingClientRect(), L = this.$refs.thumb, B = void 0;
            if (this.vertical) {
              var ie = A.clientY - P.top;
              ie = Math.min(ie, P.height - L.offsetHeight / 2), ie = Math.max(L.offsetHeight / 2, ie), B = Math.round((ie - L.offsetHeight / 2) / (P.height - L.offsetHeight) * 360);
            } else {
              var U = A.clientX - P.left;
              U = Math.min(U, P.width - L.offsetWidth / 2), U = Math.max(L.offsetWidth / 2, U), B = Math.round((U - L.offsetWidth / 2) / (P.width - L.offsetWidth) * 360);
            }
            this.color.set("hue", B);
          },
          getThumbLeft: function() {
            if (this.vertical)
              return 0;
            var A = this.$el, P = this.color.get("hue");
            if (!A)
              return 0;
            var L = this.$refs.thumb;
            return Math.round(P * (A.offsetWidth - L.offsetWidth / 2) / 360);
          },
          getThumbTop: function() {
            if (!this.vertical)
              return 0;
            var A = this.$el, P = this.color.get("hue");
            if (!A)
              return 0;
            var L = this.$refs.thumb;
            return Math.round(P * (A.offsetHeight - L.offsetHeight / 2) / 360);
          },
          update: function() {
            this.thumbLeft = this.getThumbLeft(), this.thumbTop = this.getThumbTop();
          }
        },
        mounted: function() {
          var A = this, P = this.$refs, L = P.bar, B = P.thumb, U = {
            drag: function(ce) {
              A.handleDrag(ce);
            },
            end: function(ce) {
              A.handleDrag(ce);
            }
          };
          $(L, U), $(B, U), this.update();
        }
      }, fe = Q, ue = Object(W.a)(
        fe,
        z,
        j,
        !1,
        null,
        null,
        null
      );
      ue.options.__file = "packages/color-picker/src/components/hue-slider.vue";
      var ae = ue.exports, ye = function() {
        var k = this, A = k.$createElement, P = k._self._c || A;
        return P(
          "div",
          {
            staticClass: "el-color-alpha-slider",
            class: { "is-vertical": k.vertical }
          },
          [
            P("div", {
              ref: "bar",
              staticClass: "el-color-alpha-slider__bar",
              style: {
                background: k.background
              },
              on: { click: k.handleClick }
            }),
            P("div", {
              ref: "thumb",
              staticClass: "el-color-alpha-slider__thumb",
              style: {
                left: k.thumbLeft + "px",
                top: k.thumbTop + "px"
              }
            })
          ]
        );
      }, re = [];
      ye._withStripped = !0;
      var T = {
        name: "el-color-alpha-slider",
        props: {
          color: {
            required: !0
          },
          vertical: Boolean
        },
        watch: {
          "color._alpha": function() {
            this.update();
          },
          "color.value": function() {
            this.update();
          }
        },
        methods: {
          handleClick: function(A) {
            var P = this.$refs.thumb, L = A.target;
            L !== P && this.handleDrag(A);
          },
          handleDrag: function(A) {
            var P = this.$el.getBoundingClientRect(), L = this.$refs.thumb;
            if (this.vertical) {
              var U = A.clientY - P.top;
              U = Math.max(L.offsetHeight / 2, U), U = Math.min(U, P.height - L.offsetHeight / 2), this.color.set("alpha", Math.round((U - L.offsetHeight / 2) / (P.height - L.offsetHeight) * 100));
            } else {
              var B = A.clientX - P.left;
              B = Math.max(L.offsetWidth / 2, B), B = Math.min(B, P.width - L.offsetWidth / 2), this.color.set("alpha", Math.round((B - L.offsetWidth / 2) / (P.width - L.offsetWidth) * 100));
            }
          },
          getThumbLeft: function() {
            if (this.vertical)
              return 0;
            var A = this.$el, P = this.color._alpha;
            if (!A)
              return 0;
            var L = this.$refs.thumb;
            return Math.round(P * (A.offsetWidth - L.offsetWidth / 2) / 100);
          },
          getThumbTop: function() {
            if (!this.vertical)
              return 0;
            var A = this.$el, P = this.color._alpha;
            if (!A)
              return 0;
            var L = this.$refs.thumb;
            return Math.round(P * (A.offsetHeight - L.offsetHeight / 2) / 100);
          },
          getBackground: function() {
            if (this.color && this.color.value) {
              var A = this.color.toRgb(), P = A.r, L = A.g, B = A.b;
              return "linear-gradient(to right, rgba(" + P + ", " + L + ", " + B + ", 0) 0%, rgba(" + P + ", " + L + ", " + B + ", 1) 100%)";
            }
            return null;
          },
          update: function() {
            this.thumbLeft = this.getThumbLeft(), this.thumbTop = this.getThumbTop(), this.background = this.getBackground();
          }
        },
        data: function() {
          return {
            thumbLeft: 0,
            thumbTop: 0,
            background: null
          };
        },
        mounted: function() {
          var A = this, P = this.$refs, L = P.bar, B = P.thumb, U = {
            drag: function(ce) {
              A.handleDrag(ce);
            },
            end: function(ce) {
              A.handleDrag(ce);
            }
          };
          $(L, U), $(B, U), this.update();
        }
      }, D = T, R = Object(W.a)(
        D,
        ye,
        re,
        !1,
        null,
        null,
        null
      );
      R.options.__file = "packages/color-picker/src/components/alpha-slider.vue";
      var I = R.exports, se = function() {
        var k = this, A = k.$createElement, P = k._self._c || A;
        return P("div", { staticClass: "el-color-predefine" }, [
          P(
            "div",
            { staticClass: "el-color-predefine__colors" },
            k._l(k.rgbaColors, function(L, B) {
              return P(
                "div",
                {
                  key: k.colors[B],
                  staticClass: "el-color-predefine__color-selector",
                  class: { selected: L.selected, "is-alpha": L._alpha < 100 },
                  on: {
                    click: function(U) {
                      k.handleSelect(B);
                    }
                  }
                },
                [P("div", { style: { "background-color": L.value } })]
              );
            }),
            0
          )
        ]);
      }, Oe = [];
      se._withStripped = !0;
      var Me = {
        props: {
          colors: { type: Array, required: !0 },
          color: { required: !0 }
        },
        data: function() {
          return {
            rgbaColors: this.parseColors(this.colors, this.color)
          };
        },
        methods: {
          handleSelect: function(A) {
            this.color.fromString(this.colors[A]);
          },
          parseColors: function(A, P) {
            return A.map(function(L) {
              var B = new w();
              return B.enableAlpha = !0, B.format = "rgba", B.fromString(L), B.selected = B.value === P.value, B;
            });
          }
        },
        watch: {
          "$parent.currentColor": function(A) {
            var P = new w();
            P.fromString(A), this.rgbaColors.forEach(function(L) {
              L.selected = P.compare(L);
            });
          },
          colors: function(A) {
            this.rgbaColors = this.parseColors(A, this.color);
          },
          color: function(A) {
            this.rgbaColors = this.parseColors(this.colors, A);
          }
        }
      }, Re = Me, Je = Object(W.a)(
        Re,
        se,
        Oe,
        !1,
        null,
        null,
        null
      );
      Je.options.__file = "packages/color-picker/src/components/predefine.vue";
      var Ee = Je.exports, Fe = r(5), Ft = /* @__PURE__ */ r.n(Fe), zt = r(6), Fn = /* @__PURE__ */ r.n(zt), wt = r(10), Te = /* @__PURE__ */ r.n(wt), ln = r(14), en = /* @__PURE__ */ r.n(ln), un = {
        name: "el-color-picker-dropdown",
        mixins: [Ft.a, Fn.a],
        components: {
          SvPanel: Y,
          HueSlider: ae,
          AlphaSlider: I,
          ElInput: Te.a,
          ElButton: en.a,
          Predefine: Ee
        },
        props: {
          color: {
            required: !0
          },
          showAlpha: Boolean,
          predefine: Array
        },
        data: function() {
          return {
            customInput: ""
          };
        },
        computed: {
          currentColor: function() {
            var A = this.$parent;
            return !A.value && !A.showPanelColor ? "" : A.color.value;
          }
        },
        methods: {
          confirmValue: function() {
            this.$emit("pick");
          },
          handleConfirm: function() {
            this.color.fromString(this.customInput);
          }
        },
        mounted: function() {
          this.$parent.popperElm = this.popperElm = this.$el, this.referenceElm = this.$parent.$el;
        },
        watch: {
          showPopper: function(A) {
            var P = this;
            A === !0 && this.$nextTick(function() {
              var L = P.$refs, B = L.sl, U = L.hue, ie = L.alpha;
              B && B.update(), U && U.update(), ie && ie.update();
            });
          },
          currentColor: {
            immediate: !0,
            handler: function(A) {
              this.customInput = A;
            }
          }
        }
      }, zn = un, En = Object(W.a)(
        zn,
        O,
        C,
        !1,
        null,
        null,
        null
      );
      En.options.__file = "packages/color-picker/src/components/picker-dropdown.vue";
      var Bn = En.exports, Bt = r(12), Qi = /* @__PURE__ */ r.n(Bt), ei = r(4), jn = /* @__PURE__ */ r.n(ei), K = {
        name: "ElColorPicker",
        mixins: [jn.a],
        props: {
          value: String,
          showAlpha: Boolean,
          colorFormat: String,
          disabled: Boolean,
          size: String,
          popperClass: String,
          predefine: Array
        },
        inject: {
          elForm: {
            default: ""
          },
          elFormItem: {
            default: ""
          }
        },
        directives: { Clickoutside: Qi.a },
        computed: {
          displayedColor: function() {
            return !this.value && !this.showPanelColor ? "transparent" : this.displayedRgb(this.color, this.showAlpha);
          },
          _elFormItemSize: function() {
            return (this.elFormItem || {}).elFormItemSize;
          },
          colorSize: function() {
            return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
          },
          colorDisabled: function() {
            return this.disabled || (this.elForm || {}).disabled;
          }
        },
        watch: {
          value: function(A) {
            A ? A && A !== this.color.value && this.color.fromString(A) : this.showPanelColor = !1;
          },
          color: {
            deep: !0,
            handler: function() {
              this.showPanelColor = !0;
            }
          },
          displayedColor: function(A) {
            if (!!this.showPicker) {
              var P = new w({
                enableAlpha: this.showAlpha,
                format: this.colorFormat
              });
              P.fromString(this.value);
              var L = this.displayedRgb(P, this.showAlpha);
              A !== L && this.$emit("active-change", A);
            }
          }
        },
        methods: {
          handleTrigger: function() {
            this.colorDisabled || (this.showPicker = !this.showPicker);
          },
          confirmValue: function() {
            var A = this.color.value;
            this.$emit("input", A), this.$emit("change", A), this.dispatch("ElFormItem", "el.form.change", A), this.showPicker = !1;
          },
          clearValue: function() {
            this.$emit("input", null), this.$emit("change", null), this.value !== null && this.dispatch("ElFormItem", "el.form.change", null), this.showPanelColor = !1, this.showPicker = !1, this.resetColor();
          },
          hide: function() {
            this.showPicker = !1, this.resetColor();
          },
          resetColor: function() {
            var A = this;
            this.$nextTick(function(P) {
              A.value ? A.color.fromString(A.value) : A.showPanelColor = !1;
            });
          },
          displayedRgb: function(A, P) {
            if (!(A instanceof w))
              throw Error("color should be instance of Color Class");
            var L = A.toRgb(), B = L.r, U = L.g, ie = L.b;
            return P ? "rgba(" + B + ", " + U + ", " + ie + ", " + A.get("alpha") / 100 + ")" : "rgb(" + B + ", " + U + ", " + ie + ")";
          }
        },
        mounted: function() {
          var A = this.value;
          A && this.color.fromString(A), this.popperElm = this.$refs.dropdown.$el;
        },
        data: function() {
          var A = new w({
            enableAlpha: this.showAlpha,
            format: this.colorFormat
          });
          return {
            color: A,
            showPicker: !1,
            showPanelColor: !1
          };
        },
        components: {
          PickerDropdown: Bn
        }
      }, oe = K, N = Object(W.a)(
        oe,
        i,
        s,
        !1,
        null,
        null,
        null
      );
      N.options.__file = "packages/color-picker/src/main.vue";
      var q = N.exports;
      q.install = function(k) {
        k.component(q.name, q);
      }, t.default = q;
    },
    6: function(e, t) {
      e.exports = jb();
    },
    7: function(e, t) {
      e.exports = Nt;
    }
  });
})(Gb);
const RP = /* @__PURE__ */ ot(Gb.exports);
var Kb = { exports: {} }, Cc = { exports: {} }, Bm;
function FP() {
  return Bm || (Bm = 1, function(n) {
    n.exports = function(e) {
      var t = {};
      function r(i) {
        if (t[i])
          return t[i].exports;
        var s = t[i] = {
          i,
          l: !1,
          exports: {}
        };
        return e[i].call(s.exports, s, s.exports, r), s.l = !0, s.exports;
      }
      return r.m = e, r.c = t, r.d = function(i, s, o) {
        r.o(i, s) || Object.defineProperty(i, s, { enumerable: !0, get: o });
      }, r.r = function(i) {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(i, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(i, "__esModule", { value: !0 });
      }, r.t = function(i, s) {
        if (s & 1 && (i = r(i)), s & 8 || s & 4 && typeof i == "object" && i && i.__esModule)
          return i;
        var o = /* @__PURE__ */ Object.create(null);
        if (r.r(o), Object.defineProperty(o, "default", { enumerable: !0, value: i }), s & 2 && typeof i != "string")
          for (var a in i)
            r.d(o, a, function(l) {
              return i[l];
            }.bind(null, a));
        return o;
      }, r.n = function(i) {
        var s = i && i.__esModule ? function() {
          return i.default;
        } : function() {
          return i;
        };
        return r.d(s, "a", s), s;
      }, r.o = function(i, s) {
        return Object.prototype.hasOwnProperty.call(i, s);
      }, r.p = "/dist/", r(r.s = 87);
    }({
      0: function(e, t, r) {
        r.d(t, "a", function() {
          return i;
        });
        function i(s, o, a, l, u, c, f, p) {
          var d = typeof s == "function" ? s.options : s;
          o && (d.render = o, d.staticRenderFns = a, d._compiled = !0), l && (d.functional = !0), c && (d._scopeId = "data-v-" + c);
          var h;
          if (f ? (h = function(m) {
            m = m || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !m && typeof __VUE_SSR_CONTEXT__ < "u" && (m = __VUE_SSR_CONTEXT__), u && u.call(this, m), m && m._registeredComponents && m._registeredComponents.add(f);
          }, d._ssrRegister = h) : u && (h = p ? function() {
            u.call(this, this.$root.$options.shadowRoot);
          } : u), h)
            if (d.functional) {
              d._injectStyles = h;
              var v = d.render;
              d.render = function(_, y) {
                return h.call(y), v(_, y);
              };
            } else {
              var g = d.beforeCreate;
              d.beforeCreate = g ? [].concat(g, h) : [h];
            }
          return {
            exports: s,
            options: d
          };
        }
      },
      10: function(e, t) {
        e.exports = Zs.exports;
      },
      2: function(e, t) {
        e.exports = ji();
      },
      22: function(e, t) {
        e.exports = rp();
      },
      3: function(e, t) {
        e.exports = ne;
      },
      30: function(e, t, r) {
        var i = r(2), s = r(3);
        t.a = {
          bind: function(a, l, u) {
            var c = null, f = void 0, p = Object(s.isMac)() ? 100 : 200, d = function() {
              return u.context[l.expression].apply();
            }, h = function() {
              Date.now() - f < p && d(), clearInterval(c), c = null;
            };
            Object(i.on)(a, "mousedown", function(v) {
              v.button === 0 && (f = Date.now(), Object(i.once)(document, "mouseup", h), clearInterval(c), c = setInterval(d, p));
            });
          }
        };
      },
      87: function(e, t, r) {
        r.r(t);
        var i = function() {
          var g = this, m = g.$createElement, _ = g._self._c || m;
          return _(
            "div",
            {
              class: [
                "el-input-number",
                g.inputNumberSize ? "el-input-number--" + g.inputNumberSize : "",
                { "is-disabled": g.inputNumberDisabled },
                { "is-without-controls": !g.controls },
                { "is-controls-right": g.controlsAtRight }
              ],
              on: {
                dragstart: function(y) {
                  y.preventDefault();
                }
              }
            },
            [
              g.controls ? _(
                "span",
                {
                  directives: [
                    {
                      name: "repeat-click",
                      rawName: "v-repeat-click",
                      value: g.decrease,
                      expression: "decrease"
                    }
                  ],
                  staticClass: "el-input-number__decrease",
                  class: { "is-disabled": g.minDisabled },
                  attrs: { role: "button" },
                  on: {
                    keydown: function(y) {
                      return !("button" in y) && g._k(y.keyCode, "enter", 13, y.key, "Enter") ? null : g.decrease(y);
                    }
                  }
                },
                [
                  _("i", {
                    class: "el-icon-" + (g.controlsAtRight ? "arrow-down" : "minus")
                  })
                ]
              ) : g._e(),
              g.controls ? _(
                "span",
                {
                  directives: [
                    {
                      name: "repeat-click",
                      rawName: "v-repeat-click",
                      value: g.increase,
                      expression: "increase"
                    }
                  ],
                  staticClass: "el-input-number__increase",
                  class: { "is-disabled": g.maxDisabled },
                  attrs: { role: "button" },
                  on: {
                    keydown: function(y) {
                      return !("button" in y) && g._k(y.keyCode, "enter", 13, y.key, "Enter") ? null : g.increase(y);
                    }
                  }
                },
                [
                  _("i", {
                    class: "el-icon-" + (g.controlsAtRight ? "arrow-up" : "plus")
                  })
                ]
              ) : g._e(),
              _("el-input", {
                ref: "input",
                attrs: {
                  value: g.displayValue,
                  placeholder: g.placeholder,
                  disabled: g.inputNumberDisabled,
                  size: g.inputNumberSize,
                  max: g.max,
                  min: g.min,
                  name: g.name,
                  label: g.label
                },
                on: {
                  blur: g.handleBlur,
                  focus: g.handleFocus,
                  input: g.handleInput,
                  change: g.handleInputChange
                },
                nativeOn: {
                  keydown: [
                    function(y) {
                      return !("button" in y) && g._k(y.keyCode, "up", 38, y.key, ["Up", "ArrowUp"]) ? null : (y.preventDefault(), g.increase(y));
                    },
                    function(y) {
                      return !("button" in y) && g._k(y.keyCode, "down", 40, y.key, [
                        "Down",
                        "ArrowDown"
                      ]) ? null : (y.preventDefault(), g.decrease(y));
                    }
                  ]
                }
              })
            ],
            1
          );
        }, s = [];
        i._withStripped = !0;
        var o = r(10), a = /* @__PURE__ */ r.n(o), l = r(22), u = /* @__PURE__ */ r.n(l), c = r(30), f = {
          name: "ElInputNumber",
          mixins: [u()("input")],
          inject: {
            elForm: {
              default: ""
            },
            elFormItem: {
              default: ""
            }
          },
          directives: {
            repeatClick: c.a
          },
          components: {
            ElInput: a.a
          },
          props: {
            step: {
              type: Number,
              default: 1
            },
            stepStrictly: {
              type: Boolean,
              default: !1
            },
            max: {
              type: Number,
              default: 1 / 0
            },
            min: {
              type: Number,
              default: -1 / 0
            },
            value: {},
            disabled: Boolean,
            size: String,
            controls: {
              type: Boolean,
              default: !0
            },
            controlsPosition: {
              type: String,
              default: ""
            },
            name: String,
            label: String,
            placeholder: String,
            precision: {
              type: Number,
              validator: function(m) {
                return m >= 0 && m === parseInt(m, 10);
              }
            }
          },
          data: function() {
            return {
              currentValue: 0,
              userInput: null
            };
          },
          watch: {
            value: {
              immediate: !0,
              handler: function(m) {
                var _ = m === void 0 ? m : Number(m);
                if (_ !== void 0) {
                  if (isNaN(_))
                    return;
                  if (this.stepStrictly) {
                    var y = this.getPrecision(this.step), w = Math.pow(10, y);
                    _ = Math.round(_ / this.step) * w * this.step / w;
                  }
                  this.precision !== void 0 && (_ = this.toPrecision(_, this.precision));
                }
                _ >= this.max && (_ = this.max), _ <= this.min && (_ = this.min), this.currentValue = _, this.userInput = null, this.$emit("input", _);
              }
            }
          },
          computed: {
            minDisabled: function() {
              return this._decrease(this.value, this.step) < this.min;
            },
            maxDisabled: function() {
              return this._increase(this.value, this.step) > this.max;
            },
            numPrecision: function() {
              var m = this.value, _ = this.step, y = this.getPrecision, w = this.precision, O = y(_);
              return w !== void 0 ? (O > w && console.warn("[Element Warn][InputNumber]precision should not be less than the decimal places of step"), w) : Math.max(y(m), O);
            },
            controlsAtRight: function() {
              return this.controls && this.controlsPosition === "right";
            },
            _elFormItemSize: function() {
              return (this.elFormItem || {}).elFormItemSize;
            },
            inputNumberSize: function() {
              return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
            },
            inputNumberDisabled: function() {
              return this.disabled || !!(this.elForm || {}).disabled;
            },
            displayValue: function() {
              if (this.userInput !== null)
                return this.userInput;
              var m = this.currentValue;
              if (typeof m == "number") {
                if (this.stepStrictly) {
                  var _ = this.getPrecision(this.step), y = Math.pow(10, _);
                  m = Math.round(m / this.step) * y * this.step / y;
                }
                this.precision !== void 0 && (m = m.toFixed(this.precision));
              }
              return m;
            }
          },
          methods: {
            toPrecision: function(m, _) {
              return _ === void 0 && (_ = this.numPrecision), parseFloat(Math.round(m * Math.pow(10, _)) / Math.pow(10, _));
            },
            getPrecision: function(m) {
              if (m === void 0)
                return 0;
              var _ = m.toString(), y = _.indexOf("."), w = 0;
              return y !== -1 && (w = _.length - y - 1), w;
            },
            _increase: function(m, _) {
              if (typeof m != "number" && m !== void 0)
                return this.currentValue;
              var y = Math.pow(10, this.numPrecision);
              return this.toPrecision((y * m + y * _) / y);
            },
            _decrease: function(m, _) {
              if (typeof m != "number" && m !== void 0)
                return this.currentValue;
              var y = Math.pow(10, this.numPrecision);
              return this.toPrecision((y * m - y * _) / y);
            },
            increase: function() {
              if (!(this.inputNumberDisabled || this.maxDisabled)) {
                var m = this.value || 0, _ = this._increase(m, this.step);
                this.setCurrentValue(_);
              }
            },
            decrease: function() {
              if (!(this.inputNumberDisabled || this.minDisabled)) {
                var m = this.value || 0, _ = this._decrease(m, this.step);
                this.setCurrentValue(_);
              }
            },
            handleBlur: function(m) {
              this.$emit("blur", m);
            },
            handleFocus: function(m) {
              this.$emit("focus", m);
            },
            setCurrentValue: function(m) {
              var _ = this.currentValue;
              typeof m == "number" && this.precision !== void 0 && (m = this.toPrecision(m, this.precision)), m >= this.max && (m = this.max), m <= this.min && (m = this.min), _ !== m && (this.userInput = null, this.$emit("input", m), this.$emit("change", m, _), this.currentValue = m);
            },
            handleInput: function(m) {
              this.userInput = m;
            },
            handleInputChange: function(m) {
              var _ = m === "" ? void 0 : Number(m);
              (!isNaN(_) || m === "") && this.setCurrentValue(_), this.userInput = null;
            },
            select: function() {
              this.$refs.input.select();
            }
          },
          mounted: function() {
            var m = this.$refs.input.$refs.input;
            m.setAttribute("role", "spinbutton"), m.setAttribute("aria-valuemax", this.max), m.setAttribute("aria-valuemin", this.min), m.setAttribute("aria-valuenow", this.currentValue), m.setAttribute("aria-disabled", this.inputNumberDisabled);
          },
          updated: function() {
            if (!(!this.$refs || !this.$refs.input)) {
              var m = this.$refs.input.$refs.input;
              m.setAttribute("aria-valuenow", this.currentValue);
            }
          }
        }, p = f, d = r(0), h = Object(d.a)(
          p,
          i,
          s,
          !1,
          null,
          null,
          null
        );
        h.options.__file = "packages/input-number/src/input-number.vue";
        var v = h.exports;
        v.install = function(g) {
          g.component(v.name, v);
        }, t.default = v;
      }
    });
  }(Cc)), Cc.exports;
}
(function(n) {
  n.exports = function(e) {
    var t = {};
    function r(i) {
      if (t[i])
        return t[i].exports;
      var s = t[i] = {
        i,
        l: !1,
        exports: {}
      };
      return e[i].call(s.exports, s, s.exports, r), s.l = !0, s.exports;
    }
    return r.m = e, r.c = t, r.d = function(i, s, o) {
      r.o(i, s) || Object.defineProperty(i, s, { enumerable: !0, get: o });
    }, r.r = function(i) {
      typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(i, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(i, "__esModule", { value: !0 });
    }, r.t = function(i, s) {
      if (s & 1 && (i = r(i)), s & 8 || s & 4 && typeof i == "object" && i && i.__esModule)
        return i;
      var o = /* @__PURE__ */ Object.create(null);
      if (r.r(o), Object.defineProperty(o, "default", { enumerable: !0, value: i }), s & 2 && typeof i != "string")
        for (var a in i)
          r.d(o, a, function(l) {
            return i[l];
          }.bind(null, a));
      return o;
    }, r.n = function(i) {
      var s = i && i.__esModule ? function() {
        return i.default;
      } : function() {
        return i;
      };
      return r.d(s, "a", s), s;
    }, r.o = function(i, s) {
      return Object.prototype.hasOwnProperty.call(i, s);
    }, r.p = "/dist/", r(r.s = 64);
  }({
    0: function(e, t, r) {
      r.d(t, "a", function() {
        return i;
      });
      function i(s, o, a, l, u, c, f, p) {
        var d = typeof s == "function" ? s.options : s;
        o && (d.render = o, d.staticRenderFns = a, d._compiled = !0), l && (d.functional = !0), c && (d._scopeId = "data-v-" + c);
        var h;
        if (f ? (h = function(m) {
          m = m || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !m && typeof __VUE_SSR_CONTEXT__ < "u" && (m = __VUE_SSR_CONTEXT__), u && u.call(this, m), m && m._registeredComponents && m._registeredComponents.add(f);
        }, d._ssrRegister = h) : u && (h = p ? function() {
          u.call(this, this.$root.$options.shadowRoot);
        } : u), h)
          if (d.functional) {
            d._injectStyles = h;
            var v = d.render;
            d.render = function(_, y) {
              return h.call(y), v(_, y);
            };
          } else {
            var g = d.beforeCreate;
            d.beforeCreate = g ? [].concat(g, h) : [h];
          }
        return {
          exports: s,
          options: d
        };
      }
    },
    29: function(e, t) {
      e.exports = Lf.exports;
    },
    4: function(e, t) {
      e.exports = an();
    },
    50: function(e, t) {
      e.exports = FP();
    },
    64: function(e, t, r) {
      r.r(t);
      var i = function() {
        var b = this, x = b.$createElement, E = b._self._c || x;
        return E(
          "div",
          {
            staticClass: "el-slider",
            class: {
              "is-vertical": b.vertical,
              "el-slider--with-input": b.showInput
            },
            attrs: {
              role: "slider",
              "aria-valuemin": b.min,
              "aria-valuemax": b.max,
              "aria-orientation": b.vertical ? "vertical" : "horizontal",
              "aria-disabled": b.sliderDisabled
            }
          },
          [
            b.showInput && !b.range ? E("el-input-number", {
              ref: "input",
              staticClass: "el-slider__input",
              attrs: {
                step: b.step,
                disabled: b.sliderDisabled,
                controls: b.showInputControls,
                min: b.min,
                max: b.max,
                debounce: b.debounce,
                size: b.inputSize
              },
              on: { change: b.emitChange },
              model: {
                value: b.firstValue,
                callback: function(M) {
                  b.firstValue = M;
                },
                expression: "firstValue"
              }
            }) : b._e(),
            E(
              "div",
              {
                ref: "slider",
                staticClass: "el-slider__runway",
                class: { "show-input": b.showInput, disabled: b.sliderDisabled },
                style: b.runwayStyle,
                on: { click: b.onSliderClick }
              },
              [
                E("div", { staticClass: "el-slider__bar", style: b.barStyle }),
                E("slider-button", {
                  ref: "button1",
                  attrs: {
                    vertical: b.vertical,
                    "tooltip-class": b.tooltipClass
                  },
                  model: {
                    value: b.firstValue,
                    callback: function(M) {
                      b.firstValue = M;
                    },
                    expression: "firstValue"
                  }
                }),
                b.range ? E("slider-button", {
                  ref: "button2",
                  attrs: {
                    vertical: b.vertical,
                    "tooltip-class": b.tooltipClass
                  },
                  model: {
                    value: b.secondValue,
                    callback: function(M) {
                      b.secondValue = M;
                    },
                    expression: "secondValue"
                  }
                }) : b._e(),
                b._l(b.stops, function(M, $) {
                  return b.showStops ? E("div", {
                    key: $,
                    staticClass: "el-slider__stop",
                    style: b.getStopStyle(M)
                  }) : b._e();
                }),
                b.markList.length > 0 ? [
                  E(
                    "div",
                    b._l(b.markList, function(M, $) {
                      return E("div", {
                        key: $,
                        staticClass: "el-slider__stop el-slider__marks-stop",
                        style: b.getStopStyle(M.position)
                      });
                    }),
                    0
                  ),
                  E(
                    "div",
                    { staticClass: "el-slider__marks" },
                    b._l(b.markList, function(M, $) {
                      return E("slider-marker", {
                        key: $,
                        style: b.getStopStyle(M.position),
                        attrs: { mark: M.mark }
                      });
                    }),
                    1
                  )
                ] : b._e()
              ],
              2
            )
          ],
          1
        );
      }, s = [];
      i._withStripped = !0;
      var o = r(50), a = /* @__PURE__ */ r.n(o), l = function() {
        var b = this, x = b.$createElement, E = b._self._c || x;
        return E(
          "div",
          {
            ref: "button",
            staticClass: "el-slider__button-wrapper",
            class: { hover: b.hovering, dragging: b.dragging },
            style: b.wrapperStyle,
            attrs: { tabindex: "0" },
            on: {
              mouseenter: b.handleMouseEnter,
              mouseleave: b.handleMouseLeave,
              mousedown: b.onButtonDown,
              touchstart: b.onButtonDown,
              focus: b.handleMouseEnter,
              blur: b.handleMouseLeave,
              keydown: [
                function(M) {
                  return !("button" in M) && b._k(M.keyCode, "left", 37, M.key, [
                    "Left",
                    "ArrowLeft"
                  ]) || "button" in M && M.button !== 0 ? null : b.onLeftKeyDown(M);
                },
                function(M) {
                  return !("button" in M) && b._k(M.keyCode, "right", 39, M.key, [
                    "Right",
                    "ArrowRight"
                  ]) || "button" in M && M.button !== 2 ? null : b.onRightKeyDown(M);
                },
                function(M) {
                  return !("button" in M) && b._k(M.keyCode, "down", 40, M.key, [
                    "Down",
                    "ArrowDown"
                  ]) ? null : (M.preventDefault(), b.onLeftKeyDown(M));
                },
                function(M) {
                  return !("button" in M) && b._k(M.keyCode, "up", 38, M.key, ["Up", "ArrowUp"]) ? null : (M.preventDefault(), b.onRightKeyDown(M));
                }
              ]
            }
          },
          [
            E(
              "el-tooltip",
              {
                ref: "tooltip",
                attrs: {
                  placement: "top",
                  "popper-class": b.tooltipClass,
                  disabled: !b.showTooltip
                }
              },
              [
                E("span", { attrs: { slot: "content" }, slot: "content" }, [
                  b._v(b._s(b.formatValue))
                ]),
                E("div", {
                  staticClass: "el-slider__button",
                  class: { hover: b.hovering, dragging: b.dragging }
                })
              ]
            )
          ],
          1
        );
      }, u = [];
      l._withStripped = !0;
      var c = r(29), f = /* @__PURE__ */ r.n(c), p = {
        name: "ElSliderButton",
        components: {
          ElTooltip: f.a
        },
        props: {
          value: {
            type: Number,
            default: 0
          },
          vertical: {
            type: Boolean,
            default: !1
          },
          tooltipClass: String
        },
        data: function() {
          return {
            hovering: !1,
            dragging: !1,
            isClick: !1,
            startX: 0,
            currentX: 0,
            startY: 0,
            currentY: 0,
            startPosition: 0,
            newPosition: null,
            oldValue: this.value
          };
        },
        computed: {
          disabled: function() {
            return this.$parent.sliderDisabled;
          },
          max: function() {
            return this.$parent.max;
          },
          min: function() {
            return this.$parent.min;
          },
          step: function() {
            return this.$parent.step;
          },
          showTooltip: function() {
            return this.$parent.showTooltip;
          },
          precision: function() {
            return this.$parent.precision;
          },
          currentPosition: function() {
            return (this.value - this.min) / (this.max - this.min) * 100 + "%";
          },
          enableFormat: function() {
            return this.$parent.formatTooltip instanceof Function;
          },
          formatValue: function() {
            return this.enableFormat && this.$parent.formatTooltip(this.value) || this.value;
          },
          wrapperStyle: function() {
            return this.vertical ? { bottom: this.currentPosition } : { left: this.currentPosition };
          }
        },
        watch: {
          dragging: function(x) {
            this.$parent.dragging = x;
          }
        },
        methods: {
          displayTooltip: function() {
            this.$refs.tooltip && (this.$refs.tooltip.showPopper = !0);
          },
          hideTooltip: function() {
            this.$refs.tooltip && (this.$refs.tooltip.showPopper = !1);
          },
          handleMouseEnter: function() {
            this.hovering = !0, this.displayTooltip();
          },
          handleMouseLeave: function() {
            this.hovering = !1, this.hideTooltip();
          },
          onButtonDown: function(x) {
            this.disabled || (x.preventDefault(), this.onDragStart(x), window.addEventListener("mousemove", this.onDragging), window.addEventListener("touchmove", this.onDragging), window.addEventListener("mouseup", this.onDragEnd), window.addEventListener("touchend", this.onDragEnd), window.addEventListener("contextmenu", this.onDragEnd));
          },
          onLeftKeyDown: function() {
            this.disabled || (this.newPosition = parseFloat(this.currentPosition) - this.step / (this.max - this.min) * 100, this.setPosition(this.newPosition), this.$parent.emitChange());
          },
          onRightKeyDown: function() {
            this.disabled || (this.newPosition = parseFloat(this.currentPosition) + this.step / (this.max - this.min) * 100, this.setPosition(this.newPosition), this.$parent.emitChange());
          },
          onDragStart: function(x) {
            this.dragging = !0, this.isClick = !0, x.type === "touchstart" && (x.clientY = x.touches[0].clientY, x.clientX = x.touches[0].clientX), this.vertical ? this.startY = x.clientY : this.startX = x.clientX, this.startPosition = parseFloat(this.currentPosition), this.newPosition = this.startPosition;
          },
          onDragging: function(x) {
            if (this.dragging) {
              this.isClick = !1, this.displayTooltip(), this.$parent.resetSize();
              var E = 0;
              x.type === "touchmove" && (x.clientY = x.touches[0].clientY, x.clientX = x.touches[0].clientX), this.vertical ? (this.currentY = x.clientY, E = (this.startY - this.currentY) / this.$parent.sliderSize * 100) : (this.currentX = x.clientX, E = (this.currentX - this.startX) / this.$parent.sliderSize * 100), this.newPosition = this.startPosition + E, this.setPosition(this.newPosition);
            }
          },
          onDragEnd: function() {
            var x = this;
            this.dragging && (setTimeout(function() {
              x.dragging = !1, x.hideTooltip(), x.isClick || (x.setPosition(x.newPosition), x.$parent.emitChange());
            }, 0), window.removeEventListener("mousemove", this.onDragging), window.removeEventListener("touchmove", this.onDragging), window.removeEventListener("mouseup", this.onDragEnd), window.removeEventListener("touchend", this.onDragEnd), window.removeEventListener("contextmenu", this.onDragEnd));
          },
          setPosition: function(x) {
            var E = this;
            if (!(x === null || isNaN(x))) {
              x < 0 ? x = 0 : x > 100 && (x = 100);
              var M = 100 / ((this.max - this.min) / this.step), $ = Math.round(x / M), F = $ * M * (this.max - this.min) * 0.01 + this.min;
              F = parseFloat(F.toFixed(this.precision)), this.$emit("input", F), this.$nextTick(function() {
                E.displayTooltip(), E.$refs.tooltip && E.$refs.tooltip.updatePopper();
              }), !this.dragging && this.value !== this.oldValue && (this.oldValue = this.value);
            }
          }
        }
      }, d = p, h = r(0), v = Object(h.a)(
        d,
        l,
        u,
        !1,
        null,
        null,
        null
      );
      v.options.__file = "packages/slider/src/button.vue";
      var g = v.exports, m = {
        name: "ElMarker",
        props: {
          mark: {
            type: [String, Object]
          }
        },
        render: function() {
          var x = arguments[0], E = typeof this.mark == "string" ? this.mark : this.mark.label;
          return x(
            "div",
            { class: "el-slider__marks-text", style: this.mark.style || {} },
            [E]
          );
        }
      }, _ = r(4), y = /* @__PURE__ */ r.n(_), w = {
        name: "ElSlider",
        mixins: [y.a],
        inject: {
          elForm: {
            default: ""
          }
        },
        props: {
          min: {
            type: Number,
            default: 0
          },
          max: {
            type: Number,
            default: 100
          },
          step: {
            type: Number,
            default: 1
          },
          value: {
            type: [Number, Array],
            default: 0
          },
          showInput: {
            type: Boolean,
            default: !1
          },
          showInputControls: {
            type: Boolean,
            default: !0
          },
          inputSize: {
            type: String,
            default: "small"
          },
          showStops: {
            type: Boolean,
            default: !1
          },
          showTooltip: {
            type: Boolean,
            default: !0
          },
          formatTooltip: Function,
          disabled: {
            type: Boolean,
            default: !1
          },
          range: {
            type: Boolean,
            default: !1
          },
          vertical: {
            type: Boolean,
            default: !1
          },
          height: {
            type: String
          },
          debounce: {
            type: Number,
            default: 300
          },
          label: {
            type: String
          },
          tooltipClass: String,
          marks: Object
        },
        components: {
          ElInputNumber: a.a,
          SliderButton: g,
          SliderMarker: m
        },
        data: function() {
          return {
            firstValue: null,
            secondValue: null,
            oldValue: null,
            dragging: !1,
            sliderSize: 1
          };
        },
        watch: {
          value: function(x, E) {
            this.dragging || Array.isArray(x) && Array.isArray(E) && x.every(function(M, $) {
              return M === E[$];
            }) || this.setValues();
          },
          dragging: function(x) {
            x || this.setValues();
          },
          firstValue: function(x) {
            this.range ? this.$emit("input", [this.minValue, this.maxValue]) : this.$emit("input", x);
          },
          secondValue: function() {
            this.range && this.$emit("input", [this.minValue, this.maxValue]);
          },
          min: function() {
            this.setValues();
          },
          max: function() {
            this.setValues();
          }
        },
        methods: {
          valueChanged: function() {
            var x = this;
            return this.range ? ![this.minValue, this.maxValue].every(function(E, M) {
              return E === x.oldValue[M];
            }) : this.value !== this.oldValue;
          },
          setValues: function() {
            if (this.min > this.max) {
              console.error("[Element Error][Slider]min should not be greater than max.");
              return;
            }
            var x = this.value;
            this.range && Array.isArray(x) ? x[1] < this.min ? this.$emit("input", [this.min, this.min]) : x[0] > this.max ? this.$emit("input", [this.max, this.max]) : x[0] < this.min ? this.$emit("input", [this.min, x[1]]) : x[1] > this.max ? this.$emit("input", [x[0], this.max]) : (this.firstValue = x[0], this.secondValue = x[1], this.valueChanged() && (this.dispatch("ElFormItem", "el.form.change", [this.minValue, this.maxValue]), this.oldValue = x.slice())) : !this.range && typeof x == "number" && !isNaN(x) && (x < this.min ? this.$emit("input", this.min) : x > this.max ? this.$emit("input", this.max) : (this.firstValue = x, this.valueChanged() && (this.dispatch("ElFormItem", "el.form.change", x), this.oldValue = x)));
          },
          setPosition: function(x) {
            var E = this.min + x * (this.max - this.min) / 100;
            if (!this.range) {
              this.$refs.button1.setPosition(x);
              return;
            }
            var M = void 0;
            Math.abs(this.minValue - E) < Math.abs(this.maxValue - E) ? M = this.firstValue < this.secondValue ? "button1" : "button2" : M = this.firstValue > this.secondValue ? "button1" : "button2", this.$refs[M].setPosition(x);
          },
          onSliderClick: function(x) {
            if (!(this.sliderDisabled || this.dragging)) {
              if (this.resetSize(), this.vertical) {
                var E = this.$refs.slider.getBoundingClientRect().bottom;
                this.setPosition((E - x.clientY) / this.sliderSize * 100);
              } else {
                var M = this.$refs.slider.getBoundingClientRect().left;
                this.setPosition((x.clientX - M) / this.sliderSize * 100);
              }
              this.emitChange();
            }
          },
          resetSize: function() {
            this.$refs.slider && (this.sliderSize = this.$refs.slider["client" + (this.vertical ? "Height" : "Width")]);
          },
          emitChange: function() {
            var x = this;
            this.$nextTick(function() {
              x.$emit("change", x.range ? [x.minValue, x.maxValue] : x.value);
            });
          },
          getStopStyle: function(x) {
            return this.vertical ? { bottom: x + "%" } : { left: x + "%" };
          }
        },
        computed: {
          stops: function() {
            var x = this;
            if (!this.showStops || this.min > this.max)
              return [];
            if (this.step === 0)
              return [];
            for (var E = (this.max - this.min) / this.step, M = 100 * this.step / (this.max - this.min), $ = [], F = 1; F < E; F++)
              $.push(F * M);
            return this.range ? $.filter(function(J) {
              return J < 100 * (x.minValue - x.min) / (x.max - x.min) || J > 100 * (x.maxValue - x.min) / (x.max - x.min);
            }) : $.filter(function(J) {
              return J > 100 * (x.firstValue - x.min) / (x.max - x.min);
            });
          },
          markList: function() {
            var x = this;
            if (!this.marks)
              return [];
            var E = Object.keys(this.marks);
            return E.map(parseFloat).sort(function(M, $) {
              return M - $;
            }).filter(function(M) {
              return M <= x.max && M >= x.min;
            }).map(function(M) {
              return {
                point: M,
                position: (M - x.min) * 100 / (x.max - x.min),
                mark: x.marks[M]
              };
            });
          },
          minValue: function() {
            return Math.min(this.firstValue, this.secondValue);
          },
          maxValue: function() {
            return Math.max(this.firstValue, this.secondValue);
          },
          barSize: function() {
            return this.range ? 100 * (this.maxValue - this.minValue) / (this.max - this.min) + "%" : 100 * (this.firstValue - this.min) / (this.max - this.min) + "%";
          },
          barStart: function() {
            return this.range ? 100 * (this.minValue - this.min) / (this.max - this.min) + "%" : "0%";
          },
          precision: function() {
            var x = [this.min, this.max, this.step].map(function(E) {
              var M = ("" + E).split(".")[1];
              return M ? M.length : 0;
            });
            return Math.max.apply(null, x);
          },
          runwayStyle: function() {
            return this.vertical ? { height: this.height } : {};
          },
          barStyle: function() {
            return this.vertical ? {
              height: this.barSize,
              bottom: this.barStart
            } : {
              width: this.barSize,
              left: this.barStart
            };
          },
          sliderDisabled: function() {
            return this.disabled || (this.elForm || {}).disabled;
          }
        },
        mounted: function() {
          var x = void 0;
          this.range ? (Array.isArray(this.value) ? (this.firstValue = Math.max(this.min, this.value[0]), this.secondValue = Math.min(this.max, this.value[1])) : (this.firstValue = this.min, this.secondValue = this.max), this.oldValue = [this.firstValue, this.secondValue], x = this.firstValue + "-" + this.secondValue) : (typeof this.value != "number" || isNaN(this.value) ? this.firstValue = this.min : this.firstValue = Math.min(this.max, Math.max(this.min, this.value)), this.oldValue = this.firstValue, x = this.firstValue), this.$el.setAttribute("aria-valuetext", x), this.$el.setAttribute("aria-label", this.label ? this.label : "slider between " + this.min + " and " + this.max), this.resetSize(), window.addEventListener("resize", this.resetSize);
        },
        beforeDestroy: function() {
          window.removeEventListener("resize", this.resetSize);
        }
      }, O = w, C = Object(h.a)(
        O,
        i,
        s,
        !1,
        null,
        null,
        null
      );
      C.options.__file = "packages/slider/src/main.vue";
      var S = C.exports;
      S.install = function(b) {
        b.component(S.name, S);
      }, t.default = S;
    }
  });
})(Kb);
const zP = /* @__PURE__ */ ot(Kb.exports), BP = st({
  components: { ElButton: Rf, ElDialog: Kr, ElColorPicker: RP, ElSlider: zP, ElCheckbox: IP },
  setup() {
    const n = ct(!1), e = $e("editor"), t = oy({
      color: "rgb(19, 206, 102)",
      padding: 10,
      borderRadius: 10,
      borderColor: "rgb(0, 0, 0)",
      borderWidth: 4,
      isBorderLeft: !1
    }), r = ve(() => {
      const { padding: s, isBorderLeft: o, borderColor: a, borderWidth: l, borderRadius: u, color: c } = t, f = o ? `border-left: ${l}px solid ${a};` : "";
      return `
      padding: ${s}px;
      ${f}
      border-radius: ${u}px;
      background-color: ${c};
      `;
    });
    return { visible: n, highlightConfig: t, setCustomHighlightStyle: () => {
      e.value.chain().focus().toggleCustomHighlight({ class: "t-highlight", style: r.value }).run(), n.value = !1;
    }, highlightStyle: r };
  }
});
var jP = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", [t("div", { on: { click: function(r) {
    e.visible = !0;
  } } }, [e._v("Custom")]), t("el-dialog", { attrs: { visible: e.visible, "append-to-body": "", width: "1000px" }, on: { "update:visible": function(r) {
    e.visible = r;
  } }, scopedSlots: e._u([{ key: "title", fn: function() {
    return [t("h4", [e._v("Custom Highlight")])];
  }, proxy: !0 }, { key: "footer", fn: function() {
    return [t("span", { staticClass: "dialog-footer" }, [t("el-button", { on: { click: function(r) {
      e.visible = !1;
    } } }, [e._v("Cancel")]), t("el-button", { attrs: { type: "primary" }, on: { click: e.setCustomHighlightStyle } }, [e._v("Confirm")])], 1)];
  }, proxy: !0 }]) }, [t("div", { staticClass: "flex space-x-4", staticStyle: { height: "290px" } }, [t("div", { staticClass: "flex-1" }, [t("div", [t("div", { staticClass: "mb-2 font-bold" }, [e._v("Color")]), t("el-color-picker", { model: { value: e.highlightConfig.color, callback: function(r) {
    e.$set(e.highlightConfig, "color", r);
  }, expression: "highlightConfig.color" } })], 1), t("div", [t("div", { staticClass: "font-bold" }, [e._v("Padding (" + e._s(e.highlightConfig.padding) + ")")]), t("el-slider", { attrs: { max: 30 }, model: { value: e.highlightConfig.padding, callback: function(r) {
    e.$set(e.highlightConfig, "padding", r);
  }, expression: "highlightConfig.padding" } })], 1), t("div", [t("div", { staticClass: "font-bold" }, [e._v("Border radius (" + e._s(e.highlightConfig.borderRadius) + ")")]), t("el-slider", { attrs: { max: 30 }, model: { value: e.highlightConfig.borderRadius, callback: function(r) {
    e.$set(e.highlightConfig, "borderRadius", r);
  }, expression: "highlightConfig.borderRadius" } })], 1), t("div", [t("el-checkbox", { model: { value: e.highlightConfig.isBorderLeft, callback: function(r) {
    e.$set(e.highlightConfig, "isBorderLeft", r);
  }, expression: "highlightConfig.isBorderLeft" } }, [t("div", { staticClass: "font-bold" }, [e._v("Border left")])]), e.highlightConfig.isBorderLeft ? t("div", { staticClass: "mt-2 flex space-x-4" }, [t("el-color-picker", { model: { value: e.highlightConfig.borderColor, callback: function(r) {
    e.$set(e.highlightConfig, "borderColor", r);
  }, expression: "highlightConfig.borderColor" } }), t("el-slider", { staticClass: "flex-1", attrs: { max: 30 }, model: { value: e.highlightConfig.borderWidth, callback: function(r) {
    e.$set(e.highlightConfig, "borderWidth", r);
  }, expression: "highlightConfig.borderWidth" } })], 1) : e._e()], 1)]), t("div", { staticClass: "flex-1" }, [t("div", { staticClass: "custom-highlight-preview", style: e.highlightStyle }, [e._v(" Lorem ipsum dolor sit amet, consectetur adipisicing elit. Magni quam sint ad aliquid nobis animi sunt omnis optio vel. Quae hic laudantium ex repudiandae alias corporis modi repellendus quis laboriosam! ")])])])])], 1);
}, VP = [], HP = /* @__PURE__ */ le(
  BP,
  jP,
  VP,
  !1,
  null,
  null,
  null,
  null
);
const WP = HP.exports;
const qP = st({
  name: "HighlightCommand",
  components: { ButtonCommand: yt, ElDropdown: Ff, ElDropdownMenu: zf, ElDropdownItem: Bf, DropdownItemHighlight: WP },
  setup() {
    const n = $e("editor"), e = [
      {
        type: "Success",
        customClass: "t-highlight t-highlight-success",
        action: () => n.value.chain().focus().toggleCustomHighlight({ class: "t-highlight t-highlight-success" }).run()
      },
      {
        type: "Warning",
        customClass: "t-highlight t-highlight-warning",
        action: () => n.value.chain().focus().toggleCustomHighlight({ class: "t-highlight t-highlight-warning" }).run()
      },
      {
        type: "Custom",
        customClass: "t-highlight"
      }
    ];
    return { editor: n, HIGHLIGHT_ITEMS: e, handleSetHighlight: (i) => e.find((s) => s.type === i).action(), getIsActive: (i) => n.value.isActive({ class: i }) };
  }
});
var UP = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("el-dropdown", { attrs: { trigger: "click" }, on: { command: e.handleSetHighlight } }, [t("button-command", { attrs: { icon: "markup-line", title: "Highlight" } }), t("el-dropdown-menu", { attrs: { slot: "dropdown" }, slot: "dropdown" }, e._l(e.HIGHLIGHT_ITEMS, function(r) {
    return t("el-dropdown-item", { key: r.type, class: { "is-active": e.getIsActive(r.customClass) }, attrs: { command: r.type } }, [r.type !== "Custom" ? t("div", [e._v(e._s(r.type))]) : t("dropdown-item-highlight")], 1);
  }), 1)], 1);
}, GP = [], KP = /* @__PURE__ */ le(
  qP,
  UP,
  GP,
  !1,
  null,
  "685bac2d",
  null,
  null
);
const JP = KP.exports, XP = st({
  name: "MenuBar",
  components: {
    ButtonCommand: yt,
    FontSizeCommand: $y,
    ImageCommand: uC,
    ImageAlbumCommand: Zk,
    ImageComparisonCommand: vM,
    VideoCommand: SM,
    LinkCommand: TM,
    RichLinkCommand: IM,
    CollapseCommand: _A,
    SkuCommand: NP,
    HighlightCommand: JP
  },
  props: {
    menuSettings: {
      type: Array,
      default: () => kl
    }
  },
  setup(n) {
    const e = $e("editor"), t = je(() => e != null && e.value ? [
      {
        icon: "bold",
        title: "Bold",
        isActive: e.value.isActive("bold"),
        action: () => e.value.chain().focus().toggleBold().run(),
        group: 1
      },
      {
        icon: "italic",
        title: "Italic",
        isActive: e.value.isActive("italic"),
        action: () => e.value.chain().focus().toggleItalic().run(),
        group: 1
      },
      {
        icon: "strikethrough",
        title: "Strike",
        isActive: e.value.isActive("strike"),
        action: () => e.value.chain().focus().toggleStrike().run(),
        group: 1
      },
      {
        icon: "underline",
        title: "Underline",
        isActive: e.value.isActive("underline"),
        action: () => e.value.chain().focus().toggleUnderline().run(),
        group: 1
      },
      {
        icon: "h-1",
        title: "Heading 1",
        isActive: e.value.isActive("heading", { level: 1 }),
        action: () => e.value.chain().focus().toggleHeading({ level: 1 }).run(),
        group: 2
      },
      {
        icon: "h-2",
        title: "Heading 2",
        isActive: e.value.isActive("heading", { level: 2 }),
        action: () => e.value.chain().focus().toggleHeading({ level: 2 }).run(),
        group: 2
      },
      {
        icon: "h-3",
        title: "Heading 3",
        isActive: e.value.isActive("heading", { level: 3 }),
        action: () => e.value.chain().focus().toggleHeading({ level: 3 }).run(),
        group: 2
      },
      {
        icon: "paragraph",
        title: "Paragraph",
        isActive: e.value.isActive("paragraph"),
        action: () => e.value.chain().focus().setParagraph().run(),
        group: 2
      },
      { title: "Font size", component: "font-size-command", group: 2 },
      {
        icon: "align-left",
        title: "Text Left",
        isActive: e.value.isActive({ textAlign: "left" }),
        action: () => e.value.chain().focus().setTextAlign("left").run(),
        group: 3
      },
      {
        icon: "align-center",
        title: "Text Center",
        isActive: e.value.isActive({ textAlign: "center" }),
        action: () => e.value.chain().focus().setTextAlign("center").run(),
        group: 3
      },
      {
        icon: "align-right",
        title: "Text Right",
        isActive: e.value.isActive({ textAlign: "right" }),
        action: () => e.value.chain().focus().setTextAlign("right").run(),
        group: 3
      },
      {
        icon: "align-justify",
        title: "Text justify",
        isActive: e.value.isActive({ textAlign: "justify" }),
        action: () => e.value.chain().focus().setTextAlign("justify").run(),
        group: 3
      },
      {
        icon: "list-unordered",
        title: "Bullet List",
        isActive: e.value.isActive("bulletList"),
        action: () => e.value.chain().focus().toggleBulletList().run(),
        group: 4
      },
      {
        icon: "list-ordered",
        title: "Ordered List",
        isActive: e.value.isActive("orderedList"),
        action: () => e.value.chain().focus().toggleOrderedList().run(),
        group: 4
      },
      { title: "Image", component: "image-command", group: 5 },
      { title: "Image album", component: "image-album-command", group: 5 },
      { title: "Image comparison", component: "image-comparison-command", group: 5 },
      { title: "Video", component: "video-command", group: 6 },
      { title: "Link", component: "link-command", group: 6 },
      { title: "Rich Link", component: "rich-link-command", group: 6 },
      { title: "Collapse", component: "collapse-command", group: 6 },
      { title: "Sku", component: "sku-command", group: 7 },
      {
        icon: "double-quotes-l",
        title: "Blockquote",
        isActive: e.value.isActive("blockquote"),
        action: () => e.value.chain().focus().toggleBlockquote().run(),
        group: 8
      },
      { title: "Highlight", component: "highlight-command", group: 8 },
      {
        icon: "separator",
        title: "Horizontal Rule",
        action: () => e.value.chain().focus().setHorizontalRule().run(),
        group: 8
      },
      {
        icon: "code-box-line",
        title: "Code Block",
        isActive: e.value.isActive("codeBlock"),
        action: () => e.value.chain().focus().toggleCodeBlock().run(),
        group: 8
      },
      {
        icon: "code-view",
        title: "Code",
        isActive: e.value.isActive("code"),
        action: () => e.value.chain().focus().toggleCode().run(),
        group: 8
      },
      {
        icon: "text-wrap",
        title: "Hard Break",
        action: () => e.value.chain().focus().setHardBreak().run(),
        group: 9
      },
      {
        icon: "format-clear",
        title: "Clear Format",
        action: () => e.value.chain().focus().clearNodes().unsetAllMarks().run(),
        group: 9
      },
      {
        icon: "arrow-go-back-line",
        title: "Undo",
        action: () => e.value.chain().focus().undo().run(),
        group: 10
      },
      {
        icon: "arrow-go-forward-line",
        title: "Redo",
        action: () => e.value.chain().focus().redo().run(),
        group: 10
      }
    ] : []), r = je(() => {
      if (!n.menuSettings)
        return [];
      const i = n.menuSettings.map((a) => a.toLocaleLowerCase()), s = t.value.filter((a) => {
        var l;
        if (!!a.title)
          return i.includes((l = a.title) == null ? void 0 : l.toLocaleLowerCase());
      });
      return s.sort((a, l) => a.group - l.group), s.reduce((a, l, u) => (u > 0 && l.group !== s[u - 1].group && a.push({ type: "divider" }), a.push(l), a), []);
    });
    return { items: t, includeMenuSettings: r };
  }
});
var YP = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "menu-bar" }, e._l(e.includeMenuSettings, function(r, i) {
    return t("div", { key: i }, [r.type === "divider" ? t("div", { staticClass: "divider" }) : r.component ? t(r.component, e._b({ tag: "component", attrs: { "menu-settings": e.menuSettings } }, "component", r, !1)) : t("button-command", { attrs: { icon: r.icon, "is-active": r.isActive, title: r.title }, on: { click: function(s) {
      r.action && r.action();
    } } })], 1);
  }), 0);
}, QP = [], ZP = /* @__PURE__ */ le(
  XP,
  YP,
  QP,
  !1,
  null,
  null,
  null,
  null
);
const e$ = ZP.exports;
function Xe(n) {
  this.content = n;
}
Xe.prototype = {
  constructor: Xe,
  find: function(n) {
    for (var e = 0; e < this.content.length; e += 2)
      if (this.content[e] === n)
        return e;
    return -1;
  },
  get: function(n) {
    var e = this.find(n);
    return e == -1 ? void 0 : this.content[e + 1];
  },
  update: function(n, e, t) {
    var r = t && t != n ? this.remove(t) : this, i = r.find(n), s = r.content.slice();
    return i == -1 ? s.push(t || n, e) : (s[i + 1] = e, t && (s[i] = t)), new Xe(s);
  },
  remove: function(n) {
    var e = this.find(n);
    if (e == -1)
      return this;
    var t = this.content.slice();
    return t.splice(e, 2), new Xe(t);
  },
  addToStart: function(n, e) {
    return new Xe([n, e].concat(this.remove(n).content));
  },
  addToEnd: function(n, e) {
    var t = this.remove(n).content.slice();
    return t.push(n, e), new Xe(t);
  },
  addBefore: function(n, e, t) {
    var r = this.remove(e), i = r.content.slice(), s = r.find(n);
    return i.splice(s == -1 ? i.length : s, 0, e, t), new Xe(i);
  },
  forEach: function(n) {
    for (var e = 0; e < this.content.length; e += 2)
      n(this.content[e], this.content[e + 1]);
  },
  prepend: function(n) {
    return n = Xe.from(n), n.size ? new Xe(n.content.concat(this.subtract(n).content)) : this;
  },
  append: function(n) {
    return n = Xe.from(n), n.size ? new Xe(this.subtract(n).content.concat(n.content)) : this;
  },
  subtract: function(n) {
    var e = this;
    n = Xe.from(n);
    for (var t = 0; t < n.content.length; t += 2)
      e = e.remove(n.content[t]);
    return e;
  },
  toObject: function() {
    var n = {};
    return this.forEach(function(e, t) {
      n[e] = t;
    }), n;
  },
  get size() {
    return this.content.length >> 1;
  }
};
Xe.from = function(n) {
  if (n instanceof Xe)
    return n;
  var e = [];
  if (n)
    for (var t in n)
      e.push(t, n[t]);
  return new Xe(e);
};
function Jb(n, e, t) {
  for (let r = 0; ; r++) {
    if (r == n.childCount || r == e.childCount)
      return n.childCount == e.childCount ? null : t;
    let i = n.child(r), s = e.child(r);
    if (i == s) {
      t += i.nodeSize;
      continue;
    }
    if (!i.sameMarkup(s))
      return t;
    if (i.isText && i.text != s.text) {
      for (let o = 0; i.text[o] == s.text[o]; o++)
        t++;
      return t;
    }
    if (i.content.size || s.content.size) {
      let o = Jb(i.content, s.content, t + 1);
      if (o != null)
        return o;
    }
    t += i.nodeSize;
  }
}
function Xb(n, e, t, r) {
  for (let i = n.childCount, s = e.childCount; ; ) {
    if (i == 0 || s == 0)
      return i == s ? null : { a: t, b: r };
    let o = n.child(--i), a = e.child(--s), l = o.nodeSize;
    if (o == a) {
      t -= l, r -= l;
      continue;
    }
    if (!o.sameMarkup(a))
      return { a: t, b: r };
    if (o.isText && o.text != a.text) {
      let u = 0, c = Math.min(o.text.length, a.text.length);
      for (; u < c && o.text[o.text.length - u - 1] == a.text[a.text.length - u - 1]; )
        u++, t--, r--;
      return { a: t, b: r };
    }
    if (o.content.size || a.content.size) {
      let u = Xb(o.content, a.content, t - 1, r - 1);
      if (u)
        return u;
    }
    t -= l, r -= l;
  }
}
class V {
  constructor(e, t) {
    if (this.content = e, this.size = t || 0, t == null)
      for (let r = 0; r < e.length; r++)
        this.size += e[r].nodeSize;
  }
  nodesBetween(e, t, r, i = 0, s) {
    for (let o = 0, a = 0; a < t; o++) {
      let l = this.content[o], u = a + l.nodeSize;
      if (u > e && r(l, i + a, s || null, o) !== !1 && l.content.size) {
        let c = a + 1;
        l.nodesBetween(Math.max(0, e - c), Math.min(l.content.size, t - c), r, i + c);
      }
      a = u;
    }
  }
  descendants(e) {
    this.nodesBetween(0, this.size, e);
  }
  textBetween(e, t, r, i) {
    let s = "", o = !0;
    return this.nodesBetween(e, t, (a, l) => {
      let u = a.isText ? a.text.slice(Math.max(e, l) - l, t - l) : a.isLeaf ? i ? typeof i == "function" ? i(a) : i : a.type.spec.leafText ? a.type.spec.leafText(a) : "" : "";
      a.isBlock && (a.isLeaf && u || a.isTextblock) && r && (o ? o = !1 : s += r), s += u;
    }, 0), s;
  }
  append(e) {
    if (!e.size)
      return this;
    if (!this.size)
      return e;
    let t = this.lastChild, r = e.firstChild, i = this.content.slice(), s = 0;
    for (t.isText && t.sameMarkup(r) && (i[i.length - 1] = t.withText(t.text + r.text), s = 1); s < e.content.length; s++)
      i.push(e.content[s]);
    return new V(i, this.size + e.size);
  }
  cut(e, t = this.size) {
    if (e == 0 && t == this.size)
      return this;
    let r = [], i = 0;
    if (t > e)
      for (let s = 0, o = 0; o < t; s++) {
        let a = this.content[s], l = o + a.nodeSize;
        l > e && ((o < e || l > t) && (a.isText ? a = a.cut(Math.max(0, e - o), Math.min(a.text.length, t - o)) : a = a.cut(Math.max(0, e - o - 1), Math.min(a.content.size, t - o - 1))), r.push(a), i += a.nodeSize), o = l;
      }
    return new V(r, i);
  }
  cutByIndex(e, t) {
    return e == t ? V.empty : e == 0 && t == this.content.length ? this : new V(this.content.slice(e, t));
  }
  replaceChild(e, t) {
    let r = this.content[e];
    if (r == t)
      return this;
    let i = this.content.slice(), s = this.size + t.nodeSize - r.nodeSize;
    return i[e] = t, new V(i, s);
  }
  addToStart(e) {
    return new V([e].concat(this.content), this.size + e.nodeSize);
  }
  addToEnd(e) {
    return new V(this.content.concat(e), this.size + e.nodeSize);
  }
  eq(e) {
    if (this.content.length != e.content.length)
      return !1;
    for (let t = 0; t < this.content.length; t++)
      if (!this.content[t].eq(e.content[t]))
        return !1;
    return !0;
  }
  get firstChild() {
    return this.content.length ? this.content[0] : null;
  }
  get lastChild() {
    return this.content.length ? this.content[this.content.length - 1] : null;
  }
  get childCount() {
    return this.content.length;
  }
  child(e) {
    let t = this.content[e];
    if (!t)
      throw new RangeError("Index " + e + " out of range for " + this);
    return t;
  }
  maybeChild(e) {
    return this.content[e] || null;
  }
  forEach(e) {
    for (let t = 0, r = 0; t < this.content.length; t++) {
      let i = this.content[t];
      e(i, r, t), r += i.nodeSize;
    }
  }
  findDiffStart(e, t = 0) {
    return Jb(this, e, t);
  }
  findDiffEnd(e, t = this.size, r = e.size) {
    return Xb(this, e, t, r);
  }
  findIndex(e, t = -1) {
    if (e == 0)
      return Mo(0, e);
    if (e == this.size)
      return Mo(this.content.length, e);
    if (e > this.size || e < 0)
      throw new RangeError(`Position ${e} outside of fragment (${this})`);
    for (let r = 0, i = 0; ; r++) {
      let s = this.child(r), o = i + s.nodeSize;
      if (o >= e)
        return o == e || t > 0 ? Mo(r + 1, o) : Mo(r, i);
      i = o;
    }
  }
  toString() {
    return "<" + this.toStringInner() + ">";
  }
  toStringInner() {
    return this.content.join(", ");
  }
  toJSON() {
    return this.content.length ? this.content.map((e) => e.toJSON()) : null;
  }
  static fromJSON(e, t) {
    if (!t)
      return V.empty;
    if (!Array.isArray(t))
      throw new RangeError("Invalid input for Fragment.fromJSON");
    return new V(t.map(e.nodeFromJSON));
  }
  static fromArray(e) {
    if (!e.length)
      return V.empty;
    let t, r = 0;
    for (let i = 0; i < e.length; i++) {
      let s = e[i];
      r += s.nodeSize, i && s.isText && e[i - 1].sameMarkup(s) ? (t || (t = e.slice(0, i)), t[t.length - 1] = s.withText(t[t.length - 1].text + s.text)) : t && t.push(s);
    }
    return new V(t || e, r);
  }
  static from(e) {
    if (!e)
      return V.empty;
    if (e instanceof V)
      return e;
    if (Array.isArray(e))
      return this.fromArray(e);
    if (e.attrs)
      return new V([e], e.nodeSize);
    throw new RangeError("Can not convert " + e + " to a Fragment" + (e.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
  }
}
V.empty = new V([], 0);
const Oc = { index: 0, offset: 0 };
function Mo(n, e) {
  return Oc.index = n, Oc.offset = e, Oc;
}
function Ca(n, e) {
  if (n === e)
    return !0;
  if (!(n && typeof n == "object") || !(e && typeof e == "object"))
    return !1;
  let t = Array.isArray(n);
  if (Array.isArray(e) != t)
    return !1;
  if (t) {
    if (n.length != e.length)
      return !1;
    for (let r = 0; r < n.length; r++)
      if (!Ca(n[r], e[r]))
        return !1;
  } else {
    for (let r in n)
      if (!(r in e) || !Ca(n[r], e[r]))
        return !1;
    for (let r in e)
      if (!(r in n))
        return !1;
  }
  return !0;
}
class Se {
  constructor(e, t) {
    this.type = e, this.attrs = t;
  }
  addToSet(e) {
    let t, r = !1;
    for (let i = 0; i < e.length; i++) {
      let s = e[i];
      if (this.eq(s))
        return e;
      if (this.type.excludes(s.type))
        t || (t = e.slice(0, i));
      else {
        if (s.type.excludes(this.type))
          return e;
        !r && s.type.rank > this.type.rank && (t || (t = e.slice(0, i)), t.push(this), r = !0), t && t.push(s);
      }
    }
    return t || (t = e.slice()), r || t.push(this), t;
  }
  removeFromSet(e) {
    for (let t = 0; t < e.length; t++)
      if (this.eq(e[t]))
        return e.slice(0, t).concat(e.slice(t + 1));
    return e;
  }
  isInSet(e) {
    for (let t = 0; t < e.length; t++)
      if (this.eq(e[t]))
        return !0;
    return !1;
  }
  eq(e) {
    return this == e || this.type == e.type && Ca(this.attrs, e.attrs);
  }
  toJSON() {
    let e = { type: this.type.name };
    for (let t in this.attrs) {
      e.attrs = this.attrs;
      break;
    }
    return e;
  }
  static fromJSON(e, t) {
    if (!t)
      throw new RangeError("Invalid input for Mark.fromJSON");
    let r = e.marks[t.type];
    if (!r)
      throw new RangeError(`There is no mark type ${t.type} in this schema`);
    return r.create(t.attrs);
  }
  static sameSet(e, t) {
    if (e == t)
      return !0;
    if (e.length != t.length)
      return !1;
    for (let r = 0; r < e.length; r++)
      if (!e[r].eq(t[r]))
        return !1;
    return !0;
  }
  static setFrom(e) {
    if (!e || Array.isArray(e) && e.length == 0)
      return Se.none;
    if (e instanceof Se)
      return [e];
    let t = e.slice();
    return t.sort((r, i) => r.type.rank - i.type.rank), t;
  }
}
Se.none = [];
class Oa extends Error {
}
class X {
  constructor(e, t, r) {
    this.content = e, this.openStart = t, this.openEnd = r;
  }
  get size() {
    return this.content.size - this.openStart - this.openEnd;
  }
  insertAt(e, t) {
    let r = Qb(this.content, e + this.openStart, t);
    return r && new X(r, this.openStart, this.openEnd);
  }
  removeBetween(e, t) {
    return new X(Yb(this.content, e + this.openStart, t + this.openStart), this.openStart, this.openEnd);
  }
  eq(e) {
    return this.content.eq(e.content) && this.openStart == e.openStart && this.openEnd == e.openEnd;
  }
  toString() {
    return this.content + "(" + this.openStart + "," + this.openEnd + ")";
  }
  toJSON() {
    if (!this.content.size)
      return null;
    let e = { content: this.content.toJSON() };
    return this.openStart > 0 && (e.openStart = this.openStart), this.openEnd > 0 && (e.openEnd = this.openEnd), e;
  }
  static fromJSON(e, t) {
    if (!t)
      return X.empty;
    let r = t.openStart || 0, i = t.openEnd || 0;
    if (typeof r != "number" || typeof i != "number")
      throw new RangeError("Invalid input for Slice.fromJSON");
    return new X(V.fromJSON(e, t.content), r, i);
  }
  static maxOpen(e, t = !0) {
    let r = 0, i = 0;
    for (let s = e.firstChild; s && !s.isLeaf && (t || !s.type.spec.isolating); s = s.firstChild)
      r++;
    for (let s = e.lastChild; s && !s.isLeaf && (t || !s.type.spec.isolating); s = s.lastChild)
      i++;
    return new X(e, r, i);
  }
}
X.empty = new X(V.empty, 0, 0);
function Yb(n, e, t) {
  let { index: r, offset: i } = n.findIndex(e), s = n.maybeChild(r), { index: o, offset: a } = n.findIndex(t);
  if (i == e || s.isText) {
    if (a != t && !n.child(o).isText)
      throw new RangeError("Removing non-flat range");
    return n.cut(0, e).append(n.cut(t));
  }
  if (r != o)
    throw new RangeError("Removing non-flat range");
  return n.replaceChild(r, s.copy(Yb(s.content, e - i - 1, t - i - 1)));
}
function Qb(n, e, t, r) {
  let { index: i, offset: s } = n.findIndex(e), o = n.maybeChild(i);
  if (s == e || o.isText)
    return r && !r.canReplace(i, i, t) ? null : n.cut(0, e).append(t).append(n.cut(e));
  let a = Qb(o.content, e - s - 1, t);
  return a && n.replaceChild(i, o.copy(a));
}
function t$(n, e, t) {
  if (t.openStart > n.depth)
    throw new Oa("Inserted content deeper than insertion position");
  if (n.depth - t.openStart != e.depth - t.openEnd)
    throw new Oa("Inconsistent open depths");
  return Zb(n, e, t, 0);
}
function Zb(n, e, t, r) {
  let i = n.index(r), s = n.node(r);
  if (i == e.index(r) && r < n.depth - t.openStart) {
    let o = Zb(n, e, t, r + 1);
    return s.copy(s.content.replaceChild(i, o));
  } else if (t.content.size)
    if (!t.openStart && !t.openEnd && n.depth == r && e.depth == r) {
      let o = n.parent, a = o.content;
      return Nr(o, a.cut(0, n.parentOffset).append(t.content).append(a.cut(e.parentOffset)));
    } else {
      let { start: o, end: a } = n$(t, n);
      return Nr(s, t0(n, o, a, e, r));
    }
  else
    return Nr(s, Ea(n, e, r));
}
function e0(n, e) {
  if (!e.type.compatibleContent(n.type))
    throw new Oa("Cannot join " + e.type.name + " onto " + n.type.name);
}
function zd(n, e, t) {
  let r = n.node(t);
  return e0(r, e.node(t)), r;
}
function Lr(n, e) {
  let t = e.length - 1;
  t >= 0 && n.isText && n.sameMarkup(e[t]) ? e[t] = n.withText(e[t].text + n.text) : e.push(n);
}
function gs(n, e, t, r) {
  let i = (e || n).node(t), s = 0, o = e ? e.index(t) : i.childCount;
  n && (s = n.index(t), n.depth > t ? s++ : n.textOffset && (Lr(n.nodeAfter, r), s++));
  for (let a = s; a < o; a++)
    Lr(i.child(a), r);
  e && e.depth == t && e.textOffset && Lr(e.nodeBefore, r);
}
function Nr(n, e) {
  return n.type.checkContent(e), n.copy(e);
}
function t0(n, e, t, r, i) {
  let s = n.depth > i && zd(n, e, i + 1), o = r.depth > i && zd(t, r, i + 1), a = [];
  return gs(null, n, i, a), s && o && e.index(i) == t.index(i) ? (e0(s, o), Lr(Nr(s, t0(n, e, t, r, i + 1)), a)) : (s && Lr(Nr(s, Ea(n, e, i + 1)), a), gs(e, t, i, a), o && Lr(Nr(o, Ea(t, r, i + 1)), a)), gs(r, null, i, a), new V(a);
}
function Ea(n, e, t) {
  let r = [];
  if (gs(null, n, t, r), n.depth > t) {
    let i = zd(n, e, t + 1);
    Lr(Nr(i, Ea(n, e, t + 1)), r);
  }
  return gs(e, null, t, r), new V(r);
}
function n$(n, e) {
  let t = e.depth - n.openStart, i = e.node(t).copy(n.content);
  for (let s = t - 1; s >= 0; s--)
    i = e.node(s).copy(V.from(i));
  return {
    start: i.resolveNoCache(n.openStart + t),
    end: i.resolveNoCache(i.content.size - n.openEnd - t)
  };
}
class As {
  constructor(e, t, r) {
    this.pos = e, this.path = t, this.parentOffset = r, this.depth = t.length / 3 - 1;
  }
  resolveDepth(e) {
    return e == null ? this.depth : e < 0 ? this.depth + e : e;
  }
  get parent() {
    return this.node(this.depth);
  }
  get doc() {
    return this.node(0);
  }
  node(e) {
    return this.path[this.resolveDepth(e) * 3];
  }
  index(e) {
    return this.path[this.resolveDepth(e) * 3 + 1];
  }
  indexAfter(e) {
    return e = this.resolveDepth(e), this.index(e) + (e == this.depth && !this.textOffset ? 0 : 1);
  }
  start(e) {
    return e = this.resolveDepth(e), e == 0 ? 0 : this.path[e * 3 - 1] + 1;
  }
  end(e) {
    return e = this.resolveDepth(e), this.start(e) + this.node(e).content.size;
  }
  before(e) {
    if (e = this.resolveDepth(e), !e)
      throw new RangeError("There is no position before the top-level node");
    return e == this.depth + 1 ? this.pos : this.path[e * 3 - 1];
  }
  after(e) {
    if (e = this.resolveDepth(e), !e)
      throw new RangeError("There is no position after the top-level node");
    return e == this.depth + 1 ? this.pos : this.path[e * 3 - 1] + this.path[e * 3].nodeSize;
  }
  get textOffset() {
    return this.pos - this.path[this.path.length - 1];
  }
  get nodeAfter() {
    let e = this.parent, t = this.index(this.depth);
    if (t == e.childCount)
      return null;
    let r = this.pos - this.path[this.path.length - 1], i = e.child(t);
    return r ? e.child(t).cut(r) : i;
  }
  get nodeBefore() {
    let e = this.index(this.depth), t = this.pos - this.path[this.path.length - 1];
    return t ? this.parent.child(e).cut(0, t) : e == 0 ? null : this.parent.child(e - 1);
  }
  posAtIndex(e, t) {
    t = this.resolveDepth(t);
    let r = this.path[t * 3], i = t == 0 ? 0 : this.path[t * 3 - 1] + 1;
    for (let s = 0; s < e; s++)
      i += r.child(s).nodeSize;
    return i;
  }
  marks() {
    let e = this.parent, t = this.index();
    if (e.content.size == 0)
      return Se.none;
    if (this.textOffset)
      return e.child(t).marks;
    let r = e.maybeChild(t - 1), i = e.maybeChild(t);
    if (!r) {
      let a = r;
      r = i, i = a;
    }
    let s = r.marks;
    for (var o = 0; o < s.length; o++)
      s[o].type.spec.inclusive === !1 && (!i || !s[o].isInSet(i.marks)) && (s = s[o--].removeFromSet(s));
    return s;
  }
  marksAcross(e) {
    let t = this.parent.maybeChild(this.index());
    if (!t || !t.isInline)
      return null;
    let r = t.marks, i = e.parent.maybeChild(e.index());
    for (var s = 0; s < r.length; s++)
      r[s].type.spec.inclusive === !1 && (!i || !r[s].isInSet(i.marks)) && (r = r[s--].removeFromSet(r));
    return r;
  }
  sharedDepth(e) {
    for (let t = this.depth; t > 0; t--)
      if (this.start(t) <= e && this.end(t) >= e)
        return t;
    return 0;
  }
  blockRange(e = this, t) {
    if (e.pos < this.pos)
      return e.blockRange(this);
    for (let r = this.depth - (this.parent.inlineContent || this.pos == e.pos ? 1 : 0); r >= 0; r--)
      if (e.pos <= this.end(r) && (!t || t(this.node(r))))
        return new Ta(this, e, r);
    return null;
  }
  sameParent(e) {
    return this.pos - this.parentOffset == e.pos - e.parentOffset;
  }
  max(e) {
    return e.pos > this.pos ? e : this;
  }
  min(e) {
    return e.pos < this.pos ? e : this;
  }
  toString() {
    let e = "";
    for (let t = 1; t <= this.depth; t++)
      e += (e ? "/" : "") + this.node(t).type.name + "_" + this.index(t - 1);
    return e + ":" + this.parentOffset;
  }
  static resolve(e, t) {
    if (!(t >= 0 && t <= e.content.size))
      throw new RangeError("Position " + t + " out of range");
    let r = [], i = 0, s = t;
    for (let o = e; ; ) {
      let { index: a, offset: l } = o.content.findIndex(s), u = s - l;
      if (r.push(o, a, i + l), !u || (o = o.child(a), o.isText))
        break;
      s = u - 1, i += l + 1;
    }
    return new As(t, r, s);
  }
  static resolveCached(e, t) {
    for (let i = 0; i < Ec.length; i++) {
      let s = Ec[i];
      if (s.pos == t && s.doc == e)
        return s;
    }
    let r = Ec[Tc] = As.resolve(e, t);
    return Tc = (Tc + 1) % r$, r;
  }
}
let Ec = [], Tc = 0, r$ = 12;
class Ta {
  constructor(e, t, r) {
    this.$from = e, this.$to = t, this.depth = r;
  }
  get start() {
    return this.$from.before(this.depth + 1);
  }
  get end() {
    return this.$to.after(this.depth + 1);
  }
  get parent() {
    return this.$from.node(this.depth);
  }
  get startIndex() {
    return this.$from.index(this.depth);
  }
  get endIndex() {
    return this.$to.indexAfter(this.depth);
  }
}
const i$ = /* @__PURE__ */ Object.create(null);
class wn {
  constructor(e, t, r, i = Se.none) {
    this.type = e, this.attrs = t, this.marks = i, this.content = r || V.empty;
  }
  get nodeSize() {
    return this.isLeaf ? 1 : 2 + this.content.size;
  }
  get childCount() {
    return this.content.childCount;
  }
  child(e) {
    return this.content.child(e);
  }
  maybeChild(e) {
    return this.content.maybeChild(e);
  }
  forEach(e) {
    this.content.forEach(e);
  }
  nodesBetween(e, t, r, i = 0) {
    this.content.nodesBetween(e, t, r, i, this);
  }
  descendants(e) {
    this.nodesBetween(0, this.content.size, e);
  }
  get textContent() {
    return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
  }
  textBetween(e, t, r, i) {
    return this.content.textBetween(e, t, r, i);
  }
  get firstChild() {
    return this.content.firstChild;
  }
  get lastChild() {
    return this.content.lastChild;
  }
  eq(e) {
    return this == e || this.sameMarkup(e) && this.content.eq(e.content);
  }
  sameMarkup(e) {
    return this.hasMarkup(e.type, e.attrs, e.marks);
  }
  hasMarkup(e, t, r) {
    return this.type == e && Ca(this.attrs, t || e.defaultAttrs || i$) && Se.sameSet(this.marks, r || Se.none);
  }
  copy(e = null) {
    return e == this.content ? this : new wn(this.type, this.attrs, e, this.marks);
  }
  mark(e) {
    return e == this.marks ? this : new wn(this.type, this.attrs, this.content, e);
  }
  cut(e, t = this.content.size) {
    return e == 0 && t == this.content.size ? this : this.copy(this.content.cut(e, t));
  }
  slice(e, t = this.content.size, r = !1) {
    if (e == t)
      return X.empty;
    let i = this.resolve(e), s = this.resolve(t), o = r ? 0 : i.sharedDepth(t), a = i.start(o), u = i.node(o).content.cut(i.pos - a, s.pos - a);
    return new X(u, i.depth - o, s.depth - o);
  }
  replace(e, t, r) {
    return t$(this.resolve(e), this.resolve(t), r);
  }
  nodeAt(e) {
    for (let t = this; ; ) {
      let { index: r, offset: i } = t.content.findIndex(e);
      if (t = t.maybeChild(r), !t)
        return null;
      if (i == e || t.isText)
        return t;
      e -= i + 1;
    }
  }
  childAfter(e) {
    let { index: t, offset: r } = this.content.findIndex(e);
    return { node: this.content.maybeChild(t), index: t, offset: r };
  }
  childBefore(e) {
    if (e == 0)
      return { node: null, index: 0, offset: 0 };
    let { index: t, offset: r } = this.content.findIndex(e);
    if (r < e)
      return { node: this.content.child(t), index: t, offset: r };
    let i = this.content.child(t - 1);
    return { node: i, index: t - 1, offset: r - i.nodeSize };
  }
  resolve(e) {
    return As.resolveCached(this, e);
  }
  resolveNoCache(e) {
    return As.resolve(this, e);
  }
  rangeHasMark(e, t, r) {
    let i = !1;
    return t > e && this.nodesBetween(e, t, (s) => (r.isInSet(s.marks) && (i = !0), !i)), i;
  }
  get isBlock() {
    return this.type.isBlock;
  }
  get isTextblock() {
    return this.type.isTextblock;
  }
  get inlineContent() {
    return this.type.inlineContent;
  }
  get isInline() {
    return this.type.isInline;
  }
  get isText() {
    return this.type.isText;
  }
  get isLeaf() {
    return this.type.isLeaf;
  }
  get isAtom() {
    return this.type.isAtom;
  }
  toString() {
    if (this.type.spec.toDebugString)
      return this.type.spec.toDebugString(this);
    let e = this.type.name;
    return this.content.size && (e += "(" + this.content.toStringInner() + ")"), n0(this.marks, e);
  }
  contentMatchAt(e) {
    let t = this.type.contentMatch.matchFragment(this.content, 0, e);
    if (!t)
      throw new Error("Called contentMatchAt on a node with invalid content");
    return t;
  }
  canReplace(e, t, r = V.empty, i = 0, s = r.childCount) {
    let o = this.contentMatchAt(e).matchFragment(r, i, s), a = o && o.matchFragment(this.content, t);
    if (!a || !a.validEnd)
      return !1;
    for (let l = i; l < s; l++)
      if (!this.type.allowsMarks(r.child(l).marks))
        return !1;
    return !0;
  }
  canReplaceWith(e, t, r, i) {
    if (i && !this.type.allowsMarks(i))
      return !1;
    let s = this.contentMatchAt(e).matchType(r), o = s && s.matchFragment(this.content, t);
    return o ? o.validEnd : !1;
  }
  canAppend(e) {
    return e.content.size ? this.canReplace(this.childCount, this.childCount, e.content) : this.type.compatibleContent(e.type);
  }
  check() {
    this.type.checkContent(this.content);
    let e = Se.none;
    for (let t = 0; t < this.marks.length; t++)
      e = this.marks[t].addToSet(e);
    if (!Se.sameSet(e, this.marks))
      throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((t) => t.type.name)}`);
    this.content.forEach((t) => t.check());
  }
  toJSON() {
    let e = { type: this.type.name };
    for (let t in this.attrs) {
      e.attrs = this.attrs;
      break;
    }
    return this.content.size && (e.content = this.content.toJSON()), this.marks.length && (e.marks = this.marks.map((t) => t.toJSON())), e;
  }
  static fromJSON(e, t) {
    if (!t)
      throw new RangeError("Invalid input for Node.fromJSON");
    let r = null;
    if (t.marks) {
      if (!Array.isArray(t.marks))
        throw new RangeError("Invalid mark data for Node.fromJSON");
      r = t.marks.map(e.markFromJSON);
    }
    if (t.type == "text") {
      if (typeof t.text != "string")
        throw new RangeError("Invalid text node in JSON");
      return e.text(t.text, r);
    }
    let i = V.fromJSON(e, t.content);
    return e.nodeType(t.type).create(t.attrs, i, r);
  }
}
wn.prototype.text = void 0;
class ka extends wn {
  constructor(e, t, r, i) {
    if (super(e, t, null, i), !r)
      throw new RangeError("Empty text nodes are not allowed");
    this.text = r;
  }
  toString() {
    return this.type.spec.toDebugString ? this.type.spec.toDebugString(this) : n0(this.marks, JSON.stringify(this.text));
  }
  get textContent() {
    return this.text;
  }
  textBetween(e, t) {
    return this.text.slice(e, t);
  }
  get nodeSize() {
    return this.text.length;
  }
  mark(e) {
    return e == this.marks ? this : new ka(this.type, this.attrs, this.text, e);
  }
  withText(e) {
    return e == this.text ? this : new ka(this.type, this.attrs, e, this.marks);
  }
  cut(e = 0, t = this.text.length) {
    return e == 0 && t == this.text.length ? this : this.withText(this.text.slice(e, t));
  }
  eq(e) {
    return this.sameMarkup(e) && this.text == e.text;
  }
  toJSON() {
    let e = super.toJSON();
    return e.text = this.text, e;
  }
}
function n0(n, e) {
  for (let t = n.length - 1; t >= 0; t--)
    e = n[t].type.name + "(" + e + ")";
  return e;
}
class Br {
  constructor(e) {
    this.validEnd = e, this.next = [], this.wrapCache = [];
  }
  static parse(e, t) {
    let r = new s$(e, t);
    if (r.next == null)
      return Br.empty;
    let i = r0(r);
    r.next && r.err("Unexpected trailing text");
    let s = f$(d$(i));
    return p$(s, r), s;
  }
  matchType(e) {
    for (let t = 0; t < this.next.length; t++)
      if (this.next[t].type == e)
        return this.next[t].next;
    return null;
  }
  matchFragment(e, t = 0, r = e.childCount) {
    let i = this;
    for (let s = t; i && s < r; s++)
      i = i.matchType(e.child(s).type);
    return i;
  }
  get inlineContent() {
    return this.next.length != 0 && this.next[0].type.isInline;
  }
  get defaultType() {
    for (let e = 0; e < this.next.length; e++) {
      let { type: t } = this.next[e];
      if (!(t.isText || t.hasRequiredAttrs()))
        return t;
    }
    return null;
  }
  compatible(e) {
    for (let t = 0; t < this.next.length; t++)
      for (let r = 0; r < e.next.length; r++)
        if (this.next[t].type == e.next[r].type)
          return !0;
    return !1;
  }
  fillBefore(e, t = !1, r = 0) {
    let i = [this];
    function s(o, a) {
      let l = o.matchFragment(e, r);
      if (l && (!t || l.validEnd))
        return V.from(a.map((u) => u.createAndFill()));
      for (let u = 0; u < o.next.length; u++) {
        let { type: c, next: f } = o.next[u];
        if (!(c.isText || c.hasRequiredAttrs()) && i.indexOf(f) == -1) {
          i.push(f);
          let p = s(f, a.concat(c));
          if (p)
            return p;
        }
      }
      return null;
    }
    return s(this, []);
  }
  findWrapping(e) {
    for (let r = 0; r < this.wrapCache.length; r += 2)
      if (this.wrapCache[r] == e)
        return this.wrapCache[r + 1];
    let t = this.computeWrapping(e);
    return this.wrapCache.push(e, t), t;
  }
  computeWrapping(e) {
    let t = /* @__PURE__ */ Object.create(null), r = [{ match: this, type: null, via: null }];
    for (; r.length; ) {
      let i = r.shift(), s = i.match;
      if (s.matchType(e)) {
        let o = [];
        for (let a = i; a.type; a = a.via)
          o.push(a.type);
        return o.reverse();
      }
      for (let o = 0; o < s.next.length; o++) {
        let { type: a, next: l } = s.next[o];
        !a.isLeaf && !a.hasRequiredAttrs() && !(a.name in t) && (!i.type || l.validEnd) && (r.push({ match: a.contentMatch, type: a, via: i }), t[a.name] = !0);
      }
    }
    return null;
  }
  get edgeCount() {
    return this.next.length;
  }
  edge(e) {
    if (e >= this.next.length)
      throw new RangeError(`There's no ${e}th edge in this content match`);
    return this.next[e];
  }
  toString() {
    let e = [];
    function t(r) {
      e.push(r);
      for (let i = 0; i < r.next.length; i++)
        e.indexOf(r.next[i].next) == -1 && t(r.next[i].next);
    }
    return t(this), e.map((r, i) => {
      let s = i + (r.validEnd ? "*" : " ") + " ";
      for (let o = 0; o < r.next.length; o++)
        s += (o ? ", " : "") + r.next[o].type.name + "->" + e.indexOf(r.next[o].next);
      return s;
    }).join(`
`);
  }
}
Br.empty = new Br(!0);
class s$ {
  constructor(e, t) {
    this.string = e, this.nodeTypes = t, this.inline = null, this.pos = 0, this.tokens = e.split(/\s*(?=\b|\W|$)/), this.tokens[this.tokens.length - 1] == "" && this.tokens.pop(), this.tokens[0] == "" && this.tokens.shift();
  }
  get next() {
    return this.tokens[this.pos];
  }
  eat(e) {
    return this.next == e && (this.pos++ || !0);
  }
  err(e) {
    throw new SyntaxError(e + " (in content expression '" + this.string + "')");
  }
}
function r0(n) {
  let e = [];
  do
    e.push(o$(n));
  while (n.eat("|"));
  return e.length == 1 ? e[0] : { type: "choice", exprs: e };
}
function o$(n) {
  let e = [];
  do
    e.push(a$(n));
  while (n.next && n.next != ")" && n.next != "|");
  return e.length == 1 ? e[0] : { type: "seq", exprs: e };
}
function a$(n) {
  let e = c$(n);
  for (; ; )
    if (n.eat("+"))
      e = { type: "plus", expr: e };
    else if (n.eat("*"))
      e = { type: "star", expr: e };
    else if (n.eat("?"))
      e = { type: "opt", expr: e };
    else if (n.eat("{"))
      e = l$(n, e);
    else
      break;
  return e;
}
function jm(n) {
  /\D/.test(n.next) && n.err("Expected number, got '" + n.next + "'");
  let e = Number(n.next);
  return n.pos++, e;
}
function l$(n, e) {
  let t = jm(n), r = t;
  return n.eat(",") && (n.next != "}" ? r = jm(n) : r = -1), n.eat("}") || n.err("Unclosed braced range"), { type: "range", min: t, max: r, expr: e };
}
function u$(n, e) {
  let t = n.nodeTypes, r = t[e];
  if (r)
    return [r];
  let i = [];
  for (let s in t) {
    let o = t[s];
    o.groups.indexOf(e) > -1 && i.push(o);
  }
  return i.length == 0 && n.err("No node type or group '" + e + "' found"), i;
}
function c$(n) {
  if (n.eat("(")) {
    let e = r0(n);
    return n.eat(")") || n.err("Missing closing paren"), e;
  } else if (/\W/.test(n.next))
    n.err("Unexpected token '" + n.next + "'");
  else {
    let e = u$(n, n.next).map((t) => (n.inline == null ? n.inline = t.isInline : n.inline != t.isInline && n.err("Mixing inline and block content"), { type: "name", value: t }));
    return n.pos++, e.length == 1 ? e[0] : { type: "choice", exprs: e };
  }
}
function d$(n) {
  let e = [[]];
  return i(s(n, 0), t()), e;
  function t() {
    return e.push([]) - 1;
  }
  function r(o, a, l) {
    let u = { term: l, to: a };
    return e[o].push(u), u;
  }
  function i(o, a) {
    o.forEach((l) => l.to = a);
  }
  function s(o, a) {
    if (o.type == "choice")
      return o.exprs.reduce((l, u) => l.concat(s(u, a)), []);
    if (o.type == "seq")
      for (let l = 0; ; l++) {
        let u = s(o.exprs[l], a);
        if (l == o.exprs.length - 1)
          return u;
        i(u, a = t());
      }
    else if (o.type == "star") {
      let l = t();
      return r(a, l), i(s(o.expr, l), l), [r(l)];
    } else if (o.type == "plus") {
      let l = t();
      return i(s(o.expr, a), l), i(s(o.expr, l), l), [r(l)];
    } else {
      if (o.type == "opt")
        return [r(a)].concat(s(o.expr, a));
      if (o.type == "range") {
        let l = a;
        for (let u = 0; u < o.min; u++) {
          let c = t();
          i(s(o.expr, l), c), l = c;
        }
        if (o.max == -1)
          i(s(o.expr, l), l);
        else
          for (let u = o.min; u < o.max; u++) {
            let c = t();
            r(l, c), i(s(o.expr, l), c), l = c;
          }
        return [r(l)];
      } else {
        if (o.type == "name")
          return [r(a, void 0, o.value)];
        throw new Error("Unknown expr type");
      }
    }
  }
}
function i0(n, e) {
  return e - n;
}
function Vm(n, e) {
  let t = [];
  return r(e), t.sort(i0);
  function r(i) {
    let s = n[i];
    if (s.length == 1 && !s[0].term)
      return r(s[0].to);
    t.push(i);
    for (let o = 0; o < s.length; o++) {
      let { term: a, to: l } = s[o];
      !a && t.indexOf(l) == -1 && r(l);
    }
  }
}
function f$(n) {
  let e = /* @__PURE__ */ Object.create(null);
  return t(Vm(n, 0));
  function t(r) {
    let i = [];
    r.forEach((o) => {
      n[o].forEach(({ term: a, to: l }) => {
        if (!a)
          return;
        let u;
        for (let c = 0; c < i.length; c++)
          i[c][0] == a && (u = i[c][1]);
        Vm(n, l).forEach((c) => {
          u || i.push([a, u = []]), u.indexOf(c) == -1 && u.push(c);
        });
      });
    });
    let s = e[r.join(",")] = new Br(r.indexOf(n.length - 1) > -1);
    for (let o = 0; o < i.length; o++) {
      let a = i[o][1].sort(i0);
      s.next.push({ type: i[o][0], next: e[a.join(",")] || t(a) });
    }
    return s;
  }
}
function p$(n, e) {
  for (let t = 0, r = [n]; t < r.length; t++) {
    let i = r[t], s = !i.validEnd, o = [];
    for (let a = 0; a < i.next.length; a++) {
      let { type: l, next: u } = i.next[a];
      o.push(l.name), s && !(l.isText || l.hasRequiredAttrs()) && (s = !1), r.indexOf(u) == -1 && r.push(u);
    }
    s && e.err("Only non-generatable nodes (" + o.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
  }
}
function s0(n) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let t in n) {
    let r = n[t];
    if (!r.hasDefault)
      return null;
    e[t] = r.default;
  }
  return e;
}
function o0(n, e) {
  let t = /* @__PURE__ */ Object.create(null);
  for (let r in n) {
    let i = e && e[r];
    if (i === void 0) {
      let s = n[r];
      if (s.hasDefault)
        i = s.default;
      else
        throw new RangeError("No value supplied for attribute " + r);
    }
    t[r] = i;
  }
  return t;
}
function a0(n) {
  let e = /* @__PURE__ */ Object.create(null);
  if (n)
    for (let t in n)
      e[t] = new h$(n[t]);
  return e;
}
class Ma {
  constructor(e, t, r) {
    this.name = e, this.schema = t, this.spec = r, this.markSet = null, this.groups = r.group ? r.group.split(" ") : [], this.attrs = a0(r.attrs), this.defaultAttrs = s0(this.attrs), this.contentMatch = null, this.inlineContent = null, this.isBlock = !(r.inline || e == "text"), this.isText = e == "text";
  }
  get isInline() {
    return !this.isBlock;
  }
  get isTextblock() {
    return this.isBlock && this.inlineContent;
  }
  get isLeaf() {
    return this.contentMatch == Br.empty;
  }
  get isAtom() {
    return this.isLeaf || !!this.spec.atom;
  }
  get whitespace() {
    return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
  }
  hasRequiredAttrs() {
    for (let e in this.attrs)
      if (this.attrs[e].isRequired)
        return !0;
    return !1;
  }
  compatibleContent(e) {
    return this == e || this.contentMatch.compatible(e.contentMatch);
  }
  computeAttrs(e) {
    return !e && this.defaultAttrs ? this.defaultAttrs : o0(this.attrs, e);
  }
  create(e = null, t, r) {
    if (this.isText)
      throw new Error("NodeType.create can't construct text nodes");
    return new wn(this, this.computeAttrs(e), V.from(t), Se.setFrom(r));
  }
  createChecked(e = null, t, r) {
    return t = V.from(t), this.checkContent(t), new wn(this, this.computeAttrs(e), t, Se.setFrom(r));
  }
  createAndFill(e = null, t, r) {
    if (e = this.computeAttrs(e), t = V.from(t), t.size) {
      let o = this.contentMatch.fillBefore(t);
      if (!o)
        return null;
      t = o.append(t);
    }
    let i = this.contentMatch.matchFragment(t), s = i && i.fillBefore(V.empty, !0);
    return s ? new wn(this, e, t.append(s), Se.setFrom(r)) : null;
  }
  validContent(e) {
    let t = this.contentMatch.matchFragment(e);
    if (!t || !t.validEnd)
      return !1;
    for (let r = 0; r < e.childCount; r++)
      if (!this.allowsMarks(e.child(r).marks))
        return !1;
    return !0;
  }
  checkContent(e) {
    if (!this.validContent(e))
      throw new RangeError(`Invalid content for node ${this.name}: ${e.toString().slice(0, 50)}`);
  }
  allowsMarkType(e) {
    return this.markSet == null || this.markSet.indexOf(e) > -1;
  }
  allowsMarks(e) {
    if (this.markSet == null)
      return !0;
    for (let t = 0; t < e.length; t++)
      if (!this.allowsMarkType(e[t].type))
        return !1;
    return !0;
  }
  allowedMarks(e) {
    if (this.markSet == null)
      return e;
    let t;
    for (let r = 0; r < e.length; r++)
      this.allowsMarkType(e[r].type) ? t && t.push(e[r]) : t || (t = e.slice(0, r));
    return t ? t.length ? t : Se.none : e;
  }
  static compile(e, t) {
    let r = /* @__PURE__ */ Object.create(null);
    e.forEach((s, o) => r[s] = new Ma(s, t, o));
    let i = t.spec.topNode || "doc";
    if (!r[i])
      throw new RangeError("Schema is missing its top node type ('" + i + "')");
    if (!r.text)
      throw new RangeError("Every schema needs a 'text' type");
    for (let s in r.text.attrs)
      throw new RangeError("The text node type should not have attributes");
    return r;
  }
}
class h$ {
  constructor(e) {
    this.hasDefault = Object.prototype.hasOwnProperty.call(e, "default"), this.default = e.default;
  }
  get isRequired() {
    return !this.hasDefault;
  }
}
class Fl {
  constructor(e, t, r, i) {
    this.name = e, this.rank = t, this.schema = r, this.spec = i, this.attrs = a0(i.attrs), this.excluded = null;
    let s = s0(this.attrs);
    this.instance = s ? new Se(this, s) : null;
  }
  create(e = null) {
    return !e && this.instance ? this.instance : new Se(this, o0(this.attrs, e));
  }
  static compile(e, t) {
    let r = /* @__PURE__ */ Object.create(null), i = 0;
    return e.forEach((s, o) => r[s] = new Fl(s, i++, t, o)), r;
  }
  removeFromSet(e) {
    for (var t = 0; t < e.length; t++)
      e[t].type == this && (e = e.slice(0, t).concat(e.slice(t + 1)), t--);
    return e;
  }
  isInSet(e) {
    for (let t = 0; t < e.length; t++)
      if (e[t].type == this)
        return e[t];
  }
  excludes(e) {
    return this.excluded.indexOf(e) > -1;
  }
}
class m$ {
  constructor(e) {
    this.cached = /* @__PURE__ */ Object.create(null);
    let t = this.spec = {};
    for (let i in e)
      t[i] = e[i];
    t.nodes = Xe.from(e.nodes), t.marks = Xe.from(e.marks || {}), this.nodes = Ma.compile(this.spec.nodes, this), this.marks = Fl.compile(this.spec.marks, this);
    let r = /* @__PURE__ */ Object.create(null);
    for (let i in this.nodes) {
      if (i in this.marks)
        throw new RangeError(i + " can not be both a node and a mark");
      let s = this.nodes[i], o = s.spec.content || "", a = s.spec.marks;
      s.contentMatch = r[o] || (r[o] = Br.parse(o, this.nodes)), s.inlineContent = s.contentMatch.inlineContent, s.markSet = a == "_" ? null : a ? Hm(this, a.split(" ")) : a == "" || !s.inlineContent ? [] : null;
    }
    for (let i in this.marks) {
      let s = this.marks[i], o = s.spec.excludes;
      s.excluded = o == null ? [s] : o == "" ? [] : Hm(this, o.split(" "));
    }
    this.nodeFromJSON = this.nodeFromJSON.bind(this), this.markFromJSON = this.markFromJSON.bind(this), this.topNodeType = this.nodes[this.spec.topNode || "doc"], this.cached.wrappings = /* @__PURE__ */ Object.create(null);
  }
  node(e, t = null, r, i) {
    if (typeof e == "string")
      e = this.nodeType(e);
    else if (e instanceof Ma) {
      if (e.schema != this)
        throw new RangeError("Node type from different schema used (" + e.name + ")");
    } else
      throw new RangeError("Invalid node type: " + e);
    return e.createChecked(t, r, i);
  }
  text(e, t) {
    let r = this.nodes.text;
    return new ka(r, r.defaultAttrs, e, Se.setFrom(t));
  }
  mark(e, t) {
    return typeof e == "string" && (e = this.marks[e]), e.create(t);
  }
  nodeFromJSON(e) {
    return wn.fromJSON(this, e);
  }
  markFromJSON(e) {
    return Se.fromJSON(this, e);
  }
  nodeType(e) {
    let t = this.nodes[e];
    if (!t)
      throw new RangeError("Unknown node type: " + e);
    return t;
  }
}
function Hm(n, e) {
  let t = [];
  for (let r = 0; r < e.length; r++) {
    let i = e[r], s = n.marks[i], o = s;
    if (s)
      t.push(s);
    else
      for (let a in n.marks) {
        let l = n.marks[a];
        (i == "_" || l.spec.group && l.spec.group.split(" ").indexOf(i) > -1) && t.push(o = l);
      }
    if (!o)
      throw new SyntaxError("Unknown mark type: '" + e[r] + "'");
  }
  return t;
}
class Mi {
  constructor(e, t) {
    this.schema = e, this.rules = t, this.tags = [], this.styles = [], t.forEach((r) => {
      r.tag ? this.tags.push(r) : r.style && this.styles.push(r);
    }), this.normalizeLists = !this.tags.some((r) => {
      if (!/^(ul|ol)\b/.test(r.tag) || !r.node)
        return !1;
      let i = e.nodes[r.node];
      return i.contentMatch.matchType(i);
    });
  }
  parse(e, t = {}) {
    let r = new qm(this, t, !1);
    return r.addAll(e, t.from, t.to), r.finish();
  }
  parseSlice(e, t = {}) {
    let r = new qm(this, t, !0);
    return r.addAll(e, t.from, t.to), X.maxOpen(r.finish());
  }
  matchTag(e, t, r) {
    for (let i = r ? this.tags.indexOf(r) + 1 : 0; i < this.tags.length; i++) {
      let s = this.tags[i];
      if (y$(e, s.tag) && (s.namespace === void 0 || e.namespaceURI == s.namespace) && (!s.context || t.matchesContext(s.context))) {
        if (s.getAttrs) {
          let o = s.getAttrs(e);
          if (o === !1)
            continue;
          s.attrs = o || void 0;
        }
        return s;
      }
    }
  }
  matchStyle(e, t, r, i) {
    for (let s = i ? this.styles.indexOf(i) + 1 : 0; s < this.styles.length; s++) {
      let o = this.styles[s], a = o.style;
      if (!(a.indexOf(e) != 0 || o.context && !r.matchesContext(o.context) || a.length > e.length && (a.charCodeAt(e.length) != 61 || a.slice(e.length + 1) != t))) {
        if (o.getAttrs) {
          let l = o.getAttrs(t);
          if (l === !1)
            continue;
          o.attrs = l || void 0;
        }
        return o;
      }
    }
  }
  static schemaRules(e) {
    let t = [];
    function r(i) {
      let s = i.priority == null ? 50 : i.priority, o = 0;
      for (; o < t.length; o++) {
        let a = t[o];
        if ((a.priority == null ? 50 : a.priority) < s)
          break;
      }
      t.splice(o, 0, i);
    }
    for (let i in e.marks) {
      let s = e.marks[i].spec.parseDOM;
      s && s.forEach((o) => {
        r(o = Um(o)), o.mark || o.ignore || o.clearMark || (o.mark = i);
      });
    }
    for (let i in e.nodes) {
      let s = e.nodes[i].spec.parseDOM;
      s && s.forEach((o) => {
        r(o = Um(o)), o.node || o.ignore || o.mark || (o.node = i);
      });
    }
    return t;
  }
  static fromSchema(e) {
    return e.cached.domParser || (e.cached.domParser = new Mi(e, Mi.schemaRules(e)));
  }
}
const l0 = {
  address: !0,
  article: !0,
  aside: !0,
  blockquote: !0,
  canvas: !0,
  dd: !0,
  div: !0,
  dl: !0,
  fieldset: !0,
  figcaption: !0,
  figure: !0,
  footer: !0,
  form: !0,
  h1: !0,
  h2: !0,
  h3: !0,
  h4: !0,
  h5: !0,
  h6: !0,
  header: !0,
  hgroup: !0,
  hr: !0,
  li: !0,
  noscript: !0,
  ol: !0,
  output: !0,
  p: !0,
  pre: !0,
  section: !0,
  table: !0,
  tfoot: !0,
  ul: !0
}, g$ = {
  head: !0,
  noscript: !0,
  object: !0,
  script: !0,
  style: !0,
  title: !0
}, u0 = { ol: !0, ul: !0 }, Aa = 1, Pa = 2, vs = 4;
function Wm(n, e, t) {
  return e != null ? (e ? Aa : 0) | (e === "full" ? Pa : 0) : n && n.whitespace == "pre" ? Aa | Pa : t & ~vs;
}
class Ao {
  constructor(e, t, r, i, s, o, a) {
    this.type = e, this.attrs = t, this.marks = r, this.pendingMarks = i, this.solid = s, this.options = a, this.content = [], this.activeMarks = Se.none, this.stashMarks = [], this.match = o || (a & vs ? null : e.contentMatch);
  }
  findWrapping(e) {
    if (!this.match) {
      if (!this.type)
        return [];
      let t = this.type.contentMatch.fillBefore(V.from(e));
      if (t)
        this.match = this.type.contentMatch.matchFragment(t);
      else {
        let r = this.type.contentMatch, i;
        return (i = r.findWrapping(e.type)) ? (this.match = r, i) : null;
      }
    }
    return this.match.findWrapping(e.type);
  }
  finish(e) {
    if (!(this.options & Aa)) {
      let r = this.content[this.content.length - 1], i;
      if (r && r.isText && (i = /[ \t\r\n\u000c]+$/.exec(r.text))) {
        let s = r;
        r.text.length == i[0].length ? this.content.pop() : this.content[this.content.length - 1] = s.withText(s.text.slice(0, s.text.length - i[0].length));
      }
    }
    let t = V.from(this.content);
    return !e && this.match && (t = t.append(this.match.fillBefore(V.empty, !0))), this.type ? this.type.create(this.attrs, t, this.marks) : t;
  }
  popFromStashMark(e) {
    for (let t = this.stashMarks.length - 1; t >= 0; t--)
      if (e.eq(this.stashMarks[t]))
        return this.stashMarks.splice(t, 1)[0];
  }
  applyPending(e) {
    for (let t = 0, r = this.pendingMarks; t < r.length; t++) {
      let i = r[t];
      (this.type ? this.type.allowsMarkType(i.type) : w$(i.type, e)) && !i.isInSet(this.activeMarks) && (this.activeMarks = i.addToSet(this.activeMarks), this.pendingMarks = i.removeFromSet(this.pendingMarks));
    }
  }
  inlineContext(e) {
    return this.type ? this.type.inlineContent : this.content.length ? this.content[0].isInline : e.parentNode && !l0.hasOwnProperty(e.parentNode.nodeName.toLowerCase());
  }
}
class qm {
  constructor(e, t, r) {
    this.parser = e, this.options = t, this.isOpen = r, this.open = 0;
    let i = t.topNode, s, o = Wm(null, t.preserveWhitespace, 0) | (r ? vs : 0);
    i ? s = new Ao(i.type, i.attrs, Se.none, Se.none, !0, t.topMatch || i.type.contentMatch, o) : r ? s = new Ao(null, null, Se.none, Se.none, !0, null, o) : s = new Ao(e.schema.topNodeType, null, Se.none, Se.none, !0, null, o), this.nodes = [s], this.find = t.findPositions, this.needsBlock = !1;
  }
  get top() {
    return this.nodes[this.open];
  }
  addDOM(e) {
    e.nodeType == 3 ? this.addTextNode(e) : e.nodeType == 1 && this.addElement(e);
  }
  withStyleRules(e, t) {
    let r = e.getAttribute("style");
    if (!r)
      return t();
    let i = this.readStyles(b$(r));
    if (!i)
      return;
    let [s, o] = i, a = this.top;
    for (let l = 0; l < o.length; l++)
      this.removePendingMark(o[l], a);
    for (let l = 0; l < s.length; l++)
      this.addPendingMark(s[l]);
    t();
    for (let l = 0; l < s.length; l++)
      this.removePendingMark(s[l], a);
    for (let l = 0; l < o.length; l++)
      this.addPendingMark(o[l]);
  }
  addTextNode(e) {
    let t = e.nodeValue, r = this.top;
    if (r.options & Pa || r.inlineContext(e) || /[^ \t\r\n\u000c]/.test(t)) {
      if (r.options & Aa)
        r.options & Pa ? t = t.replace(/\r\n?/g, `
`) : t = t.replace(/\r?\n|\r/g, " ");
      else if (t = t.replace(/[ \t\r\n\u000c]+/g, " "), /^[ \t\r\n\u000c]/.test(t) && this.open == this.nodes.length - 1) {
        let i = r.content[r.content.length - 1], s = e.previousSibling;
        (!i || s && s.nodeName == "BR" || i.isText && /[ \t\r\n\u000c]$/.test(i.text)) && (t = t.slice(1));
      }
      t && this.insertNode(this.parser.schema.text(t)), this.findInText(e);
    } else
      this.findInside(e);
  }
  addElement(e, t) {
    let r = e.nodeName.toLowerCase(), i;
    u0.hasOwnProperty(r) && this.parser.normalizeLists && v$(e);
    let s = this.options.ruleFromNode && this.options.ruleFromNode(e) || (i = this.parser.matchTag(e, this, t));
    if (s ? s.ignore : g$.hasOwnProperty(r))
      this.findInside(e), this.ignoreFallback(e);
    else if (!s || s.skip || s.closeParent) {
      s && s.closeParent ? this.open = Math.max(0, this.open - 1) : s && s.skip.nodeType && (e = s.skip);
      let o, a = this.top, l = this.needsBlock;
      if (l0.hasOwnProperty(r))
        a.content.length && a.content[0].isInline && this.open && (this.open--, a = this.top), o = !0, a.type || (this.needsBlock = !0);
      else if (!e.firstChild) {
        this.leafFallback(e);
        return;
      }
      s && s.skip ? this.addAll(e) : this.withStyleRules(e, () => this.addAll(e)), o && this.sync(a), this.needsBlock = l;
    } else
      this.withStyleRules(e, () => {
        this.addElementByRule(e, s, s.consuming === !1 ? i : void 0);
      });
  }
  leafFallback(e) {
    e.nodeName == "BR" && this.top.type && this.top.type.inlineContent && this.addTextNode(e.ownerDocument.createTextNode(`
`));
  }
  ignoreFallback(e) {
    e.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent) && this.findPlace(this.parser.schema.text("-"));
  }
  readStyles(e) {
    let t = Se.none, r = Se.none;
    for (let i = 0; i < e.length; i += 2)
      for (let s = void 0; ; ) {
        let o = this.parser.matchStyle(e[i], e[i + 1], this, s);
        if (!o)
          break;
        if (o.ignore)
          return null;
        if (o.clearMark ? this.top.pendingMarks.concat(this.top.activeMarks).forEach((a) => {
          o.clearMark(a) && (r = a.addToSet(r));
        }) : t = this.parser.schema.marks[o.mark].create(o.attrs).addToSet(t), o.consuming === !1)
          s = o;
        else
          break;
      }
    return [t, r];
  }
  addElementByRule(e, t, r) {
    let i, s, o;
    t.node ? (s = this.parser.schema.nodes[t.node], s.isLeaf ? this.insertNode(s.create(t.attrs)) || this.leafFallback(e) : i = this.enter(s, t.attrs || null, t.preserveWhitespace)) : (o = this.parser.schema.marks[t.mark].create(t.attrs), this.addPendingMark(o));
    let a = this.top;
    if (s && s.isLeaf)
      this.findInside(e);
    else if (r)
      this.addElement(e, r);
    else if (t.getContent)
      this.findInside(e), t.getContent(e, this.parser.schema).forEach((l) => this.insertNode(l));
    else {
      let l = e;
      typeof t.contentElement == "string" ? l = e.querySelector(t.contentElement) : typeof t.contentElement == "function" ? l = t.contentElement(e) : t.contentElement && (l = t.contentElement), this.findAround(e, l, !0), this.addAll(l);
    }
    i && this.sync(a) && this.open--, o && this.removePendingMark(o, a);
  }
  addAll(e, t, r) {
    let i = t || 0;
    for (let s = t ? e.childNodes[t] : e.firstChild, o = r == null ? null : e.childNodes[r]; s != o; s = s.nextSibling, ++i)
      this.findAtPoint(e, i), this.addDOM(s);
    this.findAtPoint(e, i);
  }
  findPlace(e) {
    let t, r;
    for (let i = this.open; i >= 0; i--) {
      let s = this.nodes[i], o = s.findWrapping(e);
      if (o && (!t || t.length > o.length) && (t = o, r = s, !o.length) || s.solid)
        break;
    }
    if (!t)
      return !1;
    this.sync(r);
    for (let i = 0; i < t.length; i++)
      this.enterInner(t[i], null, !1);
    return !0;
  }
  insertNode(e) {
    if (e.isInline && this.needsBlock && !this.top.type) {
      let t = this.textblockFromContext();
      t && this.enterInner(t);
    }
    if (this.findPlace(e)) {
      this.closeExtra();
      let t = this.top;
      t.applyPending(e.type), t.match && (t.match = t.match.matchType(e.type));
      let r = t.activeMarks;
      for (let i = 0; i < e.marks.length; i++)
        (!t.type || t.type.allowsMarkType(e.marks[i].type)) && (r = e.marks[i].addToSet(r));
      return t.content.push(e.mark(r)), !0;
    }
    return !1;
  }
  enter(e, t, r) {
    let i = this.findPlace(e.create(t));
    return i && this.enterInner(e, t, !0, r), i;
  }
  enterInner(e, t = null, r = !1, i) {
    this.closeExtra();
    let s = this.top;
    s.applyPending(e), s.match = s.match && s.match.matchType(e);
    let o = Wm(e, i, s.options);
    s.options & vs && s.content.length == 0 && (o |= vs), this.nodes.push(new Ao(e, t, s.activeMarks, s.pendingMarks, r, null, o)), this.open++;
  }
  closeExtra(e = !1) {
    let t = this.nodes.length - 1;
    if (t > this.open) {
      for (; t > this.open; t--)
        this.nodes[t - 1].content.push(this.nodes[t].finish(e));
      this.nodes.length = this.open + 1;
    }
  }
  finish() {
    return this.open = 0, this.closeExtra(this.isOpen), this.nodes[0].finish(this.isOpen || this.options.topOpen);
  }
  sync(e) {
    for (let t = this.open; t >= 0; t--)
      if (this.nodes[t] == e)
        return this.open = t, !0;
    return !1;
  }
  get currentPos() {
    this.closeExtra();
    let e = 0;
    for (let t = this.open; t >= 0; t--) {
      let r = this.nodes[t].content;
      for (let i = r.length - 1; i >= 0; i--)
        e += r[i].nodeSize;
      t && e++;
    }
    return e;
  }
  findAtPoint(e, t) {
    if (this.find)
      for (let r = 0; r < this.find.length; r++)
        this.find[r].node == e && this.find[r].offset == t && (this.find[r].pos = this.currentPos);
  }
  findInside(e) {
    if (this.find)
      for (let t = 0; t < this.find.length; t++)
        this.find[t].pos == null && e.nodeType == 1 && e.contains(this.find[t].node) && (this.find[t].pos = this.currentPos);
  }
  findAround(e, t, r) {
    if (e != t && this.find)
      for (let i = 0; i < this.find.length; i++)
        this.find[i].pos == null && e.nodeType == 1 && e.contains(this.find[i].node) && t.compareDocumentPosition(this.find[i].node) & (r ? 2 : 4) && (this.find[i].pos = this.currentPos);
  }
  findInText(e) {
    if (this.find)
      for (let t = 0; t < this.find.length; t++)
        this.find[t].node == e && (this.find[t].pos = this.currentPos - (e.nodeValue.length - this.find[t].offset));
  }
  matchesContext(e) {
    if (e.indexOf("|") > -1)
      return e.split(/\s*\|\s*/).some(this.matchesContext, this);
    let t = e.split("/"), r = this.options.context, i = !this.isOpen && (!r || r.parent.type == this.nodes[0].type), s = -(r ? r.depth + 1 : 0) + (i ? 0 : 1), o = (a, l) => {
      for (; a >= 0; a--) {
        let u = t[a];
        if (u == "") {
          if (a == t.length - 1 || a == 0)
            continue;
          for (; l >= s; l--)
            if (o(a - 1, l))
              return !0;
          return !1;
        } else {
          let c = l > 0 || l == 0 && i ? this.nodes[l].type : r && l >= s ? r.node(l - s).type : null;
          if (!c || c.name != u && c.groups.indexOf(u) == -1)
            return !1;
          l--;
        }
      }
      return !0;
    };
    return o(t.length - 1, this.open);
  }
  textblockFromContext() {
    let e = this.options.context;
    if (e)
      for (let t = e.depth; t >= 0; t--) {
        let r = e.node(t).contentMatchAt(e.indexAfter(t)).defaultType;
        if (r && r.isTextblock && r.defaultAttrs)
          return r;
      }
    for (let t in this.parser.schema.nodes) {
      let r = this.parser.schema.nodes[t];
      if (r.isTextblock && r.defaultAttrs)
        return r;
    }
  }
  addPendingMark(e) {
    let t = _$(e, this.top.pendingMarks);
    t && this.top.stashMarks.push(t), this.top.pendingMarks = e.addToSet(this.top.pendingMarks);
  }
  removePendingMark(e, t) {
    for (let r = this.open; r >= 0; r--) {
      let i = this.nodes[r];
      if (i.pendingMarks.lastIndexOf(e) > -1)
        i.pendingMarks = e.removeFromSet(i.pendingMarks);
      else {
        i.activeMarks = e.removeFromSet(i.activeMarks);
        let o = i.popFromStashMark(e);
        o && i.type && i.type.allowsMarkType(o.type) && (i.activeMarks = o.addToSet(i.activeMarks));
      }
      if (i == t)
        break;
    }
  }
}
function v$(n) {
  for (let e = n.firstChild, t = null; e; e = e.nextSibling) {
    let r = e.nodeType == 1 ? e.nodeName.toLowerCase() : null;
    r && u0.hasOwnProperty(r) && t ? (t.appendChild(e), e = t) : r == "li" ? t = e : r && (t = null);
  }
}
function y$(n, e) {
  return (n.matches || n.msMatchesSelector || n.webkitMatchesSelector || n.mozMatchesSelector).call(n, e);
}
function b$(n) {
  let e = /\s*([\w-]+)\s*:\s*([^;]+)/g, t, r = [];
  for (; t = e.exec(n); )
    r.push(t[1], t[2].trim());
  return r;
}
function Um(n) {
  let e = {};
  for (let t in n)
    e[t] = n[t];
  return e;
}
function w$(n, e) {
  let t = e.schema.nodes;
  for (let r in t) {
    let i = t[r];
    if (!i.allowsMarkType(n))
      continue;
    let s = [], o = (a) => {
      s.push(a);
      for (let l = 0; l < a.edgeCount; l++) {
        let { type: u, next: c } = a.edge(l);
        if (u == e || s.indexOf(c) < 0 && o(c))
          return !0;
      }
    };
    if (o(i.contentMatch))
      return !0;
  }
}
function _$(n, e) {
  for (let t = 0; t < e.length; t++)
    if (n.eq(e[t]))
      return e[t];
}
class yn {
  constructor(e, t) {
    this.nodes = e, this.marks = t;
  }
  serializeFragment(e, t = {}, r) {
    r || (r = kc(t).createDocumentFragment());
    let i = r, s = [];
    return e.forEach((o) => {
      if (s.length || o.marks.length) {
        let a = 0, l = 0;
        for (; a < s.length && l < o.marks.length; ) {
          let u = o.marks[l];
          if (!this.marks[u.type.name]) {
            l++;
            continue;
          }
          if (!u.eq(s[a][0]) || u.type.spec.spanning === !1)
            break;
          a++, l++;
        }
        for (; a < s.length; )
          i = s.pop()[1];
        for (; l < o.marks.length; ) {
          let u = o.marks[l++], c = this.serializeMark(u, o.isInline, t);
          c && (s.push([u, i]), i.appendChild(c.dom), i = c.contentDOM || c.dom);
        }
      }
      i.appendChild(this.serializeNodeInner(o, t));
    }), r;
  }
  serializeNodeInner(e, t) {
    let { dom: r, contentDOM: i } = yn.renderSpec(kc(t), this.nodes[e.type.name](e));
    if (i) {
      if (e.isLeaf)
        throw new RangeError("Content hole not allowed in a leaf node spec");
      this.serializeFragment(e.content, t, i);
    }
    return r;
  }
  serializeNode(e, t = {}) {
    let r = this.serializeNodeInner(e, t);
    for (let i = e.marks.length - 1; i >= 0; i--) {
      let s = this.serializeMark(e.marks[i], e.isInline, t);
      s && ((s.contentDOM || s.dom).appendChild(r), r = s.dom);
    }
    return r;
  }
  serializeMark(e, t, r = {}) {
    let i = this.marks[e.type.name];
    return i && yn.renderSpec(kc(r), i(e, t));
  }
  static renderSpec(e, t, r = null) {
    if (typeof t == "string")
      return { dom: e.createTextNode(t) };
    if (t.nodeType != null)
      return { dom: t };
    if (t.dom && t.dom.nodeType != null)
      return t;
    let i = t[0], s = i.indexOf(" ");
    s > 0 && (r = i.slice(0, s), i = i.slice(s + 1));
    let o, a = r ? e.createElementNS(r, i) : e.createElement(i), l = t[1], u = 1;
    if (l && typeof l == "object" && l.nodeType == null && !Array.isArray(l)) {
      u = 2;
      for (let c in l)
        if (l[c] != null) {
          let f = c.indexOf(" ");
          f > 0 ? a.setAttributeNS(c.slice(0, f), c.slice(f + 1), l[c]) : a.setAttribute(c, l[c]);
        }
    }
    for (let c = u; c < t.length; c++) {
      let f = t[c];
      if (f === 0) {
        if (c < t.length - 1 || c > u)
          throw new RangeError("Content hole must be the only child of its parent node");
        return { dom: a, contentDOM: a };
      } else {
        let { dom: p, contentDOM: d } = yn.renderSpec(e, f, r);
        if (a.appendChild(p), d) {
          if (o)
            throw new RangeError("Multiple content holes");
          o = d;
        }
      }
    }
    return { dom: a, contentDOM: o };
  }
  static fromSchema(e) {
    return e.cached.domSerializer || (e.cached.domSerializer = new yn(this.nodesFromSchema(e), this.marksFromSchema(e)));
  }
  static nodesFromSchema(e) {
    let t = Gm(e.nodes);
    return t.text || (t.text = (r) => r.text), t;
  }
  static marksFromSchema(e) {
    return Gm(e.marks);
  }
}
function Gm(n) {
  let e = {};
  for (let t in n) {
    let r = n[t].spec.toDOM;
    r && (e[t] = r);
  }
  return e;
}
function kc(n) {
  return n.document || window.document;
}
const c0 = 65535, d0 = Math.pow(2, 16);
function S$(n, e) {
  return n + e * d0;
}
function Km(n) {
  return n & c0;
}
function x$(n) {
  return (n - (n & c0)) / d0;
}
const f0 = 1, p0 = 2, na = 4, h0 = 8;
class Bd {
  constructor(e, t, r) {
    this.pos = e, this.delInfo = t, this.recover = r;
  }
  get deleted() {
    return (this.delInfo & h0) > 0;
  }
  get deletedBefore() {
    return (this.delInfo & (f0 | na)) > 0;
  }
  get deletedAfter() {
    return (this.delInfo & (p0 | na)) > 0;
  }
  get deletedAcross() {
    return (this.delInfo & na) > 0;
  }
}
class At {
  constructor(e, t = !1) {
    if (this.ranges = e, this.inverted = t, !e.length && At.empty)
      return At.empty;
  }
  recover(e) {
    let t = 0, r = Km(e);
    if (!this.inverted)
      for (let i = 0; i < r; i++)
        t += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1];
    return this.ranges[r * 3] + t + x$(e);
  }
  mapResult(e, t = 1) {
    return this._map(e, t, !1);
  }
  map(e, t = 1) {
    return this._map(e, t, !0);
  }
  _map(e, t, r) {
    let i = 0, s = this.inverted ? 2 : 1, o = this.inverted ? 1 : 2;
    for (let a = 0; a < this.ranges.length; a += 3) {
      let l = this.ranges[a] - (this.inverted ? i : 0);
      if (l > e)
        break;
      let u = this.ranges[a + s], c = this.ranges[a + o], f = l + u;
      if (e <= f) {
        let p = u ? e == l ? -1 : e == f ? 1 : t : t, d = l + i + (p < 0 ? 0 : c);
        if (r)
          return d;
        let h = e == (t < 0 ? l : f) ? null : S$(a / 3, e - l), v = e == l ? p0 : e == f ? f0 : na;
        return (t < 0 ? e != l : e != f) && (v |= h0), new Bd(d, v, h);
      }
      i += c - u;
    }
    return r ? e + i : new Bd(e + i, 0, null);
  }
  touches(e, t) {
    let r = 0, i = Km(t), s = this.inverted ? 2 : 1, o = this.inverted ? 1 : 2;
    for (let a = 0; a < this.ranges.length; a += 3) {
      let l = this.ranges[a] - (this.inverted ? r : 0);
      if (l > e)
        break;
      let u = this.ranges[a + s], c = l + u;
      if (e <= c && a == i * 3)
        return !0;
      r += this.ranges[a + o] - u;
    }
    return !1;
  }
  forEach(e) {
    let t = this.inverted ? 2 : 1, r = this.inverted ? 1 : 2;
    for (let i = 0, s = 0; i < this.ranges.length; i += 3) {
      let o = this.ranges[i], a = o - (this.inverted ? s : 0), l = o + (this.inverted ? 0 : s), u = this.ranges[i + t], c = this.ranges[i + r];
      e(a, a + u, l, l + c), s += c - u;
    }
  }
  invert() {
    return new At(this.ranges, !this.inverted);
  }
  toString() {
    return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
  }
  static offset(e) {
    return e == 0 ? At.empty : new At(e < 0 ? [0, -e, 0] : [0, 0, e]);
  }
}
At.empty = new At([]);
class wi {
  constructor(e = [], t, r = 0, i = e.length) {
    this.maps = e, this.mirror = t, this.from = r, this.to = i;
  }
  slice(e = 0, t = this.maps.length) {
    return new wi(this.maps, this.mirror, e, t);
  }
  copy() {
    return new wi(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to);
  }
  appendMap(e, t) {
    this.to = this.maps.push(e), t != null && this.setMirror(this.maps.length - 1, t);
  }
  appendMapping(e) {
    for (let t = 0, r = this.maps.length; t < e.maps.length; t++) {
      let i = e.getMirror(t);
      this.appendMap(e.maps[t], i != null && i < t ? r + i : void 0);
    }
  }
  getMirror(e) {
    if (this.mirror) {
      for (let t = 0; t < this.mirror.length; t++)
        if (this.mirror[t] == e)
          return this.mirror[t + (t % 2 ? -1 : 1)];
    }
  }
  setMirror(e, t) {
    this.mirror || (this.mirror = []), this.mirror.push(e, t);
  }
  appendMappingInverted(e) {
    for (let t = e.maps.length - 1, r = this.maps.length + e.maps.length; t >= 0; t--) {
      let i = e.getMirror(t);
      this.appendMap(e.maps[t].invert(), i != null && i > t ? r - i - 1 : void 0);
    }
  }
  invert() {
    let e = new wi();
    return e.appendMappingInverted(this), e;
  }
  map(e, t = 1) {
    if (this.mirror)
      return this._map(e, t, !0);
    for (let r = this.from; r < this.to; r++)
      e = this.maps[r].map(e, t);
    return e;
  }
  mapResult(e, t = 1) {
    return this._map(e, t, !1);
  }
  _map(e, t, r) {
    let i = 0;
    for (let s = this.from; s < this.to; s++) {
      let o = this.maps[s], a = o.mapResult(e, t);
      if (a.recover != null) {
        let l = this.getMirror(s);
        if (l != null && l > s && l < this.to) {
          s = l, e = this.maps[l].recover(a.recover);
          continue;
        }
      }
      i |= a.delInfo, e = a.pos;
    }
    return r ? e : new Bd(e, i, null);
  }
}
const Mc = /* @__PURE__ */ Object.create(null);
class at {
  getMap() {
    return At.empty;
  }
  merge(e) {
    return null;
  }
  static fromJSON(e, t) {
    if (!t || !t.stepType)
      throw new RangeError("Invalid input for Step.fromJSON");
    let r = Mc[t.stepType];
    if (!r)
      throw new RangeError(`No step type ${t.stepType} defined`);
    return r.fromJSON(e, t);
  }
  static jsonID(e, t) {
    if (e in Mc)
      throw new RangeError("Duplicate use of step JSON ID " + e);
    return Mc[e] = t, t.prototype.jsonID = e, t;
  }
}
class Ne {
  constructor(e, t) {
    this.doc = e, this.failed = t;
  }
  static ok(e) {
    return new Ne(e, null);
  }
  static fail(e) {
    return new Ne(null, e);
  }
  static fromReplace(e, t, r, i) {
    try {
      return Ne.ok(e.replace(t, r, i));
    } catch (s) {
      if (s instanceof Oa)
        return Ne.fail(s.message);
      throw s;
    }
  }
}
function op(n, e, t) {
  let r = [];
  for (let i = 0; i < n.childCount; i++) {
    let s = n.child(i);
    s.content.size && (s = s.copy(op(s.content, e, s))), s.isInline && (s = e(s, t, i)), r.push(s);
  }
  return V.fromArray(r);
}
class Zn extends at {
  constructor(e, t, r) {
    super(), this.from = e, this.to = t, this.mark = r;
  }
  apply(e) {
    let t = e.slice(this.from, this.to), r = e.resolve(this.from), i = r.node(r.sharedDepth(this.to)), s = new X(op(t.content, (o, a) => !o.isAtom || !a.type.allowsMarkType(this.mark.type) ? o : o.mark(this.mark.addToSet(o.marks)), i), t.openStart, t.openEnd);
    return Ne.fromReplace(e, this.from, this.to, s);
  }
  invert() {
    return new bn(this.from, this.to, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1);
    return t.deleted && r.deleted || t.pos >= r.pos ? null : new Zn(t.pos, r.pos, this.mark);
  }
  merge(e) {
    return e instanceof Zn && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new Zn(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "addMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for AddMarkStep.fromJSON");
    return new Zn(t.from, t.to, e.markFromJSON(t.mark));
  }
}
at.jsonID("addMark", Zn);
class bn extends at {
  constructor(e, t, r) {
    super(), this.from = e, this.to = t, this.mark = r;
  }
  apply(e) {
    let t = e.slice(this.from, this.to), r = new X(op(t.content, (i) => i.mark(this.mark.removeFromSet(i.marks)), e), t.openStart, t.openEnd);
    return Ne.fromReplace(e, this.from, this.to, r);
  }
  invert() {
    return new Zn(this.from, this.to, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1);
    return t.deleted && r.deleted || t.pos >= r.pos ? null : new bn(t.pos, r.pos, this.mark);
  }
  merge(e) {
    return e instanceof bn && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new bn(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "removeMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
    return new bn(t.from, t.to, e.markFromJSON(t.mark));
  }
}
at.jsonID("removeMark", bn);
class er extends at {
  constructor(e, t) {
    super(), this.pos = e, this.mark = t;
  }
  apply(e) {
    let t = e.nodeAt(this.pos);
    if (!t)
      return Ne.fail("No node at mark step's position");
    let r = t.type.create(t.attrs, null, this.mark.addToSet(t.marks));
    return Ne.fromReplace(e, this.pos, this.pos + 1, new X(V.from(r), 0, t.isLeaf ? 0 : 1));
  }
  invert(e) {
    let t = e.nodeAt(this.pos);
    if (t) {
      let r = this.mark.addToSet(t.marks);
      if (r.length == t.marks.length) {
        for (let i = 0; i < t.marks.length; i++)
          if (!t.marks[i].isInSet(r))
            return new er(this.pos, t.marks[i]);
        return new er(this.pos, this.mark);
      }
    }
    return new Ai(this.pos, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new er(t.pos, this.mark);
  }
  toJSON() {
    return { stepType: "addNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  static fromJSON(e, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
    return new er(t.pos, e.markFromJSON(t.mark));
  }
}
at.jsonID("addNodeMark", er);
class Ai extends at {
  constructor(e, t) {
    super(), this.pos = e, this.mark = t;
  }
  apply(e) {
    let t = e.nodeAt(this.pos);
    if (!t)
      return Ne.fail("No node at mark step's position");
    let r = t.type.create(t.attrs, null, this.mark.removeFromSet(t.marks));
    return Ne.fromReplace(e, this.pos, this.pos + 1, new X(V.from(r), 0, t.isLeaf ? 0 : 1));
  }
  invert(e) {
    let t = e.nodeAt(this.pos);
    return !t || !this.mark.isInSet(t.marks) ? this : new er(this.pos, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new Ai(t.pos, this.mark);
  }
  toJSON() {
    return { stepType: "removeNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  static fromJSON(e, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
    return new Ai(t.pos, e.markFromJSON(t.mark));
  }
}
at.jsonID("removeNodeMark", Ai);
class Qe extends at {
  constructor(e, t, r, i = !1) {
    super(), this.from = e, this.to = t, this.slice = r, this.structure = i;
  }
  apply(e) {
    return this.structure && jd(e, this.from, this.to) ? Ne.fail("Structure replace would overwrite content") : Ne.fromReplace(e, this.from, this.to, this.slice);
  }
  getMap() {
    return new At([this.from, this.to - this.from, this.slice.size]);
  }
  invert(e) {
    return new Qe(this.from, this.from + this.slice.size, e.slice(this.from, this.to));
  }
  map(e) {
    let t = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1);
    return t.deletedAcross && r.deletedAcross ? null : new Qe(t.pos, Math.max(t.pos, r.pos), this.slice);
  }
  merge(e) {
    if (!(e instanceof Qe) || e.structure || this.structure)
      return null;
    if (this.from + this.slice.size == e.from && !this.slice.openEnd && !e.slice.openStart) {
      let t = this.slice.size + e.slice.size == 0 ? X.empty : new X(this.slice.content.append(e.slice.content), this.slice.openStart, e.slice.openEnd);
      return new Qe(this.from, this.to + (e.to - e.from), t, this.structure);
    } else if (e.to == this.from && !this.slice.openStart && !e.slice.openEnd) {
      let t = this.slice.size + e.slice.size == 0 ? X.empty : new X(e.slice.content.append(this.slice.content), e.slice.openStart, this.slice.openEnd);
      return new Qe(e.from, this.to, t, this.structure);
    } else
      return null;
  }
  toJSON() {
    let e = { stepType: "replace", from: this.from, to: this.to };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for ReplaceStep.fromJSON");
    return new Qe(t.from, t.to, X.fromJSON(e, t.slice), !!t.structure);
  }
}
at.jsonID("replace", Qe);
class qe extends at {
  constructor(e, t, r, i, s, o, a = !1) {
    super(), this.from = e, this.to = t, this.gapFrom = r, this.gapTo = i, this.slice = s, this.insert = o, this.structure = a;
  }
  apply(e) {
    if (this.structure && (jd(e, this.from, this.gapFrom) || jd(e, this.gapTo, this.to)))
      return Ne.fail("Structure gap-replace would overwrite content");
    let t = e.slice(this.gapFrom, this.gapTo);
    if (t.openStart || t.openEnd)
      return Ne.fail("Gap is not a flat range");
    let r = this.slice.insertAt(this.insert, t.content);
    return r ? Ne.fromReplace(e, this.from, this.to, r) : Ne.fail("Content does not fit in gap");
  }
  getMap() {
    return new At([
      this.from,
      this.gapFrom - this.from,
      this.insert,
      this.gapTo,
      this.to - this.gapTo,
      this.slice.size - this.insert
    ]);
  }
  invert(e) {
    let t = this.gapTo - this.gapFrom;
    return new qe(this.from, this.from + this.slice.size + t, this.from + this.insert, this.from + this.insert + t, e.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
  }
  map(e) {
    let t = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1), i = e.map(this.gapFrom, -1), s = e.map(this.gapTo, 1);
    return t.deletedAcross && r.deletedAcross || i < t.pos || s > r.pos ? null : new qe(t.pos, r.pos, i, s, this.slice, this.insert, this.structure);
  }
  toJSON() {
    let e = {
      stepType: "replaceAround",
      from: this.from,
      to: this.to,
      gapFrom: this.gapFrom,
      gapTo: this.gapTo,
      insert: this.insert
    };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number" || typeof t.gapFrom != "number" || typeof t.gapTo != "number" || typeof t.insert != "number")
      throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
    return new qe(t.from, t.to, t.gapFrom, t.gapTo, X.fromJSON(e, t.slice), t.insert, !!t.structure);
  }
}
at.jsonID("replaceAround", qe);
function jd(n, e, t) {
  let r = n.resolve(e), i = t - e, s = r.depth;
  for (; i > 0 && s > 0 && r.indexAfter(s) == r.node(s).childCount; )
    s--, i--;
  if (i > 0) {
    let o = r.node(s).maybeChild(r.indexAfter(s));
    for (; i > 0; ) {
      if (!o || o.isLeaf)
        return !0;
      o = o.firstChild, i--;
    }
  }
  return !1;
}
function C$(n, e, t, r) {
  let i = [], s = [], o, a;
  n.doc.nodesBetween(e, t, (l, u, c) => {
    if (!l.isInline)
      return;
    let f = l.marks;
    if (!r.isInSet(f) && c.type.allowsMarkType(r.type)) {
      let p = Math.max(u, e), d = Math.min(u + l.nodeSize, t), h = r.addToSet(f);
      for (let v = 0; v < f.length; v++)
        f[v].isInSet(h) || (o && o.to == p && o.mark.eq(f[v]) ? o.to = d : i.push(o = new bn(p, d, f[v])));
      a && a.to == p ? a.to = d : s.push(a = new Zn(p, d, r));
    }
  }), i.forEach((l) => n.step(l)), s.forEach((l) => n.step(l));
}
function O$(n, e, t, r) {
  let i = [], s = 0;
  n.doc.nodesBetween(e, t, (o, a) => {
    if (!o.isInline)
      return;
    s++;
    let l = null;
    if (r instanceof Fl) {
      let u = o.marks, c;
      for (; c = r.isInSet(u); )
        (l || (l = [])).push(c), u = c.removeFromSet(u);
    } else
      r ? r.isInSet(o.marks) && (l = [r]) : l = o.marks;
    if (l && l.length) {
      let u = Math.min(a + o.nodeSize, t);
      for (let c = 0; c < l.length; c++) {
        let f = l[c], p;
        for (let d = 0; d < i.length; d++) {
          let h = i[d];
          h.step == s - 1 && f.eq(i[d].style) && (p = h);
        }
        p ? (p.to = u, p.step = s) : i.push({ style: f, from: Math.max(a, e), to: u, step: s });
      }
    }
  }), i.forEach((o) => n.step(new bn(o.from, o.to, o.style)));
}
function E$(n, e, t, r = t.contentMatch) {
  let i = n.doc.nodeAt(e), s = [], o = e + 1;
  for (let a = 0; a < i.childCount; a++) {
    let l = i.child(a), u = o + l.nodeSize, c = r.matchType(l.type);
    if (!c)
      s.push(new Qe(o, u, X.empty));
    else {
      r = c;
      for (let f = 0; f < l.marks.length; f++)
        t.allowsMarkType(l.marks[f].type) || n.step(new bn(o, u, l.marks[f]));
      if (l.isText && !t.spec.code) {
        let f, p = /\r?\n|\r/g, d;
        for (; f = p.exec(l.text); )
          d || (d = new X(V.from(t.schema.text(" ", t.allowedMarks(l.marks))), 0, 0)), s.push(new Qe(o + f.index, o + f.index + f[0].length, d));
      }
    }
    o = u;
  }
  if (!r.validEnd) {
    let a = r.fillBefore(V.empty, !0);
    n.replace(o, o, new X(a, 0, 0));
  }
  for (let a = s.length - 1; a >= 0; a--)
    n.step(s[a]);
}
function T$(n, e, t) {
  return (e == 0 || n.canReplace(e, n.childCount)) && (t == n.childCount || n.canReplace(0, t));
}
function qi(n) {
  let t = n.parent.content.cutByIndex(n.startIndex, n.endIndex);
  for (let r = n.depth; ; --r) {
    let i = n.$from.node(r), s = n.$from.index(r), o = n.$to.indexAfter(r);
    if (r < n.depth && i.canReplace(s, o, t))
      return r;
    if (r == 0 || i.type.spec.isolating || !T$(i, s, o))
      break;
  }
  return null;
}
function k$(n, e, t) {
  let { $from: r, $to: i, depth: s } = e, o = r.before(s + 1), a = i.after(s + 1), l = o, u = a, c = V.empty, f = 0;
  for (let h = s, v = !1; h > t; h--)
    v || r.index(h) > 0 ? (v = !0, c = V.from(r.node(h).copy(c)), f++) : l--;
  let p = V.empty, d = 0;
  for (let h = s, v = !1; h > t; h--)
    v || i.after(h + 1) < i.end(h) ? (v = !0, p = V.from(i.node(h).copy(p)), d++) : u++;
  n.step(new qe(l, u, o, a, new X(c.append(p), f, d), c.size - f, !0));
}
function ap(n, e, t = null, r = n) {
  let i = M$(n, e), s = i && A$(r, e);
  return s ? i.map(Jm).concat({ type: e, attrs: t }).concat(s.map(Jm)) : null;
}
function Jm(n) {
  return { type: n, attrs: null };
}
function M$(n, e) {
  let { parent: t, startIndex: r, endIndex: i } = n, s = t.contentMatchAt(r).findWrapping(e);
  if (!s)
    return null;
  let o = s.length ? s[0] : e;
  return t.canReplaceWith(r, i, o) ? s : null;
}
function A$(n, e) {
  let { parent: t, startIndex: r, endIndex: i } = n, s = t.child(r), o = e.contentMatch.findWrapping(s.type);
  if (!o)
    return null;
  let l = (o.length ? o[o.length - 1] : e).contentMatch;
  for (let u = r; l && u < i; u++)
    l = l.matchType(t.child(u).type);
  return !l || !l.validEnd ? null : o;
}
function P$(n, e, t) {
  let r = V.empty;
  for (let o = t.length - 1; o >= 0; o--) {
    if (r.size) {
      let a = t[o].type.contentMatch.matchFragment(r);
      if (!a || !a.validEnd)
        throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
    }
    r = V.from(t[o].type.create(t[o].attrs, r));
  }
  let i = e.start, s = e.end;
  n.step(new qe(i, s, i, s, new X(r, 0, 0), t.length, !0));
}
function $$(n, e, t, r, i) {
  if (!r.isTextblock)
    throw new RangeError("Type given to setBlockType should be a textblock");
  let s = n.steps.length;
  n.doc.nodesBetween(e, t, (o, a) => {
    if (o.isTextblock && !o.hasMarkup(r, i) && D$(n.doc, n.mapping.slice(s).map(a), r)) {
      n.clearIncompatible(n.mapping.slice(s).map(a, 1), r);
      let l = n.mapping.slice(s), u = l.map(a, 1), c = l.map(a + o.nodeSize, 1);
      return n.step(new qe(u, c, u + 1, c - 1, new X(V.from(r.create(i, null, o.marks)), 0, 0), 1, !0)), !1;
    }
  });
}
function D$(n, e, t) {
  let r = n.resolve(e), i = r.index();
  return r.parent.canReplaceWith(i, i + 1, t);
}
function L$(n, e, t, r, i) {
  let s = n.doc.nodeAt(e);
  if (!s)
    throw new RangeError("No node at given position");
  t || (t = s.type);
  let o = t.create(r, null, i || s.marks);
  if (s.isLeaf)
    return n.replaceWith(e, e + s.nodeSize, o);
  if (!t.validContent(s.content))
    throw new RangeError("Invalid content for node type " + t.name);
  n.step(new qe(e, e + s.nodeSize, e + 1, e + s.nodeSize - 1, new X(V.from(o), 0, 0), 1, !0));
}
function _i(n, e, t = 1, r) {
  let i = n.resolve(e), s = i.depth - t, o = r && r[r.length - 1] || i.parent;
  if (s < 0 || i.parent.type.spec.isolating || !i.parent.canReplace(i.index(), i.parent.childCount) || !o.type.validContent(i.parent.content.cutByIndex(i.index(), i.parent.childCount)))
    return !1;
  for (let u = i.depth - 1, c = t - 2; u > s; u--, c--) {
    let f = i.node(u), p = i.index(u);
    if (f.type.spec.isolating)
      return !1;
    let d = f.content.cutByIndex(p, f.childCount), h = r && r[c + 1];
    h && (d = d.replaceChild(0, h.type.create(h.attrs)));
    let v = r && r[c] || f;
    if (!f.canReplace(p + 1, f.childCount) || !v.type.validContent(d))
      return !1;
  }
  let a = i.indexAfter(s), l = r && r[0];
  return i.node(s).canReplaceWith(a, a, l ? l.type : i.node(s + 1).type);
}
function N$(n, e, t = 1, r) {
  let i = n.doc.resolve(e), s = V.empty, o = V.empty;
  for (let a = i.depth, l = i.depth - t, u = t - 1; a > l; a--, u--) {
    s = V.from(i.node(a).copy(s));
    let c = r && r[u];
    o = V.from(c ? c.type.create(c.attrs, o) : i.node(a).copy(o));
  }
  n.step(new Qe(e, e, new X(s.append(o), t, t), !0));
}
function pr(n, e) {
  let t = n.resolve(e), r = t.index();
  return m0(t.nodeBefore, t.nodeAfter) && t.parent.canReplace(r, r + 1);
}
function m0(n, e) {
  return !!(n && e && !n.isLeaf && n.canAppend(e));
}
function zl(n, e, t = -1) {
  let r = n.resolve(e);
  for (let i = r.depth; ; i--) {
    let s, o, a = r.index(i);
    if (i == r.depth ? (s = r.nodeBefore, o = r.nodeAfter) : t > 0 ? (s = r.node(i + 1), a++, o = r.node(i).maybeChild(a)) : (s = r.node(i).maybeChild(a - 1), o = r.node(i + 1)), s && !s.isTextblock && m0(s, o) && r.node(i).canReplace(a, a + 1))
      return e;
    if (i == 0)
      break;
    e = t < 0 ? r.before(i) : r.after(i);
  }
}
function I$(n, e, t) {
  let r = new Qe(e - t, e + t, X.empty, !0);
  n.step(r);
}
function R$(n, e, t) {
  let r = n.resolve(e);
  if (r.parent.canReplaceWith(r.index(), r.index(), t))
    return e;
  if (r.parentOffset == 0)
    for (let i = r.depth - 1; i >= 0; i--) {
      let s = r.index(i);
      if (r.node(i).canReplaceWith(s, s, t))
        return r.before(i + 1);
      if (s > 0)
        return null;
    }
  if (r.parentOffset == r.parent.content.size)
    for (let i = r.depth - 1; i >= 0; i--) {
      let s = r.indexAfter(i);
      if (r.node(i).canReplaceWith(s, s, t))
        return r.after(i + 1);
      if (s < r.node(i).childCount)
        return null;
    }
  return null;
}
function g0(n, e, t) {
  let r = n.resolve(e);
  if (!t.content.size)
    return e;
  let i = t.content;
  for (let s = 0; s < t.openStart; s++)
    i = i.firstChild.content;
  for (let s = 1; s <= (t.openStart == 0 && t.size ? 2 : 1); s++)
    for (let o = r.depth; o >= 0; o--) {
      let a = o == r.depth ? 0 : r.pos <= (r.start(o + 1) + r.end(o + 1)) / 2 ? -1 : 1, l = r.index(o) + (a > 0 ? 1 : 0), u = r.node(o), c = !1;
      if (s == 1)
        c = u.canReplace(l, l, i);
      else {
        let f = u.contentMatchAt(l).findWrapping(i.firstChild.type);
        c = f && u.canReplaceWith(l, l, f[0]);
      }
      if (c)
        return a == 0 ? r.pos : a < 0 ? r.before(o + 1) : r.after(o + 1);
    }
  return null;
}
function lp(n, e, t = e, r = X.empty) {
  if (e == t && !r.size)
    return null;
  let i = n.resolve(e), s = n.resolve(t);
  return v0(i, s, r) ? new Qe(e, t, r) : new F$(i, s, r).fit();
}
function v0(n, e, t) {
  return !t.openStart && !t.openEnd && n.start() == e.start() && n.parent.canReplace(n.index(), e.index(), t.content);
}
class F$ {
  constructor(e, t, r) {
    this.$from = e, this.$to = t, this.unplaced = r, this.frontier = [], this.placed = V.empty;
    for (let i = 0; i <= e.depth; i++) {
      let s = e.node(i);
      this.frontier.push({
        type: s.type,
        match: s.contentMatchAt(e.indexAfter(i))
      });
    }
    for (let i = e.depth; i > 0; i--)
      this.placed = V.from(e.node(i).copy(this.placed));
  }
  get depth() {
    return this.frontier.length - 1;
  }
  fit() {
    for (; this.unplaced.size; ) {
      let u = this.findFittable();
      u ? this.placeNodes(u) : this.openMore() || this.dropNode();
    }
    let e = this.mustMoveInline(), t = this.placed.size - this.depth - this.$from.depth, r = this.$from, i = this.close(e < 0 ? this.$to : r.doc.resolve(e));
    if (!i)
      return null;
    let s = this.placed, o = r.depth, a = i.depth;
    for (; o && a && s.childCount == 1; )
      s = s.firstChild.content, o--, a--;
    let l = new X(s, o, a);
    return e > -1 ? new qe(r.pos, e, this.$to.pos, this.$to.end(), l, t) : l.size || r.pos != this.$to.pos ? new Qe(r.pos, i.pos, l) : null;
  }
  findFittable() {
    let e = this.unplaced.openStart;
    for (let t = this.unplaced.content, r = 0, i = this.unplaced.openEnd; r < e; r++) {
      let s = t.firstChild;
      if (t.childCount > 1 && (i = 0), s.type.spec.isolating && i <= r) {
        e = r;
        break;
      }
      t = s.content;
    }
    for (let t = 1; t <= 2; t++)
      for (let r = t == 1 ? e : this.unplaced.openStart; r >= 0; r--) {
        let i, s = null;
        r ? (s = Ac(this.unplaced.content, r - 1).firstChild, i = s.content) : i = this.unplaced.content;
        let o = i.firstChild;
        for (let a = this.depth; a >= 0; a--) {
          let { type: l, match: u } = this.frontier[a], c, f = null;
          if (t == 1 && (o ? u.matchType(o.type) || (f = u.fillBefore(V.from(o), !1)) : s && l.compatibleContent(s.type)))
            return { sliceDepth: r, frontierDepth: a, parent: s, inject: f };
          if (t == 2 && o && (c = u.findWrapping(o.type)))
            return { sliceDepth: r, frontierDepth: a, parent: s, wrap: c };
          if (s && u.matchType(s.type))
            break;
        }
      }
  }
  openMore() {
    let { content: e, openStart: t, openEnd: r } = this.unplaced, i = Ac(e, t);
    return !i.childCount || i.firstChild.isLeaf ? !1 : (this.unplaced = new X(e, t + 1, Math.max(r, i.size + t >= e.size - r ? t + 1 : 0)), !0);
  }
  dropNode() {
    let { content: e, openStart: t, openEnd: r } = this.unplaced, i = Ac(e, t);
    if (i.childCount <= 1 && t > 0) {
      let s = e.size - t <= t + i.size;
      this.unplaced = new X(is(e, t - 1, 1), t - 1, s ? t - 1 : r);
    } else
      this.unplaced = new X(is(e, t, 1), t, r);
  }
  placeNodes({ sliceDepth: e, frontierDepth: t, parent: r, inject: i, wrap: s }) {
    for (; this.depth > t; )
      this.closeFrontierNode();
    if (s)
      for (let v = 0; v < s.length; v++)
        this.openFrontierNode(s[v]);
    let o = this.unplaced, a = r ? r.content : o.content, l = o.openStart - e, u = 0, c = [], { match: f, type: p } = this.frontier[t];
    if (i) {
      for (let v = 0; v < i.childCount; v++)
        c.push(i.child(v));
      f = f.matchFragment(i);
    }
    let d = a.size + e - (o.content.size - o.openEnd);
    for (; u < a.childCount; ) {
      let v = a.child(u), g = f.matchType(v.type);
      if (!g)
        break;
      u++, (u > 1 || l == 0 || v.content.size) && (f = g, c.push(y0(v.mark(p.allowedMarks(v.marks)), u == 1 ? l : 0, u == a.childCount ? d : -1)));
    }
    let h = u == a.childCount;
    h || (d = -1), this.placed = ss(this.placed, t, V.from(c)), this.frontier[t].match = f, h && d < 0 && r && r.type == this.frontier[this.depth].type && this.frontier.length > 1 && this.closeFrontierNode();
    for (let v = 0, g = a; v < d; v++) {
      let m = g.lastChild;
      this.frontier.push({ type: m.type, match: m.contentMatchAt(m.childCount) }), g = m.content;
    }
    this.unplaced = h ? e == 0 ? X.empty : new X(is(o.content, e - 1, 1), e - 1, d < 0 ? o.openEnd : e - 1) : new X(is(o.content, e, u), o.openStart, o.openEnd);
  }
  mustMoveInline() {
    if (!this.$to.parent.isTextblock)
      return -1;
    let e = this.frontier[this.depth], t;
    if (!e.type.isTextblock || !Pc(this.$to, this.$to.depth, e.type, e.match, !1) || this.$to.depth == this.depth && (t = this.findCloseLevel(this.$to)) && t.depth == this.depth)
      return -1;
    let { depth: r } = this.$to, i = this.$to.after(r);
    for (; r > 1 && i == this.$to.end(--r); )
      ++i;
    return i;
  }
  findCloseLevel(e) {
    e:
      for (let t = Math.min(this.depth, e.depth); t >= 0; t--) {
        let { match: r, type: i } = this.frontier[t], s = t < e.depth && e.end(t + 1) == e.pos + (e.depth - (t + 1)), o = Pc(e, t, i, r, s);
        if (!!o) {
          for (let a = t - 1; a >= 0; a--) {
            let { match: l, type: u } = this.frontier[a], c = Pc(e, a, u, l, !0);
            if (!c || c.childCount)
              continue e;
          }
          return { depth: t, fit: o, move: s ? e.doc.resolve(e.after(t + 1)) : e };
        }
      }
  }
  close(e) {
    let t = this.findCloseLevel(e);
    if (!t)
      return null;
    for (; this.depth > t.depth; )
      this.closeFrontierNode();
    t.fit.childCount && (this.placed = ss(this.placed, t.depth, t.fit)), e = t.move;
    for (let r = t.depth + 1; r <= e.depth; r++) {
      let i = e.node(r), s = i.type.contentMatch.fillBefore(i.content, !0, e.index(r));
      this.openFrontierNode(i.type, i.attrs, s);
    }
    return e;
  }
  openFrontierNode(e, t = null, r) {
    let i = this.frontier[this.depth];
    i.match = i.match.matchType(e), this.placed = ss(this.placed, this.depth, V.from(e.create(t, r))), this.frontier.push({ type: e, match: e.contentMatch });
  }
  closeFrontierNode() {
    let t = this.frontier.pop().match.fillBefore(V.empty, !0);
    t.childCount && (this.placed = ss(this.placed, this.frontier.length, t));
  }
}
function is(n, e, t) {
  return e == 0 ? n.cutByIndex(t, n.childCount) : n.replaceChild(0, n.firstChild.copy(is(n.firstChild.content, e - 1, t)));
}
function ss(n, e, t) {
  return e == 0 ? n.append(t) : n.replaceChild(n.childCount - 1, n.lastChild.copy(ss(n.lastChild.content, e - 1, t)));
}
function Ac(n, e) {
  for (let t = 0; t < e; t++)
    n = n.firstChild.content;
  return n;
}
function y0(n, e, t) {
  if (e <= 0)
    return n;
  let r = n.content;
  return e > 1 && (r = r.replaceChild(0, y0(r.firstChild, e - 1, r.childCount == 1 ? t - 1 : 0))), e > 0 && (r = n.type.contentMatch.fillBefore(r).append(r), t <= 0 && (r = r.append(n.type.contentMatch.matchFragment(r).fillBefore(V.empty, !0)))), n.copy(r);
}
function Pc(n, e, t, r, i) {
  let s = n.node(e), o = i ? n.indexAfter(e) : n.index(e);
  if (o == s.childCount && !t.compatibleContent(s.type))
    return null;
  let a = r.fillBefore(s.content, !0, o);
  return a && !z$(t, s.content, o) ? a : null;
}
function z$(n, e, t) {
  for (let r = t; r < e.childCount; r++)
    if (!n.allowsMarks(e.child(r).marks))
      return !0;
  return !1;
}
function B$(n) {
  return n.spec.defining || n.spec.definingForContent;
}
function j$(n, e, t, r) {
  if (!r.size)
    return n.deleteRange(e, t);
  let i = n.doc.resolve(e), s = n.doc.resolve(t);
  if (v0(i, s, r))
    return n.step(new Qe(e, t, r));
  let o = w0(i, n.doc.resolve(t));
  o[o.length - 1] == 0 && o.pop();
  let a = -(i.depth + 1);
  o.unshift(a);
  for (let p = i.depth, d = i.pos - 1; p > 0; p--, d--) {
    let h = i.node(p).type.spec;
    if (h.defining || h.definingAsContext || h.isolating)
      break;
    o.indexOf(p) > -1 ? a = p : i.before(p) == d && o.splice(1, 0, -p);
  }
  let l = o.indexOf(a), u = [], c = r.openStart;
  for (let p = r.content, d = 0; ; d++) {
    let h = p.firstChild;
    if (u.push(h), d == r.openStart)
      break;
    p = h.content;
  }
  for (let p = c - 1; p >= 0; p--) {
    let d = u[p], h = B$(d.type);
    if (h && !d.sameMarkup(i.node(Math.abs(a) - 1)))
      c = p;
    else if (h || !d.type.isTextblock)
      break;
  }
  for (let p = r.openStart; p >= 0; p--) {
    let d = (p + c + 1) % (r.openStart + 1), h = u[d];
    if (!!h)
      for (let v = 0; v < o.length; v++) {
        let g = o[(v + l) % o.length], m = !0;
        g < 0 && (m = !1, g = -g);
        let _ = i.node(g - 1), y = i.index(g - 1);
        if (_.canReplaceWith(y, y, h.type, h.marks))
          return n.replace(i.before(g), m ? s.after(g) : t, new X(b0(r.content, 0, r.openStart, d), d, r.openEnd));
      }
  }
  let f = n.steps.length;
  for (let p = o.length - 1; p >= 0 && (n.replace(e, t, r), !(n.steps.length > f)); p--) {
    let d = o[p];
    d < 0 || (e = i.before(d), t = s.after(d));
  }
}
function b0(n, e, t, r, i) {
  if (e < t) {
    let s = n.firstChild;
    n = n.replaceChild(0, s.copy(b0(s.content, e + 1, t, r, s)));
  }
  if (e > r) {
    let s = i.contentMatchAt(0), o = s.fillBefore(n).append(n);
    n = o.append(s.matchFragment(o).fillBefore(V.empty, !0));
  }
  return n;
}
function V$(n, e, t, r) {
  if (!r.isInline && e == t && n.doc.resolve(e).parent.content.size) {
    let i = R$(n.doc, e, r.type);
    i != null && (e = t = i);
  }
  n.replaceRange(e, t, new X(V.from(r), 0, 0));
}
function H$(n, e, t) {
  let r = n.doc.resolve(e), i = n.doc.resolve(t), s = w0(r, i);
  for (let o = 0; o < s.length; o++) {
    let a = s[o], l = o == s.length - 1;
    if (l && a == 0 || r.node(a).type.contentMatch.validEnd)
      return n.delete(r.start(a), i.end(a));
    if (a > 0 && (l || r.node(a - 1).canReplace(r.index(a - 1), i.indexAfter(a - 1))))
      return n.delete(r.before(a), i.after(a));
  }
  for (let o = 1; o <= r.depth && o <= i.depth; o++)
    if (e - r.start(o) == r.depth - o && t > r.end(o) && i.end(o) - t != i.depth - o)
      return n.delete(r.before(o), t);
  n.delete(e, t);
}
function w0(n, e) {
  let t = [], r = Math.min(n.depth, e.depth);
  for (let i = r; i >= 0; i--) {
    let s = n.start(i);
    if (s < n.pos - (n.depth - i) || e.end(i) > e.pos + (e.depth - i) || n.node(i).type.spec.isolating || e.node(i).type.spec.isolating)
      break;
    (s == e.start(i) || i == n.depth && i == e.depth && n.parent.inlineContent && e.parent.inlineContent && i && e.start(i - 1) == s - 1) && t.push(i);
  }
  return t;
}
class Si extends at {
  constructor(e, t, r) {
    super(), this.pos = e, this.attr = t, this.value = r;
  }
  apply(e) {
    let t = e.nodeAt(this.pos);
    if (!t)
      return Ne.fail("No node at attribute step's position");
    let r = /* @__PURE__ */ Object.create(null);
    for (let s in t.attrs)
      r[s] = t.attrs[s];
    r[this.attr] = this.value;
    let i = t.type.create(r, null, t.marks);
    return Ne.fromReplace(e, this.pos, this.pos + 1, new X(V.from(i), 0, t.isLeaf ? 0 : 1));
  }
  getMap() {
    return At.empty;
  }
  invert(e) {
    return new Si(this.pos, this.attr, e.nodeAt(this.pos).attrs[this.attr]);
  }
  map(e) {
    let t = e.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new Si(t.pos, this.attr, this.value);
  }
  toJSON() {
    return { stepType: "attr", pos: this.pos, attr: this.attr, value: this.value };
  }
  static fromJSON(e, t) {
    if (typeof t.pos != "number" || typeof t.attr != "string")
      throw new RangeError("Invalid input for AttrStep.fromJSON");
    return new Si(t.pos, t.attr, t.value);
  }
}
at.jsonID("attr", Si);
class Ps extends at {
  constructor(e, t) {
    super(), this.attr = e, this.value = t;
  }
  apply(e) {
    let t = /* @__PURE__ */ Object.create(null);
    for (let i in e.attrs)
      t[i] = e.attrs[i];
    t[this.attr] = this.value;
    let r = e.type.create(t, e.content, e.marks);
    return Ne.ok(r);
  }
  getMap() {
    return At.empty;
  }
  invert(e) {
    return new Ps(this.attr, e.attrs[this.attr]);
  }
  map(e) {
    return this;
  }
  toJSON() {
    return { stepType: "docAttr", attr: this.attr, value: this.value };
  }
  static fromJSON(e, t) {
    if (typeof t.attr != "string")
      throw new RangeError("Invalid input for DocAttrStep.fromJSON");
    return new Ps(t.attr, t.value);
  }
}
at.jsonID("docAttr", Ps);
let Pi = class extends Error {
};
Pi = function n(e) {
  let t = Error.call(this, e);
  return t.__proto__ = n.prototype, t;
};
Pi.prototype = Object.create(Error.prototype);
Pi.prototype.constructor = Pi;
Pi.prototype.name = "TransformError";
class _0 {
  constructor(e) {
    this.doc = e, this.steps = [], this.docs = [], this.mapping = new wi();
  }
  get before() {
    return this.docs.length ? this.docs[0] : this.doc;
  }
  step(e) {
    let t = this.maybeStep(e);
    if (t.failed)
      throw new Pi(t.failed);
    return this;
  }
  maybeStep(e) {
    let t = e.apply(this.doc);
    return t.failed || this.addStep(e, t.doc), t;
  }
  get docChanged() {
    return this.steps.length > 0;
  }
  addStep(e, t) {
    this.docs.push(this.doc), this.steps.push(e), this.mapping.appendMap(e.getMap()), this.doc = t;
  }
  replace(e, t = e, r = X.empty) {
    let i = lp(this.doc, e, t, r);
    return i && this.step(i), this;
  }
  replaceWith(e, t, r) {
    return this.replace(e, t, new X(V.from(r), 0, 0));
  }
  delete(e, t) {
    return this.replace(e, t, X.empty);
  }
  insert(e, t) {
    return this.replaceWith(e, e, t);
  }
  replaceRange(e, t, r) {
    return j$(this, e, t, r), this;
  }
  replaceRangeWith(e, t, r) {
    return V$(this, e, t, r), this;
  }
  deleteRange(e, t) {
    return H$(this, e, t), this;
  }
  lift(e, t) {
    return k$(this, e, t), this;
  }
  join(e, t = 1) {
    return I$(this, e, t), this;
  }
  wrap(e, t) {
    return P$(this, e, t), this;
  }
  setBlockType(e, t = e, r, i = null) {
    return $$(this, e, t, r, i), this;
  }
  setNodeMarkup(e, t, r = null, i) {
    return L$(this, e, t, r, i), this;
  }
  setNodeAttribute(e, t, r) {
    return this.step(new Si(e, t, r)), this;
  }
  setDocAttribute(e, t) {
    return this.step(new Ps(e, t)), this;
  }
  addNodeMark(e, t) {
    return this.step(new er(e, t)), this;
  }
  removeNodeMark(e, t) {
    if (!(t instanceof Se)) {
      let r = this.doc.nodeAt(e);
      if (!r)
        throw new RangeError("No node at position " + e);
      if (t = t.isInSet(r.marks), !t)
        return this;
    }
    return this.step(new Ai(e, t)), this;
  }
  split(e, t = 1, r) {
    return N$(this, e, t, r), this;
  }
  addMark(e, t, r) {
    return C$(this, e, t, r), this;
  }
  removeMark(e, t, r) {
    return O$(this, e, t, r), this;
  }
  clearIncompatible(e, t, r) {
    return E$(this, e, t, r), this;
  }
}
const $c = /* @__PURE__ */ Object.create(null);
class me {
  constructor(e, t, r) {
    this.$anchor = e, this.$head = t, this.ranges = r || [new W$(e.min(t), e.max(t))];
  }
  get anchor() {
    return this.$anchor.pos;
  }
  get head() {
    return this.$head.pos;
  }
  get from() {
    return this.$from.pos;
  }
  get to() {
    return this.$to.pos;
  }
  get $from() {
    return this.ranges[0].$from;
  }
  get $to() {
    return this.ranges[0].$to;
  }
  get empty() {
    let e = this.ranges;
    for (let t = 0; t < e.length; t++)
      if (e[t].$from.pos != e[t].$to.pos)
        return !1;
    return !0;
  }
  content() {
    return this.$from.doc.slice(this.from, this.to, !0);
  }
  replace(e, t = X.empty) {
    let r = t.content.lastChild, i = null;
    for (let a = 0; a < t.openEnd; a++)
      i = r, r = r.lastChild;
    let s = e.steps.length, o = this.ranges;
    for (let a = 0; a < o.length; a++) {
      let { $from: l, $to: u } = o[a], c = e.mapping.slice(s);
      e.replaceRange(c.map(l.pos), c.map(u.pos), a ? X.empty : t), a == 0 && Qm(e, s, (r ? r.isInline : i && i.isTextblock) ? -1 : 1);
    }
  }
  replaceWith(e, t) {
    let r = e.steps.length, i = this.ranges;
    for (let s = 0; s < i.length; s++) {
      let { $from: o, $to: a } = i[s], l = e.mapping.slice(r), u = l.map(o.pos), c = l.map(a.pos);
      s ? e.deleteRange(u, c) : (e.replaceRangeWith(u, c, t), Qm(e, r, t.isInline ? -1 : 1));
    }
  }
  static findFrom(e, t, r = !1) {
    let i = e.parent.inlineContent ? new de(e) : fi(e.node(0), e.parent, e.pos, e.index(), t, r);
    if (i)
      return i;
    for (let s = e.depth - 1; s >= 0; s--) {
      let o = t < 0 ? fi(e.node(0), e.node(s), e.before(s + 1), e.index(s), t, r) : fi(e.node(0), e.node(s), e.after(s + 1), e.index(s) + 1, t, r);
      if (o)
        return o;
    }
    return null;
  }
  static near(e, t = 1) {
    return this.findFrom(e, t) || this.findFrom(e, -t) || new rn(e.node(0));
  }
  static atStart(e) {
    return fi(e, e, 0, 0, 1) || new rn(e);
  }
  static atEnd(e) {
    return fi(e, e, e.content.size, e.childCount, -1) || new rn(e);
  }
  static fromJSON(e, t) {
    if (!t || !t.type)
      throw new RangeError("Invalid input for Selection.fromJSON");
    let r = $c[t.type];
    if (!r)
      throw new RangeError(`No selection type ${t.type} defined`);
    return r.fromJSON(e, t);
  }
  static jsonID(e, t) {
    if (e in $c)
      throw new RangeError("Duplicate use of selection JSON ID " + e);
    return $c[e] = t, t.prototype.jsonID = e, t;
  }
  getBookmark() {
    return de.between(this.$anchor, this.$head).getBookmark();
  }
}
me.prototype.visible = !0;
class W$ {
  constructor(e, t) {
    this.$from = e, this.$to = t;
  }
}
let Xm = !1;
function Ym(n) {
  !Xm && !n.parent.inlineContent && (Xm = !0, console.warn("TextSelection endpoint not pointing into a node with inline content (" + n.parent.type.name + ")"));
}
class de extends me {
  constructor(e, t = e) {
    Ym(e), Ym(t), super(e, t);
  }
  get $cursor() {
    return this.$anchor.pos == this.$head.pos ? this.$head : null;
  }
  map(e, t) {
    let r = e.resolve(t.map(this.head));
    if (!r.parent.inlineContent)
      return me.near(r);
    let i = e.resolve(t.map(this.anchor));
    return new de(i.parent.inlineContent ? i : r, r);
  }
  replace(e, t = X.empty) {
    if (super.replace(e, t), t == X.empty) {
      let r = this.$from.marksAcross(this.$to);
      r && e.ensureMarks(r);
    }
  }
  eq(e) {
    return e instanceof de && e.anchor == this.anchor && e.head == this.head;
  }
  getBookmark() {
    return new Bl(this.anchor, this.head);
  }
  toJSON() {
    return { type: "text", anchor: this.anchor, head: this.head };
  }
  static fromJSON(e, t) {
    if (typeof t.anchor != "number" || typeof t.head != "number")
      throw new RangeError("Invalid input for TextSelection.fromJSON");
    return new de(e.resolve(t.anchor), e.resolve(t.head));
  }
  static create(e, t, r = t) {
    let i = e.resolve(t);
    return new this(i, r == t ? i : e.resolve(r));
  }
  static between(e, t, r) {
    let i = e.pos - t.pos;
    if ((!r || i) && (r = i >= 0 ? 1 : -1), !t.parent.inlineContent) {
      let s = me.findFrom(t, r, !0) || me.findFrom(t, -r, !0);
      if (s)
        t = s.$head;
      else
        return me.near(t, r);
    }
    return e.parent.inlineContent || (i == 0 ? e = t : (e = (me.findFrom(e, -r, !0) || me.findFrom(e, r, !0)).$anchor, e.pos < t.pos != i < 0 && (e = t))), new de(e, t);
  }
}
me.jsonID("text", de);
class Bl {
  constructor(e, t) {
    this.anchor = e, this.head = t;
  }
  map(e) {
    return new Bl(e.map(this.anchor), e.map(this.head));
  }
  resolve(e) {
    return de.between(e.resolve(this.anchor), e.resolve(this.head));
  }
}
class te extends me {
  constructor(e) {
    let t = e.nodeAfter, r = e.node(0).resolve(e.pos + t.nodeSize);
    super(e, r), this.node = t;
  }
  map(e, t) {
    let { deleted: r, pos: i } = t.mapResult(this.anchor), s = e.resolve(i);
    return r ? me.near(s) : new te(s);
  }
  content() {
    return new X(V.from(this.node), 0, 0);
  }
  eq(e) {
    return e instanceof te && e.anchor == this.anchor;
  }
  toJSON() {
    return { type: "node", anchor: this.anchor };
  }
  getBookmark() {
    return new up(this.anchor);
  }
  static fromJSON(e, t) {
    if (typeof t.anchor != "number")
      throw new RangeError("Invalid input for NodeSelection.fromJSON");
    return new te(e.resolve(t.anchor));
  }
  static create(e, t) {
    return new te(e.resolve(t));
  }
  static isSelectable(e) {
    return !e.isText && e.type.spec.selectable !== !1;
  }
}
te.prototype.visible = !1;
me.jsonID("node", te);
class up {
  constructor(e) {
    this.anchor = e;
  }
  map(e) {
    let { deleted: t, pos: r } = e.mapResult(this.anchor);
    return t ? new Bl(r, r) : new up(r);
  }
  resolve(e) {
    let t = e.resolve(this.anchor), r = t.nodeAfter;
    return r && te.isSelectable(r) ? new te(t) : me.near(t);
  }
}
class rn extends me {
  constructor(e) {
    super(e.resolve(0), e.resolve(e.content.size));
  }
  replace(e, t = X.empty) {
    if (t == X.empty) {
      e.delete(0, e.doc.content.size);
      let r = me.atStart(e.doc);
      r.eq(e.selection) || e.setSelection(r);
    } else
      super.replace(e, t);
  }
  toJSON() {
    return { type: "all" };
  }
  static fromJSON(e) {
    return new rn(e);
  }
  map(e) {
    return new rn(e);
  }
  eq(e) {
    return e instanceof rn;
  }
  getBookmark() {
    return q$;
  }
}
me.jsonID("all", rn);
const q$ = {
  map() {
    return this;
  },
  resolve(n) {
    return new rn(n);
  }
};
function fi(n, e, t, r, i, s = !1) {
  if (e.inlineContent)
    return de.create(n, t);
  for (let o = r - (i > 0 ? 0 : 1); i > 0 ? o < e.childCount : o >= 0; o += i) {
    let a = e.child(o);
    if (a.isAtom) {
      if (!s && te.isSelectable(a))
        return te.create(n, t - (i < 0 ? a.nodeSize : 0));
    } else {
      let l = fi(n, a, t + i, i < 0 ? a.childCount : 0, i, s);
      if (l)
        return l;
    }
    t += a.nodeSize * i;
  }
  return null;
}
function Qm(n, e, t) {
  let r = n.steps.length - 1;
  if (r < e)
    return;
  let i = n.steps[r];
  if (!(i instanceof Qe || i instanceof qe))
    return;
  let s = n.mapping.maps[r], o;
  s.forEach((a, l, u, c) => {
    o == null && (o = c);
  }), n.setSelection(me.near(n.doc.resolve(o), t));
}
const Zm = 1, Po = 2, eg = 4;
class U$ extends _0 {
  constructor(e) {
    super(e.doc), this.curSelectionFor = 0, this.updated = 0, this.meta = /* @__PURE__ */ Object.create(null), this.time = Date.now(), this.curSelection = e.selection, this.storedMarks = e.storedMarks;
  }
  get selection() {
    return this.curSelectionFor < this.steps.length && (this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor)), this.curSelectionFor = this.steps.length), this.curSelection;
  }
  setSelection(e) {
    if (e.$from.doc != this.doc)
      throw new RangeError("Selection passed to setSelection must point at the current document");
    return this.curSelection = e, this.curSelectionFor = this.steps.length, this.updated = (this.updated | Zm) & ~Po, this.storedMarks = null, this;
  }
  get selectionSet() {
    return (this.updated & Zm) > 0;
  }
  setStoredMarks(e) {
    return this.storedMarks = e, this.updated |= Po, this;
  }
  ensureMarks(e) {
    return Se.sameSet(this.storedMarks || this.selection.$from.marks(), e) || this.setStoredMarks(e), this;
  }
  addStoredMark(e) {
    return this.ensureMarks(e.addToSet(this.storedMarks || this.selection.$head.marks()));
  }
  removeStoredMark(e) {
    return this.ensureMarks(e.removeFromSet(this.storedMarks || this.selection.$head.marks()));
  }
  get storedMarksSet() {
    return (this.updated & Po) > 0;
  }
  addStep(e, t) {
    super.addStep(e, t), this.updated = this.updated & ~Po, this.storedMarks = null;
  }
  setTime(e) {
    return this.time = e, this;
  }
  replaceSelection(e) {
    return this.selection.replace(this, e), this;
  }
  replaceSelectionWith(e, t = !0) {
    let r = this.selection;
    return t && (e = e.mark(this.storedMarks || (r.empty ? r.$from.marks() : r.$from.marksAcross(r.$to) || Se.none))), r.replaceWith(this, e), this;
  }
  deleteSelection() {
    return this.selection.replace(this), this;
  }
  insertText(e, t, r) {
    let i = this.doc.type.schema;
    if (t == null)
      return e ? this.replaceSelectionWith(i.text(e), !0) : this.deleteSelection();
    {
      if (r == null && (r = t), r = r == null ? t : r, !e)
        return this.deleteRange(t, r);
      let s = this.storedMarks;
      if (!s) {
        let o = this.doc.resolve(t);
        s = r == t ? o.marks() : o.marksAcross(this.doc.resolve(r));
      }
      return this.replaceRangeWith(t, r, i.text(e, s)), this.selection.empty || this.setSelection(me.near(this.selection.$to)), this;
    }
  }
  setMeta(e, t) {
    return this.meta[typeof e == "string" ? e : e.key] = t, this;
  }
  getMeta(e) {
    return this.meta[typeof e == "string" ? e : e.key];
  }
  get isGeneric() {
    for (let e in this.meta)
      return !1;
    return !0;
  }
  scrollIntoView() {
    return this.updated |= eg, this;
  }
  get scrolledIntoView() {
    return (this.updated & eg) > 0;
  }
}
function tg(n, e) {
  return !e || !n ? n : n.bind(e);
}
class as {
  constructor(e, t, r) {
    this.name = e, this.init = tg(t.init, r), this.apply = tg(t.apply, r);
  }
}
const G$ = [
  new as("doc", {
    init(n) {
      return n.doc || n.schema.topNodeType.createAndFill();
    },
    apply(n) {
      return n.doc;
    }
  }),
  new as("selection", {
    init(n, e) {
      return n.selection || me.atStart(e.doc);
    },
    apply(n) {
      return n.selection;
    }
  }),
  new as("storedMarks", {
    init(n) {
      return n.storedMarks || null;
    },
    apply(n, e, t, r) {
      return r.selection.$cursor ? n.storedMarks : null;
    }
  }),
  new as("scrollToSelection", {
    init() {
      return 0;
    },
    apply(n, e) {
      return n.scrolledIntoView ? e + 1 : e;
    }
  })
];
class Dc {
  constructor(e, t) {
    this.schema = e, this.plugins = [], this.pluginsByKey = /* @__PURE__ */ Object.create(null), this.fields = G$.slice(), t && t.forEach((r) => {
      if (this.pluginsByKey[r.key])
        throw new RangeError("Adding different instances of a keyed plugin (" + r.key + ")");
      this.plugins.push(r), this.pluginsByKey[r.key] = r, r.spec.state && this.fields.push(new as(r.key, r.spec.state, r));
    });
  }
}
class yi {
  constructor(e) {
    this.config = e;
  }
  get schema() {
    return this.config.schema;
  }
  get plugins() {
    return this.config.plugins;
  }
  apply(e) {
    return this.applyTransaction(e).state;
  }
  filterTransaction(e, t = -1) {
    for (let r = 0; r < this.config.plugins.length; r++)
      if (r != t) {
        let i = this.config.plugins[r];
        if (i.spec.filterTransaction && !i.spec.filterTransaction.call(i, e, this))
          return !1;
      }
    return !0;
  }
  applyTransaction(e) {
    if (!this.filterTransaction(e))
      return { state: this, transactions: [] };
    let t = [e], r = this.applyInner(e), i = null;
    for (; ; ) {
      let s = !1;
      for (let o = 0; o < this.config.plugins.length; o++) {
        let a = this.config.plugins[o];
        if (a.spec.appendTransaction) {
          let l = i ? i[o].n : 0, u = i ? i[o].state : this, c = l < t.length && a.spec.appendTransaction.call(a, l ? t.slice(l) : t, u, r);
          if (c && r.filterTransaction(c, o)) {
            if (c.setMeta("appendedTransaction", e), !i) {
              i = [];
              for (let f = 0; f < this.config.plugins.length; f++)
                i.push(f < o ? { state: r, n: t.length } : { state: this, n: 0 });
            }
            t.push(c), r = r.applyInner(c), s = !0;
          }
          i && (i[o] = { state: r, n: t.length });
        }
      }
      if (!s)
        return { state: r, transactions: t };
    }
  }
  applyInner(e) {
    if (!e.before.eq(this.doc))
      throw new RangeError("Applying a mismatched transaction");
    let t = new yi(this.config), r = this.config.fields;
    for (let i = 0; i < r.length; i++) {
      let s = r[i];
      t[s.name] = s.apply(e, this[s.name], this, t);
    }
    return t;
  }
  get tr() {
    return new U$(this);
  }
  static create(e) {
    let t = new Dc(e.doc ? e.doc.type.schema : e.schema, e.plugins), r = new yi(t);
    for (let i = 0; i < t.fields.length; i++)
      r[t.fields[i].name] = t.fields[i].init(e, r);
    return r;
  }
  reconfigure(e) {
    let t = new Dc(this.schema, e.plugins), r = t.fields, i = new yi(t);
    for (let s = 0; s < r.length; s++) {
      let o = r[s].name;
      i[o] = this.hasOwnProperty(o) ? this[o] : r[s].init(e, i);
    }
    return i;
  }
  toJSON(e) {
    let t = { doc: this.doc.toJSON(), selection: this.selection.toJSON() };
    if (this.storedMarks && (t.storedMarks = this.storedMarks.map((r) => r.toJSON())), e && typeof e == "object")
      for (let r in e) {
        if (r == "doc" || r == "selection")
          throw new RangeError("The JSON fields `doc` and `selection` are reserved");
        let i = e[r], s = i.spec.state;
        s && s.toJSON && (t[r] = s.toJSON.call(i, this[i.key]));
      }
    return t;
  }
  static fromJSON(e, t, r) {
    if (!t)
      throw new RangeError("Invalid input for EditorState.fromJSON");
    if (!e.schema)
      throw new RangeError("Required config field 'schema' missing");
    let i = new Dc(e.schema, e.plugins), s = new yi(i);
    return i.fields.forEach((o) => {
      if (o.name == "doc")
        s.doc = wn.fromJSON(e.schema, t.doc);
      else if (o.name == "selection")
        s.selection = me.fromJSON(s.doc, t.selection);
      else if (o.name == "storedMarks")
        t.storedMarks && (s.storedMarks = t.storedMarks.map(e.schema.markFromJSON));
      else {
        if (r)
          for (let a in r) {
            let l = r[a], u = l.spec.state;
            if (l.key == o.name && u && u.fromJSON && Object.prototype.hasOwnProperty.call(t, a)) {
              s[o.name] = u.fromJSON.call(l, e, t[a], s);
              return;
            }
          }
        s[o.name] = o.init(e, s);
      }
    }), s;
  }
}
function S0(n, e, t) {
  for (let r in n) {
    let i = n[r];
    i instanceof Function ? i = i.bind(e) : r == "handleDOMEvents" && (i = S0(i, e, {})), t[r] = i;
  }
  return t;
}
class lt {
  constructor(e) {
    this.spec = e, this.props = {}, e.props && S0(e.props, this, this.props), this.key = e.key ? e.key.key : x0("plugin");
  }
  getState(e) {
    return e[this.key];
  }
}
const Lc = /* @__PURE__ */ Object.create(null);
function x0(n) {
  return n in Lc ? n + "$" + ++Lc[n] : (Lc[n] = 0, n + "$");
}
class Zt {
  constructor(e = "key") {
    this.key = x0(e);
  }
  get(e) {
    return e.config.pluginsByKey[this.key];
  }
  getState(e) {
    return e[this.key];
  }
}
const dt = function(n) {
  for (var e = 0; ; e++)
    if (n = n.previousSibling, !n)
      return e;
}, $s = function(n) {
  let e = n.assignedSlot || n.parentNode;
  return e && e.nodeType == 11 ? e.host : e;
};
let ng = null;
const Pn = function(n, e, t) {
  let r = ng || (ng = document.createRange());
  return r.setEnd(n, t == null ? n.nodeValue.length : t), r.setStart(n, e || 0), r;
}, jr = function(n, e, t, r) {
  return t && (rg(n, e, t, r, -1) || rg(n, e, t, r, 1));
}, K$ = /^(img|br|input|textarea|hr)$/i;
function rg(n, e, t, r, i) {
  for (; ; ) {
    if (n == t && e == r)
      return !0;
    if (e == (i < 0 ? 0 : gn(n))) {
      let s = n.parentNode;
      if (!s || s.nodeType != 1 || cp(n) || K$.test(n.nodeName) || n.contentEditable == "false")
        return !1;
      e = dt(n) + (i < 0 ? 0 : 1), n = s;
    } else if (n.nodeType == 1) {
      if (n = n.childNodes[e + (i < 0 ? -1 : 0)], n.contentEditable == "false")
        return !1;
      e = i < 0 ? gn(n) : 0;
    } else
      return !1;
  }
}
function gn(n) {
  return n.nodeType == 3 ? n.nodeValue.length : n.childNodes.length;
}
function J$(n, e, t) {
  for (let r = e == 0, i = e == gn(n); r || i; ) {
    if (n == t)
      return !0;
    let s = dt(n);
    if (n = n.parentNode, !n)
      return !1;
    r = r && s == 0, i = i && s == gn(n);
  }
}
function cp(n) {
  let e;
  for (let t = n; t && !(e = t.pmViewDesc); t = t.parentNode)
    ;
  return e && e.node && e.node.isBlock && (e.dom == n || e.contentDOM == n);
}
const jl = function(n) {
  return n.focusNode && jr(n.focusNode, n.focusOffset, n.anchorNode, n.anchorOffset);
};
function Or(n, e) {
  let t = document.createEvent("Event");
  return t.initEvent("keydown", !0, !0), t.keyCode = n, t.key = t.code = e, t;
}
function X$(n) {
  let e = n.activeElement;
  for (; e && e.shadowRoot; )
    e = e.shadowRoot.activeElement;
  return e;
}
function Y$(n, e, t) {
  if (n.caretPositionFromPoint)
    try {
      let r = n.caretPositionFromPoint(e, t);
      if (r)
        return { node: r.offsetNode, offset: r.offset };
    } catch {
    }
  if (n.caretRangeFromPoint) {
    let r = n.caretRangeFromPoint(e, t);
    if (r)
      return { node: r.startContainer, offset: r.startOffset };
  }
}
const xn = typeof navigator < "u" ? navigator : null, ig = typeof document < "u" ? document : null, hr = xn && xn.userAgent || "", Vd = /Edge\/(\d+)/.exec(hr), C0 = /MSIE \d/.exec(hr), Hd = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(hr), xt = !!(C0 || Hd || Vd), sr = C0 ? document.documentMode : Hd ? +Hd[1] : Vd ? +Vd[1] : 0, on = !xt && /gecko\/(\d+)/i.test(hr);
on && +(/Firefox\/(\d+)/.exec(hr) || [0, 0])[1];
const Wd = !xt && /Chrome\/(\d+)/.exec(hr), rt = !!Wd, Q$ = Wd ? +Wd[1] : 0, mt = !xt && !!xn && /Apple Computer/.test(xn.vendor), $i = mt && (/Mobile\/\w+/.test(hr) || !!xn && xn.maxTouchPoints > 2), qt = $i || (xn ? /Mac/.test(xn.platform) : !1), Z$ = xn ? /Win/.test(xn.platform) : !1, tn = /Android \d/.test(hr), eo = !!ig && "webkitFontSmoothing" in ig.documentElement.style, eD = eo ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0;
function tD(n) {
  return {
    left: 0,
    right: n.documentElement.clientWidth,
    top: 0,
    bottom: n.documentElement.clientHeight
  };
}
function kn(n, e) {
  return typeof n == "number" ? n : n[e];
}
function nD(n) {
  let e = n.getBoundingClientRect(), t = e.width / n.offsetWidth || 1, r = e.height / n.offsetHeight || 1;
  return {
    left: e.left,
    right: e.left + n.clientWidth * t,
    top: e.top,
    bottom: e.top + n.clientHeight * r
  };
}
function sg(n, e, t) {
  let r = n.someProp("scrollThreshold") || 0, i = n.someProp("scrollMargin") || 5, s = n.dom.ownerDocument;
  for (let o = t || n.dom; o; o = $s(o)) {
    if (o.nodeType != 1)
      continue;
    let a = o, l = a == s.body, u = l ? tD(s) : nD(a), c = 0, f = 0;
    if (e.top < u.top + kn(r, "top") ? f = -(u.top - e.top + kn(i, "top")) : e.bottom > u.bottom - kn(r, "bottom") && (f = e.bottom - e.top > u.bottom - u.top ? e.top + kn(i, "top") - u.top : e.bottom - u.bottom + kn(i, "bottom")), e.left < u.left + kn(r, "left") ? c = -(u.left - e.left + kn(i, "left")) : e.right > u.right - kn(r, "right") && (c = e.right - u.right + kn(i, "right")), c || f)
      if (l)
        s.defaultView.scrollBy(c, f);
      else {
        let p = a.scrollLeft, d = a.scrollTop;
        f && (a.scrollTop += f), c && (a.scrollLeft += c);
        let h = a.scrollLeft - p, v = a.scrollTop - d;
        e = { left: e.left - h, top: e.top - v, right: e.right - h, bottom: e.bottom - v };
      }
    if (l || /^(fixed|sticky)$/.test(getComputedStyle(o).position))
      break;
  }
}
function rD(n) {
  let e = n.dom.getBoundingClientRect(), t = Math.max(0, e.top), r, i;
  for (let s = (e.left + e.right) / 2, o = t + 1; o < Math.min(innerHeight, e.bottom); o += 5) {
    let a = n.root.elementFromPoint(s, o);
    if (!a || a == n.dom || !n.dom.contains(a))
      continue;
    let l = a.getBoundingClientRect();
    if (l.top >= t - 20) {
      r = a, i = l.top;
      break;
    }
  }
  return { refDOM: r, refTop: i, stack: O0(n.dom) };
}
function O0(n) {
  let e = [], t = n.ownerDocument;
  for (let r = n; r && (e.push({ dom: r, top: r.scrollTop, left: r.scrollLeft }), n != t); r = $s(r))
    ;
  return e;
}
function iD({ refDOM: n, refTop: e, stack: t }) {
  let r = n ? n.getBoundingClientRect().top : 0;
  E0(t, r == 0 ? 0 : r - e);
}
function E0(n, e) {
  for (let t = 0; t < n.length; t++) {
    let { dom: r, top: i, left: s } = n[t];
    r.scrollTop != i + e && (r.scrollTop = i + e), r.scrollLeft != s && (r.scrollLeft = s);
  }
}
let si = null;
function sD(n) {
  if (n.setActive)
    return n.setActive();
  if (si)
    return n.focus(si);
  let e = O0(n);
  n.focus(si == null ? {
    get preventScroll() {
      return si = { preventScroll: !0 }, !0;
    }
  } : void 0), si || (si = !1, E0(e, 0));
}
function T0(n, e) {
  let t, r = 2e8, i, s = 0, o = e.top, a = e.top, l, u;
  for (let c = n.firstChild, f = 0; c; c = c.nextSibling, f++) {
    let p;
    if (c.nodeType == 1)
      p = c.getClientRects();
    else if (c.nodeType == 3)
      p = Pn(c).getClientRects();
    else
      continue;
    for (let d = 0; d < p.length; d++) {
      let h = p[d];
      if (h.top <= o && h.bottom >= a) {
        o = Math.max(h.bottom, o), a = Math.min(h.top, a);
        let v = h.left > e.left ? h.left - e.left : h.right < e.left ? e.left - h.right : 0;
        if (v < r) {
          t = c, r = v, i = v && t.nodeType == 3 ? {
            left: h.right < e.left ? h.right : h.left,
            top: e.top
          } : e, c.nodeType == 1 && v && (s = f + (e.left >= (h.left + h.right) / 2 ? 1 : 0));
          continue;
        }
      } else
        h.top > e.top && !l && h.left <= e.left && h.right >= e.left && (l = c, u = { left: Math.max(h.left, Math.min(h.right, e.left)), top: h.top });
      !t && (e.left >= h.right && e.top >= h.top || e.left >= h.left && e.top >= h.bottom) && (s = f + 1);
    }
  }
  return !t && l && (t = l, i = u, r = 0), t && t.nodeType == 3 ? oD(t, i) : !t || r && t.nodeType == 1 ? { node: n, offset: s } : T0(t, i);
}
function oD(n, e) {
  let t = n.nodeValue.length, r = document.createRange();
  for (let i = 0; i < t; i++) {
    r.setEnd(n, i + 1), r.setStart(n, i);
    let s = Hn(r, 1);
    if (s.top != s.bottom && dp(e, s))
      return { node: n, offset: i + (e.left >= (s.left + s.right) / 2 ? 1 : 0) };
  }
  return { node: n, offset: 0 };
}
function dp(n, e) {
  return n.left >= e.left - 1 && n.left <= e.right + 1 && n.top >= e.top - 1 && n.top <= e.bottom + 1;
}
function aD(n, e) {
  let t = n.parentNode;
  return t && /^li$/i.test(t.nodeName) && e.left < n.getBoundingClientRect().left ? t : n;
}
function lD(n, e, t) {
  let { node: r, offset: i } = T0(e, t), s = -1;
  if (r.nodeType == 1 && !r.firstChild) {
    let o = r.getBoundingClientRect();
    s = o.left != o.right && t.left > (o.left + o.right) / 2 ? 1 : -1;
  }
  return n.docView.posFromDOM(r, i, s);
}
function uD(n, e, t, r) {
  let i = -1;
  for (let s = e, o = !1; s != n.dom; ) {
    let a = n.docView.nearestDesc(s, !0);
    if (!a)
      return null;
    if (a.dom.nodeType == 1 && (a.node.isBlock && a.parent && !o || !a.contentDOM)) {
      let l = a.dom.getBoundingClientRect();
      if (a.node.isBlock && a.parent && !o && (o = !0, l.left > r.left || l.top > r.top ? i = a.posBefore : (l.right < r.left || l.bottom < r.top) && (i = a.posAfter)), !a.contentDOM && i < 0 && !a.node.isText)
        return (a.node.isBlock ? r.top < (l.top + l.bottom) / 2 : r.left < (l.left + l.right) / 2) ? a.posBefore : a.posAfter;
    }
    s = a.dom.parentNode;
  }
  return i > -1 ? i : n.docView.posFromDOM(e, t, -1);
}
function k0(n, e, t) {
  let r = n.childNodes.length;
  if (r && t.top < t.bottom)
    for (let i = Math.max(0, Math.min(r - 1, Math.floor(r * (e.top - t.top) / (t.bottom - t.top)) - 2)), s = i; ; ) {
      let o = n.childNodes[s];
      if (o.nodeType == 1) {
        let a = o.getClientRects();
        for (let l = 0; l < a.length; l++) {
          let u = a[l];
          if (dp(e, u))
            return k0(o, e, u);
        }
      }
      if ((s = (s + 1) % r) == i)
        break;
    }
  return n;
}
function cD(n, e) {
  let t = n.dom.ownerDocument, r, i = 0, s = Y$(t, e.left, e.top);
  s && ({ node: r, offset: i } = s);
  let o = (n.root.elementFromPoint ? n.root : t).elementFromPoint(e.left, e.top), a;
  if (!o || !n.dom.contains(o.nodeType != 1 ? o.parentNode : o)) {
    let u = n.dom.getBoundingClientRect();
    if (!dp(e, u) || (o = k0(n.dom, e, u), !o))
      return null;
  }
  if (mt)
    for (let u = o; r && u; u = $s(u))
      u.draggable && (r = void 0);
  if (o = aD(o, e), r) {
    if (on && r.nodeType == 1 && (i = Math.min(i, r.childNodes.length), i < r.childNodes.length)) {
      let c = r.childNodes[i], f;
      c.nodeName == "IMG" && (f = c.getBoundingClientRect()).right <= e.left && f.bottom > e.top && i++;
    }
    let u;
    eo && i && r.nodeType == 1 && (u = r.childNodes[i - 1]).nodeType == 1 && u.contentEditable == "false" && u.getBoundingClientRect().top >= e.top && i--, r == n.dom && i == r.childNodes.length - 1 && r.lastChild.nodeType == 1 && e.top > r.lastChild.getBoundingClientRect().bottom ? a = n.state.doc.content.size : (i == 0 || r.nodeType != 1 || r.childNodes[i - 1].nodeName != "BR") && (a = uD(n, r, i, e));
  }
  a == null && (a = lD(n, o, e));
  let l = n.docView.nearestDesc(o, !0);
  return { pos: a, inside: l ? l.posAtStart - l.border : -1 };
}
function og(n) {
  return n.top < n.bottom || n.left < n.right;
}
function Hn(n, e) {
  let t = n.getClientRects();
  if (t.length) {
    let r = t[e < 0 ? 0 : t.length - 1];
    if (og(r))
      return r;
  }
  return Array.prototype.find.call(t, og) || n.getBoundingClientRect();
}
const dD = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
function M0(n, e, t) {
  let { node: r, offset: i, atom: s } = n.docView.domFromPos(e, t < 0 ? -1 : 1), o = eo || on;
  if (r.nodeType == 3)
    if (o && (dD.test(r.nodeValue) || (t < 0 ? !i : i == r.nodeValue.length))) {
      let l = Hn(Pn(r, i, i), t);
      if (on && i && /\s/.test(r.nodeValue[i - 1]) && i < r.nodeValue.length) {
        let u = Hn(Pn(r, i - 1, i - 1), -1);
        if (u.top == l.top) {
          let c = Hn(Pn(r, i, i + 1), -1);
          if (c.top != l.top)
            return ts(c, c.left < u.left);
        }
      }
      return l;
    } else {
      let l = i, u = i, c = t < 0 ? 1 : -1;
      return t < 0 && !i ? (u++, c = -1) : t >= 0 && i == r.nodeValue.length ? (l--, c = 1) : t < 0 ? l-- : u++, ts(Hn(Pn(r, l, u), c), c < 0);
    }
  if (!n.state.doc.resolve(e - (s || 0)).parent.inlineContent) {
    if (s == null && i && (t < 0 || i == gn(r))) {
      let l = r.childNodes[i - 1];
      if (l.nodeType == 1)
        return Nc(l.getBoundingClientRect(), !1);
    }
    if (s == null && i < gn(r)) {
      let l = r.childNodes[i];
      if (l.nodeType == 1)
        return Nc(l.getBoundingClientRect(), !0);
    }
    return Nc(r.getBoundingClientRect(), t >= 0);
  }
  if (s == null && i && (t < 0 || i == gn(r))) {
    let l = r.childNodes[i - 1], u = l.nodeType == 3 ? Pn(l, gn(l) - (o ? 0 : 1)) : l.nodeType == 1 && (l.nodeName != "BR" || !l.nextSibling) ? l : null;
    if (u)
      return ts(Hn(u, 1), !1);
  }
  if (s == null && i < gn(r)) {
    let l = r.childNodes[i];
    for (; l.pmViewDesc && l.pmViewDesc.ignoreForCoords; )
      l = l.nextSibling;
    let u = l ? l.nodeType == 3 ? Pn(l, 0, o ? 0 : 1) : l.nodeType == 1 ? l : null : null;
    if (u)
      return ts(Hn(u, -1), !0);
  }
  return ts(Hn(r.nodeType == 3 ? Pn(r) : r, -t), t >= 0);
}
function ts(n, e) {
  if (n.width == 0)
    return n;
  let t = e ? n.left : n.right;
  return { top: n.top, bottom: n.bottom, left: t, right: t };
}
function Nc(n, e) {
  if (n.height == 0)
    return n;
  let t = e ? n.top : n.bottom;
  return { top: t, bottom: t, left: n.left, right: n.right };
}
function A0(n, e, t) {
  let r = n.state, i = n.root.activeElement;
  r != e && n.updateState(e), i != n.dom && n.focus();
  try {
    return t();
  } finally {
    r != e && n.updateState(r), i != n.dom && i && i.focus();
  }
}
function fD(n, e, t) {
  let r = e.selection, i = t == "up" ? r.$from : r.$to;
  return A0(n, e, () => {
    let { node: s } = n.docView.domFromPos(i.pos, t == "up" ? -1 : 1);
    for (; ; ) {
      let a = n.docView.nearestDesc(s, !0);
      if (!a)
        break;
      if (a.node.isBlock) {
        s = a.contentDOM || a.dom;
        break;
      }
      s = a.dom.parentNode;
    }
    let o = M0(n, i.pos, 1);
    for (let a = s.firstChild; a; a = a.nextSibling) {
      let l;
      if (a.nodeType == 1)
        l = a.getClientRects();
      else if (a.nodeType == 3)
        l = Pn(a, 0, a.nodeValue.length).getClientRects();
      else
        continue;
      for (let u = 0; u < l.length; u++) {
        let c = l[u];
        if (c.bottom > c.top + 1 && (t == "up" ? o.top - c.top > (c.bottom - o.top) * 2 : c.bottom - o.bottom > (o.bottom - c.top) * 2))
          return !1;
      }
    }
    return !0;
  });
}
const pD = /[\u0590-\u08ac]/;
function hD(n, e, t) {
  let { $head: r } = e.selection;
  if (!r.parent.isTextblock)
    return !1;
  let i = r.parentOffset, s = !i, o = i == r.parent.content.size, a = n.domSelection();
  return !pD.test(r.parent.textContent) || !a.modify ? t == "left" || t == "backward" ? s : o : A0(n, e, () => {
    let { focusNode: l, focusOffset: u, anchorNode: c, anchorOffset: f } = n.domSelectionRange(), p = a.caretBidiLevel;
    a.modify("move", t, "character");
    let d = r.depth ? n.docView.domAfterPos(r.before()) : n.dom, { focusNode: h, focusOffset: v } = n.domSelectionRange(), g = h && !d.contains(h.nodeType == 1 ? h : h.parentNode) || l == h && u == v;
    try {
      a.collapse(c, f), l && (l != c || u != f) && a.extend && a.extend(l, u);
    } catch {
    }
    return p != null && (a.caretBidiLevel = p), g;
  });
}
let ag = null, lg = null, ug = !1;
function mD(n, e, t) {
  return ag == e && lg == t ? ug : (ag = e, lg = t, ug = t == "up" || t == "down" ? fD(n, e, t) : hD(n, e, t));
}
const Jt = 0, cg = 1, Mr = 2, Cn = 3;
class to {
  constructor(e, t, r, i) {
    this.parent = e, this.children = t, this.dom = r, this.contentDOM = i, this.dirty = Jt, r.pmViewDesc = this;
  }
  matchesWidget(e) {
    return !1;
  }
  matchesMark(e) {
    return !1;
  }
  matchesNode(e, t, r) {
    return !1;
  }
  matchesHack(e) {
    return !1;
  }
  parseRule() {
    return null;
  }
  stopEvent(e) {
    return !1;
  }
  get size() {
    let e = 0;
    for (let t = 0; t < this.children.length; t++)
      e += this.children[t].size;
    return e;
  }
  get border() {
    return 0;
  }
  destroy() {
    this.parent = void 0, this.dom.pmViewDesc == this && (this.dom.pmViewDesc = void 0);
    for (let e = 0; e < this.children.length; e++)
      this.children[e].destroy();
  }
  posBeforeChild(e) {
    for (let t = 0, r = this.posAtStart; ; t++) {
      let i = this.children[t];
      if (i == e)
        return r;
      r += i.size;
    }
  }
  get posBefore() {
    return this.parent.posBeforeChild(this);
  }
  get posAtStart() {
    return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
  }
  get posAfter() {
    return this.posBefore + this.size;
  }
  get posAtEnd() {
    return this.posAtStart + this.size - 2 * this.border;
  }
  localPosFromDOM(e, t, r) {
    if (this.contentDOM && this.contentDOM.contains(e.nodeType == 1 ? e : e.parentNode))
      if (r < 0) {
        let s, o;
        if (e == this.contentDOM)
          s = e.childNodes[t - 1];
        else {
          for (; e.parentNode != this.contentDOM; )
            e = e.parentNode;
          s = e.previousSibling;
        }
        for (; s && !((o = s.pmViewDesc) && o.parent == this); )
          s = s.previousSibling;
        return s ? this.posBeforeChild(o) + o.size : this.posAtStart;
      } else {
        let s, o;
        if (e == this.contentDOM)
          s = e.childNodes[t];
        else {
          for (; e.parentNode != this.contentDOM; )
            e = e.parentNode;
          s = e.nextSibling;
        }
        for (; s && !((o = s.pmViewDesc) && o.parent == this); )
          s = s.nextSibling;
        return s ? this.posBeforeChild(o) : this.posAtEnd;
      }
    let i;
    if (e == this.dom && this.contentDOM)
      i = t > dt(this.contentDOM);
    else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM))
      i = e.compareDocumentPosition(this.contentDOM) & 2;
    else if (this.dom.firstChild) {
      if (t == 0)
        for (let s = e; ; s = s.parentNode) {
          if (s == this.dom) {
            i = !1;
            break;
          }
          if (s.previousSibling)
            break;
        }
      if (i == null && t == e.childNodes.length)
        for (let s = e; ; s = s.parentNode) {
          if (s == this.dom) {
            i = !0;
            break;
          }
          if (s.nextSibling)
            break;
        }
    }
    return (i == null ? r > 0 : i) ? this.posAtEnd : this.posAtStart;
  }
  nearestDesc(e, t = !1) {
    for (let r = !0, i = e; i; i = i.parentNode) {
      let s = this.getDesc(i), o;
      if (s && (!t || s.node))
        if (r && (o = s.nodeDOM) && !(o.nodeType == 1 ? o.contains(e.nodeType == 1 ? e : e.parentNode) : o == e))
          r = !1;
        else
          return s;
    }
  }
  getDesc(e) {
    let t = e.pmViewDesc;
    for (let r = t; r; r = r.parent)
      if (r == this)
        return t;
  }
  posFromDOM(e, t, r) {
    for (let i = e; i; i = i.parentNode) {
      let s = this.getDesc(i);
      if (s)
        return s.localPosFromDOM(e, t, r);
    }
    return -1;
  }
  descAt(e) {
    for (let t = 0, r = 0; t < this.children.length; t++) {
      let i = this.children[t], s = r + i.size;
      if (r == e && s != r) {
        for (; !i.border && i.children.length; )
          i = i.children[0];
        return i;
      }
      if (e < s)
        return i.descAt(e - r - i.border);
      r = s;
    }
  }
  domFromPos(e, t) {
    if (!this.contentDOM)
      return { node: this.dom, offset: 0, atom: e + 1 };
    let r = 0, i = 0;
    for (let s = 0; r < this.children.length; r++) {
      let o = this.children[r], a = s + o.size;
      if (a > e || o instanceof $0) {
        i = e - s;
        break;
      }
      s = a;
    }
    if (i)
      return this.children[r].domFromPos(i - this.children[r].border, t);
    for (let s; r && !(s = this.children[r - 1]).size && s instanceof P0 && s.side >= 0; r--)
      ;
    if (t <= 0) {
      let s, o = !0;
      for (; s = r ? this.children[r - 1] : null, !(!s || s.dom.parentNode == this.contentDOM); r--, o = !1)
        ;
      return s && t && o && !s.border && !s.domAtom ? s.domFromPos(s.size, t) : { node: this.contentDOM, offset: s ? dt(s.dom) + 1 : 0 };
    } else {
      let s, o = !0;
      for (; s = r < this.children.length ? this.children[r] : null, !(!s || s.dom.parentNode == this.contentDOM); r++, o = !1)
        ;
      return s && o && !s.border && !s.domAtom ? s.domFromPos(0, t) : { node: this.contentDOM, offset: s ? dt(s.dom) : this.contentDOM.childNodes.length };
    }
  }
  parseRange(e, t, r = 0) {
    if (this.children.length == 0)
      return { node: this.contentDOM, from: e, to: t, fromOffset: 0, toOffset: this.contentDOM.childNodes.length };
    let i = -1, s = -1;
    for (let o = r, a = 0; ; a++) {
      let l = this.children[a], u = o + l.size;
      if (i == -1 && e <= u) {
        let c = o + l.border;
        if (e >= c && t <= u - l.border && l.node && l.contentDOM && this.contentDOM.contains(l.contentDOM))
          return l.parseRange(e, t, c);
        e = o;
        for (let f = a; f > 0; f--) {
          let p = this.children[f - 1];
          if (p.size && p.dom.parentNode == this.contentDOM && !p.emptyChildAt(1)) {
            i = dt(p.dom) + 1;
            break;
          }
          e -= p.size;
        }
        i == -1 && (i = 0);
      }
      if (i > -1 && (u > t || a == this.children.length - 1)) {
        t = u;
        for (let c = a + 1; c < this.children.length; c++) {
          let f = this.children[c];
          if (f.size && f.dom.parentNode == this.contentDOM && !f.emptyChildAt(-1)) {
            s = dt(f.dom);
            break;
          }
          t += f.size;
        }
        s == -1 && (s = this.contentDOM.childNodes.length);
        break;
      }
      o = u;
    }
    return { node: this.contentDOM, from: e, to: t, fromOffset: i, toOffset: s };
  }
  emptyChildAt(e) {
    if (this.border || !this.contentDOM || !this.children.length)
      return !1;
    let t = this.children[e < 0 ? 0 : this.children.length - 1];
    return t.size == 0 || t.emptyChildAt(e);
  }
  domAfterPos(e) {
    let { node: t, offset: r } = this.domFromPos(e, 0);
    if (t.nodeType != 1 || r == t.childNodes.length)
      throw new RangeError("No node after pos " + e);
    return t.childNodes[r];
  }
  setSelection(e, t, r, i = !1) {
    let s = Math.min(e, t), o = Math.max(e, t);
    for (let p = 0, d = 0; p < this.children.length; p++) {
      let h = this.children[p], v = d + h.size;
      if (s > d && o < v)
        return h.setSelection(e - d - h.border, t - d - h.border, r, i);
      d = v;
    }
    let a = this.domFromPos(e, e ? -1 : 1), l = t == e ? a : this.domFromPos(t, t ? -1 : 1), u = r.getSelection(), c = !1;
    if ((on || mt) && e == t) {
      let { node: p, offset: d } = a;
      if (p.nodeType == 3) {
        if (c = !!(d && p.nodeValue[d - 1] == `
`), c && d == p.nodeValue.length)
          for (let h = p, v; h; h = h.parentNode) {
            if (v = h.nextSibling) {
              v.nodeName == "BR" && (a = l = { node: v.parentNode, offset: dt(v) + 1 });
              break;
            }
            let g = h.pmViewDesc;
            if (g && g.node && g.node.isBlock)
              break;
          }
      } else {
        let h = p.childNodes[d - 1];
        c = h && (h.nodeName == "BR" || h.contentEditable == "false");
      }
    }
    if (on && u.focusNode && u.focusNode != l.node && u.focusNode.nodeType == 1) {
      let p = u.focusNode.childNodes[u.focusOffset];
      p && p.contentEditable == "false" && (i = !0);
    }
    if (!(i || c && mt) && jr(a.node, a.offset, u.anchorNode, u.anchorOffset) && jr(l.node, l.offset, u.focusNode, u.focusOffset))
      return;
    let f = !1;
    if ((u.extend || e == t) && !c) {
      u.collapse(a.node, a.offset);
      try {
        e != t && u.extend(l.node, l.offset), f = !0;
      } catch {
      }
    }
    if (!f) {
      if (e > t) {
        let d = a;
        a = l, l = d;
      }
      let p = document.createRange();
      p.setEnd(l.node, l.offset), p.setStart(a.node, a.offset), u.removeAllRanges(), u.addRange(p);
    }
  }
  ignoreMutation(e) {
    return !this.contentDOM && e.type != "selection";
  }
  get contentLost() {
    return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
  }
  markDirty(e, t) {
    for (let r = 0, i = 0; i < this.children.length; i++) {
      let s = this.children[i], o = r + s.size;
      if (r == o ? e <= o && t >= r : e < o && t > r) {
        let a = r + s.border, l = o - s.border;
        if (e >= a && t <= l) {
          this.dirty = e == r || t == o ? Mr : cg, e == a && t == l && (s.contentLost || s.dom.parentNode != this.contentDOM) ? s.dirty = Cn : s.markDirty(e - a, t - a);
          return;
        } else
          s.dirty = s.dom == s.contentDOM && s.dom.parentNode == this.contentDOM && !s.children.length ? Mr : Cn;
      }
      r = o;
    }
    this.dirty = Mr;
  }
  markParentsDirty() {
    let e = 1;
    for (let t = this.parent; t; t = t.parent, e++) {
      let r = e == 1 ? Mr : cg;
      t.dirty < r && (t.dirty = r);
    }
  }
  get domAtom() {
    return !1;
  }
  get ignoreForCoords() {
    return !1;
  }
}
class P0 extends to {
  constructor(e, t, r, i) {
    let s, o = t.type.toDOM;
    if (typeof o == "function" && (o = o(r, () => {
      if (!s)
        return i;
      if (s.parent)
        return s.parent.posBeforeChild(s);
    })), !t.type.spec.raw) {
      if (o.nodeType != 1) {
        let a = document.createElement("span");
        a.appendChild(o), o = a;
      }
      o.contentEditable = "false", o.classList.add("ProseMirror-widget");
    }
    super(e, [], o, null), this.widget = t, this.widget = t, s = this;
  }
  matchesWidget(e) {
    return this.dirty == Jt && e.type.eq(this.widget.type);
  }
  parseRule() {
    return { ignore: !0 };
  }
  stopEvent(e) {
    let t = this.widget.spec.stopEvent;
    return t ? t(e) : !1;
  }
  ignoreMutation(e) {
    return e.type != "selection" || this.widget.spec.ignoreSelection;
  }
  destroy() {
    this.widget.type.destroy(this.dom), super.destroy();
  }
  get domAtom() {
    return !0;
  }
  get side() {
    return this.widget.type.side;
  }
}
class gD extends to {
  constructor(e, t, r, i) {
    super(e, [], t, null), this.textDOM = r, this.text = i;
  }
  get size() {
    return this.text.length;
  }
  localPosFromDOM(e, t) {
    return e != this.textDOM ? this.posAtStart + (t ? this.size : 0) : this.posAtStart + t;
  }
  domFromPos(e) {
    return { node: this.textDOM, offset: e };
  }
  ignoreMutation(e) {
    return e.type === "characterData" && e.target.nodeValue == e.oldValue;
  }
}
class Vr extends to {
  constructor(e, t, r, i) {
    super(e, [], r, i), this.mark = t;
  }
  static create(e, t, r, i) {
    let s = i.nodeViews[t.type.name], o = s && s(t, i, r);
    return (!o || !o.dom) && (o = yn.renderSpec(document, t.type.spec.toDOM(t, r))), new Vr(e, t, o.dom, o.contentDOM || o.dom);
  }
  parseRule() {
    return this.dirty & Cn || this.mark.type.spec.reparseInView ? null : { mark: this.mark.type.name, attrs: this.mark.attrs, contentElement: this.contentDOM };
  }
  matchesMark(e) {
    return this.dirty != Cn && this.mark.eq(e);
  }
  markDirty(e, t) {
    if (super.markDirty(e, t), this.dirty != Jt) {
      let r = this.parent;
      for (; !r.node; )
        r = r.parent;
      r.dirty < this.dirty && (r.dirty = this.dirty), this.dirty = Jt;
    }
  }
  slice(e, t, r) {
    let i = Vr.create(this.parent, this.mark, !0, r), s = this.children, o = this.size;
    t < o && (s = Gd(s, t, o, r)), e > 0 && (s = Gd(s, 0, e, r));
    for (let a = 0; a < s.length; a++)
      s[a].parent = i;
    return i.children = s, i;
  }
}
class or extends to {
  constructor(e, t, r, i, s, o, a, l, u) {
    super(e, [], s, o), this.node = t, this.outerDeco = r, this.innerDeco = i, this.nodeDOM = a;
  }
  static create(e, t, r, i, s, o) {
    let a = s.nodeViews[t.type.name], l, u = a && a(t, s, () => {
      if (!l)
        return o;
      if (l.parent)
        return l.parent.posBeforeChild(l);
    }, r, i), c = u && u.dom, f = u && u.contentDOM;
    if (t.isText) {
      if (!c)
        c = document.createTextNode(t.text);
      else if (c.nodeType != 3)
        throw new RangeError("Text must be rendered as a DOM text node");
    } else
      c || ({ dom: c, contentDOM: f } = yn.renderSpec(document, t.type.spec.toDOM(t)));
    !f && !t.isText && c.nodeName != "BR" && (c.hasAttribute("contenteditable") || (c.contentEditable = "false"), t.type.spec.draggable && (c.draggable = !0));
    let p = c;
    return c = N0(c, r, t), u ? l = new vD(e, t, r, i, c, f || null, p, u, s, o + 1) : t.isText ? new Vl(e, t, r, i, c, p, s) : new or(e, t, r, i, c, f || null, p, s, o + 1);
  }
  parseRule() {
    if (this.node.type.spec.reparseInView)
      return null;
    let e = { node: this.node.type.name, attrs: this.node.attrs };
    if (this.node.type.whitespace == "pre" && (e.preserveWhitespace = "full"), !this.contentDOM)
      e.getContent = () => this.node.content;
    else if (!this.contentLost)
      e.contentElement = this.contentDOM;
    else {
      for (let t = this.children.length - 1; t >= 0; t--) {
        let r = this.children[t];
        if (this.dom.contains(r.dom.parentNode)) {
          e.contentElement = r.dom.parentNode;
          break;
        }
      }
      e.contentElement || (e.getContent = () => V.empty);
    }
    return e;
  }
  matchesNode(e, t, r) {
    return this.dirty == Jt && e.eq(this.node) && Ud(t, this.outerDeco) && r.eq(this.innerDeco);
  }
  get size() {
    return this.node.nodeSize;
  }
  get border() {
    return this.node.isLeaf ? 0 : 1;
  }
  updateChildren(e, t) {
    let r = this.node.inlineContent, i = t, s = e.composing ? this.localCompositionInfo(e, t) : null, o = s && s.pos > -1 ? s : null, a = s && s.pos < 0, l = new bD(this, o && o.node, e);
    SD(this.node, this.innerDeco, (u, c, f) => {
      u.spec.marks ? l.syncToMarks(u.spec.marks, r, e) : u.type.side >= 0 && !f && l.syncToMarks(c == this.node.childCount ? Se.none : this.node.child(c).marks, r, e), l.placeWidget(u, e, i);
    }, (u, c, f, p) => {
      l.syncToMarks(u.marks, r, e);
      let d;
      l.findNodeMatch(u, c, f, p) || a && e.state.selection.from > i && e.state.selection.to < i + u.nodeSize && (d = l.findIndexWithChild(s.node)) > -1 && l.updateNodeAt(u, c, f, d, e) || l.updateNextNode(u, c, f, e, p, i) || l.addNode(u, c, f, e, i), i += u.nodeSize;
    }), l.syncToMarks([], r, e), this.node.isTextblock && l.addTextblockHacks(), l.destroyRest(), (l.changed || this.dirty == Mr) && (o && this.protectLocalComposition(e, o), D0(this.contentDOM, this.children, e), $i && xD(this.dom));
  }
  localCompositionInfo(e, t) {
    let { from: r, to: i } = e.state.selection;
    if (!(e.state.selection instanceof de) || r < t || i > t + this.node.content.size)
      return null;
    let s = e.domSelectionRange(), o = CD(s.focusNode, s.focusOffset);
    if (!o || !this.dom.contains(o.parentNode))
      return null;
    if (this.node.inlineContent) {
      let a = o.nodeValue, l = OD(this.node.content, a, r - t, i - t);
      return l < 0 ? null : { node: o, pos: l, text: a };
    } else
      return { node: o, pos: -1, text: "" };
  }
  protectLocalComposition(e, { node: t, pos: r, text: i }) {
    if (this.getDesc(t))
      return;
    let s = t;
    for (; s.parentNode != this.contentDOM; s = s.parentNode) {
      for (; s.previousSibling; )
        s.parentNode.removeChild(s.previousSibling);
      for (; s.nextSibling; )
        s.parentNode.removeChild(s.nextSibling);
      s.pmViewDesc && (s.pmViewDesc = void 0);
    }
    let o = new gD(this, s, t, i);
    e.input.compositionNodes.push(o), this.children = Gd(this.children, r, r + i.length, e, o);
  }
  update(e, t, r, i) {
    return this.dirty == Cn || !e.sameMarkup(this.node) ? !1 : (this.updateInner(e, t, r, i), !0);
  }
  updateInner(e, t, r, i) {
    this.updateOuterDeco(t), this.node = e, this.innerDeco = r, this.contentDOM && this.updateChildren(i, this.posAtStart), this.dirty = Jt;
  }
  updateOuterDeco(e) {
    if (Ud(e, this.outerDeco))
      return;
    let t = this.nodeDOM.nodeType != 1, r = this.dom;
    this.dom = L0(this.dom, this.nodeDOM, qd(this.outerDeco, this.node, t), qd(e, this.node, t)), this.dom != r && (r.pmViewDesc = void 0, this.dom.pmViewDesc = this), this.outerDeco = e;
  }
  selectNode() {
    this.nodeDOM.nodeType == 1 && this.nodeDOM.classList.add("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && (this.dom.draggable = !0);
  }
  deselectNode() {
    this.nodeDOM.nodeType == 1 && this.nodeDOM.classList.remove("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && this.dom.removeAttribute("draggable");
  }
  get domAtom() {
    return this.node.isAtom;
  }
}
function dg(n, e, t, r, i) {
  N0(r, e, n);
  let s = new or(void 0, n, e, t, r, r, r, i, 0);
  return s.contentDOM && s.updateChildren(i, 0), s;
}
class Vl extends or {
  constructor(e, t, r, i, s, o, a) {
    super(e, t, r, i, s, null, o, a, 0);
  }
  parseRule() {
    let e = this.nodeDOM.parentNode;
    for (; e && e != this.dom && !e.pmIsDeco; )
      e = e.parentNode;
    return { skip: e || !0 };
  }
  update(e, t, r, i) {
    return this.dirty == Cn || this.dirty != Jt && !this.inParent() || !e.sameMarkup(this.node) ? !1 : (this.updateOuterDeco(t), (this.dirty != Jt || e.text != this.node.text) && e.text != this.nodeDOM.nodeValue && (this.nodeDOM.nodeValue = e.text, i.trackWrites == this.nodeDOM && (i.trackWrites = null)), this.node = e, this.dirty = Jt, !0);
  }
  inParent() {
    let e = this.parent.contentDOM;
    for (let t = this.nodeDOM; t; t = t.parentNode)
      if (t == e)
        return !0;
    return !1;
  }
  domFromPos(e) {
    return { node: this.nodeDOM, offset: e };
  }
  localPosFromDOM(e, t, r) {
    return e == this.nodeDOM ? this.posAtStart + Math.min(t, this.node.text.length) : super.localPosFromDOM(e, t, r);
  }
  ignoreMutation(e) {
    return e.type != "characterData" && e.type != "selection";
  }
  slice(e, t, r) {
    let i = this.node.cut(e, t), s = document.createTextNode(i.text);
    return new Vl(this.parent, i, this.outerDeco, this.innerDeco, s, s, r);
  }
  markDirty(e, t) {
    super.markDirty(e, t), this.dom != this.nodeDOM && (e == 0 || t == this.nodeDOM.nodeValue.length) && (this.dirty = Cn);
  }
  get domAtom() {
    return !1;
  }
}
class $0 extends to {
  parseRule() {
    return { ignore: !0 };
  }
  matchesHack(e) {
    return this.dirty == Jt && this.dom.nodeName == e;
  }
  get domAtom() {
    return !0;
  }
  get ignoreForCoords() {
    return this.dom.nodeName == "IMG";
  }
}
class vD extends or {
  constructor(e, t, r, i, s, o, a, l, u, c) {
    super(e, t, r, i, s, o, a, u, c), this.spec = l;
  }
  update(e, t, r, i) {
    if (this.dirty == Cn)
      return !1;
    if (this.spec.update) {
      let s = this.spec.update(e, t, r);
      return s && this.updateInner(e, t, r, i), s;
    } else
      return !this.contentDOM && !e.isLeaf ? !1 : super.update(e, t, r, i);
  }
  selectNode() {
    this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
  }
  deselectNode() {
    this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
  }
  setSelection(e, t, r, i) {
    this.spec.setSelection ? this.spec.setSelection(e, t, r) : super.setSelection(e, t, r, i);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
  stopEvent(e) {
    return this.spec.stopEvent ? this.spec.stopEvent(e) : !1;
  }
  ignoreMutation(e) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(e) : super.ignoreMutation(e);
  }
}
function D0(n, e, t) {
  let r = n.firstChild, i = !1;
  for (let s = 0; s < e.length; s++) {
    let o = e[s], a = o.dom;
    if (a.parentNode == n) {
      for (; a != r; )
        r = fg(r), i = !0;
      r = r.nextSibling;
    } else
      i = !0, n.insertBefore(a, r);
    if (o instanceof Vr) {
      let l = r ? r.previousSibling : n.lastChild;
      D0(o.contentDOM, o.children, t), r = l ? l.nextSibling : n.firstChild;
    }
  }
  for (; r; )
    r = fg(r), i = !0;
  i && t.trackWrites == n && (t.trackWrites = null);
}
const ys = function(n) {
  n && (this.nodeName = n);
};
ys.prototype = /* @__PURE__ */ Object.create(null);
const Ar = [new ys()];
function qd(n, e, t) {
  if (n.length == 0)
    return Ar;
  let r = t ? Ar[0] : new ys(), i = [r];
  for (let s = 0; s < n.length; s++) {
    let o = n[s].type.attrs;
    if (!!o) {
      o.nodeName && i.push(r = new ys(o.nodeName));
      for (let a in o) {
        let l = o[a];
        l != null && (t && i.length == 1 && i.push(r = new ys(e.isInline ? "span" : "div")), a == "class" ? r.class = (r.class ? r.class + " " : "") + l : a == "style" ? r.style = (r.style ? r.style + ";" : "") + l : a != "nodeName" && (r[a] = l));
      }
    }
  }
  return i;
}
function L0(n, e, t, r) {
  if (t == Ar && r == Ar)
    return e;
  let i = e;
  for (let s = 0; s < r.length; s++) {
    let o = r[s], a = t[s];
    if (s) {
      let l;
      a && a.nodeName == o.nodeName && i != n && (l = i.parentNode) && l.nodeName.toLowerCase() == o.nodeName || (l = document.createElement(o.nodeName), l.pmIsDeco = !0, l.appendChild(i), a = Ar[0]), i = l;
    }
    yD(i, a || Ar[0], o);
  }
  return i;
}
function yD(n, e, t) {
  for (let r in e)
    r != "class" && r != "style" && r != "nodeName" && !(r in t) && n.removeAttribute(r);
  for (let r in t)
    r != "class" && r != "style" && r != "nodeName" && t[r] != e[r] && n.setAttribute(r, t[r]);
  if (e.class != t.class) {
    let r = e.class ? e.class.split(" ").filter(Boolean) : [], i = t.class ? t.class.split(" ").filter(Boolean) : [];
    for (let s = 0; s < r.length; s++)
      i.indexOf(r[s]) == -1 && n.classList.remove(r[s]);
    for (let s = 0; s < i.length; s++)
      r.indexOf(i[s]) == -1 && n.classList.add(i[s]);
    n.classList.length == 0 && n.removeAttribute("class");
  }
  if (e.style != t.style) {
    if (e.style) {
      let r = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, i;
      for (; i = r.exec(e.style); )
        n.style.removeProperty(i[1]);
    }
    t.style && (n.style.cssText += t.style);
  }
}
function N0(n, e, t) {
  return L0(n, n, Ar, qd(e, t, n.nodeType != 1));
}
function Ud(n, e) {
  if (n.length != e.length)
    return !1;
  for (let t = 0; t < n.length; t++)
    if (!n[t].type.eq(e[t].type))
      return !1;
  return !0;
}
function fg(n) {
  let e = n.nextSibling;
  return n.parentNode.removeChild(n), e;
}
class bD {
  constructor(e, t, r) {
    this.lock = t, this.view = r, this.index = 0, this.stack = [], this.changed = !1, this.top = e, this.preMatch = wD(e.node.content, e);
  }
  destroyBetween(e, t) {
    if (e != t) {
      for (let r = e; r < t; r++)
        this.top.children[r].destroy();
      this.top.children.splice(e, t - e), this.changed = !0;
    }
  }
  destroyRest() {
    this.destroyBetween(this.index, this.top.children.length);
  }
  syncToMarks(e, t, r) {
    let i = 0, s = this.stack.length >> 1, o = Math.min(s, e.length);
    for (; i < o && (i == s - 1 ? this.top : this.stack[i + 1 << 1]).matchesMark(e[i]) && e[i].type.spec.spanning !== !1; )
      i++;
    for (; i < s; )
      this.destroyRest(), this.top.dirty = Jt, this.index = this.stack.pop(), this.top = this.stack.pop(), s--;
    for (; s < e.length; ) {
      this.stack.push(this.top, this.index + 1);
      let a = -1;
      for (let l = this.index; l < Math.min(this.index + 3, this.top.children.length); l++) {
        let u = this.top.children[l];
        if (u.matchesMark(e[s]) && !this.isLocked(u.dom)) {
          a = l;
          break;
        }
      }
      if (a > -1)
        a > this.index && (this.changed = !0, this.destroyBetween(this.index, a)), this.top = this.top.children[this.index];
      else {
        let l = Vr.create(this.top, e[s], t, r);
        this.top.children.splice(this.index, 0, l), this.top = l, this.changed = !0;
      }
      this.index = 0, s++;
    }
  }
  findNodeMatch(e, t, r, i) {
    let s = -1, o;
    if (i >= this.preMatch.index && (o = this.preMatch.matches[i - this.preMatch.index]).parent == this.top && o.matchesNode(e, t, r))
      s = this.top.children.indexOf(o, this.index);
    else
      for (let a = this.index, l = Math.min(this.top.children.length, a + 5); a < l; a++) {
        let u = this.top.children[a];
        if (u.matchesNode(e, t, r) && !this.preMatch.matched.has(u)) {
          s = a;
          break;
        }
      }
    return s < 0 ? !1 : (this.destroyBetween(this.index, s), this.index++, !0);
  }
  updateNodeAt(e, t, r, i, s) {
    let o = this.top.children[i];
    return o.dirty == Cn && o.dom == o.contentDOM && (o.dirty = Mr), o.update(e, t, r, s) ? (this.destroyBetween(this.index, i), this.index++, !0) : !1;
  }
  findIndexWithChild(e) {
    for (; ; ) {
      let t = e.parentNode;
      if (!t)
        return -1;
      if (t == this.top.contentDOM) {
        let r = e.pmViewDesc;
        if (r) {
          for (let i = this.index; i < this.top.children.length; i++)
            if (this.top.children[i] == r)
              return i;
        }
        return -1;
      }
      e = t;
    }
  }
  updateNextNode(e, t, r, i, s, o) {
    for (let a = this.index; a < this.top.children.length; a++) {
      let l = this.top.children[a];
      if (l instanceof or) {
        let u = this.preMatch.matched.get(l);
        if (u != null && u != s)
          return !1;
        let c = l.dom, f, p = this.isLocked(c) && !(e.isText && l.node && l.node.isText && l.nodeDOM.nodeValue == e.text && l.dirty != Cn && Ud(t, l.outerDeco));
        if (!p && l.update(e, t, r, i))
          return this.destroyBetween(this.index, a), l.dom != c && (this.changed = !0), this.index++, !0;
        if (!p && (f = this.recreateWrapper(l, e, t, r, i, o)))
          return this.top.children[this.index] = f, f.contentDOM && (f.dirty = Mr, f.updateChildren(i, o + 1), f.dirty = Jt), this.changed = !0, this.index++, !0;
        break;
      }
    }
    return !1;
  }
  recreateWrapper(e, t, r, i, s, o) {
    if (e.dirty || t.isAtom || !e.children.length || !e.node.content.eq(t.content))
      return null;
    let a = or.create(this.top, t, r, i, s, o);
    if (a.contentDOM) {
      a.children = e.children, e.children = [];
      for (let l of a.children)
        l.parent = a;
    }
    return e.destroy(), a;
  }
  addNode(e, t, r, i, s) {
    let o = or.create(this.top, e, t, r, i, s);
    o.contentDOM && o.updateChildren(i, s + 1), this.top.children.splice(this.index++, 0, o), this.changed = !0;
  }
  placeWidget(e, t, r) {
    let i = this.index < this.top.children.length ? this.top.children[this.index] : null;
    if (i && i.matchesWidget(e) && (e == i.widget || !i.widget.type.toDOM.parentNode))
      this.index++;
    else {
      let s = new P0(this.top, e, t, r);
      this.top.children.splice(this.index++, 0, s), this.changed = !0;
    }
  }
  addTextblockHacks() {
    let e = this.top.children[this.index - 1], t = this.top;
    for (; e instanceof Vr; )
      t = e, e = t.children[t.children.length - 1];
    (!e || !(e instanceof Vl) || /\n$/.test(e.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(e.node.text)) && ((mt || rt) && e && e.dom.contentEditable == "false" && this.addHackNode("IMG", t), this.addHackNode("BR", this.top));
  }
  addHackNode(e, t) {
    if (t == this.top && this.index < t.children.length && t.children[this.index].matchesHack(e))
      this.index++;
    else {
      let r = document.createElement(e);
      e == "IMG" && (r.className = "ProseMirror-separator", r.alt = ""), e == "BR" && (r.className = "ProseMirror-trailingBreak");
      let i = new $0(this.top, [], r, null);
      t != this.top ? t.children.push(i) : t.children.splice(this.index++, 0, i), this.changed = !0;
    }
  }
  isLocked(e) {
    return this.lock && (e == this.lock || e.nodeType == 1 && e.contains(this.lock.parentNode));
  }
}
function wD(n, e) {
  let t = e, r = t.children.length, i = n.childCount, s = /* @__PURE__ */ new Map(), o = [];
  e:
    for (; i > 0; ) {
      let a;
      for (; ; )
        if (r) {
          let u = t.children[r - 1];
          if (u instanceof Vr)
            t = u, r = u.children.length;
          else {
            a = u, r--;
            break;
          }
        } else {
          if (t == e)
            break e;
          r = t.parent.children.indexOf(t), t = t.parent;
        }
      let l = a.node;
      if (!!l) {
        if (l != n.child(i - 1))
          break;
        --i, s.set(a, i), o.push(a);
      }
    }
  return { index: i, matched: s, matches: o.reverse() };
}
function _D(n, e) {
  return n.type.side - e.type.side;
}
function SD(n, e, t, r) {
  let i = e.locals(n), s = 0;
  if (i.length == 0) {
    for (let u = 0; u < n.childCount; u++) {
      let c = n.child(u);
      r(c, i, e.forChild(s, c), u), s += c.nodeSize;
    }
    return;
  }
  let o = 0, a = [], l = null;
  for (let u = 0; ; ) {
    let c, f;
    for (; o < i.length && i[o].to == s; ) {
      let g = i[o++];
      g.widget && (c ? (f || (f = [c])).push(g) : c = g);
    }
    if (c)
      if (f) {
        f.sort(_D);
        for (let g = 0; g < f.length; g++)
          t(f[g], u, !!l);
      } else
        t(c, u, !!l);
    let p, d;
    if (l)
      d = -1, p = l, l = null;
    else if (u < n.childCount)
      d = u, p = n.child(u++);
    else
      break;
    for (let g = 0; g < a.length; g++)
      a[g].to <= s && a.splice(g--, 1);
    for (; o < i.length && i[o].from <= s && i[o].to > s; )
      a.push(i[o++]);
    let h = s + p.nodeSize;
    if (p.isText) {
      let g = h;
      o < i.length && i[o].from < g && (g = i[o].from);
      for (let m = 0; m < a.length; m++)
        a[m].to < g && (g = a[m].to);
      g < h && (l = p.cut(g - s), p = p.cut(0, g - s), h = g, d = -1);
    } else
      for (; o < i.length && i[o].to < h; )
        o++;
    let v = p.isInline && !p.isLeaf ? a.filter((g) => !g.inline) : a.slice();
    r(p, v, e.forChild(s, p), d), s = h;
  }
}
function xD(n) {
  if (n.nodeName == "UL" || n.nodeName == "OL") {
    let e = n.style.cssText;
    n.style.cssText = e + "; list-style: square !important", window.getComputedStyle(n).listStyle, n.style.cssText = e;
  }
}
function CD(n, e) {
  for (; ; ) {
    if (n.nodeType == 3)
      return n;
    if (n.nodeType == 1 && e > 0) {
      if (n.childNodes.length > e && n.childNodes[e].nodeType == 3)
        return n.childNodes[e];
      n = n.childNodes[e - 1], e = gn(n);
    } else if (n.nodeType == 1 && e < n.childNodes.length)
      n = n.childNodes[e], e = 0;
    else
      return null;
  }
}
function OD(n, e, t, r) {
  for (let i = 0, s = 0; i < n.childCount && s <= r; ) {
    let o = n.child(i++), a = s;
    if (s += o.nodeSize, !o.isText)
      continue;
    let l = o.text;
    for (; i < n.childCount; ) {
      let u = n.child(i++);
      if (s += u.nodeSize, !u.isText)
        break;
      l += u.text;
    }
    if (s >= t) {
      if (s >= r && l.slice(r - e.length - a, r - a) == e)
        return r - e.length;
      let u = a < r ? l.lastIndexOf(e, r - a - 1) : -1;
      if (u >= 0 && u + e.length + a >= t)
        return a + u;
      if (t == r && l.length >= r + e.length - a && l.slice(r - a, r - a + e.length) == e)
        return r;
    }
  }
  return -1;
}
function Gd(n, e, t, r, i) {
  let s = [];
  for (let o = 0, a = 0; o < n.length; o++) {
    let l = n[o], u = a, c = a += l.size;
    u >= t || c <= e ? s.push(l) : (u < e && s.push(l.slice(0, e - u, r)), i && (s.push(i), i = void 0), c > t && s.push(l.slice(t - u, l.size, r)));
  }
  return s;
}
function fp(n, e = null) {
  let t = n.domSelectionRange(), r = n.state.doc;
  if (!t.focusNode)
    return null;
  let i = n.docView.nearestDesc(t.focusNode), s = i && i.size == 0, o = n.docView.posFromDOM(t.focusNode, t.focusOffset, 1);
  if (o < 0)
    return null;
  let a = r.resolve(o), l, u;
  if (jl(t)) {
    for (l = a; i && !i.node; )
      i = i.parent;
    let c = i.node;
    if (i && c.isAtom && te.isSelectable(c) && i.parent && !(c.isInline && J$(t.focusNode, t.focusOffset, i.dom))) {
      let f = i.posBefore;
      u = new te(o == f ? a : r.resolve(f));
    }
  } else {
    let c = n.docView.posFromDOM(t.anchorNode, t.anchorOffset, 1);
    if (c < 0)
      return null;
    l = r.resolve(c);
  }
  if (!u) {
    let c = e == "pointer" || n.state.selection.head < a.pos && !s ? 1 : -1;
    u = pp(n, l, a, c);
  }
  return u;
}
function I0(n) {
  return n.editable ? n.hasFocus() : F0(n) && document.activeElement && document.activeElement.contains(n.dom);
}
function Nn(n, e = !1) {
  let t = n.state.selection;
  if (R0(n, t), !!I0(n)) {
    if (!e && n.input.mouseDown && n.input.mouseDown.allowDefault && rt) {
      let r = n.domSelectionRange(), i = n.domObserver.currentSelection;
      if (r.anchorNode && i.anchorNode && jr(r.anchorNode, r.anchorOffset, i.anchorNode, i.anchorOffset)) {
        n.input.mouseDown.delayedSelectionSync = !0, n.domObserver.setCurSelection();
        return;
      }
    }
    if (n.domObserver.disconnectSelection(), n.cursorWrapper)
      TD(n);
    else {
      let { anchor: r, head: i } = t, s, o;
      pg && !(t instanceof de) && (t.$from.parent.inlineContent || (s = hg(n, t.from)), !t.empty && !t.$from.parent.inlineContent && (o = hg(n, t.to))), n.docView.setSelection(r, i, n.root, e), pg && (s && mg(s), o && mg(o)), t.visible ? n.dom.classList.remove("ProseMirror-hideselection") : (n.dom.classList.add("ProseMirror-hideselection"), "onselectionchange" in document && ED(n));
    }
    n.domObserver.setCurSelection(), n.domObserver.connectSelection();
  }
}
const pg = mt || rt && Q$ < 63;
function hg(n, e) {
  let { node: t, offset: r } = n.docView.domFromPos(e, 0), i = r < t.childNodes.length ? t.childNodes[r] : null, s = r ? t.childNodes[r - 1] : null;
  if (mt && i && i.contentEditable == "false")
    return Ic(i);
  if ((!i || i.contentEditable == "false") && (!s || s.contentEditable == "false")) {
    if (i)
      return Ic(i);
    if (s)
      return Ic(s);
  }
}
function Ic(n) {
  return n.contentEditable = "true", mt && n.draggable && (n.draggable = !1, n.wasDraggable = !0), n;
}
function mg(n) {
  n.contentEditable = "false", n.wasDraggable && (n.draggable = !0, n.wasDraggable = null);
}
function ED(n) {
  let e = n.dom.ownerDocument;
  e.removeEventListener("selectionchange", n.input.hideSelectionGuard);
  let t = n.domSelectionRange(), r = t.anchorNode, i = t.anchorOffset;
  e.addEventListener("selectionchange", n.input.hideSelectionGuard = () => {
    (t.anchorNode != r || t.anchorOffset != i) && (e.removeEventListener("selectionchange", n.input.hideSelectionGuard), setTimeout(() => {
      (!I0(n) || n.state.selection.visible) && n.dom.classList.remove("ProseMirror-hideselection");
    }, 20));
  });
}
function TD(n) {
  let e = n.domSelection(), t = document.createRange(), r = n.cursorWrapper.dom, i = r.nodeName == "IMG";
  i ? t.setEnd(r.parentNode, dt(r) + 1) : t.setEnd(r, 0), t.collapse(!1), e.removeAllRanges(), e.addRange(t), !i && !n.state.selection.visible && xt && sr <= 11 && (r.disabled = !0, r.disabled = !1);
}
function R0(n, e) {
  if (e instanceof te) {
    let t = n.docView.descAt(e.from);
    t != n.lastSelectedViewDesc && (gg(n), t && t.selectNode(), n.lastSelectedViewDesc = t);
  } else
    gg(n);
}
function gg(n) {
  n.lastSelectedViewDesc && (n.lastSelectedViewDesc.parent && n.lastSelectedViewDesc.deselectNode(), n.lastSelectedViewDesc = void 0);
}
function pp(n, e, t, r) {
  return n.someProp("createSelectionBetween", (i) => i(n, e, t)) || de.between(e, t, r);
}
function vg(n) {
  return n.editable && !n.hasFocus() ? !1 : F0(n);
}
function F0(n) {
  let e = n.domSelectionRange();
  if (!e.anchorNode)
    return !1;
  try {
    return n.dom.contains(e.anchorNode.nodeType == 3 ? e.anchorNode.parentNode : e.anchorNode) && (n.editable || n.dom.contains(e.focusNode.nodeType == 3 ? e.focusNode.parentNode : e.focusNode));
  } catch {
    return !1;
  }
}
function kD(n) {
  let e = n.docView.domFromPos(n.state.selection.anchor, 0), t = n.domSelectionRange();
  return jr(e.node, e.offset, t.anchorNode, t.anchorOffset);
}
function Kd(n, e) {
  let { $anchor: t, $head: r } = n.selection, i = e > 0 ? t.max(r) : t.min(r), s = i.parent.inlineContent ? i.depth ? n.doc.resolve(e > 0 ? i.after() : i.before()) : null : i;
  return s && me.findFrom(s, e);
}
function Wn(n, e) {
  return n.dispatch(n.state.tr.setSelection(e).scrollIntoView()), !0;
}
function yg(n, e, t) {
  let r = n.state.selection;
  if (r instanceof de)
    if (t.indexOf("s") > -1) {
      let { $head: i } = r, s = i.textOffset ? null : e < 0 ? i.nodeBefore : i.nodeAfter;
      if (!s || s.isText || !s.isLeaf)
        return !1;
      let o = n.state.doc.resolve(i.pos + s.nodeSize * (e < 0 ? -1 : 1));
      return Wn(n, new de(r.$anchor, o));
    } else if (r.empty) {
      if (n.endOfTextblock(e > 0 ? "forward" : "backward")) {
        let i = Kd(n.state, e);
        return i && i instanceof te ? Wn(n, i) : !1;
      } else if (!(qt && t.indexOf("m") > -1)) {
        let i = r.$head, s = i.textOffset ? null : e < 0 ? i.nodeBefore : i.nodeAfter, o;
        if (!s || s.isText)
          return !1;
        let a = e < 0 ? i.pos - s.nodeSize : i.pos;
        return s.isAtom || (o = n.docView.descAt(a)) && !o.contentDOM ? te.isSelectable(s) ? Wn(n, new te(e < 0 ? n.state.doc.resolve(i.pos - s.nodeSize) : i)) : eo ? Wn(n, new de(n.state.doc.resolve(e < 0 ? a : a + s.nodeSize))) : !1 : !1;
      }
    } else
      return !1;
  else {
    if (r instanceof te && r.node.isInline)
      return Wn(n, new de(e > 0 ? r.$to : r.$from));
    {
      let i = Kd(n.state, e);
      return i ? Wn(n, i) : !1;
    }
  }
}
function $a(n) {
  return n.nodeType == 3 ? n.nodeValue.length : n.childNodes.length;
}
function bs(n, e) {
  let t = n.pmViewDesc;
  return t && t.size == 0 && (e < 0 || n.nextSibling || n.nodeName != "BR");
}
function oi(n, e) {
  return e < 0 ? MD(n) : AD(n);
}
function MD(n) {
  let e = n.domSelectionRange(), t = e.focusNode, r = e.focusOffset;
  if (!t)
    return;
  let i, s, o = !1;
  for (on && t.nodeType == 1 && r < $a(t) && bs(t.childNodes[r], -1) && (o = !0); ; )
    if (r > 0) {
      if (t.nodeType != 1)
        break;
      {
        let a = t.childNodes[r - 1];
        if (bs(a, -1))
          i = t, s = --r;
        else if (a.nodeType == 3)
          t = a, r = t.nodeValue.length;
        else
          break;
      }
    } else {
      if (z0(t))
        break;
      {
        let a = t.previousSibling;
        for (; a && bs(a, -1); )
          i = t.parentNode, s = dt(a), a = a.previousSibling;
        if (a)
          t = a, r = $a(t);
        else {
          if (t = t.parentNode, t == n.dom)
            break;
          r = 0;
        }
      }
    }
  o ? Jd(n, t, r) : i && Jd(n, i, s);
}
function AD(n) {
  let e = n.domSelectionRange(), t = e.focusNode, r = e.focusOffset;
  if (!t)
    return;
  let i = $a(t), s, o;
  for (; ; )
    if (r < i) {
      if (t.nodeType != 1)
        break;
      let a = t.childNodes[r];
      if (bs(a, 1))
        s = t, o = ++r;
      else
        break;
    } else {
      if (z0(t))
        break;
      {
        let a = t.nextSibling;
        for (; a && bs(a, 1); )
          s = a.parentNode, o = dt(a) + 1, a = a.nextSibling;
        if (a)
          t = a, r = 0, i = $a(t);
        else {
          if (t = t.parentNode, t == n.dom)
            break;
          r = i = 0;
        }
      }
    }
  s && Jd(n, s, o);
}
function z0(n) {
  let e = n.pmViewDesc;
  return e && e.node && e.node.isBlock;
}
function PD(n, e) {
  for (; n && e == n.childNodes.length && !cp(n); )
    e = dt(n) + 1, n = n.parentNode;
  for (; n && e < n.childNodes.length; ) {
    let t = n.childNodes[e];
    if (t.nodeType == 3)
      return t;
    if (t.nodeType == 1 && t.contentEditable == "false")
      break;
    n = t, e = 0;
  }
}
function $D(n, e) {
  for (; n && !e && !cp(n); )
    e = dt(n), n = n.parentNode;
  for (; n && e; ) {
    let t = n.childNodes[e - 1];
    if (t.nodeType == 3)
      return t;
    if (t.nodeType == 1 && t.contentEditable == "false")
      break;
    n = t, e = n.childNodes.length;
  }
}
function Jd(n, e, t) {
  if (e.nodeType != 3) {
    let s, o;
    (o = PD(e, t)) ? (e = o, t = 0) : (s = $D(e, t)) && (e = s, t = s.nodeValue.length);
  }
  let r = n.domSelection();
  if (jl(r)) {
    let s = document.createRange();
    s.setEnd(e, t), s.setStart(e, t), r.removeAllRanges(), r.addRange(s);
  } else
    r.extend && r.extend(e, t);
  n.domObserver.setCurSelection();
  let { state: i } = n;
  setTimeout(() => {
    n.state == i && Nn(n);
  }, 50);
}
function bg(n, e) {
  let t = n.state.doc.resolve(e);
  if (!(rt || Z$) && t.parent.inlineContent) {
    let i = n.coordsAtPos(e);
    if (e > t.start()) {
      let s = n.coordsAtPos(e - 1), o = (s.top + s.bottom) / 2;
      if (o > i.top && o < i.bottom && Math.abs(s.left - i.left) > 1)
        return s.left < i.left ? "ltr" : "rtl";
    }
    if (e < t.end()) {
      let s = n.coordsAtPos(e + 1), o = (s.top + s.bottom) / 2;
      if (o > i.top && o < i.bottom && Math.abs(s.left - i.left) > 1)
        return s.left > i.left ? "ltr" : "rtl";
    }
  }
  return getComputedStyle(n.dom).direction == "rtl" ? "rtl" : "ltr";
}
function wg(n, e, t) {
  let r = n.state.selection;
  if (r instanceof de && !r.empty || t.indexOf("s") > -1 || qt && t.indexOf("m") > -1)
    return !1;
  let { $from: i, $to: s } = r;
  if (!i.parent.inlineContent || n.endOfTextblock(e < 0 ? "up" : "down")) {
    let o = Kd(n.state, e);
    if (o && o instanceof te)
      return Wn(n, o);
  }
  if (!i.parent.inlineContent) {
    let o = e < 0 ? i : s, a = r instanceof rn ? me.near(o, e) : me.findFrom(o, e);
    return a ? Wn(n, a) : !1;
  }
  return !1;
}
function _g(n, e) {
  if (!(n.state.selection instanceof de))
    return !0;
  let { $head: t, $anchor: r, empty: i } = n.state.selection;
  if (!t.sameParent(r))
    return !0;
  if (!i)
    return !1;
  if (n.endOfTextblock(e > 0 ? "forward" : "backward"))
    return !0;
  let s = !t.textOffset && (e < 0 ? t.nodeBefore : t.nodeAfter);
  if (s && !s.isText) {
    let o = n.state.tr;
    return e < 0 ? o.delete(t.pos - s.nodeSize, t.pos) : o.delete(t.pos, t.pos + s.nodeSize), n.dispatch(o), !0;
  }
  return !1;
}
function Sg(n, e, t) {
  n.domObserver.stop(), e.contentEditable = t, n.domObserver.start();
}
function DD(n) {
  if (!mt || n.state.selection.$head.parentOffset > 0)
    return !1;
  let { focusNode: e, focusOffset: t } = n.domSelectionRange();
  if (e && e.nodeType == 1 && t == 0 && e.firstChild && e.firstChild.contentEditable == "false") {
    let r = e.firstChild;
    Sg(n, r, "true"), setTimeout(() => Sg(n, r, "false"), 20);
  }
  return !1;
}
function LD(n) {
  let e = "";
  return n.ctrlKey && (e += "c"), n.metaKey && (e += "m"), n.altKey && (e += "a"), n.shiftKey && (e += "s"), e;
}
function ND(n, e) {
  let t = e.keyCode, r = LD(e);
  if (t == 8 || qt && t == 72 && r == "c")
    return _g(n, -1) || oi(n, -1);
  if (t == 46 && !e.shiftKey || qt && t == 68 && r == "c")
    return _g(n, 1) || oi(n, 1);
  if (t == 13 || t == 27)
    return !0;
  if (t == 37 || qt && t == 66 && r == "c") {
    let i = t == 37 ? bg(n, n.state.selection.from) == "ltr" ? -1 : 1 : -1;
    return yg(n, i, r) || oi(n, i);
  } else if (t == 39 || qt && t == 70 && r == "c") {
    let i = t == 39 ? bg(n, n.state.selection.from) == "ltr" ? 1 : -1 : 1;
    return yg(n, i, r) || oi(n, i);
  } else {
    if (t == 38 || qt && t == 80 && r == "c")
      return wg(n, -1, r) || oi(n, -1);
    if (t == 40 || qt && t == 78 && r == "c")
      return DD(n) || wg(n, 1, r) || oi(n, 1);
    if (r == (qt ? "m" : "c") && (t == 66 || t == 73 || t == 89 || t == 90))
      return !0;
  }
  return !1;
}
function B0(n, e) {
  n.someProp("transformCopied", (d) => {
    e = d(e, n);
  });
  let t = [], { content: r, openStart: i, openEnd: s } = e;
  for (; i > 1 && s > 1 && r.childCount == 1 && r.firstChild.childCount == 1; ) {
    i--, s--;
    let d = r.firstChild;
    t.push(d.type.name, d.attrs != d.type.defaultAttrs ? d.attrs : null), r = d.content;
  }
  let o = n.someProp("clipboardSerializer") || yn.fromSchema(n.state.schema), a = U0(), l = a.createElement("div");
  l.appendChild(o.serializeFragment(r, { document: a }));
  let u = l.firstChild, c, f = 0;
  for (; u && u.nodeType == 1 && (c = q0[u.nodeName.toLowerCase()]); ) {
    for (let d = c.length - 1; d >= 0; d--) {
      let h = a.createElement(c[d]);
      for (; l.firstChild; )
        h.appendChild(l.firstChild);
      l.appendChild(h), f++;
    }
    u = l.firstChild;
  }
  u && u.nodeType == 1 && u.setAttribute("data-pm-slice", `${i} ${s}${f ? ` -${f}` : ""} ${JSON.stringify(t)}`);
  let p = n.someProp("clipboardTextSerializer", (d) => d(e, n)) || e.content.textBetween(0, e.content.size, `

`);
  return { dom: l, text: p };
}
function j0(n, e, t, r, i) {
  let s = i.parent.type.spec.code, o, a;
  if (!t && !e)
    return null;
  let l = e && (r || s || !t);
  if (l) {
    if (n.someProp("transformPastedText", (p) => {
      e = p(e, s || r, n);
    }), s)
      return e ? new X(V.from(n.state.schema.text(e.replace(/\r\n?/g, `
`))), 0, 0) : X.empty;
    let f = n.someProp("clipboardTextParser", (p) => p(e, i, r, n));
    if (f)
      a = f;
    else {
      let p = i.marks(), { schema: d } = n.state, h = yn.fromSchema(d);
      o = document.createElement("div"), e.split(/(?:\r\n?|\n)+/).forEach((v) => {
        let g = o.appendChild(document.createElement("p"));
        v && g.appendChild(h.serializeNode(d.text(v, p)));
      });
    }
  } else
    n.someProp("transformPastedHTML", (f) => {
      t = f(t, n);
    }), o = FD(t), eo && zD(o);
  let u = o && o.querySelector("[data-pm-slice]"), c = u && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(u.getAttribute("data-pm-slice") || "");
  if (c && c[3])
    for (let f = +c[3]; f > 0; f--) {
      let p = o.firstChild;
      for (; p && p.nodeType != 1; )
        p = p.nextSibling;
      if (!p)
        break;
      o = p;
    }
  if (a || (a = (n.someProp("clipboardParser") || n.someProp("domParser") || Mi.fromSchema(n.state.schema)).parseSlice(o, {
    preserveWhitespace: !!(l || c),
    context: i,
    ruleFromNode(p) {
      return p.nodeName == "BR" && !p.nextSibling && p.parentNode && !ID.test(p.parentNode.nodeName) ? { ignore: !0 } : null;
    }
  })), c)
    a = BD(xg(a, +c[1], +c[2]), c[4]);
  else if (a = X.maxOpen(RD(a.content, i), !0), a.openStart || a.openEnd) {
    let f = 0, p = 0;
    for (let d = a.content.firstChild; f < a.openStart && !d.type.spec.isolating; f++, d = d.firstChild)
      ;
    for (let d = a.content.lastChild; p < a.openEnd && !d.type.spec.isolating; p++, d = d.lastChild)
      ;
    a = xg(a, f, p);
  }
  return n.someProp("transformPasted", (f) => {
    a = f(a, n);
  }), a;
}
const ID = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
function RD(n, e) {
  if (n.childCount < 2)
    return n;
  for (let t = e.depth; t >= 0; t--) {
    let i = e.node(t).contentMatchAt(e.index(t)), s, o = [];
    if (n.forEach((a) => {
      if (!o)
        return;
      let l = i.findWrapping(a.type), u;
      if (!l)
        return o = null;
      if (u = o.length && s.length && H0(l, s, a, o[o.length - 1], 0))
        o[o.length - 1] = u;
      else {
        o.length && (o[o.length - 1] = W0(o[o.length - 1], s.length));
        let c = V0(a, l);
        o.push(c), i = i.matchType(c.type), s = l;
      }
    }), o)
      return V.from(o);
  }
  return n;
}
function V0(n, e, t = 0) {
  for (let r = e.length - 1; r >= t; r--)
    n = e[r].create(null, V.from(n));
  return n;
}
function H0(n, e, t, r, i) {
  if (i < n.length && i < e.length && n[i] == e[i]) {
    let s = H0(n, e, t, r.lastChild, i + 1);
    if (s)
      return r.copy(r.content.replaceChild(r.childCount - 1, s));
    if (r.contentMatchAt(r.childCount).matchType(i == n.length - 1 ? t.type : n[i + 1]))
      return r.copy(r.content.append(V.from(V0(t, n, i + 1))));
  }
}
function W0(n, e) {
  if (e == 0)
    return n;
  let t = n.content.replaceChild(n.childCount - 1, W0(n.lastChild, e - 1)), r = n.contentMatchAt(n.childCount).fillBefore(V.empty, !0);
  return n.copy(t.append(r));
}
function Xd(n, e, t, r, i, s) {
  let o = e < 0 ? n.firstChild : n.lastChild, a = o.content;
  return n.childCount > 1 && (s = 0), i < r - 1 && (a = Xd(a, e, t, r, i + 1, s)), i >= t && (a = e < 0 ? o.contentMatchAt(0).fillBefore(a, s <= i).append(a) : a.append(o.contentMatchAt(o.childCount).fillBefore(V.empty, !0))), n.replaceChild(e < 0 ? 0 : n.childCount - 1, o.copy(a));
}
function xg(n, e, t) {
  return e < n.openStart && (n = new X(Xd(n.content, -1, e, n.openStart, 0, n.openEnd), e, n.openEnd)), t < n.openEnd && (n = new X(Xd(n.content, 1, t, n.openEnd, 0, 0), n.openStart, t)), n;
}
const q0 = {
  thead: ["table"],
  tbody: ["table"],
  tfoot: ["table"],
  caption: ["table"],
  colgroup: ["table"],
  col: ["table", "colgroup"],
  tr: ["table", "tbody"],
  td: ["table", "tbody", "tr"],
  th: ["table", "tbody", "tr"]
};
let Cg = null;
function U0() {
  return Cg || (Cg = document.implementation.createHTMLDocument("title"));
}
function FD(n) {
  let e = /^(\s*<meta [^>]*>)*/.exec(n);
  e && (n = n.slice(e[0].length));
  let t = U0().createElement("div"), r = /<([a-z][^>\s]+)/i.exec(n), i;
  if ((i = r && q0[r[1].toLowerCase()]) && (n = i.map((s) => "<" + s + ">").join("") + n + i.map((s) => "</" + s + ">").reverse().join("")), t.innerHTML = n, i)
    for (let s = 0; s < i.length; s++)
      t = t.querySelector(i[s]) || t;
  return t;
}
function zD(n) {
  let e = n.querySelectorAll(rt ? "span:not([class]):not([style])" : "span.Apple-converted-space");
  for (let t = 0; t < e.length; t++) {
    let r = e[t];
    r.childNodes.length == 1 && r.textContent == "\xA0" && r.parentNode && r.parentNode.replaceChild(n.ownerDocument.createTextNode(" "), r);
  }
}
function BD(n, e) {
  if (!n.size)
    return n;
  let t = n.content.firstChild.type.schema, r;
  try {
    r = JSON.parse(e);
  } catch {
    return n;
  }
  let { content: i, openStart: s, openEnd: o } = n;
  for (let a = r.length - 2; a >= 0; a -= 2) {
    let l = t.nodes[r[a]];
    if (!l || l.hasRequiredAttrs())
      break;
    i = V.from(l.create(r[a + 1], i)), s++, o++;
  }
  return new X(i, s, o);
}
const gt = {}, vt = {}, jD = { touchstart: !0, touchmove: !0 };
class VD {
  constructor() {
    this.shiftKey = !1, this.mouseDown = null, this.lastKeyCode = null, this.lastKeyCodeTime = 0, this.lastClick = { time: 0, x: 0, y: 0, type: "" }, this.lastSelectionOrigin = null, this.lastSelectionTime = 0, this.lastIOSEnter = 0, this.lastIOSEnterFallbackTimeout = -1, this.lastFocus = 0, this.lastTouch = 0, this.lastAndroidDelete = 0, this.composing = !1, this.composingTimeout = -1, this.compositionNodes = [], this.compositionEndedAt = -2e8, this.compositionID = 1, this.compositionPendingChanges = 0, this.domChangeCount = 0, this.eventHandlers = /* @__PURE__ */ Object.create(null), this.hideSelectionGuard = null;
  }
}
function HD(n) {
  for (let e in gt) {
    let t = gt[e];
    n.dom.addEventListener(e, n.input.eventHandlers[e] = (r) => {
      qD(n, r) && !hp(n, r) && (n.editable || !(r.type in vt)) && t(n, r);
    }, jD[e] ? { passive: !0 } : void 0);
  }
  mt && n.dom.addEventListener("input", () => null), Yd(n);
}
function tr(n, e) {
  n.input.lastSelectionOrigin = e, n.input.lastSelectionTime = Date.now();
}
function WD(n) {
  n.domObserver.stop();
  for (let e in n.input.eventHandlers)
    n.dom.removeEventListener(e, n.input.eventHandlers[e]);
  clearTimeout(n.input.composingTimeout), clearTimeout(n.input.lastIOSEnterFallbackTimeout);
}
function Yd(n) {
  n.someProp("handleDOMEvents", (e) => {
    for (let t in e)
      n.input.eventHandlers[t] || n.dom.addEventListener(t, n.input.eventHandlers[t] = (r) => hp(n, r));
  });
}
function hp(n, e) {
  return n.someProp("handleDOMEvents", (t) => {
    let r = t[e.type];
    return r ? r(n, e) || e.defaultPrevented : !1;
  });
}
function qD(n, e) {
  if (!e.bubbles)
    return !0;
  if (e.defaultPrevented)
    return !1;
  for (let t = e.target; t != n.dom; t = t.parentNode)
    if (!t || t.nodeType == 11 || t.pmViewDesc && t.pmViewDesc.stopEvent(e))
      return !1;
  return !0;
}
function UD(n, e) {
  !hp(n, e) && gt[e.type] && (n.editable || !(e.type in vt)) && gt[e.type](n, e);
}
vt.keydown = (n, e) => {
  let t = e;
  if (n.input.shiftKey = t.keyCode == 16 || t.shiftKey, !K0(n, t) && (n.input.lastKeyCode = t.keyCode, n.input.lastKeyCodeTime = Date.now(), !(tn && rt && t.keyCode == 13)))
    if (t.keyCode != 229 && n.domObserver.forceFlush(), $i && t.keyCode == 13 && !t.ctrlKey && !t.altKey && !t.metaKey) {
      let r = Date.now();
      n.input.lastIOSEnter = r, n.input.lastIOSEnterFallbackTimeout = setTimeout(() => {
        n.input.lastIOSEnter == r && (n.someProp("handleKeyDown", (i) => i(n, Or(13, "Enter"))), n.input.lastIOSEnter = 0);
      }, 200);
    } else
      n.someProp("handleKeyDown", (r) => r(n, t)) || ND(n, t) ? t.preventDefault() : tr(n, "key");
};
vt.keyup = (n, e) => {
  e.keyCode == 16 && (n.input.shiftKey = !1);
};
vt.keypress = (n, e) => {
  let t = e;
  if (K0(n, t) || !t.charCode || t.ctrlKey && !t.altKey || qt && t.metaKey)
    return;
  if (n.someProp("handleKeyPress", (i) => i(n, t))) {
    t.preventDefault();
    return;
  }
  let r = n.state.selection;
  if (!(r instanceof de) || !r.$from.sameParent(r.$to)) {
    let i = String.fromCharCode(t.charCode);
    !/[\r\n]/.test(i) && !n.someProp("handleTextInput", (s) => s(n, r.$from.pos, r.$to.pos, i)) && n.dispatch(n.state.tr.insertText(i).scrollIntoView()), t.preventDefault();
  }
};
function Hl(n) {
  return { left: n.clientX, top: n.clientY };
}
function GD(n, e) {
  let t = e.x - n.clientX, r = e.y - n.clientY;
  return t * t + r * r < 100;
}
function mp(n, e, t, r, i) {
  if (r == -1)
    return !1;
  let s = n.state.doc.resolve(r);
  for (let o = s.depth + 1; o > 0; o--)
    if (n.someProp(e, (a) => o > s.depth ? a(n, t, s.nodeAfter, s.before(o), i, !0) : a(n, t, s.node(o), s.before(o), i, !1)))
      return !0;
  return !1;
}
function xi(n, e, t) {
  n.focused || n.focus();
  let r = n.state.tr.setSelection(e);
  t == "pointer" && r.setMeta("pointer", !0), n.dispatch(r);
}
function KD(n, e) {
  if (e == -1)
    return !1;
  let t = n.state.doc.resolve(e), r = t.nodeAfter;
  return r && r.isAtom && te.isSelectable(r) ? (xi(n, new te(t), "pointer"), !0) : !1;
}
function JD(n, e) {
  if (e == -1)
    return !1;
  let t = n.state.selection, r, i;
  t instanceof te && (r = t.node);
  let s = n.state.doc.resolve(e);
  for (let o = s.depth + 1; o > 0; o--) {
    let a = o > s.depth ? s.nodeAfter : s.node(o);
    if (te.isSelectable(a)) {
      r && t.$from.depth > 0 && o >= t.$from.depth && s.before(t.$from.depth + 1) == t.$from.pos ? i = s.before(t.$from.depth) : i = s.before(o);
      break;
    }
  }
  return i != null ? (xi(n, te.create(n.state.doc, i), "pointer"), !0) : !1;
}
function XD(n, e, t, r, i) {
  return mp(n, "handleClickOn", e, t, r) || n.someProp("handleClick", (s) => s(n, e, r)) || (i ? JD(n, t) : KD(n, t));
}
function YD(n, e, t, r) {
  return mp(n, "handleDoubleClickOn", e, t, r) || n.someProp("handleDoubleClick", (i) => i(n, e, r));
}
function QD(n, e, t, r) {
  return mp(n, "handleTripleClickOn", e, t, r) || n.someProp("handleTripleClick", (i) => i(n, e, r)) || ZD(n, t, r);
}
function ZD(n, e, t) {
  if (t.button != 0)
    return !1;
  let r = n.state.doc;
  if (e == -1)
    return r.inlineContent ? (xi(n, de.create(r, 0, r.content.size), "pointer"), !0) : !1;
  let i = r.resolve(e);
  for (let s = i.depth + 1; s > 0; s--) {
    let o = s > i.depth ? i.nodeAfter : i.node(s), a = i.before(s);
    if (o.inlineContent)
      xi(n, de.create(r, a + 1, a + 1 + o.content.size), "pointer");
    else if (te.isSelectable(o))
      xi(n, te.create(r, a), "pointer");
    else
      continue;
    return !0;
  }
}
function gp(n) {
  return Da(n);
}
const G0 = qt ? "metaKey" : "ctrlKey";
gt.mousedown = (n, e) => {
  let t = e;
  n.input.shiftKey = t.shiftKey;
  let r = gp(n), i = Date.now(), s = "singleClick";
  i - n.input.lastClick.time < 500 && GD(t, n.input.lastClick) && !t[G0] && (n.input.lastClick.type == "singleClick" ? s = "doubleClick" : n.input.lastClick.type == "doubleClick" && (s = "tripleClick")), n.input.lastClick = { time: i, x: t.clientX, y: t.clientY, type: s };
  let o = n.posAtCoords(Hl(t));
  !o || (s == "singleClick" ? (n.input.mouseDown && n.input.mouseDown.done(), n.input.mouseDown = new eL(n, o, t, !!r)) : (s == "doubleClick" ? YD : QD)(n, o.pos, o.inside, t) ? t.preventDefault() : tr(n, "pointer"));
};
class eL {
  constructor(e, t, r, i) {
    this.view = e, this.pos = t, this.event = r, this.flushed = i, this.delayedSelectionSync = !1, this.mightDrag = null, this.startDoc = e.state.doc, this.selectNode = !!r[G0], this.allowDefault = r.shiftKey;
    let s, o;
    if (t.inside > -1)
      s = e.state.doc.nodeAt(t.inside), o = t.inside;
    else {
      let c = e.state.doc.resolve(t.pos);
      s = c.parent, o = c.depth ? c.before() : 0;
    }
    const a = i ? null : r.target, l = a ? e.docView.nearestDesc(a, !0) : null;
    this.target = l ? l.dom : null;
    let { selection: u } = e.state;
    (r.button == 0 && s.type.spec.draggable && s.type.spec.selectable !== !1 || u instanceof te && u.from <= o && u.to > o) && (this.mightDrag = {
      node: s,
      pos: o,
      addAttr: !!(this.target && !this.target.draggable),
      setUneditable: !!(this.target && on && !this.target.hasAttribute("contentEditable"))
    }), this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable) && (this.view.domObserver.stop(), this.mightDrag.addAttr && (this.target.draggable = !0), this.mightDrag.setUneditable && setTimeout(() => {
      this.view.input.mouseDown == this && this.target.setAttribute("contentEditable", "false");
    }, 20), this.view.domObserver.start()), e.root.addEventListener("mouseup", this.up = this.up.bind(this)), e.root.addEventListener("mousemove", this.move = this.move.bind(this)), tr(e, "pointer");
  }
  done() {
    this.view.root.removeEventListener("mouseup", this.up), this.view.root.removeEventListener("mousemove", this.move), this.mightDrag && this.target && (this.view.domObserver.stop(), this.mightDrag.addAttr && this.target.removeAttribute("draggable"), this.mightDrag.setUneditable && this.target.removeAttribute("contentEditable"), this.view.domObserver.start()), this.delayedSelectionSync && setTimeout(() => Nn(this.view)), this.view.input.mouseDown = null;
  }
  up(e) {
    if (this.done(), !this.view.dom.contains(e.target))
      return;
    let t = this.pos;
    this.view.state.doc != this.startDoc && (t = this.view.posAtCoords(Hl(e))), this.updateAllowDefault(e), this.allowDefault || !t ? tr(this.view, "pointer") : XD(this.view, t.pos, t.inside, e, this.selectNode) ? e.preventDefault() : e.button == 0 && (this.flushed || mt && this.mightDrag && !this.mightDrag.node.isAtom || rt && !this.view.state.selection.visible && Math.min(Math.abs(t.pos - this.view.state.selection.from), Math.abs(t.pos - this.view.state.selection.to)) <= 2) ? (xi(this.view, me.near(this.view.state.doc.resolve(t.pos)), "pointer"), e.preventDefault()) : tr(this.view, "pointer");
  }
  move(e) {
    this.updateAllowDefault(e), tr(this.view, "pointer"), e.buttons == 0 && this.done();
  }
  updateAllowDefault(e) {
    !this.allowDefault && (Math.abs(this.event.x - e.clientX) > 4 || Math.abs(this.event.y - e.clientY) > 4) && (this.allowDefault = !0);
  }
}
gt.touchstart = (n) => {
  n.input.lastTouch = Date.now(), gp(n), tr(n, "pointer");
};
gt.touchmove = (n) => {
  n.input.lastTouch = Date.now(), tr(n, "pointer");
};
gt.contextmenu = (n) => gp(n);
function K0(n, e) {
  return n.composing ? !0 : mt && Math.abs(e.timeStamp - n.input.compositionEndedAt) < 500 ? (n.input.compositionEndedAt = -2e8, !0) : !1;
}
const tL = tn ? 5e3 : -1;
vt.compositionstart = vt.compositionupdate = (n) => {
  if (!n.composing) {
    n.domObserver.flush();
    let { state: e } = n, t = e.selection.$from;
    if (e.selection.empty && (e.storedMarks || !t.textOffset && t.parentOffset && t.nodeBefore.marks.some((r) => r.type.spec.inclusive === !1)))
      n.markCursor = n.state.storedMarks || t.marks(), Da(n, !0), n.markCursor = null;
    else if (Da(n), on && e.selection.empty && t.parentOffset && !t.textOffset && t.nodeBefore.marks.length) {
      let r = n.domSelectionRange();
      for (let i = r.focusNode, s = r.focusOffset; i && i.nodeType == 1 && s != 0; ) {
        let o = s < 0 ? i.lastChild : i.childNodes[s - 1];
        if (!o)
          break;
        if (o.nodeType == 3) {
          n.domSelection().collapse(o, o.nodeValue.length);
          break;
        } else
          i = o, s = -1;
      }
    }
    n.input.composing = !0;
  }
  J0(n, tL);
};
vt.compositionend = (n, e) => {
  n.composing && (n.input.composing = !1, n.input.compositionEndedAt = e.timeStamp, n.input.compositionPendingChanges = n.domObserver.pendingRecords().length ? n.input.compositionID : 0, n.input.compositionPendingChanges && Promise.resolve().then(() => n.domObserver.flush()), n.input.compositionID++, J0(n, 20));
};
function J0(n, e) {
  clearTimeout(n.input.composingTimeout), e > -1 && (n.input.composingTimeout = setTimeout(() => Da(n), e));
}
function X0(n) {
  for (n.composing && (n.input.composing = !1, n.input.compositionEndedAt = nL()); n.input.compositionNodes.length > 0; )
    n.input.compositionNodes.pop().markParentsDirty();
}
function nL() {
  let n = document.createEvent("Event");
  return n.initEvent("event", !0, !0), n.timeStamp;
}
function Da(n, e = !1) {
  if (!(tn && n.domObserver.flushingSoon >= 0)) {
    if (n.domObserver.forceFlush(), X0(n), e || n.docView && n.docView.dirty) {
      let t = fp(n);
      return t && !t.eq(n.state.selection) ? n.dispatch(n.state.tr.setSelection(t)) : n.updateState(n.state), !0;
    }
    return !1;
  }
}
function rL(n, e) {
  if (!n.dom.parentNode)
    return;
  let t = n.dom.parentNode.appendChild(document.createElement("div"));
  t.appendChild(e), t.style.cssText = "position: fixed; left: -10000px; top: 10px";
  let r = getSelection(), i = document.createRange();
  i.selectNodeContents(e), n.dom.blur(), r.removeAllRanges(), r.addRange(i), setTimeout(() => {
    t.parentNode && t.parentNode.removeChild(t), n.focus();
  }, 50);
}
const Ds = xt && sr < 15 || $i && eD < 604;
gt.copy = vt.cut = (n, e) => {
  let t = e, r = n.state.selection, i = t.type == "cut";
  if (r.empty)
    return;
  let s = Ds ? null : t.clipboardData, o = r.content(), { dom: a, text: l } = B0(n, o);
  s ? (t.preventDefault(), s.clearData(), s.setData("text/html", a.innerHTML), s.setData("text/plain", l)) : rL(n, a), i && n.dispatch(n.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function iL(n) {
  return n.openStart == 0 && n.openEnd == 0 && n.content.childCount == 1 ? n.content.firstChild : null;
}
function sL(n, e) {
  if (!n.dom.parentNode)
    return;
  let t = n.input.shiftKey || n.state.selection.$from.parent.type.spec.code, r = n.dom.parentNode.appendChild(document.createElement(t ? "textarea" : "div"));
  t || (r.contentEditable = "true"), r.style.cssText = "position: fixed; left: -10000px; top: 10px", r.focus();
  let i = n.input.shiftKey && n.input.lastKeyCode != 45;
  setTimeout(() => {
    n.focus(), r.parentNode && r.parentNode.removeChild(r), t ? Ls(n, r.value, null, i, e) : Ls(n, r.textContent, r.innerHTML, i, e);
  }, 50);
}
function Ls(n, e, t, r, i) {
  let s = j0(n, e, t, r, n.state.selection.$from);
  if (n.someProp("handlePaste", (l) => l(n, i, s || X.empty)))
    return !0;
  if (!s)
    return !1;
  let o = iL(s), a = o ? n.state.tr.replaceSelectionWith(o, r) : n.state.tr.replaceSelection(s);
  return n.dispatch(a.scrollIntoView().setMeta("paste", !0).setMeta("uiEvent", "paste")), !0;
}
function Y0(n) {
  let e = n.getData("text/plain") || n.getData("Text");
  if (e)
    return e;
  let t = n.getData("text/uri-list");
  return t ? t.replace(/\r?\n/g, " ") : "";
}
vt.paste = (n, e) => {
  let t = e;
  if (n.composing && !tn)
    return;
  let r = Ds ? null : t.clipboardData, i = n.input.shiftKey && n.input.lastKeyCode != 45;
  r && Ls(n, Y0(r), r.getData("text/html"), i, t) ? t.preventDefault() : sL(n, t);
};
class Q0 {
  constructor(e, t, r) {
    this.slice = e, this.move = t, this.node = r;
  }
}
const Z0 = qt ? "altKey" : "ctrlKey";
gt.dragstart = (n, e) => {
  let t = e, r = n.input.mouseDown;
  if (r && r.done(), !t.dataTransfer)
    return;
  let i = n.state.selection, s = i.empty ? null : n.posAtCoords(Hl(t)), o;
  if (!(s && s.pos >= i.from && s.pos <= (i instanceof te ? i.to - 1 : i.to))) {
    if (r && r.mightDrag)
      o = te.create(n.state.doc, r.mightDrag.pos);
    else if (t.target && t.target.nodeType == 1) {
      let c = n.docView.nearestDesc(t.target, !0);
      c && c.node.type.spec.draggable && c != n.docView && (o = te.create(n.state.doc, c.posBefore));
    }
  }
  let a = (o || n.state.selection).content(), { dom: l, text: u } = B0(n, a);
  t.dataTransfer.clearData(), t.dataTransfer.setData(Ds ? "Text" : "text/html", l.innerHTML), t.dataTransfer.effectAllowed = "copyMove", Ds || t.dataTransfer.setData("text/plain", u), n.dragging = new Q0(a, !t[Z0], o);
};
gt.dragend = (n) => {
  let e = n.dragging;
  window.setTimeout(() => {
    n.dragging == e && (n.dragging = null);
  }, 50);
};
vt.dragover = vt.dragenter = (n, e) => e.preventDefault();
vt.drop = (n, e) => {
  let t = e, r = n.dragging;
  if (n.dragging = null, !t.dataTransfer)
    return;
  let i = n.posAtCoords(Hl(t));
  if (!i)
    return;
  let s = n.state.doc.resolve(i.pos), o = r && r.slice;
  o ? n.someProp("transformPasted", (h) => {
    o = h(o, n);
  }) : o = j0(n, Y0(t.dataTransfer), Ds ? null : t.dataTransfer.getData("text/html"), !1, s);
  let a = !!(r && !t[Z0]);
  if (n.someProp("handleDrop", (h) => h(n, t, o || X.empty, a))) {
    t.preventDefault();
    return;
  }
  if (!o)
    return;
  t.preventDefault();
  let l = o ? g0(n.state.doc, s.pos, o) : s.pos;
  l == null && (l = s.pos);
  let u = n.state.tr;
  if (a) {
    let { node: h } = r;
    h ? h.replace(u) : u.deleteSelection();
  }
  let c = u.mapping.map(l), f = o.openStart == 0 && o.openEnd == 0 && o.content.childCount == 1, p = u.doc;
  if (f ? u.replaceRangeWith(c, c, o.content.firstChild) : u.replaceRange(c, c, o), u.doc.eq(p))
    return;
  let d = u.doc.resolve(c);
  if (f && te.isSelectable(o.content.firstChild) && d.nodeAfter && d.nodeAfter.sameMarkup(o.content.firstChild))
    u.setSelection(new te(d));
  else {
    let h = u.mapping.map(l);
    u.mapping.maps[u.mapping.maps.length - 1].forEach((v, g, m, _) => h = _), u.setSelection(pp(n, d, u.doc.resolve(h)));
  }
  n.focus(), n.dispatch(u.setMeta("uiEvent", "drop"));
};
gt.focus = (n) => {
  n.input.lastFocus = Date.now(), n.focused || (n.domObserver.stop(), n.dom.classList.add("ProseMirror-focused"), n.domObserver.start(), n.focused = !0, setTimeout(() => {
    n.docView && n.hasFocus() && !n.domObserver.currentSelection.eq(n.domSelectionRange()) && Nn(n);
  }, 20));
};
gt.blur = (n, e) => {
  let t = e;
  n.focused && (n.domObserver.stop(), n.dom.classList.remove("ProseMirror-focused"), n.domObserver.start(), t.relatedTarget && n.dom.contains(t.relatedTarget) && n.domObserver.currentSelection.clear(), n.focused = !1);
};
gt.beforeinput = (n, e) => {
  if (rt && tn && e.inputType == "deleteContentBackward") {
    n.domObserver.flushSoon();
    let { domChangeCount: r } = n.input;
    setTimeout(() => {
      if (n.input.domChangeCount != r || (n.dom.blur(), n.focus(), n.someProp("handleKeyDown", (s) => s(n, Or(8, "Backspace")))))
        return;
      let { $cursor: i } = n.state.selection;
      i && i.pos > 0 && n.dispatch(n.state.tr.delete(i.pos - 1, i.pos).scrollIntoView());
    }, 50);
  }
};
for (let n in vt)
  gt[n] = vt[n];
function Ns(n, e) {
  if (n == e)
    return !0;
  for (let t in n)
    if (n[t] !== e[t])
      return !1;
  for (let t in e)
    if (!(t in n))
      return !1;
  return !0;
}
class La {
  constructor(e, t) {
    this.toDOM = e, this.spec = t || Ir, this.side = this.spec.side || 0;
  }
  map(e, t, r, i) {
    let { pos: s, deleted: o } = e.mapResult(t.from + i, this.side < 0 ? -1 : 1);
    return o ? null : new Ut(s - r, s - r, this);
  }
  valid() {
    return !0;
  }
  eq(e) {
    return this == e || e instanceof La && (this.spec.key && this.spec.key == e.spec.key || this.toDOM == e.toDOM && Ns(this.spec, e.spec));
  }
  destroy(e) {
    this.spec.destroy && this.spec.destroy(e);
  }
}
class ar {
  constructor(e, t) {
    this.attrs = e, this.spec = t || Ir;
  }
  map(e, t, r, i) {
    let s = e.map(t.from + i, this.spec.inclusiveStart ? -1 : 1) - r, o = e.map(t.to + i, this.spec.inclusiveEnd ? 1 : -1) - r;
    return s >= o ? null : new Ut(s, o, this);
  }
  valid(e, t) {
    return t.from < t.to;
  }
  eq(e) {
    return this == e || e instanceof ar && Ns(this.attrs, e.attrs) && Ns(this.spec, e.spec);
  }
  static is(e) {
    return e.type instanceof ar;
  }
  destroy() {
  }
}
class vp {
  constructor(e, t) {
    this.attrs = e, this.spec = t || Ir;
  }
  map(e, t, r, i) {
    let s = e.mapResult(t.from + i, 1);
    if (s.deleted)
      return null;
    let o = e.mapResult(t.to + i, -1);
    return o.deleted || o.pos <= s.pos ? null : new Ut(s.pos - r, o.pos - r, this);
  }
  valid(e, t) {
    let { index: r, offset: i } = e.content.findIndex(t.from), s;
    return i == t.from && !(s = e.child(r)).isText && i + s.nodeSize == t.to;
  }
  eq(e) {
    return this == e || e instanceof vp && Ns(this.attrs, e.attrs) && Ns(this.spec, e.spec);
  }
  destroy() {
  }
}
class Ut {
  constructor(e, t, r) {
    this.from = e, this.to = t, this.type = r;
  }
  copy(e, t) {
    return new Ut(e, t, this.type);
  }
  eq(e, t = 0) {
    return this.type.eq(e.type) && this.from + t == e.from && this.to + t == e.to;
  }
  map(e, t, r) {
    return this.type.map(e, this, t, r);
  }
  static widget(e, t, r) {
    return new Ut(e, e, new La(t, r));
  }
  static inline(e, t, r, i) {
    return new Ut(e, t, new ar(r, i));
  }
  static node(e, t, r, i) {
    return new Ut(e, t, new vp(r, i));
  }
  get spec() {
    return this.type.spec;
  }
  get inline() {
    return this.type instanceof ar;
  }
  get widget() {
    return this.type instanceof La;
  }
}
const pi = [], Ir = {};
class Be {
  constructor(e, t) {
    this.local = e.length ? e : pi, this.children = t.length ? t : pi;
  }
  static create(e, t) {
    return t.length ? Na(t, e, 0, Ir) : tt;
  }
  find(e, t, r) {
    let i = [];
    return this.findInner(e == null ? 0 : e, t == null ? 1e9 : t, i, 0, r), i;
  }
  findInner(e, t, r, i, s) {
    for (let o = 0; o < this.local.length; o++) {
      let a = this.local[o];
      a.from <= t && a.to >= e && (!s || s(a.spec)) && r.push(a.copy(a.from + i, a.to + i));
    }
    for (let o = 0; o < this.children.length; o += 3)
      if (this.children[o] < t && this.children[o + 1] > e) {
        let a = this.children[o] + 1;
        this.children[o + 2].findInner(e - a, t - a, r, i + a, s);
      }
  }
  map(e, t, r) {
    return this == tt || e.maps.length == 0 ? this : this.mapInner(e, t, 0, 0, r || Ir);
  }
  mapInner(e, t, r, i, s) {
    let o;
    for (let a = 0; a < this.local.length; a++) {
      let l = this.local[a].map(e, r, i);
      l && l.type.valid(t, l) ? (o || (o = [])).push(l) : s.onRemove && s.onRemove(this.local[a].spec);
    }
    return this.children.length ? oL(this.children, o || [], e, t, r, i, s) : o ? new Be(o.sort(Rr), pi) : tt;
  }
  add(e, t) {
    return t.length ? this == tt ? Be.create(e, t) : this.addInner(e, t, 0) : this;
  }
  addInner(e, t, r) {
    let i, s = 0;
    e.forEach((a, l) => {
      let u = l + r, c;
      if (!!(c = tw(t, a, u))) {
        for (i || (i = this.children.slice()); s < i.length && i[s] < l; )
          s += 3;
        i[s] == l ? i[s + 2] = i[s + 2].addInner(a, c, u + 1) : i.splice(s, 0, l, l + a.nodeSize, Na(c, a, u + 1, Ir)), s += 3;
      }
    });
    let o = ew(s ? nw(t) : t, -r);
    for (let a = 0; a < o.length; a++)
      o[a].type.valid(e, o[a]) || o.splice(a--, 1);
    return new Be(o.length ? this.local.concat(o).sort(Rr) : this.local, i || this.children);
  }
  remove(e) {
    return e.length == 0 || this == tt ? this : this.removeInner(e, 0);
  }
  removeInner(e, t) {
    let r = this.children, i = this.local;
    for (let s = 0; s < r.length; s += 3) {
      let o, a = r[s] + t, l = r[s + 1] + t;
      for (let c = 0, f; c < e.length; c++)
        (f = e[c]) && f.from > a && f.to < l && (e[c] = null, (o || (o = [])).push(f));
      if (!o)
        continue;
      r == this.children && (r = this.children.slice());
      let u = r[s + 2].removeInner(o, a + 1);
      u != tt ? r[s + 2] = u : (r.splice(s, 3), s -= 3);
    }
    if (i.length) {
      for (let s = 0, o; s < e.length; s++)
        if (o = e[s])
          for (let a = 0; a < i.length; a++)
            i[a].eq(o, t) && (i == this.local && (i = this.local.slice()), i.splice(a--, 1));
    }
    return r == this.children && i == this.local ? this : i.length || r.length ? new Be(i, r) : tt;
  }
  forChild(e, t) {
    if (this == tt)
      return this;
    if (t.isLeaf)
      return Be.empty;
    let r, i;
    for (let a = 0; a < this.children.length; a += 3)
      if (this.children[a] >= e) {
        this.children[a] == e && (r = this.children[a + 2]);
        break;
      }
    let s = e + 1, o = s + t.content.size;
    for (let a = 0; a < this.local.length; a++) {
      let l = this.local[a];
      if (l.from < o && l.to > s && l.type instanceof ar) {
        let u = Math.max(s, l.from) - s, c = Math.min(o, l.to) - s;
        u < c && (i || (i = [])).push(l.copy(u, c));
      }
    }
    if (i) {
      let a = new Be(i.sort(Rr), pi);
      return r ? new Kn([a, r]) : a;
    }
    return r || tt;
  }
  eq(e) {
    if (this == e)
      return !0;
    if (!(e instanceof Be) || this.local.length != e.local.length || this.children.length != e.children.length)
      return !1;
    for (let t = 0; t < this.local.length; t++)
      if (!this.local[t].eq(e.local[t]))
        return !1;
    for (let t = 0; t < this.children.length; t += 3)
      if (this.children[t] != e.children[t] || this.children[t + 1] != e.children[t + 1] || !this.children[t + 2].eq(e.children[t + 2]))
        return !1;
    return !0;
  }
  locals(e) {
    return yp(this.localsInner(e));
  }
  localsInner(e) {
    if (this == tt)
      return pi;
    if (e.inlineContent || !this.local.some(ar.is))
      return this.local;
    let t = [];
    for (let r = 0; r < this.local.length; r++)
      this.local[r].type instanceof ar || t.push(this.local[r]);
    return t;
  }
}
Be.empty = new Be([], []);
Be.removeOverlap = yp;
const tt = Be.empty;
class Kn {
  constructor(e) {
    this.members = e;
  }
  map(e, t) {
    const r = this.members.map((i) => i.map(e, t, Ir));
    return Kn.from(r);
  }
  forChild(e, t) {
    if (t.isLeaf)
      return Be.empty;
    let r = [];
    for (let i = 0; i < this.members.length; i++) {
      let s = this.members[i].forChild(e, t);
      s != tt && (s instanceof Kn ? r = r.concat(s.members) : r.push(s));
    }
    return Kn.from(r);
  }
  eq(e) {
    if (!(e instanceof Kn) || e.members.length != this.members.length)
      return !1;
    for (let t = 0; t < this.members.length; t++)
      if (!this.members[t].eq(e.members[t]))
        return !1;
    return !0;
  }
  locals(e) {
    let t, r = !0;
    for (let i = 0; i < this.members.length; i++) {
      let s = this.members[i].localsInner(e);
      if (!!s.length)
        if (!t)
          t = s;
        else {
          r && (t = t.slice(), r = !1);
          for (let o = 0; o < s.length; o++)
            t.push(s[o]);
        }
    }
    return t ? yp(r ? t : t.sort(Rr)) : pi;
  }
  static from(e) {
    switch (e.length) {
      case 0:
        return tt;
      case 1:
        return e[0];
      default:
        return new Kn(e.every((t) => t instanceof Be) ? e : e.reduce((t, r) => t.concat(r instanceof Be ? r : r.members), []));
    }
  }
}
function oL(n, e, t, r, i, s, o) {
  let a = n.slice();
  for (let u = 0, c = s; u < t.maps.length; u++) {
    let f = 0;
    t.maps[u].forEach((p, d, h, v) => {
      let g = v - h - (d - p);
      for (let m = 0; m < a.length; m += 3) {
        let _ = a[m + 1];
        if (_ < 0 || p > _ + c - f)
          continue;
        let y = a[m] + c - f;
        d >= y ? a[m + 1] = p <= y ? -2 : -1 : p >= c && g && (a[m] += g, a[m + 1] += g);
      }
      f += g;
    }), c = t.maps[u].map(c, -1);
  }
  let l = !1;
  for (let u = 0; u < a.length; u += 3)
    if (a[u + 1] < 0) {
      if (a[u + 1] == -2) {
        l = !0, a[u + 1] = -1;
        continue;
      }
      let c = t.map(n[u] + s), f = c - i;
      if (f < 0 || f >= r.content.size) {
        l = !0;
        continue;
      }
      let p = t.map(n[u + 1] + s, -1), d = p - i, { index: h, offset: v } = r.content.findIndex(f), g = r.maybeChild(h);
      if (g && v == f && v + g.nodeSize == d) {
        let m = a[u + 2].mapInner(t, g, c + 1, n[u] + s + 1, o);
        m != tt ? (a[u] = f, a[u + 1] = d, a[u + 2] = m) : (a[u + 1] = -2, l = !0);
      } else
        l = !0;
    }
  if (l) {
    let u = aL(a, n, e, t, i, s, o), c = Na(u, r, 0, o);
    e = c.local;
    for (let f = 0; f < a.length; f += 3)
      a[f + 1] < 0 && (a.splice(f, 3), f -= 3);
    for (let f = 0, p = 0; f < c.children.length; f += 3) {
      let d = c.children[f];
      for (; p < a.length && a[p] < d; )
        p += 3;
      a.splice(p, 0, c.children[f], c.children[f + 1], c.children[f + 2]);
    }
  }
  return new Be(e.sort(Rr), a);
}
function ew(n, e) {
  if (!e || !n.length)
    return n;
  let t = [];
  for (let r = 0; r < n.length; r++) {
    let i = n[r];
    t.push(new Ut(i.from + e, i.to + e, i.type));
  }
  return t;
}
function aL(n, e, t, r, i, s, o) {
  function a(l, u) {
    for (let c = 0; c < l.local.length; c++) {
      let f = l.local[c].map(r, i, u);
      f ? t.push(f) : o.onRemove && o.onRemove(l.local[c].spec);
    }
    for (let c = 0; c < l.children.length; c += 3)
      a(l.children[c + 2], l.children[c] + u + 1);
  }
  for (let l = 0; l < n.length; l += 3)
    n[l + 1] == -1 && a(n[l + 2], e[l] + s + 1);
  return t;
}
function tw(n, e, t) {
  if (e.isLeaf)
    return null;
  let r = t + e.nodeSize, i = null;
  for (let s = 0, o; s < n.length; s++)
    (o = n[s]) && o.from > t && o.to < r && ((i || (i = [])).push(o), n[s] = null);
  return i;
}
function nw(n) {
  let e = [];
  for (let t = 0; t < n.length; t++)
    n[t] != null && e.push(n[t]);
  return e;
}
function Na(n, e, t, r) {
  let i = [], s = !1;
  e.forEach((a, l) => {
    let u = tw(n, a, l + t);
    if (u) {
      s = !0;
      let c = Na(u, a, t + l + 1, r);
      c != tt && i.push(l, l + a.nodeSize, c);
    }
  });
  let o = ew(s ? nw(n) : n, -t).sort(Rr);
  for (let a = 0; a < o.length; a++)
    o[a].type.valid(e, o[a]) || (r.onRemove && r.onRemove(o[a].spec), o.splice(a--, 1));
  return o.length || i.length ? new Be(o, i) : tt;
}
function Rr(n, e) {
  return n.from - e.from || n.to - e.to;
}
function yp(n) {
  let e = n;
  for (let t = 0; t < e.length - 1; t++) {
    let r = e[t];
    if (r.from != r.to)
      for (let i = t + 1; i < e.length; i++) {
        let s = e[i];
        if (s.from == r.from) {
          s.to != r.to && (e == n && (e = n.slice()), e[i] = s.copy(s.from, r.to), Og(e, i + 1, s.copy(r.to, s.to)));
          continue;
        } else {
          s.from < r.to && (e == n && (e = n.slice()), e[t] = r.copy(r.from, s.from), Og(e, i, r.copy(s.from, r.to)));
          break;
        }
      }
  }
  return e;
}
function Og(n, e, t) {
  for (; e < n.length && Rr(t, n[e]) > 0; )
    e++;
  n.splice(e, 0, t);
}
function Rc(n) {
  let e = [];
  return n.someProp("decorations", (t) => {
    let r = t(n.state);
    r && r != tt && e.push(r);
  }), n.cursorWrapper && e.push(Be.create(n.state.doc, [n.cursorWrapper.deco])), Kn.from(e);
}
const lL = {
  childList: !0,
  characterData: !0,
  characterDataOldValue: !0,
  attributes: !0,
  attributeOldValue: !0,
  subtree: !0
}, uL = xt && sr <= 11;
class cL {
  constructor() {
    this.anchorNode = null, this.anchorOffset = 0, this.focusNode = null, this.focusOffset = 0;
  }
  set(e) {
    this.anchorNode = e.anchorNode, this.anchorOffset = e.anchorOffset, this.focusNode = e.focusNode, this.focusOffset = e.focusOffset;
  }
  clear() {
    this.anchorNode = this.focusNode = null;
  }
  eq(e) {
    return e.anchorNode == this.anchorNode && e.anchorOffset == this.anchorOffset && e.focusNode == this.focusNode && e.focusOffset == this.focusOffset;
  }
}
class dL {
  constructor(e, t) {
    this.view = e, this.handleDOMChange = t, this.queue = [], this.flushingSoon = -1, this.observer = null, this.currentSelection = new cL(), this.onCharData = null, this.suppressingSelectionUpdates = !1, this.observer = window.MutationObserver && new window.MutationObserver((r) => {
      for (let i = 0; i < r.length; i++)
        this.queue.push(r[i]);
      xt && sr <= 11 && r.some((i) => i.type == "childList" && i.removedNodes.length || i.type == "characterData" && i.oldValue.length > i.target.nodeValue.length) ? this.flushSoon() : this.flush();
    }), uL && (this.onCharData = (r) => {
      this.queue.push({ target: r.target, type: "characterData", oldValue: r.prevValue }), this.flushSoon();
    }), this.onSelectionChange = this.onSelectionChange.bind(this);
  }
  flushSoon() {
    this.flushingSoon < 0 && (this.flushingSoon = window.setTimeout(() => {
      this.flushingSoon = -1, this.flush();
    }, 20));
  }
  forceFlush() {
    this.flushingSoon > -1 && (window.clearTimeout(this.flushingSoon), this.flushingSoon = -1, this.flush());
  }
  start() {
    this.observer && (this.observer.takeRecords(), this.observer.observe(this.view.dom, lL)), this.onCharData && this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData), this.connectSelection();
  }
  stop() {
    if (this.observer) {
      let e = this.observer.takeRecords();
      if (e.length) {
        for (let t = 0; t < e.length; t++)
          this.queue.push(e[t]);
        window.setTimeout(() => this.flush(), 20);
      }
      this.observer.disconnect();
    }
    this.onCharData && this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData), this.disconnectSelection();
  }
  connectSelection() {
    this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
  }
  disconnectSelection() {
    this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
  }
  suppressSelectionUpdates() {
    this.suppressingSelectionUpdates = !0, setTimeout(() => this.suppressingSelectionUpdates = !1, 50);
  }
  onSelectionChange() {
    if (!!vg(this.view)) {
      if (this.suppressingSelectionUpdates)
        return Nn(this.view);
      if (xt && sr <= 11 && !this.view.state.selection.empty) {
        let e = this.view.domSelectionRange();
        if (e.focusNode && jr(e.focusNode, e.focusOffset, e.anchorNode, e.anchorOffset))
          return this.flushSoon();
      }
      this.flush();
    }
  }
  setCurSelection() {
    this.currentSelection.set(this.view.domSelectionRange());
  }
  ignoreSelectionChange(e) {
    if (!e.focusNode)
      return !0;
    let t = /* @__PURE__ */ new Set(), r;
    for (let s = e.focusNode; s; s = $s(s))
      t.add(s);
    for (let s = e.anchorNode; s; s = $s(s))
      if (t.has(s)) {
        r = s;
        break;
      }
    let i = r && this.view.docView.nearestDesc(r);
    if (i && i.ignoreMutation({
      type: "selection",
      target: r.nodeType == 3 ? r.parentNode : r
    }))
      return this.setCurSelection(), !0;
  }
  pendingRecords() {
    if (this.observer)
      for (let e of this.observer.takeRecords())
        this.queue.push(e);
    return this.queue;
  }
  flush() {
    let { view: e } = this;
    if (!e.docView || this.flushingSoon > -1)
      return;
    let t = this.pendingRecords();
    t.length && (this.queue = []);
    let r = e.domSelectionRange(), i = !this.suppressingSelectionUpdates && !this.currentSelection.eq(r) && vg(e) && !this.ignoreSelectionChange(r), s = -1, o = -1, a = !1, l = [];
    if (e.editable)
      for (let c = 0; c < t.length; c++) {
        let f = this.registerMutation(t[c], l);
        f && (s = s < 0 ? f.from : Math.min(f.from, s), o = o < 0 ? f.to : Math.max(f.to, o), f.typeOver && (a = !0));
      }
    if (on && l.length > 1) {
      let c = l.filter((f) => f.nodeName == "BR");
      if (c.length == 2) {
        let f = c[0], p = c[1];
        f.parentNode && f.parentNode.parentNode == p.parentNode ? p.remove() : f.remove();
      }
    }
    let u = null;
    s < 0 && i && e.input.lastFocus > Date.now() - 200 && Math.max(e.input.lastTouch, e.input.lastClick.time) < Date.now() - 300 && jl(r) && (u = fp(e)) && u.eq(me.near(e.state.doc.resolve(0), 1)) ? (e.input.lastFocus = 0, Nn(e), this.currentSelection.set(r), e.scrollToSelection()) : (s > -1 || i) && (s > -1 && (e.docView.markDirty(s, o), fL(e)), this.handleDOMChange(s, o, a, l), e.docView && e.docView.dirty ? e.updateState(e.state) : this.currentSelection.eq(r) || Nn(e), this.currentSelection.set(r));
  }
  registerMutation(e, t) {
    if (t.indexOf(e.target) > -1)
      return null;
    let r = this.view.docView.nearestDesc(e.target);
    if (e.type == "attributes" && (r == this.view.docView || e.attributeName == "contenteditable" || e.attributeName == "style" && !e.oldValue && !e.target.getAttribute("style")) || !r || r.ignoreMutation(e))
      return null;
    if (e.type == "childList") {
      for (let c = 0; c < e.addedNodes.length; c++)
        t.push(e.addedNodes[c]);
      if (r.contentDOM && r.contentDOM != r.dom && !r.contentDOM.contains(e.target))
        return { from: r.posBefore, to: r.posAfter };
      let i = e.previousSibling, s = e.nextSibling;
      if (xt && sr <= 11 && e.addedNodes.length)
        for (let c = 0; c < e.addedNodes.length; c++) {
          let { previousSibling: f, nextSibling: p } = e.addedNodes[c];
          (!f || Array.prototype.indexOf.call(e.addedNodes, f) < 0) && (i = f), (!p || Array.prototype.indexOf.call(e.addedNodes, p) < 0) && (s = p);
        }
      let o = i && i.parentNode == e.target ? dt(i) + 1 : 0, a = r.localPosFromDOM(e.target, o, -1), l = s && s.parentNode == e.target ? dt(s) : e.target.childNodes.length, u = r.localPosFromDOM(e.target, l, 1);
      return { from: a, to: u };
    } else
      return e.type == "attributes" ? { from: r.posAtStart - r.border, to: r.posAtEnd + r.border } : {
        from: r.posAtStart,
        to: r.posAtEnd,
        typeOver: e.target.nodeValue == e.oldValue
      };
  }
}
let Eg = /* @__PURE__ */ new WeakMap(), Tg = !1;
function fL(n) {
  if (!Eg.has(n) && (Eg.set(n, null), ["normal", "nowrap", "pre-line"].indexOf(getComputedStyle(n.dom).whiteSpace) !== -1)) {
    if (n.requiresGeckoHackNode = on, Tg)
      return;
    console.warn("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package."), Tg = !0;
  }
}
function pL(n) {
  let e;
  function t(l) {
    l.preventDefault(), l.stopImmediatePropagation(), e = l.getTargetRanges()[0];
  }
  n.dom.addEventListener("beforeinput", t, !0), document.execCommand("indent"), n.dom.removeEventListener("beforeinput", t, !0);
  let r = e.startContainer, i = e.startOffset, s = e.endContainer, o = e.endOffset, a = n.domAtPos(n.state.selection.anchor);
  return jr(a.node, a.offset, s, o) && ([r, i, s, o] = [s, o, r, i]), { anchorNode: r, anchorOffset: i, focusNode: s, focusOffset: o };
}
function hL(n, e, t) {
  let { node: r, fromOffset: i, toOffset: s, from: o, to: a } = n.docView.parseRange(e, t), l = n.domSelectionRange(), u, c = l.anchorNode;
  if (c && n.dom.contains(c.nodeType == 1 ? c : c.parentNode) && (u = [{ node: c, offset: l.anchorOffset }], jl(l) || u.push({ node: l.focusNode, offset: l.focusOffset })), rt && n.input.lastKeyCode === 8)
    for (let g = s; g > i; g--) {
      let m = r.childNodes[g - 1], _ = m.pmViewDesc;
      if (m.nodeName == "BR" && !_) {
        s = g;
        break;
      }
      if (!_ || _.size)
        break;
    }
  let f = n.state.doc, p = n.someProp("domParser") || Mi.fromSchema(n.state.schema), d = f.resolve(o), h = null, v = p.parse(r, {
    topNode: d.parent,
    topMatch: d.parent.contentMatchAt(d.index()),
    topOpen: !0,
    from: i,
    to: s,
    preserveWhitespace: d.parent.type.whitespace == "pre" ? "full" : !0,
    findPositions: u,
    ruleFromNode: mL,
    context: d
  });
  if (u && u[0].pos != null) {
    let g = u[0].pos, m = u[1] && u[1].pos;
    m == null && (m = g), h = { anchor: g + o, head: m + o };
  }
  return { doc: v, sel: h, from: o, to: a };
}
function mL(n) {
  let e = n.pmViewDesc;
  if (e)
    return e.parseRule();
  if (n.nodeName == "BR" && n.parentNode) {
    if (mt && /^(ul|ol)$/i.test(n.parentNode.nodeName)) {
      let t = document.createElement("div");
      return t.appendChild(document.createElement("li")), { skip: t };
    } else if (n.parentNode.lastChild == n || mt && /^(tr|table)$/i.test(n.parentNode.nodeName))
      return { ignore: !0 };
  } else if (n.nodeName == "IMG" && n.getAttribute("mark-placeholder"))
    return { ignore: !0 };
  return null;
}
const gL = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function vL(n, e, t, r, i) {
  let s = n.input.compositionPendingChanges || (n.composing ? n.input.compositionID : 0);
  if (n.input.compositionPendingChanges = 0, e < 0) {
    let x = n.input.lastSelectionTime > Date.now() - 50 ? n.input.lastSelectionOrigin : null, E = fp(n, x);
    if (E && !n.state.selection.eq(E)) {
      if (rt && tn && n.input.lastKeyCode === 13 && Date.now() - 100 < n.input.lastKeyCodeTime && n.someProp("handleKeyDown", ($) => $(n, Or(13, "Enter"))))
        return;
      let M = n.state.tr.setSelection(E);
      x == "pointer" ? M.setMeta("pointer", !0) : x == "key" && M.scrollIntoView(), s && M.setMeta("composition", s), n.dispatch(M);
    }
    return;
  }
  let o = n.state.doc.resolve(e), a = o.sharedDepth(t);
  e = o.before(a + 1), t = n.state.doc.resolve(t).after(a + 1);
  let l = n.state.selection, u = hL(n, e, t), c = n.state.doc, f = c.slice(u.from, u.to), p, d;
  n.input.lastKeyCode === 8 && Date.now() - 100 < n.input.lastKeyCodeTime ? (p = n.state.selection.to, d = "end") : (p = n.state.selection.from, d = "start"), n.input.lastKeyCode = null;
  let h = wL(f.content, u.doc.content, u.from, p, d);
  if (($i && n.input.lastIOSEnter > Date.now() - 225 || tn) && i.some((x) => x.nodeType == 1 && !gL.test(x.nodeName)) && (!h || h.endA >= h.endB) && n.someProp("handleKeyDown", (x) => x(n, Or(13, "Enter")))) {
    n.input.lastIOSEnter = 0;
    return;
  }
  if (!h)
    if (r && l instanceof de && !l.empty && l.$head.sameParent(l.$anchor) && !n.composing && !(u.sel && u.sel.anchor != u.sel.head))
      h = { start: l.from, endA: l.to, endB: l.to };
    else {
      if (u.sel) {
        let x = kg(n, n.state.doc, u.sel);
        if (x && !x.eq(n.state.selection)) {
          let E = n.state.tr.setSelection(x);
          s && E.setMeta("composition", s), n.dispatch(E);
        }
      }
      return;
    }
  if (rt && n.cursorWrapper && u.sel && u.sel.anchor == n.cursorWrapper.deco.from && u.sel.head == u.sel.anchor) {
    let x = h.endB - h.start;
    u.sel = { anchor: u.sel.anchor + x, head: u.sel.anchor + x };
  }
  n.input.domChangeCount++, n.state.selection.from < n.state.selection.to && h.start == h.endB && n.state.selection instanceof de && (h.start > n.state.selection.from && h.start <= n.state.selection.from + 2 && n.state.selection.from >= u.from ? h.start = n.state.selection.from : h.endA < n.state.selection.to && h.endA >= n.state.selection.to - 2 && n.state.selection.to <= u.to && (h.endB += n.state.selection.to - h.endA, h.endA = n.state.selection.to)), xt && sr <= 11 && h.endB == h.start + 1 && h.endA == h.start && h.start > u.from && u.doc.textBetween(h.start - u.from - 1, h.start - u.from + 1) == " \xA0" && (h.start--, h.endA--, h.endB--);
  let v = u.doc.resolveNoCache(h.start - u.from), g = u.doc.resolveNoCache(h.endB - u.from), m = c.resolve(h.start), _ = v.sameParent(g) && v.parent.inlineContent && m.end() >= h.endA, y;
  if (($i && n.input.lastIOSEnter > Date.now() - 225 && (!_ || i.some((x) => x.nodeName == "DIV" || x.nodeName == "P")) || !_ && v.pos < u.doc.content.size && !v.sameParent(g) && (y = me.findFrom(u.doc.resolve(v.pos + 1), 1, !0)) && y.head == g.pos) && n.someProp("handleKeyDown", (x) => x(n, Or(13, "Enter")))) {
    n.input.lastIOSEnter = 0;
    return;
  }
  if (n.state.selection.anchor > h.start && bL(c, h.start, h.endA, v, g) && n.someProp("handleKeyDown", (x) => x(n, Or(8, "Backspace")))) {
    tn && rt && n.domObserver.suppressSelectionUpdates();
    return;
  }
  rt && tn && h.endB == h.start && (n.input.lastAndroidDelete = Date.now()), tn && !_ && v.start() != g.start() && g.parentOffset == 0 && v.depth == g.depth && u.sel && u.sel.anchor == u.sel.head && u.sel.head == h.endA && (h.endB -= 2, g = u.doc.resolveNoCache(h.endB - u.from), setTimeout(() => {
    n.someProp("handleKeyDown", function(x) {
      return x(n, Or(13, "Enter"));
    });
  }, 20));
  let w = h.start, O = h.endA, C, S, b;
  if (_) {
    if (v.pos == g.pos)
      xt && sr <= 11 && v.parentOffset == 0 && (n.domObserver.suppressSelectionUpdates(), setTimeout(() => Nn(n), 20)), C = n.state.tr.delete(w, O), S = c.resolve(h.start).marksAcross(c.resolve(h.endA));
    else if (h.endA == h.endB && (b = yL(v.parent.content.cut(v.parentOffset, g.parentOffset), m.parent.content.cut(m.parentOffset, h.endA - m.start()))))
      C = n.state.tr, b.type == "add" ? C.addMark(w, O, b.mark) : C.removeMark(w, O, b.mark);
    else if (v.parent.child(v.index()).isText && v.index() == g.index() - (g.textOffset ? 0 : 1)) {
      let x = v.parent.textBetween(v.parentOffset, g.parentOffset);
      if (n.someProp("handleTextInput", (E) => E(n, w, O, x)))
        return;
      C = n.state.tr.insertText(x, w, O);
    }
  }
  if (C || (C = n.state.tr.replace(w, O, u.doc.slice(h.start - u.from, h.endB - u.from))), u.sel) {
    let x = kg(n, C.doc, u.sel);
    x && !(rt && tn && n.composing && x.empty && (h.start != h.endB || n.input.lastAndroidDelete < Date.now() - 100) && (x.head == w || x.head == C.mapping.map(O) - 1) || xt && x.empty && x.head == w) && C.setSelection(x);
  }
  S && C.ensureMarks(S), s && C.setMeta("composition", s), n.dispatch(C.scrollIntoView());
}
function kg(n, e, t) {
  return Math.max(t.anchor, t.head) > e.content.size ? null : pp(n, e.resolve(t.anchor), e.resolve(t.head));
}
function yL(n, e) {
  let t = n.firstChild.marks, r = e.firstChild.marks, i = t, s = r, o, a, l;
  for (let c = 0; c < r.length; c++)
    i = r[c].removeFromSet(i);
  for (let c = 0; c < t.length; c++)
    s = t[c].removeFromSet(s);
  if (i.length == 1 && s.length == 0)
    a = i[0], o = "add", l = (c) => c.mark(a.addToSet(c.marks));
  else if (i.length == 0 && s.length == 1)
    a = s[0], o = "remove", l = (c) => c.mark(a.removeFromSet(c.marks));
  else
    return null;
  let u = [];
  for (let c = 0; c < e.childCount; c++)
    u.push(l(e.child(c)));
  if (V.from(u).eq(n))
    return { mark: a, type: o };
}
function bL(n, e, t, r, i) {
  if (!r.parent.isTextblock || t - e <= i.pos - r.pos || Fc(r, !0, !1) < i.pos)
    return !1;
  let s = n.resolve(e);
  if (s.parentOffset < s.parent.content.size || !s.parent.isTextblock)
    return !1;
  let o = n.resolve(Fc(s, !0, !0));
  return !o.parent.isTextblock || o.pos > t || Fc(o, !0, !1) < t ? !1 : r.parent.content.cut(r.parentOffset).eq(o.parent.content);
}
function Fc(n, e, t) {
  let r = n.depth, i = e ? n.end() : n.pos;
  for (; r > 0 && (e || n.indexAfter(r) == n.node(r).childCount); )
    r--, i++, e = !1;
  if (t) {
    let s = n.node(r).maybeChild(n.indexAfter(r));
    for (; s && !s.isLeaf; )
      s = s.firstChild, i++;
  }
  return i;
}
function wL(n, e, t, r, i) {
  let s = n.findDiffStart(e, t);
  if (s == null)
    return null;
  let { a: o, b: a } = n.findDiffEnd(e, t + n.size, t + e.size);
  if (i == "end") {
    let l = Math.max(0, s - Math.min(o, a));
    r -= o + l - s;
  }
  if (o < s && n.size < e.size) {
    let l = r <= s && r >= o ? s - r : 0;
    s -= l, s && s < e.size && Mg(e.textBetween(s - 1, s + 1)) && (s += l ? 1 : -1), a = s + (a - o), o = s;
  } else if (a < s) {
    let l = r <= s && r >= a ? s - r : 0;
    s -= l, s && s < n.size && Mg(n.textBetween(s - 1, s + 1)) && (s += l ? 1 : -1), o = s + (o - a), a = s;
  }
  return { start: s, endA: o, endB: a };
}
function Mg(n) {
  if (n.length != 2)
    return !1;
  let e = n.charCodeAt(0), t = n.charCodeAt(1);
  return e >= 56320 && e <= 57343 && t >= 55296 && t <= 56319;
}
class _L {
  constructor(e, t) {
    this._root = null, this.focused = !1, this.trackWrites = null, this.mounted = !1, this.markCursor = null, this.cursorWrapper = null, this.lastSelectedViewDesc = void 0, this.input = new VD(), this.prevDirectPlugins = [], this.pluginViews = [], this.requiresGeckoHackNode = !1, this.dragging = null, this._props = t, this.state = t.state, this.directPlugins = t.plugins || [], this.directPlugins.forEach(Lg), this.dispatch = this.dispatch.bind(this), this.dom = e && e.mount || document.createElement("div"), e && (e.appendChild ? e.appendChild(this.dom) : typeof e == "function" ? e(this.dom) : e.mount && (this.mounted = !0)), this.editable = $g(this), Pg(this), this.nodeViews = Dg(this), this.docView = dg(this.state.doc, Ag(this), Rc(this), this.dom, this), this.domObserver = new dL(this, (r, i, s, o) => vL(this, r, i, s, o)), this.domObserver.start(), HD(this), this.updatePluginViews();
  }
  get composing() {
    return this.input.composing;
  }
  get props() {
    if (this._props.state != this.state) {
      let e = this._props;
      this._props = {};
      for (let t in e)
        this._props[t] = e[t];
      this._props.state = this.state;
    }
    return this._props;
  }
  update(e) {
    e.handleDOMEvents != this._props.handleDOMEvents && Yd(this);
    let t = this._props;
    this._props = e, e.plugins && (e.plugins.forEach(Lg), this.directPlugins = e.plugins), this.updateStateInner(e.state, t);
  }
  setProps(e) {
    let t = {};
    for (let r in this._props)
      t[r] = this._props[r];
    t.state = this.state;
    for (let r in e)
      t[r] = e[r];
    this.update(t);
  }
  updateState(e) {
    this.updateStateInner(e, this._props);
  }
  updateStateInner(e, t) {
    var r;
    let i = this.state, s = !1, o = !1;
    e.storedMarks && this.composing && (X0(this), o = !0), this.state = e;
    let a = i.plugins != e.plugins || this._props.plugins != t.plugins;
    if (a || this._props.plugins != t.plugins || this._props.nodeViews != t.nodeViews) {
      let d = Dg(this);
      xL(d, this.nodeViews) && (this.nodeViews = d, s = !0);
    }
    (a || t.handleDOMEvents != this._props.handleDOMEvents) && Yd(this), this.editable = $g(this), Pg(this);
    let l = Rc(this), u = Ag(this), c = i.plugins != e.plugins && !i.doc.eq(e.doc) ? "reset" : e.scrollToSelection > i.scrollToSelection ? "to selection" : "preserve", f = s || !this.docView.matchesNode(e.doc, u, l);
    (f || !e.selection.eq(i.selection)) && (o = !0);
    let p = c == "preserve" && o && this.dom.style.overflowAnchor == null && rD(this);
    if (o) {
      this.domObserver.stop();
      let d = f && (xt || rt) && !this.composing && !i.selection.empty && !e.selection.empty && SL(i.selection, e.selection);
      if (f) {
        let h = rt ? this.trackWrites = this.domSelectionRange().focusNode : null;
        (s || !this.docView.update(e.doc, u, l, this)) && (this.docView.updateOuterDeco([]), this.docView.destroy(), this.docView = dg(e.doc, u, l, this.dom, this)), h && !this.trackWrites && (d = !0);
      }
      d || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && kD(this)) ? Nn(this, d) : (R0(this, e.selection), this.domObserver.setCurSelection()), this.domObserver.start();
    }
    this.updatePluginViews(i), ((r = this.dragging) === null || r === void 0 ? void 0 : r.node) && !i.doc.eq(e.doc) && this.updateDraggedNode(this.dragging, i), c == "reset" ? this.dom.scrollTop = 0 : c == "to selection" ? this.scrollToSelection() : p && iD(p);
  }
  scrollToSelection() {
    let e = this.domSelectionRange().focusNode;
    if (!this.someProp("handleScrollToSelection", (t) => t(this)))
      if (this.state.selection instanceof te) {
        let t = this.docView.domAfterPos(this.state.selection.from);
        t.nodeType == 1 && sg(this, t.getBoundingClientRect(), e);
      } else
        sg(this, this.coordsAtPos(this.state.selection.head, 1), e);
  }
  destroyPluginViews() {
    let e;
    for (; e = this.pluginViews.pop(); )
      e.destroy && e.destroy();
  }
  updatePluginViews(e) {
    if (!e || e.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
      this.prevDirectPlugins = this.directPlugins, this.destroyPluginViews();
      for (let t = 0; t < this.directPlugins.length; t++) {
        let r = this.directPlugins[t];
        r.spec.view && this.pluginViews.push(r.spec.view(this));
      }
      for (let t = 0; t < this.state.plugins.length; t++) {
        let r = this.state.plugins[t];
        r.spec.view && this.pluginViews.push(r.spec.view(this));
      }
    } else
      for (let t = 0; t < this.pluginViews.length; t++) {
        let r = this.pluginViews[t];
        r.update && r.update(this, e);
      }
  }
  updateDraggedNode(e, t) {
    let r = e.node, i = -1;
    if (this.state.doc.nodeAt(r.from) == r.node)
      i = r.from;
    else {
      let s = r.from + (this.state.doc.content.size - t.doc.content.size);
      (s > 0 && this.state.doc.nodeAt(s)) == r.node && (i = s);
    }
    this.dragging = new Q0(e.slice, e.move, i < 0 ? void 0 : te.create(this.state.doc, i));
  }
  someProp(e, t) {
    let r = this._props && this._props[e], i;
    if (r != null && (i = t ? t(r) : r))
      return i;
    for (let o = 0; o < this.directPlugins.length; o++) {
      let a = this.directPlugins[o].props[e];
      if (a != null && (i = t ? t(a) : a))
        return i;
    }
    let s = this.state.plugins;
    if (s)
      for (let o = 0; o < s.length; o++) {
        let a = s[o].props[e];
        if (a != null && (i = t ? t(a) : a))
          return i;
      }
  }
  hasFocus() {
    if (xt) {
      let e = this.root.activeElement;
      if (e == this.dom)
        return !0;
      if (!e || !this.dom.contains(e))
        return !1;
      for (; e && this.dom != e && this.dom.contains(e); ) {
        if (e.contentEditable == "false")
          return !1;
        e = e.parentElement;
      }
      return !0;
    }
    return this.root.activeElement == this.dom;
  }
  focus() {
    this.domObserver.stop(), this.editable && sD(this.dom), Nn(this), this.domObserver.start();
  }
  get root() {
    let e = this._root;
    if (e == null) {
      for (let t = this.dom.parentNode; t; t = t.parentNode)
        if (t.nodeType == 9 || t.nodeType == 11 && t.host)
          return t.getSelection || (Object.getPrototypeOf(t).getSelection = () => t.ownerDocument.getSelection()), this._root = t;
    }
    return e || document;
  }
  updateRoot() {
    this._root = null;
  }
  posAtCoords(e) {
    return cD(this, e);
  }
  coordsAtPos(e, t = 1) {
    return M0(this, e, t);
  }
  domAtPos(e, t = 0) {
    return this.docView.domFromPos(e, t);
  }
  nodeDOM(e) {
    let t = this.docView.descAt(e);
    return t ? t.nodeDOM : null;
  }
  posAtDOM(e, t, r = -1) {
    let i = this.docView.posFromDOM(e, t, r);
    if (i == null)
      throw new RangeError("DOM position not inside the editor");
    return i;
  }
  endOfTextblock(e, t) {
    return mD(this, t || this.state, e);
  }
  pasteHTML(e, t) {
    return Ls(this, "", e, !1, t || new ClipboardEvent("paste"));
  }
  pasteText(e, t) {
    return Ls(this, e, null, !0, t || new ClipboardEvent("paste"));
  }
  destroy() {
    !this.docView || (WD(this), this.destroyPluginViews(), this.mounted ? (this.docView.update(this.state.doc, [], Rc(this), this), this.dom.textContent = "") : this.dom.parentNode && this.dom.parentNode.removeChild(this.dom), this.docView.destroy(), this.docView = null);
  }
  get isDestroyed() {
    return this.docView == null;
  }
  dispatchEvent(e) {
    return UD(this, e);
  }
  dispatch(e) {
    let t = this._props.dispatchTransaction;
    t ? t.call(this, e) : this.updateState(this.state.apply(e));
  }
  domSelectionRange() {
    return mt && this.root.nodeType === 11 && X$(this.dom.ownerDocument) == this.dom ? pL(this) : this.domSelection();
  }
  domSelection() {
    return this.root.getSelection();
  }
}
function Ag(n) {
  let e = /* @__PURE__ */ Object.create(null);
  return e.class = "ProseMirror", e.contenteditable = String(n.editable), n.someProp("attributes", (t) => {
    if (typeof t == "function" && (t = t(n.state)), t)
      for (let r in t)
        r == "class" ? e.class += " " + t[r] : r == "style" ? e.style = (e.style ? e.style + ";" : "") + t[r] : !e[r] && r != "contenteditable" && r != "nodeName" && (e[r] = String(t[r]));
  }), e.translate || (e.translate = "no"), [Ut.node(0, n.state.doc.content.size, e)];
}
function Pg(n) {
  if (n.markCursor) {
    let e = document.createElement("img");
    e.className = "ProseMirror-separator", e.setAttribute("mark-placeholder", "true"), e.setAttribute("alt", ""), n.cursorWrapper = { dom: e, deco: Ut.widget(n.state.selection.head, e, { raw: !0, marks: n.markCursor }) };
  } else
    n.cursorWrapper = null;
}
function $g(n) {
  return !n.someProp("editable", (e) => e(n.state) === !1);
}
function SL(n, e) {
  let t = Math.min(n.$anchor.sharedDepth(n.head), e.$anchor.sharedDepth(e.head));
  return n.$anchor.start(t) != e.$anchor.start(t);
}
function Dg(n) {
  let e = /* @__PURE__ */ Object.create(null);
  function t(r) {
    for (let i in r)
      Object.prototype.hasOwnProperty.call(e, i) || (e[i] = r[i]);
  }
  return n.someProp("nodeViews", t), n.someProp("markViews", t), e;
}
function xL(n, e) {
  let t = 0, r = 0;
  for (let i in n) {
    if (n[i] != e[i])
      return !0;
    t++;
  }
  for (let i in e)
    r++;
  return t != r;
}
function Lg(n) {
  if (n.spec.state || n.spec.filterTransaction || n.spec.appendTransaction)
    throw new RangeError("Plugins passed directly to the view must not have a state component");
}
var fr = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
}, Ia = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: '"'
}, CL = typeof navigator < "u" && /Mac/.test(navigator.platform), OL = typeof navigator < "u" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
for (var Ze = 0; Ze < 10; Ze++)
  fr[48 + Ze] = fr[96 + Ze] = String(Ze);
for (var Ze = 1; Ze <= 24; Ze++)
  fr[Ze + 111] = "F" + Ze;
for (var Ze = 65; Ze <= 90; Ze++)
  fr[Ze] = String.fromCharCode(Ze + 32), Ia[Ze] = String.fromCharCode(Ze);
for (var zc in fr)
  Ia.hasOwnProperty(zc) || (Ia[zc] = fr[zc]);
function EL(n) {
  var e = CL && n.metaKey && n.shiftKey && !n.ctrlKey && !n.altKey || OL && n.shiftKey && n.key && n.key.length == 1 || n.key == "Unidentified", t = !e && n.key || (n.shiftKey ? Ia : fr)[n.keyCode] || n.key || "Unidentified";
  return t == "Esc" && (t = "Escape"), t == "Del" && (t = "Delete"), t == "Left" && (t = "ArrowLeft"), t == "Up" && (t = "ArrowUp"), t == "Right" && (t = "ArrowRight"), t == "Down" && (t = "ArrowDown"), t;
}
const TL = typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : !1;
function kL(n) {
  let e = n.split(/-(?!$)/), t = e[e.length - 1];
  t == "Space" && (t = " ");
  let r, i, s, o;
  for (let a = 0; a < e.length - 1; a++) {
    let l = e[a];
    if (/^(cmd|meta|m)$/i.test(l))
      o = !0;
    else if (/^a(lt)?$/i.test(l))
      r = !0;
    else if (/^(c|ctrl|control)$/i.test(l))
      i = !0;
    else if (/^s(hift)?$/i.test(l))
      s = !0;
    else if (/^mod$/i.test(l))
      TL ? o = !0 : i = !0;
    else
      throw new Error("Unrecognized modifier name: " + l);
  }
  return r && (t = "Alt-" + t), i && (t = "Ctrl-" + t), o && (t = "Meta-" + t), s && (t = "Shift-" + t), t;
}
function ML(n) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let t in n)
    e[kL(t)] = n[t];
  return e;
}
function Bc(n, e, t = !0) {
  return e.altKey && (n = "Alt-" + n), e.ctrlKey && (n = "Ctrl-" + n), e.metaKey && (n = "Meta-" + n), t && e.shiftKey && (n = "Shift-" + n), n;
}
function AL(n) {
  return new lt({ props: { handleKeyDown: rw(n) } });
}
function rw(n) {
  let e = ML(n);
  return function(t, r) {
    let i = EL(r), s, o = e[Bc(i, r)];
    if (o && o(t.state, t.dispatch, t))
      return !0;
    if (i.length == 1 && i != " ") {
      if (r.shiftKey) {
        let a = e[Bc(i, r, !1)];
        if (a && a(t.state, t.dispatch, t))
          return !0;
      }
      if ((r.shiftKey || r.altKey || r.metaKey || i.charCodeAt(0) > 127) && (s = fr[r.keyCode]) && s != i) {
        let a = e[Bc(s, r)];
        if (a && a(t.state, t.dispatch, t))
          return !0;
      }
    }
    return !1;
  };
}
const PL = (n, e) => n.selection.empty ? !1 : (e && e(n.tr.deleteSelection().scrollIntoView()), !0);
function $L(n, e) {
  let { $cursor: t } = n.selection;
  return !t || (e ? !e.endOfTextblock("backward", n) : t.parentOffset > 0) ? null : t;
}
const DL = (n, e, t) => {
  let r = $L(n, t);
  if (!r)
    return !1;
  let i = iw(r);
  if (!i) {
    let o = r.blockRange(), a = o && qi(o);
    return a == null ? !1 : (e && e(n.tr.lift(o, a).scrollIntoView()), !0);
  }
  let s = i.nodeBefore;
  if (!s.type.spec.isolating && aw(n, i, e))
    return !0;
  if (r.parent.content.size == 0 && (Di(s, "end") || te.isSelectable(s))) {
    let o = lp(n.doc, r.before(), r.after(), X.empty);
    if (o && o.slice.size < o.to - o.from) {
      if (e) {
        let a = n.tr.step(o);
        a.setSelection(Di(s, "end") ? me.findFrom(a.doc.resolve(a.mapping.map(i.pos, -1)), -1) : te.create(a.doc, i.pos - s.nodeSize)), e(a.scrollIntoView());
      }
      return !0;
    }
  }
  return s.isAtom && i.depth == r.depth - 1 ? (e && e(n.tr.delete(i.pos - s.nodeSize, i.pos).scrollIntoView()), !0) : !1;
};
function Di(n, e, t = !1) {
  for (let r = n; r; r = e == "start" ? r.firstChild : r.lastChild) {
    if (r.isTextblock)
      return !0;
    if (t && r.childCount != 1)
      return !1;
  }
  return !1;
}
const LL = (n, e, t) => {
  let { $head: r, empty: i } = n.selection, s = r;
  if (!i)
    return !1;
  if (r.parent.isTextblock) {
    if (t ? !t.endOfTextblock("backward", n) : r.parentOffset > 0)
      return !1;
    s = iw(r);
  }
  let o = s && s.nodeBefore;
  return !o || !te.isSelectable(o) ? !1 : (e && e(n.tr.setSelection(te.create(n.doc, s.pos - o.nodeSize)).scrollIntoView()), !0);
};
function iw(n) {
  if (!n.parent.type.spec.isolating)
    for (let e = n.depth - 1; e >= 0; e--) {
      if (n.index(e) > 0)
        return n.doc.resolve(n.before(e + 1));
      if (n.node(e).type.spec.isolating)
        break;
    }
  return null;
}
function NL(n, e) {
  let { $cursor: t } = n.selection;
  return !t || (e ? !e.endOfTextblock("forward", n) : t.parentOffset < t.parent.content.size) ? null : t;
}
const IL = (n, e, t) => {
  let r = NL(n, t);
  if (!r)
    return !1;
  let i = sw(r);
  if (!i)
    return !1;
  let s = i.nodeAfter;
  if (aw(n, i, e))
    return !0;
  if (r.parent.content.size == 0 && (Di(s, "start") || te.isSelectable(s))) {
    let o = lp(n.doc, r.before(), r.after(), X.empty);
    if (o && o.slice.size < o.to - o.from) {
      if (e) {
        let a = n.tr.step(o);
        a.setSelection(Di(s, "start") ? me.findFrom(a.doc.resolve(a.mapping.map(i.pos)), 1) : te.create(a.doc, a.mapping.map(i.pos))), e(a.scrollIntoView());
      }
      return !0;
    }
  }
  return s.isAtom && i.depth == r.depth - 1 ? (e && e(n.tr.delete(i.pos, i.pos + s.nodeSize).scrollIntoView()), !0) : !1;
}, RL = (n, e, t) => {
  let { $head: r, empty: i } = n.selection, s = r;
  if (!i)
    return !1;
  if (r.parent.isTextblock) {
    if (t ? !t.endOfTextblock("forward", n) : r.parentOffset < r.parent.content.size)
      return !1;
    s = sw(r);
  }
  let o = s && s.nodeAfter;
  return !o || !te.isSelectable(o) ? !1 : (e && e(n.tr.setSelection(te.create(n.doc, s.pos)).scrollIntoView()), !0);
};
function sw(n) {
  if (!n.parent.type.spec.isolating)
    for (let e = n.depth - 1; e >= 0; e--) {
      let t = n.node(e);
      if (n.index(e) + 1 < t.childCount)
        return n.doc.resolve(n.after(e + 1));
      if (t.type.spec.isolating)
        break;
    }
  return null;
}
const FL = (n, e) => {
  let t = n.selection, r = t instanceof te, i;
  if (r) {
    if (t.node.isTextblock || !pr(n.doc, t.from))
      return !1;
    i = t.from;
  } else if (i = zl(n.doc, t.from, -1), i == null)
    return !1;
  if (e) {
    let s = n.tr.join(i);
    r && s.setSelection(te.create(s.doc, i - n.doc.resolve(i).nodeBefore.nodeSize)), e(s.scrollIntoView());
  }
  return !0;
}, zL = (n, e) => {
  let t = n.selection, r;
  if (t instanceof te) {
    if (t.node.isTextblock || !pr(n.doc, t.to))
      return !1;
    r = t.to;
  } else if (r = zl(n.doc, t.to, 1), r == null)
    return !1;
  return e && e(n.tr.join(r).scrollIntoView()), !0;
}, BL = (n, e) => {
  let { $from: t, $to: r } = n.selection, i = t.blockRange(r), s = i && qi(i);
  return s == null ? !1 : (e && e(n.tr.lift(i, s).scrollIntoView()), !0);
}, jL = (n, e) => {
  let { $head: t, $anchor: r } = n.selection;
  return !t.parent.type.spec.code || !t.sameParent(r) ? !1 : (e && e(n.tr.insertText(`
`).scrollIntoView()), !0);
};
function ow(n) {
  for (let e = 0; e < n.edgeCount; e++) {
    let { type: t } = n.edge(e);
    if (t.isTextblock && !t.hasRequiredAttrs())
      return t;
  }
  return null;
}
const VL = (n, e) => {
  let { $head: t, $anchor: r } = n.selection;
  if (!t.parent.type.spec.code || !t.sameParent(r))
    return !1;
  let i = t.node(-1), s = t.indexAfter(-1), o = ow(i.contentMatchAt(s));
  if (!o || !i.canReplaceWith(s, s, o))
    return !1;
  if (e) {
    let a = t.after(), l = n.tr.replaceWith(a, a, o.createAndFill());
    l.setSelection(me.near(l.doc.resolve(a), 1)), e(l.scrollIntoView());
  }
  return !0;
}, HL = (n, e) => {
  let t = n.selection, { $from: r, $to: i } = t;
  if (t instanceof rn || r.parent.inlineContent || i.parent.inlineContent)
    return !1;
  let s = ow(i.parent.contentMatchAt(i.indexAfter()));
  if (!s || !s.isTextblock)
    return !1;
  if (e) {
    let o = (!r.parentOffset && i.index() < i.parent.childCount ? r : i).pos, a = n.tr.insert(o, s.createAndFill());
    a.setSelection(de.create(a.doc, o + 1)), e(a.scrollIntoView());
  }
  return !0;
}, WL = (n, e) => {
  let { $cursor: t } = n.selection;
  if (!t || t.parent.content.size)
    return !1;
  if (t.depth > 1 && t.after() != t.end(-1)) {
    let s = t.before();
    if (_i(n.doc, s))
      return e && e(n.tr.split(s).scrollIntoView()), !0;
  }
  let r = t.blockRange(), i = r && qi(r);
  return i == null ? !1 : (e && e(n.tr.lift(r, i).scrollIntoView()), !0);
}, qL = (n, e) => {
  let { $from: t, to: r } = n.selection, i, s = t.sharedDepth(r);
  return s == 0 ? !1 : (i = t.before(s), e && e(n.tr.setSelection(te.create(n.doc, i))), !0);
};
function UL(n, e, t) {
  let r = e.nodeBefore, i = e.nodeAfter, s = e.index();
  return !r || !i || !r.type.compatibleContent(i.type) ? !1 : !r.content.size && e.parent.canReplace(s - 1, s) ? (t && t(n.tr.delete(e.pos - r.nodeSize, e.pos).scrollIntoView()), !0) : !e.parent.canReplace(s, s + 1) || !(i.isTextblock || pr(n.doc, e.pos)) ? !1 : (t && t(n.tr.clearIncompatible(e.pos, r.type, r.contentMatchAt(r.childCount)).join(e.pos).scrollIntoView()), !0);
}
function aw(n, e, t) {
  let r = e.nodeBefore, i = e.nodeAfter, s, o;
  if (r.type.spec.isolating || i.type.spec.isolating)
    return !1;
  if (UL(n, e, t))
    return !0;
  let a = e.parent.canReplace(e.index(), e.index() + 1);
  if (a && (s = (o = r.contentMatchAt(r.childCount)).findWrapping(i.type)) && o.matchType(s[0] || i.type).validEnd) {
    if (t) {
      let f = e.pos + i.nodeSize, p = V.empty;
      for (let v = s.length - 1; v >= 0; v--)
        p = V.from(s[v].create(null, p));
      p = V.from(r.copy(p));
      let d = n.tr.step(new qe(e.pos - 1, f, e.pos, f, new X(p, 1, 0), s.length, !0)), h = f + 2 * s.length;
      pr(d.doc, h) && d.join(h), t(d.scrollIntoView());
    }
    return !0;
  }
  let l = me.findFrom(e, 1), u = l && l.$from.blockRange(l.$to), c = u && qi(u);
  if (c != null && c >= e.depth)
    return t && t(n.tr.lift(u, c).scrollIntoView()), !0;
  if (a && Di(i, "start", !0) && Di(r, "end")) {
    let f = r, p = [];
    for (; p.push(f), !f.isTextblock; )
      f = f.lastChild;
    let d = i, h = 1;
    for (; !d.isTextblock; d = d.firstChild)
      h++;
    if (f.canReplace(f.childCount, f.childCount, d.content)) {
      if (t) {
        let v = V.empty;
        for (let m = p.length - 1; m >= 0; m--)
          v = V.from(p[m].copy(v));
        let g = n.tr.step(new qe(e.pos - p.length, e.pos + i.nodeSize, e.pos + h, e.pos + i.nodeSize - h, new X(v, p.length, 0), 0, !0));
        t(g.scrollIntoView());
      }
      return !0;
    }
  }
  return !1;
}
function lw(n) {
  return function(e, t) {
    let r = e.selection, i = n < 0 ? r.$from : r.$to, s = i.depth;
    for (; i.node(s).isInline; ) {
      if (!s)
        return !1;
      s--;
    }
    return i.node(s).isTextblock ? (t && t(e.tr.setSelection(de.create(e.doc, n < 0 ? i.start(s) : i.end(s)))), !0) : !1;
  };
}
const GL = lw(-1), KL = lw(1);
function JL(n, e = null) {
  return function(t, r) {
    let { $from: i, $to: s } = t.selection, o = i.blockRange(s), a = o && ap(o, n, e);
    return a ? (r && r(t.tr.wrap(o, a).scrollIntoView()), !0) : !1;
  };
}
function Ng(n, e = null) {
  return function(t, r) {
    let i = !1;
    for (let s = 0; s < t.selection.ranges.length && !i; s++) {
      let { $from: { pos: o }, $to: { pos: a } } = t.selection.ranges[s];
      t.doc.nodesBetween(o, a, (l, u) => {
        if (i)
          return !1;
        if (!(!l.isTextblock || l.hasMarkup(n, e)))
          if (l.type == n)
            i = !0;
          else {
            let c = t.doc.resolve(u), f = c.index();
            i = c.parent.canReplaceWith(f, f + 1, n);
          }
      });
    }
    if (!i)
      return !1;
    if (r) {
      let s = t.tr;
      for (let o = 0; o < t.selection.ranges.length; o++) {
        let { $from: { pos: a }, $to: { pos: l } } = t.selection.ranges[o];
        s.setBlockType(a, l, n, e);
      }
      r(s.scrollIntoView());
    }
    return !0;
  };
}
typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os < "u" && os.platform && os.platform() == "darwin";
function XL(n, e = null) {
  return function(t, r) {
    let { $from: i, $to: s } = t.selection, o = i.blockRange(s), a = !1, l = o;
    if (!o)
      return !1;
    if (o.depth >= 2 && i.node(o.depth - 1).type.compatibleContent(n) && o.startIndex == 0) {
      if (i.index(o.depth - 1) == 0)
        return !1;
      let c = t.doc.resolve(o.start - 2);
      l = new Ta(c, c, o.depth), o.endIndex < o.parent.childCount && (o = new Ta(i, t.doc.resolve(s.end(o.depth)), o.depth)), a = !0;
    }
    let u = ap(l, n, e, o);
    return u ? (r && r(YL(t.tr, o, u, a, n).scrollIntoView()), !0) : !1;
  };
}
function YL(n, e, t, r, i) {
  let s = V.empty;
  for (let c = t.length - 1; c >= 0; c--)
    s = V.from(t[c].type.create(t[c].attrs, s));
  n.step(new qe(e.start - (r ? 2 : 0), e.end, e.start, e.end, new X(s, 0, 0), t.length, !0));
  let o = 0;
  for (let c = 0; c < t.length; c++)
    t[c].type == i && (o = c + 1);
  let a = t.length - o, l = e.start + t.length - (r ? 2 : 0), u = e.parent;
  for (let c = e.startIndex, f = e.endIndex, p = !0; c < f; c++, p = !1)
    !p && _i(n.doc, l, a) && (n.split(l, a), l += 2 * a), l += u.child(c).nodeSize;
  return n;
}
function QL(n) {
  return function(e, t) {
    let { $from: r, $to: i } = e.selection, s = r.blockRange(i, (o) => o.childCount > 0 && o.firstChild.type == n);
    return s ? t ? r.node(s.depth - 1).type == n ? ZL(e, t, n, s) : eN(e, t, s) : !0 : !1;
  };
}
function ZL(n, e, t, r) {
  let i = n.tr, s = r.end, o = r.$to.end(r.depth);
  s < o && (i.step(new qe(s - 1, o, s, o, new X(V.from(t.create(null, r.parent.copy())), 1, 0), 1, !0)), r = new Ta(i.doc.resolve(r.$from.pos), i.doc.resolve(o), r.depth));
  const a = qi(r);
  if (a == null)
    return !1;
  i.lift(r, a);
  let l = i.mapping.map(s, -1) - 1;
  return pr(i.doc, l) && i.join(l), e(i.scrollIntoView()), !0;
}
function eN(n, e, t) {
  let r = n.tr, i = t.parent;
  for (let d = t.end, h = t.endIndex - 1, v = t.startIndex; h > v; h--)
    d -= i.child(h).nodeSize, r.delete(d - 1, d + 1);
  let s = r.doc.resolve(t.start), o = s.nodeAfter;
  if (r.mapping.map(t.end) != t.start + s.nodeAfter.nodeSize)
    return !1;
  let a = t.startIndex == 0, l = t.endIndex == i.childCount, u = s.node(-1), c = s.index(-1);
  if (!u.canReplace(c + (a ? 0 : 1), c + 1, o.content.append(l ? V.empty : V.from(i))))
    return !1;
  let f = s.pos, p = f + o.nodeSize;
  return r.step(new qe(f - (a ? 1 : 0), p + (l ? 1 : 0), f + 1, p - 1, new X((a ? V.empty : V.from(i.copy(V.empty))).append(l ? V.empty : V.from(i.copy(V.empty))), a ? 0 : 1, l ? 0 : 1), a ? 0 : 1)), e(r.scrollIntoView()), !0;
}
function tN(n) {
  return function(e, t) {
    let { $from: r, $to: i } = e.selection, s = r.blockRange(i, (u) => u.childCount > 0 && u.firstChild.type == n);
    if (!s)
      return !1;
    let o = s.startIndex;
    if (o == 0)
      return !1;
    let a = s.parent, l = a.child(o - 1);
    if (l.type != n)
      return !1;
    if (t) {
      let u = l.lastChild && l.lastChild.type == a.type, c = V.from(u ? n.create() : null), f = new X(V.from(n.create(null, V.from(a.type.create(null, c)))), u ? 3 : 1, 0), p = s.start, d = s.end;
      t(e.tr.step(new qe(p - (u ? 3 : 1), d, p, d, f, 1, !0)).scrollIntoView());
    }
    return !0;
  };
}
function Wl(n) {
  const { state: e, transaction: t } = n;
  let { selection: r } = t, { doc: i } = t, { storedMarks: s } = t;
  return {
    ...e,
    apply: e.apply.bind(e),
    applyTransaction: e.applyTransaction.bind(e),
    filterTransaction: e.filterTransaction,
    plugins: e.plugins,
    schema: e.schema,
    reconfigure: e.reconfigure.bind(e),
    toJSON: e.toJSON.bind(e),
    get storedMarks() {
      return s;
    },
    get selection() {
      return r;
    },
    get doc() {
      return i;
    },
    get tr() {
      return r = t.selection, i = t.doc, s = t.storedMarks, t;
    }
  };
}
class ql {
  constructor(e) {
    this.editor = e.editor, this.rawCommands = this.editor.extensionManager.commands, this.customState = e.state;
  }
  get hasCustomState() {
    return !!this.customState;
  }
  get state() {
    return this.customState || this.editor.state;
  }
  get commands() {
    const { rawCommands: e, editor: t, state: r } = this, { view: i } = t, { tr: s } = r, o = this.buildProps(s);
    return Object.fromEntries(Object.entries(e).map(([a, l]) => [a, (...c) => {
      const f = l(...c)(o);
      return !s.getMeta("preventDispatch") && !this.hasCustomState && i.dispatch(s), f;
    }]));
  }
  get chain() {
    return () => this.createChain();
  }
  get can() {
    return () => this.createCan();
  }
  createChain(e, t = !0) {
    const { rawCommands: r, editor: i, state: s } = this, { view: o } = i, a = [], l = !!e, u = e || s.tr, c = () => (!l && t && !u.getMeta("preventDispatch") && !this.hasCustomState && o.dispatch(u), a.every((p) => p === !0)), f = {
      ...Object.fromEntries(Object.entries(r).map(([p, d]) => [p, (...v) => {
        const g = this.buildProps(u, t), m = d(...v)(g);
        return a.push(m), f;
      }])),
      run: c
    };
    return f;
  }
  createCan(e) {
    const { rawCommands: t, state: r } = this, i = !1, s = e || r.tr, o = this.buildProps(s, i);
    return {
      ...Object.fromEntries(Object.entries(t).map(([l, u]) => [l, (...c) => u(...c)({ ...o, dispatch: void 0 })])),
      chain: () => this.createChain(s, i)
    };
  }
  buildProps(e, t = !0) {
    const { rawCommands: r, editor: i, state: s } = this, { view: o } = i, a = {
      tr: e,
      editor: i,
      view: o,
      state: Wl({
        state: s,
        transaction: e
      }),
      dispatch: t ? () => {
      } : void 0,
      chain: () => this.createChain(e, t),
      can: () => this.createCan(e),
      get commands() {
        return Object.fromEntries(Object.entries(r).map(([l, u]) => [l, (...c) => u(...c)(a)]));
      }
    };
    return a;
  }
}
class nN {
  constructor() {
    this.callbacks = {};
  }
  on(e, t) {
    return this.callbacks[e] || (this.callbacks[e] = []), this.callbacks[e].push(t), this;
  }
  emit(e, ...t) {
    const r = this.callbacks[e];
    return r && r.forEach((i) => i.apply(this, t)), this;
  }
  off(e, t) {
    const r = this.callbacks[e];
    return r && (t ? this.callbacks[e] = r.filter((i) => i !== t) : delete this.callbacks[e]), this;
  }
  removeAllListeners() {
    this.callbacks = {};
  }
}
function Z(n, e, t) {
  return n.config[e] === void 0 && n.parent ? Z(n.parent, e, t) : typeof n.config[e] == "function" ? n.config[e].bind({
    ...t,
    parent: n.parent ? Z(n.parent, e, t) : null
  }) : n.config[e];
}
function Ul(n) {
  const e = n.filter((i) => i.type === "extension"), t = n.filter((i) => i.type === "node"), r = n.filter((i) => i.type === "mark");
  return {
    baseExtensions: e,
    nodeExtensions: t,
    markExtensions: r
  };
}
function uw(n) {
  const e = [], { nodeExtensions: t, markExtensions: r } = Ul(n), i = [...t, ...r], s = {
    default: null,
    rendered: !0,
    renderHTML: null,
    parseHTML: null,
    keepOnSplit: !0,
    isRequired: !1
  };
  return n.forEach((o) => {
    const a = {
      name: o.name,
      options: o.options,
      storage: o.storage
    }, l = Z(o, "addGlobalAttributes", a);
    if (!l)
      return;
    l().forEach((c) => {
      c.types.forEach((f) => {
        Object.entries(c.attributes).forEach(([p, d]) => {
          e.push({
            type: f,
            name: p,
            attribute: {
              ...s,
              ...d
            }
          });
        });
      });
    });
  }), i.forEach((o) => {
    const a = {
      name: o.name,
      options: o.options,
      storage: o.storage
    }, l = Z(o, "addAttributes", a);
    if (!l)
      return;
    const u = l();
    Object.entries(u).forEach(([c, f]) => {
      const p = {
        ...s,
        ...f
      };
      typeof (p == null ? void 0 : p.default) == "function" && (p.default = p.default()), (p == null ? void 0 : p.isRequired) && (p == null ? void 0 : p.default) === void 0 && delete p.default, e.push({
        type: o.name,
        name: c,
        attribute: p
      });
    });
  }), e;
}
function Ge(n, e) {
  if (typeof n == "string") {
    if (!e.nodes[n])
      throw Error(`There is no node type named '${n}'. Maybe you forgot to add the extension?`);
    return e.nodes[n];
  }
  return n;
}
function we(...n) {
  return n.filter((e) => !!e).reduce((e, t) => {
    const r = { ...e };
    return Object.entries(t).forEach(([i, s]) => {
      if (!r[i]) {
        r[i] = s;
        return;
      }
      if (i === "class") {
        const a = s ? s.split(" ") : [], l = r[i] ? r[i].split(" ") : [], u = a.filter((c) => !l.includes(c));
        r[i] = [...l, ...u].join(" ");
      } else
        i === "style" ? r[i] = [r[i], s].join("; ") : r[i] = s;
    }), r;
  }, {});
}
function Qd(n, e) {
  return e.filter((t) => t.attribute.rendered).map((t) => t.attribute.renderHTML ? t.attribute.renderHTML(n.attrs) || {} : {
    [t.name]: n.attrs[t.name]
  }).reduce((t, r) => we(t, r), {});
}
function cw(n) {
  return typeof n == "function";
}
function he(n, e = void 0, ...t) {
  return cw(n) ? e ? n.bind(e)(...t) : n(...t) : n;
}
function rN(n = {}) {
  return Object.keys(n).length === 0 && n.constructor === Object;
}
function iN(n) {
  return typeof n != "string" ? n : n.match(/^[+-]?(?:\d*\.)?\d+$/) ? Number(n) : n === "true" ? !0 : n === "false" ? !1 : n;
}
function Ig(n, e) {
  return n.style ? n : {
    ...n,
    getAttrs: (t) => {
      const r = n.getAttrs ? n.getAttrs(t) : n.attrs;
      if (r === !1)
        return !1;
      const i = e.reduce((s, o) => {
        const a = o.attribute.parseHTML ? o.attribute.parseHTML(t) : iN(t.getAttribute(o.name));
        return a == null ? s : {
          ...s,
          [o.name]: a
        };
      }, {});
      return { ...r, ...i };
    }
  };
}
function Rg(n) {
  return Object.fromEntries(
    Object.entries(n).filter(([e, t]) => e === "attrs" && rN(t) ? !1 : t != null)
  );
}
function sN(n, e) {
  var t;
  const r = uw(n), { nodeExtensions: i, markExtensions: s } = Ul(n), o = (t = i.find((u) => Z(u, "topNode"))) === null || t === void 0 ? void 0 : t.name, a = Object.fromEntries(i.map((u) => {
    const c = r.filter((m) => m.type === u.name), f = {
      name: u.name,
      options: u.options,
      storage: u.storage,
      editor: e
    }, p = n.reduce((m, _) => {
      const y = Z(_, "extendNodeSchema", f);
      return {
        ...m,
        ...y ? y(u) : {}
      };
    }, {}), d = Rg({
      ...p,
      content: he(Z(u, "content", f)),
      marks: he(Z(u, "marks", f)),
      group: he(Z(u, "group", f)),
      inline: he(Z(u, "inline", f)),
      atom: he(Z(u, "atom", f)),
      selectable: he(Z(u, "selectable", f)),
      draggable: he(Z(u, "draggable", f)),
      code: he(Z(u, "code", f)),
      defining: he(Z(u, "defining", f)),
      isolating: he(Z(u, "isolating", f)),
      attrs: Object.fromEntries(c.map((m) => {
        var _;
        return [m.name, { default: (_ = m == null ? void 0 : m.attribute) === null || _ === void 0 ? void 0 : _.default }];
      }))
    }), h = he(Z(u, "parseHTML", f));
    h && (d.parseDOM = h.map((m) => Ig(m, c)));
    const v = Z(u, "renderHTML", f);
    v && (d.toDOM = (m) => v({
      node: m,
      HTMLAttributes: Qd(m, c)
    }));
    const g = Z(u, "renderText", f);
    return g && (d.toText = g), [u.name, d];
  })), l = Object.fromEntries(s.map((u) => {
    const c = r.filter((g) => g.type === u.name), f = {
      name: u.name,
      options: u.options,
      storage: u.storage,
      editor: e
    }, p = n.reduce((g, m) => {
      const _ = Z(m, "extendMarkSchema", f);
      return {
        ...g,
        ..._ ? _(u) : {}
      };
    }, {}), d = Rg({
      ...p,
      inclusive: he(Z(u, "inclusive", f)),
      excludes: he(Z(u, "excludes", f)),
      group: he(Z(u, "group", f)),
      spanning: he(Z(u, "spanning", f)),
      code: he(Z(u, "code", f)),
      attrs: Object.fromEntries(c.map((g) => {
        var m;
        return [g.name, { default: (m = g == null ? void 0 : g.attribute) === null || m === void 0 ? void 0 : m.default }];
      }))
    }), h = he(Z(u, "parseHTML", f));
    h && (d.parseDOM = h.map((g) => Ig(g, c)));
    const v = Z(u, "renderHTML", f);
    return v && (d.toDOM = (g) => v({
      mark: g,
      HTMLAttributes: Qd(g, c)
    })), [u.name, d];
  }));
  return new m$({
    topNode: o,
    nodes: a,
    marks: l
  });
}
function jc(n, e) {
  return e.nodes[n] || e.marks[n] || null;
}
function Fg(n, e) {
  return Array.isArray(e) ? e.some((t) => (typeof t == "string" ? t : t.name) === n.name) : e;
}
const oN = (n, e = 500) => {
  let t = "";
  const r = n.parentOffset;
  return n.parent.nodesBetween(Math.max(0, r - e), r, (i, s, o, a) => {
    var l, u;
    const c = ((u = (l = i.type.spec).toText) === null || u === void 0 ? void 0 : u.call(l, {
      node: i,
      pos: s,
      parent: o,
      index: a
    })) || i.textContent || "%leaf%";
    t += c.slice(0, Math.max(0, r - s));
  }), t;
};
function bp(n) {
  return Object.prototype.toString.call(n) === "[object RegExp]";
}
class Gl {
  constructor(e) {
    this.find = e.find, this.handler = e.handler;
  }
}
const aN = (n, e) => {
  if (bp(e))
    return e.exec(n);
  const t = e(n);
  if (!t)
    return null;
  const r = [t.text];
  return r.index = t.index, r.input = n, r.data = t.data, t.replaceWith && (t.text.includes(t.replaceWith) || console.warn('[tiptap warn]: "inputRuleMatch.replaceWith" must be part of "inputRuleMatch.text".'), r.push(t.replaceWith)), r;
};
function Vc(n) {
  var e;
  const { editor: t, from: r, to: i, text: s, rules: o, plugin: a } = n, { view: l } = t;
  if (l.composing)
    return !1;
  const u = l.state.doc.resolve(r);
  if (u.parent.type.spec.code || !!(!((e = u.nodeBefore || u.nodeAfter) === null || e === void 0) && e.marks.find((p) => p.type.spec.code)))
    return !1;
  let c = !1;
  const f = oN(u) + s;
  return o.forEach((p) => {
    if (c)
      return;
    const d = aN(f, p.find);
    if (!d)
      return;
    const h = l.state.tr, v = Wl({
      state: l.state,
      transaction: h
    }), g = {
      from: r - (d[0].length - s.length),
      to: i
    }, { commands: m, chain: _, can: y } = new ql({
      editor: t,
      state: v
    });
    p.handler({
      state: v,
      range: g,
      match: d,
      commands: m,
      chain: _,
      can: y
    }) === null || !h.steps.length || (h.setMeta(a, {
      transform: h,
      from: r,
      to: i,
      text: s
    }), l.dispatch(h), c = !0);
  }), c;
}
function lN(n) {
  const { editor: e, rules: t } = n, r = new lt({
    state: {
      init() {
        return null;
      },
      apply(i, s) {
        const o = i.getMeta(r);
        return o || (i.selectionSet || i.docChanged ? null : s);
      }
    },
    props: {
      handleTextInput(i, s, o, a) {
        return Vc({
          editor: e,
          from: s,
          to: o,
          text: a,
          rules: t,
          plugin: r
        });
      },
      handleDOMEvents: {
        compositionend: (i) => (setTimeout(() => {
          const { $cursor: s } = i.state.selection;
          s && Vc({
            editor: e,
            from: s.pos,
            to: s.pos,
            text: "",
            rules: t,
            plugin: r
          });
        }), !1)
      },
      handleKeyDown(i, s) {
        if (s.key !== "Enter")
          return !1;
        const { $cursor: o } = i.state.selection;
        return o ? Vc({
          editor: e,
          from: o.pos,
          to: o.pos,
          text: `
`,
          rules: t,
          plugin: r
        }) : !1;
      }
    },
    isInputRules: !0
  });
  return r;
}
function uN(n) {
  return typeof n == "number";
}
class cN {
  constructor(e) {
    this.find = e.find, this.handler = e.handler;
  }
}
const dN = (n, e) => {
  if (bp(e))
    return [...n.matchAll(e)];
  const t = e(n);
  return t ? t.map((r) => {
    const i = [r.text];
    return i.index = r.index, i.input = n, i.data = r.data, r.replaceWith && (r.text.includes(r.replaceWith) || console.warn('[tiptap warn]: "pasteRuleMatch.replaceWith" must be part of "pasteRuleMatch.text".'), i.push(r.replaceWith)), i;
  }) : [];
};
function fN(n) {
  const { editor: e, state: t, from: r, to: i, rule: s, pasteEvent: o, dropEvent: a } = n, { commands: l, chain: u, can: c } = new ql({
    editor: e,
    state: t
  }), f = [];
  return t.doc.nodesBetween(r, i, (d, h) => {
    if (!d.isTextblock || d.type.spec.code)
      return;
    const v = Math.max(r, h), g = Math.min(i, h + d.content.size), m = d.textBetween(v - h, g - h, void 0, "\uFFFC");
    dN(m, s.find).forEach((y) => {
      if (y.index === void 0)
        return;
      const w = v + y.index + 1, O = w + y[0].length, C = {
        from: t.tr.mapping.map(w),
        to: t.tr.mapping.map(O)
      }, S = s.handler({
        state: t,
        range: C,
        match: y,
        commands: l,
        chain: u,
        can: c,
        pasteEvent: o,
        dropEvent: a
      });
      f.push(S);
    });
  }), f.every((d) => d !== null);
}
function pN(n) {
  const { editor: e, rules: t } = n;
  let r = null, i = !1, s = !1, o = new ClipboardEvent("paste"), a = new DragEvent("drop");
  return t.map((u) => new lt({
    view(c) {
      const f = (p) => {
        var d;
        r = !((d = c.dom.parentElement) === null || d === void 0) && d.contains(p.target) ? c.dom.parentElement : null;
      };
      return window.addEventListener("dragstart", f), {
        destroy() {
          window.removeEventListener("dragstart", f);
        }
      };
    },
    props: {
      handleDOMEvents: {
        drop: (c, f) => (s = r === c.dom.parentElement, a = f, !1),
        paste: (c, f) => {
          var p;
          const d = (p = f.clipboardData) === null || p === void 0 ? void 0 : p.getData("text/html");
          return o = f, i = !!(d != null && d.includes("data-pm-slice")), !1;
        }
      }
    },
    appendTransaction: (c, f, p) => {
      const d = c[0], h = d.getMeta("uiEvent") === "paste" && !i, v = d.getMeta("uiEvent") === "drop" && !s;
      if (!h && !v)
        return;
      const g = f.doc.content.findDiffStart(p.doc.content), m = f.doc.content.findDiffEnd(p.doc.content);
      if (!uN(g) || !m || g === m.b)
        return;
      const _ = p.tr, y = Wl({
        state: p,
        transaction: _
      });
      if (!(!fN({
        editor: e,
        state: y,
        from: Math.max(g - 1, 0),
        to: m.b - 1,
        rule: u,
        pasteEvent: o,
        dropEvent: a
      }) || !_.steps.length))
        return a = new DragEvent("drop"), o = new ClipboardEvent("paste"), _;
    }
  }));
}
function hN(n) {
  const e = n.filter((t, r) => n.indexOf(t) !== r);
  return [...new Set(e)];
}
class bi {
  constructor(e, t) {
    this.splittableMarks = [], this.editor = t, this.extensions = bi.resolve(e), this.schema = sN(this.extensions, t), this.extensions.forEach((r) => {
      var i;
      this.editor.extensionStorage[r.name] = r.storage;
      const s = {
        name: r.name,
        options: r.options,
        storage: r.storage,
        editor: this.editor,
        type: jc(r.name, this.schema)
      };
      r.type === "mark" && ((i = he(Z(r, "keepOnSplit", s))) !== null && i !== void 0 ? i : !0) && this.splittableMarks.push(r.name);
      const o = Z(r, "onBeforeCreate", s);
      o && this.editor.on("beforeCreate", o);
      const a = Z(r, "onCreate", s);
      a && this.editor.on("create", a);
      const l = Z(r, "onUpdate", s);
      l && this.editor.on("update", l);
      const u = Z(r, "onSelectionUpdate", s);
      u && this.editor.on("selectionUpdate", u);
      const c = Z(r, "onTransaction", s);
      c && this.editor.on("transaction", c);
      const f = Z(r, "onFocus", s);
      f && this.editor.on("focus", f);
      const p = Z(r, "onBlur", s);
      p && this.editor.on("blur", p);
      const d = Z(r, "onDestroy", s);
      d && this.editor.on("destroy", d);
    });
  }
  static resolve(e) {
    const t = bi.sort(bi.flatten(e)), r = hN(t.map((i) => i.name));
    return r.length && console.warn(`[tiptap warn]: Duplicate extension names found: [${r.map((i) => `'${i}'`).join(", ")}]. This can lead to issues.`), t;
  }
  static flatten(e) {
    return e.map((t) => {
      const r = {
        name: t.name,
        options: t.options,
        storage: t.storage
      }, i = Z(t, "addExtensions", r);
      return i ? [t, ...this.flatten(i())] : t;
    }).flat(10);
  }
  static sort(e) {
    return e.sort((r, i) => {
      const s = Z(r, "priority") || 100, o = Z(i, "priority") || 100;
      return s > o ? -1 : s < o ? 1 : 0;
    });
  }
  get commands() {
    return this.extensions.reduce((e, t) => {
      const r = {
        name: t.name,
        options: t.options,
        storage: t.storage,
        editor: this.editor,
        type: jc(t.name, this.schema)
      }, i = Z(t, "addCommands", r);
      return i ? {
        ...e,
        ...i()
      } : e;
    }, {});
  }
  get plugins() {
    const { editor: e } = this, t = bi.sort([...this.extensions].reverse()), r = [], i = [], s = t.map((o) => {
      const a = {
        name: o.name,
        options: o.options,
        storage: o.storage,
        editor: e,
        type: jc(o.name, this.schema)
      }, l = [], u = Z(o, "addKeyboardShortcuts", a);
      let c = {};
      if (o.type === "mark" && o.config.exitable && (c.ArrowRight = () => Dt.handleExit({ editor: e, mark: o })), u) {
        const v = Object.fromEntries(Object.entries(u()).map(([g, m]) => [g, () => m({ editor: e })]));
        c = { ...c, ...v };
      }
      const f = AL(c);
      l.push(f);
      const p = Z(o, "addInputRules", a);
      Fg(o, e.options.enableInputRules) && p && r.push(...p());
      const d = Z(o, "addPasteRules", a);
      Fg(o, e.options.enablePasteRules) && d && i.push(...d());
      const h = Z(o, "addProseMirrorPlugins", a);
      if (h) {
        const v = h();
        l.push(...v);
      }
      return l;
    }).flat();
    return [
      lN({
        editor: e,
        rules: r
      }),
      ...pN({
        editor: e,
        rules: i
      }),
      ...s
    ];
  }
  get attributes() {
    return uw(this.extensions);
  }
  get nodeViews() {
    const { editor: e } = this, { nodeExtensions: t } = Ul(this.extensions);
    return Object.fromEntries(t.filter((r) => !!Z(r, "addNodeView")).map((r) => {
      const i = this.attributes.filter((l) => l.type === r.name), s = {
        name: r.name,
        options: r.options,
        storage: r.storage,
        editor: e,
        type: Ge(r.name, this.schema)
      }, o = Z(r, "addNodeView", s);
      if (!o)
        return [];
      const a = (l, u, c, f) => {
        const p = Qd(l, i);
        return o()({
          editor: e,
          node: l,
          getPos: c,
          decorations: f,
          HTMLAttributes: p,
          extension: r
        });
      };
      return [r.name, a];
    }));
  }
}
function mN(n) {
  return Object.prototype.toString.call(n).slice(8, -1);
}
function Hc(n) {
  return mN(n) !== "Object" ? !1 : n.constructor === Object && Object.getPrototypeOf(n) === Object.prototype;
}
function Kl(n, e) {
  const t = { ...n };
  return Hc(n) && Hc(e) && Object.keys(e).forEach((r) => {
    Hc(e[r]) ? r in n ? t[r] = Kl(n[r], e[r]) : Object.assign(t, { [r]: e[r] }) : Object.assign(t, { [r]: e[r] });
  }), t;
}
class Ve {
  constructor(e = {}) {
    this.type = "extension", this.name = "extension", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = he(Z(this, "addOptions", {
      name: this.name
    }))), this.storage = he(Z(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new Ve(e);
  }
  configure(e = {}) {
    const t = this.extend();
    return t.options = Kl(this.options, e), t.storage = he(Z(t, "addStorage", {
      name: t.name,
      options: t.options
    })), t;
  }
  extend(e = {}) {
    const t = new Ve(e);
    return t.parent = this, this.child = t, t.name = e.name ? e.name : t.parent.name, e.defaultOptions && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${t.name}".`), t.options = he(Z(t, "addOptions", {
      name: t.name
    })), t.storage = he(Z(t, "addStorage", {
      name: t.name,
      options: t.options
    })), t;
  }
}
function dw(n, e, t) {
  const { from: r, to: i } = e, { blockSeparator: s = `

`, textSerializers: o = {} } = t || {};
  let a = "", l = !0;
  return n.nodesBetween(r, i, (u, c, f, p) => {
    var d;
    const h = o == null ? void 0 : o[u.type.name];
    h ? (u.isBlock && !l && (a += s, l = !0), f && (a += h({
      node: u,
      pos: c,
      parent: f,
      index: p,
      range: e
    }))) : u.isText ? (a += (d = u == null ? void 0 : u.text) === null || d === void 0 ? void 0 : d.slice(Math.max(r, c) - c, i - c), l = !1) : u.isBlock && !l && (a += s, l = !0);
  }), a;
}
function fw(n) {
  return Object.fromEntries(Object.entries(n.nodes).filter(([, e]) => e.spec.toText).map(([e, t]) => [e, t.spec.toText]));
}
const gN = Ve.create({
  name: "clipboardTextSerializer",
  addProseMirrorPlugins() {
    return [
      new lt({
        key: new Zt("clipboardTextSerializer"),
        props: {
          clipboardTextSerializer: () => {
            const { editor: n } = this, { state: e, schema: t } = n, { doc: r, selection: i } = e, { ranges: s } = i, o = Math.min(...s.map((c) => c.$from.pos)), a = Math.max(...s.map((c) => c.$to.pos)), l = fw(t);
            return dw(r, { from: o, to: a }, {
              textSerializers: l
            });
          }
        }
      })
    ];
  }
}), vN = () => ({ editor: n, view: e }) => (requestAnimationFrame(() => {
  var t;
  n.isDestroyed || (e.dom.blur(), (t = window == null ? void 0 : window.getSelection()) === null || t === void 0 || t.removeAllRanges());
}), !0), yN = (n = !1) => ({ commands: e }) => e.setContent("", n), bN = () => ({ state: n, tr: e, dispatch: t }) => {
  const { selection: r } = e, { ranges: i } = r;
  return t && i.forEach(({ $from: s, $to: o }) => {
    n.doc.nodesBetween(s.pos, o.pos, (a, l) => {
      if (a.type.isText)
        return;
      const { doc: u, mapping: c } = e, f = u.resolve(c.map(l)), p = u.resolve(c.map(l + a.nodeSize)), d = f.blockRange(p);
      if (!d)
        return;
      const h = qi(d);
      if (a.type.isTextblock) {
        const { defaultType: v } = f.parent.contentMatchAt(f.index());
        e.setNodeMarkup(d.start, v);
      }
      (h || h === 0) && e.lift(d, h);
    });
  }), !0;
}, wN = (n) => (e) => n(e), _N = () => ({ state: n, dispatch: e }) => HL(n, e), SN = (n, e) => ({ editor: t, tr: r }) => {
  const { state: i } = t, s = i.doc.slice(n.from, n.to);
  r.deleteRange(n.from, n.to);
  const o = r.mapping.map(e);
  return r.insert(o, s.content), r.setSelection(new de(r.doc.resolve(o - 1))), !0;
}, xN = () => ({ tr: n, dispatch: e }) => {
  const { selection: t } = n, r = t.$anchor.node();
  if (r.content.size > 0)
    return !1;
  const i = n.selection.$anchor;
  for (let s = i.depth; s > 0; s -= 1)
    if (i.node(s).type === r.type) {
      if (e) {
        const a = i.before(s), l = i.after(s);
        n.delete(a, l).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, CN = (n) => ({ tr: e, state: t, dispatch: r }) => {
  const i = Ge(n, t.schema), s = e.selection.$anchor;
  for (let o = s.depth; o > 0; o -= 1)
    if (s.node(o).type === i) {
      if (r) {
        const l = s.before(o), u = s.after(o);
        e.delete(l, u).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, ON = (n) => ({ tr: e, dispatch: t }) => {
  const { from: r, to: i } = n;
  return t && e.delete(r, i), !0;
}, EN = () => ({ state: n, dispatch: e }) => PL(n, e), TN = () => ({ commands: n }) => n.keyboardShortcut("Enter"), kN = () => ({ state: n, dispatch: e }) => VL(n, e);
function Ra(n, e, t = { strict: !0 }) {
  const r = Object.keys(e);
  return r.length ? r.every((i) => t.strict ? e[i] === n[i] : bp(e[i]) ? e[i].test(n[i]) : e[i] === n[i]) : !0;
}
function Zd(n, e, t = {}) {
  return n.find((r) => r.type === e && Ra(r.attrs, t));
}
function MN(n, e, t = {}) {
  return !!Zd(n, e, t);
}
function wp(n, e, t = {}) {
  if (!n || !e)
    return;
  let r = n.parent.childAfter(n.parentOffset);
  if (n.parentOffset === r.offset && r.offset !== 0 && (r = n.parent.childBefore(n.parentOffset)), !r.node)
    return;
  const i = Zd([...r.node.marks], e, t);
  if (!i)
    return;
  let s = r.index, o = n.start() + r.offset, a = s + 1, l = o + r.node.nodeSize;
  for (Zd([...r.node.marks], e, t); s > 0 && i.isInSet(n.parent.child(s - 1).marks); )
    s -= 1, o -= n.parent.child(s).nodeSize;
  for (; a < n.parent.childCount && MN([...n.parent.child(a).marks], e, t); )
    l += n.parent.child(a).nodeSize, a += 1;
  return {
    from: o,
    to: l
  };
}
function mr(n, e) {
  if (typeof n == "string") {
    if (!e.marks[n])
      throw Error(`There is no mark type named '${n}'. Maybe you forgot to add the extension?`);
    return e.marks[n];
  }
  return n;
}
const AN = (n, e = {}) => ({ tr: t, state: r, dispatch: i }) => {
  const s = mr(n, r.schema), { doc: o, selection: a } = t, { $from: l, from: u, to: c } = a;
  if (i) {
    const f = wp(l, s, e);
    if (f && f.from <= u && f.to >= c) {
      const p = de.create(o, f.from, f.to);
      t.setSelection(p);
    }
  }
  return !0;
}, PN = (n) => (e) => {
  const t = typeof n == "function" ? n(e) : n;
  for (let r = 0; r < t.length; r += 1)
    if (t[r](e))
      return !0;
  return !1;
};
function _p(n) {
  return n instanceof de;
}
function Dn(n = 0, e = 0, t = 0) {
  return Math.min(Math.max(n, e), t);
}
function pw(n, e = null) {
  if (!e)
    return null;
  const t = me.atStart(n), r = me.atEnd(n);
  if (e === "start" || e === !0)
    return t;
  if (e === "end")
    return r;
  const i = t.from, s = r.to;
  return e === "all" ? de.create(n, Dn(0, i, s), Dn(n.content.size, i, s)) : de.create(n, Dn(e, i, s), Dn(e, i, s));
}
function Jl() {
  return [
    "iPad Simulator",
    "iPhone Simulator",
    "iPod Simulator",
    "iPad",
    "iPhone",
    "iPod"
  ].includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document;
}
const $N = (n = null, e = {}) => ({ editor: t, view: r, tr: i, dispatch: s }) => {
  e = {
    scrollIntoView: !0,
    ...e
  };
  const o = () => {
    Jl() && r.dom.focus(), requestAnimationFrame(() => {
      t.isDestroyed || (r.focus(), e != null && e.scrollIntoView && t.commands.scrollIntoView());
    });
  };
  if (r.hasFocus() && n === null || n === !1)
    return !0;
  if (s && n === null && !_p(t.state.selection))
    return o(), !0;
  const a = pw(i.doc, n) || t.state.selection, l = t.state.selection.eq(a);
  return s && (l || i.setSelection(a), l && i.storedMarks && i.setStoredMarks(i.storedMarks), o()), !0;
}, DN = (n, e) => (t) => n.every((r, i) => e(r, { ...t, index: i })), LN = (n, e) => ({ tr: t, commands: r }) => r.insertContentAt({ from: t.selection.from, to: t.selection.to }, n, e);
function zg(n) {
  const e = `<body>${n}</body>`;
  return new window.DOMParser().parseFromString(e, "text/html").body;
}
function Fa(n, e, t) {
  if (t = {
    slice: !0,
    parseOptions: {},
    ...t
  }, typeof n == "object" && n !== null)
    try {
      return Array.isArray(n) && n.length > 0 ? V.fromArray(n.map((r) => e.nodeFromJSON(r))) : e.nodeFromJSON(n);
    } catch (r) {
      return console.warn("[tiptap warn]: Invalid content.", "Passed value:", n, "Error:", r), Fa("", e, t);
    }
  if (typeof n == "string") {
    const r = Mi.fromSchema(e);
    return t.slice ? r.parseSlice(zg(n), t.parseOptions).content : r.parse(zg(n), t.parseOptions);
  }
  return Fa("", e, t);
}
function NN(n, e, t) {
  const r = n.steps.length - 1;
  if (r < e)
    return;
  const i = n.steps[r];
  if (!(i instanceof Qe || i instanceof qe))
    return;
  const s = n.mapping.maps[r];
  let o = 0;
  s.forEach((a, l, u, c) => {
    o === 0 && (o = c);
  }), n.setSelection(me.near(n.doc.resolve(o), t));
}
const IN = (n) => n.toString().startsWith("<"), RN = (n, e, t) => ({ tr: r, dispatch: i, editor: s }) => {
  if (i) {
    t = {
      parseOptions: {},
      updateSelection: !0,
      ...t
    };
    const o = Fa(e, s.schema, {
      parseOptions: {
        preserveWhitespace: "full",
        ...t.parseOptions
      }
    });
    if (o.toString() === "<>")
      return !0;
    let { from: a, to: l } = typeof n == "number" ? { from: n, to: n } : { from: n.from, to: n.to }, u = !0, c = !0;
    if ((IN(o) ? o : [o]).forEach((p) => {
      p.check(), u = u ? p.isText && p.marks.length === 0 : !1, c = c ? p.isBlock : !1;
    }), a === l && c) {
      const { parent: p } = r.doc.resolve(a);
      p.isTextblock && !p.type.spec.code && !p.childCount && (a -= 1, l += 1);
    }
    u ? Array.isArray(e) ? r.insertText(e.map((p) => p.text || "").join(""), a, l) : typeof e == "object" && !!e && !!e.text ? r.insertText(e.text, a, l) : r.insertText(e, a, l) : r.replaceWith(a, l, o), t.updateSelection && NN(r, r.steps.length - 1, -1);
  }
  return !0;
}, FN = () => ({ state: n, dispatch: e }) => FL(n, e), zN = () => ({ state: n, dispatch: e }) => zL(n, e), BN = () => ({ state: n, dispatch: e }) => DL(n, e), jN = () => ({ state: n, dispatch: e }) => IL(n, e), VN = () => ({ tr: n, state: e, dispatch: t }) => {
  try {
    const r = zl(e.doc, e.selection.$from.pos, -1);
    return r == null ? !1 : (n.join(r, 2), t && t(n), !0);
  } catch {
    return !1;
  }
}, HN = () => ({ state: n, dispatch: e, tr: t }) => {
  try {
    const r = zl(n.doc, n.selection.$from.pos, 1);
    return r == null ? !1 : (t.join(r, 2), e && e(t), !0);
  } catch {
    return !1;
  }
};
function Sp() {
  return typeof navigator < "u" ? /Mac/.test(navigator.platform) : !1;
}
function WN(n) {
  const e = n.split(/-(?!$)/);
  let t = e[e.length - 1];
  t === "Space" && (t = " ");
  let r, i, s, o;
  for (let a = 0; a < e.length - 1; a += 1) {
    const l = e[a];
    if (/^(cmd|meta|m)$/i.test(l))
      o = !0;
    else if (/^a(lt)?$/i.test(l))
      r = !0;
    else if (/^(c|ctrl|control)$/i.test(l))
      i = !0;
    else if (/^s(hift)?$/i.test(l))
      s = !0;
    else if (/^mod$/i.test(l))
      Jl() || Sp() ? o = !0 : i = !0;
    else
      throw new Error(`Unrecognized modifier name: ${l}`);
  }
  return r && (t = `Alt-${t}`), i && (t = `Ctrl-${t}`), o && (t = `Meta-${t}`), s && (t = `Shift-${t}`), t;
}
const qN = (n) => ({ editor: e, view: t, tr: r, dispatch: i }) => {
  const s = WN(n).split(/-(?!$)/), o = s.find((u) => !["Alt", "Ctrl", "Meta", "Shift"].includes(u)), a = new KeyboardEvent("keydown", {
    key: o === "Space" ? " " : o,
    altKey: s.includes("Alt"),
    ctrlKey: s.includes("Ctrl"),
    metaKey: s.includes("Meta"),
    shiftKey: s.includes("Shift"),
    bubbles: !0,
    cancelable: !0
  }), l = e.captureTransaction(() => {
    t.someProp("handleKeyDown", (u) => u(t, a));
  });
  return l == null || l.steps.forEach((u) => {
    const c = u.map(r.mapping);
    c && i && r.maybeStep(c);
  }), !0;
};
function Is(n, e, t = {}) {
  const { from: r, to: i, empty: s } = n.selection, o = e ? Ge(e, n.schema) : null, a = [];
  n.doc.nodesBetween(r, i, (f, p) => {
    if (f.isText)
      return;
    const d = Math.max(r, p), h = Math.min(i, p + f.nodeSize);
    a.push({
      node: f,
      from: d,
      to: h
    });
  });
  const l = i - r, u = a.filter((f) => o ? o.name === f.node.type.name : !0).filter((f) => Ra(f.node.attrs, t, { strict: !1 }));
  return s ? !!u.length : u.reduce((f, p) => f + p.to - p.from, 0) >= l;
}
const UN = (n, e = {}) => ({ state: t, dispatch: r }) => {
  const i = Ge(n, t.schema);
  return Is(t, i, e) ? BL(t, r) : !1;
}, GN = () => ({ state: n, dispatch: e }) => WL(n, e), KN = (n) => ({ state: e, dispatch: t }) => {
  const r = Ge(n, e.schema);
  return QL(r)(e, t);
}, JN = () => ({ state: n, dispatch: e }) => jL(n, e);
function Xl(n, e) {
  return e.nodes[n] ? "node" : e.marks[n] ? "mark" : null;
}
function Bg(n, e) {
  const t = typeof e == "string" ? [e] : e;
  return Object.keys(n).reduce((r, i) => (t.includes(i) || (r[i] = n[i]), r), {});
}
const XN = (n, e) => ({ tr: t, state: r, dispatch: i }) => {
  let s = null, o = null;
  const a = Xl(typeof n == "string" ? n : n.name, r.schema);
  return a ? (a === "node" && (s = Ge(n, r.schema)), a === "mark" && (o = mr(n, r.schema)), i && t.selection.ranges.forEach((l) => {
    r.doc.nodesBetween(l.$from.pos, l.$to.pos, (u, c) => {
      s && s === u.type && t.setNodeMarkup(c, void 0, Bg(u.attrs, e)), o && u.marks.length && u.marks.forEach((f) => {
        o === f.type && t.addMark(c, c + u.nodeSize, o.create(Bg(f.attrs, e)));
      });
    });
  }), !0) : !1;
}, YN = () => ({ tr: n, dispatch: e }) => (e && n.scrollIntoView(), !0), QN = () => ({ tr: n, commands: e }) => e.setTextSelection({
  from: 0,
  to: n.doc.content.size
}), ZN = () => ({ state: n, dispatch: e }) => LL(n, e), eI = () => ({ state: n, dispatch: e }) => RL(n, e), tI = () => ({ state: n, dispatch: e }) => qL(n, e), nI = () => ({ state: n, dispatch: e }) => KL(n, e), rI = () => ({ state: n, dispatch: e }) => GL(n, e);
function hw(n, e, t = {}) {
  return Fa(n, e, { slice: !1, parseOptions: t });
}
const iI = (n, e = !1, t = {}) => ({ tr: r, editor: i, dispatch: s }) => {
  const { doc: o } = r, a = hw(n, i.schema, t);
  return s && r.replaceWith(0, o.content.size, a).setMeta("preventUpdate", !e), !0;
};
function no(n, e) {
  const t = mr(e, n.schema), { from: r, to: i, empty: s } = n.selection, o = [];
  s ? (n.storedMarks && o.push(...n.storedMarks), o.push(...n.selection.$head.marks())) : n.doc.nodesBetween(r, i, (l) => {
    o.push(...l.marks);
  });
  const a = o.find((l) => l.type.name === t.name);
  return a ? { ...a.attrs } : {};
}
function sI(n, e) {
  const t = new _0(n);
  return e.forEach((r) => {
    r.steps.forEach((i) => {
      t.step(i);
    });
  }), t;
}
function oI(n) {
  for (let e = 0; e < n.edgeCount; e += 1) {
    const { type: t } = n.edge(e);
    if (t.isTextblock && !t.hasRequiredAttrs())
      return t;
  }
  return null;
}
function aI(n, e, t) {
  const r = [];
  return n.nodesBetween(e.from, e.to, (i, s) => {
    t(i) && r.push({
      node: i,
      pos: s
    });
  }), r;
}
function lI(n, e) {
  for (let t = n.depth; t > 0; t -= 1) {
    const r = n.node(t);
    if (e(r))
      return {
        pos: t > 0 ? n.before(t) : 0,
        start: n.start(t),
        depth: t,
        node: r
      };
  }
}
function xp(n) {
  return (e) => lI(e.$from, n);
}
function uI(n, e) {
  const t = yn.fromSchema(e).serializeFragment(n), i = document.implementation.createHTMLDocument().createElement("div");
  return i.appendChild(t), i.innerHTML;
}
function cI(n, e) {
  const t = {
    from: 0,
    to: n.content.size
  };
  return dw(n, t, e);
}
function dI(n, e) {
  const t = Ge(e, n.schema), { from: r, to: i } = n.selection, s = [];
  n.doc.nodesBetween(r, i, (a) => {
    s.push(a);
  });
  const o = s.reverse().find((a) => a.type.name === t.name);
  return o ? { ...o.attrs } : {};
}
function mw(n, e) {
  const t = Xl(typeof e == "string" ? e : e.name, n.schema);
  return t === "node" ? dI(n, e) : t === "mark" ? no(n, e) : {};
}
function fI(n, e = JSON.stringify) {
  const t = {};
  return n.filter((r) => {
    const i = e(r);
    return Object.prototype.hasOwnProperty.call(t, i) ? !1 : t[i] = !0;
  });
}
function pI(n) {
  const e = fI(n);
  return e.length === 1 ? e : e.filter((t, r) => !e.filter((s, o) => o !== r).some((s) => t.oldRange.from >= s.oldRange.from && t.oldRange.to <= s.oldRange.to && t.newRange.from >= s.newRange.from && t.newRange.to <= s.newRange.to));
}
function hI(n) {
  const { mapping: e, steps: t } = n, r = [];
  return e.maps.forEach((i, s) => {
    const o = [];
    if (i.ranges.length)
      i.forEach((a, l) => {
        o.push({ from: a, to: l });
      });
    else {
      const { from: a, to: l } = t[s];
      if (a === void 0 || l === void 0)
        return;
      o.push({ from: a, to: l });
    }
    o.forEach(({ from: a, to: l }) => {
      const u = e.slice(s).map(a, -1), c = e.slice(s).map(l), f = e.invert().map(u, -1), p = e.invert().map(c);
      r.push({
        oldRange: {
          from: f,
          to: p
        },
        newRange: {
          from: u,
          to: c
        }
      });
    });
  }), pI(r);
}
function Cp(n, e, t) {
  const r = [];
  return n === e ? t.resolve(n).marks().forEach((i) => {
    const s = t.resolve(n - 1), o = wp(s, i.type);
    !o || r.push({
      mark: i,
      ...o
    });
  }) : t.nodesBetween(n, e, (i, s) => {
    r.push(...i.marks.map((o) => ({
      from: s,
      to: s + i.nodeSize,
      mark: o
    })));
  }), r;
}
function ra(n, e, t) {
  return Object.fromEntries(Object.entries(t).filter(([r]) => {
    const i = n.find((s) => s.type === e && s.name === r);
    return i ? i.attribute.keepOnSplit : !1;
  }));
}
function ef(n, e, t = {}) {
  const { empty: r, ranges: i } = n.selection, s = e ? mr(e, n.schema) : null;
  if (r)
    return !!(n.storedMarks || n.selection.$from.marks()).filter((f) => s ? s.name === f.type.name : !0).find((f) => Ra(f.attrs, t, { strict: !1 }));
  let o = 0;
  const a = [];
  if (i.forEach(({ $from: f, $to: p }) => {
    const d = f.pos, h = p.pos;
    n.doc.nodesBetween(d, h, (v, g) => {
      if (!v.isText && !v.marks.length)
        return;
      const m = Math.max(d, g), _ = Math.min(h, g + v.nodeSize), y = _ - m;
      o += y, a.push(...v.marks.map((w) => ({
        mark: w,
        from: m,
        to: _
      })));
    });
  }), o === 0)
    return !1;
  const l = a.filter((f) => s ? s.name === f.mark.type.name : !0).filter((f) => Ra(f.mark.attrs, t, { strict: !1 })).reduce((f, p) => f + p.to - p.from, 0), u = a.filter((f) => s ? f.mark.type !== s && f.mark.type.excludes(s) : !0).reduce((f, p) => f + p.to - p.from, 0);
  return (l > 0 ? l + u : l) >= o;
}
function mI(n, e, t = {}) {
  if (!e)
    return Is(n, null, t) || ef(n, null, t);
  const r = Xl(e, n.schema);
  return r === "node" ? Is(n, e, t) : r === "mark" ? ef(n, e, t) : !1;
}
function jg(n, e) {
  const { nodeExtensions: t } = Ul(e), r = t.find((o) => o.name === n);
  if (!r)
    return !1;
  const i = {
    name: r.name,
    options: r.options,
    storage: r.storage
  }, s = he(Z(r, "group", i));
  return typeof s != "string" ? !1 : s.split(" ").includes("list");
}
function gI(n) {
  var e;
  const t = (e = n.type.createAndFill()) === null || e === void 0 ? void 0 : e.toJSON(), r = n.toJSON();
  return JSON.stringify(t) === JSON.stringify(r);
}
function vI(n) {
  return n instanceof te;
}
function yI(n, e, t) {
  const i = n.state.doc.content.size, s = Dn(e, 0, i), o = Dn(t, 0, i), a = n.coordsAtPos(s), l = n.coordsAtPos(o, -1), u = Math.min(a.top, l.top), c = Math.max(a.bottom, l.bottom), f = Math.min(a.left, l.left), p = Math.max(a.right, l.right), d = p - f, h = c - u, m = {
    top: u,
    bottom: c,
    left: f,
    right: p,
    width: d,
    height: h,
    x: f,
    y: u
  };
  return {
    ...m,
    toJSON: () => m
  };
}
function bI(n, e, t) {
  var r;
  const { selection: i } = e;
  let s = null;
  if (_p(i) && (s = i.$cursor), s) {
    const a = (r = n.storedMarks) !== null && r !== void 0 ? r : s.marks();
    return !!t.isInSet(a) || !a.some((l) => l.type.excludes(t));
  }
  const { ranges: o } = i;
  return o.some(({ $from: a, $to: l }) => {
    let u = a.depth === 0 ? n.doc.inlineContent && n.doc.type.allowsMarkType(t) : !1;
    return n.doc.nodesBetween(a.pos, l.pos, (c, f, p) => {
      if (u)
        return !1;
      if (c.isInline) {
        const d = !p || p.type.allowsMarkType(t), h = !!t.isInSet(c.marks) || !c.marks.some((v) => v.type.excludes(t));
        u = d && h;
      }
      return !u;
    }), u;
  });
}
const wI = (n, e = {}) => ({ tr: t, state: r, dispatch: i }) => {
  const { selection: s } = t, { empty: o, ranges: a } = s, l = mr(n, r.schema);
  if (i)
    if (o) {
      const u = no(r, l);
      t.addStoredMark(l.create({
        ...u,
        ...e
      }));
    } else
      a.forEach((u) => {
        const c = u.$from.pos, f = u.$to.pos;
        r.doc.nodesBetween(c, f, (p, d) => {
          const h = Math.max(d, c), v = Math.min(d + p.nodeSize, f);
          p.marks.find((m) => m.type === l) ? p.marks.forEach((m) => {
            l === m.type && t.addMark(h, v, l.create({
              ...m.attrs,
              ...e
            }));
          }) : t.addMark(h, v, l.create(e));
        });
      });
  return bI(r, t, l);
}, _I = (n, e) => ({ tr: t }) => (t.setMeta(n, e), !0), SI = (n, e = {}) => ({ state: t, dispatch: r, chain: i }) => {
  const s = Ge(n, t.schema);
  return s.isTextblock ? i().command(({ commands: o }) => Ng(s, e)(t) ? !0 : o.clearNodes()).command(({ state: o }) => Ng(s, e)(o, r)).run() : (console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.'), !1);
}, xI = (n) => ({ tr: e, dispatch: t }) => {
  if (t) {
    const { doc: r } = e, i = Dn(n, 0, r.content.size), s = te.create(r, i);
    e.setSelection(s);
  }
  return !0;
}, CI = (n) => ({ tr: e, dispatch: t }) => {
  if (t) {
    const { doc: r } = e, { from: i, to: s } = typeof n == "number" ? { from: n, to: n } : n, o = de.atStart(r).from, a = de.atEnd(r).to, l = Dn(i, o, a), u = Dn(s, o, a), c = de.create(r, l, u);
    e.setSelection(c);
  }
  return !0;
}, OI = (n) => ({ state: e, dispatch: t }) => {
  const r = Ge(n, e.schema);
  return tN(r)(e, t);
};
function Vg(n, e) {
  const t = n.storedMarks || n.selection.$to.parentOffset && n.selection.$from.marks();
  if (t) {
    const r = t.filter((i) => e == null ? void 0 : e.includes(i.type.name));
    n.tr.ensureMarks(r);
  }
}
const EI = ({ keepMarks: n = !0 } = {}) => ({ tr: e, state: t, dispatch: r, editor: i }) => {
  const { selection: s, doc: o } = e, { $from: a, $to: l } = s, u = i.extensionManager.attributes, c = ra(u, a.node().type.name, a.node().attrs);
  if (s instanceof te && s.node.isBlock)
    return !a.parentOffset || !_i(o, a.pos) ? !1 : (r && (n && Vg(t, i.extensionManager.splittableMarks), e.split(a.pos).scrollIntoView()), !0);
  if (!a.parent.isBlock)
    return !1;
  if (r) {
    const f = l.parentOffset === l.parent.content.size;
    s instanceof de && e.deleteSelection();
    const p = a.depth === 0 ? void 0 : oI(a.node(-1).contentMatchAt(a.indexAfter(-1)));
    let d = f && p ? [
      {
        type: p,
        attrs: c
      }
    ] : void 0, h = _i(e.doc, e.mapping.map(a.pos), 1, d);
    if (!d && !h && _i(e.doc, e.mapping.map(a.pos), 1, p ? [{ type: p }] : void 0) && (h = !0, d = p ? [
      {
        type: p,
        attrs: c
      }
    ] : void 0), h && (e.split(e.mapping.map(a.pos), 1, d), p && !f && !a.parentOffset && a.parent.type !== p)) {
      const v = e.mapping.map(a.before()), g = e.doc.resolve(v);
      a.node(-1).canReplaceWith(g.index(), g.index() + 1, p) && e.setNodeMarkup(e.mapping.map(a.before()), p);
    }
    n && Vg(t, i.extensionManager.splittableMarks), e.scrollIntoView();
  }
  return !0;
}, TI = (n) => ({ tr: e, state: t, dispatch: r, editor: i }) => {
  var s;
  const o = Ge(n, t.schema), { $from: a, $to: l } = t.selection, u = t.selection.node;
  if (u && u.isBlock || a.depth < 2 || !a.sameParent(l))
    return !1;
  const c = a.node(-1);
  if (c.type !== o)
    return !1;
  const f = i.extensionManager.attributes;
  if (a.parent.content.size === 0 && a.node(-1).childCount === a.indexAfter(-1)) {
    if (a.depth === 2 || a.node(-3).type !== o || a.index(-2) !== a.node(-2).childCount - 1)
      return !1;
    if (r) {
      let g = V.empty;
      const m = a.index(-1) ? 1 : a.index(-2) ? 2 : 3;
      for (let S = a.depth - m; S >= a.depth - 3; S -= 1)
        g = V.from(a.node(S).copy(g));
      const _ = a.indexAfter(-1) < a.node(-2).childCount ? 1 : a.indexAfter(-2) < a.node(-3).childCount ? 2 : 3, y = ra(f, a.node().type.name, a.node().attrs), w = ((s = o.contentMatch.defaultType) === null || s === void 0 ? void 0 : s.createAndFill(y)) || void 0;
      g = g.append(V.from(o.createAndFill(null, w) || void 0));
      const O = a.before(a.depth - (m - 1));
      e.replace(O, a.after(-_), new X(g, 4 - m, 0));
      let C = -1;
      e.doc.nodesBetween(O, e.doc.content.size, (S, b) => {
        if (C > -1)
          return !1;
        S.isTextblock && S.content.size === 0 && (C = b + 1);
      }), C > -1 && e.setSelection(de.near(e.doc.resolve(C))), e.scrollIntoView();
    }
    return !0;
  }
  const p = l.pos === a.end() ? c.contentMatchAt(0).defaultType : null, d = ra(f, c.type.name, c.attrs), h = ra(f, a.node().type.name, a.node().attrs);
  e.delete(a.pos, l.pos);
  const v = p ? [
    { type: o, attrs: d },
    { type: p, attrs: h }
  ] : [{ type: o, attrs: d }];
  if (!_i(e.doc, a.pos, 2))
    return !1;
  if (r) {
    const { selection: g, storedMarks: m } = t, { splittableMarks: _ } = i.extensionManager, y = m || g.$to.parentOffset && g.$from.marks();
    if (e.split(a.pos, 2, v).scrollIntoView(), !y || !r)
      return !0;
    const w = y.filter((O) => _.includes(O.type.name));
    e.ensureMarks(w);
  }
  return !0;
}, Wc = (n, e) => {
  const t = xp((o) => o.type === e)(n.selection);
  if (!t)
    return !0;
  const r = n.doc.resolve(Math.max(0, t.pos - 1)).before(t.depth);
  if (r === void 0)
    return !0;
  const i = n.doc.nodeAt(r);
  return t.node.type === (i == null ? void 0 : i.type) && pr(n.doc, t.pos) && n.join(t.pos), !0;
}, qc = (n, e) => {
  const t = xp((o) => o.type === e)(n.selection);
  if (!t)
    return !0;
  const r = n.doc.resolve(t.start).after(t.depth);
  if (r === void 0)
    return !0;
  const i = n.doc.nodeAt(r);
  return t.node.type === (i == null ? void 0 : i.type) && pr(n.doc, r) && n.join(r), !0;
}, kI = (n, e, t, r = {}) => ({ editor: i, tr: s, state: o, dispatch: a, chain: l, commands: u, can: c }) => {
  const { extensions: f, splittableMarks: p } = i.extensionManager, d = Ge(n, o.schema), h = Ge(e, o.schema), { selection: v, storedMarks: g } = o, { $from: m, $to: _ } = v, y = m.blockRange(_), w = g || v.$to.parentOffset && v.$from.marks();
  if (!y)
    return !1;
  const O = xp((C) => jg(C.type.name, f))(v);
  if (y.depth >= 1 && O && y.depth - O.depth <= 1) {
    if (O.node.type === d)
      return u.liftListItem(h);
    if (jg(O.node.type.name, f) && d.validContent(O.node.content) && a)
      return l().command(() => (s.setNodeMarkup(O.pos, d), !0)).command(() => Wc(s, d)).command(() => qc(s, d)).run();
  }
  return !t || !w || !a ? l().command(() => c().wrapInList(d, r) ? !0 : u.clearNodes()).wrapInList(d, r).command(() => Wc(s, d)).command(() => qc(s, d)).run() : l().command(() => {
    const C = c().wrapInList(d, r), S = w.filter((b) => p.includes(b.type.name));
    return s.ensureMarks(S), C ? !0 : u.clearNodes();
  }).wrapInList(d, r).command(() => Wc(s, d)).command(() => qc(s, d)).run();
}, MI = (n, e = {}, t = {}) => ({ state: r, commands: i }) => {
  const { extendEmptyMarkRange: s = !1 } = t, o = mr(n, r.schema);
  return ef(r, o, e) ? i.unsetMark(o, { extendEmptyMarkRange: s }) : i.setMark(o, e);
}, AI = (n, e, t = {}) => ({ state: r, commands: i }) => {
  const s = Ge(n, r.schema), o = Ge(e, r.schema);
  return Is(r, s, t) ? i.setNode(o) : i.setNode(s, t);
}, PI = (n, e = {}) => ({ state: t, commands: r }) => {
  const i = Ge(n, t.schema);
  return Is(t, i, e) ? r.lift(i) : r.wrapIn(i, e);
}, $I = () => ({ state: n, dispatch: e }) => {
  const t = n.plugins;
  for (let r = 0; r < t.length; r += 1) {
    const i = t[r];
    let s;
    if (i.spec.isInputRules && (s = i.getState(n))) {
      if (e) {
        const o = n.tr, a = s.transform;
        for (let l = a.steps.length - 1; l >= 0; l -= 1)
          o.step(a.steps[l].invert(a.docs[l]));
        if (s.text) {
          const l = o.doc.resolve(s.from).marks();
          o.replaceWith(s.from, s.to, n.schema.text(s.text, l));
        } else
          o.delete(s.from, s.to);
      }
      return !0;
    }
  }
  return !1;
}, DI = () => ({ tr: n, dispatch: e }) => {
  const { selection: t } = n, { empty: r, ranges: i } = t;
  return r || e && i.forEach((s) => {
    n.removeMark(s.$from.pos, s.$to.pos);
  }), !0;
}, LI = (n, e = {}) => ({ tr: t, state: r, dispatch: i }) => {
  var s;
  const { extendEmptyMarkRange: o = !1 } = e, { selection: a } = t, l = mr(n, r.schema), { $from: u, empty: c, ranges: f } = a;
  if (!i)
    return !0;
  if (c && o) {
    let { from: p, to: d } = a;
    const h = (s = u.marks().find((g) => g.type === l)) === null || s === void 0 ? void 0 : s.attrs, v = wp(u, l, h);
    v && (p = v.from, d = v.to), t.removeMark(p, d, l);
  } else
    f.forEach((p) => {
      t.removeMark(p.$from.pos, p.$to.pos, l);
    });
  return t.removeStoredMark(l), !0;
}, NI = (n, e = {}) => ({ tr: t, state: r, dispatch: i }) => {
  let s = null, o = null;
  const a = Xl(typeof n == "string" ? n : n.name, r.schema);
  return a ? (a === "node" && (s = Ge(n, r.schema)), a === "mark" && (o = mr(n, r.schema)), i && t.selection.ranges.forEach((l) => {
    const u = l.$from.pos, c = l.$to.pos;
    r.doc.nodesBetween(u, c, (f, p) => {
      s && s === f.type && t.setNodeMarkup(p, void 0, {
        ...f.attrs,
        ...e
      }), o && f.marks.length && f.marks.forEach((d) => {
        if (o === d.type) {
          const h = Math.max(p, u), v = Math.min(p + f.nodeSize, c);
          t.addMark(h, v, o.create({
            ...d.attrs,
            ...e
          }));
        }
      });
    });
  }), !0) : !1;
}, II = (n, e = {}) => ({ state: t, dispatch: r }) => {
  const i = Ge(n, t.schema);
  return JL(i, e)(t, r);
}, RI = (n, e = {}) => ({ state: t, dispatch: r }) => {
  const i = Ge(n, t.schema);
  return XL(i, e)(t, r);
};
var FI = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  blur: vN,
  clearContent: yN,
  clearNodes: bN,
  command: wN,
  createParagraphNear: _N,
  cut: SN,
  deleteCurrentNode: xN,
  deleteNode: CN,
  deleteRange: ON,
  deleteSelection: EN,
  enter: TN,
  exitCode: kN,
  extendMarkRange: AN,
  first: PN,
  focus: $N,
  forEach: DN,
  insertContent: LN,
  insertContentAt: RN,
  joinUp: FN,
  joinDown: zN,
  joinBackward: BN,
  joinForward: jN,
  joinItemBackward: VN,
  joinItemForward: HN,
  keyboardShortcut: qN,
  lift: UN,
  liftEmptyBlock: GN,
  liftListItem: KN,
  newlineInCode: JN,
  resetAttributes: XN,
  scrollIntoView: YN,
  selectAll: QN,
  selectNodeBackward: ZN,
  selectNodeForward: eI,
  selectParentNode: tI,
  selectTextblockEnd: nI,
  selectTextblockStart: rI,
  setContent: iI,
  setMark: wI,
  setMeta: _I,
  setNode: SI,
  setNodeSelection: xI,
  setTextSelection: CI,
  sinkListItem: OI,
  splitBlock: EI,
  splitListItem: TI,
  toggleList: kI,
  toggleMark: MI,
  toggleNode: AI,
  toggleWrap: PI,
  undoInputRule: $I,
  unsetAllMarks: DI,
  unsetMark: LI,
  updateAttributes: NI,
  wrapIn: II,
  wrapInList: RI
});
const zI = Ve.create({
  name: "commands",
  addCommands() {
    return {
      ...FI
    };
  }
}), BI = Ve.create({
  name: "editable",
  addProseMirrorPlugins() {
    return [
      new lt({
        key: new Zt("editable"),
        props: {
          editable: () => this.editor.options.editable
        }
      })
    ];
  }
}), jI = Ve.create({
  name: "focusEvents",
  addProseMirrorPlugins() {
    const { editor: n } = this;
    return [
      new lt({
        key: new Zt("focusEvents"),
        props: {
          handleDOMEvents: {
            focus: (e, t) => {
              n.isFocused = !0;
              const r = n.state.tr.setMeta("focus", { event: t }).setMeta("addToHistory", !1);
              return e.dispatch(r), !1;
            },
            blur: (e, t) => {
              n.isFocused = !1;
              const r = n.state.tr.setMeta("blur", { event: t }).setMeta("addToHistory", !1);
              return e.dispatch(r), !1;
            }
          }
        }
      })
    ];
  }
}), VI = Ve.create({
  name: "keymap",
  addKeyboardShortcuts() {
    const n = () => this.editor.commands.first(({ commands: o }) => [
      () => o.undoInputRule(),
      () => o.command(({ tr: a }) => {
        const { selection: l, doc: u } = a, { empty: c, $anchor: f } = l, { pos: p, parent: d } = f, h = f.parent.isTextblock ? a.doc.resolve(p - 1) : f, v = h.parent.type.spec.isolating, g = f.pos - f.parentOffset, m = v && h.parent.childCount === 1 ? g === f.pos : me.atStart(u).from === p;
        return !c || !m || !d.type.isTextblock || d.textContent.length ? !1 : o.clearNodes();
      }),
      () => o.deleteSelection(),
      () => o.joinBackward(),
      () => o.selectNodeBackward()
    ]), e = () => this.editor.commands.first(({ commands: o }) => [
      () => o.deleteSelection(),
      () => o.deleteCurrentNode(),
      () => o.joinForward(),
      () => o.selectNodeForward()
    ]), r = {
      Enter: () => this.editor.commands.first(({ commands: o }) => [
        () => o.newlineInCode(),
        () => o.createParagraphNear(),
        () => o.liftEmptyBlock(),
        () => o.splitBlock()
      ]),
      "Mod-Enter": () => this.editor.commands.exitCode(),
      Backspace: n,
      "Mod-Backspace": n,
      "Shift-Backspace": n,
      Delete: e,
      "Mod-Delete": e,
      "Mod-a": () => this.editor.commands.selectAll()
    }, i = {
      ...r
    }, s = {
      ...r,
      "Ctrl-h": n,
      "Alt-Backspace": n,
      "Ctrl-d": e,
      "Ctrl-Alt-Backspace": e,
      "Alt-Delete": e,
      "Alt-d": e,
      "Ctrl-a": () => this.editor.commands.selectTextblockStart(),
      "Ctrl-e": () => this.editor.commands.selectTextblockEnd()
    };
    return Jl() || Sp() ? s : i;
  },
  addProseMirrorPlugins() {
    return [
      new lt({
        key: new Zt("clearDocument"),
        appendTransaction: (n, e, t) => {
          if (!(n.some((h) => h.docChanged) && !e.doc.eq(t.doc)))
            return;
          const { empty: i, from: s, to: o } = e.selection, a = me.atStart(e.doc).from, l = me.atEnd(e.doc).to;
          if (i || !(s === a && o === l) || !(t.doc.textBetween(0, t.doc.content.size, " ", " ").length === 0))
            return;
          const f = t.tr, p = Wl({
            state: t,
            transaction: f
          }), { commands: d } = new ql({
            editor: this.editor,
            state: p
          });
          if (d.clearNodes(), !!f.steps.length)
            return f;
        }
      })
    ];
  }
}), HI = Ve.create({
  name: "tabindex",
  addProseMirrorPlugins() {
    return [
      new lt({
        key: new Zt("tabindex"),
        props: {
          attributes: this.editor.isEditable ? { tabindex: "0" } : {}
        }
      })
    ];
  }
});
var WI = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ClipboardTextSerializer: gN,
  Commands: zI,
  Editable: BI,
  FocusEvents: jI,
  Keymap: VI,
  Tabindex: HI
});
const qI = `.ProseMirror {
  position: relative;
}

.ProseMirror {
  word-wrap: break-word;
  white-space: pre-wrap;
  white-space: break-spaces;
  -webkit-font-variant-ligatures: none;
  font-variant-ligatures: none;
  font-feature-settings: "liga" 0; /* the above doesn't seem to work in Edge */
}

.ProseMirror [contenteditable="false"] {
  white-space: normal;
}

.ProseMirror [contenteditable="false"] [contenteditable="true"] {
  white-space: pre-wrap;
}

.ProseMirror pre {
  white-space: pre-wrap;
}

img.ProseMirror-separator {
  display: inline !important;
  border: none !important;
  margin: 0 !important;
  width: 1px !important;
  height: 1px !important;
}

.ProseMirror-gapcursor {
  display: none;
  pointer-events: none;
  position: absolute;
  margin: 0;
}

.ProseMirror-gapcursor:after {
  content: "";
  display: block;
  position: absolute;
  top: -2px;
  width: 20px;
  border-top: 1px solid black;
  animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite;
}

@keyframes ProseMirror-cursor-blink {
  to {
    visibility: hidden;
  }
}

.ProseMirror-hideselection *::selection {
  background: transparent;
}

.ProseMirror-hideselection *::-moz-selection {
  background: transparent;
}

.ProseMirror-hideselection * {
  caret-color: transparent;
}

.ProseMirror-focused .ProseMirror-gapcursor {
  display: block;
}

.tippy-box[data-animation=fade][data-state=hidden] {
  opacity: 0
}`;
function UI(n, e, t) {
  const r = document.querySelector(`style[data-tiptap-style${t ? `-${t}` : ""}]`);
  if (r !== null)
    return r;
  const i = document.createElement("style");
  return e && i.setAttribute("nonce", e), i.setAttribute(`data-tiptap-style${t ? `-${t}` : ""}`, ""), i.innerHTML = n, document.getElementsByTagName("head")[0].appendChild(i), i;
}
class gw extends nN {
  constructor(e = {}) {
    super(), this.isFocused = !1, this.extensionStorage = {}, this.options = {
      element: document.createElement("div"),
      content: "",
      injectCSS: !0,
      injectNonce: void 0,
      extensions: [],
      autofocus: !1,
      editable: !0,
      editorProps: {},
      parseOptions: {},
      enableInputRules: !0,
      enablePasteRules: !0,
      enableCoreExtensions: !0,
      onBeforeCreate: () => null,
      onCreate: () => null,
      onUpdate: () => null,
      onSelectionUpdate: () => null,
      onTransaction: () => null,
      onFocus: () => null,
      onBlur: () => null,
      onDestroy: () => null
    }, this.isCapturingTransaction = !1, this.capturedTransaction = null, this.setOptions(e), this.createExtensionManager(), this.createCommandManager(), this.createSchema(), this.on("beforeCreate", this.options.onBeforeCreate), this.emit("beforeCreate", { editor: this }), this.createView(), this.injectCSS(), this.on("create", this.options.onCreate), this.on("update", this.options.onUpdate), this.on("selectionUpdate", this.options.onSelectionUpdate), this.on("transaction", this.options.onTransaction), this.on("focus", this.options.onFocus), this.on("blur", this.options.onBlur), this.on("destroy", this.options.onDestroy), window.setTimeout(() => {
      this.isDestroyed || (this.commands.focus(this.options.autofocus), this.emit("create", { editor: this }));
    }, 0);
  }
  get storage() {
    return this.extensionStorage;
  }
  get commands() {
    return this.commandManager.commands;
  }
  chain() {
    return this.commandManager.chain();
  }
  can() {
    return this.commandManager.can();
  }
  injectCSS() {
    this.options.injectCSS && document && (this.css = UI(qI, this.options.injectNonce));
  }
  setOptions(e = {}) {
    this.options = {
      ...this.options,
      ...e
    }, !(!this.view || !this.state || this.isDestroyed) && (this.options.editorProps && this.view.setProps(this.options.editorProps), this.view.updateState(this.state));
  }
  setEditable(e, t = !0) {
    this.setOptions({ editable: e }), t && this.emit("update", { editor: this, transaction: this.state.tr });
  }
  get isEditable() {
    return this.options.editable && this.view && this.view.editable;
  }
  get state() {
    return this.view.state;
  }
  registerPlugin(e, t) {
    const r = cw(t) ? t(e, [...this.state.plugins]) : [...this.state.plugins, e], i = this.state.reconfigure({ plugins: r });
    this.view.updateState(i);
  }
  unregisterPlugin(e) {
    if (this.isDestroyed)
      return;
    const t = typeof e == "string" ? `${e}$` : e.key, r = this.state.reconfigure({
      plugins: this.state.plugins.filter((i) => !i.key.startsWith(t))
    });
    this.view.updateState(r);
  }
  createExtensionManager() {
    const t = [...this.options.enableCoreExtensions ? Object.values(WI) : [], ...this.options.extensions].filter((r) => ["extension", "node", "mark"].includes(r == null ? void 0 : r.type));
    this.extensionManager = new bi(t, this);
  }
  createCommandManager() {
    this.commandManager = new ql({
      editor: this
    });
  }
  createSchema() {
    this.schema = this.extensionManager.schema;
  }
  createView() {
    const e = hw(this.options.content, this.schema, this.options.parseOptions), t = pw(e, this.options.autofocus);
    this.view = new _L(this.options.element, {
      ...this.options.editorProps,
      dispatchTransaction: this.dispatchTransaction.bind(this),
      state: yi.create({
        doc: e,
        selection: t || void 0
      })
    });
    const r = this.state.reconfigure({
      plugins: this.extensionManager.plugins
    });
    this.view.updateState(r), this.createNodeViews(), this.prependClass();
    const i = this.view.dom;
    i.editor = this;
  }
  createNodeViews() {
    this.view.setProps({
      nodeViews: this.extensionManager.nodeViews
    });
  }
  prependClass() {
    this.view.dom.className = `tiptap ${this.view.dom.className}`;
  }
  captureTransaction(e) {
    this.isCapturingTransaction = !0, e(), this.isCapturingTransaction = !1;
    const t = this.capturedTransaction;
    return this.capturedTransaction = null, t;
  }
  dispatchTransaction(e) {
    if (this.view.isDestroyed)
      return;
    if (this.isCapturingTransaction) {
      if (!this.capturedTransaction) {
        this.capturedTransaction = e;
        return;
      }
      e.steps.forEach((o) => {
        var a;
        return (a = this.capturedTransaction) === null || a === void 0 ? void 0 : a.step(o);
      });
      return;
    }
    const t = this.state.apply(e), r = !this.state.selection.eq(t.selection);
    this.view.updateState(t), this.emit("transaction", {
      editor: this,
      transaction: e
    }), r && this.emit("selectionUpdate", {
      editor: this,
      transaction: e
    });
    const i = e.getMeta("focus"), s = e.getMeta("blur");
    i && this.emit("focus", {
      editor: this,
      event: i.event,
      transaction: e
    }), s && this.emit("blur", {
      editor: this,
      event: s.event,
      transaction: e
    }), !(!e.docChanged || e.getMeta("preventUpdate")) && this.emit("update", {
      editor: this,
      transaction: e
    });
  }
  getAttributes(e) {
    return mw(this.state, e);
  }
  isActive(e, t) {
    const r = typeof e == "string" ? e : null, i = typeof e == "string" ? t : e;
    return mI(this.state, r, i);
  }
  getJSON() {
    return this.state.doc.toJSON();
  }
  getHTML() {
    return uI(this.state.doc.content, this.schema);
  }
  getText(e) {
    const { blockSeparator: t = `

`, textSerializers: r = {} } = e || {};
    return cI(this.state.doc, {
      blockSeparator: t,
      textSerializers: {
        ...fw(this.schema),
        ...r
      }
    });
  }
  get isEmpty() {
    return gI(this.state.doc);
  }
  getCharacterCount() {
    return console.warn('[tiptap warn]: "editor.getCharacterCount()" is deprecated. Please use "editor.storage.characterCount.characters()" instead.'), this.state.doc.content.size - 2;
  }
  destroy() {
    this.emit("destroy"), this.view && this.view.destroy(), this.removeAllListeners();
  }
  get isDestroyed() {
    var e;
    return !(!((e = this.view) === null || e === void 0) && e.docView);
  }
}
function Li(n) {
  return new Gl({
    find: n.find,
    handler: ({ state: e, range: t, match: r }) => {
      const i = he(n.getAttributes, void 0, r);
      if (i === !1 || i === null)
        return null;
      const { tr: s } = e, o = r[r.length - 1], a = r[0];
      if (o) {
        const l = a.search(/\S/), u = t.from + a.indexOf(o), c = u + o.length;
        if (Cp(t.from, t.to, e.doc).filter((d) => d.mark.type.excluded.find((v) => v === n.type && v !== d.mark.type)).filter((d) => d.to > u).length)
          return null;
        c < t.to && s.delete(c, t.to), u > t.from && s.delete(t.from + l, u);
        const p = t.from + l + o.length;
        s.addMark(t.from + l, p, n.type.create(i || {})), s.removeStoredMark(n.type);
      }
    }
  });
}
function vw(n) {
  return new Gl({
    find: n.find,
    handler: ({ state: e, range: t, match: r }) => {
      const i = he(n.getAttributes, void 0, r) || {}, { tr: s } = e, o = t.from;
      let a = t.to;
      const l = n.type.create(i);
      if (r[1]) {
        const u = r[0].lastIndexOf(r[1]);
        let c = o + u;
        c > a ? c = a : a = c + r[1].length;
        const f = r[0][r[0].length - 1];
        s.insertText(f, o + r[0].length - 1), s.replaceWith(c, a, l);
      } else
        r[0] && s.insert(o - 1, n.type.create(i)).delete(s.mapping.map(o), s.mapping.map(a));
      s.scrollIntoView();
    }
  });
}
function tf(n) {
  return new Gl({
    find: n.find,
    handler: ({ state: e, range: t, match: r }) => {
      const i = e.doc.resolve(t.from), s = he(n.getAttributes, void 0, r) || {};
      if (!i.node(-1).canReplaceWith(i.index(-1), i.indexAfter(-1), n.type))
        return null;
      e.tr.delete(t.from, t.to).setBlockType(t.from, t.from, n.type, s);
    }
  });
}
function Rs(n) {
  return new Gl({
    find: n.find,
    handler: ({ state: e, range: t, match: r, chain: i }) => {
      const s = he(n.getAttributes, void 0, r) || {}, o = e.tr.delete(t.from, t.to), l = o.doc.resolve(t.from).blockRange(), u = l && ap(l, n.type, s);
      if (!u)
        return null;
      if (o.wrap(l, u), n.keepMarks && n.editor) {
        const { selection: f, storedMarks: p } = e, { splittableMarks: d } = n.editor.extensionManager, h = p || f.$to.parentOffset && f.$from.marks();
        if (h) {
          const v = h.filter((g) => d.includes(g.type.name));
          o.ensureMarks(v);
        }
      }
      if (n.keepAttributes) {
        const f = n.type.name === "bulletList" || n.type.name === "orderedList" ? "listItem" : "taskList";
        i().updateAttributes(f, s).run();
      }
      const c = o.doc.resolve(t.from - 1).nodeBefore;
      c && c.type === n.type && pr(o.doc, t.from - 1) && (!n.joinPredicate || n.joinPredicate(r, c)) && o.join(t.from - 1);
    }
  });
}
class Dt {
  constructor(e = {}) {
    this.type = "mark", this.name = "mark", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = he(Z(this, "addOptions", {
      name: this.name
    }))), this.storage = he(Z(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new Dt(e);
  }
  configure(e = {}) {
    const t = this.extend();
    return t.options = Kl(this.options, e), t.storage = he(Z(t, "addStorage", {
      name: t.name,
      options: t.options
    })), t;
  }
  extend(e = {}) {
    const t = new Dt(e);
    return t.parent = this, this.child = t, t.name = e.name ? e.name : t.parent.name, e.defaultOptions && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${t.name}".`), t.options = he(Z(t, "addOptions", {
      name: t.name
    })), t.storage = he(Z(t, "addStorage", {
      name: t.name,
      options: t.options
    })), t;
  }
  static handleExit({ editor: e, mark: t }) {
    const { tr: r } = e.state, i = e.state.selection.$from;
    if (i.pos === i.end()) {
      const o = i.marks();
      if (!!!o.find((u) => (u == null ? void 0 : u.type.name) === t.name))
        return !1;
      const l = o.find((u) => (u == null ? void 0 : u.type.name) === t.name);
      return l && r.removeStoredMark(l), r.insertText(" ", i.pos), e.view.dispatch(r), !0;
    }
    return !1;
  }
}
class xe {
  constructor(e = {}) {
    this.type = "node", this.name = "node", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = he(Z(this, "addOptions", {
      name: this.name
    }))), this.storage = he(Z(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new xe(e);
  }
  configure(e = {}) {
    const t = this.extend();
    return t.options = Kl(this.options, e), t.storage = he(Z(t, "addStorage", {
      name: t.name,
      options: t.options
    })), t;
  }
  extend(e = {}) {
    const t = new xe(e);
    return t.parent = this, this.child = t, t.name = e.name ? e.name : t.parent.name, e.defaultOptions && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${t.name}".`), t.options = he(Z(t, "addOptions", {
      name: t.name
    })), t.storage = he(Z(t, "addStorage", {
      name: t.name,
      options: t.options
    })), t;
  }
}
function GI() {
  return navigator.platform === "Android" || /android/i.test(navigator.userAgent);
}
class KI {
  constructor(e, t, r) {
    this.isDragging = !1, this.component = e, this.editor = t.editor, this.options = {
      stopEvent: null,
      ignoreMutation: null,
      ...r
    }, this.extension = t.extension, this.node = t.node, this.decorations = t.decorations, this.getPos = t.getPos, this.mount();
  }
  mount() {
  }
  get dom() {
    return this.editor.view.dom;
  }
  get contentDOM() {
    return null;
  }
  onDragStart(e) {
    var t, r, i, s, o, a, l;
    const { view: u } = this.editor, c = e.target, f = c.nodeType === 3 ? (t = c.parentElement) === null || t === void 0 ? void 0 : t.closest("[data-drag-handle]") : c.closest("[data-drag-handle]");
    if (!this.dom || ((r = this.contentDOM) === null || r === void 0 ? void 0 : r.contains(c)) || !f)
      return;
    let p = 0, d = 0;
    if (this.dom !== f) {
      const g = this.dom.getBoundingClientRect(), m = f.getBoundingClientRect(), _ = (i = e.offsetX) !== null && i !== void 0 ? i : (s = e.nativeEvent) === null || s === void 0 ? void 0 : s.offsetX, y = (o = e.offsetY) !== null && o !== void 0 ? o : (a = e.nativeEvent) === null || a === void 0 ? void 0 : a.offsetY;
      p = m.x - g.x + _, d = m.y - g.y + y;
    }
    (l = e.dataTransfer) === null || l === void 0 || l.setDragImage(this.dom, p, d);
    const h = te.create(u.state.doc, this.getPos()), v = u.state.tr.setSelection(h);
    u.dispatch(v);
  }
  stopEvent(e) {
    var t;
    if (!this.dom)
      return !1;
    if (typeof this.options.stopEvent == "function")
      return this.options.stopEvent({ event: e });
    const r = e.target;
    if (!(this.dom.contains(r) && !(!((t = this.contentDOM) === null || t === void 0) && t.contains(r))))
      return !1;
    const s = e.type.startsWith("drag"), o = e.type === "drop";
    if ((["INPUT", "BUTTON", "SELECT", "TEXTAREA"].includes(r.tagName) || r.isContentEditable) && !o && !s)
      return !0;
    const { isEditable: l } = this.editor, { isDragging: u } = this, c = !!this.node.type.spec.draggable, f = te.isSelectable(this.node), p = e.type === "copy", d = e.type === "paste", h = e.type === "cut", v = e.type === "mousedown";
    if (!c && f && s && e.preventDefault(), c && s && !u)
      return e.preventDefault(), !1;
    if (c && l && !u && v) {
      const g = r.closest("[data-drag-handle]");
      g && (this.dom === g || this.dom.contains(g)) && (this.isDragging = !0, document.addEventListener("dragend", () => {
        this.isDragging = !1;
      }, { once: !0 }), document.addEventListener("drop", () => {
        this.isDragging = !1;
      }, { once: !0 }), document.addEventListener("mouseup", () => {
        this.isDragging = !1;
      }, { once: !0 }));
    }
    return !(u || o || p || d || h || v && f);
  }
  ignoreMutation(e) {
    return !this.dom || !this.contentDOM ? !0 : typeof this.options.ignoreMutation == "function" ? this.options.ignoreMutation({ mutation: e }) : this.node.isLeaf || this.node.isAtom ? !0 : e.type === "selection" || this.dom.contains(e.target) && e.type === "childList" && (Jl() || GI()) && this.editor.isFocused && [
      ...Array.from(e.addedNodes),
      ...Array.from(e.removedNodes)
    ].every((r) => r.isContentEditable) ? !1 : this.contentDOM === e.target && e.type === "attributes" ? !0 : !this.contentDOM.contains(e.target);
  }
  updateAttributes(e) {
    this.editor.commands.command(({ tr: t }) => {
      const r = this.getPos();
      return t.setNodeMarkup(r, void 0, {
        ...this.node.attrs,
        ...e
      }), !0;
    });
  }
  deleteNode() {
    const e = this.getPos(), t = e + this.node.nodeSize;
    this.editor.commands.deleteRange({ from: e, to: t });
  }
}
function Hr(n) {
  return new cN({
    find: n.find,
    handler: ({ state: e, range: t, match: r, pasteEvent: i }) => {
      const s = he(n.getAttributes, void 0, r, i);
      if (s === !1 || s === null)
        return null;
      const { tr: o } = e, a = r[r.length - 1], l = r[0];
      let u = t.to;
      if (a) {
        const c = l.search(/\S/), f = t.from + l.indexOf(a), p = f + a.length;
        if (Cp(t.from, t.to, e.doc).filter((h) => h.mark.type.excluded.find((g) => g === n.type && g !== h.mark.type)).filter((h) => h.to > f).length)
          return null;
        p < t.to && o.delete(p, t.to), f > t.from && o.delete(t.from + c, f), u = t.from + c + a.length, o.addMark(t.from + c, u, n.type.create(s || {})), o.removeStoredMark(n.type);
      }
    }
  });
}
var Ct = "top", Yt = "bottom", Qt = "right", Ot = "left", Op = "auto", ro = [Ct, Yt, Qt, Ot], Ni = "start", Fs = "end", JI = "clippingParents", yw = "viewport", ns = "popper", XI = "reference", Hg = /* @__PURE__ */ ro.reduce(function(n, e) {
  return n.concat([e + "-" + Ni, e + "-" + Fs]);
}, []), bw = /* @__PURE__ */ [].concat(ro, [Op]).reduce(function(n, e) {
  return n.concat([e, e + "-" + Ni, e + "-" + Fs]);
}, []), YI = "beforeRead", QI = "read", ZI = "afterRead", eR = "beforeMain", tR = "main", nR = "afterMain", rR = "beforeWrite", iR = "write", sR = "afterWrite", oR = [YI, QI, ZI, eR, tR, nR, rR, iR, sR];
function On(n) {
  return n ? (n.nodeName || "").toLowerCase() : null;
}
function Lt(n) {
  if (n == null)
    return window;
  if (n.toString() !== "[object Window]") {
    var e = n.ownerDocument;
    return e && e.defaultView || window;
  }
  return n;
}
function Wr(n) {
  var e = Lt(n).Element;
  return n instanceof e || n instanceof Element;
}
function Xt(n) {
  var e = Lt(n).HTMLElement;
  return n instanceof e || n instanceof HTMLElement;
}
function Ep(n) {
  if (typeof ShadowRoot > "u")
    return !1;
  var e = Lt(n).ShadowRoot;
  return n instanceof e || n instanceof ShadowRoot;
}
function aR(n) {
  var e = n.state;
  Object.keys(e.elements).forEach(function(t) {
    var r = e.styles[t] || {}, i = e.attributes[t] || {}, s = e.elements[t];
    !Xt(s) || !On(s) || (Object.assign(s.style, r), Object.keys(i).forEach(function(o) {
      var a = i[o];
      a === !1 ? s.removeAttribute(o) : s.setAttribute(o, a === !0 ? "" : a);
    }));
  });
}
function lR(n) {
  var e = n.state, t = {
    popper: {
      position: e.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(e.elements.popper.style, t.popper), e.styles = t, e.elements.arrow && Object.assign(e.elements.arrow.style, t.arrow), function() {
    Object.keys(e.elements).forEach(function(r) {
      var i = e.elements[r], s = e.attributes[r] || {}, o = Object.keys(e.styles.hasOwnProperty(r) ? e.styles[r] : t[r]), a = o.reduce(function(l, u) {
        return l[u] = "", l;
      }, {});
      !Xt(i) || !On(i) || (Object.assign(i.style, a), Object.keys(s).forEach(function(l) {
        i.removeAttribute(l);
      }));
    });
  };
}
const ww = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: aR,
  effect: lR,
  requires: ["computeStyles"]
};
function _n(n) {
  return n.split("-")[0];
}
var Fr = Math.max, za = Math.min, Ii = Math.round;
function nf() {
  var n = navigator.userAgentData;
  return n != null && n.brands && Array.isArray(n.brands) ? n.brands.map(function(e) {
    return e.brand + "/" + e.version;
  }).join(" ") : navigator.userAgent;
}
function _w() {
  return !/^((?!chrome|android).)*safari/i.test(nf());
}
function Ri(n, e, t) {
  e === void 0 && (e = !1), t === void 0 && (t = !1);
  var r = n.getBoundingClientRect(), i = 1, s = 1;
  e && Xt(n) && (i = n.offsetWidth > 0 && Ii(r.width) / n.offsetWidth || 1, s = n.offsetHeight > 0 && Ii(r.height) / n.offsetHeight || 1);
  var o = Wr(n) ? Lt(n) : window, a = o.visualViewport, l = !_w() && t, u = (r.left + (l && a ? a.offsetLeft : 0)) / i, c = (r.top + (l && a ? a.offsetTop : 0)) / s, f = r.width / i, p = r.height / s;
  return {
    width: f,
    height: p,
    top: c,
    right: u + f,
    bottom: c + p,
    left: u,
    x: u,
    y: c
  };
}
function Tp(n) {
  var e = Ri(n), t = n.offsetWidth, r = n.offsetHeight;
  return Math.abs(e.width - t) <= 1 && (t = e.width), Math.abs(e.height - r) <= 1 && (r = e.height), {
    x: n.offsetLeft,
    y: n.offsetTop,
    width: t,
    height: r
  };
}
function Sw(n, e) {
  var t = e.getRootNode && e.getRootNode();
  if (n.contains(e))
    return !0;
  if (t && Ep(t)) {
    var r = e;
    do {
      if (r && n.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function In(n) {
  return Lt(n).getComputedStyle(n);
}
function uR(n) {
  return ["table", "td", "th"].indexOf(On(n)) >= 0;
}
function gr(n) {
  return ((Wr(n) ? n.ownerDocument : n.document) || window.document).documentElement;
}
function Yl(n) {
  return On(n) === "html" ? n : n.assignedSlot || n.parentNode || (Ep(n) ? n.host : null) || gr(n);
}
function Wg(n) {
  return !Xt(n) || In(n).position === "fixed" ? null : n.offsetParent;
}
function cR(n) {
  var e = /firefox/i.test(nf()), t = /Trident/i.test(nf());
  if (t && Xt(n)) {
    var r = In(n);
    if (r.position === "fixed")
      return null;
  }
  var i = Yl(n);
  for (Ep(i) && (i = i.host); Xt(i) && ["html", "body"].indexOf(On(i)) < 0; ) {
    var s = In(i);
    if (s.transform !== "none" || s.perspective !== "none" || s.contain === "paint" || ["transform", "perspective"].indexOf(s.willChange) !== -1 || e && s.willChange === "filter" || e && s.filter && s.filter !== "none")
      return i;
    i = i.parentNode;
  }
  return null;
}
function io(n) {
  for (var e = Lt(n), t = Wg(n); t && uR(t) && In(t).position === "static"; )
    t = Wg(t);
  return t && (On(t) === "html" || On(t) === "body" && In(t).position === "static") ? e : t || cR(n) || e;
}
function kp(n) {
  return ["top", "bottom"].indexOf(n) >= 0 ? "x" : "y";
}
function ws(n, e, t) {
  return Fr(n, za(e, t));
}
function dR(n, e, t) {
  var r = ws(n, e, t);
  return r > t ? t : r;
}
function xw() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Cw(n) {
  return Object.assign({}, xw(), n);
}
function Ow(n, e) {
  return e.reduce(function(t, r) {
    return t[r] = n, t;
  }, {});
}
var fR = function(e, t) {
  return e = typeof e == "function" ? e(Object.assign({}, t.rects, {
    placement: t.placement
  })) : e, Cw(typeof e != "number" ? e : Ow(e, ro));
};
function pR(n) {
  var e, t = n.state, r = n.name, i = n.options, s = t.elements.arrow, o = t.modifiersData.popperOffsets, a = _n(t.placement), l = kp(a), u = [Ot, Qt].indexOf(a) >= 0, c = u ? "height" : "width";
  if (!(!s || !o)) {
    var f = fR(i.padding, t), p = Tp(s), d = l === "y" ? Ct : Ot, h = l === "y" ? Yt : Qt, v = t.rects.reference[c] + t.rects.reference[l] - o[l] - t.rects.popper[c], g = o[l] - t.rects.reference[l], m = io(s), _ = m ? l === "y" ? m.clientHeight || 0 : m.clientWidth || 0 : 0, y = v / 2 - g / 2, w = f[d], O = _ - p[c] - f[h], C = _ / 2 - p[c] / 2 + y, S = ws(w, C, O), b = l;
    t.modifiersData[r] = (e = {}, e[b] = S, e.centerOffset = S - C, e);
  }
}
function hR(n) {
  var e = n.state, t = n.options, r = t.element, i = r === void 0 ? "[data-popper-arrow]" : r;
  i != null && (typeof i == "string" && (i = e.elements.popper.querySelector(i), !i) || !Sw(e.elements.popper, i) || (e.elements.arrow = i));
}
const mR = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: pR,
  effect: hR,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Fi(n) {
  return n.split("-")[1];
}
var gR = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function vR(n, e) {
  var t = n.x, r = n.y, i = e.devicePixelRatio || 1;
  return {
    x: Ii(t * i) / i || 0,
    y: Ii(r * i) / i || 0
  };
}
function qg(n) {
  var e, t = n.popper, r = n.popperRect, i = n.placement, s = n.variation, o = n.offsets, a = n.position, l = n.gpuAcceleration, u = n.adaptive, c = n.roundOffsets, f = n.isFixed, p = o.x, d = p === void 0 ? 0 : p, h = o.y, v = h === void 0 ? 0 : h, g = typeof c == "function" ? c({
    x: d,
    y: v
  }) : {
    x: d,
    y: v
  };
  d = g.x, v = g.y;
  var m = o.hasOwnProperty("x"), _ = o.hasOwnProperty("y"), y = Ot, w = Ct, O = window;
  if (u) {
    var C = io(t), S = "clientHeight", b = "clientWidth";
    if (C === Lt(t) && (C = gr(t), In(C).position !== "static" && a === "absolute" && (S = "scrollHeight", b = "scrollWidth")), C = C, i === Ct || (i === Ot || i === Qt) && s === Fs) {
      w = Yt;
      var x = f && C === O && O.visualViewport ? O.visualViewport.height : C[S];
      v -= x - r.height, v *= l ? 1 : -1;
    }
    if (i === Ot || (i === Ct || i === Yt) && s === Fs) {
      y = Qt;
      var E = f && C === O && O.visualViewport ? O.visualViewport.width : C[b];
      d -= E - r.width, d *= l ? 1 : -1;
    }
  }
  var M = Object.assign({
    position: a
  }, u && gR), $ = c === !0 ? vR({
    x: d,
    y: v
  }, Lt(t)) : {
    x: d,
    y: v
  };
  if (d = $.x, v = $.y, l) {
    var F;
    return Object.assign({}, M, (F = {}, F[w] = _ ? "0" : "", F[y] = m ? "0" : "", F.transform = (O.devicePixelRatio || 1) <= 1 ? "translate(" + d + "px, " + v + "px)" : "translate3d(" + d + "px, " + v + "px, 0)", F));
  }
  return Object.assign({}, M, (e = {}, e[w] = _ ? v + "px" : "", e[y] = m ? d + "px" : "", e.transform = "", e));
}
function yR(n) {
  var e = n.state, t = n.options, r = t.gpuAcceleration, i = r === void 0 ? !0 : r, s = t.adaptive, o = s === void 0 ? !0 : s, a = t.roundOffsets, l = a === void 0 ? !0 : a, u = {
    placement: _n(e.placement),
    variation: Fi(e.placement),
    popper: e.elements.popper,
    popperRect: e.rects.popper,
    gpuAcceleration: i,
    isFixed: e.options.strategy === "fixed"
  };
  e.modifiersData.popperOffsets != null && (e.styles.popper = Object.assign({}, e.styles.popper, qg(Object.assign({}, u, {
    offsets: e.modifiersData.popperOffsets,
    position: e.options.strategy,
    adaptive: o,
    roundOffsets: l
  })))), e.modifiersData.arrow != null && (e.styles.arrow = Object.assign({}, e.styles.arrow, qg(Object.assign({}, u, {
    offsets: e.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-placement": e.placement
  });
}
const bR = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: yR,
  data: {}
};
var $o = {
  passive: !0
};
function wR(n) {
  var e = n.state, t = n.instance, r = n.options, i = r.scroll, s = i === void 0 ? !0 : i, o = r.resize, a = o === void 0 ? !0 : o, l = Lt(e.elements.popper), u = [].concat(e.scrollParents.reference, e.scrollParents.popper);
  return s && u.forEach(function(c) {
    c.addEventListener("scroll", t.update, $o);
  }), a && l.addEventListener("resize", t.update, $o), function() {
    s && u.forEach(function(c) {
      c.removeEventListener("scroll", t.update, $o);
    }), a && l.removeEventListener("resize", t.update, $o);
  };
}
const _R = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: wR,
  data: {}
};
var SR = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function ia(n) {
  return n.replace(/left|right|bottom|top/g, function(e) {
    return SR[e];
  });
}
var xR = {
  start: "end",
  end: "start"
};
function Ug(n) {
  return n.replace(/start|end/g, function(e) {
    return xR[e];
  });
}
function Mp(n) {
  var e = Lt(n), t = e.pageXOffset, r = e.pageYOffset;
  return {
    scrollLeft: t,
    scrollTop: r
  };
}
function Ap(n) {
  return Ri(gr(n)).left + Mp(n).scrollLeft;
}
function CR(n, e) {
  var t = Lt(n), r = gr(n), i = t.visualViewport, s = r.clientWidth, o = r.clientHeight, a = 0, l = 0;
  if (i) {
    s = i.width, o = i.height;
    var u = _w();
    (u || !u && e === "fixed") && (a = i.offsetLeft, l = i.offsetTop);
  }
  return {
    width: s,
    height: o,
    x: a + Ap(n),
    y: l
  };
}
function OR(n) {
  var e, t = gr(n), r = Mp(n), i = (e = n.ownerDocument) == null ? void 0 : e.body, s = Fr(t.scrollWidth, t.clientWidth, i ? i.scrollWidth : 0, i ? i.clientWidth : 0), o = Fr(t.scrollHeight, t.clientHeight, i ? i.scrollHeight : 0, i ? i.clientHeight : 0), a = -r.scrollLeft + Ap(n), l = -r.scrollTop;
  return In(i || t).direction === "rtl" && (a += Fr(t.clientWidth, i ? i.clientWidth : 0) - s), {
    width: s,
    height: o,
    x: a,
    y: l
  };
}
function Pp(n) {
  var e = In(n), t = e.overflow, r = e.overflowX, i = e.overflowY;
  return /auto|scroll|overlay|hidden/.test(t + i + r);
}
function Ew(n) {
  return ["html", "body", "#document"].indexOf(On(n)) >= 0 ? n.ownerDocument.body : Xt(n) && Pp(n) ? n : Ew(Yl(n));
}
function _s(n, e) {
  var t;
  e === void 0 && (e = []);
  var r = Ew(n), i = r === ((t = n.ownerDocument) == null ? void 0 : t.body), s = Lt(r), o = i ? [s].concat(s.visualViewport || [], Pp(r) ? r : []) : r, a = e.concat(o);
  return i ? a : a.concat(_s(Yl(o)));
}
function rf(n) {
  return Object.assign({}, n, {
    left: n.x,
    top: n.y,
    right: n.x + n.width,
    bottom: n.y + n.height
  });
}
function ER(n, e) {
  var t = Ri(n, !1, e === "fixed");
  return t.top = t.top + n.clientTop, t.left = t.left + n.clientLeft, t.bottom = t.top + n.clientHeight, t.right = t.left + n.clientWidth, t.width = n.clientWidth, t.height = n.clientHeight, t.x = t.left, t.y = t.top, t;
}
function Gg(n, e, t) {
  return e === yw ? rf(CR(n, t)) : Wr(e) ? ER(e, t) : rf(OR(gr(n)));
}
function TR(n) {
  var e = _s(Yl(n)), t = ["absolute", "fixed"].indexOf(In(n).position) >= 0, r = t && Xt(n) ? io(n) : n;
  return Wr(r) ? e.filter(function(i) {
    return Wr(i) && Sw(i, r) && On(i) !== "body";
  }) : [];
}
function kR(n, e, t, r) {
  var i = e === "clippingParents" ? TR(n) : [].concat(e), s = [].concat(i, [t]), o = s[0], a = s.reduce(function(l, u) {
    var c = Gg(n, u, r);
    return l.top = Fr(c.top, l.top), l.right = za(c.right, l.right), l.bottom = za(c.bottom, l.bottom), l.left = Fr(c.left, l.left), l;
  }, Gg(n, o, r));
  return a.width = a.right - a.left, a.height = a.bottom - a.top, a.x = a.left, a.y = a.top, a;
}
function Tw(n) {
  var e = n.reference, t = n.element, r = n.placement, i = r ? _n(r) : null, s = r ? Fi(r) : null, o = e.x + e.width / 2 - t.width / 2, a = e.y + e.height / 2 - t.height / 2, l;
  switch (i) {
    case Ct:
      l = {
        x: o,
        y: e.y - t.height
      };
      break;
    case Yt:
      l = {
        x: o,
        y: e.y + e.height
      };
      break;
    case Qt:
      l = {
        x: e.x + e.width,
        y: a
      };
      break;
    case Ot:
      l = {
        x: e.x - t.width,
        y: a
      };
      break;
    default:
      l = {
        x: e.x,
        y: e.y
      };
  }
  var u = i ? kp(i) : null;
  if (u != null) {
    var c = u === "y" ? "height" : "width";
    switch (s) {
      case Ni:
        l[u] = l[u] - (e[c] / 2 - t[c] / 2);
        break;
      case Fs:
        l[u] = l[u] + (e[c] / 2 - t[c] / 2);
        break;
    }
  }
  return l;
}
function zs(n, e) {
  e === void 0 && (e = {});
  var t = e, r = t.placement, i = r === void 0 ? n.placement : r, s = t.strategy, o = s === void 0 ? n.strategy : s, a = t.boundary, l = a === void 0 ? JI : a, u = t.rootBoundary, c = u === void 0 ? yw : u, f = t.elementContext, p = f === void 0 ? ns : f, d = t.altBoundary, h = d === void 0 ? !1 : d, v = t.padding, g = v === void 0 ? 0 : v, m = Cw(typeof g != "number" ? g : Ow(g, ro)), _ = p === ns ? XI : ns, y = n.rects.popper, w = n.elements[h ? _ : p], O = kR(Wr(w) ? w : w.contextElement || gr(n.elements.popper), l, c, o), C = Ri(n.elements.reference), S = Tw({
    reference: C,
    element: y,
    strategy: "absolute",
    placement: i
  }), b = rf(Object.assign({}, y, S)), x = p === ns ? b : C, E = {
    top: O.top - x.top + m.top,
    bottom: x.bottom - O.bottom + m.bottom,
    left: O.left - x.left + m.left,
    right: x.right - O.right + m.right
  }, M = n.modifiersData.offset;
  if (p === ns && M) {
    var $ = M[i];
    Object.keys(E).forEach(function(F) {
      var J = [Qt, Yt].indexOf(F) >= 0 ? 1 : -1, W = [Ct, Yt].indexOf(F) >= 0 ? "y" : "x";
      E[F] += $[W] * J;
    });
  }
  return E;
}
function MR(n, e) {
  e === void 0 && (e = {});
  var t = e, r = t.placement, i = t.boundary, s = t.rootBoundary, o = t.padding, a = t.flipVariations, l = t.allowedAutoPlacements, u = l === void 0 ? bw : l, c = Fi(r), f = c ? a ? Hg : Hg.filter(function(h) {
    return Fi(h) === c;
  }) : ro, p = f.filter(function(h) {
    return u.indexOf(h) >= 0;
  });
  p.length === 0 && (p = f);
  var d = p.reduce(function(h, v) {
    return h[v] = zs(n, {
      placement: v,
      boundary: i,
      rootBoundary: s,
      padding: o
    })[_n(v)], h;
  }, {});
  return Object.keys(d).sort(function(h, v) {
    return d[h] - d[v];
  });
}
function AR(n) {
  if (_n(n) === Op)
    return [];
  var e = ia(n);
  return [Ug(n), e, Ug(e)];
}
function PR(n) {
  var e = n.state, t = n.options, r = n.name;
  if (!e.modifiersData[r]._skip) {
    for (var i = t.mainAxis, s = i === void 0 ? !0 : i, o = t.altAxis, a = o === void 0 ? !0 : o, l = t.fallbackPlacements, u = t.padding, c = t.boundary, f = t.rootBoundary, p = t.altBoundary, d = t.flipVariations, h = d === void 0 ? !0 : d, v = t.allowedAutoPlacements, g = e.options.placement, m = _n(g), _ = m === g, y = l || (_ || !h ? [ia(g)] : AR(g)), w = [g].concat(y).reduce(function(ye, re) {
      return ye.concat(_n(re) === Op ? MR(e, {
        placement: re,
        boundary: c,
        rootBoundary: f,
        padding: u,
        flipVariations: h,
        allowedAutoPlacements: v
      }) : re);
    }, []), O = e.rects.reference, C = e.rects.popper, S = /* @__PURE__ */ new Map(), b = !0, x = w[0], E = 0; E < w.length; E++) {
      var M = w[E], $ = _n(M), F = Fi(M) === Ni, J = [Ct, Yt].indexOf($) >= 0, W = J ? "width" : "height", H = zs(e, {
        placement: M,
        boundary: c,
        rootBoundary: f,
        altBoundary: p,
        padding: u
      }), Y = J ? F ? Qt : Ot : F ? Yt : Ct;
      O[W] > C[W] && (Y = ia(Y));
      var z = ia(Y), j = [];
      if (s && j.push(H[$] <= 0), a && j.push(H[Y] <= 0, H[z] <= 0), j.every(function(ye) {
        return ye;
      })) {
        x = M, b = !1;
        break;
      }
      S.set(M, j);
    }
    if (b)
      for (var Q = h ? 3 : 1, fe = function(re) {
        var T = w.find(function(D) {
          var R = S.get(D);
          if (R)
            return R.slice(0, re).every(function(I) {
              return I;
            });
        });
        if (T)
          return x = T, "break";
      }, ue = Q; ue > 0; ue--) {
        var ae = fe(ue);
        if (ae === "break")
          break;
      }
    e.placement !== x && (e.modifiersData[r]._skip = !0, e.placement = x, e.reset = !0);
  }
}
const $R = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: PR,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Kg(n, e, t) {
  return t === void 0 && (t = {
    x: 0,
    y: 0
  }), {
    top: n.top - e.height - t.y,
    right: n.right - e.width + t.x,
    bottom: n.bottom - e.height + t.y,
    left: n.left - e.width - t.x
  };
}
function Jg(n) {
  return [Ct, Qt, Yt, Ot].some(function(e) {
    return n[e] >= 0;
  });
}
function DR(n) {
  var e = n.state, t = n.name, r = e.rects.reference, i = e.rects.popper, s = e.modifiersData.preventOverflow, o = zs(e, {
    elementContext: "reference"
  }), a = zs(e, {
    altBoundary: !0
  }), l = Kg(o, r), u = Kg(a, i, s), c = Jg(l), f = Jg(u);
  e.modifiersData[t] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: u,
    isReferenceHidden: c,
    hasPopperEscaped: f
  }, e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-reference-hidden": c,
    "data-popper-escaped": f
  });
}
const LR = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: DR
};
function NR(n, e, t) {
  var r = _n(n), i = [Ot, Ct].indexOf(r) >= 0 ? -1 : 1, s = typeof t == "function" ? t(Object.assign({}, e, {
    placement: n
  })) : t, o = s[0], a = s[1];
  return o = o || 0, a = (a || 0) * i, [Ot, Qt].indexOf(r) >= 0 ? {
    x: a,
    y: o
  } : {
    x: o,
    y: a
  };
}
function IR(n) {
  var e = n.state, t = n.options, r = n.name, i = t.offset, s = i === void 0 ? [0, 0] : i, o = bw.reduce(function(c, f) {
    return c[f] = NR(f, e.rects, s), c;
  }, {}), a = o[e.placement], l = a.x, u = a.y;
  e.modifiersData.popperOffsets != null && (e.modifiersData.popperOffsets.x += l, e.modifiersData.popperOffsets.y += u), e.modifiersData[r] = o;
}
const RR = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: IR
};
function FR(n) {
  var e = n.state, t = n.name;
  e.modifiersData[t] = Tw({
    reference: e.rects.reference,
    element: e.rects.popper,
    strategy: "absolute",
    placement: e.placement
  });
}
const zR = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: FR,
  data: {}
};
function BR(n) {
  return n === "x" ? "y" : "x";
}
function jR(n) {
  var e = n.state, t = n.options, r = n.name, i = t.mainAxis, s = i === void 0 ? !0 : i, o = t.altAxis, a = o === void 0 ? !1 : o, l = t.boundary, u = t.rootBoundary, c = t.altBoundary, f = t.padding, p = t.tether, d = p === void 0 ? !0 : p, h = t.tetherOffset, v = h === void 0 ? 0 : h, g = zs(e, {
    boundary: l,
    rootBoundary: u,
    padding: f,
    altBoundary: c
  }), m = _n(e.placement), _ = Fi(e.placement), y = !_, w = kp(m), O = BR(w), C = e.modifiersData.popperOffsets, S = e.rects.reference, b = e.rects.popper, x = typeof v == "function" ? v(Object.assign({}, e.rects, {
    placement: e.placement
  })) : v, E = typeof x == "number" ? {
    mainAxis: x,
    altAxis: x
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, x), M = e.modifiersData.offset ? e.modifiersData.offset[e.placement] : null, $ = {
    x: 0,
    y: 0
  };
  if (!!C) {
    if (s) {
      var F, J = w === "y" ? Ct : Ot, W = w === "y" ? Yt : Qt, H = w === "y" ? "height" : "width", Y = C[w], z = Y + g[J], j = Y - g[W], Q = d ? -b[H] / 2 : 0, fe = _ === Ni ? S[H] : b[H], ue = _ === Ni ? -b[H] : -S[H], ae = e.elements.arrow, ye = d && ae ? Tp(ae) : {
        width: 0,
        height: 0
      }, re = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : xw(), T = re[J], D = re[W], R = ws(0, S[H], ye[H]), I = y ? S[H] / 2 - Q - R - T - E.mainAxis : fe - R - T - E.mainAxis, se = y ? -S[H] / 2 + Q + R + D + E.mainAxis : ue + R + D + E.mainAxis, Oe = e.elements.arrow && io(e.elements.arrow), Me = Oe ? w === "y" ? Oe.clientTop || 0 : Oe.clientLeft || 0 : 0, Re = (F = M == null ? void 0 : M[w]) != null ? F : 0, Je = Y + I - Re - Me, Ee = Y + se - Re, Fe = ws(d ? za(z, Je) : z, Y, d ? Fr(j, Ee) : j);
      C[w] = Fe, $[w] = Fe - Y;
    }
    if (a) {
      var Ft, zt = w === "x" ? Ct : Ot, Fn = w === "x" ? Yt : Qt, wt = C[O], Te = O === "y" ? "height" : "width", ln = wt + g[zt], en = wt - g[Fn], un = [Ct, Ot].indexOf(m) !== -1, zn = (Ft = M == null ? void 0 : M[O]) != null ? Ft : 0, En = un ? ln : wt - S[Te] - b[Te] - zn + E.altAxis, Bn = un ? wt + S[Te] + b[Te] - zn - E.altAxis : en, Bt = d && un ? dR(En, wt, Bn) : ws(d ? En : ln, wt, d ? Bn : en);
      C[O] = Bt, $[O] = Bt - wt;
    }
    e.modifiersData[r] = $;
  }
}
const VR = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: jR,
  requiresIfExists: ["offset"]
};
function HR(n) {
  return {
    scrollLeft: n.scrollLeft,
    scrollTop: n.scrollTop
  };
}
function WR(n) {
  return n === Lt(n) || !Xt(n) ? Mp(n) : HR(n);
}
function qR(n) {
  var e = n.getBoundingClientRect(), t = Ii(e.width) / n.offsetWidth || 1, r = Ii(e.height) / n.offsetHeight || 1;
  return t !== 1 || r !== 1;
}
function UR(n, e, t) {
  t === void 0 && (t = !1);
  var r = Xt(e), i = Xt(e) && qR(e), s = gr(e), o = Ri(n, i, t), a = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (r || !r && !t) && ((On(e) !== "body" || Pp(s)) && (a = WR(e)), Xt(e) ? (l = Ri(e, !0), l.x += e.clientLeft, l.y += e.clientTop) : s && (l.x = Ap(s))), {
    x: o.left + a.scrollLeft - l.x,
    y: o.top + a.scrollTop - l.y,
    width: o.width,
    height: o.height
  };
}
function GR(n) {
  var e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Set(), r = [];
  n.forEach(function(s) {
    e.set(s.name, s);
  });
  function i(s) {
    t.add(s.name);
    var o = [].concat(s.requires || [], s.requiresIfExists || []);
    o.forEach(function(a) {
      if (!t.has(a)) {
        var l = e.get(a);
        l && i(l);
      }
    }), r.push(s);
  }
  return n.forEach(function(s) {
    t.has(s.name) || i(s);
  }), r;
}
function KR(n) {
  var e = GR(n);
  return oR.reduce(function(t, r) {
    return t.concat(e.filter(function(i) {
      return i.phase === r;
    }));
  }, []);
}
function JR(n) {
  var e;
  return function() {
    return e || (e = new Promise(function(t) {
      Promise.resolve().then(function() {
        e = void 0, t(n());
      });
    })), e;
  };
}
function XR(n) {
  var e = n.reduce(function(t, r) {
    var i = t[r.name];
    return t[r.name] = i ? Object.assign({}, i, r, {
      options: Object.assign({}, i.options, r.options),
      data: Object.assign({}, i.data, r.data)
    }) : r, t;
  }, {});
  return Object.keys(e).map(function(t) {
    return e[t];
  });
}
var Xg = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function Yg() {
  for (var n = arguments.length, e = new Array(n), t = 0; t < n; t++)
    e[t] = arguments[t];
  return !e.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function YR(n) {
  n === void 0 && (n = {});
  var e = n, t = e.defaultModifiers, r = t === void 0 ? [] : t, i = e.defaultOptions, s = i === void 0 ? Xg : i;
  return function(a, l, u) {
    u === void 0 && (u = s);
    var c = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Xg, s),
      modifiersData: {},
      elements: {
        reference: a,
        popper: l
      },
      attributes: {},
      styles: {}
    }, f = [], p = !1, d = {
      state: c,
      setOptions: function(m) {
        var _ = typeof m == "function" ? m(c.options) : m;
        v(), c.options = Object.assign({}, s, c.options, _), c.scrollParents = {
          reference: Wr(a) ? _s(a) : a.contextElement ? _s(a.contextElement) : [],
          popper: _s(l)
        };
        var y = KR(XR([].concat(r, c.options.modifiers)));
        return c.orderedModifiers = y.filter(function(w) {
          return w.enabled;
        }), h(), d.update();
      },
      forceUpdate: function() {
        if (!p) {
          var m = c.elements, _ = m.reference, y = m.popper;
          if (!!Yg(_, y)) {
            c.rects = {
              reference: UR(_, io(y), c.options.strategy === "fixed"),
              popper: Tp(y)
            }, c.reset = !1, c.placement = c.options.placement, c.orderedModifiers.forEach(function(E) {
              return c.modifiersData[E.name] = Object.assign({}, E.data);
            });
            for (var w = 0; w < c.orderedModifiers.length; w++) {
              if (c.reset === !0) {
                c.reset = !1, w = -1;
                continue;
              }
              var O = c.orderedModifiers[w], C = O.fn, S = O.options, b = S === void 0 ? {} : S, x = O.name;
              typeof C == "function" && (c = C({
                state: c,
                options: b,
                name: x,
                instance: d
              }) || c);
            }
          }
        }
      },
      update: JR(function() {
        return new Promise(function(g) {
          d.forceUpdate(), g(c);
        });
      }),
      destroy: function() {
        v(), p = !0;
      }
    };
    if (!Yg(a, l))
      return d;
    d.setOptions(u).then(function(g) {
      !p && u.onFirstUpdate && u.onFirstUpdate(g);
    });
    function h() {
      c.orderedModifiers.forEach(function(g) {
        var m = g.name, _ = g.options, y = _ === void 0 ? {} : _, w = g.effect;
        if (typeof w == "function") {
          var O = w({
            state: c,
            name: m,
            instance: d,
            options: y
          }), C = function() {
          };
          f.push(O || C);
        }
      });
    }
    function v() {
      f.forEach(function(g) {
        return g();
      }), f = [];
    }
    return d;
  };
}
var QR = [_R, zR, bR, ww, RR, $R, VR, mR, LR], ZR = /* @__PURE__ */ YR({
  defaultModifiers: QR
}), eF = "tippy-box", kw = "tippy-content", tF = "tippy-backdrop", Mw = "tippy-arrow", Aw = "tippy-svg-arrow", Sr = {
  passive: !0,
  capture: !0
}, Pw = function() {
  return document.body;
};
function nF(n, e) {
  return {}.hasOwnProperty.call(n, e);
}
function Uc(n, e, t) {
  if (Array.isArray(n)) {
    var r = n[e];
    return r == null ? Array.isArray(t) ? t[e] : t : r;
  }
  return n;
}
function $p(n, e) {
  var t = {}.toString.call(n);
  return t.indexOf("[object") === 0 && t.indexOf(e + "]") > -1;
}
function $w(n, e) {
  return typeof n == "function" ? n.apply(void 0, e) : n;
}
function Qg(n, e) {
  if (e === 0)
    return n;
  var t;
  return function(r) {
    clearTimeout(t), t = setTimeout(function() {
      n(r);
    }, e);
  };
}
function rF(n, e) {
  var t = Object.assign({}, n);
  return e.forEach(function(r) {
    delete t[r];
  }), t;
}
function iF(n) {
  return n.split(/\s+/).filter(Boolean);
}
function hi(n) {
  return [].concat(n);
}
function Zg(n, e) {
  n.indexOf(e) === -1 && n.push(e);
}
function sF(n) {
  return n.filter(function(e, t) {
    return n.indexOf(e) === t;
  });
}
function oF(n) {
  return n.split("-")[0];
}
function Ba(n) {
  return [].slice.call(n);
}
function ev(n) {
  return Object.keys(n).reduce(function(e, t) {
    return n[t] !== void 0 && (e[t] = n[t]), e;
  }, {});
}
function Ss() {
  return document.createElement("div");
}
function Bs(n) {
  return ["Element", "Fragment"].some(function(e) {
    return $p(n, e);
  });
}
function aF(n) {
  return $p(n, "NodeList");
}
function lF(n) {
  return $p(n, "MouseEvent");
}
function uF(n) {
  return !!(n && n._tippy && n._tippy.reference === n);
}
function cF(n) {
  return Bs(n) ? [n] : aF(n) ? Ba(n) : Array.isArray(n) ? n : Ba(document.querySelectorAll(n));
}
function Gc(n, e) {
  n.forEach(function(t) {
    t && (t.style.transitionDuration = e + "ms");
  });
}
function tv(n, e) {
  n.forEach(function(t) {
    t && t.setAttribute("data-state", e);
  });
}
function dF(n) {
  var e, t = hi(n), r = t[0];
  return r != null && (e = r.ownerDocument) != null && e.body ? r.ownerDocument : document;
}
function fF(n, e) {
  var t = e.clientX, r = e.clientY;
  return n.every(function(i) {
    var s = i.popperRect, o = i.popperState, a = i.props, l = a.interactiveBorder, u = oF(o.placement), c = o.modifiersData.offset;
    if (!c)
      return !0;
    var f = u === "bottom" ? c.top.y : 0, p = u === "top" ? c.bottom.y : 0, d = u === "right" ? c.left.x : 0, h = u === "left" ? c.right.x : 0, v = s.top - r + f > l, g = r - s.bottom - p > l, m = s.left - t + d > l, _ = t - s.right - h > l;
    return v || g || m || _;
  });
}
function Kc(n, e, t) {
  var r = e + "EventListener";
  ["transitionend", "webkitTransitionEnd"].forEach(function(i) {
    n[r](i, t);
  });
}
function nv(n, e) {
  for (var t = e; t; ) {
    var r;
    if (n.contains(t))
      return !0;
    t = t.getRootNode == null || (r = t.getRootNode()) == null ? void 0 : r.host;
  }
  return !1;
}
var mn = {
  isTouch: !1
}, rv = 0;
function pF() {
  mn.isTouch || (mn.isTouch = !0, window.performance && document.addEventListener("mousemove", Dw));
}
function Dw() {
  var n = performance.now();
  n - rv < 20 && (mn.isTouch = !1, document.removeEventListener("mousemove", Dw)), rv = n;
}
function hF() {
  var n = document.activeElement;
  if (uF(n)) {
    var e = n._tippy;
    n.blur && !e.state.isVisible && n.blur();
  }
}
function mF() {
  document.addEventListener("touchstart", pF, Sr), window.addEventListener("blur", hF);
}
var gF = typeof window < "u" && typeof document < "u", vF = gF ? !!window.msCrypto : !1;
function ai(n) {
  var e = n === "destroy" ? "n already-" : " ";
  return [n + "() was called on a" + e + "destroyed instance. This is a no-op but", "indicates a potential memory leak."].join(" ");
}
function iv(n) {
  var e = /[ \t]{2,}/g, t = /^[ \t]*/gm;
  return n.replace(e, " ").replace(t, "").trim();
}
function yF(n) {
  return iv(`
  %ctippy.js

  %c` + iv(n) + `

  %c\u{1F477}\u200D This is a development-only message. It will be removed in production.
  `);
}
function Lw(n) {
  return [
    yF(n),
    "color: #00C584; font-size: 1.3em; font-weight: bold;",
    "line-height: 1.5",
    "color: #a6a095;"
  ];
}
var js;
process.env.NODE_ENV !== "production" && bF();
function bF() {
  js = /* @__PURE__ */ new Set();
}
function $n(n, e) {
  if (n && !js.has(e)) {
    var t;
    js.add(e), (t = console).warn.apply(t, Lw(e));
  }
}
function sf(n, e) {
  if (n && !js.has(e)) {
    var t;
    js.add(e), (t = console).error.apply(t, Lw(e));
  }
}
function wF(n) {
  var e = !n, t = Object.prototype.toString.call(n) === "[object Object]" && !n.addEventListener;
  sf(e, ["tippy() was passed", "`" + String(n) + "`", "as its targets (first) argument. Valid types are: String, Element,", "Element[], or NodeList."].join(" ")), sf(t, ["tippy() was passed a plain object which is not supported as an argument", "for virtual positioning. Use props.getReferenceClientRect instead."].join(" "));
}
var Nw = {
  animateFill: !1,
  followCursor: !1,
  inlinePositioning: !1,
  sticky: !1
}, _F = {
  allowHTML: !1,
  animation: "fade",
  arrow: !0,
  content: "",
  inertia: !1,
  maxWidth: 350,
  role: "tooltip",
  theme: "",
  zIndex: 9999
}, Pt = Object.assign({
  appendTo: Pw,
  aria: {
    content: "auto",
    expanded: "auto"
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: !0,
  ignoreAttributes: !1,
  interactive: !1,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: "",
  offset: [0, 10],
  onAfterUpdate: function() {
  },
  onBeforeUpdate: function() {
  },
  onCreate: function() {
  },
  onDestroy: function() {
  },
  onHidden: function() {
  },
  onHide: function() {
  },
  onMount: function() {
  },
  onShow: function() {
  },
  onShown: function() {
  },
  onTrigger: function() {
  },
  onUntrigger: function() {
  },
  onClickOutside: function() {
  },
  placement: "top",
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: !1,
  touch: !0,
  trigger: "mouseenter focus",
  triggerTarget: null
}, Nw, _F), SF = Object.keys(Pt), xF = function(e) {
  process.env.NODE_ENV !== "production" && Rw(e, []);
  var t = Object.keys(e);
  t.forEach(function(r) {
    Pt[r] = e[r];
  });
};
function Iw(n) {
  var e = n.plugins || [], t = e.reduce(function(r, i) {
    var s = i.name, o = i.defaultValue;
    if (s) {
      var a;
      r[s] = n[s] !== void 0 ? n[s] : (a = Pt[s]) != null ? a : o;
    }
    return r;
  }, {});
  return Object.assign({}, n, t);
}
function CF(n, e) {
  var t = e ? Object.keys(Iw(Object.assign({}, Pt, {
    plugins: e
  }))) : SF, r = t.reduce(function(i, s) {
    var o = (n.getAttribute("data-tippy-" + s) || "").trim();
    if (!o)
      return i;
    if (s === "content")
      i[s] = o;
    else
      try {
        i[s] = JSON.parse(o);
      } catch {
        i[s] = o;
      }
    return i;
  }, {});
  return r;
}
function sv(n, e) {
  var t = Object.assign({}, e, {
    content: $w(e.content, [n])
  }, e.ignoreAttributes ? {} : CF(n, e.plugins));
  return t.aria = Object.assign({}, Pt.aria, t.aria), t.aria = {
    expanded: t.aria.expanded === "auto" ? e.interactive : t.aria.expanded,
    content: t.aria.content === "auto" ? e.interactive ? null : "describedby" : t.aria.content
  }, t;
}
function Rw(n, e) {
  n === void 0 && (n = {}), e === void 0 && (e = []);
  var t = Object.keys(n);
  t.forEach(function(r) {
    var i = rF(Pt, Object.keys(Nw)), s = !nF(i, r);
    s && (s = e.filter(function(o) {
      return o.name === r;
    }).length === 0), $n(s, ["`" + r + "`", "is not a valid prop. You may have spelled it incorrectly, or if it's", "a plugin, forgot to pass it in an array as props.plugins.", `

`, `All props: https://atomiks.github.io/tippyjs/v6/all-props/
`, "Plugins: https://atomiks.github.io/tippyjs/v6/plugins/"].join(" "));
  });
}
var OF = function() {
  return "innerHTML";
};
function of(n, e) {
  n[OF()] = e;
}
function ov(n) {
  var e = Ss();
  return n === !0 ? e.className = Mw : (e.className = Aw, Bs(n) ? e.appendChild(n) : of(e, n)), e;
}
function av(n, e) {
  Bs(e.content) ? (of(n, ""), n.appendChild(e.content)) : typeof e.content != "function" && (e.allowHTML ? of(n, e.content) : n.textContent = e.content);
}
function af(n) {
  var e = n.firstElementChild, t = Ba(e.children);
  return {
    box: e,
    content: t.find(function(r) {
      return r.classList.contains(kw);
    }),
    arrow: t.find(function(r) {
      return r.classList.contains(Mw) || r.classList.contains(Aw);
    }),
    backdrop: t.find(function(r) {
      return r.classList.contains(tF);
    })
  };
}
function Fw(n) {
  var e = Ss(), t = Ss();
  t.className = eF, t.setAttribute("data-state", "hidden"), t.setAttribute("tabindex", "-1");
  var r = Ss();
  r.className = kw, r.setAttribute("data-state", "hidden"), av(r, n.props), e.appendChild(t), t.appendChild(r), i(n.props, n.props);
  function i(s, o) {
    var a = af(e), l = a.box, u = a.content, c = a.arrow;
    o.theme ? l.setAttribute("data-theme", o.theme) : l.removeAttribute("data-theme"), typeof o.animation == "string" ? l.setAttribute("data-animation", o.animation) : l.removeAttribute("data-animation"), o.inertia ? l.setAttribute("data-inertia", "") : l.removeAttribute("data-inertia"), l.style.maxWidth = typeof o.maxWidth == "number" ? o.maxWidth + "px" : o.maxWidth, o.role ? l.setAttribute("role", o.role) : l.removeAttribute("role"), (s.content !== o.content || s.allowHTML !== o.allowHTML) && av(u, n.props), o.arrow ? c ? s.arrow !== o.arrow && (l.removeChild(c), l.appendChild(ov(o.arrow))) : l.appendChild(ov(o.arrow)) : c && l.removeChild(c);
  }
  return {
    popper: e,
    onUpdate: i
  };
}
Fw.$$tippy = !0;
var EF = 1, Do = [], Jc = [];
function TF(n, e) {
  var t = sv(n, Object.assign({}, Pt, Iw(ev(e)))), r, i, s, o = !1, a = !1, l = !1, u = !1, c, f, p, d = [], h = Qg(Je, t.interactiveDebounce), v, g = EF++, m = null, _ = sF(t.plugins), y = {
    isEnabled: !0,
    isVisible: !1,
    isDestroyed: !1,
    isMounted: !1,
    isShown: !1
  }, w = {
    id: g,
    reference: n,
    popper: Ss(),
    popperInstance: m,
    props: t,
    state: y,
    plugins: _,
    clearDelayTimeouts: En,
    setProps: Bn,
    setContent: Bt,
    show: Qi,
    hide: ei,
    hideWithInteractivity: jn,
    enable: un,
    disable: zn,
    unmount: K,
    destroy: oe
  };
  if (!t.render)
    return process.env.NODE_ENV !== "production" && sf(!0, "render() function has not been supplied."), w;
  var O = t.render(w), C = O.popper, S = O.onUpdate;
  C.setAttribute("data-tippy-root", ""), C.id = "tippy-" + w.id, w.popper = C, n._tippy = w, C._tippy = w;
  var b = _.map(function(N) {
    return N.fn(w);
  }), x = n.hasAttribute("aria-expanded");
  return Oe(), Q(), Y(), z("onCreate", [w]), t.showOnCreate && ln(), C.addEventListener("mouseenter", function() {
    w.props.interactive && w.state.isVisible && w.clearDelayTimeouts();
  }), C.addEventListener("mouseleave", function() {
    w.props.interactive && w.props.trigger.indexOf("mouseenter") >= 0 && J().addEventListener("mousemove", h);
  }), w;
  function E() {
    var N = w.props.touch;
    return Array.isArray(N) ? N : [N, 0];
  }
  function M() {
    return E()[0] === "hold";
  }
  function $() {
    var N;
    return !!((N = w.props.render) != null && N.$$tippy);
  }
  function F() {
    return v || n;
  }
  function J() {
    var N = F().parentNode;
    return N ? dF(N) : document;
  }
  function W() {
    return af(C);
  }
  function H(N) {
    return w.state.isMounted && !w.state.isVisible || mn.isTouch || c && c.type === "focus" ? 0 : Uc(w.props.delay, N ? 0 : 1, Pt.delay);
  }
  function Y(N) {
    N === void 0 && (N = !1), C.style.pointerEvents = w.props.interactive && !N ? "" : "none", C.style.zIndex = "" + w.props.zIndex;
  }
  function z(N, q, k) {
    if (k === void 0 && (k = !0), b.forEach(function(P) {
      P[N] && P[N].apply(P, q);
    }), k) {
      var A;
      (A = w.props)[N].apply(A, q);
    }
  }
  function j() {
    var N = w.props.aria;
    if (!!N.content) {
      var q = "aria-" + N.content, k = C.id, A = hi(w.props.triggerTarget || n);
      A.forEach(function(P) {
        var L = P.getAttribute(q);
        if (w.state.isVisible)
          P.setAttribute(q, L ? L + " " + k : k);
        else {
          var B = L && L.replace(k, "").trim();
          B ? P.setAttribute(q, B) : P.removeAttribute(q);
        }
      });
    }
  }
  function Q() {
    if (!(x || !w.props.aria.expanded)) {
      var N = hi(w.props.triggerTarget || n);
      N.forEach(function(q) {
        w.props.interactive ? q.setAttribute("aria-expanded", w.state.isVisible && q === F() ? "true" : "false") : q.removeAttribute("aria-expanded");
      });
    }
  }
  function fe() {
    J().removeEventListener("mousemove", h), Do = Do.filter(function(N) {
      return N !== h;
    });
  }
  function ue(N) {
    if (!(mn.isTouch && (l || N.type === "mousedown"))) {
      var q = N.composedPath && N.composedPath()[0] || N.target;
      if (!(w.props.interactive && nv(C, q))) {
        if (hi(w.props.triggerTarget || n).some(function(k) {
          return nv(k, q);
        })) {
          if (mn.isTouch || w.state.isVisible && w.props.trigger.indexOf("click") >= 0)
            return;
        } else
          z("onClickOutside", [w, N]);
        w.props.hideOnClick === !0 && (w.clearDelayTimeouts(), w.hide(), a = !0, setTimeout(function() {
          a = !1;
        }), w.state.isMounted || T());
      }
    }
  }
  function ae() {
    l = !0;
  }
  function ye() {
    l = !1;
  }
  function re() {
    var N = J();
    N.addEventListener("mousedown", ue, !0), N.addEventListener("touchend", ue, Sr), N.addEventListener("touchstart", ye, Sr), N.addEventListener("touchmove", ae, Sr);
  }
  function T() {
    var N = J();
    N.removeEventListener("mousedown", ue, !0), N.removeEventListener("touchend", ue, Sr), N.removeEventListener("touchstart", ye, Sr), N.removeEventListener("touchmove", ae, Sr);
  }
  function D(N, q) {
    I(N, function() {
      !w.state.isVisible && C.parentNode && C.parentNode.contains(C) && q();
    });
  }
  function R(N, q) {
    I(N, q);
  }
  function I(N, q) {
    var k = W().box;
    function A(P) {
      P.target === k && (Kc(k, "remove", A), q());
    }
    if (N === 0)
      return q();
    Kc(k, "remove", f), Kc(k, "add", A), f = A;
  }
  function se(N, q, k) {
    k === void 0 && (k = !1);
    var A = hi(w.props.triggerTarget || n);
    A.forEach(function(P) {
      P.addEventListener(N, q, k), d.push({
        node: P,
        eventType: N,
        handler: q,
        options: k
      });
    });
  }
  function Oe() {
    M() && (se("touchstart", Re, {
      passive: !0
    }), se("touchend", Ee, {
      passive: !0
    })), iF(w.props.trigger).forEach(function(N) {
      if (N !== "manual")
        switch (se(N, Re), N) {
          case "mouseenter":
            se("mouseleave", Ee);
            break;
          case "focus":
            se(vF ? "focusout" : "blur", Fe);
            break;
          case "focusin":
            se("focusout", Fe);
            break;
        }
    });
  }
  function Me() {
    d.forEach(function(N) {
      var q = N.node, k = N.eventType, A = N.handler, P = N.options;
      q.removeEventListener(k, A, P);
    }), d = [];
  }
  function Re(N) {
    var q, k = !1;
    if (!(!w.state.isEnabled || Ft(N) || a)) {
      var A = ((q = c) == null ? void 0 : q.type) === "focus";
      c = N, v = N.currentTarget, Q(), !w.state.isVisible && lF(N) && Do.forEach(function(P) {
        return P(N);
      }), N.type === "click" && (w.props.trigger.indexOf("mouseenter") < 0 || o) && w.props.hideOnClick !== !1 && w.state.isVisible ? k = !0 : ln(N), N.type === "click" && (o = !k), k && !A && en(N);
    }
  }
  function Je(N) {
    var q = N.target, k = F().contains(q) || C.contains(q);
    if (!(N.type === "mousemove" && k)) {
      var A = Te().concat(C).map(function(P) {
        var L, B = P._tippy, U = (L = B.popperInstance) == null ? void 0 : L.state;
        return U ? {
          popperRect: P.getBoundingClientRect(),
          popperState: U,
          props: t
        } : null;
      }).filter(Boolean);
      fF(A, N) && (fe(), en(N));
    }
  }
  function Ee(N) {
    var q = Ft(N) || w.props.trigger.indexOf("click") >= 0 && o;
    if (!q) {
      if (w.props.interactive) {
        w.hideWithInteractivity(N);
        return;
      }
      en(N);
    }
  }
  function Fe(N) {
    w.props.trigger.indexOf("focusin") < 0 && N.target !== F() || w.props.interactive && N.relatedTarget && C.contains(N.relatedTarget) || en(N);
  }
  function Ft(N) {
    return mn.isTouch ? M() !== N.type.indexOf("touch") >= 0 : !1;
  }
  function zt() {
    Fn();
    var N = w.props, q = N.popperOptions, k = N.placement, A = N.offset, P = N.getReferenceClientRect, L = N.moveTransition, B = $() ? af(C).arrow : null, U = P ? {
      getBoundingClientRect: P,
      contextElement: P.contextElement || F()
    } : n, ie = {
      name: "$$tippy",
      enabled: !0,
      phase: "beforeWrite",
      requires: ["computeStyles"],
      fn: function(De) {
        var He = De.state;
        if ($()) {
          var Tt = W(), jt = Tt.box;
          ["placement", "reference-hidden", "escaped"].forEach(function(cn) {
            cn === "placement" ? jt.setAttribute("data-placement", He.placement) : He.attributes.popper["data-popper-" + cn] ? jt.setAttribute("data-" + cn, "") : jt.removeAttribute("data-" + cn);
          }), He.attributes.popper = {};
        }
      }
    }, ce = [{
      name: "offset",
      options: {
        offset: A
      }
    }, {
      name: "preventOverflow",
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: "flip",
      options: {
        padding: 5
      }
    }, {
      name: "computeStyles",
      options: {
        adaptive: !L
      }
    }, ie];
    $() && B && ce.push({
      name: "arrow",
      options: {
        element: B,
        padding: 3
      }
    }), ce.push.apply(ce, (q == null ? void 0 : q.modifiers) || []), w.popperInstance = ZR(U, C, Object.assign({}, q, {
      placement: k,
      onFirstUpdate: p,
      modifiers: ce
    }));
  }
  function Fn() {
    w.popperInstance && (w.popperInstance.destroy(), w.popperInstance = null);
  }
  function wt() {
    var N = w.props.appendTo, q, k = F();
    w.props.interactive && N === Pw || N === "parent" ? q = k.parentNode : q = $w(N, [k]), q.contains(C) || q.appendChild(C), w.state.isMounted = !0, zt(), process.env.NODE_ENV !== "production" && $n(w.props.interactive && N === Pt.appendTo && k.nextElementSibling !== C, ["Interactive tippy element may not be accessible via keyboard", "navigation because it is not directly after the reference element", "in the DOM source order.", `

`, "Using a wrapper <div> or <span> tag around the reference element", "solves this by creating a new parentNode context.", `

`, "Specifying `appendTo: document.body` silences this warning, but it", "assumes you are using a focus management solution to handle", "keyboard navigation.", `

`, "See: https://atomiks.github.io/tippyjs/v6/accessibility/#interactivity"].join(" "));
  }
  function Te() {
    return Ba(C.querySelectorAll("[data-tippy-root]"));
  }
  function ln(N) {
    w.clearDelayTimeouts(), N && z("onTrigger", [w, N]), re();
    var q = H(!0), k = E(), A = k[0], P = k[1];
    mn.isTouch && A === "hold" && P && (q = P), q ? r = setTimeout(function() {
      w.show();
    }, q) : w.show();
  }
  function en(N) {
    if (w.clearDelayTimeouts(), z("onUntrigger", [w, N]), !w.state.isVisible) {
      T();
      return;
    }
    if (!(w.props.trigger.indexOf("mouseenter") >= 0 && w.props.trigger.indexOf("click") >= 0 && ["mouseleave", "mousemove"].indexOf(N.type) >= 0 && o)) {
      var q = H(!1);
      q ? i = setTimeout(function() {
        w.state.isVisible && w.hide();
      }, q) : s = requestAnimationFrame(function() {
        w.hide();
      });
    }
  }
  function un() {
    w.state.isEnabled = !0;
  }
  function zn() {
    w.hide(), w.state.isEnabled = !1;
  }
  function En() {
    clearTimeout(r), clearTimeout(i), cancelAnimationFrame(s);
  }
  function Bn(N) {
    if (process.env.NODE_ENV !== "production" && $n(w.state.isDestroyed, ai("setProps")), !w.state.isDestroyed) {
      z("onBeforeUpdate", [w, N]), Me();
      var q = w.props, k = sv(n, Object.assign({}, q, ev(N), {
        ignoreAttributes: !0
      }));
      w.props = k, Oe(), q.interactiveDebounce !== k.interactiveDebounce && (fe(), h = Qg(Je, k.interactiveDebounce)), q.triggerTarget && !k.triggerTarget ? hi(q.triggerTarget).forEach(function(A) {
        A.removeAttribute("aria-expanded");
      }) : k.triggerTarget && n.removeAttribute("aria-expanded"), Q(), Y(), S && S(q, k), w.popperInstance && (zt(), Te().forEach(function(A) {
        requestAnimationFrame(A._tippy.popperInstance.forceUpdate);
      })), z("onAfterUpdate", [w, N]);
    }
  }
  function Bt(N) {
    w.setProps({
      content: N
    });
  }
  function Qi() {
    process.env.NODE_ENV !== "production" && $n(w.state.isDestroyed, ai("show"));
    var N = w.state.isVisible, q = w.state.isDestroyed, k = !w.state.isEnabled, A = mn.isTouch && !w.props.touch, P = Uc(w.props.duration, 0, Pt.duration);
    if (!(N || q || k || A) && !F().hasAttribute("disabled") && (z("onShow", [w], !1), w.props.onShow(w) !== !1)) {
      if (w.state.isVisible = !0, $() && (C.style.visibility = "visible"), Y(), re(), w.state.isMounted || (C.style.transition = "none"), $()) {
        var L = W(), B = L.box, U = L.content;
        Gc([B, U], 0);
      }
      p = function() {
        var ce;
        if (!(!w.state.isVisible || u)) {
          if (u = !0, C.offsetHeight, C.style.transition = w.props.moveTransition, $() && w.props.animation) {
            var _e = W(), De = _e.box, He = _e.content;
            Gc([De, He], P), tv([De, He], "visible");
          }
          j(), Q(), Zg(Jc, w), (ce = w.popperInstance) == null || ce.forceUpdate(), z("onMount", [w]), w.props.animation && $() && R(P, function() {
            w.state.isShown = !0, z("onShown", [w]);
          });
        }
      }, wt();
    }
  }
  function ei() {
    process.env.NODE_ENV !== "production" && $n(w.state.isDestroyed, ai("hide"));
    var N = !w.state.isVisible, q = w.state.isDestroyed, k = !w.state.isEnabled, A = Uc(w.props.duration, 1, Pt.duration);
    if (!(N || q || k) && (z("onHide", [w], !1), w.props.onHide(w) !== !1)) {
      if (w.state.isVisible = !1, w.state.isShown = !1, u = !1, o = !1, $() && (C.style.visibility = "hidden"), fe(), T(), Y(!0), $()) {
        var P = W(), L = P.box, B = P.content;
        w.props.animation && (Gc([L, B], A), tv([L, B], "hidden"));
      }
      j(), Q(), w.props.animation ? $() && D(A, w.unmount) : w.unmount();
    }
  }
  function jn(N) {
    process.env.NODE_ENV !== "production" && $n(w.state.isDestroyed, ai("hideWithInteractivity")), J().addEventListener("mousemove", h), Zg(Do, h), h(N);
  }
  function K() {
    process.env.NODE_ENV !== "production" && $n(w.state.isDestroyed, ai("unmount")), w.state.isVisible && w.hide(), w.state.isMounted && (Fn(), Te().forEach(function(N) {
      N._tippy.unmount();
    }), C.parentNode && C.parentNode.removeChild(C), Jc = Jc.filter(function(N) {
      return N !== w;
    }), w.state.isMounted = !1, z("onHidden", [w]));
  }
  function oe() {
    process.env.NODE_ENV !== "production" && $n(w.state.isDestroyed, ai("destroy")), !w.state.isDestroyed && (w.clearDelayTimeouts(), w.unmount(), Me(), delete n._tippy, w.state.isDestroyed = !0, z("onDestroy", [w]));
  }
}
function so(n, e) {
  e === void 0 && (e = {});
  var t = Pt.plugins.concat(e.plugins || []);
  process.env.NODE_ENV !== "production" && (wF(n), Rw(e, t)), mF();
  var r = Object.assign({}, e, {
    plugins: t
  }), i = cF(n);
  if (process.env.NODE_ENV !== "production") {
    var s = Bs(r.content), o = i.length > 1;
    $n(s && o, ["tippy() was passed an Element as the `content` prop, but more than", "one tippy instance was created by this invocation. This means the", "content element will only be appended to the last tippy instance.", `

`, "Instead, pass the .innerHTML of the element, or use a function that", "returns a cloned version of the element instead.", `

`, `1) content: element.innerHTML
`, "2) content: () => element.cloneNode(true)"].join(" "));
  }
  var a = i.reduce(function(l, u) {
    var c = u && TF(u, r);
    return c && l.push(c), l;
  }, []);
  return Bs(n) ? a[0] : a;
}
so.defaultProps = Pt;
so.setDefaultProps = xF;
so.currentInput = mn;
Object.assign({}, ww, {
  effect: function(e) {
    var t = e.state, r = {
      popper: {
        position: t.options.strategy,
        left: "0",
        top: "0",
        margin: "0"
      },
      arrow: {
        position: "absolute"
      },
      reference: {}
    };
    Object.assign(t.elements.popper.style, r.popper), t.styles = r, t.elements.arrow && Object.assign(t.elements.arrow.style, r.arrow);
  }
});
so.setDefaultProps({
  render: Fw
});
class kF {
  constructor({ editor: e, element: t, view: r, tippyOptions: i = {}, updateDelay: s = 250, shouldShow: o }) {
    this.preventHide = !1, this.shouldShow = ({ view: a, state: l, from: u, to: c }) => {
      const { doc: f, selection: p } = l, { empty: d } = p, h = !f.textBetween(u, c).length && _p(l.selection), v = this.element.contains(document.activeElement);
      return !(!(a.hasFocus() || v) || d || h || !this.editor.isEditable);
    }, this.mousedownHandler = () => {
      this.preventHide = !0;
    }, this.dragstartHandler = () => {
      this.hide();
    }, this.focusHandler = () => {
      setTimeout(() => this.update(this.editor.view));
    }, this.blurHandler = ({ event: a }) => {
      var l;
      if (this.preventHide) {
        this.preventHide = !1;
        return;
      }
      (a == null ? void 0 : a.relatedTarget) && ((l = this.element.parentNode) === null || l === void 0 ? void 0 : l.contains(a.relatedTarget)) || this.hide();
    }, this.tippyBlurHandler = (a) => {
      this.blurHandler({ event: a });
    }, this.handleDebouncedUpdate = (a, l) => {
      const u = !(l != null && l.selection.eq(a.state.selection)), c = !(l != null && l.doc.eq(a.state.doc));
      !u && !c || (this.updateDebounceTimer && clearTimeout(this.updateDebounceTimer), this.updateDebounceTimer = window.setTimeout(() => {
        this.updateHandler(a, u, c, l);
      }, this.updateDelay));
    }, this.updateHandler = (a, l, u, c) => {
      var f, p, d;
      const { state: h, composing: v } = a, { selection: g } = h;
      if (v || !l && !u)
        return;
      this.createTooltip();
      const { ranges: _ } = g, y = Math.min(..._.map((C) => C.$from.pos)), w = Math.max(..._.map((C) => C.$to.pos));
      if (!((f = this.shouldShow) === null || f === void 0 ? void 0 : f.call(this, {
        editor: this.editor,
        view: a,
        state: h,
        oldState: c,
        from: y,
        to: w
      }))) {
        this.hide();
        return;
      }
      (p = this.tippy) === null || p === void 0 || p.setProps({
        getReferenceClientRect: ((d = this.tippyOptions) === null || d === void 0 ? void 0 : d.getReferenceClientRect) || (() => {
          if (vI(h.selection)) {
            let C = a.nodeDOM(y);
            const S = C.dataset.nodeViewWrapper ? C : C.querySelector("[data-node-view-wrapper]");
            if (S && (C = S.firstChild), C)
              return C.getBoundingClientRect();
          }
          return yI(a, y, w);
        })
      }), this.show();
    }, this.editor = e, this.element = t, this.view = r, this.updateDelay = s, o && (this.shouldShow = o), this.element.addEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.view.dom.addEventListener("dragstart", this.dragstartHandler), this.editor.on("focus", this.focusHandler), this.editor.on("blur", this.blurHandler), this.tippyOptions = i, this.element.remove(), this.element.style.visibility = "visible";
  }
  createTooltip() {
    const { element: e } = this.editor.options, t = !!e.parentElement;
    this.tippy || !t || (this.tippy = so(e, {
      duration: 0,
      getReferenceClientRect: null,
      content: this.element,
      interactive: !0,
      trigger: "manual",
      placement: "top",
      hideOnClick: "toggle",
      ...this.tippyOptions
    }), this.tippy.popper.firstChild && this.tippy.popper.firstChild.addEventListener("blur", this.tippyBlurHandler));
  }
  update(e, t) {
    const { state: r } = e, i = r.selection.$from.pos !== r.selection.$to.pos;
    if (this.updateDelay > 0 && i) {
      this.handleDebouncedUpdate(e, t);
      return;
    }
    const s = !(t != null && t.selection.eq(e.state.selection)), o = !(t != null && t.doc.eq(e.state.doc));
    this.updateHandler(e, s, o, t);
  }
  show() {
    var e;
    (e = this.tippy) === null || e === void 0 || e.show();
  }
  hide() {
    var e;
    (e = this.tippy) === null || e === void 0 || e.hide();
  }
  destroy() {
    var e, t;
    !((e = this.tippy) === null || e === void 0) && e.popper.firstChild && this.tippy.popper.firstChild.removeEventListener("blur", this.tippyBlurHandler), (t = this.tippy) === null || t === void 0 || t.destroy(), this.element.removeEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.view.dom.removeEventListener("dragstart", this.dragstartHandler), this.editor.off("focus", this.focusHandler), this.editor.off("blur", this.blurHandler);
  }
}
const zw = (n) => new lt({
  key: typeof n.pluginKey == "string" ? new Zt(n.pluginKey) : n.pluginKey,
  view: (e) => new kF({ view: e, ...n })
});
Ve.create({
  name: "bubbleMenu",
  addOptions() {
    return {
      element: null,
      tippyOptions: {},
      pluginKey: "bubbleMenu",
      updateDelay: void 0,
      shouldShow: null
    };
  },
  addProseMirrorPlugins() {
    return this.options.element ? [
      zw({
        pluginKey: this.options.pluginKey,
        editor: this.editor,
        element: this.options.element,
        tippyOptions: this.options.tippyOptions,
        updateDelay: this.options.updateDelay,
        shouldShow: this.options.shouldShow
      })
    ] : [];
  }
});
var Mn = {}, Ql = {}, bt = {}, Jr = {}, Zl = {};
Object.defineProperty(Zl, "__esModule", { value: !0 });
Zl.isInstanceOf = void 0;
const MF = (n) => (e) => {
  if (!(e instanceof n))
    return `value should be an instance of ${n.name}`;
};
Zl.isInstanceOf = MF;
var eu = {};
Object.defineProperty(eu, "__esModule", { value: !0 });
eu.isInteger = void 0;
const AF = (n) => {
  if (typeof n != "number" || !Number.isInteger(n))
    return "value should be an integer";
};
eu.isInteger = AF;
var tu = {};
Object.defineProperty(tu, "__esModule", { value: !0 });
tu.isOneOf = void 0;
const PF = (n) => (e) => {
  if (!n.includes(e))
    return `value should be one of "${n.join('", "')}"`;
};
tu.isOneOf = PF;
var nu = {};
Object.defineProperty(nu, "__esModule", { value: !0 });
nu.isSymbol = void 0;
const $F = (n) => {
  if (typeof n != "symbol")
    return "value should be a symbol";
};
nu.isSymbol = $F;
(function(n) {
  var e = mh && mh.__importDefault || function(l) {
    return l && l.__esModule ? l : { default: l };
  };
  Object.defineProperty(n, "__esModule", { value: !0 }), n.isSymbol = n.isOneOf = n.isInteger = n.isInstanceOf = n.vuePropValidator = void 0;
  const t = e(Nt);
  function r(l, ...u) {
    const c = l ? [...u, l] : u;
    if (c.length !== 0)
      return (f) => {
        for (const p of c) {
          const d = p(f);
          if (d)
            return typeof t.default == "object" && "util" in t.default ? t.default.util.warn(`${d} (received: '${String(f)}')`) : console.warn(`${d} (received: '${String(f)}')`), !1;
        }
        return !0;
      };
  }
  n.vuePropValidator = r;
  var i = Zl;
  Object.defineProperty(n, "isInstanceOf", { enumerable: !0, get: function() {
    return i.isInstanceOf;
  } });
  var s = eu;
  Object.defineProperty(n, "isInteger", { enumerable: !0, get: function() {
    return s.isInteger;
  } });
  var o = tu;
  Object.defineProperty(n, "isOneOf", { enumerable: !0, get: function() {
    return o.isOneOf;
  } });
  var a = nu;
  Object.defineProperty(n, "isSymbol", { enumerable: !0, get: function() {
    return a.isSymbol;
  } });
})(Jr);
Object.defineProperty(bt, "__esModule", { value: !0 });
bt.propOptionsGenerator = void 0;
const Lo = Jr, DF = (n, e, ...t) => ({
  optional: {
    type: n,
    required: !1,
    default: void 0,
    validator: (0, Lo.vuePropValidator)(e, ...t)
  },
  nullable: {
    type: n,
    required: !1,
    default: null,
    validator: (0, Lo.vuePropValidator)(e, ...t)
  },
  withDefault: (r) => ({
    type: n,
    required: !1,
    default: r,
    validator: (0, Lo.vuePropValidator)(e, ...t)
  }),
  required: {
    type: n,
    required: !0,
    validator: (0, Lo.vuePropValidator)(e, ...t)
  }
});
bt.propOptionsGenerator = DF;
Object.defineProperty(Ql, "__esModule", { value: !0 });
Ql.stringProp = void 0;
const LF = bt, NF = (n) => (0, LF.propOptionsGenerator)(String, n);
Ql.stringProp = NF;
var ru = {};
Object.defineProperty(ru, "__esModule", { value: !0 });
ru.booleanProp = void 0;
const IF = bt, RF = (n) => (0, IF.propOptionsGenerator)(Boolean, n);
ru.booleanProp = RF;
var iu = {};
Object.defineProperty(iu, "__esModule", { value: !0 });
iu.numberProp = void 0;
const FF = bt, zF = (n) => (0, FF.propOptionsGenerator)(Number, n);
iu.numberProp = zF;
var su = {};
Object.defineProperty(su, "__esModule", { value: !0 });
su.integerProp = void 0;
const BF = bt, jF = Jr, VF = (n) => (0, BF.propOptionsGenerator)(Number, n, jF.isInteger);
su.integerProp = VF;
var ou = {};
Object.defineProperty(ou, "__esModule", { value: !0 });
ou.symbolProp = void 0;
const HF = bt, WF = Jr, qF = (n) => (0, HF.propOptionsGenerator)(void 0, n, WF.isSymbol);
ou.symbolProp = qF;
var au = {};
Object.defineProperty(au, "__esModule", { value: !0 });
au.vueComponentProp = void 0;
const UF = bt, GF = (n) => (0, UF.propOptionsGenerator)([Object, String], n);
au.vueComponentProp = GF;
var lu = {};
Object.defineProperty(lu, "__esModule", { value: !0 });
lu.anyProp = void 0;
const KF = bt, JF = (n) => (0, KF.propOptionsGenerator)(void 0, n);
lu.anyProp = JF;
var uu = {};
Object.defineProperty(uu, "__esModule", { value: !0 });
uu.arrayProp = void 0;
const XF = bt, YF = (n) => (0, XF.propOptionsGenerator)(Array, n);
uu.arrayProp = YF;
var cu = {};
Object.defineProperty(cu, "__esModule", { value: !0 });
cu.objectProp = void 0;
const QF = bt, ZF = (n) => (0, QF.propOptionsGenerator)(Object, n);
cu.objectProp = ZF;
var du = {};
Object.defineProperty(du, "__esModule", { value: !0 });
du.functionProp = void 0;
const Xc = Jr, e2 = (n) => ({
  optional: {
    type: Function,
    required: !1,
    default: void 0,
    validator: (0, Xc.vuePropValidator)(n)
  },
  nullable: {
    type: Function,
    required: !1,
    default: null,
    validator: (0, Xc.vuePropValidator)(n)
  },
  required: {
    type: Function,
    required: !0,
    validator: (0, Xc.vuePropValidator)(n)
  }
});
du.functionProp = e2;
var oo = {};
Object.defineProperty(oo, "__esModule", { value: !0 });
oo.oneOfProp = void 0;
const t2 = bt, n2 = Jr, r2 = (n) => {
  const e = [
    ...new Set(n.flatMap((t) => {
      var r;
      return t == null ? [] : (r = t.constructor) !== null && r !== void 0 ? r : [];
    }))
  ];
  if (e.length !== 0)
    return e.length === 1 ? e[0] : e;
}, i2 = (n, e) => (0, t2.propOptionsGenerator)(r2(n), e, (0, n2.isOneOf)(n));
oo.oneOfProp = i2;
var fu = {};
Object.defineProperty(fu, "__esModule", { value: !0 });
fu.oneOfObjectKeysProp = void 0;
const s2 = oo, o2 = (n, e) => (0, s2.oneOfProp)(Object.keys(n), e);
fu.oneOfObjectKeysProp = o2;
var pu = {};
Object.defineProperty(pu, "__esModule", { value: !0 });
pu.oneOfTypesProp = void 0;
const a2 = bt, l2 = (n, e) => (0, a2.propOptionsGenerator)(n, e);
pu.oneOfTypesProp = l2;
var hu = {};
Object.defineProperty(hu, "__esModule", { value: !0 });
hu.instanceOfProp = void 0;
const u2 = bt, c2 = Jr, d2 = (n, e) => (0, u2.propOptionsGenerator)(n, e, (0, c2.isInstanceOf)(n));
hu.instanceOfProp = d2;
var mu = {};
Object.defineProperty(mu, "__esModule", { value: !0 });
mu.isNegative = void 0;
const f2 = (n) => {
  if (typeof n != "number" || n >= 0 || Number.isNaN(n))
    return "value should be a negative number";
};
mu.isNegative = f2;
var gu = {};
Object.defineProperty(gu, "__esModule", { value: !0 });
gu.isPositive = void 0;
const p2 = (n) => {
  if (typeof n != "number" || n <= 0 || Number.isNaN(n))
    return "value should be a positive number";
};
gu.isPositive = p2;
var vu = {};
Object.defineProperty(vu, "__esModule", { value: !0 });
vu.isNonNegative = void 0;
const h2 = (n) => {
  if (typeof n != "number" || n < 0 || Number.isNaN(n))
    return "value should be a non-negative number";
};
vu.isNonNegative = h2;
var yu = {};
Object.defineProperty(yu, "__esModule", { value: !0 });
yu.isNonPositive = void 0;
const m2 = (n) => {
  if (typeof n != "number" || n > 0 || Number.isNaN(n))
    return "value should be a non-positive number";
};
yu.isNonPositive = m2;
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.isNonPositive = n.isNonNegative = n.isPositive = n.isNegative = n.instanceOfProp = n.oneOfTypesProp = n.oneOfObjectKeysProp = n.oneOfProp = n.functionProp = n.objectProp = n.arrayProp = n.anyProp = n.vueComponentProp = n.symbolProp = n.integerProp = n.numberProp = n.booleanProp = n.stringProp = void 0;
  var e = Ql;
  Object.defineProperty(n, "stringProp", { enumerable: !0, get: function() {
    return e.stringProp;
  } });
  var t = ru;
  Object.defineProperty(n, "booleanProp", { enumerable: !0, get: function() {
    return t.booleanProp;
  } });
  var r = iu;
  Object.defineProperty(n, "numberProp", { enumerable: !0, get: function() {
    return r.numberProp;
  } });
  var i = su;
  Object.defineProperty(n, "integerProp", { enumerable: !0, get: function() {
    return i.integerProp;
  } });
  var s = ou;
  Object.defineProperty(n, "symbolProp", { enumerable: !0, get: function() {
    return s.symbolProp;
  } });
  var o = au;
  Object.defineProperty(n, "vueComponentProp", { enumerable: !0, get: function() {
    return o.vueComponentProp;
  } });
  var a = lu;
  Object.defineProperty(n, "anyProp", { enumerable: !0, get: function() {
    return a.anyProp;
  } });
  var l = uu;
  Object.defineProperty(n, "arrayProp", { enumerable: !0, get: function() {
    return l.arrayProp;
  } });
  var u = cu;
  Object.defineProperty(n, "objectProp", { enumerable: !0, get: function() {
    return u.objectProp;
  } });
  var c = du;
  Object.defineProperty(n, "functionProp", { enumerable: !0, get: function() {
    return c.functionProp;
  } });
  var f = oo;
  Object.defineProperty(n, "oneOfProp", { enumerable: !0, get: function() {
    return f.oneOfProp;
  } });
  var p = fu;
  Object.defineProperty(n, "oneOfObjectKeysProp", { enumerable: !0, get: function() {
    return p.oneOfObjectKeysProp;
  } });
  var d = pu;
  Object.defineProperty(n, "oneOfTypesProp", { enumerable: !0, get: function() {
    return d.oneOfTypesProp;
  } });
  var h = hu;
  Object.defineProperty(n, "instanceOfProp", { enumerable: !0, get: function() {
    return h.instanceOfProp;
  } });
  var v = mu;
  Object.defineProperty(n, "isNegative", { enumerable: !0, get: function() {
    return v.isNegative;
  } });
  var g = gu;
  Object.defineProperty(n, "isPositive", { enumerable: !0, get: function() {
    return g.isPositive;
  } });
  var m = vu;
  Object.defineProperty(n, "isNonNegative", { enumerable: !0, get: function() {
    return m.isNonNegative;
  } });
  var _ = yu;
  Object.defineProperty(n, "isNonPositive", { enumerable: !0, get: function() {
    return _.isNonPositive;
  } });
})(Mn);
const g2 = {
  name: "BubbleMenu",
  props: {
    pluginKey: {
      type: [String, Object],
      default: "bubbleMenu"
    },
    editor: {
      type: Object,
      required: !0
    },
    updateDelay: {
      type: Number
    },
    tippyOptions: {
      type: Object,
      default: () => ({})
    },
    shouldShow: {
      type: Function,
      default: null
    }
  },
  watch: {
    editor: {
      immediate: !0,
      handler(n) {
        !n || this.$nextTick(() => {
          n.registerPlugin(zw({
            updateDelay: this.updateDelay,
            editor: n,
            element: this.$el,
            pluginKey: this.pluginKey,
            shouldShow: this.shouldShow,
            tippyOptions: this.tippyOptions
          }));
        });
      }
    }
  },
  render(n) {
    return n("div", { style: { visibility: "hidden" } }, this.$slots.default);
  },
  beforeDestroy() {
    this.editor.unregisterPlugin(this.pluginKey);
  }
};
class v2 extends gw {
  constructor() {
    super(...arguments), this.contentComponent = null;
  }
}
const Bw = {
  name: "EditorContent",
  props: {
    editor: {
      default: null,
      type: Object
    }
  },
  watch: {
    editor: {
      immediate: !0,
      handler(n) {
        n && n.options.element && this.$nextTick(() => {
          const e = this.$el;
          !e || !n.options.element.firstChild || (e.append(...n.options.element.childNodes), n.contentComponent = this, n.setOptions({
            element: e
          }), n.createNodeViews());
        });
      }
    }
  },
  render(n) {
    return n("div");
  },
  beforeDestroy() {
    const { editor: n } = this;
    if (!n || (n.isDestroyed || n.view.setProps({
      nodeViews: {}
    }), n.contentComponent = null, !n.options.element.firstChild))
      return;
    const e = document.createElement("div");
    e.append(...n.options.element.childNodes), n.setOptions({
      element: e
    });
  }
}, Ui = {
  props: {
    as: {
      type: String,
      default: "div"
    }
  },
  inject: ["onDragStart", "decorationClasses"],
  render(n) {
    return n(this.as, {
      class: this.decorationClasses.value,
      style: {
        whiteSpace: "normal"
      },
      attrs: {
        "data-node-view-wrapper": ""
      },
      on: {
        dragstart: this.onDragStart
      }
    }, this.$slots.default);
  }
};
class y2 {
  constructor(e, t) {
    const r = typeof e == "function" ? e : Ci.extend(e);
    this.ref = new r(t).$mount();
  }
  get element() {
    return this.ref.$el;
  }
  updateProps(e = {}) {
    var t, r, i;
    if (!this.ref.$props)
      return;
    const s = (i = (r = (t = this.ref.$props.editor) === null || t === void 0 ? void 0 : t.contentComponent) === null || r === void 0 ? void 0 : r.$options._base) !== null && i !== void 0 ? i : Ci, o = s.config.silent;
    s.config.silent = !0, Object.entries(e).forEach(([a, l]) => {
      this.ref.$props[a] = l;
    }), s.config.silent = o;
  }
  destroy() {
    this.ref.$destroy();
  }
}
const Gi = {
  editor: Mn.objectProp().required,
  node: Mn.objectProp().required,
  decorations: Mn.objectProp().required,
  selected: Mn.booleanProp().required,
  extension: Mn.objectProp().required,
  getPos: Mn.functionProp().required,
  updateAttributes: Mn.functionProp().required,
  deleteNode: Mn.functionProp().required
};
class b2 extends KI {
  mount() {
    var e, t;
    const r = {
      editor: this.editor,
      node: this.node,
      decorations: this.decorations,
      selected: !1,
      extension: this.extension,
      getPos: () => this.getPos(),
      updateAttributes: (a = {}) => this.updateAttributes(a),
      deleteNode: () => this.deleteNode()
    }, i = this.onDragStart.bind(this);
    this.decorationClasses = Ci.observable({
      value: this.getDecorationClasses()
    });
    const o = ((t = (e = this.editor.contentComponent) === null || e === void 0 ? void 0 : e.$options._base) !== null && t !== void 0 ? t : Ci).extend(this.component).extend({
      props: Object.keys(r),
      provide: () => ({
        onDragStart: i,
        decorationClasses: this.decorationClasses
      })
    });
    this.renderer = new y2(o, {
      parent: this.editor.contentComponent,
      propsData: r
    });
  }
  get dom() {
    if (!this.renderer.element.hasAttribute("data-node-view-wrapper"))
      throw Error("Please use the NodeViewWrapper component for your node view.");
    return this.renderer.element;
  }
  get contentDOM() {
    return this.node.isLeaf ? null : this.dom.querySelector("[data-node-view-content]") || this.dom;
  }
  update(e, t) {
    const r = (i) => {
      this.decorationClasses.value = this.getDecorationClasses(), this.renderer.updateProps(i);
    };
    if (typeof this.options.update == "function") {
      const i = this.node, s = this.decorations;
      return this.node = e, this.decorations = t, this.options.update({
        oldNode: i,
        oldDecorations: s,
        newNode: e,
        newDecorations: t,
        updateProps: () => r({ node: e, decorations: t })
      });
    }
    return e.type !== this.node.type ? !1 : (e === this.node && this.decorations === t || (this.node = e, this.decorations = t, r({ node: e, decorations: t })), !0);
  }
  selectNode() {
    this.renderer.updateProps({
      selected: !0
    }), this.renderer.element.classList.add("ProseMirror-selectednode");
  }
  deselectNode() {
    this.renderer.updateProps({
      selected: !1
    }), this.renderer.element.classList.remove("ProseMirror-selectednode");
  }
  getDecorationClasses() {
    return this.decorations.map((e) => e.type.attrs.class).flat().join(" ");
  }
  destroy() {
    this.renderer.destroy();
  }
}
function w2(n, e) {
  return (t) => t.editor.contentComponent ? new b2(n, t, e) : {};
}
const _2 = st({
  name: "RemoveCommand",
  components: { ButtonCommand: yt },
  setup() {
    const n = $e("editor");
    return { onRemove: () => {
      n == null || n.value.chain().focus().deleteSelection().run();
    } };
  }
});
var S2 = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("button-command", { attrs: { icon: "delete-bin-line", title: "Remove" }, on: { click: e.onRemove } });
}, x2 = [], C2 = /* @__PURE__ */ le(
  _2,
  S2,
  x2,
  !1,
  null,
  null,
  null,
  null
);
const O2 = C2.exports;
var jw = { exports: {} };
(function(n) {
  n.exports = function(e) {
    var t = {};
    function r(i) {
      if (t[i])
        return t[i].exports;
      var s = t[i] = {
        i,
        l: !1,
        exports: {}
      };
      return e[i].call(s.exports, s, s.exports, r), s.l = !0, s.exports;
    }
    return r.m = e, r.c = t, r.d = function(i, s, o) {
      r.o(i, s) || Object.defineProperty(i, s, { enumerable: !0, get: o });
    }, r.r = function(i) {
      typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(i, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(i, "__esModule", { value: !0 });
    }, r.t = function(i, s) {
      if (s & 1 && (i = r(i)), s & 8 || s & 4 && typeof i == "object" && i && i.__esModule)
        return i;
      var o = /* @__PURE__ */ Object.create(null);
      if (r.r(o), Object.defineProperty(o, "default", { enumerable: !0, value: i }), s & 2 && typeof i != "string")
        for (var a in i)
          r.d(o, a, function(l) {
            return i[l];
          }.bind(null, a));
      return o;
    }, r.n = function(i) {
      var s = i && i.__esModule ? function() {
        return i.default;
      } : function() {
        return i;
      };
      return r.d(s, "a", s), s;
    }, r.o = function(i, s) {
      return Object.prototype.hasOwnProperty.call(i, s);
    }, r.p = "/dist/", r(r.s = 100);
  }({
    0: function(e, t, r) {
      r.d(t, "a", function() {
        return i;
      });
      function i(s, o, a, l, u, c, f, p) {
        var d = typeof s == "function" ? s.options : s;
        o && (d.render = o, d.staticRenderFns = a, d._compiled = !0), l && (d.functional = !0), c && (d._scopeId = "data-v-" + c);
        var h;
        if (f ? (h = function(m) {
          m = m || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !m && typeof __VUE_SSR_CONTEXT__ < "u" && (m = __VUE_SSR_CONTEXT__), u && u.call(this, m), m && m._registeredComponents && m._registeredComponents.add(f);
        }, d._ssrRegister = h) : u && (h = p ? function() {
          u.call(this, this.$root.$options.shadowRoot);
        } : u), h)
          if (d.functional) {
            d._injectStyles = h;
            var v = d.render;
            d.render = function(_, y) {
              return h.call(y), v(_, y);
            };
          } else {
            var g = d.beforeCreate;
            d.beforeCreate = g ? [].concat(g, h) : [h];
          }
        return {
          exports: s,
          options: d
        };
      }
    },
    100: function(e, t, r) {
      r.r(t);
      var i = function() {
        var d = this, h = d.$createElement, v = d._self._c || h;
        return v(
          "form",
          {
            staticClass: "el-form",
            class: [
              d.labelPosition ? "el-form--label-" + d.labelPosition : "",
              { "el-form--inline": d.inline }
            ]
          },
          [d._t("default")],
          2
        );
      }, s = [];
      i._withStripped = !0;
      var o = r(9), a = /* @__PURE__ */ r.n(o), l = {
        name: "ElForm",
        componentName: "ElForm",
        provide: function() {
          return {
            elForm: this
          };
        },
        props: {
          model: Object,
          rules: Object,
          labelPosition: String,
          labelWidth: String,
          labelSuffix: {
            type: String,
            default: ""
          },
          inline: Boolean,
          inlineMessage: Boolean,
          statusIcon: Boolean,
          showMessage: {
            type: Boolean,
            default: !0
          },
          size: String,
          disabled: Boolean,
          validateOnRuleChange: {
            type: Boolean,
            default: !0
          },
          hideRequiredAsterisk: {
            type: Boolean,
            default: !1
          }
        },
        watch: {
          rules: function() {
            this.fields.forEach(function(h) {
              h.removeValidateEvents(), h.addValidateEvents();
            }), this.validateOnRuleChange && this.validate(function() {
            });
          }
        },
        computed: {
          autoLabelWidth: function() {
            if (!this.potentialLabelWidthArr.length)
              return 0;
            var h = Math.max.apply(Math, this.potentialLabelWidthArr);
            return h ? h + "px" : "";
          }
        },
        data: function() {
          return {
            fields: [],
            potentialLabelWidthArr: []
          };
        },
        created: function() {
          var h = this;
          this.$on("el.form.addField", function(v) {
            v && h.fields.push(v);
          }), this.$on("el.form.removeField", function(v) {
            v.prop && h.fields.splice(h.fields.indexOf(v), 1);
          });
        },
        methods: {
          resetFields: function() {
            if (!this.model) {
              console.warn("[Element Warn][Form]model is required for resetFields to work.");
              return;
            }
            this.fields.forEach(function(h) {
              h.resetField();
            });
          },
          clearValidate: function() {
            var h = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], v = h.length ? typeof h == "string" ? this.fields.filter(function(g) {
              return h === g.prop;
            }) : this.fields.filter(function(g) {
              return h.indexOf(g.prop) > -1;
            }) : this.fields;
            v.forEach(function(g) {
              g.clearValidate();
            });
          },
          validate: function(h) {
            var v = this;
            if (!this.model) {
              console.warn("[Element Warn][Form]model is required for validate to work!");
              return;
            }
            var g = void 0;
            typeof h != "function" && window.Promise && (g = new window.Promise(function(w, O) {
              h = function(S, b) {
                S ? w(S) : O(b);
              };
            }));
            var m = !0, _ = 0;
            this.fields.length === 0 && h && h(!0);
            var y = {};
            if (this.fields.forEach(function(w) {
              w.validate("", function(O, C) {
                O && (m = !1), y = a()({}, y, C), typeof h == "function" && ++_ === v.fields.length && h(m, y);
              });
            }), g)
              return g;
          },
          validateField: function(h, v) {
            h = [].concat(h);
            var g = this.fields.filter(function(m) {
              return h.indexOf(m.prop) !== -1;
            });
            if (!g.length) {
              console.warn("[Element Warn]please pass correct props!");
              return;
            }
            g.forEach(function(m) {
              m.validate("", v);
            });
          },
          getLabelWidthIndex: function(h) {
            var v = this.potentialLabelWidthArr.indexOf(h);
            if (v === -1)
              throw new Error("[ElementForm]unpected width ", h);
            return v;
          },
          registerLabelWidth: function(h, v) {
            if (h && v) {
              var g = this.getLabelWidthIndex(v);
              this.potentialLabelWidthArr.splice(g, 1, h);
            } else
              h && this.potentialLabelWidthArr.push(h);
          },
          deregisterLabelWidth: function(h) {
            var v = this.getLabelWidthIndex(h);
            this.potentialLabelWidthArr.splice(v, 1);
          }
        }
      }, u = l, c = r(0), f = Object(c.a)(
        u,
        i,
        s,
        !1,
        null,
        null,
        null
      );
      f.options.__file = "packages/form/src/form.vue";
      var p = f.exports;
      p.install = function(d) {
        d.component(p.name, p);
      }, t.default = p;
    },
    9: function(e, t) {
      e.exports = Cl();
    }
  });
})(jw);
const E2 = /* @__PURE__ */ ot(jw.exports);
var Vw = { exports: {} }, Hw = { exports: {} }, vr = { exports: {} }, T2 = vr.exports = typeof window < "u" && window.Math == Math ? window : typeof self < "u" && self.Math == Math ? self : Function("return this")();
typeof __g == "number" && (__g = T2);
var Ki = { exports: {} }, k2 = Ki.exports = { version: "2.6.12" };
typeof __e == "number" && (__e = k2);
var M2 = function(n) {
  if (typeof n != "function")
    throw TypeError(n + " is not a function!");
  return n;
}, A2 = M2, P2 = function(n, e, t) {
  if (A2(n), e === void 0)
    return n;
  switch (t) {
    case 1:
      return function(r) {
        return n.call(e, r);
      };
    case 2:
      return function(r, i) {
        return n.call(e, r, i);
      };
    case 3:
      return function(r, i, s) {
        return n.call(e, r, i, s);
      };
  }
  return function() {
    return n.apply(e, arguments);
  };
}, Xr = {}, ao = function(n) {
  return typeof n == "object" ? n !== null : typeof n == "function";
}, $2 = ao, bu = function(n) {
  if (!$2(n))
    throw TypeError(n + " is not an object!");
  return n;
}, lo = function(n) {
  try {
    return !!n();
  } catch {
    return !0;
  }
}, Yr = !lo(function() {
  return Object.defineProperty({}, "a", { get: function() {
    return 7;
  } }).a != 7;
}), Yc, lv;
function Ww() {
  if (lv)
    return Yc;
  lv = 1;
  var n = ao, e = vr.exports.document, t = n(e) && n(e.createElement);
  return Yc = function(r) {
    return t ? e.createElement(r) : {};
  }, Yc;
}
var qw = !Yr && !lo(function() {
  return Object.defineProperty(Ww()("div"), "a", { get: function() {
    return 7;
  } }).a != 7;
}), No = ao, Dp = function(n, e) {
  if (!No(n))
    return n;
  var t, r;
  if (e && typeof (t = n.toString) == "function" && !No(r = t.call(n)) || typeof (t = n.valueOf) == "function" && !No(r = t.call(n)) || !e && typeof (t = n.toString) == "function" && !No(r = t.call(n)))
    return r;
  throw TypeError("Can't convert object to primitive value");
}, uv = bu, D2 = qw, L2 = Dp, N2 = Object.defineProperty;
Xr.f = Yr ? Object.defineProperty : function(e, t, r) {
  if (uv(e), t = L2(t, !0), uv(r), D2)
    try {
      return N2(e, t, r);
    } catch {
    }
  if ("get" in r || "set" in r)
    throw TypeError("Accessors not supported!");
  return "value" in r && (e[t] = r.value), e;
};
var wu = function(n, e) {
  return {
    enumerable: !(n & 1),
    configurable: !(n & 2),
    writable: !(n & 4),
    value: e
  };
}, I2 = Xr, R2 = wu, Ji = Yr ? function(n, e, t) {
  return I2.f(n, e, R2(1, t));
} : function(n, e, t) {
  return n[e] = t, n;
}, F2 = {}.hasOwnProperty, Qr = function(n, e) {
  return F2.call(n, e);
}, Io = vr.exports, Qc = Ki.exports, cv = P2, z2 = Ji, B2 = Qr, Ro = "prototype", nt = function(n, e, t) {
  var r = n & nt.F, i = n & nt.G, s = n & nt.S, o = n & nt.P, a = n & nt.B, l = n & nt.W, u = i ? Qc : Qc[e] || (Qc[e] = {}), c = u[Ro], f = i ? Io : s ? Io[e] : (Io[e] || {})[Ro], p, d, h;
  i && (t = e);
  for (p in t)
    d = !r && f && f[p] !== void 0, !(d && B2(u, p)) && (h = d ? f[p] : t[p], u[p] = i && typeof f[p] != "function" ? t[p] : a && d ? cv(h, Io) : l && f[p] == h ? function(v) {
      var g = function(m, _, y) {
        if (this instanceof v) {
          switch (arguments.length) {
            case 0:
              return new v();
            case 1:
              return new v(m);
            case 2:
              return new v(m, _);
          }
          return new v(m, _, y);
        }
        return v.apply(this, arguments);
      };
      return g[Ro] = v[Ro], g;
    }(h) : o && typeof h == "function" ? cv(Function.call, h) : h, o && ((u.virtual || (u.virtual = {}))[p] = h, n & nt.R && c && !c[p] && z2(c, p, h)));
};
nt.F = 1;
nt.G = 2;
nt.S = 4;
nt.P = 8;
nt.B = 16;
nt.W = 32;
nt.U = 64;
nt.R = 128;
var Lp = nt, j2 = {}.toString, Uw = function(n) {
  return j2.call(n).slice(8, -1);
}, V2 = Uw, Gw = Object("z").propertyIsEnumerable(0) ? Object : function(n) {
  return V2(n) == "String" ? n.split("") : Object(n);
}, Np = function(n) {
  if (n == null)
    throw TypeError("Can't call method on  " + n);
  return n;
}, H2 = Gw, W2 = Np, Xi = function(n) {
  return H2(W2(n));
}, q2 = Math.ceil, U2 = Math.floor, Ip = function(n) {
  return isNaN(n = +n) ? 0 : (n > 0 ? U2 : q2)(n);
}, G2 = Ip, K2 = Math.min, J2 = function(n) {
  return n > 0 ? K2(G2(n), 9007199254740991) : 0;
}, X2 = Ip, Y2 = Math.max, Q2 = Math.min, Z2 = function(n, e) {
  return n = X2(n), n < 0 ? Y2(n + e, 0) : Q2(n, e);
}, ez = Xi, tz = J2, nz = Z2, rz = function(n) {
  return function(e, t, r) {
    var i = ez(e), s = tz(i.length), o = nz(r, s), a;
    if (n && t != t) {
      for (; s > o; )
        if (a = i[o++], a != a)
          return !0;
    } else
      for (; s > o; o++)
        if ((n || o in i) && i[o] === t)
          return n || o || 0;
    return !n && -1;
  };
}, _u = { exports: {} }, iz = !0, sz = Ki.exports, dv = vr.exports, fv = "__core-js_shared__", pv = dv[fv] || (dv[fv] = {});
(_u.exports = function(n, e) {
  return pv[n] || (pv[n] = e !== void 0 ? e : {});
})("versions", []).push({
  version: sz.version,
  mode: "pure",
  copyright: "\xA9 2020 Denis Pushkarev (zloirock.ru)"
});
var oz = 0, az = Math.random(), Su = function(n) {
  return "Symbol(".concat(n === void 0 ? "" : n, ")_", (++oz + az).toString(36));
}, hv = _u.exports("keys"), lz = Su, Rp = function(n) {
  return hv[n] || (hv[n] = lz(n));
}, mv = Qr, uz = Xi, cz = rz(!1), dz = Rp("IE_PROTO"), Kw = function(n, e) {
  var t = uz(n), r = 0, i = [], s;
  for (s in t)
    s != dz && mv(t, s) && i.push(s);
  for (; e.length > r; )
    mv(t, s = e[r++]) && (~cz(i, s) || i.push(s));
  return i;
}, Fp = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(","), fz = Kw, pz = Fp, xu = Object.keys || function(e) {
  return fz(e, pz);
}, Cu = {};
Cu.f = Object.getOwnPropertySymbols;
var uo = {};
uo.f = {}.propertyIsEnumerable;
var hz = Np, zp = function(n) {
  return Object(hz(n));
}, Zc, gv;
function mz() {
  if (gv)
    return Zc;
  gv = 1;
  var n = Yr, e = xu, t = Cu, r = uo, i = zp, s = Gw, o = Object.assign;
  return Zc = !o || lo(function() {
    var a = {}, l = {}, u = Symbol(), c = "abcdefghijklmnopqrst";
    return a[u] = 7, c.split("").forEach(function(f) {
      l[f] = f;
    }), o({}, a)[u] != 7 || Object.keys(o({}, l)).join("") != c;
  }) ? function(l, u) {
    for (var c = i(l), f = arguments.length, p = 1, d = t.f, h = r.f; f > p; )
      for (var v = s(arguments[p++]), g = d ? e(v).concat(d(v)) : e(v), m = g.length, _ = 0, y; m > _; )
        y = g[_++], (!n || h.call(v, y)) && (c[y] = v[y]);
    return c;
  } : o, Zc;
}
var ed = Lp;
ed(ed.S + ed.F, "Object", { assign: mz() });
var gz = Ki.exports.Object.assign;
(function(n) {
  n.exports = { default: gz, __esModule: !0 };
})(Hw);
var vz = Hw.exports, yz = bz(vz);
function bz(n) {
  return n && n.__esModule ? n : { default: n };
}
var ls = yz.default || function(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e];
    for (var r in t)
      Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
  }
  return n;
}, Jw = { exports: {} }, wz = Ip, _z = Np, Sz = function(n) {
  return function(e, t) {
    var r = String(_z(e)), i = wz(t), s = r.length, o, a;
    return i < 0 || i >= s ? n ? "" : void 0 : (o = r.charCodeAt(i), o < 55296 || o > 56319 || i + 1 === s || (a = r.charCodeAt(i + 1)) < 56320 || a > 57343 ? n ? r.charAt(i) : o : n ? r.slice(i, i + 2) : (o - 55296 << 10) + (a - 56320) + 65536);
  };
}, Bp = { exports: {} };
(function(n) {
  n.exports = Ji;
})(Bp);
var jp = {}, xz = Xr, Cz = bu, Oz = xu, Ez = Yr ? Object.defineProperties : function(e, t) {
  Cz(e);
  for (var r = Oz(t), i = r.length, s = 0, o; i > s; )
    xz.f(e, o = r[s++], t[o]);
  return e;
}, td, vv;
function Tz() {
  if (vv)
    return td;
  vv = 1;
  var n = vr.exports.document;
  return td = n && n.documentElement, td;
}
var kz = bu, Mz = Ez, yv = Fp, Az = Rp("IE_PROTO"), nd = function() {
}, lf = "prototype", sa = function() {
  var n = Ww()("iframe"), e = yv.length, t = "<", r = ">", i;
  for (n.style.display = "none", Tz().appendChild(n), n.src = "javascript:", i = n.contentWindow.document, i.open(), i.write(t + "script" + r + "document.F=Object" + t + "/script" + r), i.close(), sa = i.F; e--; )
    delete sa[lf][yv[e]];
  return sa();
}, Xw = Object.create || function(e, t) {
  var r;
  return e !== null ? (nd[lf] = kz(e), r = new nd(), nd[lf] = null, r[Az] = e) : r = sa(), t === void 0 ? r : Mz(r, t);
}, Zr = { exports: {} }, uf = _u.exports("wks"), Pz = Su, cf = vr.exports.Symbol, bv = typeof cf == "function", $z = Zr.exports = function(n) {
  return uf[n] || (uf[n] = bv && cf[n] || (bv ? cf : Pz)("Symbol." + n));
};
$z.store = uf;
var Dz = Xr.f, Lz = Qr, wv = Zr.exports("toStringTag"), Vp = function(n, e, t) {
  n && !Lz(n = t ? n : n.prototype, wv) && Dz(n, wv, { configurable: !0, value: e });
}, Nz = Xw, Iz = wu, Rz = Vp, Yw = {};
Ji(Yw, Zr.exports("iterator"), function() {
  return this;
});
var Fz = function(n, e, t) {
  n.prototype = Nz(Yw, { next: Iz(1, t) }), Rz(n, e + " Iterator");
}, zz = Qr, Bz = zp, _v = Rp("IE_PROTO"), jz = Object.prototype, Vz = Object.getPrototypeOf || function(n) {
  return n = Bz(n), zz(n, _v) ? n[_v] : typeof n.constructor == "function" && n instanceof n.constructor ? n.constructor.prototype : n instanceof Object ? jz : null;
}, rd = Lp, Hz = Bp.exports, Wz = Ji, Sv = jp, qz = Fz, Uz = Vp, Gz = Vz, id = Zr.exports("iterator"), sd = !([].keys && "next" in [].keys()), Kz = "@@iterator", xv = "keys", Fo = "values", Jz = function() {
  return this;
}, Qw = function(n, e, t, r, i, s, o) {
  qz(t, e, r);
  var a = function(y) {
    if (!sd && y in f)
      return f[y];
    switch (y) {
      case xv:
        return function() {
          return new t(this, y);
        };
      case Fo:
        return function() {
          return new t(this, y);
        };
    }
    return function() {
      return new t(this, y);
    };
  }, l = e + " Iterator", u = i == Fo, c = !1, f = n.prototype, p = f[id] || f[Kz] || i && f[i], d = p || a(i), h = i ? u ? a("entries") : d : void 0, v = e == "Array" && f.entries || p, g, m, _;
  if (v && (_ = Gz(v.call(new n())), _ !== Object.prototype && _.next && Uz(_, l, !0)), u && p && p.name !== Fo && (c = !0, d = function() {
    return p.call(this);
  }), o && (sd || c || !f[id]) && Wz(f, id, d), Sv[e] = d, Sv[l] = Jz, i)
    if (g = {
      values: u ? d : a(Fo),
      keys: s ? d : a(xv),
      entries: h
    }, o)
      for (m in g)
        m in f || Hz(f, m, g[m]);
    else
      rd(rd.P + rd.F * (sd || c), e, g);
  return g;
}, Xz = Sz(!0);
Qw(String, "String", function(n) {
  this._t = String(n), this._i = 0;
}, function() {
  var n = this._t, e = this._i, t;
  return e >= n.length ? { value: void 0, done: !0 } : (t = Xz(n, e), this._i += t.length, { value: t, done: !1 });
});
var Yz = function(n, e) {
  return { value: e, done: !!n };
}, zo = Yz, Cv = jp, Qz = Xi;
Qw(Array, "Array", function(n, e) {
  this._t = Qz(n), this._i = 0, this._k = e;
}, function() {
  var n = this._t, e = this._k, t = this._i++;
  return !n || t >= n.length ? (this._t = void 0, zo(1)) : e == "keys" ? zo(0, t) : e == "values" ? zo(0, n[t]) : zo(0, [t, n[t]]);
}, "values");
Cv.Arguments = Cv.Array;
var Zz = vr.exports, eB = Ji, Ov = jp, Ev = Zr.exports("toStringTag"), Tv = "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(",");
for (var od = 0; od < Tv.length; od++) {
  var ad = Tv[od], kv = Zz[ad], ld = kv && kv.prototype;
  ld && !ld[Ev] && eB(ld, Ev, ad), Ov[ad] = Ov.Array;
}
var Ou = {};
Ou.f = Zr.exports;
var tB = Ou.f("iterator");
(function(n) {
  n.exports = { default: tB, __esModule: !0 };
})(Jw);
var Zw = { exports: {} }, e_ = { exports: {} }, qr = Su("meta"), nB = ao, Hp = Qr, rB = Xr.f, iB = 0, Eu = Object.isExtensible || function() {
  return !0;
}, sB = !lo(function() {
  return Eu(Object.preventExtensions({}));
}), Wp = function(n) {
  rB(n, qr, { value: {
    i: "O" + ++iB,
    w: {}
  } });
}, oB = function(n, e) {
  if (!nB(n))
    return typeof n == "symbol" ? n : (typeof n == "string" ? "S" : "P") + n;
  if (!Hp(n, qr)) {
    if (!Eu(n))
      return "F";
    if (!e)
      return "E";
    Wp(n);
  }
  return n[qr].i;
}, aB = function(n, e) {
  if (!Hp(n, qr)) {
    if (!Eu(n))
      return !0;
    if (!e)
      return !1;
    Wp(n);
  }
  return n[qr].w;
}, lB = function(n) {
  return sB && uB.NEED && Eu(n) && !Hp(n, qr) && Wp(n), n;
}, uB = e_.exports = {
  KEY: qr,
  NEED: !1,
  fastKey: oB,
  getWeak: aB,
  onFreeze: lB
}, Mv = Ki.exports, cB = Ou, dB = Xr.f, qp = function(n) {
  var e = Mv.Symbol || (Mv.Symbol = {});
  n.charAt(0) != "_" && !(n in e) && dB(e, n, { value: cB.f(n) });
}, fB = xu, pB = Cu, hB = uo, mB = function(n) {
  var e = fB(n), t = pB.f;
  if (t)
    for (var r = t(n), i = hB.f, s = 0, o; r.length > s; )
      i.call(n, o = r[s++]) && e.push(o);
  return e;
}, gB = Uw, vB = Array.isArray || function(e) {
  return gB(e) == "Array";
}, t_ = {}, Up = {}, yB = Kw, bB = Fp.concat("length", "prototype");
Up.f = Object.getOwnPropertyNames || function(e) {
  return yB(e, bB);
};
var wB = Xi, n_ = Up.f, _B = {}.toString, r_ = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [], SB = function(n) {
  try {
    return n_(n);
  } catch {
    return r_.slice();
  }
};
t_.f = function(e) {
  return r_ && _B.call(e) == "[object Window]" ? SB(e) : n_(wB(e));
};
var i_ = {}, xB = uo, CB = wu, OB = Xi, EB = Dp, TB = Qr, kB = qw, Av = Object.getOwnPropertyDescriptor;
i_.f = Yr ? Av : function(e, t) {
  if (e = OB(e), t = EB(t, !0), kB)
    try {
      return Av(e, t);
    } catch {
    }
  if (TB(e, t))
    return CB(!xB.f.call(e, t), e[t]);
};
var Tu = vr.exports, We = Qr, df = Yr, it = Lp, Pv = Bp.exports, MB = e_.exports.KEY, Gp = lo, Kp = _u.exports, Jp = Vp, AB = Su, co = Zr.exports, PB = Ou, $B = qp, DB = mB, LB = vB, ff = bu, NB = ao, IB = zp, ku = Xi, Xp = Dp, pf = wu, Vs = Xw, s_ = t_, o_ = i_, Mu = Cu, a_ = Xr, RB = xu, l_ = o_.f, Er = a_.f, u_ = s_.f, Et = Tu.Symbol, ja = Tu.JSON, Bo = ja && ja.stringify, lr = "prototype", _t = co("_hidden"), $v = co("toPrimitive"), FB = {}.propertyIsEnumerable, rs = Kp("symbol-registry"), Rn = Kp("symbols"), fo = Kp("op-symbols"), Gt = Object[lr], Yi = typeof Et == "function" && !!Mu.f, ud = Tu.QObject, hf = !ud || !ud[lr] || !ud[lr].findChild, mf = df && Gp(function() {
  return Vs(Er({}, "a", {
    get: function() {
      return Er(this, "a", { value: 7 }).a;
    }
  })).a != 7;
}) ? function(n, e, t) {
  var r = l_(Gt, e);
  r && delete Gt[e], Er(n, e, t), r && n !== Gt && Er(Gt, e, r);
} : Er, Dv = function(n) {
  var e = Rn[n] = Vs(Et[lr]);
  return e._k = n, e;
}, gf = Yi && typeof Et.iterator == "symbol" ? function(n) {
  return typeof n == "symbol";
} : function(n) {
  return n instanceof Et;
}, Au = function(e, t, r) {
  return e === Gt && Au(fo, t, r), ff(e), t = Xp(t, !0), ff(r), We(Rn, t) ? (r.enumerable ? (We(e, _t) && e[_t][t] && (e[_t][t] = !1), r = Vs(r, { enumerable: pf(0, !1) })) : (We(e, _t) || Er(e, _t, pf(1, {})), e[_t][t] = !0), mf(e, t, r)) : Er(e, t, r);
}, c_ = function(e, t) {
  ff(e);
  for (var r = DB(t = ku(t)), i = 0, s = r.length, o; s > i; )
    Au(e, o = r[i++], t[o]);
  return e;
}, zB = function(e, t) {
  return t === void 0 ? Vs(e) : c_(Vs(e), t);
}, Lv = function(e) {
  var t = FB.call(this, e = Xp(e, !0));
  return this === Gt && We(Rn, e) && !We(fo, e) ? !1 : t || !We(this, e) || !We(Rn, e) || We(this, _t) && this[_t][e] ? t : !0;
}, d_ = function(e, t) {
  if (e = ku(e), t = Xp(t, !0), !(e === Gt && We(Rn, t) && !We(fo, t))) {
    var r = l_(e, t);
    return r && We(Rn, t) && !(We(e, _t) && e[_t][t]) && (r.enumerable = !0), r;
  }
}, f_ = function(e) {
  for (var t = u_(ku(e)), r = [], i = 0, s; t.length > i; )
    !We(Rn, s = t[i++]) && s != _t && s != MB && r.push(s);
  return r;
}, p_ = function(e) {
  for (var t = e === Gt, r = u_(t ? fo : ku(e)), i = [], s = 0, o; r.length > s; )
    We(Rn, o = r[s++]) && (t ? We(Gt, o) : !0) && i.push(Rn[o]);
  return i;
};
Yi || (Et = function() {
  if (this instanceof Et)
    throw TypeError("Symbol is not a constructor!");
  var e = AB(arguments.length > 0 ? arguments[0] : void 0), t = function(r) {
    this === Gt && t.call(fo, r), We(this, _t) && We(this[_t], e) && (this[_t][e] = !1), mf(this, e, pf(1, r));
  };
  return df && hf && mf(Gt, e, { configurable: !0, set: t }), Dv(e);
}, Pv(Et[lr], "toString", function() {
  return this._k;
}), o_.f = d_, a_.f = Au, Up.f = s_.f = f_, uo.f = Lv, Mu.f = p_, df && !iz && Pv(Gt, "propertyIsEnumerable", Lv, !0), PB.f = function(n) {
  return Dv(co(n));
});
it(it.G + it.W + it.F * !Yi, { Symbol: Et });
for (var Nv = "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","), Iv = 0; Nv.length > Iv; )
  co(Nv[Iv++]);
for (var Rv = RB(co.store), Fv = 0; Rv.length > Fv; )
  $B(Rv[Fv++]);
it(it.S + it.F * !Yi, "Symbol", {
  for: function(n) {
    return We(rs, n += "") ? rs[n] : rs[n] = Et(n);
  },
  keyFor: function(e) {
    if (!gf(e))
      throw TypeError(e + " is not a symbol!");
    for (var t in rs)
      if (rs[t] === e)
        return t;
  },
  useSetter: function() {
    hf = !0;
  },
  useSimple: function() {
    hf = !1;
  }
});
it(it.S + it.F * !Yi, "Object", {
  create: zB,
  defineProperty: Au,
  defineProperties: c_,
  getOwnPropertyDescriptor: d_,
  getOwnPropertyNames: f_,
  getOwnPropertySymbols: p_
});
var BB = Gp(function() {
  Mu.f(1);
});
it(it.S + it.F * BB, "Object", {
  getOwnPropertySymbols: function(e) {
    return Mu.f(IB(e));
  }
});
ja && it(it.S + it.F * (!Yi || Gp(function() {
  var n = Et();
  return Bo([n]) != "[null]" || Bo({ a: n }) != "{}" || Bo(Object(n)) != "{}";
})), "JSON", {
  stringify: function(e) {
    for (var t = [e], r = 1, i, s; arguments.length > r; )
      t.push(arguments[r++]);
    if (s = i = t[1], !(!NB(i) && e === void 0 || gf(e)))
      return LB(i) || (i = function(o, a) {
        if (typeof s == "function" && (a = s.call(this, o, a)), !gf(a))
          return a;
      }), t[1] = i, Bo.apply(ja, t);
  }
});
Et[lr][$v] || Ji(Et[lr], $v, Et[lr].valueOf);
Jp(Et, "Symbol");
Jp(Math, "Math", !0);
Jp(Tu.JSON, "JSON", !0);
qp("asyncIterator");
qp("observable");
var jB = Ki.exports.Symbol;
(function(n) {
  n.exports = { default: jB, __esModule: !0 };
})(Zw);
var VB = Jw.exports, h_ = m_(VB), HB = Zw.exports, nr = m_(HB), cd = typeof nr.default == "function" && typeof h_.default == "symbol" ? function(n) {
  return typeof n;
} : function(n) {
  return n && typeof nr.default == "function" && n.constructor === nr.default && n !== nr.default.prototype ? "symbol" : typeof n;
};
function m_(n) {
  return n && n.__esModule ? n : { default: n };
}
var ur = typeof nr.default == "function" && cd(h_.default) === "symbol" ? function(n) {
  return typeof n > "u" ? "undefined" : cd(n);
} : function(n) {
  return n && typeof nr.default == "function" && n.constructor === nr.default && n !== nr.default.prototype ? "symbol" : typeof n > "u" ? "undefined" : cd(n);
}, WB = /%[sdj%]/g, g_ = function() {
};
process.env.NODE_ENV !== "production" && typeof window < "u" && typeof document < "u" && (g_ = function(e, t) {
  typeof console < "u" && console.warn && t.every(function(r) {
    return typeof r == "string";
  }) && console.warn(e, t);
});
function $t() {
  for (var n = arguments.length, e = Array(n), t = 0; t < n; t++)
    e[t] = arguments[t];
  var r = 1, i = e[0], s = e.length;
  if (typeof i == "function")
    return i.apply(null, e.slice(1));
  if (typeof i == "string") {
    for (var o = String(i).replace(WB, function(l) {
      if (l === "%%")
        return "%";
      if (r >= s)
        return l;
      switch (l) {
        case "%s":
          return String(e[r++]);
        case "%d":
          return Number(e[r++]);
        case "%j":
          try {
            return JSON.stringify(e[r++]);
          } catch {
            return "[Circular]";
          }
          break;
        default:
          return l;
      }
    }), a = e[r]; r < s; a = e[++r])
      o += " " + a;
    return o;
  }
  return i;
}
function qB(n) {
  return n === "string" || n === "url" || n === "hex" || n === "email" || n === "pattern";
}
function Ie(n, e) {
  return !!(n == null || e === "array" && Array.isArray(n) && !n.length || qB(e) && typeof n == "string" && !n);
}
function UB(n, e, t) {
  var r = [], i = 0, s = n.length;
  function o(a) {
    r.push.apply(r, a), i++, i === s && t(r);
  }
  n.forEach(function(a) {
    e(a, o);
  });
}
function zv(n, e, t) {
  var r = 0, i = n.length;
  function s(o) {
    if (o && o.length) {
      t(o);
      return;
    }
    var a = r;
    r = r + 1, a < i ? e(n[a], s) : t([]);
  }
  s([]);
}
function GB(n) {
  var e = [];
  return Object.keys(n).forEach(function(t) {
    e.push.apply(e, n[t]);
  }), e;
}
function KB(n, e, t, r) {
  if (e.first) {
    var i = GB(n);
    return zv(i, t, r);
  }
  var s = e.firstFields || [];
  s === !0 && (s = Object.keys(n));
  var o = Object.keys(n), a = o.length, l = 0, u = [], c = function(p) {
    u.push.apply(u, p), l++, l === a && r(u);
  };
  o.forEach(function(f) {
    var p = n[f];
    s.indexOf(f) !== -1 ? zv(p, t, c) : UB(p, t, c);
  });
}
function Bv(n) {
  return function(e) {
    return e && e.message ? (e.field = e.field || n.fullField, e) : {
      message: e,
      field: e.field || n.fullField
    };
  };
}
function jv(n, e) {
  if (e) {
    for (var t in e)
      if (e.hasOwnProperty(t)) {
        var r = e[t];
        (typeof r > "u" ? "undefined" : ur(r)) === "object" && ur(n[t]) === "object" ? n[t] = ls({}, n[t], r) : n[t] = r;
      }
  }
  return n;
}
function v_(n, e, t, r, i, s) {
  n.required && (!t.hasOwnProperty(n.field) || Ie(e, s || n.type)) && r.push($t(i.messages.required, n.fullField));
}
function JB(n, e, t, r, i) {
  (/^\s+$/.test(e) || e === "") && r.push($t(i.messages.whitespace, n.fullField));
}
var dd = {
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  url: new RegExp("^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$", "i"),
  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
}, us = {
  integer: function(e) {
    return us.number(e) && parseInt(e, 10) === e;
  },
  float: function(e) {
    return us.number(e) && !us.integer(e);
  },
  array: function(e) {
    return Array.isArray(e);
  },
  regexp: function(e) {
    if (e instanceof RegExp)
      return !0;
    try {
      return !!new RegExp(e);
    } catch {
      return !1;
    }
  },
  date: function(e) {
    return typeof e.getTime == "function" && typeof e.getMonth == "function" && typeof e.getYear == "function";
  },
  number: function(e) {
    return isNaN(e) ? !1 : typeof e == "number";
  },
  object: function(e) {
    return (typeof e > "u" ? "undefined" : ur(e)) === "object" && !us.array(e);
  },
  method: function(e) {
    return typeof e == "function";
  },
  email: function(e) {
    return typeof e == "string" && !!e.match(dd.email) && e.length < 255;
  },
  url: function(e) {
    return typeof e == "string" && !!e.match(dd.url);
  },
  hex: function(e) {
    return typeof e == "string" && !!e.match(dd.hex);
  }
};
function XB(n, e, t, r, i) {
  if (n.required && e === void 0) {
    v_(n, e, t, r, i);
    return;
  }
  var s = ["integer", "float", "array", "regexp", "object", "method", "email", "number", "date", "url", "hex"], o = n.type;
  s.indexOf(o) > -1 ? us[o](e) || r.push($t(i.messages.types[o], n.fullField, n.type)) : o && (typeof e > "u" ? "undefined" : ur(e)) !== n.type && r.push($t(i.messages.types[o], n.fullField, n.type));
}
function YB(n, e, t, r, i) {
  var s = typeof n.len == "number", o = typeof n.min == "number", a = typeof n.max == "number", l = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g, u = e, c = null, f = typeof e == "number", p = typeof e == "string", d = Array.isArray(e);
  if (f ? c = "number" : p ? c = "string" : d && (c = "array"), !c)
    return !1;
  d && (u = e.length), p && (u = e.replace(l, "_").length), s ? u !== n.len && r.push($t(i.messages[c].len, n.fullField, n.len)) : o && !a && u < n.min ? r.push($t(i.messages[c].min, n.fullField, n.min)) : a && !o && u > n.max ? r.push($t(i.messages[c].max, n.fullField, n.max)) : o && a && (u < n.min || u > n.max) && r.push($t(i.messages[c].range, n.fullField, n.min, n.max));
}
var li = "enum";
function QB(n, e, t, r, i) {
  n[li] = Array.isArray(n[li]) ? n[li] : [], n[li].indexOf(e) === -1 && r.push($t(i.messages[li], n.fullField, n[li].join(", ")));
}
function ZB(n, e, t, r, i) {
  if (n.pattern) {
    if (n.pattern instanceof RegExp)
      n.pattern.lastIndex = 0, n.pattern.test(e) || r.push($t(i.messages.pattern.mismatch, n.fullField, e, n.pattern));
    else if (typeof n.pattern == "string") {
      var s = new RegExp(n.pattern);
      s.test(e) || r.push($t(i.messages.pattern.mismatch, n.fullField, e, n.pattern));
    }
  }
}
const be = {
  required: v_,
  whitespace: JB,
  type: XB,
  range: YB,
  enum: QB,
  pattern: ZB
};
function ej(n, e, t, r, i) {
  var s = [], o = n.required || !n.required && r.hasOwnProperty(n.field);
  if (o) {
    if (Ie(e, "string") && !n.required)
      return t();
    be.required(n, e, r, s, i, "string"), Ie(e, "string") || (be.type(n, e, r, s, i), be.range(n, e, r, s, i), be.pattern(n, e, r, s, i), n.whitespace === !0 && be.whitespace(n, e, r, s, i));
  }
  t(s);
}
function tj(n, e, t, r, i) {
  var s = [], o = n.required || !n.required && r.hasOwnProperty(n.field);
  if (o) {
    if (Ie(e) && !n.required)
      return t();
    be.required(n, e, r, s, i), e !== void 0 && be.type(n, e, r, s, i);
  }
  t(s);
}
function nj(n, e, t, r, i) {
  var s = [], o = n.required || !n.required && r.hasOwnProperty(n.field);
  if (o) {
    if (Ie(e) && !n.required)
      return t();
    be.required(n, e, r, s, i), e !== void 0 && (be.type(n, e, r, s, i), be.range(n, e, r, s, i));
  }
  t(s);
}
function rj(n, e, t, r, i) {
  var s = [], o = n.required || !n.required && r.hasOwnProperty(n.field);
  if (o) {
    if (Ie(e) && !n.required)
      return t();
    be.required(n, e, r, s, i), e !== void 0 && be.type(n, e, r, s, i);
  }
  t(s);
}
function ij(n, e, t, r, i) {
  var s = [], o = n.required || !n.required && r.hasOwnProperty(n.field);
  if (o) {
    if (Ie(e) && !n.required)
      return t();
    be.required(n, e, r, s, i), Ie(e) || be.type(n, e, r, s, i);
  }
  t(s);
}
function sj(n, e, t, r, i) {
  var s = [], o = n.required || !n.required && r.hasOwnProperty(n.field);
  if (o) {
    if (Ie(e) && !n.required)
      return t();
    be.required(n, e, r, s, i), e !== void 0 && (be.type(n, e, r, s, i), be.range(n, e, r, s, i));
  }
  t(s);
}
function oj(n, e, t, r, i) {
  var s = [], o = n.required || !n.required && r.hasOwnProperty(n.field);
  if (o) {
    if (Ie(e) && !n.required)
      return t();
    be.required(n, e, r, s, i), e !== void 0 && (be.type(n, e, r, s, i), be.range(n, e, r, s, i));
  }
  t(s);
}
function aj(n, e, t, r, i) {
  var s = [], o = n.required || !n.required && r.hasOwnProperty(n.field);
  if (o) {
    if (Ie(e, "array") && !n.required)
      return t();
    be.required(n, e, r, s, i, "array"), Ie(e, "array") || (be.type(n, e, r, s, i), be.range(n, e, r, s, i));
  }
  t(s);
}
function lj(n, e, t, r, i) {
  var s = [], o = n.required || !n.required && r.hasOwnProperty(n.field);
  if (o) {
    if (Ie(e) && !n.required)
      return t();
    be.required(n, e, r, s, i), e !== void 0 && be.type(n, e, r, s, i);
  }
  t(s);
}
var uj = "enum";
function cj(n, e, t, r, i) {
  var s = [], o = n.required || !n.required && r.hasOwnProperty(n.field);
  if (o) {
    if (Ie(e) && !n.required)
      return t();
    be.required(n, e, r, s, i), e && be[uj](n, e, r, s, i);
  }
  t(s);
}
function dj(n, e, t, r, i) {
  var s = [], o = n.required || !n.required && r.hasOwnProperty(n.field);
  if (o) {
    if (Ie(e, "string") && !n.required)
      return t();
    be.required(n, e, r, s, i), Ie(e, "string") || be.pattern(n, e, r, s, i);
  }
  t(s);
}
function fj(n, e, t, r, i) {
  var s = [], o = n.required || !n.required && r.hasOwnProperty(n.field);
  if (o) {
    if (Ie(e) && !n.required)
      return t();
    if (be.required(n, e, r, s, i), !Ie(e)) {
      var a = void 0;
      typeof e == "number" ? a = new Date(e) : a = e, be.type(n, a, r, s, i), a && be.range(n, a.getTime(), r, s, i);
    }
  }
  t(s);
}
function pj(n, e, t, r, i) {
  var s = [], o = Array.isArray(e) ? "array" : typeof e > "u" ? "undefined" : ur(e);
  be.required(n, e, r, s, i, o), t(s);
}
function fd(n, e, t, r, i) {
  var s = n.type, o = [], a = n.required || !n.required && r.hasOwnProperty(n.field);
  if (a) {
    if (Ie(e, s) && !n.required)
      return t();
    be.required(n, e, r, o, i, s), Ie(e, s) || be.type(n, e, r, o, i);
  }
  t(o);
}
const oa = {
  string: ej,
  method: tj,
  number: nj,
  boolean: rj,
  regexp: ij,
  integer: sj,
  float: oj,
  array: aj,
  object: lj,
  enum: cj,
  pattern: dj,
  date: fj,
  url: fd,
  hex: fd,
  email: fd,
  required: pj
};
function vf() {
  return {
    default: "Validation error on field %s",
    required: "%s is required",
    enum: "%s must be one of %s",
    whitespace: "%s cannot be empty",
    date: {
      format: "%s date %s is invalid for format %s",
      parse: "%s date could not be parsed, %s is invalid ",
      invalid: "%s date %s is invalid"
    },
    types: {
      string: "%s is not a %s",
      method: "%s is not a %s (function)",
      array: "%s is not an %s",
      object: "%s is not an %s",
      number: "%s is not a %s",
      date: "%s is not a %s",
      boolean: "%s is not a %s",
      integer: "%s is not an %s",
      float: "%s is not a %s",
      regexp: "%s is not a valid %s",
      email: "%s is not a valid %s",
      url: "%s is not a valid %s",
      hex: "%s is not a valid %s"
    },
    string: {
      len: "%s must be exactly %s characters",
      min: "%s must be at least %s characters",
      max: "%s cannot be longer than %s characters",
      range: "%s must be between %s and %s characters"
    },
    number: {
      len: "%s must equal %s",
      min: "%s cannot be less than %s",
      max: "%s cannot be greater than %s",
      range: "%s must be between %s and %s"
    },
    array: {
      len: "%s must be exactly %s in length",
      min: "%s cannot be less than %s in length",
      max: "%s cannot be greater than %s in length",
      range: "%s must be between %s and %s in length"
    },
    pattern: {
      mismatch: "%s value %s does not match pattern %s"
    },
    clone: function() {
      var e = JSON.parse(JSON.stringify(this));
      return e.clone = this.clone, e;
    }
  };
}
var Yp = vf();
function Hs(n) {
  this.rules = null, this._messages = Yp, this.define(n);
}
Hs.prototype = {
  messages: function(e) {
    return e && (this._messages = jv(vf(), e)), this._messages;
  },
  define: function(e) {
    if (!e)
      throw new Error("Cannot configure a schema with no rules");
    if ((typeof e > "u" ? "undefined" : ur(e)) !== "object" || Array.isArray(e))
      throw new Error("Rules must be an object");
    this.rules = {};
    var t = void 0, r = void 0;
    for (t in e)
      e.hasOwnProperty(t) && (r = e[t], this.rules[t] = Array.isArray(r) ? r : [r]);
  },
  validate: function(e) {
    var t = this, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = arguments[2], s = e, o = r, a = i;
    if (typeof o == "function" && (a = o, o = {}), !this.rules || Object.keys(this.rules).length === 0) {
      a && a();
      return;
    }
    function l(v) {
      var g = void 0, m = void 0, _ = [], y = {};
      function w(O) {
        Array.isArray(O) ? _ = _.concat.apply(_, O) : _.push(O);
      }
      for (g = 0; g < v.length; g++)
        w(v[g]);
      if (!_.length)
        _ = null, y = null;
      else
        for (g = 0; g < _.length; g++)
          m = _[g].field, y[m] = y[m] || [], y[m].push(_[g]);
      a(_, y);
    }
    if (o.messages) {
      var u = this.messages();
      u === Yp && (u = vf()), jv(u, o.messages), o.messages = u;
    } else
      o.messages = this.messages();
    var c = void 0, f = void 0, p = {}, d = o.keys || Object.keys(this.rules);
    d.forEach(function(v) {
      c = t.rules[v], f = s[v], c.forEach(function(g) {
        var m = g;
        typeof m.transform == "function" && (s === e && (s = ls({}, s)), f = s[v] = m.transform(f)), typeof m == "function" ? m = {
          validator: m
        } : m = ls({}, m), m.validator = t.getValidationMethod(m), m.field = v, m.fullField = m.fullField || v, m.type = t.getType(m), m.validator && (p[v] = p[v] || [], p[v].push({
          rule: m,
          value: f,
          source: s,
          field: v
        }));
      });
    });
    var h = {};
    KB(p, o, function(v, g) {
      var m = v.rule, _ = (m.type === "object" || m.type === "array") && (ur(m.fields) === "object" || ur(m.defaultField) === "object");
      _ = _ && (m.required || !m.required && v.value), m.field = v.field;
      function y(C, S) {
        return ls({}, S, {
          fullField: m.fullField + "." + C
        });
      }
      function w() {
        var C = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], S = C;
        if (Array.isArray(S) || (S = [S]), S.length && g_("async-validator:", S), S.length && m.message && (S = [].concat(m.message)), S = S.map(Bv(m)), o.first && S.length)
          return h[m.field] = 1, g(S);
        if (!_)
          g(S);
        else {
          if (m.required && !v.value)
            return m.message ? S = [].concat(m.message).map(Bv(m)) : o.error ? S = [o.error(m, $t(o.messages.required, m.field))] : S = [], g(S);
          var b = {};
          if (m.defaultField)
            for (var x in v.value)
              v.value.hasOwnProperty(x) && (b[x] = m.defaultField);
          b = ls({}, b, v.rule.fields);
          for (var E in b)
            if (b.hasOwnProperty(E)) {
              var M = Array.isArray(b[E]) ? b[E] : [b[E]];
              b[E] = M.map(y.bind(null, E));
            }
          var $ = new Hs(b);
          $.messages(o.messages), v.rule.options && (v.rule.options.messages = o.messages, v.rule.options.error = o.error), $.validate(v.value, v.rule.options || o, function(F) {
            g(F && F.length ? S.concat(F) : F);
          });
        }
      }
      var O = m.validator(m, v.value, w, v.source, o);
      O && O.then && O.then(function() {
        return w();
      }, function(C) {
        return w(C);
      });
    }, function(v) {
      l(v);
    });
  },
  getType: function(e) {
    if (e.type === void 0 && e.pattern instanceof RegExp && (e.type = "pattern"), typeof e.validator != "function" && e.type && !oa.hasOwnProperty(e.type))
      throw new Error($t("Unknown rule type %s", e.type));
    return e.type || "string";
  },
  getValidationMethod: function(e) {
    if (typeof e.validator == "function")
      return e.validator;
    var t = Object.keys(e), r = t.indexOf("message");
    return r !== -1 && t.splice(r, 1), t.length === 1 && t[0] === "required" ? oa.required : oa[this.getType(e)] || !1;
  }
};
Hs.register = function(e, t) {
  if (typeof t != "function")
    throw new Error("Cannot register a validator by type, validator is not a function");
  oa[e] = t;
};
Hs.messages = Yp;
const hj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Hs
}, Symbol.toStringTag, { value: "Module" })), mj = /* @__PURE__ */ Df(hj);
(function(n) {
  n.exports = function(e) {
    var t = {};
    function r(i) {
      if (t[i])
        return t[i].exports;
      var s = t[i] = {
        i,
        l: !1,
        exports: {}
      };
      return e[i].call(s.exports, s, s.exports, r), s.l = !0, s.exports;
    }
    return r.m = e, r.c = t, r.d = function(i, s, o) {
      r.o(i, s) || Object.defineProperty(i, s, { enumerable: !0, get: o });
    }, r.r = function(i) {
      typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(i, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(i, "__esModule", { value: !0 });
    }, r.t = function(i, s) {
      if (s & 1 && (i = r(i)), s & 8 || s & 4 && typeof i == "object" && i && i.__esModule)
        return i;
      var o = /* @__PURE__ */ Object.create(null);
      if (r.r(o), Object.defineProperty(o, "default", { enumerable: !0, value: i }), s & 2 && typeof i != "string")
        for (var a in i)
          r.d(o, a, function(l) {
            return i[l];
          }.bind(null, a));
      return o;
    }, r.n = function(i) {
      var s = i && i.__esModule ? function() {
        return i.default;
      } : function() {
        return i;
      };
      return r.d(s, "a", s), s;
    }, r.o = function(i, s) {
      return Object.prototype.hasOwnProperty.call(i, s);
    }, r.p = "/dist/", r(r.s = 70);
  }({
    0: function(e, t, r) {
      r.d(t, "a", function() {
        return i;
      });
      function i(s, o, a, l, u, c, f, p) {
        var d = typeof s == "function" ? s.options : s;
        o && (d.render = o, d.staticRenderFns = a, d._compiled = !0), l && (d.functional = !0), c && (d._scopeId = "data-v-" + c);
        var h;
        if (f ? (h = function(m) {
          m = m || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !m && typeof __VUE_SSR_CONTEXT__ < "u" && (m = __VUE_SSR_CONTEXT__), u && u.call(this, m), m && m._registeredComponents && m._registeredComponents.add(f);
        }, d._ssrRegister = h) : u && (h = p ? function() {
          u.call(this, this.$root.$options.shadowRoot);
        } : u), h)
          if (d.functional) {
            d._injectStyles = h;
            var v = d.render;
            d.render = function(_, y) {
              return h.call(y), v(_, y);
            };
          } else {
            var g = d.beforeCreate;
            d.beforeCreate = g ? [].concat(g, h) : [h];
          }
        return {
          exports: s,
          options: d
        };
      }
    },
    3: function(e, t) {
      e.exports = ne;
    },
    4: function(e, t) {
      e.exports = an();
    },
    49: function(e, t) {
      e.exports = mj;
    },
    70: function(e, t, r) {
      r.r(t);
      var i = function() {
        var b = this, x = b.$createElement, E = b._self._c || x;
        return E(
          "div",
          {
            staticClass: "el-form-item",
            class: [
              {
                "el-form-item--feedback": b.elForm && b.elForm.statusIcon,
                "is-error": b.validateState === "error",
                "is-validating": b.validateState === "validating",
                "is-success": b.validateState === "success",
                "is-required": b.isRequired || b.required,
                "is-no-asterisk": b.elForm && b.elForm.hideRequiredAsterisk
              },
              b.sizeClass ? "el-form-item--" + b.sizeClass : ""
            ]
          },
          [
            E(
              "label-wrap",
              {
                attrs: {
                  "is-auto-width": b.labelStyle && b.labelStyle.width === "auto",
                  "update-all": b.form.labelWidth === "auto"
                }
              },
              [
                b.label || b.$slots.label ? E(
                  "label",
                  {
                    staticClass: "el-form-item__label",
                    style: b.labelStyle,
                    attrs: { for: b.labelFor }
                  },
                  [
                    b._t("label", [
                      b._v(b._s(b.label + b.form.labelSuffix))
                    ])
                  ],
                  2
                ) : b._e()
              ]
            ),
            E(
              "div",
              { staticClass: "el-form-item__content", style: b.contentStyle },
              [
                b._t("default"),
                E(
                  "transition",
                  { attrs: { name: "el-zoom-in-top" } },
                  [
                    b.validateState === "error" && b.showMessage && b.form.showMessage ? b._t(
                      "error",
                      [
                        E(
                          "div",
                          {
                            staticClass: "el-form-item__error",
                            class: {
                              "el-form-item__error--inline": typeof b.inlineMessage == "boolean" ? b.inlineMessage : b.elForm && b.elForm.inlineMessage || !1
                            }
                          },
                          [
                            b._v(
                              `
          ` + b._s(b.validateMessage) + `
        `
                            )
                          ]
                        )
                      ],
                      { error: b.validateMessage }
                    ) : b._e()
                  ],
                  2
                )
              ],
              2
            )
          ],
          1
        );
      }, s = [];
      i._withStripped = !0;
      var o = r(49), a = /* @__PURE__ */ r.n(o), l = r(4), u = /* @__PURE__ */ r.n(l), c = r(9), f = /* @__PURE__ */ r.n(c), p = r(3), d = {
        props: {
          isAutoWidth: Boolean,
          updateAll: Boolean
        },
        inject: ["elForm", "elFormItem"],
        render: function() {
          var x = arguments[0], E = this.$slots.default;
          if (!E)
            return null;
          if (this.isAutoWidth) {
            var M = this.elForm.autoLabelWidth, $ = {};
            if (M && M !== "auto") {
              var F = parseInt(M, 10) - this.computedWidth;
              F && ($.marginLeft = F + "px");
            }
            return x(
              "div",
              { class: "el-form-item__label-wrap", style: $ },
              [E]
            );
          } else
            return E[0];
        },
        methods: {
          getLabelWidth: function() {
            if (this.$el && this.$el.firstElementChild) {
              var x = window.getComputedStyle(this.$el.firstElementChild).width;
              return Math.ceil(parseFloat(x));
            } else
              return 0;
          },
          updateLabelWidth: function() {
            var x = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "update";
            this.$slots.default && this.isAutoWidth && this.$el.firstElementChild && (x === "update" ? this.computedWidth = this.getLabelWidth() : x === "remove" && this.elForm.deregisterLabelWidth(this.computedWidth));
          }
        },
        watch: {
          computedWidth: function(x, E) {
            this.updateAll && (this.elForm.registerLabelWidth(x, E), this.elFormItem.updateComputedLabelWidth(x));
          }
        },
        data: function() {
          return {
            computedWidth: 0
          };
        },
        mounted: function() {
          this.updateLabelWidth("update");
        },
        updated: function() {
          this.updateLabelWidth("update");
        },
        beforeDestroy: function() {
          this.updateLabelWidth("remove");
        }
      }, h = d, v = r(0), g, m, _ = Object(v.a)(
        h,
        g,
        m,
        !1,
        null,
        null,
        null
      );
      _.options.__file = "packages/form/src/label-wrap.vue";
      var y = _.exports, w = {
        name: "ElFormItem",
        componentName: "ElFormItem",
        mixins: [u.a],
        provide: function() {
          return {
            elFormItem: this
          };
        },
        inject: ["elForm"],
        props: {
          label: String,
          labelWidth: String,
          prop: String,
          required: {
            type: Boolean,
            default: void 0
          },
          rules: [Object, Array],
          error: String,
          validateStatus: String,
          for: String,
          inlineMessage: {
            type: [String, Boolean],
            default: ""
          },
          showMessage: {
            type: Boolean,
            default: !0
          },
          size: String
        },
        components: {
          LabelWrap: y
        },
        watch: {
          error: {
            immediate: !0,
            handler: function(x) {
              this.validateMessage = x, this.validateState = x ? "error" : "";
            }
          },
          validateStatus: function(x) {
            this.validateState = x;
          },
          rules: function(x) {
            (!x || x.length === 0) && this.required === void 0 && this.clearValidate();
          }
        },
        computed: {
          labelFor: function() {
            return this.for || this.prop;
          },
          labelStyle: function() {
            var x = {};
            if (this.form.labelPosition === "top")
              return x;
            var E = this.labelWidth || this.form.labelWidth;
            return E && (x.width = E), x;
          },
          contentStyle: function() {
            var x = {}, E = this.label;
            if (this.form.labelPosition === "top" || this.form.inline || !E && !this.labelWidth && this.isNested)
              return x;
            var M = this.labelWidth || this.form.labelWidth;
            return M === "auto" ? this.labelWidth === "auto" ? x.marginLeft = this.computedLabelWidth : this.form.labelWidth === "auto" && (x.marginLeft = this.elForm.autoLabelWidth) : x.marginLeft = M, x;
          },
          form: function() {
            for (var x = this.$parent, E = x.$options.componentName; E !== "ElForm"; )
              E === "ElFormItem" && (this.isNested = !0), x = x.$parent, E = x.$options.componentName;
            return x;
          },
          fieldValue: function() {
            var x = this.form.model;
            if (!(!x || !this.prop)) {
              var E = this.prop;
              return E.indexOf(":") !== -1 && (E = E.replace(/:/, ".")), Object(p.getPropByPath)(x, E, !0).v;
            }
          },
          isRequired: function() {
            var x = this.getRules(), E = !1;
            return x && x.length && x.every(function(M) {
              return M.required ? (E = !0, !1) : !0;
            }), E;
          },
          _formSize: function() {
            return this.elForm.size;
          },
          elFormItemSize: function() {
            return this.size || this._formSize;
          },
          sizeClass: function() {
            return this.elFormItemSize || (this.$ELEMENT || {}).size;
          }
        },
        data: function() {
          return {
            validateState: "",
            validateMessage: "",
            validateDisabled: !1,
            validator: {},
            isNested: !1,
            computedLabelWidth: ""
          };
        },
        methods: {
          validate: function(x) {
            var E = this, M = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : p.noop;
            this.validateDisabled = !1;
            var $ = this.getFilteredRule(x);
            if ((!$ || $.length === 0) && this.required === void 0)
              return M(), !0;
            this.validateState = "validating";
            var F = {};
            $ && $.length > 0 && $.forEach(function(H) {
              delete H.trigger;
            }), F[this.prop] = $;
            var J = new a.a(F), W = {};
            W[this.prop] = this.fieldValue, J.validate(W, { firstFields: !0 }, function(H, Y) {
              E.validateState = H ? "error" : "success", E.validateMessage = H ? H[0].message : "", M(E.validateMessage, Y), E.elForm && E.elForm.$emit("validate", E.prop, !H, E.validateMessage || null);
            });
          },
          clearValidate: function() {
            this.validateState = "", this.validateMessage = "", this.validateDisabled = !1;
          },
          resetField: function() {
            var x = this;
            this.validateState = "", this.validateMessage = "";
            var E = this.form.model, M = this.fieldValue, $ = this.prop;
            $.indexOf(":") !== -1 && ($ = $.replace(/:/, "."));
            var F = Object(p.getPropByPath)(E, $, !0);
            this.validateDisabled = !0, Array.isArray(M) ? F.o[F.k] = [].concat(this.initialValue) : F.o[F.k] = this.initialValue, this.$nextTick(function() {
              x.validateDisabled = !1;
            }), this.broadcast("ElTimeSelect", "fieldReset", this.initialValue);
          },
          getRules: function() {
            var x = this.form.rules, E = this.rules, M = this.required !== void 0 ? { required: !!this.required } : [], $ = Object(p.getPropByPath)(x, this.prop || "");
            return x = x ? $.o[this.prop || ""] || $.v : [], [].concat(E || x || []).concat(M);
          },
          getFilteredRule: function(x) {
            var E = this.getRules();
            return E.filter(function(M) {
              return !M.trigger || x === "" ? !0 : Array.isArray(M.trigger) ? M.trigger.indexOf(x) > -1 : M.trigger === x;
            }).map(function(M) {
              return f()({}, M);
            });
          },
          onFieldBlur: function() {
            this.validate("blur");
          },
          onFieldChange: function() {
            if (this.validateDisabled) {
              this.validateDisabled = !1;
              return;
            }
            this.validate("change");
          },
          updateComputedLabelWidth: function(x) {
            this.computedLabelWidth = x ? x + "px" : "";
          },
          addValidateEvents: function() {
            var x = this.getRules();
            (x.length || this.required !== void 0) && (this.$on("el.form.blur", this.onFieldBlur), this.$on("el.form.change", this.onFieldChange));
          },
          removeValidateEvents: function() {
            this.$off();
          }
        },
        mounted: function() {
          if (this.prop) {
            this.dispatch("ElForm", "el.form.addField", [this]);
            var x = this.fieldValue;
            Array.isArray(x) && (x = [].concat(x)), Object.defineProperty(this, "initialValue", {
              value: x
            }), this.addValidateEvents();
          }
        },
        beforeDestroy: function() {
          this.dispatch("ElForm", "el.form.removeField", [this]);
        }
      }, O = w, C = Object(v.a)(
        O,
        i,
        s,
        !1,
        null,
        null,
        null
      );
      C.options.__file = "packages/form/src/form-item.vue";
      var S = C.exports;
      S.install = function(b) {
        b.component(S.name, S);
      }, t.default = S;
    },
    9: function(e, t) {
      e.exports = Cl();
    }
  });
})(Vw);
const gj = /* @__PURE__ */ ot(Vw.exports);
var y_ = { exports: {} };
(function(n) {
  n.exports = function(e) {
    var t = {};
    function r(i) {
      if (t[i])
        return t[i].exports;
      var s = t[i] = {
        i,
        l: !1,
        exports: {}
      };
      return e[i].call(s.exports, s, s.exports, r), s.l = !0, s.exports;
    }
    return r.m = e, r.c = t, r.d = function(i, s, o) {
      r.o(i, s) || Object.defineProperty(i, s, { enumerable: !0, get: o });
    }, r.r = function(i) {
      typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(i, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(i, "__esModule", { value: !0 });
    }, r.t = function(i, s) {
      if (s & 1 && (i = r(i)), s & 8 || s & 4 && typeof i == "object" && i && i.__esModule)
        return i;
      var o = /* @__PURE__ */ Object.create(null);
      if (r.r(o), Object.defineProperty(o, "default", { enumerable: !0, value: i }), s & 2 && typeof i != "string")
        for (var a in i)
          r.d(o, a, function(l) {
            return i[l];
          }.bind(null, a));
      return o;
    }, r.n = function(i) {
      var s = i && i.__esModule ? function() {
        return i.default;
      } : function() {
        return i;
      };
      return r.d(s, "a", s), s;
    }, r.o = function(i, s) {
      return Object.prototype.hasOwnProperty.call(i, s);
    }, r.p = "/dist/", r(r.s = 94);
  }({
    0: function(e, t, r) {
      r.d(t, "a", function() {
        return i;
      });
      function i(s, o, a, l, u, c, f, p) {
        var d = typeof s == "function" ? s.options : s;
        o && (d.render = o, d.staticRenderFns = a, d._compiled = !0), l && (d.functional = !0), c && (d._scopeId = "data-v-" + c);
        var h;
        if (f ? (h = function(m) {
          m = m || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !m && typeof __VUE_SSR_CONTEXT__ < "u" && (m = __VUE_SSR_CONTEXT__), u && u.call(this, m), m && m._registeredComponents && m._registeredComponents.add(f);
        }, d._ssrRegister = h) : u && (h = p ? function() {
          u.call(this, this.$root.$options.shadowRoot);
        } : u), h)
          if (d.functional) {
            d._injectStyles = h;
            var v = d.render;
            d.render = function(_, y) {
              return h.call(y), v(_, y);
            };
          } else {
            var g = d.beforeCreate;
            d.beforeCreate = g ? [].concat(g, h) : [h];
          }
        return {
          exports: s,
          options: d
        };
      }
    },
    11: function(e, t) {
      e.exports = El();
    },
    22: function(e, t) {
      e.exports = rp();
    },
    4: function(e, t) {
      e.exports = an();
    },
    94: function(e, t, r) {
      r.r(t);
      var i = function() {
        var m = this, _ = m.$createElement, y = m._self._c || _;
        return y(
          "div",
          {
            staticClass: "el-switch",
            class: { "is-disabled": m.switchDisabled, "is-checked": m.checked },
            attrs: {
              role: "switch",
              "aria-checked": m.checked,
              "aria-disabled": m.switchDisabled
            },
            on: {
              click: function(w) {
                return w.preventDefault(), m.switchValue(w);
              }
            }
          },
          [
            y("input", {
              ref: "input",
              staticClass: "el-switch__input",
              attrs: {
                type: "checkbox",
                id: m.id,
                name: m.name,
                "true-value": m.activeValue,
                "false-value": m.inactiveValue,
                disabled: m.switchDisabled
              },
              on: {
                change: m.handleChange,
                keydown: function(w) {
                  return !("button" in w) && m._k(w.keyCode, "enter", 13, w.key, "Enter") ? null : m.switchValue(w);
                }
              }
            }),
            m.inactiveIconClass || m.inactiveText ? y(
              "span",
              {
                class: [
                  "el-switch__label",
                  "el-switch__label--left",
                  m.checked ? "" : "is-active"
                ]
              },
              [
                m.inactiveIconClass ? y("i", { class: [m.inactiveIconClass] }) : m._e(),
                !m.inactiveIconClass && m.inactiveText ? y("span", { attrs: { "aria-hidden": m.checked } }, [
                  m._v(m._s(m.inactiveText))
                ]) : m._e()
              ]
            ) : m._e(),
            y("span", {
              ref: "core",
              staticClass: "el-switch__core",
              style: { width: m.coreWidth + "px" }
            }),
            m.activeIconClass || m.activeText ? y(
              "span",
              {
                class: [
                  "el-switch__label",
                  "el-switch__label--right",
                  m.checked ? "is-active" : ""
                ]
              },
              [
                m.activeIconClass ? y("i", { class: [m.activeIconClass] }) : m._e(),
                !m.activeIconClass && m.activeText ? y("span", { attrs: { "aria-hidden": !m.checked } }, [
                  m._v(m._s(m.activeText))
                ]) : m._e()
              ]
            ) : m._e()
          ]
        );
      }, s = [];
      i._withStripped = !0;
      var o = r(4), a = /* @__PURE__ */ r.n(o), l = r(22), u = /* @__PURE__ */ r.n(l), c = r(11), f = /* @__PURE__ */ r.n(c), p = {
        name: "ElSwitch",
        mixins: [u()("input"), f.a, a.a],
        inject: {
          elForm: {
            default: ""
          }
        },
        props: {
          value: {
            type: [Boolean, String, Number],
            default: !1
          },
          disabled: {
            type: Boolean,
            default: !1
          },
          width: {
            type: Number,
            default: 40
          },
          activeIconClass: {
            type: String,
            default: ""
          },
          inactiveIconClass: {
            type: String,
            default: ""
          },
          activeText: String,
          inactiveText: String,
          activeColor: {
            type: String,
            default: ""
          },
          inactiveColor: {
            type: String,
            default: ""
          },
          activeValue: {
            type: [Boolean, String, Number],
            default: !0
          },
          inactiveValue: {
            type: [Boolean, String, Number],
            default: !1
          },
          name: {
            type: String,
            default: ""
          },
          validateEvent: {
            type: Boolean,
            default: !0
          },
          id: String
        },
        data: function() {
          return {
            coreWidth: this.width
          };
        },
        created: function() {
          ~[this.activeValue, this.inactiveValue].indexOf(this.value) || this.$emit("input", this.inactiveValue);
        },
        computed: {
          checked: function() {
            return this.value === this.activeValue;
          },
          switchDisabled: function() {
            return this.disabled || (this.elForm || {}).disabled;
          }
        },
        watch: {
          checked: function() {
            this.$refs.input.checked = this.checked, (this.activeColor || this.inactiveColor) && this.setBackgroundColor(), this.validateEvent && this.dispatch("ElFormItem", "el.form.change", [this.value]);
          }
        },
        methods: {
          handleChange: function(_) {
            var y = this, w = this.checked ? this.inactiveValue : this.activeValue;
            this.$emit("input", w), this.$emit("change", w), this.$nextTick(function() {
              y.$refs.input && (y.$refs.input.checked = y.checked);
            });
          },
          setBackgroundColor: function() {
            var _ = this.checked ? this.activeColor : this.inactiveColor;
            this.$refs.core.style.borderColor = _, this.$refs.core.style.backgroundColor = _;
          },
          switchValue: function() {
            !this.switchDisabled && this.handleChange();
          },
          getMigratingConfig: function() {
            return {
              props: {
                "on-color": "on-color is renamed to active-color.",
                "off-color": "off-color is renamed to inactive-color.",
                "on-text": "on-text is renamed to active-text.",
                "off-text": "off-text is renamed to inactive-text.",
                "on-value": "on-value is renamed to active-value.",
                "off-value": "off-value is renamed to inactive-value.",
                "on-icon-class": "on-icon-class is renamed to active-icon-class.",
                "off-icon-class": "off-icon-class is renamed to inactive-icon-class."
              }
            };
          }
        },
        mounted: function() {
          this.coreWidth = this.width || 40, (this.activeColor || this.inactiveColor) && this.setBackgroundColor(), this.$refs.input.checked = this.checked;
        }
      }, d = p, h = r(0), v = Object(h.a)(
        d,
        i,
        s,
        !1,
        null,
        null,
        null
      );
      v.options.__file = "packages/switch/src/component.vue";
      var g = v.exports;
      g.install = function(m) {
        m.component(g.name, g);
      }, t.default = g;
    }
  });
})(y_);
const vj = /* @__PURE__ */ ot(y_.exports), yj = (n) => {
  const e = oy(n());
  return { state: e, reset: () => {
    Object.assign(e, n());
  } };
}, bj = {};
var wj = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("button", e._g(e._b({ staticClass: "base-button" }, "button", e.$attrs, !1), e.$listeners), [e._t("default")], 2);
}, _j = [], Sj = /* @__PURE__ */ le(
  bj,
  wj,
  _j,
  !1,
  null,
  null,
  null,
  null
);
const xj = Sj.exports, Cj = {
  alt: "",
  fullscreen: !1,
  description: "",
  objectFit: Od
}, Oj = st({
  name: "ImageRestyleCommand",
  components: {
    BaseButton: xj,
    ButtonCommand: yt,
    ElDialog: Kr,
    ElForm: E2,
    ElFormItem: gj,
    ElInput: Eb,
    ElSelect: Vb,
    ElOption: Wb,
    ElButton: Rf,
    ElSwitch: vj
  },
  setup() {
    const n = $e("editor"), { state: e, reset: t } = yj(() => Cj), r = je(() => n == null ? void 0 : n.value.isActive("image")), i = je(() => r.value ? "image" : "imageView"), s = je(() => {
      var v, g;
      const d = (v = n == null ? void 0 : n.value) == null ? void 0 : v.getAttributes("image"), h = (g = n == null ? void 0 : n.value) == null ? void 0 : g.getAttributes("imageView");
      return r.value ? d : h;
    }), o = je(() => {
      var d;
      return (d = s.value) == null ? void 0 : d.src;
    }), a = je(() => {
      const d = {};
      return d.fullscreen = e.fullscreen, e.objectFit && e.objectFit !== Od && (d.objectFit = e.objectFit), d;
    }), l = () => {
      var d, h, v, g;
      e.alt = (d = s.value) == null ? void 0 : d.alt, e.description = (h = s.value) == null ? void 0 : h.description, e.fullscreen = (v = s.value) == null ? void 0 : v.fullscreen, e.objectFit = ((g = s.value) == null ? void 0 : g.objectFit) || Od;
    }, u = () => {
      n == null || n.value.chain().updateAttributes(i.value, { alt: e.alt || null }).run();
    }, c = () => {
      n == null || n.value.chain().setObjectFit(e.objectFit).run();
    };
    function f() {
      n == null || n.value.chain().updateAttributes(i.value, {
        fullscreen: e.fullscreen,
        description: e.description
      }).run();
    }
    return {
      form: e,
      attributes: s,
      imageSrc: o,
      imageStyles: a,
      initForm: l,
      onUpdateAttribute: () => {
        u(), f(), c(), t();
      }
    };
  },
  data() {
    return {
      visible: !1,
      objectFits: Nx
    };
  },
  watch: {
    visible: {
      handler: "initForm",
      immediate: !0
    }
  },
  methods: {
    close() {
      this.visible = !1;
    },
    onSave() {
      this.onUpdateAttribute(), this.close();
    }
  }
});
var Ej = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", [t("button-command", { attrs: { icon: "pencil-ruler-2-line", title: "Change Style" }, on: { click: function(r) {
    e.visible = !0;
  } } }), t("el-dialog", { attrs: { visible: e.visible, "append-to-body": "", title: "Edit image", width: "60%" }, on: { "update:visible": function(r) {
    e.visible = r;
  } } }, [t("div", { staticClass: "flex space-x-4" }, [t("div", { staticClass: "w-1/2" }, [t("img", { style: e.imageStyles, attrs: { alt: e.form.alt, src: e.imageSrc } })]), t("div", { staticClass: "flex flex-col w-1/2" }, [t("el-form", { staticClass: "flex-1", attrs: { "label-position": "top", size: "small" } }, [t("el-form-item", { attrs: { label: "Alternative Text" } }, [t("el-input", { attrs: { autocomplete: "off" }, model: { value: e.form.alt, callback: function(r) {
    e.$set(e.form, "alt", r);
  }, expression: "form.alt" } })], 1), t("el-form-item", { attrs: { label: "Fullscreen" } }, [t("el-switch", { model: { value: e.form.fullscreen, callback: function(r) {
    e.$set(e.form, "fullscreen", r);
  }, expression: "form.fullscreen" } })], 1), t("el-form-item", { attrs: { label: "Description" } }, [t("el-input", { attrs: { autocomplete: "off" }, model: { value: e.form.description, callback: function(r) {
    e.$set(e.form, "description", r);
  }, expression: "form.description" } })], 1), t("el-form-item", { attrs: { label: "Object fit" } }, [t("el-select", { staticClass: "w-full capitalize", model: { value: e.form.objectFit, callback: function(r) {
    e.$set(e.form, "objectFit", r);
  }, expression: "form.objectFit" } }, e._l(e.objectFits, function(r) {
    return t("el-option", { key: r, attrs: { label: r, value: r } });
  }), 1)], 1)], 1), t("div", { staticClass: "flex justify-end" }, [t("base-button", { staticStyle: { background: "coral" }, on: { click: e.close } }, [e._v("Hu\u1EF7")]), t("base-button", { staticClass: "ml-2", on: { click: e.onSave } }, [e._v("L\u01B0u")])], 1)], 1)])])], 1);
}, Tj = [], kj = /* @__PURE__ */ le(
  Oj,
  Ej,
  Tj,
  !1,
  null,
  null,
  null,
  null
);
const Mj = kj.exports;
const Aj = st({
  name: "ImageDisplayCommand",
  components: { ButtonCommand: yt, ElDropdown: Ff, ElDropdownMenu: zf, ElDropdownItem: Bf },
  setup() {
    const n = Ix, e = $e("editor");
    return { displayCollection: n, getLabelDisplay: (s) => Rx[s], handleSetDisplay: (s) => {
      e == null || e.value.chain().setDisplay(s).run();
    }, getIsActive: (s) => {
      const o = e == null ? void 0 : e.value.getAttributes("image");
      return (o == null ? void 0 : o.display) === s;
    } };
  }
});
var Pj = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("el-dropdown", { attrs: { trigger: "click" }, on: { command: e.handleSetDisplay } }, [t("button-command", { attrs: { icon: "layout-2-line", title: "Image Display" } }), t("el-dropdown-menu", { attrs: { slot: "dropdown" }, slot: "dropdown" }, e._l(e.displayCollection, function(r) {
    return t("el-dropdown-item", { key: r, class: { "is-active": e.getIsActive(r) }, attrs: { command: r } }, [e._v(" " + e._s(e.getLabelDisplay(r)) + " ")]);
  }), 1)], 1);
}, $j = [], Dj = /* @__PURE__ */ le(
  Aj,
  Pj,
  $j,
  !1,
  null,
  "f445fb6e",
  null,
  null
);
const Lj = Dj.exports, Nj = st({
  name: "MenuBubbleImage",
  components: { ImageDisplayCommand: Lj, ImageRestyleCommand: Mj, RemoveCommand: O2 }
});
var Ij = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "flex" }, [t("image-display-command"), t("image-restyle-command"), t("remove-command")], 1);
}, Rj = [], Fj = /* @__PURE__ */ le(
  Nj,
  Ij,
  Rj,
  !1,
  null,
  null,
  null,
  null
);
const zj = Fj.exports, Bj = st({
  name: "MenuBubbleText",
  components: { ButtonCommand: yt, FontSizeCommand: $y },
  props: {
    menuSettings: {
      type: Array,
      default: () => kl
    }
  },
  setup(n) {
    const e = $e("editor"), t = je(() => e != null && e.value ? [
      {
        icon: "bold",
        title: "Bold",
        isActive: e.value.isActive("bold"),
        action: () => e.value.chain().focus().toggleBold().run()
      },
      {
        icon: "italic",
        title: "Italic",
        isActive: e.value.isActive("italic"),
        action: () => e.value.chain().focus().toggleItalic().run()
      },
      {
        icon: "strikethrough",
        title: "Strike",
        isActive: e.value.isActive("strike"),
        action: () => e.value.chain().focus().toggleStrike().run()
      },
      {
        icon: "underline",
        title: "Underline",
        isActive: e.value.isActive("underline"),
        action: () => e.value.chain().focus().toggleUnderline().run()
      },
      {
        icon: "code-box-line",
        title: "Code Block",
        isActive: e.value.isActive("codeBlock"),
        action: () => e.value.chain().focus().toggleCodeBlock().run()
      },
      { title: "Font size", component: "font-size-command" },
      {
        icon: "h-1",
        title: "Heading 1",
        isActive: e.value.isActive("heading", { level: 1 }),
        action: () => e.value.chain().focus().toggleHeading({ level: 1 }).run()
      },
      {
        icon: "h-2",
        title: "Heading 2",
        isActive: e.value.isActive("heading", { level: 2 }),
        action: () => e.value.chain().focus().toggleHeading({ level: 2 }).run()
      },
      {
        icon: "h-3",
        title: "Heading 3",
        isActive: e.value.isActive("heading", { level: 3 }),
        action: () => e.value.chain().focus().toggleHeading({ level: 3 }).run()
      },
      {
        icon: "paragraph",
        title: "Paragraph",
        isActive: e.value.isActive("paragraph"),
        action: () => e.value.chain().focus().setParagraph().run()
      },
      {
        icon: "list-unordered",
        title: "Bullet List",
        isActive: e.value.isActive("bulletList"),
        action: () => e.value.chain().focus().toggleBulletList().run()
      },
      {
        icon: "list-ordered",
        title: "Ordered List",
        isActive: e.value.isActive("orderedList"),
        action: () => e.value.chain().focus().toggleOrderedList().run()
      }
    ] : []), r = je(() => {
      if (!n.menuSettings)
        return [];
      const i = n.menuSettings.map((o) => o.toLocaleLowerCase());
      return t.value.filter((o) => {
        var a;
        if (!!o.title)
          return i.includes((a = o.title) == null ? void 0 : a.toLocaleLowerCase());
      });
    });
    return { items: t, includeMenuSettings: r };
  }
});
var jj = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "flex" }, [e._l(e.includeMenuSettings, function(r) {
    return [r.component ? t(r.component, e._b({ key: r.component, tag: "component" }, "component", r, !1)) : t("button-command", { key: r.title, attrs: { title: r.title, icon: r.icon, "is-active": r.isActive }, on: { click: function(i) {
      r.action && r.action();
    } } })];
  })], 2);
}, Vj = [], Hj = /* @__PURE__ */ le(
  Bj,
  jj,
  Vj,
  !1,
  null,
  null,
  null,
  null
);
const Wj = Hj.exports;
const qj = st({
  name: "MenuBubble",
  components: {
    MenuBubbleImage: zj,
    MenuBubbleText: Wj,
    BubbleMenu: g2
  },
  props: {
    menuSettings: {
      type: Array,
      default: () => kl
    }
  },
  setup() {
    const n = $e("editor"), e = (s) => n == null ? void 0 : n.value.isActive(s), t = je(() => e("image") || e("imageView")), r = je(() => e("ratingCard")), i = je(() => e("skuCard"));
    return { editor: n, isImage: t, isRatingCard: r, isSkuCard: i };
  }
});
var Uj = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, e.editor ? t("bubble-menu", { staticClass: "bubble-menu", attrs: { editor: e.editor, tippyOptions: { zIndex: 1e3 } } }, [e.isImage ? t("menu-bubble-image") : t("menu-bubble-text", { attrs: { menuSettings: e.menuSettings } })], 1) : e._e();
}, Gj = [], Kj = /* @__PURE__ */ le(
  qj,
  Uj,
  Gj,
  !1,
  null,
  null,
  null,
  null
);
const Jj = Kj.exports, Xj = /^\s*>\s$/, Yj = xe.create({
  name: "blockquote",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  group: "block",
  defining: !0,
  parseHTML() {
    return [
      { tag: "blockquote" }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["blockquote", we(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setBlockquote: () => ({ commands: n }) => n.wrapIn(this.name),
      toggleBlockquote: () => ({ commands: n }) => n.toggleWrap(this.name),
      unsetBlockquote: () => ({ commands: n }) => n.lift(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-b": () => this.editor.commands.toggleBlockquote()
    };
  },
  addInputRules() {
    return [
      Rs({
        find: Xj,
        type: this.type
      })
    ];
  }
}), Qj = /(?:^|\s)((?:\*\*)((?:[^*]+))(?:\*\*))$/, Zj = /(?:^|\s)((?:\*\*)((?:[^*]+))(?:\*\*))/g, eV = /(?:^|\s)((?:__)((?:[^__]+))(?:__))$/, tV = /(?:^|\s)((?:__)((?:[^__]+))(?:__))/g, nV = Dt.create({
  name: "bold",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "strong"
      },
      {
        tag: "b",
        getAttrs: (n) => n.style.fontWeight !== "normal" && null
      },
      {
        style: "font-weight",
        getAttrs: (n) => /^(bold(er)?|[5-9]\d{2,})$/.test(n) && null
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["strong", we(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setBold: () => ({ commands: n }) => n.setMark(this.name),
      toggleBold: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetBold: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-b": () => this.editor.commands.toggleBold(),
      "Mod-B": () => this.editor.commands.toggleBold()
    };
  },
  addInputRules() {
    return [
      Li({
        find: Qj,
        type: this.type
      }),
      Li({
        find: eV,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Hr({
        find: Zj,
        type: this.type
      }),
      Hr({
        find: tV,
        type: this.type
      })
    ];
  }
}), rV = xe.create({
  name: "listItem",
  addOptions() {
    return {
      HTMLAttributes: {},
      bulletListTypeName: "bulletList",
      orderedListTypeName: "orderedList"
    };
  },
  content: "paragraph block*",
  defining: !0,
  parseHTML() {
    return [
      {
        tag: "li"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["li", we(this.options.HTMLAttributes, n), 0];
  },
  addKeyboardShortcuts() {
    return {
      Enter: () => this.editor.commands.splitListItem(this.name),
      Tab: () => this.editor.commands.sinkListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
  }
}), Vv = Dt.create({
  name: "textStyle",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "span",
        getAttrs: (n) => n.hasAttribute("style") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["span", we(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      removeEmptyTextStyle: () => ({ state: n, commands: e }) => {
        const t = no(n, this.type);
        return Object.entries(t).some(([, i]) => !!i) ? !0 : e.unsetMark(this.name);
      }
    };
  }
}), Hv = /^\s*([-+*])\s$/, iV = xe.create({
  name: "bulletList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  parseHTML() {
    return [
      { tag: "ul" }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["ul", we(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      toggleBulletList: () => ({ commands: n, chain: e }) => this.options.keepAttributes ? e().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(rV.name, this.editor.getAttributes(Vv.name)).run() : n.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-8": () => this.editor.commands.toggleBulletList()
    };
  },
  addInputRules() {
    let n = Rs({
      find: Hv,
      type: this.type
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (n = Rs({
      find: Hv,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: () => this.editor.getAttributes(Vv.name),
      editor: this.editor
    })), [
      n
    ];
  }
}), sV = /(?:^|\s)((?:`)((?:[^`]+))(?:`))$/, oV = /(?:^|\s)((?:`)((?:[^`]+))(?:`))/g, aV = Dt.create({
  name: "code",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  excludes: "_",
  code: !0,
  exitable: !0,
  parseHTML() {
    return [
      { tag: "code" }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["code", we(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setCode: () => ({ commands: n }) => n.setMark(this.name),
      toggleCode: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetCode: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-e": () => this.editor.commands.toggleCode()
    };
  },
  addInputRules() {
    return [
      Li({
        find: sV,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Hr({
        find: oV,
        type: this.type
      })
    ];
  }
}), lV = /^```([a-z]+)?[\s\n]$/, uV = /^~~~([a-z]+)?[\s\n]$/, cV = xe.create({
  name: "codeBlock",
  addOptions() {
    return {
      languageClassPrefix: "language-",
      exitOnTripleEnter: !0,
      exitOnArrowDown: !0,
      HTMLAttributes: {}
    };
  },
  content: "text*",
  marks: "",
  group: "block",
  code: !0,
  defining: !0,
  addAttributes() {
    return {
      language: {
        default: null,
        parseHTML: (n) => {
          var e;
          const { languageClassPrefix: t } = this.options, s = [...((e = n.firstElementChild) === null || e === void 0 ? void 0 : e.classList) || []].filter((o) => o.startsWith(t)).map((o) => o.replace(t, ""))[0];
          return s || null;
        },
        rendered: !1
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "pre",
        preserveWhitespace: "full"
      }
    ];
  },
  renderHTML({ node: n, HTMLAttributes: e }) {
    return [
      "pre",
      we(this.options.HTMLAttributes, e),
      [
        "code",
        {
          class: n.attrs.language ? this.options.languageClassPrefix + n.attrs.language : null
        },
        0
      ]
    ];
  },
  addCommands() {
    return {
      setCodeBlock: (n) => ({ commands: e }) => e.setNode(this.name, n),
      toggleCodeBlock: (n) => ({ commands: e }) => e.toggleNode(this.name, "paragraph", n)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-c": () => this.editor.commands.toggleCodeBlock(),
      Backspace: () => {
        const { empty: n, $anchor: e } = this.editor.state.selection, t = e.pos === 1;
        return !n || e.parent.type.name !== this.name ? !1 : t || !e.parent.textContent.length ? this.editor.commands.clearNodes() : !1;
      },
      Enter: ({ editor: n }) => {
        if (!this.options.exitOnTripleEnter)
          return !1;
        const { state: e } = n, { selection: t } = e, { $from: r, empty: i } = t;
        if (!i || r.parent.type !== this.type)
          return !1;
        const s = r.parentOffset === r.parent.nodeSize - 2, o = r.parent.textContent.endsWith(`

`);
        return !s || !o ? !1 : n.chain().command(({ tr: a }) => (a.delete(r.pos - 2, r.pos), !0)).exitCode().run();
      },
      ArrowDown: ({ editor: n }) => {
        if (!this.options.exitOnArrowDown)
          return !1;
        const { state: e } = n, { selection: t, doc: r } = e, { $from: i, empty: s } = t;
        if (!s || i.parent.type !== this.type || !(i.parentOffset === i.parent.nodeSize - 2))
          return !1;
        const a = i.after();
        return a === void 0 || r.nodeAt(a) ? !1 : n.commands.exitCode();
      }
    };
  },
  addInputRules() {
    return [
      tf({
        find: lV,
        type: this.type,
        getAttributes: (n) => ({
          language: n[1]
        })
      }),
      tf({
        find: uV,
        type: this.type,
        getAttributes: (n) => ({
          language: n[1]
        })
      })
    ];
  },
  addProseMirrorPlugins() {
    return [
      new lt({
        key: new Zt("codeBlockVSCodeHandler"),
        props: {
          handlePaste: (n, e) => {
            if (!e.clipboardData || this.editor.isActive(this.type.name))
              return !1;
            const t = e.clipboardData.getData("text/plain"), r = e.clipboardData.getData("vscode-editor-data"), i = r ? JSON.parse(r) : void 0, s = i == null ? void 0 : i.mode;
            if (!t || !s)
              return !1;
            const { tr: o } = n.state;
            return o.replaceSelectionWith(this.type.create({ language: s })), o.setSelection(de.near(o.doc.resolve(Math.max(0, o.selection.from - 2)))), o.insertText(t.replace(/\r\n?/g, `
`)), o.setMeta("paste", !0), n.dispatch(o), !0;
          }
        }
      })
    ];
  }
}), dV = xe.create({
  name: "doc",
  topNode: !0,
  content: "block+"
});
function fV(n = {}) {
  return new lt({
    view(e) {
      return new pV(e, n);
    }
  });
}
class pV {
  constructor(e, t) {
    var r;
    this.editorView = e, this.cursorPos = null, this.element = null, this.timeout = -1, this.width = (r = t.width) !== null && r !== void 0 ? r : 1, this.color = t.color === !1 ? void 0 : t.color || "black", this.class = t.class, this.handlers = ["dragover", "dragend", "drop", "dragleave"].map((i) => {
      let s = (o) => {
        this[i](o);
      };
      return e.dom.addEventListener(i, s), { name: i, handler: s };
    });
  }
  destroy() {
    this.handlers.forEach(({ name: e, handler: t }) => this.editorView.dom.removeEventListener(e, t));
  }
  update(e, t) {
    this.cursorPos != null && t.doc != e.state.doc && (this.cursorPos > e.state.doc.content.size ? this.setCursor(null) : this.updateOverlay());
  }
  setCursor(e) {
    e != this.cursorPos && (this.cursorPos = e, e == null ? (this.element.parentNode.removeChild(this.element), this.element = null) : this.updateOverlay());
  }
  updateOverlay() {
    let e = this.editorView.state.doc.resolve(this.cursorPos), t = !e.parent.inlineContent, r;
    if (t) {
      let a = e.nodeBefore, l = e.nodeAfter;
      if (a || l) {
        let u = this.editorView.nodeDOM(this.cursorPos - (a ? a.nodeSize : 0));
        if (u) {
          let c = u.getBoundingClientRect(), f = a ? c.bottom : c.top;
          a && l && (f = (f + this.editorView.nodeDOM(this.cursorPos).getBoundingClientRect().top) / 2), r = { left: c.left, right: c.right, top: f - this.width / 2, bottom: f + this.width / 2 };
        }
      }
    }
    if (!r) {
      let a = this.editorView.coordsAtPos(this.cursorPos);
      r = { left: a.left - this.width / 2, right: a.left + this.width / 2, top: a.top, bottom: a.bottom };
    }
    let i = this.editorView.dom.offsetParent;
    this.element || (this.element = i.appendChild(document.createElement("div")), this.class && (this.element.className = this.class), this.element.style.cssText = "position: absolute; z-index: 50; pointer-events: none;", this.color && (this.element.style.backgroundColor = this.color)), this.element.classList.toggle("prosemirror-dropcursor-block", t), this.element.classList.toggle("prosemirror-dropcursor-inline", !t);
    let s, o;
    if (!i || i == document.body && getComputedStyle(i).position == "static")
      s = -pageXOffset, o = -pageYOffset;
    else {
      let a = i.getBoundingClientRect();
      s = a.left - i.scrollLeft, o = a.top - i.scrollTop;
    }
    this.element.style.left = r.left - s + "px", this.element.style.top = r.top - o + "px", this.element.style.width = r.right - r.left + "px", this.element.style.height = r.bottom - r.top + "px";
  }
  scheduleRemoval(e) {
    clearTimeout(this.timeout), this.timeout = setTimeout(() => this.setCursor(null), e);
  }
  dragover(e) {
    if (!this.editorView.editable)
      return;
    let t = this.editorView.posAtCoords({ left: e.clientX, top: e.clientY }), r = t && t.inside >= 0 && this.editorView.state.doc.nodeAt(t.inside), i = r && r.type.spec.disableDropCursor, s = typeof i == "function" ? i(this.editorView, t, e) : i;
    if (t && !s) {
      let o = t.pos;
      if (this.editorView.dragging && this.editorView.dragging.slice) {
        let a = g0(this.editorView.state.doc, o, this.editorView.dragging.slice);
        a != null && (o = a);
      }
      this.setCursor(o), this.scheduleRemoval(5e3);
    }
  }
  dragend() {
    this.scheduleRemoval(20);
  }
  drop() {
    this.scheduleRemoval(20);
  }
  dragleave(e) {
    (e.target == this.editorView.dom || !this.editorView.dom.contains(e.relatedTarget)) && this.setCursor(null);
  }
}
const hV = Ve.create({
  name: "dropCursor",
  addOptions() {
    return {
      color: "currentColor",
      width: 1,
      class: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      fV(this.options)
    ];
  }
});
class Ae extends me {
  constructor(e) {
    super(e, e);
  }
  map(e, t) {
    let r = e.resolve(t.map(this.head));
    return Ae.valid(r) ? new Ae(r) : me.near(r);
  }
  content() {
    return X.empty;
  }
  eq(e) {
    return e instanceof Ae && e.head == this.head;
  }
  toJSON() {
    return { type: "gapcursor", pos: this.head };
  }
  static fromJSON(e, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for GapCursor.fromJSON");
    return new Ae(e.resolve(t.pos));
  }
  getBookmark() {
    return new Qp(this.anchor);
  }
  static valid(e) {
    let t = e.parent;
    if (t.isTextblock || !mV(e) || !gV(e))
      return !1;
    let r = t.type.spec.allowGapCursor;
    if (r != null)
      return r;
    let i = t.contentMatchAt(e.index()).defaultType;
    return i && i.isTextblock;
  }
  static findGapCursorFrom(e, t, r = !1) {
    e:
      for (; ; ) {
        if (!r && Ae.valid(e))
          return e;
        let i = e.pos, s = null;
        for (let o = e.depth; ; o--) {
          let a = e.node(o);
          if (t > 0 ? e.indexAfter(o) < a.childCount : e.index(o) > 0) {
            s = a.child(t > 0 ? e.indexAfter(o) : e.index(o) - 1);
            break;
          } else if (o == 0)
            return null;
          i += t;
          let l = e.doc.resolve(i);
          if (Ae.valid(l))
            return l;
        }
        for (; ; ) {
          let o = t > 0 ? s.firstChild : s.lastChild;
          if (!o) {
            if (s.isAtom && !s.isText && !te.isSelectable(s)) {
              e = e.doc.resolve(i + s.nodeSize * t), r = !1;
              continue e;
            }
            break;
          }
          s = o, i += t;
          let a = e.doc.resolve(i);
          if (Ae.valid(a))
            return a;
        }
        return null;
      }
  }
}
Ae.prototype.visible = !1;
Ae.findFrom = Ae.findGapCursorFrom;
me.jsonID("gapcursor", Ae);
class Qp {
  constructor(e) {
    this.pos = e;
  }
  map(e) {
    return new Qp(e.map(this.pos));
  }
  resolve(e) {
    let t = e.resolve(this.pos);
    return Ae.valid(t) ? new Ae(t) : me.near(t);
  }
}
function mV(n) {
  for (let e = n.depth; e >= 0; e--) {
    let t = n.index(e), r = n.node(e);
    if (t == 0) {
      if (r.type.spec.isolating)
        return !0;
      continue;
    }
    for (let i = r.child(t - 1); ; i = i.lastChild) {
      if (i.childCount == 0 && !i.inlineContent || i.isAtom || i.type.spec.isolating)
        return !0;
      if (i.inlineContent)
        return !1;
    }
  }
  return !0;
}
function gV(n) {
  for (let e = n.depth; e >= 0; e--) {
    let t = n.indexAfter(e), r = n.node(e);
    if (t == r.childCount) {
      if (r.type.spec.isolating)
        return !0;
      continue;
    }
    for (let i = r.child(t); ; i = i.firstChild) {
      if (i.childCount == 0 && !i.inlineContent || i.isAtom || i.type.spec.isolating)
        return !0;
      if (i.inlineContent)
        return !1;
    }
  }
  return !0;
}
function vV() {
  return new lt({
    props: {
      decorations: _V,
      createSelectionBetween(n, e, t) {
        return e.pos == t.pos && Ae.valid(t) ? new Ae(t) : null;
      },
      handleClick: bV,
      handleKeyDown: yV,
      handleDOMEvents: { beforeinput: wV }
    }
  });
}
const yV = rw({
  ArrowLeft: jo("horiz", -1),
  ArrowRight: jo("horiz", 1),
  ArrowUp: jo("vert", -1),
  ArrowDown: jo("vert", 1)
});
function jo(n, e) {
  const t = n == "vert" ? e > 0 ? "down" : "up" : e > 0 ? "right" : "left";
  return function(r, i, s) {
    let o = r.selection, a = e > 0 ? o.$to : o.$from, l = o.empty;
    if (o instanceof de) {
      if (!s.endOfTextblock(t) || a.depth == 0)
        return !1;
      l = !1, a = r.doc.resolve(e > 0 ? a.after() : a.before());
    }
    let u = Ae.findGapCursorFrom(a, e, l);
    return u ? (i && i(r.tr.setSelection(new Ae(u))), !0) : !1;
  };
}
function bV(n, e, t) {
  if (!n || !n.editable)
    return !1;
  let r = n.state.doc.resolve(e);
  if (!Ae.valid(r))
    return !1;
  let i = n.posAtCoords({ left: t.clientX, top: t.clientY });
  return i && i.inside > -1 && te.isSelectable(n.state.doc.nodeAt(i.inside)) ? !1 : (n.dispatch(n.state.tr.setSelection(new Ae(r))), !0);
}
function wV(n, e) {
  if (e.inputType != "insertCompositionText" || !(n.state.selection instanceof Ae))
    return !1;
  let { $from: t } = n.state.selection, r = t.parent.contentMatchAt(t.index()).findWrapping(n.state.schema.nodes.text);
  if (!r)
    return !1;
  let i = V.empty;
  for (let o = r.length - 1; o >= 0; o--)
    i = V.from(r[o].createAndFill(null, i));
  let s = n.state.tr.replace(t.pos, t.pos, new X(i, 0, 0));
  return s.setSelection(de.near(s.doc.resolve(t.pos + 1))), n.dispatch(s), !1;
}
function _V(n) {
  if (!(n.selection instanceof Ae))
    return null;
  let e = document.createElement("div");
  return e.className = "ProseMirror-gapcursor", Be.create(n.doc, [Ut.widget(n.selection.head, e, { key: "gapcursor" })]);
}
const SV = Ve.create({
  name: "gapCursor",
  addProseMirrorPlugins() {
    return [
      vV()
    ];
  },
  extendNodeSchema(n) {
    var e;
    const t = {
      name: n.name,
      options: n.options,
      storage: n.storage
    };
    return {
      allowGapCursor: (e = he(Z(n, "allowGapCursor", t))) !== null && e !== void 0 ? e : null
    };
  }
}), xV = xe.create({
  name: "hardBreak",
  addOptions() {
    return {
      keepMarks: !0,
      HTMLAttributes: {}
    };
  },
  inline: !0,
  group: "inline",
  selectable: !1,
  parseHTML() {
    return [
      { tag: "br" }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["br", we(this.options.HTMLAttributes, n)];
  },
  renderText() {
    return `
`;
  },
  addCommands() {
    return {
      setHardBreak: () => ({ commands: n, chain: e, state: t, editor: r }) => n.first([
        () => n.exitCode(),
        () => n.command(() => {
          const { selection: i, storedMarks: s } = t;
          if (i.$from.parent.type.spec.isolating)
            return !1;
          const { keepMarks: o } = this.options, { splittableMarks: a } = r.extensionManager, l = s || i.$to.parentOffset && i.$from.marks();
          return e().insertContent({ type: this.name }).command(({ tr: u, dispatch: c }) => {
            if (c && l && o) {
              const f = l.filter((p) => a.includes(p.type.name));
              u.ensureMarks(f);
            }
            return !0;
          }).run();
        })
      ])
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Enter": () => this.editor.commands.setHardBreak(),
      "Shift-Enter": () => this.editor.commands.setHardBreak()
    };
  }
}), CV = xe.create({
  name: "heading",
  addOptions() {
    return {
      levels: [1, 2, 3, 4, 5, 6],
      HTMLAttributes: {}
    };
  },
  content: "inline*",
  group: "block",
  defining: !0,
  addAttributes() {
    return {
      level: {
        default: 1,
        rendered: !1
      }
    };
  },
  parseHTML() {
    return this.options.levels.map((n) => ({
      tag: `h${n}`,
      attrs: { level: n }
    }));
  },
  renderHTML({ node: n, HTMLAttributes: e }) {
    return [`h${this.options.levels.includes(n.attrs.level) ? n.attrs.level : this.options.levels[0]}`, we(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setHeading: (n) => ({ commands: e }) => this.options.levels.includes(n.level) ? e.setNode(this.name, n) : !1,
      toggleHeading: (n) => ({ commands: e }) => this.options.levels.includes(n.level) ? e.toggleNode(this.name, "paragraph", n) : !1
    };
  },
  addKeyboardShortcuts() {
    return this.options.levels.reduce((n, e) => ({
      ...n,
      [`Mod-Alt-${e}`]: () => this.editor.commands.toggleHeading({ level: e })
    }), {});
  },
  addInputRules() {
    return this.options.levels.map((n) => tf({
      find: new RegExp(`^(#{1,${n}})\\s$`),
      type: this.type,
      getAttributes: {
        level: n
      }
    }));
  }
});
var Va = 200, Ue = function() {
};
Ue.prototype.append = function(e) {
  return e.length ? (e = Ue.from(e), !this.length && e || e.length < Va && this.leafAppend(e) || this.length < Va && e.leafPrepend(this) || this.appendInner(e)) : this;
};
Ue.prototype.prepend = function(e) {
  return e.length ? Ue.from(e).append(this) : this;
};
Ue.prototype.appendInner = function(e) {
  return new OV(this, e);
};
Ue.prototype.slice = function(e, t) {
  return e === void 0 && (e = 0), t === void 0 && (t = this.length), e >= t ? Ue.empty : this.sliceInner(Math.max(0, e), Math.min(this.length, t));
};
Ue.prototype.get = function(e) {
  if (!(e < 0 || e >= this.length))
    return this.getInner(e);
};
Ue.prototype.forEach = function(e, t, r) {
  t === void 0 && (t = 0), r === void 0 && (r = this.length), t <= r ? this.forEachInner(e, t, r, 0) : this.forEachInvertedInner(e, t, r, 0);
};
Ue.prototype.map = function(e, t, r) {
  t === void 0 && (t = 0), r === void 0 && (r = this.length);
  var i = [];
  return this.forEach(function(s, o) {
    return i.push(e(s, o));
  }, t, r), i;
};
Ue.from = function(e) {
  return e instanceof Ue ? e : e && e.length ? new b_(e) : Ue.empty;
};
var b_ = /* @__PURE__ */ function(n) {
  function e(r) {
    n.call(this), this.values = r;
  }
  n && (e.__proto__ = n), e.prototype = Object.create(n && n.prototype), e.prototype.constructor = e;
  var t = { length: { configurable: !0 }, depth: { configurable: !0 } };
  return e.prototype.flatten = function() {
    return this.values;
  }, e.prototype.sliceInner = function(i, s) {
    return i == 0 && s == this.length ? this : new e(this.values.slice(i, s));
  }, e.prototype.getInner = function(i) {
    return this.values[i];
  }, e.prototype.forEachInner = function(i, s, o, a) {
    for (var l = s; l < o; l++)
      if (i(this.values[l], a + l) === !1)
        return !1;
  }, e.prototype.forEachInvertedInner = function(i, s, o, a) {
    for (var l = s - 1; l >= o; l--)
      if (i(this.values[l], a + l) === !1)
        return !1;
  }, e.prototype.leafAppend = function(i) {
    if (this.length + i.length <= Va)
      return new e(this.values.concat(i.flatten()));
  }, e.prototype.leafPrepend = function(i) {
    if (this.length + i.length <= Va)
      return new e(i.flatten().concat(this.values));
  }, t.length.get = function() {
    return this.values.length;
  }, t.depth.get = function() {
    return 0;
  }, Object.defineProperties(e.prototype, t), e;
}(Ue);
Ue.empty = new b_([]);
var OV = /* @__PURE__ */ function(n) {
  function e(t, r) {
    n.call(this), this.left = t, this.right = r, this.length = t.length + r.length, this.depth = Math.max(t.depth, r.depth) + 1;
  }
  return n && (e.__proto__ = n), e.prototype = Object.create(n && n.prototype), e.prototype.constructor = e, e.prototype.flatten = function() {
    return this.left.flatten().concat(this.right.flatten());
  }, e.prototype.getInner = function(r) {
    return r < this.left.length ? this.left.get(r) : this.right.get(r - this.left.length);
  }, e.prototype.forEachInner = function(r, i, s, o) {
    var a = this.left.length;
    if (i < a && this.left.forEachInner(r, i, Math.min(s, a), o) === !1 || s > a && this.right.forEachInner(r, Math.max(i - a, 0), Math.min(this.length, s) - a, o + a) === !1)
      return !1;
  }, e.prototype.forEachInvertedInner = function(r, i, s, o) {
    var a = this.left.length;
    if (i > a && this.right.forEachInvertedInner(r, i - a, Math.max(s, a) - a, o + a) === !1 || s < a && this.left.forEachInvertedInner(r, Math.min(i, a), s, o) === !1)
      return !1;
  }, e.prototype.sliceInner = function(r, i) {
    if (r == 0 && i == this.length)
      return this;
    var s = this.left.length;
    return i <= s ? this.left.slice(r, i) : r >= s ? this.right.slice(r - s, i - s) : this.left.slice(r, s).append(this.right.slice(0, i - s));
  }, e.prototype.leafAppend = function(r) {
    var i = this.right.leafAppend(r);
    if (i)
      return new e(this.left, i);
  }, e.prototype.leafPrepend = function(r) {
    var i = this.left.leafPrepend(r);
    if (i)
      return new e(i, this.right);
  }, e.prototype.appendInner = function(r) {
    return this.left.depth >= Math.max(this.right.depth, r.depth) + 1 ? new e(this.left, new e(this.right, r)) : new e(this, r);
  }, e;
}(Ue);
const EV = 500;
class nn {
  constructor(e, t) {
    this.items = e, this.eventCount = t;
  }
  popEvent(e, t) {
    if (this.eventCount == 0)
      return null;
    let r = this.items.length;
    for (; ; r--)
      if (this.items.get(r - 1).selection) {
        --r;
        break;
      }
    let i, s;
    t && (i = this.remapping(r, this.items.length), s = i.maps.length);
    let o = e.tr, a, l, u = [], c = [];
    return this.items.forEach((f, p) => {
      if (!f.step) {
        i || (i = this.remapping(r, p + 1), s = i.maps.length), s--, c.push(f);
        return;
      }
      if (i) {
        c.push(new dn(f.map));
        let d = f.step.map(i.slice(s)), h;
        d && o.maybeStep(d).doc && (h = o.mapping.maps[o.mapping.maps.length - 1], u.push(new dn(h, void 0, void 0, u.length + c.length))), s--, h && i.appendMap(h, s);
      } else
        o.maybeStep(f.step);
      if (f.selection)
        return a = i ? f.selection.map(i.slice(s)) : f.selection, l = new nn(this.items.slice(0, r).append(c.reverse().concat(u)), this.eventCount - 1), !1;
    }, this.items.length, 0), { remaining: l, transform: o, selection: a };
  }
  addTransform(e, t, r, i) {
    let s = [], o = this.eventCount, a = this.items, l = !i && a.length ? a.get(a.length - 1) : null;
    for (let c = 0; c < e.steps.length; c++) {
      let f = e.steps[c].invert(e.docs[c]), p = new dn(e.mapping.maps[c], f, t), d;
      (d = l && l.merge(p)) && (p = d, c ? s.pop() : a = a.slice(0, a.length - 1)), s.push(p), t && (o++, t = void 0), i || (l = p);
    }
    let u = o - r.depth;
    return u > kV && (a = TV(a, u), o -= u), new nn(a.append(s), o);
  }
  remapping(e, t) {
    let r = new wi();
    return this.items.forEach((i, s) => {
      let o = i.mirrorOffset != null && s - i.mirrorOffset >= e ? r.maps.length - i.mirrorOffset : void 0;
      r.appendMap(i.map, o);
    }, e, t), r;
  }
  addMaps(e) {
    return this.eventCount == 0 ? this : new nn(this.items.append(e.map((t) => new dn(t))), this.eventCount);
  }
  rebased(e, t) {
    if (!this.eventCount)
      return this;
    let r = [], i = Math.max(0, this.items.length - t), s = e.mapping, o = e.steps.length, a = this.eventCount;
    this.items.forEach((p) => {
      p.selection && a--;
    }, i);
    let l = t;
    this.items.forEach((p) => {
      let d = s.getMirror(--l);
      if (d == null)
        return;
      o = Math.min(o, d);
      let h = s.maps[d];
      if (p.step) {
        let v = e.steps[d].invert(e.docs[d]), g = p.selection && p.selection.map(s.slice(l + 1, d));
        g && a++, r.push(new dn(h, v, g));
      } else
        r.push(new dn(h));
    }, i);
    let u = [];
    for (let p = t; p < o; p++)
      u.push(new dn(s.maps[p]));
    let c = this.items.slice(0, i).append(u).append(r), f = new nn(c, a);
    return f.emptyItemCount() > EV && (f = f.compress(this.items.length - r.length)), f;
  }
  emptyItemCount() {
    let e = 0;
    return this.items.forEach((t) => {
      t.step || e++;
    }), e;
  }
  compress(e = this.items.length) {
    let t = this.remapping(0, e), r = t.maps.length, i = [], s = 0;
    return this.items.forEach((o, a) => {
      if (a >= e)
        i.push(o), o.selection && s++;
      else if (o.step) {
        let l = o.step.map(t.slice(r)), u = l && l.getMap();
        if (r--, u && t.appendMap(u, r), l) {
          let c = o.selection && o.selection.map(t.slice(r));
          c && s++;
          let f = new dn(u.invert(), l, c), p, d = i.length - 1;
          (p = i.length && i[d].merge(f)) ? i[d] = p : i.push(f);
        }
      } else
        o.map && r--;
    }, this.items.length, 0), new nn(Ue.from(i.reverse()), s);
  }
}
nn.empty = new nn(Ue.empty, 0);
function TV(n, e) {
  let t;
  return n.forEach((r, i) => {
    if (r.selection && e-- == 0)
      return t = i, !1;
  }), n.slice(t);
}
class dn {
  constructor(e, t, r, i) {
    this.map = e, this.step = t, this.selection = r, this.mirrorOffset = i;
  }
  merge(e) {
    if (this.step && e.step && !e.selection) {
      let t = e.step.merge(this.step);
      if (t)
        return new dn(t.getMap().invert(), t, this.selection);
    }
  }
}
class qn {
  constructor(e, t, r, i, s) {
    this.done = e, this.undone = t, this.prevRanges = r, this.prevTime = i, this.prevComposition = s;
  }
}
const kV = 20;
function MV(n, e, t, r) {
  let i = t.getMeta(cr), s;
  if (i)
    return i.historyState;
  t.getMeta(PV) && (n = new qn(n.done, n.undone, null, 0, -1));
  let o = t.getMeta("appendedTransaction");
  if (t.steps.length == 0)
    return n;
  if (o && o.getMeta(cr))
    return o.getMeta(cr).redo ? new qn(n.done.addTransform(t, void 0, r, aa(e)), n.undone, Wv(t.mapping.maps[t.steps.length - 1]), n.prevTime, n.prevComposition) : new qn(n.done, n.undone.addTransform(t, void 0, r, aa(e)), null, n.prevTime, n.prevComposition);
  if (t.getMeta("addToHistory") !== !1 && !(o && o.getMeta("addToHistory") === !1)) {
    let a = t.getMeta("composition"), l = n.prevTime == 0 || !o && n.prevComposition != a && (n.prevTime < (t.time || 0) - r.newGroupDelay || !AV(t, n.prevRanges)), u = o ? pd(n.prevRanges, t.mapping) : Wv(t.mapping.maps[t.steps.length - 1]);
    return new qn(n.done.addTransform(t, l ? e.selection.getBookmark() : void 0, r, aa(e)), nn.empty, u, t.time, a == null ? n.prevComposition : a);
  } else
    return (s = t.getMeta("rebased")) ? new qn(n.done.rebased(t, s), n.undone.rebased(t, s), pd(n.prevRanges, t.mapping), n.prevTime, n.prevComposition) : new qn(n.done.addMaps(t.mapping.maps), n.undone.addMaps(t.mapping.maps), pd(n.prevRanges, t.mapping), n.prevTime, n.prevComposition);
}
function AV(n, e) {
  if (!e)
    return !1;
  if (!n.docChanged)
    return !0;
  let t = !1;
  return n.mapping.maps[0].forEach((r, i) => {
    for (let s = 0; s < e.length; s += 2)
      r <= e[s + 1] && i >= e[s] && (t = !0);
  }), t;
}
function Wv(n) {
  let e = [];
  return n.forEach((t, r, i, s) => e.push(i, s)), e;
}
function pd(n, e) {
  if (!n)
    return null;
  let t = [];
  for (let r = 0; r < n.length; r += 2) {
    let i = e.map(n[r], 1), s = e.map(n[r + 1], -1);
    i <= s && t.push(i, s);
  }
  return t;
}
function w_(n, e, t, r) {
  let i = aa(e), s = cr.get(e).spec.config, o = (r ? n.undone : n.done).popEvent(e, i);
  if (!o)
    return;
  let a = o.selection.resolve(o.transform.doc), l = (r ? n.done : n.undone).addTransform(o.transform, e.selection.getBookmark(), s, i), u = new qn(r ? l : o.remaining, r ? o.remaining : l, null, 0, -1);
  t(o.transform.setSelection(a).setMeta(cr, { redo: r, historyState: u }).scrollIntoView());
}
let hd = !1, qv = null;
function aa(n) {
  let e = n.plugins;
  if (qv != e) {
    hd = !1, qv = e;
    for (let t = 0; t < e.length; t++)
      if (e[t].spec.historyPreserveItems) {
        hd = !0;
        break;
      }
  }
  return hd;
}
const cr = new Zt("history"), PV = new Zt("closeHistory");
function $V(n = {}) {
  return n = {
    depth: n.depth || 100,
    newGroupDelay: n.newGroupDelay || 500
  }, new lt({
    key: cr,
    state: {
      init() {
        return new qn(nn.empty, nn.empty, null, 0, -1);
      },
      apply(e, t, r) {
        return MV(t, r, e, n);
      }
    },
    config: n,
    props: {
      handleDOMEvents: {
        beforeinput(e, t) {
          let r = t.inputType, i = r == "historyUndo" ? __ : r == "historyRedo" ? S_ : null;
          return i ? (t.preventDefault(), i(e.state, e.dispatch)) : !1;
        }
      }
    }
  });
}
const __ = (n, e) => {
  let t = cr.getState(n);
  return !t || t.done.eventCount == 0 ? !1 : (e && w_(t, n, e, !1), !0);
}, S_ = (n, e) => {
  let t = cr.getState(n);
  return !t || t.undone.eventCount == 0 ? !1 : (e && w_(t, n, e, !0), !0);
}, DV = Ve.create({
  name: "history",
  addOptions() {
    return {
      depth: 100,
      newGroupDelay: 500
    };
  },
  addCommands() {
    return {
      undo: () => ({ state: n, dispatch: e }) => __(n, e),
      redo: () => ({ state: n, dispatch: e }) => S_(n, e)
    };
  },
  addProseMirrorPlugins() {
    return [
      $V(this.options)
    ];
  },
  addKeyboardShortcuts() {
    return {
      "Mod-z": () => this.editor.commands.undo(),
      "Mod-Z": () => this.editor.commands.undo(),
      "Mod-y": () => this.editor.commands.redo(),
      "Mod-Y": () => this.editor.commands.redo(),
      "Shift-Mod-z": () => this.editor.commands.redo(),
      "Shift-Mod-Z": () => this.editor.commands.redo(),
      "Mod-\u044F": () => this.editor.commands.undo(),
      "Shift-Mod-\u044F": () => this.editor.commands.redo()
    };
  }
}), LV = xe.create({
  name: "horizontalRule",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  parseHTML() {
    return [{ tag: "hr" }];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["hr", we(this.options.HTMLAttributes, n)];
  },
  addCommands() {
    return {
      setHorizontalRule: () => ({ chain: n, state: e }) => {
        const { $to: t } = e.selection, r = n();
        return t.parentOffset === 0 ? r.insertContentAt(Math.max(t.pos - 2, 0), { type: this.name }) : r.insertContent({ type: this.name }), r.command(({ tr: i, dispatch: s }) => {
          var o;
          if (s) {
            const { $to: a } = i.selection, l = a.end();
            if (a.nodeAfter)
              a.nodeAfter.isTextblock ? i.setSelection(de.create(i.doc, a.pos + 1)) : a.nodeAfter.isBlock ? i.setSelection(te.create(i.doc, a.pos)) : i.setSelection(de.create(i.doc, a.pos));
            else {
              const u = (o = a.parent.type.contentMatch.defaultType) === null || o === void 0 ? void 0 : o.create();
              u && (i.insert(l, u), i.setSelection(de.create(i.doc, l + 1)));
            }
            i.scrollIntoView();
          }
          return !0;
        }).run();
      }
    };
  },
  addInputRules() {
    return [
      vw({
        find: /^(?:---|—-|___\s|\*\*\*\s)$/,
        type: this.type
      })
    ];
  }
}), NV = /(?:^|\s)((?:\*)((?:[^*]+))(?:\*))$/, IV = /(?:^|\s)((?:\*)((?:[^*]+))(?:\*))/g, RV = /(?:^|\s)((?:_)((?:[^_]+))(?:_))$/, FV = /(?:^|\s)((?:_)((?:[^_]+))(?:_))/g, zV = Dt.create({
  name: "italic",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "em"
      },
      {
        tag: "i",
        getAttrs: (n) => n.style.fontStyle !== "normal" && null
      },
      {
        style: "font-style=italic"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["em", we(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setItalic: () => ({ commands: n }) => n.setMark(this.name),
      toggleItalic: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetItalic: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-i": () => this.editor.commands.toggleItalic(),
      "Mod-I": () => this.editor.commands.toggleItalic()
    };
  },
  addInputRules() {
    return [
      Li({
        find: NV,
        type: this.type
      }),
      Li({
        find: RV,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Hr({
        find: IV,
        type: this.type
      }),
      Hr({
        find: FV,
        type: this.type
      })
    ];
  }
}), BV = xe.create({
  name: "listItem",
  addOptions() {
    return {
      HTMLAttributes: {},
      bulletListTypeName: "bulletList",
      orderedListTypeName: "orderedList"
    };
  },
  content: "paragraph block*",
  defining: !0,
  parseHTML() {
    return [
      {
        tag: "li"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["li", we(this.options.HTMLAttributes, n), 0];
  },
  addKeyboardShortcuts() {
    return {
      Enter: () => this.editor.commands.splitListItem(this.name),
      Tab: () => this.editor.commands.sinkListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
  }
}), jV = xe.create({
  name: "listItem",
  addOptions() {
    return {
      HTMLAttributes: {},
      bulletListTypeName: "bulletList",
      orderedListTypeName: "orderedList"
    };
  },
  content: "paragraph block*",
  defining: !0,
  parseHTML() {
    return [
      {
        tag: "li"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["li", we(this.options.HTMLAttributes, n), 0];
  },
  addKeyboardShortcuts() {
    return {
      Enter: () => this.editor.commands.splitListItem(this.name),
      Tab: () => this.editor.commands.sinkListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
  }
}), Uv = Dt.create({
  name: "textStyle",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "span",
        getAttrs: (n) => n.hasAttribute("style") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["span", we(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      removeEmptyTextStyle: () => ({ state: n, commands: e }) => {
        const t = no(n, this.type);
        return Object.entries(t).some(([, i]) => !!i) ? !0 : e.unsetMark(this.name);
      }
    };
  }
}), Gv = /^(\d+)\.\s$/, VV = xe.create({
  name: "orderedList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  addAttributes() {
    return {
      start: {
        default: 1,
        parseHTML: (n) => n.hasAttribute("start") ? parseInt(n.getAttribute("start") || "", 10) : 1
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "ol"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    const { start: e, ...t } = n;
    return e === 1 ? ["ol", we(this.options.HTMLAttributes, t), 0] : ["ol", we(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      toggleOrderedList: () => ({ commands: n, chain: e }) => this.options.keepAttributes ? e().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(jV.name, this.editor.getAttributes(Uv.name)).run() : n.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-7": () => this.editor.commands.toggleOrderedList()
    };
  },
  addInputRules() {
    let n = Rs({
      find: Gv,
      type: this.type,
      getAttributes: (e) => ({ start: +e[1] }),
      joinPredicate: (e, t) => t.childCount + t.attrs.start === +e[1]
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (n = Rs({
      find: Gv,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: (e) => ({ start: +e[1], ...this.editor.getAttributes(Uv.name) }),
      joinPredicate: (e, t) => t.childCount + t.attrs.start === +e[1],
      editor: this.editor
    })), [
      n
    ];
  }
}), HV = xe.create({
  name: "paragraph",
  priority: 1e3,
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  content: "inline*",
  parseHTML() {
    return [
      { tag: "p" }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["p", we(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setParagraph: () => ({ commands: n }) => n.setNode(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-0": () => this.editor.commands.setParagraph()
    };
  }
}), WV = /(?:^|\s)((?:~~)((?:[^~]+))(?:~~))$/, qV = /(?:^|\s)((?:~~)((?:[^~]+))(?:~~))/g, UV = Dt.create({
  name: "strike",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "s"
      },
      {
        tag: "del"
      },
      {
        tag: "strike"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (n) => n.includes("line-through") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["s", we(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setStrike: () => ({ commands: n }) => n.setMark(this.name),
      toggleStrike: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetStrike: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    const n = {};
    return Sp() ? n["Mod-Shift-s"] = () => this.editor.commands.toggleStrike() : n["Ctrl-Shift-s"] = () => this.editor.commands.toggleStrike(), n;
  },
  addInputRules() {
    return [
      Li({
        find: WV,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Hr({
        find: qV,
        type: this.type
      })
    ];
  }
}), GV = xe.create({
  name: "text",
  group: "inline"
}), x_ = Ve.create({
  name: "starterKit",
  addExtensions() {
    var n, e, t, r, i, s, o, a, l, u, c, f, p, d, h, v, g, m;
    const _ = [];
    return this.options.blockquote !== !1 && _.push(Yj.configure((n = this.options) === null || n === void 0 ? void 0 : n.blockquote)), this.options.bold !== !1 && _.push(nV.configure((e = this.options) === null || e === void 0 ? void 0 : e.bold)), this.options.bulletList !== !1 && _.push(iV.configure((t = this.options) === null || t === void 0 ? void 0 : t.bulletList)), this.options.code !== !1 && _.push(aV.configure((r = this.options) === null || r === void 0 ? void 0 : r.code)), this.options.codeBlock !== !1 && _.push(cV.configure((i = this.options) === null || i === void 0 ? void 0 : i.codeBlock)), this.options.document !== !1 && _.push(dV.configure((s = this.options) === null || s === void 0 ? void 0 : s.document)), this.options.dropcursor !== !1 && _.push(hV.configure((o = this.options) === null || o === void 0 ? void 0 : o.dropcursor)), this.options.gapcursor !== !1 && _.push(SV.configure((a = this.options) === null || a === void 0 ? void 0 : a.gapcursor)), this.options.hardBreak !== !1 && _.push(xV.configure((l = this.options) === null || l === void 0 ? void 0 : l.hardBreak)), this.options.heading !== !1 && _.push(CV.configure((u = this.options) === null || u === void 0 ? void 0 : u.heading)), this.options.history !== !1 && _.push(DV.configure((c = this.options) === null || c === void 0 ? void 0 : c.history)), this.options.horizontalRule !== !1 && _.push(LV.configure((f = this.options) === null || f === void 0 ? void 0 : f.horizontalRule)), this.options.italic !== !1 && _.push(zV.configure((p = this.options) === null || p === void 0 ? void 0 : p.italic)), this.options.listItem !== !1 && _.push(BV.configure((d = this.options) === null || d === void 0 ? void 0 : d.listItem)), this.options.orderedList !== !1 && _.push(VV.configure((h = this.options) === null || h === void 0 ? void 0 : h.orderedList)), this.options.paragraph !== !1 && _.push(HV.configure((v = this.options) === null || v === void 0 ? void 0 : v.paragraph)), this.options.strike !== !1 && _.push(UV.configure((g = this.options) === null || g === void 0 ? void 0 : g.strike)), this.options.text !== !1 && _.push(GV.configure((m = this.options) === null || m === void 0 ? void 0 : m.text)), _;
  }
}), C_ = Ve.create({
  name: "textAlign",
  addOptions() {
    return {
      types: [],
      alignments: ["left", "center", "right", "justify"],
      defaultAlignment: "left"
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          textAlign: {
            default: this.options.defaultAlignment,
            parseHTML: (n) => n.style.textAlign || this.options.defaultAlignment,
            renderHTML: (n) => n.textAlign === this.options.defaultAlignment ? {} : { style: `text-align: ${n.textAlign}` }
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setTextAlign: (n) => ({ commands: e }) => this.options.alignments.includes(n) ? this.options.types.every((t) => e.updateAttributes(t, { textAlign: n })) : !1,
      unsetTextAlign: () => ({ commands: n }) => this.options.types.every((e) => n.resetAttributes(e, "textAlign"))
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-l": () => this.editor.commands.setTextAlign("left"),
      "Mod-Shift-e": () => this.editor.commands.setTextAlign("center"),
      "Mod-Shift-r": () => this.editor.commands.setTextAlign("right"),
      "Mod-Shift-j": () => this.editor.commands.setTextAlign("justify")
    };
  }
}), O_ = Dt.create({
  name: "textStyle",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "span",
        getAttrs: (n) => n.hasAttribute("style") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["span", we(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      removeEmptyTextStyle: () => ({ state: n, commands: e }) => {
        const t = no(n, this.type);
        return Object.entries(t).some(([, i]) => !!i) ? !0 : e.unsetMark(this.name);
      }
    };
  }
}), E_ = Dt.create({
  name: "underline",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "u"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (n) => n.includes("underline") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["u", we(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setUnderline: () => ({ commands: n }) => n.setMark(this.name),
      toggleUnderline: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetUnderline: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-u": () => this.editor.commands.toggleUnderline(),
      "Mod-U": () => this.editor.commands.toggleUnderline()
    };
  }
}), KV = "aaa1rp3bb0ott3vie4c1le2ogado5udhabi7c0ademy5centure6ountant0s9o1tor4d0s1ult4e0g1ro2tna4f0l1rica5g0akhan5ency5i0g1rbus3force5tel5kdn3l0ibaba4pay4lfinanz6state5y2sace3tom5m0azon4ericanexpress7family11x2fam3ica3sterdam8nalytics7droid5quan4z2o0l2partments8p0le4q0uarelle8r0ab1mco4chi3my2pa2t0e3s0da2ia2sociates9t0hleta5torney7u0ction5di0ble3o3spost5thor3o0s4vianca6w0s2x0a2z0ure5ba0by2idu3namex3narepublic11d1k2r0celona5laycard4s5efoot5gains6seball5ketball8uhaus5yern5b0c1t1va3cg1n2d1e0ats2uty4er2ntley5rlin4st0buy5t2f1g1h0arti5i0ble3d1ke2ng0o3o1z2j1lack0friday9ockbuster8g1omberg7ue3m0s1w2n0pparibas9o0ats3ehringer8fa2m1nd2o0k0ing5sch2tik2on4t1utique6x2r0adesco6idgestone9oadway5ker3ther5ussels7s1t1uild0ers6siness6y1zz3v1w1y1z0h3ca0b1fe2l0l1vinklein9m0era3p2non3petown5ital0one8r0avan4ds2e0er0s4s2sa1e1h1ino4t0ering5holic7ba1n1re3c1d1enter4o1rn3f0a1d2g1h0anel2nel4rity4se2t2eap3intai5ristmas6ome4urch5i0priani6rcle4sco3tadel4i0c2y3k1l0aims4eaning6ick2nic1que6othing5ud3ub0med6m1n1o0ach3des3ffee4llege4ogne5m0cast4mbank4unity6pany2re3uter5sec4ndos3struction8ulting7tact3ractors9oking4l1p2rsica5untry4pon0s4rses6pa2r0edit0card4union9icket5own3s1uise0s6u0isinella9v1w1x1y0mru3ou3z2dabur3d1nce3ta1e1ing3sun4y2clk3ds2e0al0er2s3gree4livery5l1oitte5ta3mocrat6ntal2ist5si0gn4v2hl2iamonds6et2gital5rect0ory7scount3ver5h2y2j1k1m1np2o0cs1tor4g1mains5t1wnload7rive4tv2ubai3nlop4pont4rban5vag2r2z2earth3t2c0o2deka3u0cation8e1g1mail3erck5nergy4gineer0ing9terprises10pson4quipment8r0icsson6ni3s0q1tate5t1u0rovision8s2vents5xchange6pert3osed4ress5traspace10fage2il1rwinds6th3mily4n0s2rm0ers5shion4t3edex3edback6rrari3ero6i0delity5o2lm2nal1nce1ial7re0stone6mdale6sh0ing5t0ness6j1k1lickr3ghts4r2orist4wers5y2m1o0o0d1tball6rd1ex2sale4um3undation8x2r0ee1senius7l1ogans4ntier7tr2ujitsu5n0d2rniture7tbol5yi3ga0l0lery3o1up4me0s3p1rden4y2b0iz3d0n2e0a1nt0ing5orge5f1g0ee3h1i0ft0s3ves2ing5l0ass3e1obal2o4m0ail3bh2o1x2n1odaddy5ld0point6f2o0dyear5g0le4p1t1v2p1q1r0ainger5phics5tis4een3ipe3ocery4up4s1t1u0ardian6cci3ge2ide2tars5ru3w1y2hair2mburg5ngout5us3bo2dfc0bank7ealth0care8lp1sinki6re1mes5iphop4samitsu7tachi5v2k0t2m1n1ockey4ldings5iday5medepot5goods5s0ense7nda3rse3spital5t0ing5t0els3mail5use3w2r1sbc3t1u0ghes5yatt3undai7ibm2cbc2e1u2d1e0ee3fm2kano4l1m0amat4db2mo0bilien9n0c1dustries8finiti5o2g1k1stitute6urance4e4t0ernational10uit4vestments10o1piranga7q1r0ish4s0maili5t0anbul7t0au2v3jaguar4va3cb2e0ep2tzt3welry6io2ll2m0p2nj2o0bs1urg4t1y2p0morgan6rs3uegos4niper7kaufen5ddi3e0rryhotels6logistics9properties14fh2g1h1i0a1ds2m1ndle4tchen5wi3m1n1oeln3matsu5sher5p0mg2n2r0d1ed3uokgroup8w1y0oto4z2la0caixa5mborghini8er3ncaster6d0rover6xess5salle5t0ino3robe5w0yer5b1c1ds2ease3clerc5frak4gal2o2xus4gbt3i0dl2fe0insurance9style7ghting6ke2lly3mited4o2ncoln4k2psy3ve1ing5k1lc1p2oan0s3cker3us3l1ndon4tte1o3ve3pl0financial11r1s1t0d0a3u0ndbeck6xe1ury5v1y2ma0drid4if1son4keup4n0agement7go3p1rket0ing3s4riott5shalls7ttel5ba2c0kinsey7d1e0d0ia3et2lbourne7me1orial6n0u2rckmsd7g1h1iami3crosoft7l1ni1t2t0subishi9k1l0b1s2m0a2n1o0bi0le4da2e1i1m1nash3ey2ster5rmon3tgage6scow4to0rcycles9v0ie4p1q1r1s0d2t0n1r2u0seum3ic4v1w1x1y1z2na0b1goya4me2tura4vy3ba2c1e0c1t0bank4flix4work5ustar5w0s2xt0direct7us4f0l2g0o2hk2i0co2ke1on3nja3ssan1y5l1o0kia3rton4w0ruz3tv4p1r0a1w2tt2u1yc2z2obi1server7ffice5kinawa6layan0group9dnavy5lo3m0ega4ne1g1l0ine5oo2pen3racle3nge4g0anic5igins6saka4tsuka4t2vh3pa0ge2nasonic7ris2s1tners4s1y3y2ccw3e0t2f0izer5g1h0armacy6d1ilips5one2to0graphy6s4ysio5ics1tet2ures6d1n0g1k2oneer5zza4k1l0ace2y0station9umbing5s3m1n0c2ohl2ker3litie5rn2st3r0america6xi3ess3ime3o0d0uctions8f1gressive8mo2perties3y5tection8u0dential9s1t1ub2w0c2y2qa1pon3uebec3st5racing4dio4e0ad1lestate6tor2y4cipes5d0stone5umbrella9hab3ise0n3t2liance6n0t0als5pair3ort3ublican8st0aurant8view0s5xroth6ich0ardli6oh3l1o1p2o0cks3deo3gers4om3s0vp3u0gby3hr2n2w0e2yukyu6sa0arland6fe0ty4kura4le1on3msclub4ung5ndvik0coromant12ofi4p1rl2s1ve2xo3b0i1s2c0a1b1haeffler7midt4olarships8ol3ule3warz5ience5ot3d1e0arch3t2cure1ity6ek2lect4ner3rvices6ven3w1x0y3fr2g1h0angrila6rp2w2ell3ia1ksha5oes2p0ping5uji3w3i0lk2na1gles5te3j1k0i0n2y0pe4l0ing4m0art3ile4n0cf3o0ccer3ial4ftbank4ware6hu2lar2utions7ng1y2y2pa0ce3ort2t3r0l2s1t0ada2ples4r1tebank4farm7c0group6ockholm6rage3e3ream4udio2y3yle4u0cks3pplies3y2ort5rf1gery5zuki5v1watch4iss4x1y0dney4stems6z2tab1ipei4lk2obao4rget4tamotors6r2too4x0i3c0i2d0k2eam2ch0nology8l1masek5nnis4va3f1g1h0d1eater2re6iaa2ckets5enda4ps2res2ol4j0maxx4x2k0maxx5l1m0all4n1o0day3kyo3ols3p1ray3shiba5tal3urs3wn2yota3s3r0ade1ing4ining5vel0ers0insurance16ust3v2t1ube2i1nes3shu4v0s2w1z2ua1bank3s2g1k1nicom3versity8o2ol2ps2s1y1z2va0cations7na1guard7c1e0gas3ntures6risign5m\xF6gensberater2ung14sicherung10t2g1i0ajes4deo3g1king4llas4n1p1rgin4sa1ion4va1o3laanderen9n1odka3lvo3te1ing3o2yage5u2wales2mart4ter4ng0gou5tch0es6eather0channel12bcam3er2site5d0ding5ibo2r3f1hoswho6ien2ki2lliamhill9n0dows4e1ners6me2olterskluwer11odside6rk0s2ld3w2s1tc1f3xbox3erox4finity6ihuan4n2xx2yz3yachts4hoo3maxun5ndex5e1odobashi7ga2kohama6u0tube6t1un3za0ppos4ra3ero3ip2m1one3uerich6w2", JV = "\u03B5\u03BB1\u03C52\u0431\u04331\u0435\u043B3\u0434\u0435\u0442\u04384\u0435\u044E2\u043A\u0430\u0442\u043E\u043B\u0438\u043A6\u043E\u043C3\u043C\u043A\u04342\u043E\u043D1\u0441\u043A\u0432\u04306\u043E\u043D\u043B\u0430\u0439\u043D5\u0440\u04333\u0440\u0443\u04412\u04442\u0441\u0430\u0439\u04423\u0440\u04313\u0443\u043A\u04403\u049B\u0430\u04373\u0570\u0561\u05753\u05D9\u05E9\u05E8\u05D0\u05DC5\u05E7\u05D5\u05DD3\u0627\u0628\u0648\u0638\u0628\u064A5\u0631\u0627\u0645\u0643\u06485\u0644\u0627\u0631\u062F\u06464\u0628\u062D\u0631\u064A\u06465\u062C\u0632\u0627\u0626\u06315\u0633\u0639\u0648\u062F\u064A\u06296\u0639\u0644\u064A\u0627\u06465\u0645\u063A\u0631\u06285\u0645\u0627\u0631\u0627\u062A5\u06CC\u0631\u0627\u06465\u0628\u0627\u0631\u062A2\u0632\u0627\u06314\u064A\u062A\u06433\u06BE\u0627\u0631\u062A5\u062A\u0648\u0646\u06334\u0633\u0648\u062F\u0627\u06463\u0631\u064A\u06295\u0634\u0628\u0643\u06294\u0639\u0631\u0627\u06422\u06282\u0645\u0627\u06464\u0641\u0644\u0633\u0637\u064A\u06466\u0642\u0637\u06313\u0643\u0627\u062B\u0648\u0644\u064A\u06436\u0648\u06453\u0645\u0635\u06312\u0644\u064A\u0633\u064A\u06275\u0648\u0631\u064A\u062A\u0627\u0646\u064A\u06277\u0642\u06394\u0647\u0645\u0631\u0627\u06475\u067E\u0627\u06A9\u0633\u062A\u0627\u06467\u0680\u0627\u0631\u062A4\u0915\u0949\u092E3\u0928\u0947\u091F3\u092D\u093E\u0930\u09240\u092E\u094D3\u094B\u09245\u0938\u0902\u0917\u0920\u09285\u09AC\u09BE\u0982\u09B2\u09BE5\u09AD\u09BE\u09B0\u09A42\u09F0\u09A44\u0A2D\u0A3E\u0A30\u0A244\u0AAD\u0ABE\u0AB0\u0AA44\u0B2D\u0B3E\u0B30\u0B244\u0B87\u0BA8\u0BCD\u0BA4\u0BBF\u0BAF\u0BBE6\u0BB2\u0B99\u0BCD\u0B95\u0BC86\u0B9A\u0BBF\u0B99\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0BC2\u0BB0\u0BCD11\u0C2D\u0C3E\u0C30\u0C24\u0C4D5\u0CAD\u0CBE\u0CB0\u0CA44\u0D2D\u0D3E\u0D30\u0D24\u0D025\u0DBD\u0D82\u0D9A\u0DCF4\u0E04\u0E2D\u0E213\u0E44\u0E17\u0E223\u0EA5\u0EB2\u0EA73\u10D2\u10D42\u307F\u3093\u306A3\u30A2\u30DE\u30BE\u30F34\u30AF\u30E9\u30A6\u30C94\u30B0\u30FC\u30B0\u30EB4\u30B3\u30E02\u30B9\u30C8\u30A23\u30BB\u30FC\u30EB3\u30D5\u30A1\u30C3\u30B7\u30E7\u30F36\u30DD\u30A4\u30F3\u30C84\u4E16\u754C2\u4E2D\u4FE11\u56FD1\u570B1\u6587\u7F513\u4E9A\u9A6C\u900A3\u4F01\u4E1A2\u4F5B\u5C712\u4FE1\u606F2\u5065\u5EB72\u516B\u53662\u516C\u53F81\u76CA2\u53F0\u6E7E1\u70632\u5546\u57CE1\u5E971\u68072\u5609\u91CC0\u5927\u9152\u5E975\u5728\u7EBF2\u5927\u62FF2\u5929\u4E3B\u65593\u5A31\u4E502\u5BB6\u96FB2\u5E7F\u4E1C2\u5FAE\u535A2\u6148\u55842\u6211\u7231\u4F603\u624B\u673A2\u62DB\u80582\u653F\u52A11\u5E9C2\u65B0\u52A0\u57612\u95FB2\u65F6\u5C1A2\u66F8\u7C4D2\u673A\u67842\u6DE1\u9A6C\u95213\u6E38\u620F2\u6FB3\u95802\u70B9\u770B2\u79FB\u52A82\u7EC4\u7EC7\u673A\u67844\u7F51\u57401\u5E971\u7AD91\u7EDC2\u8054\u901A2\u8C37\u6B4C2\u8D2D\u72692\u901A\u8CA92\u96C6\u56E22\u96FB\u8A0A\u76C8\u79D14\u98DE\u5229\u6D663\u98DF\u54C12\u9910\u53852\u9999\u683C\u91CC\u62C93\u6E2F2\uB2F7\uB1371\uCEF42\uC0BC\uC1312\uD55C\uAD6D2", zi = (n, e) => {
  for (const t in e)
    n[t] = e[t];
  return n;
}, yf = "numeric", bf = "ascii", wf = "alpha", la = "asciinumeric", Vo = "alphanumeric", _f = "domain", T_ = "emoji", XV = "scheme", YV = "slashscheme", Kv = "whitespace";
function QV(n, e) {
  return n in e || (e[n] = []), e[n];
}
function Pr(n, e, t) {
  e[yf] && (e[la] = !0, e[Vo] = !0), e[bf] && (e[la] = !0, e[wf] = !0), e[la] && (e[Vo] = !0), e[wf] && (e[Vo] = !0), e[Vo] && (e[_f] = !0), e[T_] && (e[_f] = !0);
  for (const r in e) {
    const i = QV(r, t);
    i.indexOf(n) < 0 && i.push(n);
  }
}
function ZV(n, e) {
  const t = {};
  for (const r in e)
    e[r].indexOf(n) >= 0 && (t[r] = !0);
  return t;
}
function St(n) {
  n === void 0 && (n = null), this.j = {}, this.jr = [], this.jd = null, this.t = n;
}
St.groups = {};
St.prototype = {
  accepts() {
    return !!this.t;
  },
  go(n) {
    const e = this, t = e.j[n];
    if (t)
      return t;
    for (let r = 0; r < e.jr.length; r++) {
      const i = e.jr[r][0], s = e.jr[r][1];
      if (s && i.test(n))
        return s;
    }
    return e.jd;
  },
  has(n, e) {
    return e === void 0 && (e = !1), e ? n in this.j : !!this.go(n);
  },
  ta(n, e, t, r) {
    for (let i = 0; i < n.length; i++)
      this.tt(n[i], e, t, r);
  },
  tr(n, e, t, r) {
    r = r || St.groups;
    let i;
    return e && e.j ? i = e : (i = new St(e), t && r && Pr(e, t, r)), this.jr.push([n, i]), i;
  },
  ts(n, e, t, r) {
    let i = this;
    const s = n.length;
    if (!s)
      return i;
    for (let o = 0; o < s - 1; o++)
      i = i.tt(n[o]);
    return i.tt(n[s - 1], e, t, r);
  },
  tt(n, e, t, r) {
    r = r || St.groups;
    const i = this;
    if (e && e.j)
      return i.j[n] = e, e;
    const s = e;
    let o, a = i.go(n);
    if (a ? (o = new St(), zi(o.j, a.j), o.jr.push.apply(o.jr, a.jr), o.jd = a.jd, o.t = a.t) : o = new St(), s) {
      if (r)
        if (o.t && typeof o.t == "string") {
          const l = zi(ZV(o.t, r), t);
          Pr(s, l, r);
        } else
          t && Pr(s, t, r);
      o.t = s;
    }
    return i.j[n] = o, o;
  }
};
const pe = (n, e, t, r, i) => n.ta(e, t, r, i), Vt = (n, e, t, r, i) => n.tr(e, t, r, i), Jv = (n, e, t, r, i) => n.ts(e, t, r, i), G = (n, e, t, r, i) => n.tt(e, t, r, i), An = "WORD", Sf = "UWORD", Ws = "LOCALHOST", xf = "TLD", Cf = "UTLD", ua = "SCHEME", mi = "SLASH_SCHEME", Zp = "NUM", k_ = "WS", eh = "NL", xs = "OPENBRACE", Cs = "CLOSEBRACE", Ha = "OPENBRACKET", Wa = "CLOSEBRACKET", qa = "OPENPAREN", Ua = "CLOSEPAREN", Ga = "OPENANGLEBRACKET", Ka = "CLOSEANGLEBRACKET", Ja = "FULLWIDTHLEFTPAREN", Xa = "FULLWIDTHRIGHTPAREN", Ya = "LEFTCORNERBRACKET", Qa = "RIGHTCORNERBRACKET", Za = "LEFTWHITECORNERBRACKET", el = "RIGHTWHITECORNERBRACKET", tl = "FULLWIDTHLESSTHAN", nl = "FULLWIDTHGREATERTHAN", rl = "AMPERSAND", il = "APOSTROPHE", sl = "ASTERISK", Un = "AT", ol = "BACKSLASH", al = "BACKTICK", ll = "CARET", Jn = "COLON", th = "COMMA", ul = "DOLLAR", fn = "DOT", cl = "EQUALS", nh = "EXCLAMATION", pn = "HYPHEN", dl = "PERCENT", fl = "PIPE", pl = "PLUS", hl = "POUND", ml = "QUERY", rh = "QUOTE", ih = "SEMI", hn = "SLASH", Os = "TILDE", gl = "UNDERSCORE", M_ = "EMOJI", vl = "SYM";
var A_ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  WORD: An,
  UWORD: Sf,
  LOCALHOST: Ws,
  TLD: xf,
  UTLD: Cf,
  SCHEME: ua,
  SLASH_SCHEME: mi,
  NUM: Zp,
  WS: k_,
  NL: eh,
  OPENBRACE: xs,
  CLOSEBRACE: Cs,
  OPENBRACKET: Ha,
  CLOSEBRACKET: Wa,
  OPENPAREN: qa,
  CLOSEPAREN: Ua,
  OPENANGLEBRACKET: Ga,
  CLOSEANGLEBRACKET: Ka,
  FULLWIDTHLEFTPAREN: Ja,
  FULLWIDTHRIGHTPAREN: Xa,
  LEFTCORNERBRACKET: Ya,
  RIGHTCORNERBRACKET: Qa,
  LEFTWHITECORNERBRACKET: Za,
  RIGHTWHITECORNERBRACKET: el,
  FULLWIDTHLESSTHAN: tl,
  FULLWIDTHGREATERTHAN: nl,
  AMPERSAND: rl,
  APOSTROPHE: il,
  ASTERISK: sl,
  AT: Un,
  BACKSLASH: ol,
  BACKTICK: al,
  CARET: ll,
  COLON: Jn,
  COMMA: th,
  DOLLAR: ul,
  DOT: fn,
  EQUALS: cl,
  EXCLAMATION: nh,
  HYPHEN: pn,
  PERCENT: dl,
  PIPE: fl,
  PLUS: pl,
  POUND: hl,
  QUERY: ml,
  QUOTE: rh,
  SEMI: ih,
  SLASH: hn,
  TILDE: Os,
  UNDERSCORE: gl,
  EMOJI: M_,
  SYM: vl
});
const ui = /[a-z]/, md = /\p{L}/u, gd = /\p{Emoji}/u, vd = /\d/, Xv = /\s/, Yv = `
`, eH = "\uFE0F", tH = "\u200D";
let Ho = null, Wo = null;
function nH(n) {
  n === void 0 && (n = []);
  const e = {};
  St.groups = e;
  const t = new St();
  Ho == null && (Ho = Qv(KV)), Wo == null && (Wo = Qv(JV)), G(t, "'", il), G(t, "{", xs), G(t, "}", Cs), G(t, "[", Ha), G(t, "]", Wa), G(t, "(", qa), G(t, ")", Ua), G(t, "<", Ga), G(t, ">", Ka), G(t, "\uFF08", Ja), G(t, "\uFF09", Xa), G(t, "\u300C", Ya), G(t, "\u300D", Qa), G(t, "\u300E", Za), G(t, "\u300F", el), G(t, "\uFF1C", tl), G(t, "\uFF1E", nl), G(t, "&", rl), G(t, "*", sl), G(t, "@", Un), G(t, "`", al), G(t, "^", ll), G(t, ":", Jn), G(t, ",", th), G(t, "$", ul), G(t, ".", fn), G(t, "=", cl), G(t, "!", nh), G(t, "-", pn), G(t, "%", dl), G(t, "|", fl), G(t, "+", pl), G(t, "#", hl), G(t, "?", ml), G(t, '"', rh), G(t, "/", hn), G(t, ";", ih), G(t, "~", Os), G(t, "_", gl), G(t, "\\", ol);
  const r = Vt(t, vd, Zp, {
    [yf]: !0
  });
  Vt(r, vd, r);
  const i = Vt(t, ui, An, {
    [bf]: !0
  });
  Vt(i, ui, i);
  const s = Vt(t, md, Sf, {
    [wf]: !0
  });
  Vt(s, ui), Vt(s, md, s);
  const o = Vt(t, Xv, k_, {
    [Kv]: !0
  });
  G(t, Yv, eh, {
    [Kv]: !0
  }), G(o, Yv), Vt(o, Xv, o);
  const a = Vt(t, gd, M_, {
    [T_]: !0
  });
  Vt(a, gd, a), G(a, eH, a);
  const l = G(a, tH);
  Vt(l, gd, a);
  const u = [[ui, i]], c = [[ui, null], [md, s]];
  for (let f = 0; f < Ho.length; f++)
    Vn(t, Ho[f], xf, An, u);
  for (let f = 0; f < Wo.length; f++)
    Vn(t, Wo[f], Cf, Sf, c);
  Pr(xf, {
    tld: !0,
    ascii: !0
  }, e), Pr(Cf, {
    utld: !0,
    alpha: !0
  }, e), Vn(t, "file", ua, An, u), Vn(t, "mailto", ua, An, u), Vn(t, "http", mi, An, u), Vn(t, "https", mi, An, u), Vn(t, "ftp", mi, An, u), Vn(t, "ftps", mi, An, u), Pr(ua, {
    scheme: !0,
    ascii: !0
  }, e), Pr(mi, {
    slashscheme: !0,
    ascii: !0
  }, e), n = n.sort((f, p) => f[0] > p[0] ? 1 : -1);
  for (let f = 0; f < n.length; f++) {
    const p = n[f][0], h = n[f][1] ? {
      [XV]: !0
    } : {
      [YV]: !0
    };
    p.indexOf("-") >= 0 ? h[_f] = !0 : ui.test(p) ? vd.test(p) ? h[la] = !0 : h[bf] = !0 : h[yf] = !0, Jv(t, p, p, h);
  }
  return Jv(t, "localhost", Ws, {
    ascii: !0
  }), t.jd = new St(vl), {
    start: t,
    tokens: zi({
      groups: e
    }, A_)
  };
}
function rH(n, e) {
  const t = iH(e.replace(/[A-Z]/g, (a) => a.toLowerCase())), r = t.length, i = [];
  let s = 0, o = 0;
  for (; o < r; ) {
    let a = n, l = null, u = 0, c = null, f = -1, p = -1;
    for (; o < r && (l = a.go(t[o])); )
      a = l, a.accepts() ? (f = 0, p = 0, c = a) : f >= 0 && (f += t[o].length, p++), u += t[o].length, s += t[o].length, o++;
    s -= f, o -= p, u -= f, i.push({
      t: c.t,
      v: e.slice(s - u, s),
      s: s - u,
      e: s
    });
  }
  return i;
}
function iH(n) {
  const e = [], t = n.length;
  let r = 0;
  for (; r < t; ) {
    let i = n.charCodeAt(r), s, o = i < 55296 || i > 56319 || r + 1 === t || (s = n.charCodeAt(r + 1)) < 56320 || s > 57343 ? n[r] : n.slice(r, r + 2);
    e.push(o), r += o.length;
  }
  return e;
}
function Vn(n, e, t, r, i) {
  let s;
  const o = e.length;
  for (let a = 0; a < o - 1; a++) {
    const l = e[a];
    n.j[l] ? s = n.j[l] : (s = new St(r), s.jr = i.slice(), n.j[l] = s), n = s;
  }
  return s = new St(t), s.jr = i.slice(), n.j[e[o - 1]] = s, s;
}
function Qv(n) {
  const e = [], t = [];
  let r = 0, i = "0123456789";
  for (; r < n.length; ) {
    let s = 0;
    for (; i.indexOf(n[r + s]) >= 0; )
      s++;
    if (s > 0) {
      e.push(t.join(""));
      for (let o = parseInt(n.substring(r, r + s), 10); o > 0; o--)
        t.pop();
      r += s;
    } else
      t.push(n[r]), r++;
  }
  return e;
}
const qs = {
  defaultProtocol: "http",
  events: null,
  format: Zv,
  formatHref: Zv,
  nl2br: !1,
  tagName: "a",
  target: null,
  rel: null,
  validate: !0,
  truncate: 1 / 0,
  className: null,
  attributes: null,
  ignoreTags: [],
  render: null
};
function sh(n, e) {
  e === void 0 && (e = null);
  let t = zi({}, qs);
  n && (t = zi(t, n instanceof sh ? n.o : n));
  const r = t.ignoreTags, i = [];
  for (let s = 0; s < r.length; s++)
    i.push(r[s].toUpperCase());
  this.o = t, e && (this.defaultRender = e), this.ignoreTags = i;
}
sh.prototype = {
  o: qs,
  ignoreTags: [],
  defaultRender(n) {
    return n;
  },
  check(n) {
    return this.get("validate", n.toString(), n);
  },
  get(n, e, t) {
    const r = e != null;
    let i = this.o[n];
    return i && (typeof i == "object" ? (i = t.t in i ? i[t.t] : qs[n], typeof i == "function" && r && (i = i(e, t))) : typeof i == "function" && r && (i = i(e, t.t, t)), i);
  },
  getObj(n, e, t) {
    let r = this.o[n];
    return typeof r == "function" && e != null && (r = r(e, t.t, t)), r;
  },
  render(n) {
    const e = n.render(this);
    return (this.get("render", null, n) || this.defaultRender)(e, n.t, n);
  }
};
function Zv(n) {
  return n;
}
function P_(n, e) {
  this.t = "token", this.v = n, this.tk = e;
}
P_.prototype = {
  isLink: !1,
  toString() {
    return this.v;
  },
  toHref(n) {
    return this.toString();
  },
  toFormattedString(n) {
    const e = this.toString(), t = n.get("truncate", e, this), r = n.get("format", e, this);
    return t && r.length > t ? r.substring(0, t) + "\u2026" : r;
  },
  toFormattedHref(n) {
    return n.get("formatHref", this.toHref(n.get("defaultProtocol")), this);
  },
  startIndex() {
    return this.tk[0].s;
  },
  endIndex() {
    return this.tk[this.tk.length - 1].e;
  },
  toObject(n) {
    return n === void 0 && (n = qs.defaultProtocol), {
      type: this.t,
      value: this.toString(),
      isLink: this.isLink,
      href: this.toHref(n),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  toFormattedObject(n) {
    return {
      type: this.t,
      value: this.toFormattedString(n),
      isLink: this.isLink,
      href: this.toFormattedHref(n),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  validate(n) {
    return n.get("validate", this.toString(), this);
  },
  render(n) {
    const e = this, t = this.toHref(n.get("defaultProtocol")), r = n.get("formatHref", t, this), i = n.get("tagName", t, e), s = this.toFormattedString(n), o = {}, a = n.get("className", t, e), l = n.get("target", t, e), u = n.get("rel", t, e), c = n.getObj("attributes", t, e), f = n.getObj("events", t, e);
    return o.href = r, a && (o.class = a), l && (o.target = l), u && (o.rel = u), c && zi(o, c), {
      tagName: i,
      attributes: o,
      content: s,
      eventListeners: f
    };
  }
};
function Pu(n, e) {
  class t extends P_ {
    constructor(i, s) {
      super(i, s), this.t = n;
    }
  }
  for (const r in e)
    t.prototype[r] = e[r];
  return t.t = n, t;
}
const ey = Pu("email", {
  isLink: !0,
  toHref() {
    return "mailto:" + this.toString();
  }
}), ty = Pu("text"), sH = Pu("nl"), qo = Pu("url", {
  isLink: !0,
  toHref(n) {
    return n === void 0 && (n = qs.defaultProtocol), this.hasProtocol() ? this.v : `${n}://${this.v}`;
  },
  hasProtocol() {
    const n = this.tk;
    return n.length >= 2 && n[0].t !== Ws && n[1].t === Jn;
  }
}), Ht = (n) => new St(n);
function oH(n) {
  let {
    groups: e
  } = n;
  const t = e.domain.concat([rl, sl, Un, ol, al, ll, ul, cl, pn, Zp, dl, fl, pl, hl, hn, vl, Os, gl]), r = [il, Jn, th, fn, nh, ml, rh, ih, Ga, Ka, xs, Cs, Wa, Ha, qa, Ua, Ja, Xa, Ya, Qa, Za, el, tl, nl], i = [rl, il, sl, ol, al, ll, ul, cl, pn, xs, Cs, dl, fl, pl, hl, ml, hn, vl, Os, gl], s = Ht(), o = G(s, Os);
  pe(o, i, o), pe(o, e.domain, o);
  const a = Ht(), l = Ht(), u = Ht();
  pe(s, e.domain, a), pe(s, e.scheme, l), pe(s, e.slashscheme, u), pe(a, i, o), pe(a, e.domain, a);
  const c = G(a, Un);
  G(o, Un, c), G(l, Un, c), G(u, Un, c);
  const f = G(o, fn);
  pe(f, i, o), pe(f, e.domain, o);
  const p = Ht();
  pe(c, e.domain, p), pe(p, e.domain, p);
  const d = G(p, fn);
  pe(d, e.domain, p);
  const h = Ht(ey);
  pe(d, e.tld, h), pe(d, e.utld, h), G(c, Ws, h);
  const v = G(p, pn);
  pe(v, e.domain, p), pe(h, e.domain, p), G(h, fn, d), G(h, pn, v);
  const g = G(h, Jn);
  pe(g, e.numeric, ey);
  const m = G(a, pn), _ = G(a, fn);
  pe(m, e.domain, a), pe(_, i, o), pe(_, e.domain, a);
  const y = Ht(qo);
  pe(_, e.tld, y), pe(_, e.utld, y), pe(y, e.domain, a), pe(y, i, o), G(y, fn, _), G(y, pn, m), G(y, Un, c);
  const w = G(y, Jn), O = Ht(qo);
  pe(w, e.numeric, O);
  const C = Ht(qo), S = Ht();
  pe(C, t, C), pe(C, r, S), pe(S, t, C), pe(S, r, S), G(y, hn, C), G(O, hn, C);
  const b = G(l, Jn), x = G(u, Jn), E = G(x, hn), M = G(E, hn);
  pe(l, e.domain, a), G(l, fn, _), G(l, pn, m), pe(u, e.domain, a), G(u, fn, _), G(u, pn, m), pe(b, e.domain, C), G(b, hn, C), pe(M, e.domain, C), pe(M, t, C), G(M, hn, C);
  const $ = [
    [xs, Cs],
    [Ha, Wa],
    [qa, Ua],
    [Ga, Ka],
    [Ja, Xa],
    [Ya, Qa],
    [Za, el],
    [tl, nl]
  ];
  for (let F = 0; F < $.length; F++) {
    const [J, W] = $[F], H = G(C, J);
    G(S, J, H), G(H, W, C);
    const Y = Ht(qo);
    pe(H, t, Y);
    const z = Ht();
    pe(H, r), pe(Y, t, Y), pe(Y, r, z), pe(z, t, Y), pe(z, r, z), G(Y, W, C), G(z, W, C);
  }
  return G(s, Ws, y), G(s, eh, sH), {
    start: s,
    tokens: A_
  };
}
function aH(n, e, t) {
  let r = t.length, i = 0, s = [], o = [];
  for (; i < r; ) {
    let a = n, l = null, u = null, c = 0, f = null, p = -1;
    for (; i < r && !(l = a.go(t[i].t)); )
      o.push(t[i++]);
    for (; i < r && (u = l || a.go(t[i].t)); )
      l = null, a = u, a.accepts() ? (p = 0, f = a) : p >= 0 && p++, i++, c++;
    if (p < 0)
      i -= c, i < r && (o.push(t[i]), i++);
    else {
      o.length > 0 && (s.push(yd(ty, e, o)), o = []), i -= p, c -= p;
      const d = f.t, h = t.slice(i - c, i);
      s.push(yd(d, e, h));
    }
  }
  return o.length > 0 && s.push(yd(ty, e, o)), s;
}
function yd(n, e, t) {
  const r = t[0].s, i = t[t.length - 1].e, s = e.slice(r, i);
  return new n(s, t);
}
const lH = typeof console < "u" && console && console.warn || (() => {
}), uH = "until manual call of linkify.init(). Register all schemes and plugins before invoking linkify the first time.", ke = {
  scanner: null,
  parser: null,
  tokenQueue: [],
  pluginQueue: [],
  customSchemes: [],
  initialized: !1
};
function cH() {
  St.groups = {}, ke.scanner = null, ke.parser = null, ke.tokenQueue = [], ke.pluginQueue = [], ke.customSchemes = [], ke.initialized = !1;
}
function ny(n, e) {
  if (e === void 0 && (e = !1), ke.initialized && lH(`linkifyjs: already initialized - will not register custom scheme "${n}" ${uH}`), !/^[0-9a-z]+(-[0-9a-z]+)*$/.test(n))
    throw new Error(`linkifyjs: incorrect scheme format.
1. Must only contain digits, lowercase ASCII letters or "-"
2. Cannot start or end with "-"
3. "-" cannot repeat`);
  ke.customSchemes.push([n, e]);
}
function dH() {
  ke.scanner = nH(ke.customSchemes);
  for (let n = 0; n < ke.tokenQueue.length; n++)
    ke.tokenQueue[n][1]({
      scanner: ke.scanner
    });
  ke.parser = oH(ke.scanner.tokens);
  for (let n = 0; n < ke.pluginQueue.length; n++)
    ke.pluginQueue[n][1]({
      scanner: ke.scanner,
      parser: ke.parser
    });
  ke.initialized = !0;
}
function fH(n) {
  return ke.initialized || dH(), aH(ke.parser.start, n, rH(ke.scanner.start, n));
}
function oh(n, e, t) {
  if (e === void 0 && (e = null), t === void 0 && (t = null), e && typeof e == "object") {
    if (t)
      throw Error(`linkifyjs: Invalid link type ${e}; must be a string`);
    t = e, e = null;
  }
  const r = new sh(t), i = fH(n), s = [];
  for (let o = 0; o < i.length; o++) {
    const a = i[o];
    a.isLink && (!e || a.t === e) && r.check(a) && s.push(a.toFormattedObject(r));
  }
  return s;
}
function pH(n) {
  return new lt({
    key: new Zt("autolink"),
    appendTransaction: (e, t, r) => {
      const i = e.some((u) => u.docChanged) && !t.doc.eq(r.doc), s = e.some((u) => u.getMeta("preventAutolink"));
      if (!i || s)
        return;
      const { tr: o } = r, a = sI(t.doc, [...e]);
      if (hI(a).forEach(({ newRange: u }) => {
        const c = aI(r.doc, u, (d) => d.isTextblock);
        let f, p;
        if (c.length > 1 ? (f = c[0], p = r.doc.textBetween(f.pos, f.pos + f.node.nodeSize, void 0, " ")) : c.length && r.doc.textBetween(u.from, u.to, " ", " ").endsWith(" ") && (f = c[0], p = r.doc.textBetween(f.pos, u.to, void 0, " ")), f && p) {
          const d = p.split(" ").filter((g) => g !== "");
          if (d.length <= 0)
            return !1;
          const h = d[d.length - 1], v = f.pos + p.lastIndexOf(h);
          if (!h)
            return !1;
          oh(h).filter((g) => g.isLink).map((g) => ({
            ...g,
            from: v + g.start + 1,
            to: v + g.end + 1
          })).filter((g) => r.schema.marks.code ? !r.doc.rangeHasMark(g.from, g.to, r.schema.marks.code) : !0).filter((g) => n.validate ? n.validate(g.value) : !0).forEach((g) => {
            Cp(g.from, g.to, r.doc).some((m) => m.mark.type === n.type) || o.addMark(g.from, g.to, n.type.create({
              href: g.href
            }));
          });
        }
      }), !!o.steps.length)
        return o;
    }
  });
}
function hH(n) {
  return new lt({
    key: new Zt("handleClickLink"),
    props: {
      handleClick: (e, t, r) => {
        var i, s;
        if (r.button !== 0 || r.target.nodeName !== "A")
          return !1;
        const a = mw(e.state, n.type.name), l = r.target, u = (i = l == null ? void 0 : l.href) !== null && i !== void 0 ? i : a.href, c = (s = l == null ? void 0 : l.target) !== null && s !== void 0 ? s : a.target;
        return l && u ? (e.editable && window.open(u, c), !0) : !1;
      }
    }
  });
}
function mH(n) {
  return new lt({
    key: new Zt("handlePasteLink"),
    props: {
      handlePaste: (e, t, r) => {
        var i;
        const { state: s } = e, { selection: o } = s, { empty: a } = o;
        if (a)
          return !1;
        let l = "";
        r.content.forEach((h) => {
          l += h.textContent;
        });
        const u = oh(l).find((h) => h.isLink && h.value === l);
        if (!l || !u)
          return !1;
        const c = (i = t.clipboardData) === null || i === void 0 ? void 0 : i.getData("text/html"), f = /href="([^"]*)"/, p = c == null ? void 0 : c.match(f), d = p ? p[1] : u.href;
        return n.editor.commands.setMark(n.type, {
          href: d
        }), !0;
      }
    }
  });
}
const $_ = Dt.create({
  name: "link",
  priority: 1e3,
  keepOnSplit: !1,
  onCreate() {
    this.options.protocols.forEach((n) => {
      if (typeof n == "string") {
        ny(n);
        return;
      }
      ny(n.scheme, n.optionalSlashes);
    });
  },
  onDestroy() {
    cH();
  },
  inclusive() {
    return this.options.autolink;
  },
  addOptions() {
    return {
      openOnClick: !0,
      linkOnPaste: !0,
      autolink: !0,
      protocols: [],
      HTMLAttributes: {
        target: "_blank",
        rel: "noopener noreferrer nofollow",
        class: null
      },
      validate: void 0
    };
  },
  addAttributes() {
    return {
      href: {
        default: null
      },
      target: {
        default: this.options.HTMLAttributes.target
      },
      rel: {
        default: this.options.HTMLAttributes.rel
      },
      class: {
        default: this.options.HTMLAttributes.class
      }
    };
  },
  parseHTML() {
    return [{ tag: 'a[href]:not([href *= "javascript:" i])' }];
  },
  renderHTML({ HTMLAttributes: n }) {
    var e;
    return !((e = n.href) === null || e === void 0) && e.startsWith("javascript:") ? ["a", we(this.options.HTMLAttributes, { ...n, href: "" }), 0] : ["a", we(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setLink: (n) => ({ chain: e }) => e().setMark(this.name, n).setMeta("preventAutolink", !0).run(),
      toggleLink: (n) => ({ chain: e }) => e().toggleMark(this.name, n, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run(),
      unsetLink: () => ({ chain: n }) => n().unsetMark(this.name, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run()
    };
  },
  addPasteRules() {
    return [
      Hr({
        find: (n) => oh(n).filter((e) => this.options.validate ? this.options.validate(e.value) : !0).filter((e) => e.isLink).map((e) => ({
          text: e.value,
          index: e.start,
          data: e
        })),
        type: this.type,
        getAttributes: (n, e) => {
          var t, r;
          const i = (t = e == null ? void 0 : e.clipboardData) === null || t === void 0 ? void 0 : t.getData("text/html"), s = /href="([^"]*)"/, o = i == null ? void 0 : i.match(s);
          return o ? {
            href: o[1]
          } : {
            href: (r = n.data) === null || r === void 0 ? void 0 : r.href
          };
        }
      })
    ];
  },
  addProseMirrorPlugins() {
    const n = [];
    return this.options.autolink && n.push(pH({
      type: this.type,
      validate: this.options.validate
    })), this.options.openOnClick && n.push(hH({
      type: this.type
    })), this.options.linkOnPaste && n.push(mH({
      editor: this.editor,
      type: this.type
    })), n;
  }
});
/*! medium-zoom 1.1.0 | MIT License | https://github.com/francoischalifour/medium-zoom */
var xr = Object.assign || function(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e];
    for (var r in t)
      Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
  }
  return n;
}, Uo = function(e) {
  return e.tagName === "IMG";
}, gH = function(e) {
  return NodeList.prototype.isPrototypeOf(e);
}, ca = function(e) {
  return e && e.nodeType === 1;
}, ry = function(e) {
  var t = e.currentSrc || e.src;
  return t.substr(-4).toLowerCase() === ".svg";
}, iy = function(e) {
  try {
    return Array.isArray(e) ? e.filter(Uo) : gH(e) ? [].slice.call(e).filter(Uo) : ca(e) ? [e].filter(Uo) : typeof e == "string" ? [].slice.call(document.querySelectorAll(e)).filter(Uo) : [];
  } catch {
    throw new TypeError(`The provided selector is invalid.
Expects a CSS selector, a Node element, a NodeList or an array.
See: https://github.com/francoischalifour/medium-zoom`);
  }
}, vH = function(e) {
  var t = document.createElement("div");
  return t.classList.add("medium-zoom-overlay"), t.style.background = e, t;
}, yH = function(e) {
  var t = e.getBoundingClientRect(), r = t.top, i = t.left, s = t.width, o = t.height, a = e.cloneNode(), l = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0, u = window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0;
  return a.removeAttribute("id"), a.style.position = "absolute", a.style.top = r + l + "px", a.style.left = i + u + "px", a.style.width = s + "px", a.style.height = o + "px", a.style.transform = "", a;
}, ci = function(e, t) {
  var r = xr({
    bubbles: !1,
    cancelable: !1,
    detail: void 0
  }, t);
  if (typeof window.CustomEvent == "function")
    return new CustomEvent(e, r);
  var i = document.createEvent("CustomEvent");
  return i.initCustomEvent(e, r.bubbles, r.cancelable, r.detail), i;
}, bH = function n(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = window.Promise || function($) {
    function F() {
    }
    $(F, F);
  }, i = function($) {
    var F = $.target;
    if (F === x) {
      h();
      return;
    }
    y.indexOf(F) !== -1 && v({ target: F });
  }, s = function() {
    if (!(O || !b.original)) {
      var $ = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      Math.abs(C - $) > S.scrollOffset && setTimeout(h, 150);
    }
  }, o = function($) {
    var F = $.key || $.keyCode;
    (F === "Escape" || F === "Esc" || F === 27) && h();
  }, a = function() {
    var $ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, F = $;
    if ($.background && (x.style.background = $.background), $.container && $.container instanceof Object && (F.container = xr({}, S.container, $.container)), $.template) {
      var J = ca($.template) ? $.template : document.querySelector($.template);
      F.template = J;
    }
    return S = xr({}, S, F), y.forEach(function(W) {
      W.dispatchEvent(ci("medium-zoom:update", {
        detail: { zoom: E }
      }));
    }), E;
  }, l = function() {
    var $ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return n(xr({}, S, $));
  }, u = function() {
    for (var $ = arguments.length, F = Array($), J = 0; J < $; J++)
      F[J] = arguments[J];
    var W = F.reduce(function(H, Y) {
      return [].concat(H, iy(Y));
    }, []);
    return W.filter(function(H) {
      return y.indexOf(H) === -1;
    }).forEach(function(H) {
      y.push(H), H.classList.add("medium-zoom-image");
    }), w.forEach(function(H) {
      var Y = H.type, z = H.listener, j = H.options;
      W.forEach(function(Q) {
        Q.addEventListener(Y, z, j);
      });
    }), E;
  }, c = function() {
    for (var $ = arguments.length, F = Array($), J = 0; J < $; J++)
      F[J] = arguments[J];
    b.zoomed && h();
    var W = F.length > 0 ? F.reduce(function(H, Y) {
      return [].concat(H, iy(Y));
    }, []) : y;
    return W.forEach(function(H) {
      H.classList.remove("medium-zoom-image"), H.dispatchEvent(ci("medium-zoom:detach", {
        detail: { zoom: E }
      }));
    }), y = y.filter(function(H) {
      return W.indexOf(H) === -1;
    }), E;
  }, f = function($, F) {
    var J = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return y.forEach(function(W) {
      W.addEventListener("medium-zoom:" + $, F, J);
    }), w.push({ type: "medium-zoom:" + $, listener: F, options: J }), E;
  }, p = function($, F) {
    var J = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return y.forEach(function(W) {
      W.removeEventListener("medium-zoom:" + $, F, J);
    }), w = w.filter(function(W) {
      return !(W.type === "medium-zoom:" + $ && W.listener.toString() === F.toString());
    }), E;
  }, d = function() {
    var $ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, F = $.target, J = function() {
      var H = {
        width: document.documentElement.clientWidth,
        height: document.documentElement.clientHeight,
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
      }, Y = void 0, z = void 0;
      if (S.container)
        if (S.container instanceof Object)
          H = xr({}, H, S.container), Y = H.width - H.left - H.right - S.margin * 2, z = H.height - H.top - H.bottom - S.margin * 2;
        else {
          var j = ca(S.container) ? S.container : document.querySelector(S.container), Q = j.getBoundingClientRect(), fe = Q.width, ue = Q.height, ae = Q.left, ye = Q.top;
          H = xr({}, H, {
            width: fe,
            height: ue,
            left: ae,
            top: ye
          });
        }
      Y = Y || H.width - S.margin * 2, z = z || H.height - S.margin * 2;
      var re = b.zoomedHd || b.original, T = ry(re) ? Y : re.naturalWidth || Y, D = ry(re) ? z : re.naturalHeight || z, R = re.getBoundingClientRect(), I = R.top, se = R.left, Oe = R.width, Me = R.height, Re = Math.min(Math.max(Oe, T), Y) / Oe, Je = Math.min(Math.max(Me, D), z) / Me, Ee = Math.min(Re, Je), Fe = (-se + (Y - Oe) / 2 + S.margin + H.left) / Ee, Ft = (-I + (z - Me) / 2 + S.margin + H.top) / Ee, zt = "scale(" + Ee + ") translate3d(" + Fe + "px, " + Ft + "px, 0)";
      b.zoomed.style.transform = zt, b.zoomedHd && (b.zoomedHd.style.transform = zt);
    };
    return new r(function(W) {
      if (F && y.indexOf(F) === -1) {
        W(E);
        return;
      }
      var H = function fe() {
        O = !1, b.zoomed.removeEventListener("transitionend", fe), b.original.dispatchEvent(ci("medium-zoom:opened", {
          detail: { zoom: E }
        })), W(E);
      };
      if (b.zoomed) {
        W(E);
        return;
      }
      if (F)
        b.original = F;
      else if (y.length > 0) {
        var Y = y;
        b.original = Y[0];
      } else {
        W(E);
        return;
      }
      if (b.original.dispatchEvent(ci("medium-zoom:open", {
        detail: { zoom: E }
      })), C = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0, O = !0, b.zoomed = yH(b.original), document.body.appendChild(x), S.template) {
        var z = ca(S.template) ? S.template : document.querySelector(S.template);
        b.template = document.createElement("div"), b.template.appendChild(z.content.cloneNode(!0)), document.body.appendChild(b.template);
      }
      if (b.original.parentElement && b.original.parentElement.tagName === "PICTURE" && b.original.currentSrc && (b.zoomed.src = b.original.currentSrc), document.body.appendChild(b.zoomed), window.requestAnimationFrame(function() {
        document.body.classList.add("medium-zoom--opened");
      }), b.original.classList.add("medium-zoom-image--hidden"), b.zoomed.classList.add("medium-zoom-image--opened"), b.zoomed.addEventListener("click", h), b.zoomed.addEventListener("transitionend", H), b.original.getAttribute("data-zoom-src")) {
        b.zoomedHd = b.zoomed.cloneNode(), b.zoomedHd.removeAttribute("srcset"), b.zoomedHd.removeAttribute("sizes"), b.zoomedHd.removeAttribute("loading"), b.zoomedHd.src = b.zoomed.getAttribute("data-zoom-src"), b.zoomedHd.onerror = function() {
          clearInterval(j), console.warn("Unable to reach the zoom image target " + b.zoomedHd.src), b.zoomedHd = null, J();
        };
        var j = setInterval(function() {
          b.zoomedHd.complete && (clearInterval(j), b.zoomedHd.classList.add("medium-zoom-image--opened"), b.zoomedHd.addEventListener("click", h), document.body.appendChild(b.zoomedHd), J());
        }, 10);
      } else if (b.original.hasAttribute("srcset")) {
        b.zoomedHd = b.zoomed.cloneNode(), b.zoomedHd.removeAttribute("sizes"), b.zoomedHd.removeAttribute("loading");
        var Q = b.zoomedHd.addEventListener("load", function() {
          b.zoomedHd.removeEventListener("load", Q), b.zoomedHd.classList.add("medium-zoom-image--opened"), b.zoomedHd.addEventListener("click", h), document.body.appendChild(b.zoomedHd), J();
        });
      } else
        J();
    });
  }, h = function() {
    return new r(function($) {
      if (O || !b.original) {
        $(E);
        return;
      }
      var F = function J() {
        b.original.classList.remove("medium-zoom-image--hidden"), document.body.removeChild(b.zoomed), b.zoomedHd && document.body.removeChild(b.zoomedHd), document.body.removeChild(x), b.zoomed.classList.remove("medium-zoom-image--opened"), b.template && document.body.removeChild(b.template), O = !1, b.zoomed.removeEventListener("transitionend", J), b.original.dispatchEvent(ci("medium-zoom:closed", {
          detail: { zoom: E }
        })), b.original = null, b.zoomed = null, b.zoomedHd = null, b.template = null, $(E);
      };
      O = !0, document.body.classList.remove("medium-zoom--opened"), b.zoomed.style.transform = "", b.zoomedHd && (b.zoomedHd.style.transform = ""), b.template && (b.template.style.transition = "opacity 150ms", b.template.style.opacity = 0), b.original.dispatchEvent(ci("medium-zoom:close", {
        detail: { zoom: E }
      })), b.zoomed.addEventListener("transitionend", F);
    });
  }, v = function() {
    var $ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, F = $.target;
    return b.original ? h() : d({ target: F });
  }, g = function() {
    return S;
  }, m = function() {
    return y;
  }, _ = function() {
    return b.original;
  }, y = [], w = [], O = !1, C = 0, S = t, b = {
    original: null,
    zoomed: null,
    zoomedHd: null,
    template: null
  };
  Object.prototype.toString.call(e) === "[object Object]" ? S = e : (e || typeof e == "string") && u(e), S = xr({
    margin: 0,
    background: "#fff",
    scrollOffset: 40,
    container: null,
    template: null
  }, S);
  var x = vH(S.background);
  document.addEventListener("click", i), document.addEventListener("keyup", o), document.addEventListener("scroll", s), window.addEventListener("resize", h);
  var E = {
    open: d,
    close: h,
    toggle: v,
    update: a,
    clone: l,
    attach: u,
    detach: c,
    on: f,
    off: p,
    getOptions: g,
    getImages: m,
    getZoomedImage: _
  };
  return E;
};
function wH(n, e) {
  e === void 0 && (e = {});
  var t = e.insertAt;
  if (!(!n || typeof document > "u")) {
    var r = document.head || document.getElementsByTagName("head")[0], i = document.createElement("style");
    i.type = "text/css", t === "top" && r.firstChild ? r.insertBefore(i, r.firstChild) : r.appendChild(i), i.styleSheet ? i.styleSheet.cssText = n : i.appendChild(document.createTextNode(n));
  }
}
var _H = ".medium-zoom-overlay{position:fixed;top:0;right:0;bottom:0;left:0;opacity:0;transition:opacity .3s;will-change:opacity}.medium-zoom--opened .medium-zoom-overlay{cursor:pointer;cursor:zoom-out;opacity:1}.medium-zoom-image{cursor:pointer;cursor:zoom-in;transition:transform .3s cubic-bezier(.2,0,.2,1)!important}.medium-zoom-image--hidden{visibility:hidden}.medium-zoom-image--opened{position:relative;cursor:pointer;cursor:zoom-out;will-change:transform}";
wH(_H);
const SH = bH, D_ = xe.create({
  name: "collapse",
  group: "block",
  atom: !0,
  addOptions: () => ({
    allowFullscreen: !0,
    HTMLAttributes: {
      class: "t-viewer__collapse"
    }
  }),
  addAttributes() {
    return {
      items: {
        default: []
      }
    };
  },
  addCommands() {
    return {
      setCollapse: (n) => ({ commands: e }) => e.insertContent({
        type: this.name,
        attrs: { items: encodeURIComponent(JSON.stringify(n)) }
      })
    };
  },
  parseHTML() {
    return [
      {
        tag: "collapse-view"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["collapse-view", we(this.options.HTMLAttributes, n)];
  }
}), L_ = xe.create({
  name: "customHighlight",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  group: "block",
  defining: !0,
  parseHTML() {
    return [{ tag: "div" }];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["div", we(this.options.HTMLAttributes, n), 0];
  },
  addAttributes() {
    return {
      class: {
        default: null,
        renderHTML: (n) => n.class ? {
          class: n.class
        } : {}
      },
      style: {
        default: null,
        renderHTML: (n) => n.style ? {
          style: n.style
        } : {}
      }
    };
  },
  addCommands() {
    return {
      setCustomHighlight: (n) => ({ commands: e }) => e.wrapIn(this.name, n),
      toggleCustomHighlight: (n) => ({ commands: e }) => e.toggleWrap(this.name, n),
      unsetCustomHighlight: () => ({ commands: n }) => n.lift(this.name)
    };
  }
}), N_ = Ve.create({
  name: "display",
  addOptions: () => ({
    types: ["image"]
  }),
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          display: {
            default: null,
            renderHTML: (n) => n.display ? {
              style: `display: ${n.display}`
            } : {},
            parseHTML: (n) => ({
              display: n.style.display.replace(/['"]+/g, "")
            })
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setDisplay: (n) => ({ commands: e }) => n ? this.options.types.every((t) => e.updateAttributes(t, { display: n })) : !1,
      unsetDisplay: () => ({ commands: n }) => this.options.types.every((e) => n.resetAttributes(e, ["display"]))
    };
  }
}), xH = Ve.create({
  name: "fontSize",
  addOptions: () => ({
    types: ["textStyle"]
  }),
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontSize: {
            default: null,
            parseHTML: (n) => n.style.fontSize.replace(/['"]+/g, ""),
            renderHTML: (n) => n.fontSize ? {
              style: `font-size: ${n.fontSize}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setFontSize: (n) => ({ chain: e }) => e().setMark("textStyle", { fontSize: n }).run(),
      unsetFontSize: () => ({ chain: n }) => n().setMark("textStyle", { fontSize: null }).removeEmptyTextStyle().run()
    };
  }
}), I_ = xe.create({
  name: "iframe",
  group: "block",
  atom: !0,
  addOptions: () => ({
    allowFullscreen: !0,
    HTMLAttributes: {
      class: "t-viewer__iframe fullscreen"
    }
  }),
  addAttributes() {
    return {
      src: {
        default: null
      },
      frameborder: {
        default: 0
      },
      allowfullscreen: {
        default: !0
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "iframe"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["div", this.options.HTMLAttributes, ["iframe", n]];
  },
  addCommands() {
    return {
      setIframe: (n) => ({ tr: e, dispatch: t }) => {
        const { selection: r } = e, i = this.type.create(n);
        return t && e.replaceRangeWith(r.from, r.to, i), !0;
      }
    };
  }
}), CH = /(?:^|\s)(!\[(.+|:?)]\((\S+)(?:(?:\s+)["'](\S+)["'])?\))$/, R_ = xe.create({
  name: "image",
  addOptions() {
    return {
      inline: !1,
      allowBase64: !1,
      HTMLAttributes: {}
    };
  },
  inline() {
    return this.options.inline;
  },
  group() {
    return this.options.inline ? "inline" : "block";
  },
  draggable: !0,
  addAttributes() {
    return {
      src: {
        default: null
      },
      alt: {
        default: null
      },
      title: {
        default: null
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: this.options.allowBase64 ? "img[src]" : 'img[src]:not([src^="data:"])'
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["img", we(this.options.HTMLAttributes, n)];
  },
  addCommands() {
    return {
      setImage: (n) => ({ commands: e }) => e.insertContent({
        type: this.name,
        attrs: n
      })
    };
  },
  addInputRules() {
    return [
      vw({
        find: CH,
        type: this.type,
        getAttributes: (n) => {
          const [, , e, t, r] = n;
          return { src: t, alt: e, title: r };
        }
      })
    ];
  }
}), F_ = R_.extend({
  addAttributes() {
    return {
      ...this.parent ? this.parent() : {},
      fullscreen: {
        default: !1
      },
      description: {
        default: ""
      }
    };
  }
}).configure({}), z_ = R_.extend({
  name: "imageView",
  addAttributes() {
    return {
      ...this.parent ? this.parent() : {},
      fullscreen: {
        default: !1
      },
      description: {
        default: ""
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "image-view[src]"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["image-view", we(this.options.HTMLAttributes, n)];
  },
  addCommands() {
    return {
      setImageView: (n) => ({ commands: e }) => e.insertContent({
        type: this.name,
        attrs: n
      })
    };
  }
}).configure({ HTMLAttributes: { class: "t-viewer__image" } }), B_ = xe.create({
  name: "imageAlbum",
  group: "block",
  atom: !0,
  addOptions: () => ({
    HTMLAttributes: {
      class: "t-viewer__image-album"
    }
  }),
  addAttributes() {
    return {
      images: {
        default: []
      }
    };
  },
  addCommands() {
    return {
      setImageAlbum: (n) => ({ commands: e }) => e.insertContent({
        type: this.name,
        attrs: { images: n }
      })
    };
  },
  parseHTML() {
    return [
      {
        tag: "image-album-view"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["image-album-view", we(this.options.HTMLAttributes, n)];
  }
}), j_ = xe.create({
  name: "imageComparison",
  group: "block",
  atom: !0,
  addOptions: () => ({
    HTMLAttributes: {
      class: "t-viewer__image-comparison"
    }
  }),
  addAttributes() {
    return {
      images: {
        default: []
      }
    };
  },
  addCommands() {
    return {
      setImageComparison: (n) => ({ commands: e }) => e.insertContent({
        type: this.name,
        attrs: { images: n }
      })
    };
  },
  parseHTML() {
    return [
      {
        tag: "image-comparison-view"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["image-comparison-view", we(this.options.HTMLAttributes, n)];
  }
}), V_ = "fill", H_ = Ve.create({
  name: "objectFit",
  addOptions: () => ({
    types: ["image"],
    defaultObjectFit: V_
  }),
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          objectFit: {
            default: this.options.defaultObjectFit,
            renderHTML: (n) => !n.objectFit || n.objectFit === this.options.defaultObjectFit ? {} : {
              style: `object-fit: ${n.objectFit}`
            },
            parseHTML: (n) => ({
              objectFit: n.style.objectFit.replace(/['"]+/g, "")
            })
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setObjectFit: (n) => ({ commands: e }) => !n || n === this.options.defaultObjectFit ? !1 : this.options.types.every((t) => e.updateAttributes(t, { objectFit: n })),
      unsetObjectFit: () => ({ commands: n }) => this.options.types.every((e) => n.resetAttributes(e, ["objectFit"]))
    };
  }
});
xe.create({
  name: "ratingCard",
  group: "block",
  atom: !0,
  addOptions: () => ({
    HTMLAttributes: {
      class: "t-viewer__rating-card"
    },
    title: "",
    image: "",
    rating: "",
    likeContent: "",
    dontLikeContent: ""
  }),
  addAttributes() {
    return {
      title: {
        default: null
      },
      image: {
        default: null
      },
      rating: {
        default: null
      },
      likeContent: {
        default: null
      },
      dontLikeContent: {
        default: null
      }
    };
  },
  addCommands() {
    return {
      setRatingCard: (n) => ({ commands: e }) => e.insertContent({
        type: this.name,
        attrs: n
      })
    };
  },
  parseHTML() {
    return [
      {
        tag: "rating-view"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["rating-view", we(this.options.HTMLAttributes, n)];
  }
});
const W_ = xe.create({
  name: "richLink",
  group: "block",
  atom: !0,
  addOptions: () => ({
    HTMLAttributes: {
      class: "t-viewer__rick-link"
    }
  }),
  addAttributes() {
    return {
      image: {
        default: ""
      },
      url: {
        default: ""
      },
      title: {
        default: ""
      },
      description: {
        default: ""
      }
    };
  },
  addCommands() {
    return {
      setRichLink: (n) => ({ commands: e }) => e.insertContent({
        type: this.name,
        attrs: n
      })
    };
  },
  parseHTML() {
    return [
      {
        tag: "rich-link-view"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["rich-link-view", we(this.options.HTMLAttributes, n)];
  }
}), Of = "auto", q_ = Ve.create({
  name: "size",
  addOptions: () => ({
    types: ["image"],
    defaultSize: Of
  }),
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          width: {
            default: this.options.defaultSize,
            parseHTML: (n) => !n.style.width || n.style.width === this.options.defaultSize ? {} : { width: n.style.width },
            renderHTML: (n) => n.width === this.options.defaultSize ? {} : { style: `width: ${n.width}` }
          },
          height: {
            default: this.options.defaultSize,
            parseHTML: (n) => !n.style.height || n.style.height === this.options.defaultSize ? {} : { height: n.style.height },
            renderHTML: (n) => n.height === this.options.defaultSize ? {} : { style: `height: ${n.height}` }
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setSize: (n) => ({ commands: e }) => this.options.defaultSize === n.width && this.options.defaultSize === n.height ? !1 : this.options.types.every((t) => e.updateAttributes(t, n)),
      unsetSize: () => ({ commands: n }) => this.options.types.every((e) => n.resetAttributes(e, ["width", "height"]))
    };
  }
}), OH = xe.create({
  name: "skuCard",
  group: "block",
  atom: !0,
  addOptions: () => ({
    HTMLAttributes: {
      class: "t-viewer__sku-card"
    }
  }),
  addAttributes() {
    return {
      id: {
        default: null
      }
    };
  },
  addCommands() {
    return {
      setSkuCard: (n) => ({ commands: e }) => e.insertContent({
        type: this.name,
        attrs: { id: n }
      })
    };
  },
  parseHTML() {
    return [
      {
        tag: "sku-view"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["sku-view", we(this.options.HTMLAttributes, n)];
  }
});
xe.create({
  name: "skuComparison",
  group: "block",
  atom: !0,
  addOptions: () => ({
    products: [],
    fields: [],
    HTMLAttributes: {
      class: "t-viewer__sku-comparison"
    }
  }),
  addAttributes() {
    return {
      products: {
        default: []
      },
      fields: {
        default: []
      }
    };
  },
  addCommands() {
    return {
      setSkuComparison: (n) => ({ commands: e }) => {
        const t = {};
        return Object.entries(n).forEach(([r, i]) => {
          t[r] = encodeURIComponent(JSON.stringify(i));
        }), e.insertContent({
          type: this.name,
          attrs: t
        });
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "sku-comparison-view"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["sku-comparison-view", we(this.options.HTMLAttributes, n)];
  }
});
xe.create({
  name: "softwareStack",
  group: "block",
  atom: !0,
  addOptions: () => ({
    HTMLAttributes: {
      class: "t-viewer__software-stack"
    }
  }),
  addAttributes() {
    return {
      title: {
        default: null
      },
      images: {
        default: []
      }
    };
  },
  addCommands() {
    return {
      setSoftwareStack: (n) => ({ commands: e }) => {
        const t = {};
        return Object.entries(n).forEach(([r, i]) => {
          t[r] = encodeURIComponent(JSON.stringify(i));
        }), e.insertContent({
          type: this.name,
          attrs: t
        });
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "software-stack-view"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["software-stack-view", we(this.options.HTMLAttributes, n)];
  }
});
const EH = Ce({
  name: "ImageView",
  components: { NodeViewWrapper: Ui, TImg: ep },
  props: Gi,
  setup(n) {
    const e = ve(() => {
      const i = {}, s = n.node.attrs;
      return s.width && s.width !== Of && (i.width = s.width), s.height && s.height !== Of && (i.height = s.height), s.objectFit && s.objectFit !== V_ && (i.objectFit = s.objectFit), (s.display === "inline" || s.display === "block") && (i.display = s.display), (s.display === "left" || s.display === "right") && (i.float = s.display), i;
    }), t = ve(() => n.node.attrs.description), r = ve(() => n.node.attrs.fullscreen || !1);
    return {
      imageStyles: e,
      description: t,
      fullscreen: r
    };
  }
});
var TH = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("node-view-wrapper", { staticClass: "t-viewer-image", class: { "t-viewer__image-fullscreen": e.fullscreen } }, [t("div", { staticClass: "t-viewer-image__wrapper" }, [e.$nuxt ? t("t-img", { style: e.imageStyles, attrs: { alt: e.node.attrs.alt, height: 900, src: e.node.attrs.src, width: 1600, lazyload: "" } }) : t("img", { staticClass: "lazyload", style: e.imageStyles, attrs: { alt: e.node.attrs.alt, "data-src": e.node.attrs.src } })], 1), e.description ? t("div", { staticClass: "t-viewer-image__description" }, [e._v(" " + e._s(e.description) + " ")]) : e._e()]);
}, kH = [], MH = /* @__PURE__ */ le(
  EH,
  TH,
  kH,
  !1,
  null,
  null,
  null,
  null
);
const yl = MH.exports, AH = Ce({
  name: "ImageAlbumView",
  components: { NodeViewWrapper: Ui, TAlbumImage: _b },
  props: Gi,
  setup(n) {
    const e = ve(() => {
      const i = n.node.attrs;
      return Array.isArray(i.images) ? i.images : typeof i.images == "string" ? i.images.split(",") : [];
    }), t = ve(() => n.node.attrs.fullscreen || !1);
    function r(i) {
      n.editor.view.editable && i.preventDefault();
    }
    return {
      images: e,
      fullscreen: t,
      onClick: r
    };
  }
});
var PH = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("node-view-wrapper", { class: { "t-viewer__image-album-fullscreen": e.fullscreen } }, [t("t-album-image", { class: { "ProseMirror-selectednode": e.selected }, attrs: { images: e.images }, nativeOn: { click: function(r) {
    return e.onClick.apply(null, arguments);
  } } })], 1);
}, $H = [], DH = /* @__PURE__ */ le(
  AH,
  PH,
  $H,
  !1,
  null,
  null,
  null,
  null
);
const U_ = DH.exports;
const LH = Ce({
  name: "CollapseView",
  components: { TCollapse: $b, TCollapseItem: Db, NodeViewWrapper: Ui },
  props: Gi,
  setup(n) {
    const e = ve(() => n.node.attrs);
    return {
      collapseList: ve(() => {
        const r = JSON.parse(decodeURIComponent(e.value.items));
        return Array.isArray(r) ? r : typeof r == "string" ? r.split(",") : [];
      })
    };
  }
});
var NH = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("node-view-wrapper", [t("t-collapse", { staticClass: "collapse-view" }, e._l(e.collapseList, function(r, i) {
    return t("t-collapse-item", { key: i, attrs: { name: i, title: r.title } }, [t("span", { domProps: { innerHTML: e._s(r.content) } })]);
  }), 1)], 1);
}, IH = [], RH = /* @__PURE__ */ le(
  LH,
  NH,
  IH,
  !1,
  null,
  null,
  null,
  null
);
const G_ = RH.exports, FH = Ce({
  components: {
    NodeViewWrapper: Ui,
    TRichLink: Tb
  },
  props: Gi,
  setup(n) {
    return {
      attrs: ve(() => n.node.attrs)
    };
  }
});
var zH = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("node-view-wrapper", { staticClass: "fullscreen" }, [e.attrs.url ? t("t-rich-link", e._b({}, "t-rich-link", e.attrs, !1)) : e._e()], 1);
}, BH = [], jH = /* @__PURE__ */ le(
  FH,
  zH,
  BH,
  !1,
  null,
  null,
  null,
  null
);
const K_ = jH.exports, VH = Ce({
  components: { NodeViewWrapper: Ui, TComparisonImage: Cb },
  props: Gi,
  setup(n) {
    const e = ve(() => {
      const r = n.node.attrs;
      return Array.isArray(r.images) ? r.images : typeof r.images == "string" ? r.images.split(",") : [];
    });
    function t(r) {
      n.editor.view.editable && r.preventDefault();
    }
    return {
      images: e,
      onClick: t
    };
  }
});
var HH = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("node-view-wrapper", { staticClass: "fullscreen bg-gray-50 my-6 flex justify-center" }, [e.images.length === 2 ? t("t-comparison-image", { attrs: { "left-image": e.images[0], "right-image": e.images[1] }, nativeOn: { click: function(r) {
    return e.onClick.apply(null, arguments);
  } } }) : e._e()], 1);
}, WH = [], qH = /* @__PURE__ */ le(
  VH,
  HH,
  WH,
  !1,
  null,
  null,
  null,
  null
);
const J_ = qH.exports;
function Mt(n) {
  return () => w2(n);
}
Ce({
  components: { EditorContent: Bw },
  props: {
    value: { type: String, default: "" },
    extensions: { type: Array, default: () => [] },
    zoom: { type: Boolean, default: !1 }
  },
  setup(n) {
    const e = Le();
    return zr(() => n.value, (t) => {
      var r;
      (r = e.value) == null || r.commands.setContent(t, !1);
    }), Us(() => {
      const t = [
        L_,
        x_,
        C_,
        O_,
        E_,
        $_,
        q_,
        H_,
        N_,
        I_,
        F_.extend({
          addNodeView: Mt(yl)
        }),
        z_.extend({
          addNodeView: Mt(yl)
        }),
        B_.extend({
          addNodeView: Mt(U_)
        }),
        D_.extend({
          addNodeView: Mt(G_)
        }),
        W_.extend({
          addNodeView: Mt(K_)
        }),
        j_.extend({
          addNodeView: Mt(J_)
        }),
        ...n.extensions
      ];
      e.value = new gw({
        extensions: t,
        editable: !1,
        content: n.value
      }), n.zoom && setTimeout(() => {
        SH(".t-tiptap-viewer .t-viewer-image__wrapper .t-img", {
          background: "rgba(33,37,48,0.95)"
        });
      }, 500);
    }), bl(() => {
      var t;
      (t = e.value) == null || t.destroy();
    }), { editor: e };
  }
});
const UH = Ce({
  components: {
    TProductItem: qb,
    NodeViewWrapper: Ui
  },
  props: Gi,
  setup(n) {
    const e = Bi("config"), t = Le(), r = ve(() => n.node.attrs);
    Us(async () => {
      try {
        const { data: o } = await da.get(e.value.baseURL + "/front-store/v2/sku/detail/" + r.value.id);
        t.value = o.data;
      } catch (o) {
        console.log({ e: o });
      }
    });
    function s(o) {
      n.editor.view.editable && o.preventDefault();
    }
    return {
      attrs: r,
      onClick: s,
      skuDetail: t
    };
  }
});
var GH = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("node-view-wrapper", { staticClass: "fullscreen" }, [e.skuDetail ? t("t-product-item", { attrs: { colors: e.skuDetail.colors, "has-gift": e.skuDetail.has_gift, image: e.skuDetail.image, name: e.skuDetail.name, price: e.skuDetail.price, "price-before-discount": e.skuDetail.price_before_discount, "price-discount-percent": e.skuDetail.price_discount_percent, "shared-url": e.skuDetail.shared_url, specs: e.skuDetail.specs, status: e.skuDetail.status } }) : e._e()], 1);
}, KH = [], JH = /* @__PURE__ */ le(
  UH,
  GH,
  KH,
  !1,
  null,
  null,
  null,
  null
);
const XH = JH.exports;
var YH = { exports: {} };
(function(n) {
  (function(e, t) {
    var r = t(e, e.document, Date);
    e.lazySizes = r, n.exports && (n.exports = r);
  })(
    typeof window < "u" ? window : {},
    function(t, r, i) {
      var s, o;
      if (function() {
        var z, j = {
          lazyClass: "lazyload",
          loadedClass: "lazyloaded",
          loadingClass: "lazyloading",
          preloadClass: "lazypreload",
          errorClass: "lazyerror",
          autosizesClass: "lazyautosizes",
          fastLoadedClass: "ls-is-cached",
          iframeLoadMode: 0,
          srcAttr: "data-src",
          srcsetAttr: "data-srcset",
          sizesAttr: "data-sizes",
          minSize: 40,
          customMedia: {},
          init: !0,
          expFactor: 1.5,
          hFac: 0.8,
          loadMode: 2,
          loadHidden: !0,
          ricTimeout: 0,
          throttleDelay: 125
        };
        o = t.lazySizesConfig || t.lazysizesConfig || {};
        for (z in j)
          z in o || (o[z] = j[z]);
      }(), !r || !r.getElementsByClassName)
        return {
          init: function() {
          },
          cfg: o,
          noSupport: !0
        };
      var a = r.documentElement, l = t.HTMLPictureElement, u = "addEventListener", c = "getAttribute", f = t[u].bind(t), p = t.setTimeout, d = t.requestAnimationFrame || p, h = t.requestIdleCallback, v = /^picture$/i, g = ["load", "error", "lazyincluded", "_lazyloaded"], m = {}, _ = Array.prototype.forEach, y = function(z, j) {
        return m[j] || (m[j] = new RegExp("(\\s|^)" + j + "(\\s|$)")), m[j].test(z[c]("class") || "") && m[j];
      }, w = function(z, j) {
        y(z, j) || z.setAttribute("class", (z[c]("class") || "").trim() + " " + j);
      }, O = function(z, j) {
        var Q;
        (Q = y(z, j)) && z.setAttribute("class", (z[c]("class") || "").replace(Q, " "));
      }, C = function(z, j, Q) {
        var fe = Q ? u : "removeEventListener";
        Q && C(z, j), g.forEach(function(ue) {
          z[fe](ue, j);
        });
      }, S = function(z, j, Q, fe, ue) {
        var ae = r.createEvent("Event");
        return Q || (Q = {}), Q.instance = s, ae.initEvent(j, !fe, !ue), ae.detail = Q, z.dispatchEvent(ae), ae;
      }, b = function(z, j) {
        var Q;
        !l && (Q = t.picturefill || o.pf) ? (j && j.src && !z[c]("srcset") && z.setAttribute("srcset", j.src), Q({ reevaluate: !0, elements: [z] })) : j && j.src && (z.src = j.src);
      }, x = function(z, j) {
        return (getComputedStyle(z, null) || {})[j];
      }, E = function(z, j, Q) {
        for (Q = Q || z.offsetWidth; Q < o.minSize && j && !z._lazysizesWidth; )
          Q = j.offsetWidth, j = j.parentNode;
        return Q;
      }, M = function() {
        var z, j, Q = [], fe = [], ue = Q, ae = function() {
          var re = ue;
          for (ue = Q.length ? fe : Q, z = !0, j = !1; re.length; )
            re.shift()();
          z = !1;
        }, ye = function(re, T) {
          z && !T ? re.apply(this, arguments) : (ue.push(re), j || (j = !0, (r.hidden ? p : d)(ae)));
        };
        return ye._lsFlush = ae, ye;
      }(), $ = function(z, j) {
        return j ? function() {
          M(z);
        } : function() {
          var Q = this, fe = arguments;
          M(function() {
            z.apply(Q, fe);
          });
        };
      }, F = function(z) {
        var j, Q = 0, fe = o.throttleDelay, ue = o.ricTimeout, ae = function() {
          j = !1, Q = i.now(), z();
        }, ye = h && ue > 49 ? function() {
          h(ae, { timeout: ue }), ue !== o.ricTimeout && (ue = o.ricTimeout);
        } : $(function() {
          p(ae);
        }, !0);
        return function(re) {
          var T;
          (re = re === !0) && (ue = 33), !j && (j = !0, T = fe - (i.now() - Q), T < 0 && (T = 0), re || T < 9 ? ye() : p(ye, T));
        };
      }, J = function(z) {
        var j, Q, fe = 99, ue = function() {
          j = null, z();
        }, ae = function() {
          var ye = i.now() - Q;
          ye < fe ? p(ae, fe - ye) : (h || ue)(ue);
        };
        return function() {
          Q = i.now(), j || (j = p(ae, fe));
        };
      }, W = function() {
        var z, j, Q, fe, ue, ae, ye, re, T, D, R, I, se = /^img$/i, Oe = /^iframe$/i, Me = "onscroll" in t && !/(gle|ing)bot/.test(navigator.userAgent), Re = 0, Je = 0, Ee = 0, Fe = -1, Ft = function(K) {
          Ee--, (!K || Ee < 0 || !K.target) && (Ee = 0);
        }, zt = function(K) {
          return I == null && (I = x(r.body, "visibility") == "hidden"), I || !(x(K.parentNode, "visibility") == "hidden" && x(K, "visibility") == "hidden");
        }, Fn = function(K, oe) {
          var N, q = K, k = zt(K);
          for (re -= oe, R += oe, T -= oe, D += oe; k && (q = q.offsetParent) && q != r.body && q != a; )
            k = (x(q, "opacity") || 1) > 0, k && x(q, "overflow") != "visible" && (N = q.getBoundingClientRect(), k = D > N.left && T < N.right && R > N.top - 1 && re < N.bottom + 1);
          return k;
        }, wt = function() {
          var K, oe, N, q, k, A, P, L, B, U, ie, ce, _e = s.elements;
          if ((fe = o.loadMode) && Ee < 8 && (K = _e.length)) {
            for (oe = 0, Fe++; oe < K; oe++)
              if (!(!_e[oe] || _e[oe]._lazyRace)) {
                if (!Me || s.prematureUnveil && s.prematureUnveil(_e[oe])) {
                  Bt(_e[oe]);
                  continue;
                }
                if ((!(L = _e[oe][c]("data-expand")) || !(A = L * 1)) && (A = Je), U || (U = !o.expand || o.expand < 1 ? a.clientHeight > 500 && a.clientWidth > 500 ? 500 : 370 : o.expand, s._defEx = U, ie = U * o.expFactor, ce = o.hFac, I = null, Je < ie && Ee < 1 && Fe > 2 && fe > 2 && !r.hidden ? (Je = ie, Fe = 0) : fe > 1 && Fe > 1 && Ee < 6 ? Je = U : Je = Re), B !== A && (ae = innerWidth + A * ce, ye = innerHeight + A, P = A * -1, B = A), N = _e[oe].getBoundingClientRect(), (R = N.bottom) >= P && (re = N.top) <= ye && (D = N.right) >= P * ce && (T = N.left) <= ae && (R || D || T || re) && (o.loadHidden || zt(_e[oe])) && (j && Ee < 3 && !L && (fe < 3 || Fe < 4) || Fn(_e[oe], A))) {
                  if (Bt(_e[oe]), k = !0, Ee > 9)
                    break;
                } else
                  !k && j && !q && Ee < 4 && Fe < 4 && fe > 2 && (z[0] || o.preloadAfterLoad) && (z[0] || !L && (R || D || T || re || _e[oe][c](o.sizesAttr) != "auto")) && (q = z[0] || _e[oe]);
              }
            q && !k && Bt(q);
          }
        }, Te = F(wt), ln = function(K) {
          var oe = K.target;
          if (oe._lazyCache) {
            delete oe._lazyCache;
            return;
          }
          Ft(K), w(oe, o.loadedClass), O(oe, o.loadingClass), C(oe, un), S(oe, "lazyloaded");
        }, en = $(ln), un = function(K) {
          en({ target: K.target });
        }, zn = function(K, oe) {
          var N = K.getAttribute("data-load-mode") || o.iframeLoadMode;
          N == 0 ? K.contentWindow.location.replace(oe) : N == 1 && (K.src = oe);
        }, En = function(K) {
          var oe, N = K[c](o.srcsetAttr);
          (oe = o.customMedia[K[c]("data-media") || K[c]("media")]) && K.setAttribute("media", oe), N && K.setAttribute("srcset", N);
        }, Bn = $(function(K, oe, N, q, k) {
          var A, P, L, B, U, ie;
          (U = S(K, "lazybeforeunveil", oe)).defaultPrevented || (q && (N ? w(K, o.autosizesClass) : K.setAttribute("sizes", q)), P = K[c](o.srcsetAttr), A = K[c](o.srcAttr), k && (L = K.parentNode, B = L && v.test(L.nodeName || "")), ie = oe.firesLoad || "src" in K && (P || A || B), U = { target: K }, w(K, o.loadingClass), ie && (clearTimeout(Q), Q = p(Ft, 2500), C(K, un, !0)), B && _.call(L.getElementsByTagName("source"), En), P ? K.setAttribute("srcset", P) : A && !B && (Oe.test(K.nodeName) ? zn(K, A) : K.src = A), k && (P || B) && b(K, { src: A })), K._lazyRace && delete K._lazyRace, O(K, o.lazyClass), M(function() {
            var ce = K.complete && K.naturalWidth > 1;
            (!ie || ce) && (ce && w(K, o.fastLoadedClass), ln(U), K._lazyCache = !0, p(function() {
              "_lazyCache" in K && delete K._lazyCache;
            }, 9)), K.loading == "lazy" && Ee--;
          }, !0);
        }), Bt = function(K) {
          if (!K._lazyRace) {
            var oe, N = se.test(K.nodeName), q = N && (K[c](o.sizesAttr) || K[c]("sizes")), k = q == "auto";
            (k || !j) && N && (K[c]("src") || K.srcset) && !K.complete && !y(K, o.errorClass) && y(K, o.lazyClass) || (oe = S(K, "lazyunveilread").detail, k && H.updateElem(K, !0, K.offsetWidth), K._lazyRace = !0, Ee++, Bn(K, oe, k, q, N));
          }
        }, Qi = J(function() {
          o.loadMode = 3, Te();
        }), ei = function() {
          o.loadMode == 3 && (o.loadMode = 2), Qi();
        }, jn = function() {
          if (!j) {
            if (i.now() - ue < 999) {
              p(jn, 999);
              return;
            }
            j = !0, o.loadMode = 3, Te(), f("scroll", ei, !0);
          }
        };
        return {
          _: function() {
            ue = i.now(), s.elements = r.getElementsByClassName(o.lazyClass), z = r.getElementsByClassName(o.lazyClass + " " + o.preloadClass), f("scroll", Te, !0), f("resize", Te, !0), f("pageshow", function(K) {
              if (K.persisted) {
                var oe = r.querySelectorAll("." + o.loadingClass);
                oe.length && oe.forEach && d(function() {
                  oe.forEach(function(N) {
                    N.complete && Bt(N);
                  });
                });
              }
            }), t.MutationObserver ? new MutationObserver(Te).observe(a, { childList: !0, subtree: !0, attributes: !0 }) : (a[u]("DOMNodeInserted", Te, !0), a[u]("DOMAttrModified", Te, !0), setInterval(Te, 999)), f("hashchange", Te, !0), ["focus", "mouseover", "click", "load", "transitionend", "animationend"].forEach(function(K) {
              r[u](K, Te, !0);
            }), /d$|^c/.test(r.readyState) ? jn() : (f("load", jn), r[u]("DOMContentLoaded", Te), p(jn, 2e4)), s.elements.length ? (wt(), M._lsFlush()) : Te();
          },
          checkElems: Te,
          unveil: Bt,
          _aLSL: ei
        };
      }(), H = function() {
        var z, j = $(function(ae, ye, re, T) {
          var D, R, I;
          if (ae._lazysizesWidth = T, T += "px", ae.setAttribute("sizes", T), v.test(ye.nodeName || ""))
            for (D = ye.getElementsByTagName("source"), R = 0, I = D.length; R < I; R++)
              D[R].setAttribute("sizes", T);
          re.detail.dataAttr || b(ae, re.detail);
        }), Q = function(ae, ye, re) {
          var T, D = ae.parentNode;
          D && (re = E(ae, D, re), T = S(ae, "lazybeforesizes", { width: re, dataAttr: !!ye }), T.defaultPrevented || (re = T.detail.width, re && re !== ae._lazysizesWidth && j(ae, D, T, re)));
        }, fe = function() {
          var ae, ye = z.length;
          if (ye)
            for (ae = 0; ae < ye; ae++)
              Q(z[ae]);
        }, ue = J(fe);
        return {
          _: function() {
            z = r.getElementsByClassName(o.autosizesClass), f("resize", ue);
          },
          checkElems: ue,
          updateElem: Q
        };
      }(), Y = function() {
        !Y.i && r.getElementsByClassName && (Y.i = !0, H._(), W._());
      };
      return p(function() {
        o.init && Y();
      }), s = {
        cfg: o,
        autoSizer: H,
        loader: W,
        init: Y,
        uP: b,
        aC: w,
        rC: O,
        hC: y,
        fire: S,
        gW: E,
        rAF: M
      }, s;
    }
  );
})(YH);
var QH = {
  el: {
    colorpicker: {
      confirm: "OK",
      clear: "Clear"
    },
    datepicker: {
      now: "Now",
      today: "Today",
      cancel: "Cancel",
      clear: "Clear",
      confirm: "OK",
      selectDate: "Select date",
      selectTime: "Select time",
      startDate: "Start Date",
      startTime: "Start Time",
      endDate: "End Date",
      endTime: "End Time",
      prevYear: "Previous Year",
      nextYear: "Next Year",
      prevMonth: "Previous Month",
      nextMonth: "Next Month",
      year: "",
      month1: "January",
      month2: "February",
      month3: "March",
      month4: "April",
      month5: "May",
      month6: "June",
      month7: "July",
      month8: "August",
      month9: "September",
      month10: "October",
      month11: "November",
      month12: "December",
      week: "week",
      weeks: {
        sun: "Sun",
        mon: "Mon",
        tue: "Tue",
        wed: "Wed",
        thu: "Thu",
        fri: "Fri",
        sat: "Sat"
      },
      months: {
        jan: "Jan",
        feb: "Feb",
        mar: "Mar",
        apr: "Apr",
        may: "May",
        jun: "Jun",
        jul: "Jul",
        aug: "Aug",
        sep: "Sep",
        oct: "Oct",
        nov: "Nov",
        dec: "Dec"
      }
    },
    select: {
      loading: "Loading",
      noMatch: "No matching data",
      noData: "No data",
      placeholder: "Select"
    },
    cascader: {
      noMatch: "No matching data",
      loading: "Loading",
      placeholder: "Select",
      noData: "No data"
    },
    pagination: {
      goto: "Go to",
      pagesize: "/page",
      total: "Total {total}",
      pageClassifier: ""
    },
    messagebox: {
      title: "Message",
      confirm: "OK",
      cancel: "Cancel",
      error: "Illegal input"
    },
    upload: {
      deleteTip: "press delete to remove",
      delete: "Delete",
      preview: "Preview",
      continue: "Continue"
    },
    table: {
      emptyText: "No Data",
      confirmFilter: "Confirm",
      resetFilter: "Reset",
      clearFilter: "All",
      sumText: "Sum"
    },
    tree: {
      emptyText: "No Data"
    },
    transfer: {
      noMatch: "No matching data",
      noData: "No data",
      titles: ["List 1", "List 2"],
      filterPlaceholder: "Enter keyword",
      noCheckedFormat: "{total} items",
      hasCheckedFormat: "{checked}/{total} checked"
    },
    image: {
      error: "FAILED"
    },
    pageHeader: {
      title: "Back"
    },
    popconfirm: {
      confirmButtonText: "Yes",
      cancelButtonText: "No"
    },
    empty: {
      description: "No Data"
    }
  }
};
mP.use(QH);
const ZH = Ce({
  name: "ThinkTiptap",
  components: {
    MenuBubble: Jj,
    MenuBar: e$,
    EditorContent: Bw
  },
  props: {
    value: {
      type: String,
      default: ""
    },
    config: {
      type: Object,
      default: () => ({})
    },
    menuSettings: {
      type: Array,
      default: () => kl
    }
  },
  setup(n, { emit: e }) {
    const t = Le(), r = oS(n, "config");
    Es("editor", t), Es("config", r);
    const i = ve(() => {
      var l;
      return ((l = t.value) == null ? void 0 : l.getHTML()) === n.value;
    });
    Us(() => {
      const u = {
        extensions: [
          L_,
          x_,
          C_.configure({
            types: ["heading", "paragraph"]
          }),
          O_,
          E_,
          $_.extend({
            renderHTML({ HTMLAttributes: c, mark: f, type: p }) {
              const h = [
                "https://thinkpro",
                "http://thinkpro",
                "https://goodspace",
                "http://goodspace",
                "https://epiczone",
                "http://epiczone"
              ].some((v) => c.href.startsWith(v)) ? void 0 : "nofollow noopener";
              return ["a", we(this.options.HTMLAttributes, c, { rel: h }), 0];
            }
          }).configure({
            openOnClick: !1
          }),
          q_,
          H_,
          N_,
          I_,
          xH,
          F_.extend({
            addNodeView: Mt(yl)
          }).configure({ inline: !0 }),
          z_.extend({
            addNodeView: Mt(yl)
          }),
          B_.extend({
            addNodeView: Mt(U_)
          }),
          D_.extend({
            addNodeView: Mt(G_)
          }),
          W_.extend({
            addNodeView: Mt(K_)
          }),
          j_.extend({
            addNodeView: Mt(J_)
          }),
          OH.extend({
            addNodeView: Mt(XH)
          })
        ],
        editable: !0,
        content: n.value,
        onUpdate: () => {
          var c;
          e("input", (c = t.value) == null ? void 0 : c.getHTML());
        }
      };
      t.value = new v2(u);
    }), bl(() => {
      var l;
      (l = t.value) == null || l.destroy();
    }), zr(
      () => n.value,
      (l) => {
        var u;
        i.value || (u = t.value) == null || u.commands.setContent(l, !1);
      }
    );
    const o = (l) => {
      const u = /<sku-view[^>]+\sid="(\d+)"[^>]*>/g;
      let c = [], f;
      for (; (f = u.exec(l)) !== null; )
        c = [...c, Number(f[1])];
      return c;
    }, a = (l) => {
      let c = /<rating-view[^>]+\srating="(.*?)"[^>]*>/g.exec(l);
      return c ? Number(c[1].replace(",", ".")) : null;
    };
    return zr(
      () => n.value,
      (l) => {
        e("update:skuIds", o(l)), e("update:rating", a(l));
      }
    ), {
      editor: t,
      isSame: i
    };
  }
});
var e3 = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "t-tiptap-editor" }, [t("menu-bubble", { attrs: { "menu-settings": e.menuSettings } }), t("menu-bar", { attrs: { "menu-settings": e.menuSettings } }), t("editor-content", { staticClass: "editor-content", attrs: { editor: e.editor } })], 1);
}, t3 = [], n3 = /* @__PURE__ */ le(
  ZH,
  e3,
  t3,
  !1,
  null,
  null,
  null,
  null
);
const s3 = n3.exports;
export {
  s3 as ThinkTipTapEditor
};
